webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store2__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_store2__);


/* harmony default export */ __webpack_exports__["default"] = ({
  get: function get(key) {
    return __WEBPACK_IMPORTED_MODULE_0_store2___default.a.local.get(key);
  },
  set: function set(key, value) {
    return __WEBPACK_IMPORTED_MODULE_0_store2___default.a.local.set(key, value);
  },
  getAll: function getAll() {
    return __WEBPACK_IMPORTED_MODULE_0_store2___default.a.local.getAll();
  },
  clearAll: function clearAll() {
    return __WEBPACK_IMPORTED_MODULE_0_store2___default.a.clearAll();
  }
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "locale", function() { return locale; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_storage__ = __webpack_require__(5);


var locale = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  data: {
    lang: __WEBPACK_IMPORTED_MODULE_1__helpers_storage__["default"].get('user-lang') || 'en_US',
    lang_obj: {
      en_US: __webpack_require__(220),
      es_ES: __webpack_require__(124),
      pt_BR: __webpack_require__(227),
      pl_PL: __webpack_require__(226),
      hu_HU: __webpack_require__(222),
      zh_CN: __webpack_require__(218),
      zh_TW: __webpack_require__(217),
      it_IT: __webpack_require__(223),
      ro_RO: __webpack_require__(228),
      de_DE: __webpack_require__(219),
      nl_NL: __webpack_require__(225),
      fr_FR: __webpack_require__(221),
      ru_RU: __webpack_require__(229),
      uk_UK: __webpack_require__(231),
      es_AR: __webpack_require__(124),
      tr_TR: __webpack_require__(230),
      ko_KR: __webpack_require__(224)
    },
    lang_def: [{ 'langCode': 'en_US', 'langName': 'English' }, { 'langCode': 'pt_BR', 'langName': 'Portuguese' }, { 'langCode': 'es_ES', 'langName': 'Spanish' }, { 'langCode': 'pl_PL', 'langName': 'Polish' }, { 'langCode': 'hu_HU', 'langName': 'Hungarian' }, { 'langCode': 'zh_TW', 'langName': 'Bulgarian' }, { 'langCode': 'zh_CN', 'langName': 'Chinese' }, { 'langCode': 'it_IT', 'langName': 'Italian' }, { 'langCode': 'ro_RO', 'langName': 'Romanian' }, { 'langCode': 'de_DE', 'langName': 'Deutsch' }, { 'langCode': 'nl_NL', 'langName': 'Dutch' }, { 'langCode': 'fr_FR', 'langName': 'French' }, { 'langCode': 'ru_RU', 'langName': 'Russian' }, { 'langCode': 'uk_UK', 'langName': 'Ukrainian' }, { 'langCode': 'tr_TR', 'langName': 'Turkish' }, { 'langCode': 'ko_KR', 'langName': 'Korean' }]
  }
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventBus", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

module.exports = {"data":[{"brandName":"Cargill","brandKey":"cargill","brandCode":"001","bgImageLink":"static/bgi.jpg","brandGroup":"","termsandconditionslink":"https://www.cargill.com/portal-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["localhost:8080","identity-dev.dev.dev-cglcloud.com","cargillcustomer.dev.dev-cglcloud.com","cargillcustomer.stage.cglcloud.in","identity.mycargill.com"],"cssFileName":"cargill.css","loginwidgetlogo":"static/1200px-Cargill_logo.svg.png","homepagelogo":"assets/img/logo-cargillwhite-help.svg","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"","LoginWidgetBottomContent":"","isEmployeeLoginRequired":true,"noTranform":true},{"brandName":"Nutrena","brandKey":"nutrena","brandCode":"002","bgImageLink":"#cccccc","brandGroup":"","termsandconditionslink":"https://www.cargill.com/portal-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["nutrenacustomer.dev.dev-cglcloud.com","nutrenacustomer.stage.cglcloud.in","identity.mynutrena.com","nutrenacustomer.cglcloud.com"],"cssFileName":"nutrena.css","loginwidgetlogo":"static/nutrenaklientportal2.png","homepagelogo":"assets/img/nutrenaklientportal2.png","terms":["Please accept Nutrena terms 1","Please accept Nutrena terms 2","Please accept Nutrena terms 3"],"authServer":"","apiEndpoint":"nutrena","LoginWidgetTopContent":"","LoginWidgetBottomContent":"","isEmployeeLoginRequired":true},{"brandName":"AgResource","brandKey":"agresource","brandCode":"003","bgImageLink":"static/agbg.jpg","brandGroup":"","termsandconditionslink":"https://www.cargill.com/page/website-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["agresourcecustomer.dev.dev-cglcloud.com","agresourcecustomer.stage.cglcloud.in","identity.myagresource.com","agresourcecustomer.cglcloud.com","login.agresource.ca"],"cssFileName":"agresource.css","loginwidgetlogo":"static/agRlogo.png","homepagelogo":"assets/img/aghomelogo.png","terms":["Please accept <a href='https://www.cargill.com/page/website-terms' target='_blank'>Terms and Conditions</a>","Please accept <a href='https://www.cargill.com/page/privacy' target='_blank'>Online Privacy Policy</a>"],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"","LoginWidgetBottomContent":"","isEmployeeLoginRequired":false},{"brandName":"admqtr","brandKey":"admqtr","brandCode":"004","bgImageLink":"#ececec","brandGroup":"","termsandconditionslink":"https://www.cargill.com/page/website-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["login-admqtr.dev.dev-cglcloud.com","login-admqtr.stage.cglcloud.in","login.admqtr.com","login-admqtr.cglcloud.com","identity.myadmqtr.com"],"cssFileName":"admqtr.css","loginwidgetlogo":"static/transparent.png","homepagelogo":"assets/img/transparent.png","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"admqtr.com Login","LoginWidgetBottomContent":"This application will require new login information from you soon. To initiate the process of registering with your new login information, please click NEED TO KNOW WHAT THEY WOULD CLICK. If you do not wish to register for your new login information at this time, you can still access this application at this time, but your access will only last until the end of December 2019. To access ExtraCense using your existing login information, please follow this link: <INSERT LINK TO OLD EC ENVIRONMENT>","linkToOldEC-Dev":"","linkToOldEC-Stage":"","linkToOldEC-Prod":"","isEmployeeLoginRequired":false},{"brandName":"CommodityHedging","brandKey":"commodityhedging","brandCode":"005","bgImageLink":"#ececec","brandGroup":"","termsandconditionslink":"https://www.cargill.com/page/website-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["login-commodityhedging.dev.dev-cglcloud.com","login-commodityhedging.stage.cglcloud.in","login.commodityhedging.com","login-commodityhedging.cglcloud.com","identity.mycommodityhedging.com"],"cssFileName":"admqtr.css","loginwidgetlogo":"static/transparent.png","homepagelogo":"assets/img/transparent.png","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"commodityhedging.com Login","LoginWidgetBottomContent":"ExtraCense will require new login information from you soon. To initiate the process of registering with your new login information, please click NEED TO KNOW WHAT THEY WOULD CLICK. If you do not wish to register for your new login information at this time, you can still access ExtraCense at this time, but your access will only last until the end of December 2019. To access ExtraCense using your existing login information, please follow this link: <INSERT LINK TO OLD EC ENVIRONMENT>.","linkToOldEC-Dev":"https://internalstage.commodityhedging.com/","linkToOldEC-Stage":"https://internalstage.commodityhedging.com/","linkToOldEC-Prod":"https://internalstage.commodityhedging.com/","isEmployeeLoginRequired":false},{"brandName":"chscompass.uat","brandKey":"chscompass.uat","brandCode":"008","bgImageLink":"#ececec","brandGroup":"","termsandconditionslink":"","privacypolicylink":"","applicationUrls":["login-customer-uat-chscompass.dev.dev-cglcloud.com","login-customer-uat-chscompass.stage.cglcloud.in","login-customer-uat-chscompass.cglcloud.com","login.customer.uat.chscompass.com"],"cssFileName":"chscompass.css","loginwidgetlogo":"static/transparent.png","homepagelogo":"assets/img/transparent.png","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"uat.chscompass.com Login","LoginWidgetBottomContent":"This application will require new login information from you soon. To initiate the process of registering with your new login information, please click NEED TO KNOW WHAT THEY WOULD CLICK. If you do not wish to register for your new login information at this time, you can still access this application at this time, but your access will only last until the end of December 2019. To access ExtraCense using your existing login information, please follow this link: <INSERT LINK TO OLD EC ENVIRONMENT>","linkToOldEC-Dev":"","linkToOldEC-Stage":"","linkToOldEC-Prod":"","isEmployeeLoginRequired":false},{"brandName":"chscompass","brandKey":"chscompass","brandCode":"009","bgImageLink":"#ececec","brandGroup":"","termsandconditionslink":"","privacypolicylink":"","applicationUrls":["login-customer-chscompass.dev.dev-cglcloud.com","login-customer-chscompass.stage.cglcloud.in","login-customer-chscompass.cglcloud.com","login.customer.chscompass.com"],"cssFileName":"chscompass.css","loginwidgetlogo":"static/transparent.png","homepagelogo":"assets/img/transparent.png","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"chscompass.com Login","LoginWidgetBottomContent":"This application will require new login information from you soon. To initiate the process of registering with your new login information, please click NEED TO KNOW WHAT THEY WOULD CLICK. If you do not wish to register for your new login information at this time, you can still access this application at this time, but your access will only last until the end of December 2019. To access ExtraCense using your existing login information, please follow this link: <INSERT LINK TO OLD EC ENVIRONMENT>","linkToOldEC-Dev":"","linkToOldEC-Stage":"","linkToOldEC-Prod":"","isEmployeeLoginRequired":false}]}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = {"data":[{"brandName":"Cargill","brandKey":"cargill","brandCode":"001","bgImageLink":"static/bgi.jpg","brandGroup":"","termsandconditionslink":"https://www.cargill.com/portal-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["localhost:8080","identity-dev.dev.dev-cglcloud.com","cargillcustomer.dev.dev-cglcloud.com","cargillcustomer.stage.cglcloud.in","identity.mycargill.com"],"cssFileName":"cargill.css","loginwidgetlogo":"static/1200px-Cargill_logo.svg.png","homepagelogo":"assets/img/logo-cargillwhite-help.svg","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"","LoginWidgetBottomContent":"","isEmployeeLoginRequired":true,"noTranform":true},{"brandName":"Nutrena","brandKey":"nutrena","brandCode":"002","bgImageLink":"#cccccc","brandGroup":"","termsandconditionslink":"https://www.cargill.com/portal-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["nutrenacustomer.dev.dev-cglcloud.com","nutrenacustomer.stage.cglcloud.in","identity.mynutrena.com","nutrenacustomer.cglcloud.com"],"cssFileName":"nutrena.css","loginwidgetlogo":"static/nutrenaklientportal2.png","homepagelogo":"assets/img/nutrenaklientportal2.png","terms":["Please accept Nutrena terms 1","Please accept Nutrena terms 2","Please accept Nutrena terms 3"],"authServer":"","apiEndpoint":"nutrena","LoginWidgetTopContent":"","LoginWidgetBottomContent":"","isEmployeeLoginRequired":true},{"brandName":"AgResource","brandKey":"agresource","brandCode":"003","bgImageLink":"static/agbg.jpg","brandGroup":"","termsandconditionslink":"https://www.cargill.com/page/website-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["agresourcecustomer.dev.dev-cglcloud.com","agresourcecustomer.stage.cglcloud.in","identity.myagresource.com","agresourcecustomer.cglcloud.com","login.agresource.ca"],"cssFileName":"agresource.css","loginwidgetlogo":"static/agRlogo.png","homepagelogo":"assets/img/aghomelogo.png","terms":["Please accept <a href='https://www.cargill.com/page/website-terms' target='_blank'>Terms and Conditions</a>","Please accept <a href='https://www.cargill.com/page/privacy' target='_blank'>Online Privacy Policy</a>"],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"","LoginWidgetBottomContent":"","isEmployeeLoginRequired":false},{"brandName":"admqtr","brandKey":"admqtr","brandCode":"004","bgImageLink":"#ececec","brandGroup":"","termsandconditionslink":"https://www.cargill.com/page/website-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["login-admqtr.dev.dev-cglcloud.com","login-admqtr.stage.cglcloud.in","login.admqtr.com","login-admqtr.cglcloud.com","identity.myadmqtr.com"],"cssFileName":"admqtr.css","loginwidgetlogo":"static/transparent.png","homepagelogo":"assets/img/transparent.png","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"admqtr.com Login","LoginWidgetBottomContent":"This application will require new login information from you soon. To initiate the process of registering with your new login information, please click NEED TO KNOW WHAT THEY WOULD CLICK. If you do not wish to register for your new login information at this time, you can still access this application at this time, but your access will only last until the end of December 2019. To access ExtraCense using your existing login information, please follow this link: <INSERT LINK TO OLD EC ENVIRONMENT>","linkToOldEC-Dev":"","linkToOldEC-Stage":"","linkToOldEC-Prod":"","isEmployeeLoginRequired":false},{"brandName":"CommodityHedging","brandKey":"commodityhedging","brandCode":"005","bgImageLink":"#ececec","brandGroup":"","termsandconditionslink":"https://www.cargill.com/page/website-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["login-commodityhedging.dev.dev-cglcloud.com","login-commodityhedging.stage.cglcloud.in","login.commodityhedging.com","login-commodityhedging.cglcloud.com","identity.mycommodityhedging.com"],"cssFileName":"admqtr.css","loginwidgetlogo":"static/transparent.png","homepagelogo":"assets/img/transparent.png","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"commodityhedging.com Login","LoginWidgetBottomContent":"ExtraCense will require new login information from you soon. To initiate the process of registering with your new login information, please click NEED TO KNOW WHAT THEY WOULD CLICK. If you do not wish to register for your new login information at this time, you can still access ExtraCense at this time, but your access will only last until the end of December 2019. To access ExtraCense using your existing login information, please follow this link: <INSERT LINK TO OLD EC ENVIRONMENT>.","linkToOldEC-Dev":"https://internalstage.commodityhedging.com/","linkToOldEC-Stage":"https://internalstage.commodityhedging.com/","linkToOldEC-Prod":"https://internalstage.commodityhedging.com/","isEmployeeLoginRequired":false},{"brandName":"JSIPortal","brandKey":"jsiportal","brandCode":"006","bgImageLink":"#ececec","brandGroup":"","termsandconditionslink":"https://www.cargill.com/page/website-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["jsicustomer.dev.dev-cglcloud.com","jsicustomer.stage.cglcloud.in","jsicustomer.cglcloud.com"],"cssFileName":"jsiportal.css","loginwidgetlogo":"static/transparent.png","homepagelogo":"assets/img/transparent.png","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"","LoginWidgetBottomContent":"","isEmployeeLoginRequired":true},{"brandName":"chscompass.uat","brandKey":"chscompass.uat","brandCode":"008","bgImageLink":"#ececec","brandGroup":"","termsandconditionslink":"","privacypolicylink":"","applicationUrls":["login-customer-uat-chscompass.dev.dev-cglcloud.com","login-customer-uat-chscompass.stage.cglcloud.in","login-customer-uat-chscompass.cglcloud.com","login.customer.uat.chscompass.com"],"cssFileName":"chscompass.css","loginwidgetlogo":"static/transparent.png","homepagelogo":"assets/img/transparent.png","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"uat.chscompass.com Login","LoginWidgetBottomContent":"This application will require new login information from you soon. To initiate the process of registering with your new login information, please click NEED TO KNOW WHAT THEY WOULD CLICK. If you do not wish to register for your new login information at this time, you can still access this application at this time, but your access will only last until the end of December 2019. To access ExtraCense using your existing login information, please follow this link: <INSERT LINK TO OLD EC ENVIRONMENT>","linkToOldEC-Dev":"","linkToOldEC-Stage":"","linkToOldEC-Prod":"","isEmployeeLoginRequired":false},{"brandName":"chscompass","brandKey":"chscompass","brandCode":"009","bgImageLink":"#ececec","brandGroup":"","termsandconditionslink":"","privacypolicylink":"","applicationUrls":["login-customer-chscompass.dev.dev-cglcloud.com","login-customer-chscompass.stage.cglcloud.in","login-customer-chscompass.cglcloud.com","login.customer.chscompass.com"],"cssFileName":"chscompass.css","loginwidgetlogo":"static/transparent.png","homepagelogo":"assets/img/transparent.png","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"chscompass.com Login","LoginWidgetBottomContent":"This application will require new login information from you soon. To initiate the process of registering with your new login information, please click NEED TO KNOW WHAT THEY WOULD CLICK. If you do not wish to register for your new login information at this time, you can still access this application at this time, but your access will only last until the end of December 2019. To access ExtraCense using your existing login information, please follow this link: <INSERT LINK TO OLD EC ENVIRONMENT>","linkToOldEC-Dev":"","linkToOldEC-Stage":"","linkToOldEC-Prod":"","isEmployeeLoginRequired":false}]}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = {"data":[{"brandName":"Cargill","brandKey":"cargill","brandCode":"001","bgImageLink":"static/bgi.jpg","brandGroup":"","termsandconditionslink":"https://www.cargill.com/portal-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["localhost:8080","identity-dev.dev.dev-cglcloud.com","cargillcustomer.dev.dev-cglcloud.com","cargillcustomer.stage.cglcloud.in","cargillcustomer-deprecated.stage.cglcloud.in","identityservices.stage.mycargill.com","identityservices-deprecated.stage.mycargill.com","identityservices.mycargill.com"],"cssFileName":"cargill.css","loginwidgetlogo":"static/1200px-Cargill_logo.svg.png","homepagelogo":"assets/img/logo-cargillwhite-help.svg","terms":[],"authServer":"aus10r4jtp4dOBI930h8","apiEndpoint":"1c","LoginWidgetTopContent":"","LoginWidgetBottomContent":"","isEmployeeLoginRequired":true,"noTranform":true},{"brandName":"Nutrena","brandKey":"nutrena","brandCode":"002","bgImageLink":"#cccccc","brandGroup":"","termsandconditionslink":"https://www.cargill.com/portal-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["nutrenacustomer.dev.dev-cglcloud.com","nutrenacustomer.stage.cglcloud.in","identity.mynutrena.com","nutrenacustomer.cglcloud.com"],"cssFileName":"nutrena.css","loginwidgetlogo":"static/nutrenaklientportal2.png","homepagelogo":"assets/img/nutrenaklientportal2.png","terms":["Please accept Nutrena terms 1","Please accept Nutrena terms 2","Please accept Nutrena terms 3"],"authServer":"","apiEndpoint":"nutrena","LoginWidgetTopContent":"","LoginWidgetBottomContent":"","isEmployeeLoginRequired":true},{"brandName":"AgResource","brandKey":"agresource","brandCode":"003","bgImageLink":"static/agbg.jpg","brandGroup":"","termsandconditionslink":"https://www.cargill.com/page/website-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["agresourcecustomer.dev.dev-cglcloud.com","agresourcecustomer.stage.cglcloud.in","identity.myagresource.com","agresourcecustomer.cglcloud.com","login.agresource.ca"],"cssFileName":"agresource.css","loginwidgetlogo":"static/agRlogo.png","homepagelogo":"assets/img/aghomelogo.png","terms":["Please accept <a href='https://www.cargill.com/page/website-terms' target='_blank'>Terms and Conditions</a>","Please accept <a href='https://www.cargill.com/page/privacy' target='_blank'>Online Privacy Policy</a>"],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"","LoginWidgetBottomContent":"","isEmployeeLoginRequired":false},{"brandName":"admqtr","brandKey":"admqtr","brandCode":"004","bgImageLink":"#ececec","brandGroup":"","termsandconditionslink":"https://www.cargill.com/page/website-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["login-admqtr.dev.dev-cglcloud.com","login-admqtr.stage.cglcloud.in","login.admqtr.com","login-admqtr.cglcloud.com","identity.myadmqtr.com"],"cssFileName":"admqtr.css","loginwidgetlogo":"static/transparent.png","homepagelogo":"assets/img/transparent.png","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"admqtr.com Login","LoginWidgetBottomContent":"This application will require new login information from you soon. To initiate the process of registering with your new login information, please click NEED TO KNOW WHAT THEY WOULD CLICK. If you do not wish to register for your new login information at this time, you can still access this application at this time, but your access will only last until the end of December 2019. To access ExtraCense using your existing login information, please follow this link: <INSERT LINK TO OLD EC ENVIRONMENT>","linkToOldEC-Dev":"","linkToOldEC-Stage":"","linkToOldEC-Prod":"","isEmployeeLoginRequired":false},{"brandName":"CommodityHedging","brandKey":"commodityhedging","brandCode":"005","bgImageLink":"#ececec","brandGroup":"","termsandconditionslink":"https://www.cargill.com/page/website-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["login-commodityhedging.dev.dev-cglcloud.com","login-commodityhedging.stage.cglcloud.in","login.commodityhedging.com","login-commodityhedging.cglcloud.com","identity.mycommodityhedging.com"],"cssFileName":"admqtr.css","loginwidgetlogo":"static/transparent.png","homepagelogo":"assets/img/transparent.png","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"commodityhedging.com Login","LoginWidgetBottomContent":"ExtraCense will require new login information from you soon. To initiate the process of registering with your new login information, please click NEED TO KNOW WHAT THEY WOULD CLICK. If you do not wish to register for your new login information at this time, you can still access ExtraCense at this time, but your access will only last until the end of December 2019. To access ExtraCense using your existing login information, please follow this link: <INSERT LINK TO OLD EC ENVIRONMENT>.","linkToOldEC-Dev":"https://internalstage.commodityhedging.com/","linkToOldEC-Stage":"https://internalstage.commodityhedging.com/","linkToOldEC-Prod":"https://internalstage.commodityhedging.com/","isEmployeeLoginRequired":false},{"brandName":"JSIPortal","brandKey":"jsiportal","brandCode":"006","clientId":"0oauwafnnlzIKGnkH0h7","bgImageLink":"#ececec","brandGroup":"","termsandconditionslink":"https://www.cargill.com/page/website-terms","privacypolicylink":"https://www.cargill.com/page/privacy","applicationUrls":["jsicustomer.dev.dev-cglcloud.com","jsicustomer.stage.cglcloud.in","jsicustomer.cglcloud.com"],"cssFileName":"jsiportal.css","loginwidgetlogo":"static/transparent.png","homepagelogo":"assets/img/transparent.png","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"","LoginWidgetBottomContent":"","isEmployeeLoginRequired":true},{"brandName":"chscompass.uat","brandKey":"chscompass.uat","brandCode":"008","bgImageLink":"#ececec","brandGroup":"","termsandconditionslink":"","privacypolicylink":"","applicationUrls":["login-customer-uat-chscompass.dev.dev-cglcloud.com","login-customer-uat-chscompass.stage.cglcloud.in","login-customer-uat-chscompass.cglcloud.com","login.customer.uat.chscompass.com"],"cssFileName":"chscompass.css","loginwidgetlogo":"static/transparent.png","homepagelogo":"assets/img/transparent.png","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"uat.chscompass.com Login","LoginWidgetBottomContent":"This application will require new login information from you soon. To initiate the process of registering with your new login information, please click NEED TO KNOW WHAT THEY WOULD CLICK. If you do not wish to register for your new login information at this time, you can still access this application at this time, but your access will only last until the end of December 2019. To access ExtraCense using your existing login information, please follow this link: <INSERT LINK TO OLD EC ENVIRONMENT>","linkToOldEC-Dev":"","linkToOldEC-Stage":"","linkToOldEC-Prod":"","isEmployeeLoginRequired":false},{"brandName":"chscompass","brandKey":"chscompass","brandCode":"009","bgImageLink":"#ececec","brandGroup":"","termsandconditionslink":"","privacypolicylink":"","applicationUrls":["login-customer-chscompass.dev.dev-cglcloud.com","login-customer-chscompass.stage.cglcloud.in","login-customer-chscompass.cglcloud.com","login.customer.chscompass.com"],"cssFileName":"chscompass.css","loginwidgetlogo":"static/transparent.png","homepagelogo":"assets/img/transparent.png","terms":[],"authServer":"","apiEndpoint":"1c","LoginWidgetTopContent":"chscompass.com Login","LoginWidgetBottomContent":"This application will require new login information from you soon. To initiate the process of registering with your new login information, please click NEED TO KNOW WHAT THEY WOULD CLICK. If you do not wish to register for your new login information at this time, you can still access this application at this time, but your access will only last until the end of December 2019. To access ExtraCense using your existing login information, please follow this link: <INSERT LINK TO OLD EC ENVIRONMENT>","linkToOldEC-Dev":"","linkToOldEC-Stage":"","linkToOldEC-Prod":"","isEmployeeLoginRequired":false}]}

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_storage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_okta__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(29);





var orgUrl = window.location.href.indexOf("mycargill") > -1 ? "https://login-stage.mycargill.com/" : "https://cargillcustomer-uat.oktapreview.com/";
var brandDetails = "";
var environment = "stage";
if (environment === 'production') {
  brandDetails = __webpack_require__(16);
} else if (environment === 'stage') {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
var brand = brandDetails.data.filter(function (i) {
  return i.applicationUrls.indexOf(document.location.host) > -1;
});
var apiEndpoint = brand.length ? brand[0].apiEndpoint : '1c';

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  config.timeout = 100000;
  config.maxContentLength = 52428890;
  if (config.url.indexOf('/auth/') > -1) {
    config.url = config.url.replace('onecargill/portal/v1/auth', '1c/onecargill-services-mycargill/v1');
    config.url = config.url.replace('1c', apiEndpoint);
    config.headers.Authorization = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].prototype.$auth.getAccessToken();
  } else {
    config.url = config.url.replace('onecargill/portal/v1', '1c/onecargill-services-mycargill/v1/recovery');
    config.url = config.url.replace('1c', apiEndpoint);
  }
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  console.log('URL:' + error.config.url);
  if (error.config.url.indexOf('/auth/') > -1 && error.response === undefined) {
    console.log('loggin out cos error.response undefined');
    __WEBPACK_IMPORTED_MODULE_3__helpers_okta__["default"].oktaSignOut();
    __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].clearAll();
  } else {
    console.log(error.config);
    if (error.message && error.message.toLowerCase().indexOf('timeout') > -1) {
      window.alert('Timeout error! Please try again later.');
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }
});

/* harmony default export */ __webpack_exports__["default"] = ({
  getCurrentState: function getCurrentState(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'post',
      url: orgUrl + "api/v1/authn",
      data: data,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getAppByName: function getAppByName(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getCurrentSession: function getCurrentSession() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: orgUrl + "api/v1/sessions/me",
      data: null,
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true
    });
  },
  getPasswordPolicy: function getPasswordPolicy(url, actToken) {
    if (actToken) {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: '' + url,
        data: null,
        headers: { 'RecoveryToken': actToken }
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: '' + url,
        data: null
      });
    }
  },
  getFactorByUserId: function getFactorByUserId(url, actToken) {
    if (actToken) {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: '' + url,
        data: null,
        headers: { 'Content-Type': 'application/json', 'RecoveryToken': actToken }
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: '' + url,
        data: null,
        headers: { 'Content-Type': 'application/json' }
      });
    }
  },
  login: function login(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'post',
      url: '' + url,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      },
      data: data,
      params: data
    });
  },
  createUser: function createUser(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data);
  },
  setUserAccount: function setUserAccount(url, data, actToken) {
    if (actToken) {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ method: 'post', url: url, data: data, 'headers': { 'RecoveryToken': actToken } });
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ method: 'post', url: url, data: data });
    }
  },
  sendCode: function sendCode(url, data, actToken) {
    if (actToken) {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ method: 'post', url: url, data: data, 'headers': { 'RecoveryToken': actToken } });
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ method: 'post', url: url, data: data });
    }
  },
  resetPasswordByEmailByUser: function resetPasswordByEmailByUser(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data);
  },
  resetPasswordBySMSByUser: function resetPasswordBySMSByUser(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data);
  },
  resetPasswordByEmailByAdmin: function resetPasswordByEmailByAdmin(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data);
  },
  verifyPasscodeOnFactorSetting: function verifyPasscodeOnFactorSetting(url, data, actToken) {
    if (actToken) {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ method: 'post', url: url, data: data, 'headers': { 'RecoveryToken': actToken } });
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ method: 'post', url: url, data: data });
    }
  },
  getUserIdByToken: function getUserIdByToken(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data);
  },
  verifySecurityAnswer: function verifySecurityAnswer(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data);
  },
  resetPassword: function resetPassword(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data);
  },
  verifyOTPWithStateToken: function verifyOTPWithStateToken(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data);
  },
  changePassword: function changePassword(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data);
  },
  getActiveAppNames: function getActiveAppNames(url, actToken) {
    if (actToken) {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: '' + url,
        data: null,
        headers: { 'Content-Type': 'application/json', 'RecoveryToken': actToken }
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: '' + url,
        data: null,
        headers: { 'Content-Type': 'application/json' }
      });
    }
  },
  getUserIdByEmail: function getUserIdByEmail(url, actToken) {
    if (actToken) {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: '' + url,
        data: null,
        headers: { 'Content-Type': 'application/json', 'RecoveryToken': actToken }
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: '' + url,
        data: null,
        headers: { 'Content-Type': 'application/json' }
      });
    }
  },
  deleteSMSFactor: function deleteSMSFactor(url, actToken) {
    if (actToken) {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'delete',
        url: url,
        data: null,
        headers: { 'Content-Type': 'application/json', 'RecoveryToken': actToken }
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'delete',
        url: url,
        data: null,
        headers: { 'Content-Type': 'application/json' }
      });
    }
  },
  getUserRoleById: function getUserRoleById(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getGroupsByAppId: function getGroupsByAppId(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getGroupByName: function getGroupByName(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getGroupsByUserId: function getGroupsByUserId(url, actToken) {
    if (actToken) {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: '' + url,
        data: null,
        headers: { 'Content-Type': 'application/json', 'RecoveryToken': actToken }
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: '' + url,
        data: null,
        headers: { 'Content-Type': 'application/json' }
      });
    }
  },
  getUserDetailsOfApp: function getUserDetailsOfApp(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getUserDetailsOfGroup: function getUserDetailsOfGroup(url) {
    url = url.indexOf('~~~') > -1 ? url.split('~~~')[0] + '/' + url.split('~~~')[1].split('/').slice(1).join('/') : url;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getUserDetailsOfSearch: function getUserDetailsOfSearch(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  assignUserToGroup: function assignUserToGroup(url) {
    url = url.indexOf('~~~') > -1 ? url.split('~~~')[0] + '/' + url.split('~~~')[1].split('/').slice(1).join('/') : url;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'patch',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  unassignUserFromGroup: function unassignUserFromGroup(url) {
    url = url.indexOf('~~~') > -1 ? url.split('~~~')[0] + '/' + url.split('~~~')[1].split('/').slice(1).join('/') : url;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'delete',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getGroupStats: function getGroupStats(url) {
    url = url.indexOf('~~~') > -1 ? url.split('~~~')[0] : url;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getClientIds: function getClientIds(url, email) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json', 'user': '' + email }
    });
  },
  getLogs: function getLogs(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getListOfSuperUserApps: function getListOfSuperUserApps(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getListOfAdminConfig: function getListOfAdminConfig(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  getListOfSecurityQuestionsByLanguage: function getListOfSecurityQuestionsByLanguage(url, actToken) {
    if (actToken) {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: '' + url,
        data: null,
        headers: { 'Content-Type': 'application/json', 'RecoveryToken': actToken }
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: '' + url,
        data: null,
        headers: { 'Content-Type': 'application/json' }
      });
    }
  },
  sendReInvite: function sendReInvite(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, {});
  },
  addToAdminConfigDB: function addToAdminConfigDB(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data);
  },
  deleteAdminConfig: function deleteAdminConfig(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'delete',
      url: url,
      data: data,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  axiosPost: function axiosPost(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data, {
      headers: { token: '' }
    });
  },
  getAllowedApps: function getAllowedApps(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  unlockUser: function unlockUser(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  updateAllowedApps: function updateAllowedApps(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data);
  },
  downloadReport: function downloadReport(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '' + url,
      responseType: 'arraybuffer'
    });
  },
  validateUserDetails: function validateUserDetails(url, data, actToken) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ method: 'post', url: url, data: data, 'headers': { 'RecoveryToken': actToken } });
  },
  getDxpDetails: function getDxpDetails(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '' + url,
      data: null,
      headers: { 'Content-Type': 'application/json' }
    });
  },
  sendDxpReInvite: function sendDxpReInvite(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, {});
  },
  sendSelfRegistration: function sendSelfRegistration(url, data, actToken) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ method: 'post', url: url, data: data, 'headers': { 'RecoveryToken': actToken } });
  },
  updateName: function updateName(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data);
  },
  sendMessageToDatadog: function sendMessageToDatadog(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data);
  },
  getAdminGroup: function getAdminGroup(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url);
  },
  getAppGroupConfigData: function getAppGroupConfigData(url, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(url, data);
  }
});

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(747)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(722),
  /* scopeId */
  "data-v-da5d5c4e",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/components/Spinner.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Spinner.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-da5d5c4e", Component.options)
  } else {
    hotAPI.reload("data-v-da5d5c4e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(726)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(700),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/components/widgets/TopNavFooter.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TopNavFooter.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-016d20ce", Component.options)
  } else {
    hotAPI.reload("data-v-016d20ce", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_64__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_base_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__okta_okta_auth_js_polyfill__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__okta_okta_auth_js_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__okta_okta_auth_js_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__okta_okta_auth_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__okta_okta_auth_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__okta_okta_auth_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__okta_config__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18nConfig__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_storage__ = __webpack_require__(5);






var orgUrl = window.location.href.indexOf("mycargill") > -1 ? "https://login-stage.mycargill.com/" : "https://cargillcustomer-uat.oktapreview.com/";
var config = __WEBPACK_IMPORTED_MODULE_4__okta_config__["default"].getConfig();

var baseUrl = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');

var environment = "stage";
var brandDetails = "";
console.log('env=====', environment);
if (environment === 'production') {
  brandDetails = __webpack_require__(16);
} else if (environment === 'stage') {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
var brand = brandDetails.data.filter(function (i) {
  return i.applicationUrls.indexOf(document.location.host) > -1;
});

var OktaSignIn = __webpack_require__(504);
var browserLang = 'en';
if (navigator.userLanguage !== undefined) {
  browserLang = navigator.browserLanguage;
  console.log("browserLang: if " + browserLang);
} else {
  browserLang = navigator.language;
  console.log("browserLang: else " + browserLang);
}
console.log(environment);
console.log(brand);
var urlLang = __WEBPACK_IMPORTED_MODULE_4__okta_config__["default"].getParameterByName('lang', document.location.href);
var authparams = {
  issuer: config.issuer,
  responseType: config.responseType,
  scopes: config.scopes,
  display: 'page',
  pkce: config.pkce
};
var isRdEncode = __WEBPACK_IMPORTED_MODULE_4__okta_config__["default"].getParameterByName('encode', document.location.href);
browserLang = urlLang ? urlLang.toLowerCase() : browserLang;
console.log("After urlLang: " + browserLang);

var rd = __WEBPACK_IMPORTED_MODULE_4__okta_config__["default"].getParameterByName('rd', document.location.href);
if (rd === undefined || rd === null || rd.trim() === '') {
  rd = __WEBPACK_IMPORTED_MODULE_4__okta_config__["default"].getParameterByName('ReturnUrl', document.location.href);
} else {
  isRdEncode = true;
}
var isSamlRD = false;
if (rd !== undefined && rd !== null && rd.trim() !== '') {
  if (isRdEncode === 'true') {
    rd = __WEBPACK_IMPORTED_MODULE_1_base_64___default.a.decode(rd);
  }
  isSamlRD = true;
  console.log('rd: ' + rd);
}
browserLang = browserLang.replace("_", "-");
browserLang = __WEBPACK_IMPORTED_MODULE_4__okta_config__["default"].getBrowserLanguage(browserLang);
console.log("browser language final:" + browserLang);
var logoUrl = brand.length ? brand[0].loginwidgetlogo : 'static/1200px-Cargill_logo.svg.png';
var host = config.host;
var otp = __WEBPACK_IMPORTED_MODULE_4__okta_config__["default"].getParameterByName('otp', window.location.href);
var state = __WEBPACK_IMPORTED_MODULE_4__okta_config__["default"].getParameterByName('state', window.location.href);
var isIdentifier = true;
var url = document.location.href.toLowerCase().split('/')[2];
if (url.indexOf('cargill') === -1 && url.indexOf('localhost') === -1) {
  isIdentifier = false;
}
var isClassicEngine = false;
var mmClient = "0oa1ekuqo4jWD7LFU0h8";
var clientId = config.clientId;
if (url.indexOf('agresource') > -1 || clientId === mmClient) {
  isClassicEngine = true;
}
var authClient = new __WEBPACK_IMPORTED_MODULE_3__okta_okta_auth_js__["OktaAuth"]({
  baseUrl: orgUrl,
  issuer: config.issuer,
  language: browserLang,
  clientId: config.clientId,
  redirectUri: isSamlRD ? rd : config.redirectUrl,
  logo: logoUrl,
  authParams: authparams,
  useClassicEngine: isClassicEngine
});

var oktaSignInClient = new OktaSignIn({
  el: '#widget-div',
  baseUrl: orgUrl,
  language: browserLang,
  useClassicEngine: isClassicEngine,
  clientId: config.clientId,
  redirectUri: isSamlRD ? rd : config.redirectUrl,
  logo: logoUrl,
  authParams: authparams,
  helpLinks: {
    help: baseUrl + '/Help'
  },
  features: {
    smsRecovery: true,
    rememberMe: document.location.host.toLowerCase().indexOf('cargill') !== -1,
    selfServiceUnlock: true,
    showIdentifier: isIdentifier
  },
  i18n: __WEBPACK_IMPORTED_MODULE_5__i18nConfig__["default"],
  state: state,
  otp: otp,
  transformUsername: function transformUsername(username, operation) {
    var url = document.location.href.toLowerCase().split('/')[2];
    if (url.indexOf('cargill') === -1 && url.indexOf('localhost') === -1 && !brand[0].noTranform) {
      var brandcode = brand[0].brandCode;
      return ('0' + (username.indexOf('@') + 1)).slice(-2) + brandcode + username.split('@').join('') + '@partneridentity.okta-emea.com';
    } else {
      return username.toLowerCase();
    }
  }
});


/* harmony default export */ __webpack_exports__["default"] = ({
  oktaSignIn: function oktaSignIn() {
    var fromLogin = __WEBPACK_IMPORTED_MODULE_4__okta_config__["default"].getParameterByName('fromLogin', window.location.href);
    if (isSamlRD) {
      oktaSignInClient.showSignInAndRedirect({
        el: '#widget-div'
      });
    } else if (window.location.href.indexOf('action=unlock') > -1 || host && __WEBPACK_IMPORTED_MODULE_1_base_64___default.a.decode(host) === config.mmclient) {
      oktaSignInClient.showSignInAndRedirect({
        el: '#widget-div'
      });
    } else if (fromLogin) {
      oktaSignInClient.authClient.signInWithRedirect();
    } else {
      oktaSignInClient.authClient.session.exists().then(function (exists) {
        if (exists) {
          oktaSignInClient.authClient.signInWithRedirect();
        } else {
          authClient.tokenManager.getTokens().then(function (_ref) {
            var accessToken = _ref.accessToken,
                idToken = _ref.idToken;

            if (accessToken && idToken) {
              oktaSignInClient.authClient.token.getWithRedirect({
                el: '#widget-div',
                responseType: 'code'
              });
            } else {
              oktaSignInClient.showSignInAndRedirect();
            }
          });
        }
      });
    }
  },
  oktaWidgetRendered: function oktaWidgetRendered(handler) {
    oktaSignInClient.on('ready', function (res) {
      console.log(res);
      handler();
    });
  },
  checkTokens: function checkTokens() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      authClient.tokenManager.getTokens().then(function (_ref2) {
        var accessToken = _ref2.accessToken,
            idToken = _ref2.idToken;

        if (accessToken && idToken) {
          __WEBPACK_IMPORTED_MODULE_6__helpers_storage__["default"].set('access_token', accessToken.accessToken);
          __WEBPACK_IMPORTED_MODULE_6__helpers_storage__["default"].set('id_token', idToken.idToken);
          resolve(accessToken, idToken);
        } else {
          resolve(false, false);
        }
      });
    });
  },
  oktaIsSessionActive: function oktaIsSessionActive() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      resolve(true);
    });
  },
  getAccessToken: function getAccessToken() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (oktaSignInClient.tokenManager.get('access_token')) {
        resolve(oktaSignInClient.tokenManager.get('access_token'));
      } else {
        resolve(false);
      }
    });
  },
  addToTokenManager: function addToTokenManager(key, val) {
    oktaSignInClient.tokenManager.add(key, val);
  },
  oktaSignOut: function oktaSignOut(es) {
    if (es === 'access_denied') {
      es = '?' + es;
    } else {
      es = '';
    }
    oktaSignInClient.authClient.signOut({
      postLogoutRedirectUri: window.location.origin + '/Login' + es
    });
  },
  oktaClearSession: function oktaClearSession() {
    oktaSignInClient.session.get(function (res) {
      if (res.status === 'ACTIVE') {
        oktaSignInClient.session.close(function (err) {
          if (err) {
            console.error("Okta sign out error: ", err);
            return;
          }
        });
      }
    });
  }
});

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_app__ = __webpack_require__(100);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    customerTaxId: '',
    userRole: 0,
    user: null,
    token: null,
    name: '',
    email: ''
  },

  mutations: {
    setEmail: function setEmail(state, newEmail) {
      state.email = newEmail;
    },
    setName: function setName(state, newName) {
      state.name = newName;
    },
    setCustomerTaxId: function setCustomerTaxId(state, newCustomerTaxId) {
      state.customerTaxId = newCustomerTaxId;
    },
    setUserRole: function setUserRole(state, newUserRole) {
      state.userRole = newUserRole;
      __WEBPACK_IMPORTED_MODULE_2__helpers_app__["default"].persistUserRoleToStorage(newUserRole);
    },
    setUser: function setUser(state, user) {
      state.user = user;
    },
    setToken: function setToken(state, token) {
      state.token = token;
    }
  }
}));

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports) {

module.exports = {"data":["cargill.com","CRGL-THIRDPARTY.COM","agresource.ca","awb.com.au","awb.com"]}

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_base_64__);

var location = window.location.href;
var environment = "stage";
var orgUrl = location.indexOf("mycargill") > -1 ? "https://login-stage.mycargill.com/" : "https://cargillcustomer-uat.oktapreview.com/";
var client = "0oa10r32yuaNJCfrw0h8";
var mmClient = "0oa1ekuqo4jWD7LFU0h8";
var brandDetails = "";
console.log('env=====', environment);
if (environment === 'production') {
  brandDetails = __webpack_require__(16);
} else if (environment === 'stage') {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
var brand = brandDetails.data.filter(function (i) {
  return i.applicationUrls.indexOf(document.location.host) > -1;
});

/* harmony default export */ __webpack_exports__["default"] = ({
  getParameterByName: function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  getBrowserLanguage: function getBrowserLanguage(language) {
    language = language.split("-")[0];
    var currLang = "";
    if (language.indexOf('nl') > -1) {
      currLang = "nl-NL";
    } else if (language.indexOf('pt') > -1) {
      currLang = "pt-BR";
    } else if (language.indexOf('zh') > -1) {
      if (language.indexOf('zh_CN')) {
        currLang = "zh-CN";
      } else {
        currLang = "zh-TW";
      }
    } else {
      currLang = language;
    }
    return currLang;
  },
  getConfig: function getConfig() {
    var clientid = client;
    var issuer = orgUrl + (location.indexOf("mycargill") > -1 ? 'oauth2/aus1a547nkcosYRp00h8' : 'oauth2/aus10r4jtp4dOBI930h8');
    var redirectUrl = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + '/login/callback';
    var responseType = ['id_token', 'token'];
    var scope = ['identity.api.default', 'openid', 'email', 'profile'];
    var pkce = true;
    console.log(__WEBPACK_IMPORTED_MODULE_0_base_64___default.a.encode(mmClient));
    var host = this.getParameterByName('id', location);
    var env = this.getParameterByName('env', location);
    var mmRedirect = "https://shop.stg.milkmoovement.io/vendor-connections?vendorId=123e4567-e89b-12d3-a456-426614174000&isUserAcceptedVendorConditions=true";
    if (location.indexOf("mycargill") > -1 && host && __WEBPACK_IMPORTED_MODULE_0_base_64___default.a.decode(host) === mmClient) {
      if (env) {
        if (environment === 'stage' && env.toLowerCase() === 'sandbox') {
          mmRedirect = "https://loc-mm-shop-main.milkmoovement.services/vendor-connections?vendorId=123e4567-e89b-12d3-a456-426614174000&isUserAcceptedVendorConditions=true";
        } else if (environment === 'stage' && env.toLowerCase() === 'dev') {
          mmRedirect = "https://shop.dev.milkmoovement.io/vendor-connections?vendorId=123e4567-e89b-12d3-a456-426614174000&isUserAcceptedVendorConditions=true";
        } else {
          window.location = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + '/Error?app=milkMoovement';
        }
      }
      brand[0].isEmployeeLoginRequired = false;
      clientid = mmClient;
      issuer = orgUrl + 'oauth2/aus111li82blhgcDe0h8';
      redirectUrl = mmRedirect;
      scope = ['milkmoovement.api.default', 'openid', 'offline_access'];
      responseType = 'code';
      pkce = false;
    }
    if (location.indexOf('action=unlock') > -1) {
      brand[0].isEmployeeLoginRequired = false;
    }
    var oktaConfig = {
      clientId: clientid,
      issuer: issuer,
      redirectUrl: redirectUrl,
      scopes: scope,
      responseType: responseType,
      pkce: pkce,
      host: host,
      mmclient: mmClient
    };
    return oktaConfig;
  }
});

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(725)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(699),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/components/UserTable.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserTable.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-01537783", Component.options)
  } else {
    hotAPI.reload("data-v-01537783", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(739)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(714),
  /* scopeId */
  "data-v-4b19517a",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/components/widgets/NoTopNavFooter.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NoTopNavFooter.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4b19517a", Component.options)
  } else {
    hotAPI.reload("data-v-4b19517a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jwt_decode__);



/* harmony default export */ __webpack_exports__["default"] = ({
  persistNameToStorage: function persistNameToStorage(name) {
    __WEBPACK_IMPORTED_MODULE_0__storage__["default"].set('cf-name', name);
  },
  getAuthenticationUserFromUrl: function getAuthenticationUserFromUrl(docurl) {
    var url = docurl;

    var indexOfToken = url.indexOf('#id_token=', 0);
    if (indexOfToken > 0) {
      var token = url.substring(indexOfToken + 10);
      var authToken = __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default()(token);

      if (authToken && authToken.sub) {
        if (new Date((authToken.exp - 3592) * 1000) > new Date()) {
          return authToken;
        }
      }
    }

    return null;
  },
  persistUserRoleToStorage: function persistUserRoleToStorage(userRole) {
    __WEBPACK_IMPORTED_MODULE_0__storage__["default"].set('cf-userRole', userRole);
  },
  getAuthenticationUserFromStorage: function getAuthenticationUserFromStorage() {
    return __WEBPACK_IMPORTED_MODULE_0__storage__["default"].get('cf-user');
  }
});

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  getLanguage: function getLanguage(lang) {
    if (lang && lang !== 'zh_TW' && lang !== 'zh_CN') {
      return lang.split('_')[0];
    }
    return lang;
  }
});

/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(741)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(716),
  /* scopeId */
  "data-v-6c07c36f",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/components/footer/footer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] footer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6c07c36f", Component.options)
  } else {
    hotAPI.reload("data-v-6c07c36f", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(730)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(704),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/components/header/brandBar/brandBar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] brandBar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1c862efd", Component.options)
  } else {
    hotAPI.reload("data-v-1c862efd", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = {"1":"Estados Unidos y Canadá","7":"Rusia","20":"Egipto","27":"Sudáfrica","30":"Grecia","31":"Países Bajos (Holanda)","32":"Bélgica","33":"Francia","34":"España","36":"Hungría","39":"Italia","40":"Rumania","41":"Suiza","43":"Austria","44":"Reino Unido","45":"Dinamarca","46":"Suecia","47":"Noruega","48":"Polonia","49":"Alemania","51":"Perú","52":"México","53":"Cuba","54":"Argentina","55":"Brasil","56":"Chile","57":"Colombia","58":"Venezuela","60":"Malasia","61":"Australia","62":"Indonesia","63":"Filipinas","64":"Nueva Zelanda","65":"Singapur","66":"Tailandia","81":"Japón","82":"Corea del Sur","84":"Vietnam","86":"China","90":"Turquía","91":"India","92":"Pakistán","93":"Afganistán","94":"Sri Lanka","95":"Birmania","98":"Irán","211":"Sudán meridional","212":"Marruecos","213":"Argelia","216":"Túnez","218":"Libia","220":"Gambia","221":"Senegal","222":"Mauritania","223":"Malí","224":"Guinea","225":"Costa de Marfil","226":"Burkina Faso","227":"Níger","228":"Togo","229":"Benín","230":"Mauricio","231":"Liberia","232":"Sierra Leona","233":"Ghana","234":"Nigeria","235":"Chad","236":"República Centroafricana","237":"Camerún","238":"Cabo Verde","239":"Santo Tomé y Príncipe","240":"Guinea Ecuatorial","241":"Gabón","242":"Congo","243":"República Democrática del Congo","244":"Angola","245":"Guinea-Bissau","246":"Territorio Británico del Océano Indico","248":"Seychelles","249":"Sudán","250":"Ruanda","251":"Etiopía","252":"Somalia","253":"Yibuti","254":"Kenia","255":"República Unida de Tanzanía","256":"Uganda","257":"Burundi","258":"Mozambique","260":"Zambia","261":"Madagascar","262":"Isla de la Reunión","263":"Zimbabue","264":"Namibia","265":"Malaui","266":"Lesoto","267":"Botsuana","268":"Suazilandia","269":"Comoras","290":"Santa Elena, Ascensión y Tristán de Acuña","291":"Eritrea","297":"Aruba","298":"Islas Feroe","299":"Groenlandia","350":"Gibraltar","351":"Portugal","352":"Luxemburgo","353":"Irlanda","354":"Islandia","355":"Albania","356":"Malta","357":"Chipre","358":"Finlandia","359":"Bulgaria","370":"Lituania","371":"Letonia","372":"Estonia","373":"Moldavia","374":"Armenia","375":"Bielorrusia","376":"Andorra","377":"Mónaco","378":"San Marino","379":"Vaticano","380":"Ucrania","381":"Serbia","382":"Montenegro","383":"Kosovo","385":"Croacia","386":"Eslovenia","387":"Bosnia-Herzegovina","389":"Macedonia","420":"República Checa","421":"Eslovaquia","423":"Liechtenstein","500":"Islas Malvinas","501":"Belice","502":"Guatemala","503":"El Salvador","504":"Honduras","505":"Nicaragua","506":"Costa Rica","507":"Panamá","508":"San Pedro y Miquelón","509":"Haití","590":"Guadalupe","591":"Bolivia","592":"Guyana","593":"Ecuador","595":"Paraguay","596":"Martinica","597":"Surinam","598":"Uruguay","599":"Antillas Neerlandesas","670":"Timor Leste","672":"Antártida","673":"Brunei Darussalam","674":"Nauru","675":"Papúa Nueva Guinea","676":"Tonga","677":"Islas Salomón","678":"Vanuatu","679":"Fiyi","680":"Palaos","681":"Wallis y Futuna","682":"Islas Cook","683":"Niue","685":"Samoa","686":"Kiribati","687":"Nueva Caledonia","688":"Tuvalu","689":"Polinesia Francesa","690":"Tokelau","691":"Micronesia","692":"Islas Marshall","850":"Corea del Norte","852":"Hong Kong","853":"Macao","855":"Camboya","856":"República Democrática Popular Lao","880":"Bangladés","886":"Taiwán","960":"Maldivas","961":"Líbano","962":"Jordania","963":"República Árabe Siria","964":"Irak","965":"Kuwait","966":"Arabia Saudita","967":"Yemen","968":"Omán","970":"Palestina","971":"Emiratos Árabes Unidos","972":"Israel","973":"Baréin","974":"Catar","975":"Bután","976":"Mongolia","977":"Nepal","992":"Tayikistán","993":"Turkmenistán","994":"Azerbaiyán","995":"Georgia","996":"Kirguistán","998":"Uzbekistán","1242":"Bahamas","1246":"Barbados","1264":"Anguila","1268":"Antigua y Barbuda","1284":"Islas Vírgenes Británicas","1340":"Islas Vírgenes (E.E.U.U.)","1345":"Islas Caimanes","1441":"Bermuda","1473":"Granada","1649":"Islas Turcas y Caico","1664":"Montserrat","1670":"Islas Marianas Septentrionales","1671":"Guam","1684":"Samoa Americana","1758":"Santa Lucía","1767":"Dominica","1784":"San Vicente y las Granadinas","1787":"Puerto Rico","1809":"República Dominicana","1868":"Trinidad y Tobago","1869":"San Cristóbal y Nieves","1876":"Jamaica","441481":"Guernsey","441534":"Jersey","registration":"Registro","hello":"Hola","welcome_cargill":"Bienvenido a ","user_reg":"Registro de Usuario","enter_new_pwd":"Ingrese nueva clave","pwd_rule":"Su contraseña debe contener al menos 8 caracteres, una minúscula, una mayúscula, un número, y no debe contener partes de su usuario","repeat_pwd":"Repita la nueva contraseña","choose_forgot_pwd_qtn":"Elija una pregunta de contraseña olvidada","stock_qtn":"Preguntas sobre stock","disliked_food":"¿Cuál es la comida que menos te gustaba de niño?","name_of_first_plush_toy":"¿Cuál es el nombre de tu primer animal de peluche?","first_award":"¿Por qué ganaste tu primera medalla o premio?","favorite_security_question":"¿Cuál es tu pregunta de seguridad favorita?","favorite_toy":"¿Cuál es el juguete / animal de peluche que más te gustó de niño?","first_computer_game":"¿Cuál fue el primer juego de computadora que jugaste?","favorite_movie_quote":"¿Cuál es tu cita favorita de una película?","first_sports_team_mascot":"¿Cuál fue la mascota del primer equipo deportivo en el que jugaste?","first_music_purchase":"¿Qué álbum de música o canción compraste por primera vez?","favorite_art_piece":"¿Cuál es tu obra de arte favorita?","grandmother_favorite_desert":"¿Cuál fue el postre favorito de tu abuela?","first_thing_cooked":"¿Qué fue lo primero que aprendiste a cocinar?","childhood_dream_job":"¿Cuál era el trabajo de tus sueños cuando eras niño?","place_where_significant_other_was_met":"¿Dónde conoció a su cónyuge / pareja?","favorite_vacation_location":"¿A dónde fuiste para tus vacaciones favoritas?","new_years_two_thousand":"¿Dónde estabas en la víspera de Año Nuevo en el año 2000?","favorite_speaker_actor":"¿Quién es tu orador / orador favorito?","favorite_book_movie_character":"¿Quién es tu personaje favorito de libro / película?","favorite_sports_player":"¿Quién es tu deportista favorito?","custom_qtn":"Pregunta personalizada","own_sec_qtn":"Crea tu propia pregunta de seguridad","answer":"Respuesta","phone_inst":"Opcional. Ingrese un número de teléfono para recuperar su cuenta. Este número solo se usará para enviar mensajes de texto con códigos de verificación.","optional":"(opcional)","sms_inst":"Okta puede enviarle un mensaje de texto con un código de recuperación. Esta función es útil cuando no tiene acceso a su correo electrónico.","add_ph_no":"Agregar el número de teléfono","create_acc":"Crear mi cuenta","forgot_pwd_header":"Mensaje de texto por contraseña olvidada","enter_phone_no":"Ingrese el número de teléfono que usará para recibir códigos por mensaje de texto, luego haga clic en Enviar código para verificar que funciona.","country":"País","country_inst":"Seleccione el país donde está registrado su teléfono.","back":"Reenviar","phone_number":"Número de teléfono","phone_number_inst":"Ingrese su número en la forma en que normalmente lo marca. No agregue su código de país","code_prefix":"prefijo de código de país.","send_code":"Enviar código","done":"Hecho","verify":"Verificar","enter_code":"Introduzca el código","enter_code_rule":"Verifique el código de acceso de su teléfono e ingréselo a continuación. Tu mensaje debe llegar en menos de un minuto.","verify_success":"Número de teléfono verificado correctamente!","click":"Hacer clic","finish_setup":"Para finalizar configuración","error_review":"Revise el formulario para corregir los siguientes errores.","phone_no_not_found":"El mensaje de texto no se puede enviar porque no se encontró ningún número de teléfono en la base de datos.","noLowerCase":"Debe contener al menos una letra minúscula","noUpperCase":"Debe contener al menos una letra mayúscula","noNumber":"Debe contener al menos un número","noSpecialCharacter":"Debe contener al menos un carácter especial","notMinLength":"Debe contener al menos $ caracteres","noUsernameSubstring":"No debe contener parte del nombre de usuario","noFirstnameSubstring":"No debe contener parte de su nombre","noLastnameSubstring":"No debe contener parte de su apellido","tokenNotValid":"Tu token de activación ya no es válido","tokenInvalidInfo":"Esto puede suceder si hizo clic en su enlace de activación después de crear su cuenta, su enlace de activación expiró o la URL es incorrecta.","reqNewToken":"Solicitar una nueva ficha","passcodeNotValid":"Su contraseña no coincide con nuestros registros. Inténtalo de nuevo.","OTPEnableAfter30Sec":"Un mensaje SMS fue enviado recientemente. Por favor, espere 30 segundos antes de volver a intentarlo.","phoneNoAlreadySet":"El número de teléfono ya ha sido verificado por este usuario.","emptypassword":"La contraseña no puede estar vacía","passwordlength":"La contraseña no puede estar vacía","passwordnotvalid":"La contraseña no es valida","passwordnotmatching":"Las contraseñas deben coincidir","answerlength":"La respuesta debe tener al menos $ caracteres de longitud","phonenumbermissing":"Verifique el código de acceso que recibió para continuar","customQuestionEmpty":"La pregunta personalizada no puede estar vacía","customQAsame":"La pregunta y la respuesta personalizadas no pueden ser iguales","passwordSameasPrev":"La contraseña no puede ser su contraseña actual","answerWrong":"La respuesta de la pregunta de recuperación no coincide con nuestros registros.","phonealreadyactive":"Este número ya se ha verificado, si desea actualizar intente con otro número","first_name":"Nombre","last_name":"Apellido","enter_email":"Identificación de correo electrónico","emailNotValid":"ID de correo electrónico no válido","registeredapps":"Aplicaciones registradas","waitingapps":"Aplicaciones esperando aprobación","requestaccess":"Solicitar acceso","admin":"Administrador","selectLang":"Seleccione idioma","dashboardLabel":"Tablero","resetpwd":"Restablecer contraseña","ansForgotten":"Responda el desafío de contraseña olvidada","resetOktaPwd":"Restablece tu contraseña Okta","newpwd":"Nueva contraseña","rptpwd":"Repite la contraseña","adminLabel":"Gestión de usuarios","userAdministration":"Gestión de usuarios","adduser":"Añadir nuevo usuario","function":"Función","emailAddress":"Dirección de correo electrónico","filterApp":"Aplicación de filtro","create":"crear","logoutConfirm":"¿Seguro que quieres cerrar sesión?","no":"No","yes":"Si","logout":"Cerrar sesión","expireWarning":"Su sesión caducará en % minutos, presione OK para permanecer conectado o presione Cancelar para cerrar sesión. Si está desconectado, cualquier cambio se perderá","update":"Actualizar","activateDeactivate":"Activar/Desactivar","attention":"Atención","cancel":"Cancelar","sessionTimedout":"Su sesión ha expirado. Por favor vuelva a iniciar sesión","username":"Nombre de usuario","primary_mail":"Correo electrónico principal","secondary_mail":"Correo electrónico secundario (opcional)","groups":"Grupos","must_email":"Debe ser un correo electrónico","ieNotSupported":"IE no es compatible","tryChrome":"Internet Explorer no es compatible. Recomendamos utilizar Chrome para esta aplicación.","close":"Cerrar","forgotSQA":"¿Olvidó la respuesta de seguridad?","resetSecQA":"Restablecer la pregunta de seguridad y la contraseña","retry":"Regresar","nofactorpresent":"Esta opción no se puede usar porque el número de móvil no está configurado. Por favor contacte a su administrador.","emptypasscode":"El código no puede estar vacío","provisioned":"Este usuario aún no está registrado. La contraseña solo se puede restablecer después de que el usuario esté activo","deprovisioned":"Este usuario está desactivado. La contraseña solo se puede restablecer después de que el usuario esté activo","resetsuccesspopupmsg":"El enlace para restablecer la contraseña se ha enviado a la dirección de correo electrónico. Cierre la ventana emergente con el botón X.","wanttoreset":"¿Quieres restablecer la contraseña?","wanttoactivate":"¿Quieres activar el usuario?","wanttodeactivate":"¿Quieres desactivar el usuario?","wanttodelete":"¿Quieres eliminar el usuario?","updateprofile":"Actualización del perfil","updatesuccess":"El usuario ha sido actualizado exitosamente","usercreated":"* Usuario creado","errorcreatinguser":"* Error al crear usuario / correo electrónico ya existe","privacypolicy":"Política de privacidad","termsandconditions":"Términos y Condiciones","uname-email":"Nombre de usuario / correo electrónico","password_placeholder":"Contraseña","sign-in":"Iniciar sesión","resetmailsent":"Se ha enviado un correo electrónico a % con el enlace para restablecer la contraseña.","smssent":"expedido","resendcode":"Reenviar codigo","needhelp":"¿Necesita ayuda para iniciar sesión?","forgotPassword":"¿Se te olvidó tu contraseña?","helplink":"Ayuda","smsusage":"Los SMS solo se pueden usar si se ha configurado un número de teléfono móvil.","backtosignin":"Regresar a Iniciar sesión","resetviasms":"Restablecer por SMS","resetviaemail":"Restablecer por correo electrónico","didntreceivecode":"¿No recibió un código? Restablecer por correo electrónico","emailsent":"¡Email enviado!","recoverycredentialsnotset":"Olvidé mi contraseña porque las credenciales de recuperación no están establecidas para el usuario","usernotpresent":"Usuario no presente","mobilenumbernotset":"Número de teléfono móvil no establecido","invalidcreds":"Usuario o contraseña invalido","emailreq":"Correo electrónico requerido","emailinvalid":"Email inválido","pwdreq":"Se requiere contraseña","otplength":"OTP debería tener 6 caracteres de longitud","passcodeinvalid":"OTP inválido","firstnamereq":"Primer nombre obligatorio","lastnamereq":"Apellido obligatorio","notallowedincurrentstate":"Esta operación no está permitida en el estado de autenticación actual","nopartsofusername":"La contraseña no puede contener partes de su nombre de usuario, incluido su nombre o su apellido","passwordusedrecently":"La contraseña ha sido usada demasiado recientemente","passwordnotmetrequirements":"La contraseña no cumple con los requisitos de complejidad de la política de contraseñas actual","filteruser":"Filtrar usuarios por aplicación:","selectgroups":"Seleccionar aplicación","status":"Estado","atleastonegroup":"Seleccione al menos un grupo al que asignar el usuario","answerchallenge":"Respondida forgetton password challenge","entersmscode":"Ingrese el código de verificación enviado por SMS","enterusercreds":"Ingrese los detalles del usuario","inviteuser":"Invitar nuevo usuario","assignApplication":"Asignar a aplicación","availablegroups":"Grupos Disponibles","selectedgroups":"Grupos Asignados","emailsenttouser":"Correo electrónico enviado correctamente a ","pendingactivation":"Activación de cuenta pendiente","exit":"Salir","myprofile":"Mi perfil","activatesuccess":"El usuario se activó correctamente y se envió un correo de activación a ","deactivatesuccess":" se ha sido desactivado exitosamente","deletesuccess":" ha sido eliminado exitosamente","edituser":"Editar usuario","getstarted":"Empezar","congrats":"¡Felicidades!","accountsetup":"Has completado con éxito la configuración de tu cuenta.","edit":"Editar","assignedapps":"Aplicaciones Asignadas","assignedgroups":"Grupos Asignados","oldpwd":"Ingrese la contraseña anterior","changepwd":"Cambia la contraseña","updatephone":"Actualizar teléfono","pwdupdated":"La contraseña ha sido actualizada exitosamente","QAupdated":"La pregunta de seguridad respuesta se ha actualizado correctamente","phonenumberinvalid":"El número de teléfono no es válido","phoneupdated":"Número de teléfono actualizado correctamente","showmore":"Mostrar más","verifypassword":"Verificar contraseña","filterusergrp":"Filtrar usuarios por grupo:","allactiveusers":"Todos los usuarios activos","viewuser":"Ver usuario","partofokta":"Este usuario es parte de la organización Okta","userdeactive":"El usuario está desactivado.","showing":"Demostración","of":"de","answerpartofquestion":"La respuesta no debe ser parte de la pregunta","activationpending":"Su factor está pendiente de activación. Por favor actualice su número de teléfono, de lo contrario, los SMS de restablecimiento se enviarán a su número activo anterior","change_forgot_pwd_qtn":"Cambiar la pregunta de seguridad:","basicinfo":"Información básica","gotoapp":"Haga clic en la aplicación a la que desea ir","passwordresetsuccess":"Su contraseña ha sido restablecida exitosamente","passwordreset":"¡Restablecimiento de contraseña!","searchinfotext":"* La búsqueda se realiza solo en la aplicación","tmlabel":"Configuración","delete":"Eliminar","search":"Buscar","nop":"Número","nop_inst":"Ingrese su número como lo marca normalmente. No agregue el código de su país","nopMobile":"Número de teléfono móvil","statusactive":"Activo","statuspending":"Activacion pendiente","globalsearch":"Buscar otros usuarios","permissiondenied":"No puede eliminar / desactivar este usuario. usuario asignado a otros grupos. Puede desasignar al usuario en su lugar","activestatus":"ACTIVO","provisionedstatus":"PROVISIONADO","deprovisionedstatus":"DEPROVISIONADO","save":"Guardar","admingroup":"Grupo de administración","application":"Solicitud","selectadmingroup":"Seleccionar grupo de administradores","selectapp":"Seleccionar aplicación","adminConfigIncomplete":"Fila incompleta. Asigne un grupo de administración, marca y grupos administrados para guardar o eliminar la fila","adminconfigdeletesuccess":"Borrado exitosamente","adminconfigupdatesuccess":"Configuración actualizada exitosamente ","wanttodeleteadminconfig":"¿Quieres borrar esta configuración?","cannotdeleteconfig":"Esta configuración no puede ser eliminada","nonanoktauser":"No está permitido realizar esta acción. El proveedor de identidad de este usuario no es Okta.","reactivate":"Reenviar invitación","wanttoreactivate":"¿Desea reenviar el enlace de activación al usuario?","iread1":"Acepto que los portales,las aplicaciones y los servicios de los clientes de Cargill disponibles a través de ellos están sujetos al Portal del cliente de Cargill","iread2":"Términos y Condiciones","iread3":"que puede ser complementado o enmendado por términos y condiciones específicos para cada servicio comercial aplicable.","iagree1":"Reconozco y acepto que el procesamiento de datos personales de Cargill en relación con los servicios y aplicaciones de portales de clientes de Cargill está sujeto a los requisitos de Cargill.","iagree2":"Política de privacidad en línea","iagree3":"que puede ser complementado o enmendado por 'Avisos de privacidad' para cada servicio comercial aplicable.","privacypolicy_link":"https://www.cargill.com/page/privacy","termsandconditions_link":"https://www.cargill.com/portal-terms","resetreactivate":"Restablecer / Reactivar","emailinvaliddomain":"El usuario con este dominio no puede ser agregado","administeredgroups":"Grupos administrados","selectgroupslist":"Seleccionar grupos","alreadyactive":"Eres un usuario activo!","alreadyactivesetup":"Tu perfil no requiere registro. Utilice el inicio de sesión de los empleados de Cargill para iniciar sesión en sus aplicaciones.","selectBrand":"Marca seleccionada","permissiondeniedreset":"No puede restablecer la contraseña para este usuario.","unlockaccount":"Desbloquear cuenta","unlockaccountsuccess":"Tu cuenta ha sido desbloqueada con éxito","accountunlocked":"Cuenta desbloqueada!","copyrefid":"Please copy the reference Id from the bottom of the email you received and paste it below to proceed.","securityquestionanswerweak":"La respuesta de la pregunta de seguridad es demasiado débil, la respuesta no debe ser parte de la pregunta","securityanswermatchesquestion":"Respuesta de seguridad no válida: la respuesta no debe contener $, que es parte de la pregunta de seguridad","copysecurityanswermatchesquestion":"Respuesta de seguridad no válida: la respuesta no debe contener $, que es parte de la pregunta de seguridad","tokenInvalidShortMessage":"El enlace de activación ya no es válido.","browserspecificmsg":"Considere usar el navegador Google Chrome.","enterActivationDetails":"Para obtener la información que se solicita más abajo, consulte el correo electrónico de activación.","resendActivation":"Reenviar correo electrónico de invitación","reinvite":"Reenviar invitación","reinviteEmailMessage":"Si la información que ha suministrado es correcta, recibirá un correo electrónico de activación nuevo.","reinviteContactAdminMessage":"Si no recibe el correo electrónico de activación nuevo, póngase en contacto con Cargill.","activationOk":"Ok","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","disableExistingUserOnboard":"Disable Existing User","selfRegSubGrps":"Self registration additional group:","selectReggroup":"Select Registration group","selfRegister":"Regístrese","selfRegFormTitle":"Registrarse","E0001":"Lo sentimos, hubo un problema con la configuración de su cuenta. ","E0001_1":"Comuníquese con nosotros ","E0001_2":"","E0002":" para obtener ayuda con la configuración de su cuenta.","E0003":"Su cuenta se ha registrado correctamente. Se ha enviado un correo electrónico a la ","E0003_1":" con instrucciones para activar su cuenta.","E0004":"Su cuenta se ha registrado correctamente. Ahora puede iniciar sesión en la aplicación utilizando su contraseña existente. Si no recuerda su contraseña, utilice la opción “Olvidó su contraseña“ en la aplicación para restablecer su contraseña.","E0005":"User already exists with status ","E0005_1":" Please contact ","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"No se cumplieron los requisitos de contraseña. Requisitos de la contraseña: al menos 8 caracteres, una letra minúscula, una letra mayúscula, un número, ninguna parte de su nombre de usuario. Su contraseña no puede ser ninguna de sus últimas 24 contraseñas.","acceptTerms":"Acepte nuestra Política de privacidad y los Términos y condiciones para continuar.","phoneVerificationNotCompleted":"Por favor verifique/elimine su número de teléfono para continuar.","verifyPhoneWarning":"Haga clic en 'Enviar código' para verificar su número de teléfono","viewMoreInfo":"Ver más información","infoContent":"Ver más información sobre el usuario","createdDate":"Fecha de creación","activatedDate":"Fecha de activación","lastLoginDate":"Última fecha de inicio de sesión","lastUpdatedDate":"Fecha de última actualización","passwordChangedDate":"Fecha de cambio de contraseña","statusChangedDate":"Fecha de cambio de estado","createdDateDescription":"Fecha y hora en que se creó el registro de usuario en Okta.","activatedDateDescription":"Fecha y hora en que se envió el último correo electrónico de activación del usuario.","statusChangedDateDescription":"Fecha y hora en que se cambió por última vez el estado del usuario en Okta.","lastLoginDateDescription":"Fecha y hora en que el usuario inició sesión por última vez en Okta (no específico de la aplicación).","lastUpdatedDateDescription":"Fecha y hora en que se actualizó por última vez el registro de usuario en Okta.","passwordChangedDateDescription":"Fecha y hora en que el usuario cambió su contraseña por última vez.","resetMFATitle":"Restablecer autenticación multifactor","noFactorExist":"No existe ningún factor para este usuario.","mfaValidation":"Seleccione un factor para restablecer.","resetButton":"Reiniciar","mfaResetModalTitle":"Restablecimiento de MFA","factorResetSuccess":"El factor se restableció con éxito.","resetConfirmation":"¿Está seguro de que desea restablecer MFA para este usuario?","copyrights":"Cargill, Incorporado. Reservados todos los derechos.","reportLabel":"Informe","bulkUploadLabel":"Carga masiva de usuarios","availableIndependentGroups":"Grupos independientes disponibles:","selectedBrand":"Marca seleccionada:","bulkUploadOptionsLabel":"Opciones de carga masiva","bulkCreateUsers":"Crear usuarios en masa","bulkReinviteUsers":"Re-invitar a granel a los usuarios","confirm":"Confirmar","downloadExcelTemplate":"Descargar plantilla de Excel:","uploadInstruction":"Después de descargar la plantilla, complete la hoja de Excel y cárguela usando la sección a continuación","uploadWarningOne":"Máximo de solo 50 usuarios permitidos a la vez.","uploadWarningTwo":"Asegúrese de que el campo de correo electrónico no quede vacío.","uploadWarningThree":"Asegúrese de que usted administre las identificaciones de correo electrónico proporcionadas.","uploadWarningFour":"Asegúrese de que no queden campos vacíos.","uploadWarningFive":"Asegúrese de que todos los valores de los campos sean válidos.","uploadWarningSix":"Asegúrese de que usted administre los ID de grupo proporcionados.","uploadNote":"Las invitaciones enviadas a través de este proceso siguen el correo electrónico estándar de invitación a la cuenta de Cargill.","uploadLabel":"Subir","action":"Comportamiento","userword":"usuarias","note":"Nota:","authentication":"Autenticación","noTableData":"No hay datos para la tabla.","readOnlyGroup":"Este es un grupo de solo lectura. La asignación para este grupo debe realizarse únicamente a través de access.cargill.com","adminPermissionDenied":"Sus derechos de administrador de usuario no tienen permisos para modificar esta asignación de grupo.","msgForGenericErrorUA":"Actualmente tenemos un problema con el procesamiento de su solicitud. Por favor, inténtelo de nuevo más tarde. Si continúa viendo este error, comuníquese con su representante de servicio al cliente para obtener más ayuda.","passcodeRateLimit":"No se puede procesar su solicitud. Vuelva a intentarlo en 5 minutos.","passcodeNotEntered":"Ingrese el código de acceso para verificar.","msgForUnhandledResponse":"No se puede procesar la solicitud, comuníquese con su representante de servicio al cliente.","groupUnavailable":"El grupo ya no está disponible en Okta. Es posible que el grupo haya sido eliminado.","groupCannotBeAssigned":"El grupo $ ya no está disponible en Okta y, por lo tanto, no se puede asignar al usuario. Elimina el grupo y continúa.","copyGroupCannotBeAssigned":"El grupo $ ya no está disponible en Okta y, por lo tanto, no se puede asignar al usuario. Elimina el grupo y continúa."}

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_LoggingIn__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_LoggingIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modules_LoggingIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_Admin__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_Admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modules_Admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_AdminOld__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_AdminOld___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__modules_AdminOld__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jwt_decode__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_UserRegistration__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_UserRegistration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__modules_UserRegistration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_SelfRegistration__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_SelfRegistration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__modules_SelfRegistration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_ResetPassword__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_ResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__modules_ResetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_MyProfile__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_MyProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__modules_MyProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_Login__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__modules_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_Error__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__modules_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_TokenManager__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_TokenManager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__modules_TokenManager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_TokenManagerOld__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_TokenManagerOld___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__modules_TokenManagerOld__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_APISettings__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_APISettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__modules_APISettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_APISettingsOld__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_APISettingsOld___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__modules_APISettingsOld__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_SystemLogs__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_SystemLogs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__modules_SystemLogs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_Reports__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_Reports___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__modules_Reports__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__okta_okta_vue__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__okta_okta_auth_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__okta_okta_auth_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__okta_okta_auth_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__helpers_storage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__helpers_okta_config__ = __webpack_require__(87);



var _this = this;






























var config = __WEBPACK_IMPORTED_MODULE_24__helpers_okta_config__["default"].getConfig();
var oktaAuth = new __WEBPACK_IMPORTED_MODULE_22__okta_okta_auth_js__["OktaAuth"]({
  issuer: config.issuer,
  clientId: config.clientId,
  redirectUri: config.redirectUrl,
  scopes: config.scopes,
  pkce: config.pkce
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_21__okta_okta_vue__["a" /* default */], { oktaAuth: oktaAuth });

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/Error',
    name: 'Error',
    component: __WEBPACK_IMPORTED_MODULE_14__modules_Error___default.a
  }, {
    path: '/LoggingIn',
    name: 'LoggingIn',
    component: __WEBPACK_IMPORTED_MODULE_4__modules_LoggingIn___default.a
  }, {
    path: '/Admin',
    name: 'Admin',
    component: __WEBPACK_IMPORTED_MODULE_5__modules_Admin___default.a,
    meta: {
      requiresAuthentication: true
    }
  }, {
    path: '/AdminOld',
    name: 'adminold',
    component: __WEBPACK_IMPORTED_MODULE_6__modules_AdminOld___default.a,
    meta: {
      requiresAuthentication: true
    }
  }, {
    path: '/Login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_13__modules_Login___default.a
  }, {
    path: '*',
    redirect: '/Admin',
    component: __WEBPACK_IMPORTED_MODULE_5__modules_Admin___default.a
  }, {
    path: '/UserRegistration',
    name: 'UserRegistration',
    component: __WEBPACK_IMPORTED_MODULE_9__modules_UserRegistration___default.a
  }, {
    path: '/SelfRegistration',
    name: 'SelfRegistration',
    component: __WEBPACK_IMPORTED_MODULE_10__modules_SelfRegistration___default.a
  }, {
    path: '/ResetPassword',
    name: 'ResetPassword',
    component: __WEBPACK_IMPORTED_MODULE_11__modules_ResetPassword___default.a
  }, {
    path: '/MyProfile',
    name: 'MyProfile',
    component: __WEBPACK_IMPORTED_MODULE_12__modules_MyProfile___default.a,
    meta: {
      requiresAuthentication: true
    }
  }, {
    path: '/TokenManager',
    name: 'TokenManager',
    component: __WEBPACK_IMPORTED_MODULE_15__modules_TokenManager___default.a,
    meta: {
      requiresAuthentication: true
    }
  }, {
    path: '/TokenManagerOld',
    name: 'TokenManagerOld',
    component: __WEBPACK_IMPORTED_MODULE_16__modules_TokenManagerOld___default.a,
    meta: {
      requiresAuthentication: true
    }
  }, {
    path: '/UnlockAccount',
    name: 'ResetPassword',
    component: __WEBPACK_IMPORTED_MODULE_11__modules_ResetPassword___default.a
  }, {
    path: '/APISettings',
    name: 'APISettings',
    component: __WEBPACK_IMPORTED_MODULE_17__modules_APISettings___default.a,
    meta: {
      requiresAuthentication: true
    }
  }, {
    path: '/APISettingsOld',
    name: 'APISettingsOld',
    component: __WEBPACK_IMPORTED_MODULE_18__modules_APISettingsOld___default.a,
    meta: {
      requiresAuthentication: true
    }
  }, {
    path: '/SystemLogs',
    name: 'SystemLogs',
    component: __WEBPACK_IMPORTED_MODULE_19__modules_SystemLogs___default.a,
    meta: {
      requiresAuthentication: true
    }
  }, {
    path: '/login/callback',
    name: 'Callback',
    component: __WEBPACK_IMPORTED_MODULE_21__okta_okta_vue__["b" /* LoginCallback */]
  }, {
    path: '/Reports',
    name: 'Reports',
    component: __WEBPACK_IMPORTED_MODULE_20__modules_Reports___default.a,
    meta: {
      requiresAuthentication: true
    }
  }]
});

router.beforeEach(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(from, to, next) {
    var userRole, isAuth, redirectUrl;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            userRole = __WEBPACK_IMPORTED_MODULE_23__helpers_storage__["default"].get('cf-userRole');
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$auth.isAuthenticated();

          case 3:
            isAuth = _context.sent;

            if (from.matched.some(function (record) {
              return record.meta.requiresAuthentication;
            }) && !isAuth) {
              next({ path: "Login" });
            } else {
              if (from.hash.indexOf('id_token') > -1) {
                __WEBPACK_IMPORTED_MODULE_23__helpers_storage__["default"].set('id_token', from.hash.split('&')[0].split('=')[1]);
                __WEBPACK_IMPORTED_MODULE_23__helpers_storage__["default"].set('access_token', from.hash.split('&')[1].split('=')[1]);
                __WEBPACK_IMPORTED_MODULE_7__store__["default"].commit('setUser', __WEBPACK_IMPORTED_MODULE_8_jwt_decode___default()(from.hash.split('&')[0].split('=')[1]));
              }
              if (to.fullPath.indexOf('rd=') !== -1) {
                redirectUrl = to.fullPath.split("%2Fhome%2F");

                redirectUrl = decodeURIComponent(redirectUrl[1]);
                window.location.href = "https://cargillcustomer-uat.oktapreview.com/" + 'home/' + redirectUrl;
              } else if (from.name.toLowerCase() === 'admin' && (userRole === 'notadmin' || userRole === undefined)) {
                next({ replace: true, name: 'MyProfile' });
              } else if ((from.name.toLowerCase() === 'adminold' || from.name.toLowerCase() === 'tokenmanager' || from.name.toLowerCase() === 'tokenmanagerold' || from.name.toLowerCase() === 'apisettings' || from.name.toLowerCase() === 'apisettingsold' || from.name.toLowerCase() === 'systemlogs') && (userRole === 'admin' || userRole === 'notadmin' || userRole === undefined)) {
                next({ replace: true, name: 'MyProfile' });
              } else {
                next();
              }
            }

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["default"] = (router);

/***/ }),
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(734)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(709),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-30e6c6f8", Component.options)
  } else {
    hotAPI.reload("data-v-30e6c6f8", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";

/* harmony default export */ __webpack_exports__["default"] = ({
  deactivateOktaUser: function deactivateOktaUser(uid, reqType) {
    if (reqType === "deactivateoktauser") {
      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/auth/users/" + uid + "/deactivate", {});
    } else if (reqType === "deleteoktauser") {
      return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'delete',
        url: apiUrl + "/auth/users/" + uid,
        data: null,
        headers: { 'Content-Type': 'application/json' }
      });
    }
  },
  activateOktaUser: function activateOktaUser(uid) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUrl + "/auth/users/" + uid + "/activate", {});
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var groups = [{ "groupName": "COPRA_PH_SlotBooking_ExternalUser", "lang": "ph" }, { "groupName": "DXP_CACP_ExternalUsers", "lang": "aus" }];

/* harmony default export */ __webpack_exports__["default"] = ({
  getGroup: function getGroup(group) {
    var val = groups.filter(function (x) {
      return x.groupName.indexOf(group) > -1;
    });
    if (val.length > 0) {
      return val;
    } else {
      return -1;
    }
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  lang: {
    common: [{ key: "93", value: "93" }, { key: "355", value: "355" }, { key: "213", value: "213" }, { key: "1684", value: "1684" }, { key: "376", value: "376" }, { key: "244", value: "244" }, { key: "1264", value: "1264" }, { key: "0672", value: "antar" }, { key: "1268", value: "1268" }, { key: "54", value: "54" }, { key: "374", value: "374" }, { key: "297", value: "297" }, { key: "061", value: "aus" }, { key: "43", value: "43" }, { key: "994", value: "994" }, { key: "1242", value: "1242" }, { key: "973", value: "973" }, { key: "880", value: "880" }, { key: "1246", value: "1246" }, { key: "375", value: "375" }, { key: "32", value: "32" }, { key: "501", value: "501" }, { key: "229", value: "229" }, { key: "1441", value: "1441" }, { key: "975", value: "975" }, { key: "591", value: "591" }, { key: "387", value: "387" }, { key: "267", value: "267" }, { key: "55", value: "55" }, { key: "246", value: "246" }, { key: "673", value: "673" }, { key: "359", value: "359" }, { key: "226", value: "226" }, { key: "257", value: "257" }, { key: "855", value: "855" }, { key: "237", value: "237" }, { key: "01", value: "can" }, { key: "238", value: "238" }, { key: "1345", value: "1345" }, { key: "236", value: "236" }, { key: "235", value: "235" }, { key: "56", value: "56" }, { key: "86", value: "86" }, { key: "61", value: "61" }, { key: "57", value: "57" }, { key: "269", value: "269" }, { key: "242", value: "242" }, { key: "243", value: "243" }, { key: "682", value: "682" }, { key: "506", value: "506" }, { key: "385", value: "385" }, { key: "53", value: "53" }, { key: "357", value: "357" }, { key: "420", value: "420" }, { key: "45", value: "45" }, { key: "253", value: "253" }, { key: "1767", value: "1767" }, { key: "1809", value: "1809" }, { key: "593", value: "593" }, { key: "20", value: "20" }, { key: "503", value: "503" }, { key: "240", value: "240" }, { key: "291", value: "291" }, { key: "372", value: "372" }, { key: "251", value: "251" }, { key: "0500", value: "falk" }, { key: "298", value: "298" }, { key: "679", value: "679" }, { key: "358", value: "358" }, { key: "33", value: "33" }, { key: "689", value: "689" }, { key: "241", value: "241" }, { key: "220", value: "220" }, { key: "995", value: "995" }, { key: "49", value: "49" }, { key: "233", value: "233" }, { key: "350", value: "350" }, { key: "30", value: "30" }, { key: "299", value: "299" }, { key: "1473", value: "1473" }, { key: "590", value: "590" }, { key: "1671", value: "1671" }, { key: "502", value: "502" }, { key: "441481", value: "441481" }, { key: "224", value: "224" }, { key: "245", value: "245" }, { key: "592", value: "592" }, { key: "509", value: "509" }, { key: "379", value: "379" }, { key: "504", value: "504" }, { key: "852", value: "852" }, { key: "36", value: "36" }, { key: "354", value: "354" }, { key: "91", value: "91" }, { key: "62", value: "62" }, { key: "98", value: "98" }, { key: "964", value: "964" }, { key: "353", value: "353" }, { key: "972", value: "972" }, { key: "39", value: "39" }, { key: "225", value: "225" }, { key: "1876", value: "1876" }, { key: "81", value: "81" }, { key: "441534", value: "441534" }, { key: "962", value: "962" }, { key: "07", value: "kazak" }, { key: "254", value: "254" }, { key: "686", value: "686" }, { key: "850", value: "850" }, { key: "82", value: "82" }, { key: "965", value: "965" }, { key: "996", value: "996" }, { key: "856", value: "856" }, { key: "371", value: "371" }, { key: "961", value: "961" }, { key: "266", value: "266" }, { key: "231", value: "231" }, { key: "218", value: "218" }, { key: "423", value: "423" }, { key: "370", value: "370" }, { key: "352", value: "352" }, { key: "853", value: "853" }, { key: "389", value: "389" }, { key: "261", value: "261" }, { key: "265", value: "265" }, { key: "60", value: "60" }, { key: "960", value: "960" }, { key: "223", value: "223" }, { key: "356", value: "356" }, { key: "692", value: "692" }, { key: "596", value: "596" }, { key: "222", value: "222" }, { key: "230", value: "230" }, { key: "0262", value: "mayotte" }, { key: "52", value: "52" }, { key: "691", value: "691" }, { key: "373", value: "373" }, { key: "377", value: "377" }, { key: "976", value: "976" }, { key: "382", value: "382" }, { key: "1664", value: "1664" }, { key: "0212", value: "morocco" }, { key: "258", value: "258" }, { key: "95", value: "95" }, { key: "264", value: "264" }, { key: "674", value: "674" }, { key: "977", value: "977" }, { key: "31", value: "31" }, { key: "599", value: "599" }, { key: "687", value: "687" }, { key: "64", value: "64" }, { key: "505", value: "505" }, { key: "227", value: "227" }, { key: "234", value: "234" }, { key: "683", value: "683" }, { key: "672", value: "672" }, { key: "1670", value: "1670" }, { key: "047", value: "norway" }, { key: "968", value: "968" }, { key: "92", value: "92" }, { key: "680", value: "680" }, { key: "970", value: "970" }, { key: "507", value: "507" }, { key: "675", value: "675" }, { key: "595", value: "595" }, { key: "51", value: "51" }, { key: "63", value: "63" }, { key: "064", value: "pitcairn" }, { key: "48", value: "48" }, { key: "351", value: "351" }, { key: "1787", value: "1787" }, { key: "974", value: "974" }, { key: "262", value: "262" }, { key: "40", value: "40" }, { key: "7", value: "7" }, { key: "250", value: "250" }, { key: "290", value: "290" }, { key: "1869", value: "1869" }, { key: "1758", value: "1758" }, { key: "508", value: "508" }, { key: "1784", value: "1784" }, { key: "685", value: "685" }, { key: "378", value: "378" }, { key: "239", value: "239" }, { key: "966", value: "966" }, { key: "221", value: "221" }, { key: "381", value: "381" }, { key: "248", value: "248" }, { key: "232", value: "232" }, { key: "65", value: "65" }, { key: "421", value: "421" }, { key: "386", value: "386" }, { key: "677", value: "677" }, { key: "252", value: "252" }, { key: "27", value: "27" }, { key: "500", value: "500" }, { key: "211", value: "211" }, { key: "34", value: "34" }, { key: "94", value: "94" }, { key: "249", value: "249" }, { key: "597", value: "597" }, { key: "47", value: "47" }, { key: "268", value: "268" }, { key: "46", value: "46" }, { key: "41", value: "41" }, { key: "963", value: "963" }, { key: "886", value: "886" }, { key: "992", value: "992" }, { key: "255", value: "255" }, { key: "66", value: "66" }, { key: "670", value: "670" }, { key: "228", value: "228" }, { key: "690", value: "690" }, { key: "676", value: "676" }, { key: "1868", value: "1868" }, { key: "216", value: "216" }, { key: "90", value: "90" }, { key: "993", value: "993" }, { key: "1649", value: "1649" }, { key: "688", value: "688" }, { key: "256", value: "256" }, { key: "380", value: "380" }, { key: "971", value: "971" }, { key: "44", value: "44" }, { key: "1", value: "1" }, { key: "598", value: "598" }, { key: "998", value: "998" }, { key: "678", value: "678" }, { key: "58", value: "58" }, { key: "84", value: "84" }, { key: "1284", value: "1284" }, { key: "1340", value: "1340" }, { key: "681", value: "681" }, { key: "212", value: "212" }, { key: "967", value: "967" }, { key: "260", value: "260" }, { key: "263", value: "263" }],
    es: [{ key: "93", value: "93" }, { key: "355", value: "355" }, { key: "49", value: "49" }, { key: "376", value: "376" }, { key: "244", value: "244" }, { key: "1264", value: "1264" }, { key: "672", value: "672" }, { key: "1268", value: "1268" }, { key: "599", value: "599" }, { key: "966", value: "966" }, { key: "213", value: "213" }, { key: "54", value: "54" }, { key: "374", value: "374" }, { key: "297", value: "297" }, { key: "61", value: "61" }, { key: "43", value: "43" }, { key: "994", value: "994" }, { key: "1242", value: "1242" }, { key: "880", value: "880" }, { key: "1246", value: "1246" }, { key: "973", value: "973" }, { key: "32", value: "32" }, { key: "501", value: "501" }, { key: "229", value: "229" }, { key: "1441", value: "1441" }, { key: "375", value: "375" }, { key: "95", value: "95" }, { key: "591", value: "591" }, { key: "387", value: "387" }, { key: "267", value: "267" }, { key: "55", value: "55" }, { key: "673", value: "673" }, { key: "359", value: "359" }, { key: "226", value: "226" }, { key: "257", value: "257" }, { key: "975", value: "975" }, { key: "238", value: "238" }, { key: "855", value: "855" }, { key: "237", value: "237" }, { key: "974", value: "974" }, { key: "235", value: "235" }, { key: "56", value: "56" }, { key: "86", value: "86" }, { key: "357", value: "357" }, { key: "57", value: "57" }, { key: "269", value: "269" }, { key: "242", value: "242" }, { key: "82", value: "82" }, { key: "225", value: "225" }, { key: "506", value: "506" }, { key: "385", value: "385" }, { key: "53", value: "53" }, { key: "45", value: "45" }, { key: "1767", value: "1767" }, { key: "593", value: "593" }, { key: "20", value: "20" }, { key: "503", value: "503" }, { key: "971", value: "971" }, { key: "291", value: "291" }, { key: "421", value: "421" }, { key: "386", value: "386" }, { key: "34", value: "34" }, { key: "1", value: "1" }, { key: "372", value: "372" }, { key: "251", value: "251" }, { key: "63", value: "63" }, { key: "358", value: "358" }, { key: "679", value: "679" }, { key: "33", value: "33" }, { key: "241", value: "241" }, { key: "220", value: "220" }, { key: "995", value: "995" }, { key: "233", value: "233" }, { key: "350", value: "350" }, { key: "1473", value: "1473" }, { key: "30", value: "30" }, { key: "299", value: "299" }, { key: "590", value: "590" }, { key: "1671", value: "1671" }, { key: "502", value: "502" }, { key: "441481", value: "441481" }, { key: "224", value: "224" }, { key: "240", value: "240" }, { key: "245", value: "245" }, { key: "592", value: "592" }, { key: "509", value: "509" }, { key: "504", value: "504" }, { key: "852", value: "852" }, { key: "36", value: "36" }, { key: "91", value: "91" }, { key: "62", value: "62" }, { key: "964", value: "964" }, { key: "98", value: "98" }, { key: "353", value: "353" }, { key: "262", value: "262" }, { key: "354", value: "354" }, { key: "1345", value: "1345" }, { key: "682", value: "682" }, { key: "298", value: "298" }, { key: "500", value: "500" }, { key: "1670", value: "1670" }, { key: "692", value: "692" }, { key: "677", value: "677" }, { key: "1649", value: "1649" }, { key: "1340", value: "1340" }, { key: "1284", value: "1284" }, { key: "972", value: "972" }, { key: "39", value: "39" }, { key: "1876", value: "1876" }, { key: "81", value: "81" }, { key: "441534", value: "441534" }, { key: "962", value: "962" }, { key: "254", value: "254" }, { key: "996", value: "996" }, { key: "686", value: "686" }, { key: "383", value: "383" }, { key: "965", value: "965" }, { key: "266", value: "266" }, { key: "371", value: "371" }, { key: "961", value: "961" }, { key: "231", value: "231" }, { key: "218", value: "218" }, { key: "423", value: "423" }, { key: "370", value: "370" }, { key: "352", value: "352" }, { key: "853", value: "853" }, { key: "389", value: "389" }, { key: "261", value: "261" }, { key: "60", value: "60" }, { key: "265", value: "265" }, { key: "960", value: "960" }, { key: "223", value: "223" }, { key: "356", value: "356" }, { key: "212", value: "212" }, { key: "596", value: "596" }, { key: "230", value: "230" }, { key: "222", value: "222" }, { key: "52", value: "52" }, { key: "691", value: "691" }, { key: "373", value: "373" }, { key: "377", value: "377" }, { key: "976", value: "976" }, { key: "382", value: "382" }, { key: "1664", value: "1664" }, { key: "258", value: "258" }, { key: "264", value: "264" }, { key: "674", value: "674" }, { key: "977", value: "977" }, { key: "505", value: "505" }, { key: "227", value: "227" }, { key: "234", value: "234" }, { key: "683", value: "683" }, { key: "47", value: "47" }, { key: "687", value: "687" }, { key: "64", value: "64" }, { key: "968", value: "968" }, { key: "31", value: "31" }, { key: "92", value: "92" }, { key: "680", value: "680" }, { key: "970", value: "970" }, { key: "507", value: "507" }, { key: "675", value: "675" }, { key: "595", value: "595" }, { key: "51", value: "51" }, { key: "689", value: "689" }, { key: "48", value: "48" }, { key: "351", value: "351" }, { key: "1787", value: "1787" }, { key: "44", value: "44" }, { key: "963", value: "963" }, { key: "236", value: "236" }, { key: "420", value: "420" }, { key: "82", value: "82" }, { key: "243", value: "243" }, { key: "856", value: "856" }, { key: "1809", value: "1809" }, { key: "255", value: "255" }, { key: "250", value: "250" }, { key: "40", value: "40" }, { key: "7", value: "7" }, { key: "685", value: "685" }, { key: "1684", value: "1684" }, { key: "1869", value: "1869" }, { key: "378", value: "378" }, { key: "1784", value: "1784" }, { key: "508", value: "508" }, { key: "1758", value: "1758" }, { key: "290", value: "290" }, { key: "239", value: "239" }, { key: "221", value: "221" }, { key: "381", value: "381" }, { key: "248", value: "248" }, { key: "232", value: "232" }, { key: "65", value: "65" }, { key: "252", value: "252" }, { key: "94", value: "94" }, { key: "268", value: "268" }, { key: "27", value: "27" }, { key: "249", value: "249" }, { key: "211", value: "211" }, { key: "46", value: "46" }, { key: "41", value: "41" }, { key: "597", value: "597" }, { key: "66", value: "66" }, { key: "886", value: "886" }, { key: "992", value: "992" }, { key: "246", value: "246" }, { key: "670", value: "670" }, { key: "228", value: "228" }, { key: "690", value: "690" }, { key: "676", value: "676" }, { key: "1868", value: "1868" }, { key: "216", value: "216" }, { key: "993", value: "993" }, { key: "90", value: "90" }, { key: "688", value: "688" }, { key: "380", value: "380" }, { key: "256", value: "256" }, { key: "598", value: "598" }, { key: "998", value: "998" }, { key: "678", value: "678" }, { key: "379", value: "379" }, { key: "58", value: "58" }, { key: "84", value: "84" }, { key: "681", value: "681" }, { key: "967", value: "967" }, { key: "253", value: "253" }, { key: "260", value: "260" }, { key: "263", value: "263" }]
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var apps = [{ name: "default", msg: "You are not assigned to this app in Okta.", contact: "" }, { name: "seedware", msg: "You are not set up for automatic sign-in to SeedWare with Corteva", contact: "the_resource@agresource.ca" }];

/* harmony default export */ __webpack_exports__["default"] = ({
  getCustomErrorMsg: function getCustomErrorMsg(name) {
    if (name) {
      return apps.filter(function (app) {
        return app.name === name;
      })[0];
    } else {
      return apps[0];
    }
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var groupsPh = ["DXP_Opslink_ExternalUsers", "DXP_Russia_Users", "DXP_GPS_ExternalUsers", "DXP_Food_ExternalUsers"];
/* harmony default export */ __webpack_exports__["default"] = ({
  getGroupPh: function getGroupPh(group) {
    var val = groupsPh.indexOf(group) > -1;
    return val;
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var i18nConfig = {
  'en': {
    'needhelp': "Password Recovery",
    'primaryauth.submit': 'Log In',
    'password.forgot.email.or.username.placeholder': 'Username',
    'password.forgot.email.or.username.tooltip': 'Username'
  },
  'es': {
    'primaryauth.title': 'Iniciar sesión',
    'primaryauth.username.placeholder': 'Nombre de usuario',
    'mfa.challenge.password.placeholder': 'Contraseña',
    'oform.next': 'Siguiente',
    'unlockaccount': '¿Desbloquear cuenta?',
    'help': 'Ayuda',
    'password.reset.title.generic': 'Restablecer contraseña',
    'password.complexity.requirements.header': 'Requisitos de contraseña: ',
    'password.complexity.length.description': 'Debe contener al menos {0} caracteres',
    'password.complexity.lowercase.description': 'Debe contener al menos una letra minúscula',
    'password.complexity.uppercase.description': 'Debe contener al menos una letra mayúscula',
    'password.complexity.number.description': 'Debe contener al menos un número',
    'password.complexity.symbol.description': 'Debe contener al menos un carácter especial',
    'password.complexity.no_username.description': 'No debe contener parte del nombre de usuario',
    'password.complexity.no_first_name.description': 'No debe contener parte de su nombre',
    'password.complexity.no_last_name.description': 'No debe contener parte de su apellido',
    'password.complexity.history.description': 'La contraseña no puede ser la misma que su última contraseña',
    'oie.password.newPasswordLabel': 'Nueva contraseña',
    'oie.password.confirmPasswordLabel': 'Repita la nueva contraseña',
    'password.reset.revokeSessions': 'Cierra mi sesión en todos los demás dispositivos.',
    'password.reset': 'Restablecer contraseña',
    'goback': 'Regresar a Iniciar sesión',
    'idx.return.link.otponly.your.verification.code': 'Su código de verificación',
    'idx.enter.otp.in.original.tab': 'Ingrese la OTP en su ubicación de autenticación original.',
    'idx.return.link.otponly.warning.text': 'Si no solicitó este código, puede ignorar este mensaje. Su cuenta es segura y solo se puede acceder a ella con este código.',
    'oie.selfservice.unlock_user.landing.to.app.success.message': '¡Cuenta desbloqueada exitosamente! Verifique su cuenta con un método de seguridad para continuar',
    'oie.password.challenge.title': 'Verifique con su contraseña',
    'oie.password.label': 'Contraseña',
    'mfa.challenge.verify': 'verificar',
    'forgotpassword': 'Ha olvidado su contraseña',
    'oie.email.challenge.mfa.title': 'Obtenga  un correo electrónico de verificación',
    'oie.email.verify.subtitle.text.without.email': 'Envíe un correo electrónico de verificación haciendo clic en "Envíame un correo electrónico".',
    'oie.email.verify.primaryButton': 'Envíame un correo electrónico',
    'oie.email.mfa.title': 'Verifique con su correo electrónico',
    'oie.email.verify.alternate.magicLinkToEmailAddress': 'Enviamos un correo electrónico a <$1>{0}</$1>.',
    'oie.email.verify.alternate.verificationCode.instructions': 'Ingrese el código de verificación en el cuadro de texto.',
    'mfa.challenge.enterCode.placeholder': 'Introducir código',
    'oie.select.authenticators.verify.title': 'Verifique que es usted con un método de seguridad',
    'oie.select.authenticators.verify.subtitle': 'Seleccione entre las siguientes opciones',
    'oie.email.label': 'Correo electrónico',
    'oie.verify.authenticator.button.text': 'Seleccionar',
    'oie.phone.label': 'Teléfono',
    'oie.phone.verify.sms.sendText.without.phone': 'Enviar un código vía SMS a su teléfono',
    'oie.phone.carrier.charges': 'Es posible que se apliquen cargos por mensajería del operador',
    'oie.phone.sms.primaryButton': 'Recibir un código vía SMS',
    'oie.phone.call.secondaryButton': 'Recibir una llamada de voz en su lugar',
    'oie.verification.switch.authenticator': 'Verificar con otra cosa',
    'oie.email.verify.alternate.magicLinkToYourEmail': 'Le enviamos un correo electrónico de verificación.',
    'oie.email.verify.alternate.instructions': 'Haga clic en el enlace de verificación en su correo electrónico para continuar o ingrese el código a continuación.',
    'oie.email.verify.alternate.show.verificationCode.text': 'Introducir un código de verificación en su lugar',
    'oie.phone.verify.mfa.calling.without.phone': 'Llamando a su teléfono. Ingrese el código a continuación para verificar.',
    'oie.phone.verify.sms.codeSentText.without.phone': 'Se envió un código a su teléfono. Ingrese el código a continuación para verificar.',
    'oie.password.reset.verification': 'Verifique con uno de los siguientes métodos de seguridad para restablecer su contraseña.',
    'oie.phone.verify.title': 'Verifique con su teléfono',
    'oie.phone.verify.sms.sendText': 'Enviar un código vía SMS a',
    'oie.phone.alternate.title': 'su teléfono',
    'mfa.calling': 'llamando',
    'oie.phone.verify.enterCodeText': 'Ingrese el código a continuación para verificar.',
    'oie.phone.verify.sms.codeSentText': 'Se envió un código a'
  },
  'pt-BR': {
    'primaryauth.title': 'Acessar',
    'primaryauth.username.placeholder': 'Nome de usuário',
    'mfa.challenge.password.placeholder': 'Senha',
    'oform.next': 'Próxima',
    'unlockaccount': 'Desbloquear conta?',
    'help': 'Ajuda',
    'password.reset.title.generic': 'Redefinir a senha',
    'password.complexity.requirements.header': 'Requisitos de senha: ',
    'password.complexity.length.description': 'Deve conter pelo menos {0} caracteres',
    'password.complexity.lowercase.description': 'Deve conter pelo menos uma letra minúscula',
    'password.complexity.uppercase.description': 'Deve conter pelo menos uma letra maiúscula',
    'password.complexity.number.description': 'Deve conter pelo menos um número',
    'password.complexity.symbol.description': 'Deve conter pelo menos um símbolo',
    'password.complexity.no_username.description': 'Não deve conter parte do nome de usuário',
    'password.complexity.no_first_name.description': 'Não deve conter parte do seu primeiro nome',
    'password.complexity.no_last_name.description': 'Não deve conter parte do seu sobrenome',
    'password.complexity.history.description': 'A senha não pode ser igual à sua última senha',
    'oie.password.newPasswordLabel': 'Nova senha',
    'oie.password.confirmPasswordLabel': 'Repita a nova senha',
    'password.reset.revokeSessions': 'Desconecte-me de todos os outros dispositivos.',
    'password.reset': 'Redefinir senha',
    'goback': 'Voltar para Iniciar sessão',
    'idx.return.link.otponly.your.verification.code': 'Seu código de verificação',
    'idx.enter.otp.in.original.tab': 'Insira o OTP em seu local de autenticação original.',
    'idx.return.link.otponly.warning.text': 'Se você não solicitou este código, pode ignorar esta mensagem. Sua conta está segura e só pode ser acessada com este código.',
    'oie.selfservice.unlock_user.landing.to.app.success.message': 'Conta desbloqueada com sucesso! Verifique sua conta com um método de segurança para continuar.',
    'oie.password.challenge.title': 'Verifique com sua senha',
    'oie.password.label': 'Senha',
    'mfa.challenge.verify': 'verificar',
    'forgotpassword': 'Esqueceu sua senha',
    'oie.email.challenge.mfa.title': 'Receba um e-mail de verificação',
    'oie.email.verify.subtitle.text.without.email': 'Envie um e-mail de verificação clicando em "Envie-me um e-mail".',
    'oie.email.verify.primaryButton': 'Envie-me um e-mail',
    'oie.email.mfa.title': 'Verifique com seu e-mail',
    'oie.email.verify.alternate.magicLinkToEmailAddress': 'Enviamos um e-mail para <$1>{0}</$1>.',
    'oie.email.verify.alternate.verificationCode.instructions': 'Insira o código de verificação na caixa de texto.',
    'mfa.challenge.enterCode.placeholder': 'Insira o código',
    'oie.select.authenticators.verify.title': 'Verifique sua identidade com um método de segurança',
    'oie.select.authenticators.verify.subtitle': 'Selecione uma das seguintes opções',
    'oie.email.label': 'Email',
    'oie.verify.authenticator.button.text': 'Selecione',
    'oie.phone.label': 'Telefone',
    'oie.phone.verify.sms.sendText.without.phone': 'Envie um código via SMS para o seu telefone',
    'oie.phone.carrier.charges': 'Taxas de mensagens da operadora podem ser aplicadas',
    'oie.phone.sms.primaryButton': 'Receba um código por SMS',
    'oie.phone.call.secondaryButton': 'Receba uma chamada de voz',
    'oie.verification.switch.authenticator': 'Verifique por outro meio',
    'oie.email.verify.alternate.magicLinkToYourEmail': 'Enviamos a você um e-mail de verificação.',
    'oie.email.verify.alternate.instructions': 'Clique no link de verificação em seu e-mail para continuar ou digite o código abaixo.',
    'oie.email.verify.alternate.show.verificationCode.text': 'Insira um código de verificação',
    'oie.phone.verify.mfa.calling.without.phone': 'Ligando para o seu telefone. Digite o código abaixo para verificar.',
    'oie.phone.verify.sms.codeSentText.without.phone': 'Um código foi enviado para o seu telefone. Digite o código abaixo para verificar.',
    'oie.password.reset.verification': 'Verifique com um dos seguintes métodos de segurança para redefinir sua senha.',
    'oie.phone.verify.title': 'Verifique com seu telefone',
    'oie.phone.verify.sms.sendText': 'Envie um código via SMS para',
    'oie.phone.alternate.title': 'seu telefone',
    'mfa.calling': 'ligando',
    'oie.phone.verify.enterCodeText': 'Digite o código abaixo para verificar.',
    'oie.phone.verify.sms.codeSentText': 'Um código foi enviado para'
  },
  'pl': {
    'primaryauth.title': 'Zaloguj się',
    'primaryauth.username.placeholder': 'Nazwa użytkownika',
    'mfa.challenge.password.placeholder': 'Hasło',
    'oform.next': 'Przejdź dalej',
    'unlockaccount': 'Odblokować konto?',
    'help': 'Pomoc',
    'password.reset.title.generic': 'Zresetuj swoje hasło',
    'password.complexity.requirements.header': 'Wymagania dotyczące hasła: ',
    'password.complexity.length.description': 'Powinno zawierać co najmniej {0} znaków',
    'password.complexity.lowercase.description': 'Powinno zawierać co najmniej jedną małą literę',
    'password.complexity.uppercase.description': 'Powinno zawierać co najmniej jedną wielką literę',
    'password.complexity.number.description': 'Powinno zawierać co najmniej jedną cyfrę',
    'password.complexity.symbol.description': 'Powinno zawierać co najmniej jeden znak specjalny',
    'password.complexity.no_username.description': 'Nie powinno zawierać części nazwy użytkownika',
    'password.complexity.no_first_name.description': 'Nie powinno zawierać Twojego imienia',
    'password.complexity.no_last_name.description': 'Nie powinno zawierać Twojego nazwiska',
    'password.complexity.history.description': 'Nowe hasło nie powinno być takie samo jak poprzednie',
    'oie.password.newPasswordLabel': 'Nowe hasło',
    'oie.password.confirmPasswordLabel': 'Powtórz nowe hasło',
    'password.reset.revokeSessions': 'Wyloguj mnie ze wszystkich innych urządzeń.',
    'password.reset': 'Zresetuj hasło',
    'goback': 'Powrót do logowania',
    'idx.return.link.otponly.your.verification.code': 'Twój kod weryfikacyjny',
    'idx.enter.otp.in.original.tab': 'Wprowadź hasło jednorazowe w oryginalnej lokalizacji uwierzytelniania.',
    'idx.return.link.otponly.warning.text': 'Jeśli to nie Ty prosiłeś o ten kod, zignoruj tę wiadomość. Twoje konto jest bezpieczne i można uzyskać do niego dostęp wyłącznie za pomocą tego kodu.',
    'oie.selfservice.unlock_user.landing.to.app.success.message': 'Konto odblokowano pomyślnie! Aby kontynuować, zweryfikuj swoje konto za pomocą metody zabezpieczającej.',
    'oie.password.challenge.title': 'Zweryfikuj za pomocą hasła',
    'oie.password.label': 'Hasło',
    'mfa.challenge.verify': 'Weryfikacja',
    'forgotpassword': 'Zapomniałem hasła',
    'oie.email.challenge.mfa.title': 'Uzyskaj e-mail weryfikacyjny',
    'oie.email.verify.subtitle.text.without.email': 'Wyślij e-mail weryfikacyjny, klikając "Wyślij mi e-mail".',
    'oie.email.verify.primaryButton': 'Wyślij mi e-mail',
    'oie.email.mfa.title': 'Zweryfikuj za pomocą swojego adresu e-mail',
    'oie.email.verify.alternate.magicLinkToEmailAddress': 'Wysłaliśmy e-mail na adres <$1>{0}</$1>.',
    'oie.email.verify.alternate.verificationCode.instructions': 'Wpisz kod weryfikacyjny w polu tekstowym.',
    'mfa.challenge.enterCode.placeholder': 'Wprowadź kod',
    'oie.select.authenticators.verify.title': 'Potwierdź, że to Ty, korzystając z metody zabezpieczającej',
    'oie.select.authenticators.verify.subtitle': 'Wybierz jedną z poniższych opcji',
    'oie.email.label': 'Email',
    'oie.verify.authenticator.button.text': 'Wybierz',
    'oie.phone.label': 'Telefon',
    'oie.phone.verify.sms.sendText.without.phone': 'Wyślij kod SMS-em na swój telefon',
    'oie.phone.carrier.charges': 'Operator może naliczyć opłaty za przesyłanie wiadomości',
    'oie.phone.sms.primaryButton': 'Odbierz kod SMS-em',
    'oie.phone.call.secondaryButton': 'Zamiast tego odbierz połączenie głosowe',
    'oie.verification.switch.authenticator': 'Sprawdź, używając innej opcji',
    'oie.email.verify.alternate.magicLinkToYourEmail': 'Wysłaliśmy do Ciebie e-mail weryfikacyjny.',
    'oie.email.verify.alternate.instructions': 'Kliknij link weryfikacyjny w wiadomości e-mail, aby kontynuować, lub wprowadź poniższy kod.',
    'oie.email.verify.alternate.show.verificationCode.text': 'Zamiast tego wpisz kod weryfikacyjny',
    'oie.phone.verify.mfa.calling.without.phone': 'Połączenie telefoniczne. Wpisz poniższy kod w celu weryfikacji.',
    'oie.phone.verify.sms.codeSentText.without.phone': 'Kod został wysłany na Twój telefon. Wpisz poniższy kod w celu weryfikacji.',
    'oie.password.reset.verification': 'Aby zresetować hasło, zweryfikuj je, korzystając z jednej z poniższych metod zabezpieczeń.',
    'oie.phone.verify.title': 'Zweryfikuj za pomocą telefonu',
    'oie.phone.verify.sms.sendText': 'Wyślij kod SMS-em na ',
    'oie.phone.alternate.title': 'Twój telefon',
    'mfa.calling': 'połączenie telefoniczne ',
    'oie.phone.verify.enterCodeText': 'Wpisz poniższy kod w celu weryfikacji.',
    'oie.phone.verify.sms.codeSentText': 'Kod został wysłany do'
  },
  'hu': {
    'primaryauth.title': 'Bejelentkezés',
    'primaryauth.username.placeholder': 'Felhasználónév',
    'mfa.challenge.password.placeholder': 'Jelszó',
    'oform.next': 'Következő',
    'unlockaccount': 'Feloldja a fiók zárolását?',
    'help': 'Súgó',
    'password.reset.title.generic': 'Jelszó visszaállítása',
    'password.complexity.requirements.header': 'Jelszókövetelmények: ',
    'password.complexity.length.description': 'Tartalmazzon legalább {0} karaktert',
    'password.complexity.lowercase.description': 'Tartalmazzon legalább egy kisbetűt',
    'password.complexity.uppercase.description': 'Tartalmazzon legalább egy nagybetűt',
    'password.complexity.number.description': 'Tartalmazzon legalább egy számot ',
    'password.complexity.symbol.description': 'Tartalmazzon legalább egy különleges karaktert',
    'password.complexity.no_username.description': 'Nem tartalmazhatja a felhasználónév részeit',
    'password.complexity.no_first_name.description': 'Nem tartalmazhatja az Ön utónevét',
    'password.complexity.no_last_name.description': 'Nem tartalmazhatja az Ön vezetéknevét',
    'password.complexity.history.description': 'A jelszó nem egyezhet meg a legutóbbi jelszóval',
    'oie.password.newPasswordLabel': 'Új jelszó',
    'oie.password.confirmPasswordLabel': 'Jelszó megerősítése',
    'password.reset.revokeSessions': 'Jelentkeztessenek ki az összes többi eszközről.',
    'password.reset': 'Jelszó visszaállítása',
    'goback': 'Vissza a bejelentkezéshez',
    'idx.return.link.otponly.your.verification.code': 'Az Ön igazoló kódja',
    'idx.enter.otp.in.original.tab': 'Adja meg az egyszer használatos jelszót az eredeti hitelesítési helyen.',
    'idx.return.link.otponly.warning.text': 'Ha nem Ön kérte ezt a kódot, figyelmen kívül hagyhatja ezt az üzenetet. Fiókja biztonságban van, és csak ezzel a kóddal érhető el.',
    'oie.selfservice.unlock_user.landing.to.app.success.message': 'A fiók zárolása sikeresen feloldva! A folytatáshoz igazolja fiókját egy biztonsági módszerrel.',
    'oie.password.challenge.title': 'Igazolás jelszóval',
    'oie.password.label': 'Jelszó',
    'mfa.challenge.verify': 'igazolás',
    'forgotpassword': 'Elfelejtett jelszó',
    'oie.email.challenge.mfa.title': 'Igazoló e-mail kérése',
    'oie.email.verify.subtitle.text.without.email': 'Igazoló e-mailt az „E-mailt kérek” lehetőségre kattintva igényelhet.',
    'oie.email.verify.primaryButton': 'E-mailt kérek',
    'oie.email.mfa.title': 'Igazolás e-mail-címmel',
    'oie.email.verify.alternate.magicLinkToEmailAddress': 'E-mailt küldtünk a következő címre: <$1>{0}</$1>.',
    'oie.email.verify.alternate.verificationCode.instructions': 'Írja be az igazoló kódot a szövegmezőbe.',
    'mfa.challenge.enterCode.placeholder': 'Kód beírása',
    'oie.select.authenticators.verify.title': 'Igazolja személyazonosságát egy biztonsági módszerrel',
    'oie.select.authenticators.verify.subtitle': 'Válasszon a következő lehetőségek közül',
    'oie.email.label': 'E-mail',
    'oie.verify.authenticator.button.text': 'Kiválasztás',
    'oie.phone.label': 'Telefon',
    'oie.phone.verify.sms.sendText.without.phone': 'Kód kérése SMS-ben a telefonjára',
    'oie.phone.carrier.charges': 'A szolgáltató üzenetküldési díjai lehetnek érvényben',
    'oie.phone.sms.primaryButton': 'SMS-ben kérek kódot',
    'oie.phone.call.secondaryButton': 'Inkább hanghívást kérek',
    'oie.verification.switch.authenticator': 'Igazolás más módszerrel',
    'oie.email.verify.alternate.magicLinkToYourEmail': 'Igazoló e-mailt küldtünk Önnek.',
    'oie.email.verify.alternate.instructions': 'Kattintson az e-mailben található igazoló linkre a folytatáshoz, vagy írja be az alábbi kódot.',
    'oie.email.verify.alternate.show.verificationCode.text': 'Inkább igazoló kódot adok meg',
    'oie.phone.verify.mfa.calling.without.phone': 'Tárcsázzuk a telefonszámát. Az igazoláshoz írja be az alábbi kódot.',
    'oie.phone.verify.sms.codeSentText.without.phone': 'Kódot küldtünk a telefonjára. Az igazoláshoz írja be az alábbi kódot.',
    'oie.password.reset.verification': 'Jelszava visszaállításához igazolás szükséges az alábbi biztonsági módszerek egyikével.',
    'oie.phone.verify.title': 'Igazolás telefonon',
    'oie.phone.verify.sms.sendText': 'Kódot kérek SMS-ben a',
    'oie.phone.alternate.title': 'telefonomra',
    'mfa.calling': 'hívás',
    'oie.phone.verify.enterCodeText': 'Az igazoláshoz írja be az alábbi kódot.',
    'oie.phone.verify.sms.codeSentText': 'Kódot küldtünk ide: '
  },
  'it': {
    'primaryauth.title': 'Registrazione',
    'primaryauth.username.placeholder': 'Nome utente',
    'mfa.challenge.password.placeholder': 'Password',
    'oform.next': 'Prossima',
    'unlockaccount': "Sbloccare l'account?",
    'help': 'Aiuto',
    'password.reset.title.generic': 'Reimposta la password',
    'password.complexity.requirements.header': 'Requisiti della password: ',
    'password.complexity.length.description': 'Deve contenere almeno {0} caratteri',
    'password.complexity.lowercase.description': 'Deve contenere almeno una lettera minuscola',
    'password.complexity.uppercase.description': 'Deve contenere almeno una lettera maiuscola',
    'password.complexity.number.description': 'Deve contenere almeno un numero',
    'password.complexity.symbol.description': 'Deve contenere almeno un simbolo',
    'password.complexity.no_username.description': 'Non deve contenere parti del nome utente',
    'password.complexity.no_first_name.description': 'Non deve contenere il tuo nome',
    'password.complexity.no_last_name.description': 'Non deve contenere il tuo cognome',
    'password.complexity.history.description': "La password non può uguale all'ultima",
    'oie.password.newPasswordLabel': 'Nuova password',
    'oie.password.confirmPasswordLabel': 'Ripeti la password',
    'password.reset.revokeSessions': 'Disconnettimi da tutti gli altri dispositivi.',
    'password.reset': 'Resetta la password',
    'goback': 'Torna a Registrazione',
    'idx.return.link.otponly.your.verification.code': 'Il tuo codice di verifica',
    'idx.enter.otp.in.original.tab': "Inserisci l'OTP nella posizione di autenticazione originale.",
    'idx.return.link.otponly.warning.text': 'Se non hai richiesto questo codice, puoi ignorare questo messaggio. Il tuo account è sicuro e puoi accedervi solo con questo codice.',
    'oie.selfservice.unlock_user.landing.to.app.success.message': 'Account sbloccato correttamente! Per continuare, verifica il tuo account con un metodo di sicurezza.',
    'oie.password.challenge.title': 'Verifica con la tua password',
    'oie.password.label': 'Password',
    'mfa.challenge.verify': 'verifica',
    'forgotpassword': 'Password dimenticata',
    'oie.email.challenge.mfa.title': "Ricevi un'e-mail di verifica",
    'oie.email.verify.subtitle.text.without.email': "Invia un'e-mail di verifica facendo clic su 'Inviami un'e-mail'.",
    'oie.email.verify.primaryButton': "Inviami un'e-mail",
    'oie.email.mfa.title': 'Verifica con la tua e-mail',
    'oie.email.verify.alternate.magicLinkToEmailAddress': "Abbiamo inviato un'e-mail a <$1>{0}</$1>.",
    'oie.email.verify.alternate.verificationCode.instructions': 'Inserisci il codice di verifica nella casella di testo.',
    'mfa.challenge.enterCode.placeholder': 'Inserisci il codice',
    'oie.select.authenticators.verify.title': 'Verifica la tua identità con un metodo di sicurezza',
    'oie.select.authenticators.verify.subtitle': 'Seleziona tra le seguenti opzioni',
    'oie.email.label': 'E-mail',
    'oie.verify.authenticator.button.text': 'Seleziona',
    'oie.phone.label': 'Telefono',
    'oie.phone.verify.sms.sendText.without.phone': 'Invia un codice via SMS al tuo telefono',
    'oie.phone.carrier.charges': "Potrebbero essere applicate tariffe per messaggistica previste dall'operatore",
    'oie.phone.sms.primaryButton': 'Ricevi un codice tramite SMS',
    'oie.phone.call.secondaryButton': 'In alternativa, ricevi una chiamata vocale',
    'oie.verification.switch.authenticator': 'Verifica con altro strumento',
    'oie.email.verify.alternate.magicLinkToYourEmail': "Ti abbiamo inviato un'e-mail di verifica.",
    'oie.email.verify.alternate.instructions': 'Per continuare fai clic sul collegamento di verifica nella tua e-mail o inserisci il codice seguente.',
    'oie.email.verify.alternate.show.verificationCode.text': 'In alternativa, inserisci un codice di verifica',
    'oie.phone.verify.mfa.calling.without.phone': 'Stai per ricevere una chiamata. Per verificare inserisci il codice qui sotto.',
    'oie.phone.verify.sms.codeSentText.without.phone': 'Abbiamo inviato un codice al tuo telefono. Per verificare inserisci il codice qui sotto.',
    'oie.password.reset.verification': 'Per reimpostare la password verifica con uno dei seguenti metodi di sicurezza.',
    'oie.phone.verify.title': 'Verifica con il tuo telefono',
    'oie.phone.verify.sms.sendText': 'Invia un codice via SMS a',
    'oie.phone.alternate.title': 'il tuo telefono',
    'mfa.calling': 'chiamando',
    'oie.phone.verify.enterCodeText': 'Per verificare inserisci il codice qui sotto.',
    'oie.phone.verify.sms.codeSentText': 'È stato inviato un codice a'
  },
  'ro': {
    'primaryauth.title': 'Conectare',
    'primaryauth.username.placeholder': 'Nume de utilizator',
    'mfa.challenge.password.placeholder': 'Parolă',
    'oform.next': 'Înainte',
    'unlockaccount': 'Deblocați contul?',
    'help': 'Ajutor',
    'password.reset.title.generic': 'Parola a fost resetată!',
    'password.complexity.requirements.header': 'Cerințe privind parola: ',
    'password.complexity.length.description': 'Cel puțin {0} caractere',
    'password.complexity.lowercase.description': 'Cel puțin o literă mică',
    'password.complexity.uppercase.description': 'Cel puțin o literă mare',
    'password.complexity.number.description': 'Cel puțin un număr',
    'password.complexity.symbol.description': 'Cel puțin un caracter special',
    'password.complexity.no_username.description': 'Nicio parte din numele de utilizator',
    'password.complexity.no_first_name.description': 'Nicio parte din prenumele dumneavoastră',
    'password.complexity.no_last_name.description': 'Nicio parte din numele dumneavoastră',
    'password.complexity.history.description': 'Parola nu poate fi aceeași cu ultima dumneavoastră parolă',
    'oie.password.newPasswordLabel': 'Parolă nouă',
    'oie.password.confirmPasswordLabel': 'Confirmare parolă',
    'password.reset.revokeSessions': 'Deconectați-mă de la toate celelalte dispozitive.',
    'password.reset': 'Resetare parolă',
    'goback': 'Înapoi la Conectare',
    'idx.return.link.otponly.your.verification.code': 'Codul de verificare',
    'idx.enter.otp.in.original.tab': 'Introduceți OTP în locația originală de autentificare.',
    'idx.return.link.otponly.warning.text': 'Dacă nu ați solicitat acest cod, puteți ignora acest mesaj. Contul dumneavoastră este în siguranță și poate fi accesat numai cu acest cod.',
    'oie.selfservice.unlock_user.landing.to.app.success.message': 'Contul a fost deblocat cu succes! Verificați-vă contul cu o metodă de securitate pentru a continua.',
    'oie.password.challenge.title': 'Verificați cu parola dumneavoastră',
    'oie.password.label': 'Parolă',
    'mfa.challenge.verify': 'verificare',
    'forgotpassword': 'Parolă uitată',
    'oie.email.challenge.mfa.title': 'Primiți un e-mail de verificare',
    'oie.email.verify.subtitle.text.without.email': 'Trimiteți un e-mail de verificare făcând clic pe „Trimitere e-mail”.',
    'oie.email.verify.primaryButton': 'Trimitere e-mail',
    'oie.email.mfa.title': 'Verificați cu e-mailul dumneavoastră',
    'oie.email.verify.alternate.magicLinkToEmailAddress': 'Am trimis un e-mail la <$1>{0}</$1>.',
    'oie.email.verify.alternate.verificationCode.instructions': 'Introduceți codul de verificare în caseta de text.',
    'mfa.challenge.enterCode.placeholder': 'Introducere cod',
    'oie.select.authenticators.verify.title': 'Verificați-vă identitatea cu o metodă de securitate',
    'oie.select.authenticators.verify.subtitle': 'Selectați dintre următoarele opțiuni',
    'oie.email.label': 'E-mail',
    'oie.verify.authenticator.button.text': 'Selectare',
    'oie.phone.label': 'Telefon',
    'oie.phone.verify.sms.sendText.without.phone': 'Trimiteți un cod prin SMS la numărul dumneavoastră de telefon',
    'oie.phone.carrier.charges': 'Se pot aplica taxe de mesaje de la operator',
    'oie.phone.sms.primaryButton': 'Primiți un cod prin SMS',
    'oie.phone.call.secondaryButton': 'În schimb, primiți un apel vocal',
    'oie.verification.switch.authenticator': 'Verificați cu altă metodă',
    'oie.email.verify.alternate.magicLinkToYourEmail': 'V-am trimis un e-mail de verificare.',
    'oie.email.verify.alternate.instructions': 'Faceți clic pe linkul de verificare din e-mail pentru a continua sau introduceți codul mai jos.',
    'oie.email.verify.alternate.show.verificationCode.text': 'În schimb, introduceți un cod de verificare',
    'oie.phone.verify.mfa.calling.without.phone': 'Vă apelăm. Introduceți codul mai jos pentru a verifica.',
    'oie.phone.verify.sms.codeSentText.without.phone': 'A fost trimis un cod la numărul dumneavoastră de telefon. Introduceți codul mai jos pentru a verifica.',
    'oie.password.reset.verification': 'Verificați cu una dintre următoarele metode de securitate pentru a vă reseta parola.',
    'oie.phone.verify.title': 'Verificați cu numărul de telefon',
    'oie.phone.verify.sms.sendText': 'Trimiteți un cod prin SMS la',
    'oie.phone.alternate.title': 'numărul de telefon',
    'mfa.calling': 'apelare în curs',
    'oie.phone.verify.enterCodeText': 'Introduceți codul de mai jos pentru a verifica.',
    'oie.phone.verify.sms.codeSentText': 'A fost trimis un cod către'
  },
  'de': {
    'primaryauth.title': 'Anmelden',
    'primaryauth.username.placeholder': 'Benutzername',
    'mfa.challenge.password.placeholder': 'Passwort',
    'oform.next': 'Nächste',
    'unlockaccount': 'Konto entsperren?',
    'help': 'Hilfe',
    'password.reset.title.generic': 'Passwort zurücksetzen',
    'password.complexity.requirements.header': 'Passwortanforderungen: ',
    'password.complexity.length.description': 'Sollte mindestens {0} Zeichen enthalten',
    'password.complexity.lowercase.description': 'Sollte mindestens einen Kleinbuchstaben enthalten',
    'password.complexity.uppercase.description': 'Sollte mindestens einen Großbuchstaben enthalten',
    'password.complexity.number.description': 'Sollte mindestens eine Nummer enthalten',
    'password.complexity.symbol.description': 'Sollte mindestens ein Sonderzeichen enthalten',
    'password.complexity.no_username.description': 'Sollte keinen Teil des Benutzernamens enthalten',
    'password.complexity.no_first_name.description': 'Sollte keinen Teil Ihres Vornamens enthalten',
    'password.complexity.no_last_name.description': 'Sollte keinen Teil Ihres Nachnamens enthalten',
    'password.complexity.history.description': 'Das Passwort darf nicht mit Ihrem letzten Passwort identisch sein.',
    'oie.password.newPasswordLabel': 'Neues Passwort',
    'oie.password.confirmPasswordLabel': 'Neues Passwort wiederholen',
    'password.reset.revokeSessions': 'Melden Sie mich von allen anderen Geräten ab.',
    'password.reset': 'Passwort zurücksetzen',
    'goback': 'Zurück zur Anmeldung',
    'idx.return.link.otponly.your.verification.code': 'Ihr Bestätigungscode',
    'idx.enter.otp.in.original.tab': 'Geben Sie das Einmalpasswort an Ihrem ursprünglichen Authentifizierungsort ein.',
    'idx.return.link.otponly.warning.text': 'Wenn Sie diesen Code nicht angefordert haben, können Sie diese Nachricht ignorieren. Ihr Konto ist sicher und kann nur mit diesem Code aufgerufen werden.',
    'oie.selfservice.unlock_user.landing.to.app.success.message': 'Konto erfolgreich entsperrt! Verifizieren Sie Ihr Konto mit einer Sicherheitsmethode, um fortzufahren.',
    'oie.password.challenge.title': 'Mit Ihrem Passwort verifizieren',
    'oie.password.label': 'Passwort',
    'mfa.challenge.verify': 'verifizieren',
    'forgotpassword': 'Passwort vergessen',
    'oie.email.challenge.mfa.title': 'Verifizierungs-E-Mail erhalten',
    'oie.email.verify.subtitle.text.without.email': 'Senden Sie eine Verifizierungs-E-Mail, indem Sie auf „Schicken Sie mir eine E-Mail“ klicken.',
    'oie.email.verify.primaryButton': 'Schicken Sie mir eine E-Mail',
    'oie.email.mfa.title': 'Mit Ihrer E-Mail verifizieren',
    'oie.email.verify.alternate.magicLinkToEmailAddress': 'Wir haben eine E-Mail an <$1>{0}</$1> gesendet.',
    'oie.email.verify.alternate.verificationCode.instructions': 'Geben Sie den Verifizierungscode in das Textfeld ein.',
    'mfa.challenge.enterCode.placeholder': 'Code eingeben',
    'oie.select.authenticators.verify.title': 'Bestätigen Sie Ihre Identität mit einer Sicherheitsmethode',
    'oie.select.authenticators.verify.subtitle': 'Wählen Sie aus den folgenden Optionen',
    'oie.email.label': 'E-Mail',
    'oie.verify.authenticator.button.text': 'Auswählen',
    'oie.phone.label': 'Telefon',
    'oie.phone.verify.sms.sendText.without.phone': 'Senden Sie einen Code per SMS an Ihr Telefon',
    'oie.phone.carrier.charges': 'Es fallen ggf. Nachrichtengebühren des Netzbetreibers an.',
    'oie.phone.sms.primaryButton': 'Erhalten Sie einen Code per SMS',
    'oie.phone.call.secondaryButton': 'Erhalten Sie stattdessen einen Sprachanruf',
    'oie.verification.switch.authenticator': 'Mit etwas anderem verifizieren',
    'oie.email.verify.alternate.magicLinkToYourEmail': 'Wir haben Ihnen eine Verifizierungs-E-Mail gesendet.',
    'oie.email.verify.alternate.instructions': 'Klicken Sie auf den Verifizierungslink in Ihrer E-Mail, um fortzufahren, oder geben Sie den Code unten ein.',
    'oie.email.verify.alternate.show.verificationCode.text': 'Geben Sie stattdessen einen Verifizierungscode ein',
    'oie.phone.verify.mfa.calling.without.phone': 'Sie erhalten einen Anruf. Geben Sie zur Verifizierung den untenstehenden Code ein.',
    'oie.phone.verify.sms.codeSentText.without.phone': 'Ein Code wurde an Ihr Telefon gesendet. Geben Sie zur Verifizierung den untenstehenden Code ein.',
    'oie.password.reset.verification': 'Verifizieren Sie sich mit einer der folgenden Sicherheitsmethoden, um Ihr Passwort zurückzusetzen.',
    'oie.phone.verify.title': 'Mit Ihrem Telefon verifizieren',
    'oie.phone.verify.sms.sendText': 'Senden Sie einen Code per SMS an',
    'oie.phone.alternate.title': 'Ihr Telefon',
    'mfa.calling': 'Anruf',
    'oie.phone.verify.enterCodeText': 'Geben Sie zur Verifizierung den untenstehenden Code ein.',
    'oie.phone.verify.sms.codeSentText': 'Ein Code wurde gesendet an'
  },
  'nl-NL': {
    'primaryauth.title': 'Inloggen',
    'primaryauth.username.placeholder': 'Gebruikersnaam',
    'mfa.challenge.password.placeholder': 'Wachtwoord',
    'oform.next': 'Volgende',
    'unlockaccount': 'Account ontgrendelen?',
    'help': 'Hulp',
    'password.reset.title.generic': 'Wachtwoord opnieuw instellen',
    'password.complexity.requirements.header': 'Wachtwoordvereisten: ',
    'password.complexity.length.description': 'Ten minste {0} tekens',
    'password.complexity.lowercase.description': 'Eén kleine letter',
    'password.complexity.uppercase.description': 'Eén hoofdletter',
    'password.complexity.number.description': 'Eén cijfer',
    'password.complexity.symbol.description': 'Eén speciaal teken',
    'password.complexity.no_username.description': 'Geen deel van uw gebruikersnaam',
    'password.complexity.no_first_name.description': 'Mag geen deel van uw voornaam bevatten',
    'password.complexity.no_last_name.description': 'Mag geen deel van uw achternaam bevatten',
    'password.complexity.history.description': 'Wachtwoord mag niet hetzelfde zijn als uw laatste wachtwoord',
    'oie.password.newPasswordLabel': 'Nieuw wachtwoord',
    'oie.password.confirmPasswordLabel': 'Herhaal nieuw wachtwoord',
    'password.reset.revokeSessions': 'Meld mij af bij alle andere apparaten.',
    'password.reset': 'Wachtwoord opnieuw instellen',
    'goback': 'Terug naar inloggen',
    'idx.return.link.otponly.your.verification.code': 'Uw verificatiecode',
    'idx.enter.otp.in.original.tab': 'Voer het eenmalige wachtwoord (OTP) in op uw oorspronkelijke authenticatielocatie.',
    'idx.return.link.otponly.warning.text': 'Als u deze code niet hebt aangevraagd, kunt u dit bericht negeren. Uw account is veilig en kan alleen worden geopend met deze code.',
    'oie.selfservice.unlock_user.landing.to.app.success.message': 'Account succesvol ontgrendeld! Verifieer uw account met een beveiligingsmethode om verder te gaan.',
    'oie.password.challenge.title': 'Verifiëren met uw wachtwoord',
    'oie.password.label': 'Wachtwoord',
    'mfa.challenge.verify': 'verifiëren',
    'forgotpassword': 'Wachtwoord vergeten',
    'oie.email.challenge.mfa.title': 'Ontvang een verificatie-e-mail',
    'oie.email.verify.subtitle.text.without.email': 'Stuur een verificatie-e-mail door op "Stuur mij een e-mail" te klikken.',
    'oie.email.verify.primaryButton': 'Stuur mij een e-mail',
    'oie.email.mfa.title': 'Verifieer met uw e-mail',
    'oie.email.verify.alternate.magicLinkToEmailAddress': 'We hebben een e-mail gestuurd naar <$1>{0}</$1>.',
    'oie.email.verify.alternate.verificationCode.instructions': 'Voer de verificatiecode in het tekstvak in.',
    'mfa.challenge.enterCode.placeholder': 'Voer code in',
    'oie.select.authenticators.verify.title': 'Verifieer dat u het bent met een beveiligingsmethode',
    'oie.select.authenticators.verify.subtitle': 'Selecteer uit de volgende opties',
    'oie.email.label': 'E-mail',
    'oie.verify.authenticator.button.text': 'Selecteer',
    'oie.phone.label': 'Telefoon',
    'oie.phone.verify.sms.sendText.without.phone': 'Stuur een code via sms naar je telefoon',
    'oie.phone.carrier.charges': 'Er kunnen kosten in rekening worden gebracht voor berichten van de provider',
    'oie.phone.sms.primaryButton': 'Ontvang een code via SMS',
    'oie.phone.call.secondaryButton': 'Ontvang in plaats daarvan een spraakoproep',
    'oie.verification.switch.authenticator': 'Verifiëren met iets anders',
    'oie.email.verify.alternate.magicLinkToYourEmail': 'Wij hebben u een verificatie-e-mail gestuurd.',
    'oie.email.verify.alternate.instructions': 'Klik op de verificatielink in uw e-mail om door te gaan of voer de onderstaande code in.',
    'oie.email.verify.alternate.show.verificationCode.text': 'Voer in plaats daarvan een verificatiecode in',
    'oie.phone.verify.mfa.calling.without.phone': 'Je telefoon bellen. Voer de onderstaande code in om te verifiëren.',
    'oie.phone.verify.sms.codeSentText.without.phone': 'Er is een code naar uw telefoon verzonden. Voer de onderstaande code in om te verifiëren.',
    'oie.password.reset.verification': 'Verifieer met een van de volgende beveiligingsmethoden om uw wachtwoord opnieuw in te stellen.',
    'oie.phone.verify.title': 'Verifieer met uw telefoon',
    'oie.phone.verify.sms.sendText': 'Stuur een code via sms naar',
    'oie.phone.alternate.title': 'uw telefoon',
    'mfa.calling': 'belt',
    'oie.phone.verify.enterCodeText': 'Voer de onderstaande code in om te verifiëren.',
    'oie.phone.verify.sms.codeSentText': 'Er is een code verzonden naar'
  },
  'fr': {
    'primaryauth.title': 'Se connecter',
    'primaryauth.username.placeholder': "Nom d'utilisateur",
    'mfa.challenge.password.placeholder': 'Mot de passe',
    'oform.next': 'Suivant',
    'unlockaccount': 'Débloquez le compte ?',
    'help': 'Aide',
    'password.reset.title.generic': 'Réinitialisez votre mot de passe',
    'password.complexity.requirements.header': 'Exigences relatives au mot de passe : ',
    'password.complexity.length.description': 'Doit contenir au moins {0} caractères',
    'password.complexity.lowercase.description': 'Doit contenir au moins une lettre minuscule',
    'password.complexity.uppercase.description': 'Doit contenir au moins une lettre majuscule',
    'password.complexity.number.description': 'Doit contenir au moins un chiffre',
    'password.complexity.symbol.description': 'Doit contenir au moins un caractère spécial',
    'password.complexity.no_username.description': "Ne doit pas contenir une partie du nom d'utilisateur",
    'password.complexity.no_first_name.description': 'Ne doit pas contenir une partie de votre prénom',
    'password.complexity.no_last_name.description': 'Ne doit pas contenir une partie de votre nom de famille',
    'password.complexity.history.description': 'Le mot de passe ne peut pas être le même que votre dernier mot de passe',
    'oie.password.newPasswordLabel': 'Nouveau mot de passe',
    'oie.password.confirmPasswordLabel': 'Répétez le nouveau mot de passe',
    'password.reset.revokeSessions': 'Déconnectez-moi de tous les autres appareils.',
    'password.reset': 'Réinitialisez le mot de passe ',
    'goback': "Retour à l'identification",
    'idx.return.link.otponly.your.verification.code': 'Votre code de vérification',
    'idx.enter.otp.in.original.tab': 'Saisissez l’OTP dans votre emplacement d’authentification d’origine.',
    'idx.return.link.otponly.warning.text': "Si vous n'avez pas demandé ce code, vous pouvez ignorer ce message. Votre compte est sécurisé et vous ne pouvez y accéder qu'avec ce code.",
    'oie.selfservice.unlock_user.landing.to.app.success.message': 'Compte débloqué avec succès ! Vérifiez votre compte avec une méthode de sécurité pour continuer.',
    'oie.password.challenge.title': 'Vérifiez avec votre mot de passe',
    'oie.password.label': 'Mot de passe',
    'mfa.challenge.verify': 'Vérifiez',
    'forgotpassword': 'Mot de passe oublié',
    'oie.email.challenge.mfa.title': 'Recevez un e-mail de vérification',
    'oie.email.verify.subtitle.text.without.email': 'Envoyez un email de vérification en cliquant sur "Envoyez-moi un email".',
    'oie.email.verify.primaryButton': 'Envoyez-moi un email',
    'oie.email.mfa.title': 'Vérifiez avec votre email',
    'oie.email.verify.alternate.magicLinkToEmailAddress': 'Nous avons envoyé un e-mail à <$1>{0}</$1>.',
    'oie.email.verify.alternate.verificationCode.instructions': 'Saisissez le code de vérification dans la zone de texte.',
    'mfa.challenge.enterCode.placeholder': 'Saisissez le code',
    'oie.select.authenticators.verify.title': "Vérifiez qu'il s'agit bien de vous avec une méthode de sécurité",
    'oie.select.authenticators.verify.subtitle': 'Sélectionnez parmi les options suivantes',
    'oie.email.label': 'Email',
    'oie.verify.authenticator.button.text': 'Sélectionnez  ',
    'oie.phone.label': 'Téléphone',
    'oie.phone.verify.sms.sendText.without.phone': 'Envoyez un code par SMS sur votre téléphone',
    'oie.phone.carrier.charges': "Des frais de messagerie de l'opérateur peuvent s'appliquer",
    'oie.phone.sms.primaryButton': 'Recevez un code par SMS',
    'oie.phone.call.secondaryButton': 'Recevez plutôt un appel vocal',
    'oie.verification.switch.authenticator': 'Vérifiez avec autre chose',
    'oie.email.verify.alternate.magicLinkToYourEmail': 'Nous vous avons envoyé un e-mail de vérification.',
    'oie.email.verify.alternate.instructions': 'Cliquez sur le lien de vérification dans votre e-mail pour continuer ou saisissez le code ci-dessous.',
    'oie.email.verify.alternate.show.verificationCode.text': 'Saisissez plutôt un code de vérification',
    'oie.phone.verify.mfa.calling.without.phone': 'Appelez votre téléphone. Saisissez le code ci-dessous pour vérifier.',
    'oie.phone.verify.sms.codeSentText.without.phone': 'Un code a été envoyé sur votre téléphone. Saisissez le code ci-dessous pour vérifier.',
    'oie.password.reset.verification': "Vérifiez avec l'une des méthodes de sécurité suivantes pour réinitialiser votre mot de passe.",
    'oie.phone.verify.title': 'Vérifiez avec votre téléphone',
    'oie.phone.verify.sms.sendText': 'Envoyez un code par SMS à',
    'oie.phone.alternate.title': 'votre téléphone',
    'mfa.calling': 'appel',
    'oie.phone.verify.enterCodeText': 'Saisissez le code ci-dessous pour vérifier.',
    'oie.phone.verify.sms.codeSentText': 'Un code a été envoyé à'
  },
  'ru': {
    'primaryauth.title': 'Войти',
    'primaryauth.username.placeholder': 'Имя пользователя',
    'mfa.challenge.password.placeholder': 'Пароль',
    'oform.next': 'Далее',
    'unlockaccount': 'Разблокировать аккаунт?',
    'help': 'Справка',
    'password.reset.title.generic': 'Сброс пароля',
    'password.complexity.requirements.header': 'Требования к паролю: ',
    'password.complexity.length.description': 'Не менее {0} символов',
    'password.complexity.lowercase.description': 'Строчная буква',
    'password.complexity.uppercase.description': 'Заглавная буква',
    'password.complexity.number.description': 'Число',
    'password.complexity.symbol.description': 'Символ',
    'password.complexity.no_username.description': 'Не должен содержать часть имени пользователя',
    'password.complexity.no_first_name.description': 'Не должен содержать часть вашего имени',
    'password.complexity.no_last_name.description': 'Не должен содержать часть вашей фамилии',
    'password.complexity.history.description': 'Пароль не может совпадать с вашим последним паролем.',
    'oie.password.newPasswordLabel': 'Новый пароль',
    'oie.password.confirmPasswordLabel': 'Введите пароль ещё раз',
    'password.reset.revokeSessions': 'Выйти из системы на всех других устройствах.',
    'password.reset': 'Сбросить пароль',
    'goback': 'Вернуться на страницу входа',
    'idx.return.link.otponly.your.verification.code': 'Ваш код подтверждения',
    'idx.enter.otp.in.original.tab': 'Введите одноразовый пароль в исходном месте аутентификации.',
    'idx.return.link.otponly.warning.text': 'Если вы не запрашивали этот код, проигнорируйте это сообщение. Ваш аккаунт в безопасности, доступ к нему возможен только с этим кодом.',
    'oie.selfservice.unlock_user.landing.to.app.success.message': 'Аккаунт разблокирован. Подтвердите свой аккаунт с помощью метода безопасности, чтобы продолжить.',
    'oie.password.challenge.title': 'Подтверждение с помощью пароля',
    'oie.password.label': 'Пароль',
    'mfa.challenge.verify': 'подтвердить',
    'forgotpassword': 'Забыли пароль',
    'oie.email.challenge.mfa.title': 'Получить письмо для подтверждения',
    'oie.email.verify.subtitle.text.without.email': 'Отправьте письмо для подтверждения, нажав "Отправьте электронное письмо".',
    'oie.email.verify.primaryButton': 'Отправить электронное письмо',
    'oie.email.mfa.title': 'Подтверждение с помощью электронного письма',
    'oie.email.verify.alternate.magicLinkToEmailAddress': 'Мы отправили электронное письмо на адрес <$1>{0}</$1>.',
    'oie.email.verify.alternate.verificationCode.instructions': 'Введите код подтверждения в текстовом поле.',
    'mfa.challenge.enterCode.placeholder': 'Введите код',
    'oie.select.authenticators.verify.title': 'Подтвердите, что это вы, с помощью метода безопасности',
    'oie.select.authenticators.verify.subtitle': 'Выберите один из следующих вариантов',
    'oie.email.label': 'Электронное письмо',
    'oie.verify.authenticator.button.text': 'Выбрать',
    'oie.phone.label': 'Звонок',
    'oie.phone.verify.sms.sendText.without.phone': 'Отправьте SMS с кодом на свой телефон',
    'oie.phone.carrier.charges': 'Оператор может взимать плату за отправку сообщений',
    'oie.phone.sms.primaryButton': 'Получить SMS с кодом',
    'oie.phone.call.secondaryButton': 'Позвонить',
    'oie.verification.switch.authenticator': 'Другой способ',
    'oie.email.verify.alternate.magicLinkToYourEmail': 'Мы отправили вам письмо с подтверждением.',
    'oie.email.verify.alternate.instructions': 'Нажмите на ссылку для подтверждения в письме, чтобы продолжить, или введите код ниже.',
    'oie.email.verify.alternate.show.verificationCode.text': 'Введите код подтверждения',
    'oie.phone.verify.mfa.calling.without.phone': 'Звоним на ваш телефон. Введите код ниже для подтверждения.',
    'oie.phone.verify.sms.codeSentText.without.phone': 'Мы отправили код на ваш телефон. Введите код ниже для подтверждения.',
    'oie.password.reset.verification': 'Воспользуйтесь одним из следующих методов проверки, чтобы сбросить пароль.',
    'oie.phone.verify.title': 'Подтверждение с помощью звонка',
    'oie.phone.verify.sms.sendText': 'Отправьте SMS с кодом на',
    'oie.phone.alternate.title': 'ваш телефон',
    'mfa.calling': 'звоним',
    'oie.phone.verify.enterCodeText': 'Введите код ниже для подтверждения.',
    'oie.phone.verify.sms.codeSentText': 'Мы отправили код на'
  },
  'uk': {
    'primaryauth.title': 'Увійти',
    'primaryauth.username.placeholder': 'Ім’я користувача',
    'mfa.challenge.password.placeholder': 'Пароль',
    'oform.next': 'Далі',
    'unlockaccount': 'Розблокувати обліковий запис?',
    'help': 'Довідка',
    'password.reset.title.generic': 'Скидання пароля',
    'password.complexity.requirements.header': 'Вимоги до пароля: ',
    'password.complexity.length.description': 'Щонайменше {0} символів',
    'password.complexity.lowercase.description': 'Мала літера',
    'password.complexity.uppercase.description': 'Велика літера',
    'password.complexity.number.description': 'Число',
    'password.complexity.symbol.description': 'Символ',
    'password.complexity.no_username.description': 'Не має містити частину імені користувача',
    'password.complexity.no_first_name.description': 'Не має містити частини вашого імені',
    'password.complexity.no_last_name.description': 'Не має містити частину вашого прізвища',
    'password.complexity.history.description': 'Пароль не може збігатися з вашим останнім паролем',
    'oie.password.newPasswordLabel': 'Новий пароль',
    'oie.password.confirmPasswordLabel': 'Введіть пароль повторно',
    'password.reset.revokeSessions': 'Вийти із системи на всіх інших пристроях.',
    'password.reset': 'Скинути пароль',
    'goback': 'Назад до сторінки входу',
    'idx.return.link.otponly.your.verification.code': 'Ваш код підтвердження',
    'idx.enter.otp.in.original.tab': 'Введіть одноразовий пароль у початковому місці автентифікації.',
    'idx.return.link.otponly.warning.text': 'Якщо ви не запитували цей код, проігноруйте це повідомлення. Ваш обліковий запис у безпеці, доступ до нього можливий лише за допомогою цього коду.',
    'oie.selfservice.unlock_user.landing.to.app.success.message': 'Обліковий запис розблоковано. Підтвердьте свій обліковий запис за допомогою методу безпеки, щоб продовжити.',
    'oie.password.challenge.title': 'Підтвердження за допомогою пароля',
    'oie.password.label': 'Пароль',
    'mfa.challenge.verify': 'підтвердити',
    'forgotpassword': 'Забули пароль',
    'oie.email.challenge.mfa.title': 'Отримати електронний лист для підтвердження',
    'oie.email.verify.subtitle.text.without.email': 'Надішліть електронний лист для підтвердження, натиснувши "Надіслати мені електронний лист".',
    'oie.email.verify.primaryButton': 'Надіслати мені електронний лист',
    'oie.email.mfa.title': 'Підтвердження за допомогою електронного листа',
    'oie.email.verify.alternate.magicLinkToEmailAddress': 'Ми надіслали електронний лист на адресу <$1>{0}</$1>.',
    'oie.email.verify.alternate.verificationCode.instructions': 'Введіть код підтвердження в текстове поле.',
    'mfa.challenge.enterCode.placeholder': 'Введіть код',
    'oie.select.authenticators.verify.title': 'Підтвердьте, що це ви, за допомогою методу безпеки',
    'oie.select.authenticators.verify.subtitle': 'Виберіть із наведених нижче варіантів',
    'oie.email.label': 'Електронний лист',
    'oie.verify.authenticator.button.text': 'Вибрати',
    'oie.phone.label': 'Дзвінок',
    'oie.phone.verify.sms.sendText.without.phone': 'Надішліть SMS із кодом на свій телефон',
    'oie.phone.carrier.charges': 'Оператор може стягувати плату за обмін повідомленнями',
    'oie.phone.sms.primaryButton': 'Отримати SMS із кодом',
    'oie.phone.call.secondaryButton': 'Зателефонувати',
    'oie.verification.switch.authenticator': 'Інший спосіб',
    'oie.email.verify.alternate.magicLinkToYourEmail': 'Ми надіслали вам електронний лист для підтвердження.',
    'oie.email.verify.alternate.instructions': 'Щоб продовжити, натисніть посилання для підтвердження в електронному листі або введіть код нижче.',
    'oie.email.verify.alternate.show.verificationCode.text': 'Введіть код підтвердження',
    'oie.phone.verify.mfa.calling.without.phone': 'Телефонуємо на ваш телефон. Введіть код нижче для підтвердження.',
    'oie.phone.verify.sms.codeSentText.without.phone': 'Ми надіслали код на ваш телефон. Введіть код нижче для підтвердження.',
    'oie.password.reset.verification': 'Скористайтеся одним із наведених нижче методів перевірки, щоб скинути пароль.',
    'oie.phone.verify.title': 'Підтвердження за допомогою дзвінка',
    'oie.phone.verify.sms.sendText': 'Надішліть SMS із кодом на',
    'oie.phone.alternate.title': 'ваш телефон',
    'mfa.calling': 'телефонуємо',
    'oie.phone.verify.enterCodeText': 'Введіть код нижче для підтвердження.',
    'oie.phone.verify.sms.codeSentText': 'Ми надіслали код на'
  },
  'tr': {
    'primaryauth.title': 'Oturum Aç',
    'primaryauth.username.placeholder': 'Kullanıcı adı',
    'mfa.challenge.password.placeholder': 'Parola',
    'oform.next': 'Sonraki',
    'unlockaccount': 'Hesabın kilidi açılsın mı?',
    'help': 'Yardım',
    'password.reset.title.generic': 'Parolanızı sıfırlayın',
    'password.complexity.requirements.header': 'Parola gereksinimleri: ',
    'password.complexity.length.description': 'En az {0} karakter içermelidir',
    'password.complexity.lowercase.description': 'En az bir küçük harf içermelidir',
    'password.complexity.uppercase.description': 'En az bir büyük harf içermelidir',
    'password.complexity.number.description': 'En az bir sayı içermelidir',
    'password.complexity.symbol.description': 'En az bir özel karakter içermelidir',
    'password.complexity.no_username.description': 'Kullanıcı adının herhangi bir kısmını içermemelidir',
    'password.complexity.no_first_name.description': 'Adınızı içermemelidir',
    'password.complexity.no_last_name.description': 'Soyadınızı içermemelidir',
    'password.complexity.history.description': 'Parolanız, son parolanızla aynı olamaz',
    'oie.password.newPasswordLabel': 'Yeni parola',
    'oie.password.confirmPasswordLabel': 'Yeni parolayı tekrar girin',
    'password.reset.revokeSessions': 'Diğer tüm cihazlarda oturumumu kapat.',
    'password.reset': 'Parolayı Sıfırla',
    'goback': 'Oturum açmaya geri dön',
    'idx.return.link.otponly.your.verification.code': 'Doğrulama kodunuz',
    'idx.enter.otp.in.original.tab': "Orijinal kimlik doğrulama konumunuza OTP'yi girin.",
    'idx.return.link.otponly.warning.text': 'Bu kodu talep etmediyseniz bu mesajı görmezden gelebilirsiniz. Hesabınız güvendedir ve yalnızca bu kodla erişilebilir.',
    'oie.selfservice.unlock_user.landing.to.app.success.message': 'Hesap başarıyla açıldı! Devam etmek için hesabınızı bir güvenlik yöntemi ile doğrulayın.',
    'oie.password.challenge.title': 'Parolanızla doğrulayın',
    'oie.password.label': 'Parola',
    'mfa.challenge.verify': 'doğrula',
    'forgotpassword': 'Parolanızı mı unuttunuz?',
    'oie.email.challenge.mfa.title': 'Doğrulama e-postası alın',
    'oie.email.verify.subtitle.text.without.email': '"Bana bir e-posta gönder" seçeneğini tıklayarak bir doğrulama e-postası gönderin',
    'oie.email.verify.primaryButton': 'Bana bir e-posta gönder',
    'oie.email.mfa.title': 'E-postanızla doğrulayın',
    'oie.email.verify.alternate.magicLinkToEmailAddress': '<$1>{0}</$1> adresine bir e-posta gönderdik.',
    'oie.email.verify.alternate.verificationCode.instructions': 'Doğrulama kodunu metin kutusuna girin.',
    'mfa.challenge.enterCode.placeholder': 'Kodu Girin',
    'oie.select.authenticators.verify.title': 'Bir güvenlik yöntemi ile siz olduğunuzu doğrulayın',
    'oie.select.authenticators.verify.subtitle': 'Aşağıdaki seçeneklerden birini belirleyin',
    'oie.email.label': 'E-posta',
    'oie.verify.authenticator.button.text': 'Seç',
    'oie.phone.label': 'Telefon',
    'oie.phone.verify.sms.sendText.without.phone': 'Telefonunuza SMS yoluyla bir kod gönderin',
    'oie.phone.carrier.charges': 'Operatör mesajlaşma ücretleri uygulanabilir',
    'oie.phone.sms.primaryButton': 'SMS yoluyla bir kod alın',
    'oie.phone.call.secondaryButton': 'Bunun yerine sesli arama alın',
    'oie.verification.switch.authenticator': 'Başka bir yöntemle doğrulayın',
    'oie.email.verify.alternate.magicLinkToYourEmail': 'Size bir doğrulama e-postası gönderdik.',
    'oie.email.verify.alternate.instructions': 'Devam etmek için e-postanızdaki doğrulama bağlantısına tıklayın veya kodu aşağıya girin.',
    'oie.email.verify.alternate.show.verificationCode.text': 'Bunun yerine bir doğrulama kodu girin',
    'oie.phone.verify.mfa.calling.without.phone': 'Telefonunuz aranıyor. Doğrulamak için kodu aşağıya girin.',
    'oie.phone.verify.sms.codeSentText.without.phone': 'Telefonunuza bir kod gönderildi. Doğrulamak için kodu aşağıya girin.',
    'oie.password.reset.verification': 'Parolanızı sıfırlamak için aşağıdaki güvenlik yöntemlerinden birini kullanarak doğrulama yapın.',
    'oie.phone.verify.title': 'Telefonunuzla doğrulayın',
    'oie.phone.verify.sms.sendText': 'SMS yoluyla şuraya bir kod gönderin: ',
    'oie.phone.alternate.title': 'telefonunuz',
    'mfa.calling': 'arama',
    'oie.phone.verify.enterCodeText': 'Doğrulamak için kodu aşağıya girin.',
    'oie.phone.verify.sms.codeSentText': 'Şuraya bir kod gönderildi: '
  },
  'ko': {
    'primaryauth.title': '로그인',
    'primaryauth.username.placeholder': '사용자 이름',
    'mfa.challenge.password.placeholder': '비밀번호',
    'oform.next': '다음',
    'unlockaccount': '계정을 잠금 해제하시겠습니까?',
    'help': '도움',
    'password.reset.title.generic': '비밀번호 재설정 완료',
    'password.complexity.requirements.header': '비밀번호 요구사항: ',
    'password.complexity.length.description': '최소한 {0}개의 문자를 포함해야 합니다',
    'password.complexity.lowercase.description': '하나 이상의 소문자를 포함해야 합니다',
    'password.complexity.uppercase.description': '하나 이상의 대문자를 포함해야 합니다',
    'password.complexity.number.description': '하나 이상의 숫자를 포함해야 합니다',
    'password.complexity.symbol.description': '하나 이상의 특수 문자를 포함해야 합니다',
    'password.complexity.no_username.description': '아이디의 일부를 포함해서는 안됩니다',
    'password.complexity.no_first_name.description': '이름의 일부를 포함해서는 안됩니다',
    'password.complexity.no_last_name.description': '성의 일부를 포함해서는 안됩니다',
    'password.complexity.history.description': '비밀번호는 이전 비밀번호와 같을 수 없습니다.',
    'oie.password.newPasswordLabel': '새 비밀번호',
    'oie.password.confirmPasswordLabel': '새 비밀번호 확인',
    'password.reset.revokeSessions': '다른 모든 기기에서 로그아웃해 주세요.',
    'password.reset': '비밀번호 재설정',
    'goback': '로그인으로 돌아가기',
    'idx.return.link.otponly.your.verification.code': '인증 코드',
    'idx.enter.otp.in.original.tab': '원래 인증 위치에 OTP를 입력하세요.',
    'idx.return.link.otponly.warning.text': '이 코드를 요청하지 않았다면 이 메시지를 무시해도 됩니다. 귀하의 계정은 안전하며 이 코드로만 액세스할 수 있습니다.',
    'oie.selfservice.unlock_user.landing.to.app.success.message': '계정이 성공적으로 잠금 해제되었습니다! 계속하려면 보안 방법으로 계정을 확인하세요.',
    'oie.password.challenge.title': '비밀번호로 확인',
    'oie.password.label': '비밀번호',
    'mfa.challenge.verify': '확인하다',
    'forgotpassword': '비밀번호를 잊으셨나요?',
    'oie.email.challenge.mfa.title': '확인 이메일 받기',
    'oie.email.verify.subtitle.text.without.email': '이메일 보내기를 클릭하여 확인 이메일을 보내세요.',
    'oie.email.verify.primaryButton': '나에게 이메일을 보내기',
    'oie.email.mfa.title': '이메일로 확인',
    'oie.email.verify.alternate.magicLinkToEmailAddress': '<$1>{0}</$1>에게 이메일을 보냈습니다.',
    'oie.email.verify.alternate.verificationCode.instructions': '텍스트 상자에 인증코드를 입력하세요.',
    'mfa.challenge.enterCode.placeholder': '코드 입력',
    'oie.select.authenticators.verify.title': '보안 방법으로 본인 확인',
    'oie.select.authenticators.verify.subtitle': '다음 옵션 중에서 선택',
    'oie.email.label': '이메일',
    'oie.verify.authenticator.button.text': '선택',
    'oie.phone.label': '휴대전화 ',
    'oie.phone.verify.sms.sendText.without.phone': 'SMS를 통해 휴대전화로 코드를 전송',
    'oie.phone.carrier.charges': '통신사 메시지 요금이 부과될 수 있습니다.',
    'oie.phone.sms.primaryButton': 'SMS로 코드 받기',
    'oie.phone.call.secondaryButton': '대신 음성 통화 받기',
    'oie.verification.switch.authenticator': '기타 인증',
    'oie.email.verify.alternate.magicLinkToYourEmail': '확인 이메일을 보냈습니다.',
    'oie.email.verify.alternate.instructions': '계속하려면 이메일의 확인 링크를 클릭하거나 아래 코드를 입력하세요.',
    'oie.email.verify.alternate.show.verificationCode.text': '대신 확인 코드를 입력',
    'oie.phone.verify.mfa.calling.without.phone': '전화를 거는 중입니다. 아래 코드를 입력하여 확인하세요.',
    'oie.phone.verify.sms.codeSentText.without.phone': '휴대전화로 코드가 전송되었습니다. 아래 코드를 입력하여 확인하세요.',
    'oie.password.reset.verification': '비밀번호를 재설정하려면 다음 보안 방법 중 하나를 사용하여 인증하세요.',
    'oie.phone.verify.title': '휴대전화로 인증',
    'oie.phone.verify.sms.sendText': 'SMS를 통해 코드를 다음으로 전송합니다.',
    'oie.phone.alternate.title': '휴대전화',
    'mfa.calling': '통화',
    'oie.phone.verify.enterCodeText': '아래 코드를 입력하여 인증하세요.',
    'oie.phone.verify.sms.codeSentText': '다음으로 코드가 전송되었습니다.'
  },
  'zh-CN': {
    'primaryauth.title': '登录',
    'primaryauth.username.placeholder': '用户名',
    'mfa.challenge.password.placeholder': '密码',
    'oform.next': '下一步',
    'unlockaccount': '解锁账户？',
    'help': '帮助',
    'password.reset.title.generic': '重置密码',
    'password.complexity.requirements.header': '密码要求：',
    'password.complexity.length.description': '至少{0}个字符',
    'password.complexity.lowercase.description': '包含至少一个小写字母',
    'password.complexity.uppercase.description': '包含至少一个大写字母',
    'password.complexity.number.description': '包含至少一个数字',
    'password.complexity.symbol.description': '包含至少一个特殊字符',
    'password.complexity.no_username.description': '不包含用户名的任意部分',
    'password.complexity.no_first_name.description': '不包含您的名字',
    'password.complexity.no_last_name.description': '不包含您的姓氏',
    'password.complexity.history.description': '密码不得与您上次使用的密码相同',
    'oie.password.newPasswordLabel': '新密码',
    'oie.password.confirmPasswordLabel': '再次输入新密码',
    'password.reset.revokeSessions': '退出所有其他设备。',
    'password.reset': '重置密码',
    'goback': '返回登录页',
    'idx.return.link.otponly.your.verification.code': '您的验证码',
    'idx.enter.otp.in.original.tab': '在原始身份验证位置输入OTP。',
    'idx.return.link.otponly.warning.text': '如果您未请求此代码，则可忽略此消息。您的账户是安全的，只有使用此代码才能访问。',
    'oie.selfservice.unlock_user.landing.to.app.success.message': '账户解锁成功！使用安全方法验证您的账户以继续。',
    'oie.password.challenge.title': '使用密码验证',
    'oie.password.label': '密码',
    'mfa.challenge.verify': '验证',
    'forgotpassword': '忘记密码',
    'oie.email.challenge.mfa.title': '获取验证电子邮件',
    'oie.email.verify.subtitle.text.without.email': '单击“给我发送电子邮件”发送验证电子邮件',
    'oie.email.verify.primaryButton': '给我发送电子邮件',
    'oie.email.mfa.title': '使用您的电子邮件验证',
    'oie.email.verify.alternate.magicLinkToEmailAddress': '我们向<$1>{0}</$1>发送了一封电子邮件。',
    'oie.email.verify.alternate.verificationCode.instructions': '在文本框中输入验证码。',
    'mfa.challenge.enterCode.placeholder': '输入代码',
    'oie.select.authenticators.verify.title': '使用安全方法验证您的身份',
    'oie.select.authenticators.verify.subtitle': '从以下选项中选择',
    'oie.email.label': '电子邮件',
    'oie.verify.authenticator.button.text': '选择',
    'oie.phone.label': '电话',
    'oie.phone.verify.sms.sendText.without.phone': '通过短信将代码发送至您的手机',
    'oie.phone.carrier.charges': '运营商可能会收取短信费用',
    'oie.phone.sms.primaryButton': '通过短信接收代码',
    'oie.phone.call.secondaryButton': '改为接听语音电话',
    'oie.verification.switch.authenticator': '使用其他方式验证',
    'oie.email.verify.alternate.magicLinkToYourEmail': '我们向您发送了一封验证电子邮件。',
    'oie.email.verify.alternate.instructions': '单击电子邮件中的验证链接以继续或输入下方代码。',
    'oie.email.verify.alternate.show.verificationCode.text': '改为输入验证码',
    'oie.phone.verify.mfa.calling.without.phone': '正在拨打您的电话。输入下方代码进行验证。',
    'oie.phone.verify.sms.codeSentText.without.phone': '代码已发送至您的手机。输入下方代码进行验证。',
    'oie.password.reset.verification': '使用以下任意一种安全方法进行验证，以重置您的密码。',
    'oie.phone.verify.title': '用手机验证',
    'oie.phone.verify.sms.sendText': '通过短信将代码发送至',
    'oie.phone.alternate.title': '您的手机',
    'mfa.calling': '正在拨打电话',
    'oie.phone.verify.enterCodeText': '输入下方代码进行验证。',
    'oie.phone.verify.sms.codeSentText': '代码已发送至'
  },
  'zh-TW': {
    'primaryauth.title': 'Вход',
    'primaryauth.username.placeholder': 'Потребителско име',
    'mfa.challenge.password.placeholder': 'Парола',
    'oform.next': 'Следваща стъпка',
    'unlockaccount': 'Искаш ли да отключиш акаунта си?',
    'help': 'Помощ',
    'password.reset.title.generic': 'Нулирай паролата си',
    'password.complexity.requirements.header': 'Изисквания за паролата: ',
    'password.complexity.length.description': 'Трябва да съдържа поне {0} знака',
    'password.complexity.lowercase.description': 'Трябва да съдържа поне една малка буква',
    'password.complexity.uppercase.description': 'Трябва да съдържа поне една главна буква',
    'password.complexity.number.description': 'Трябва да съдържа поне един номер',
    'password.complexity.symbol.description': 'Трябва да съдържа поне един специален знак',
    'password.complexity.no_username.description': 'Не трябва да съдържа част от потребителското ти име',
    'password.complexity.no_first_name.description': 'Не трябва да съдържа част от името ти',
    'password.complexity.no_last_name.description': 'Не трябва да съдържа част от фамилията ти',
    'password.complexity.history.description': 'Паролата не може да бъде същата като последната ти парола',
    'oie.password.newPasswordLabel': 'нова парола',
    'oie.password.confirmPasswordLabel': 'Повтори новата парола',
    'password.reset.revokeSessions': 'Премахни регистрацията ми от всички други устройства.',
    'password.reset': 'Нулиране на парола',
    'goback': 'Назад към Вход',
    'idx.return.link.otponly.your.verification.code': 'Твоят код за потвърждение',
    'idx.enter.otp.in.original.tab': 'Въведи OTP в първоначалното си местоположение за удостоверяване.',
    'idx.return.link.otponly.warning.text': 'Ако не си поискал този код, можеш да игнорираш това съобщение. Твоят акаунт е безопасен и се влиза в него само с този код.',
    'oie.selfservice.unlock_user.landing.to.app.success.message': 'Акаунтът е отключен успешно! Потвърди акаунта си с метод за сигурност, за да продължиш.',
    'oie.password.challenge.title': 'Потвърди с паролата си',
    'oie.password.label': 'Парола',
    'mfa.challenge.verify': 'потвърди',
    'forgotpassword': 'Забравена парола',
    'oie.email.challenge.mfa.title': 'Получи имейл за потвърждение',
    'oie.email.verify.subtitle.text.without.email': 'Изпрати имейл за потвърждение, като кликнеш върху "Изпрати ми имейл".',
    'oie.email.verify.primaryButton': 'Изпрати ми имейл',
    'oie.email.mfa.title': 'Потвърди със своя имейл',
    'oie.email.verify.alternate.magicLinkToEmailAddress': 'Изпратихме имейл до <$1>{0}</$1>.',
    'oie.email.verify.alternate.verificationCode.instructions': 'Въведи кода за потвърждение в текстовото поле.',
    'mfa.challenge.enterCode.placeholder': 'Въведи код',
    'oie.select.authenticators.verify.title': 'Потвърди, че това си ти ​​с метод за сигурност',
    'oie.select.authenticators.verify.subtitle': 'Избери от следните опции',
    'oie.email.label': 'Имейл',
    'oie.verify.authenticator.button.text': 'Избор',
    'oie.phone.label': 'Телефон',
    'oie.phone.verify.sms.sendText.without.phone': 'Изпрати код чрез SMS на своя телефон',
    'oie.phone.carrier.charges': 'Операторът може да таксува съобщенията',
    'oie.phone.sms.primaryButton': 'Получаване на код чрез SMS',
    'oie.phone.call.secondaryButton': 'Вместо това приеми гласово повикване',
    'oie.verification.switch.authenticator': 'Потвърди по друг начин',
    'oie.email.verify.alternate.magicLinkToYourEmail': 'Изпратихме ти имейл за потвърждение.',
    'oie.email.verify.alternate.instructions': 'Кликни върху връзката за потвърждение в получения имейл, за да продължиш или въведи кода по-долу.',
    'oie.email.verify.alternate.show.verificationCode.text': 'Вместо това въведи код за потвърждение',
    'oie.phone.verify.mfa.calling.without.phone': 'Обаждане на телефона ти. Въведи кода по-долу, за да потвърдиш.',
    'oie.phone.verify.sms.codeSentText.without.phone': 'На твоя телефон беше изпратен код. Въведи кода по-долу, за да потвърдиш.',
    'oie.password.reset.verification': 'Потвърди с един от следните методи за сигурност, за да нулираш паролата си.',
    'oie.phone.verify.title': 'Потвърди с телефона си',
    'oie.phone.verify.sms.sendText': 'Изпрати код чрез SMS на',
    'oie.phone.alternate.title': 'своя телефон',
    'mfa.calling': 'обаждане',
    'oie.phone.verify.enterCodeText': 'Въведи кода по-долу, за да потвърдиш.',
    'oie.phone.verify.sms.codeSentText': 'Беше изпратен код до'
  }
};
/* harmony default export */ __webpack_exports__["default"] = (i18nConfig);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var translationConfig = {
  'bg': 'Влезте като служител',
  'cn': '以员工身份登录',
  'de': 'Melden Sie sich als Mitarbeiter an',
  'fr': "Connectez-vous en tant qu'employé",
  'hu': 'Jelentkezzen be alkalmazottként',
  'it': 'Accedi come dipendente',
  'ko': '직원으로 로그인',
  'nl-NL': 'Meld u aan als medewerker',
  'ro': 'Conectați-vă ca angajat',
  'ru': 'Войти как сотрудник',
  'tr': 'Çalışan olarak oturum aç',
  'uk': 'Увійдіть як співробітник',
  'id': 'Masuk dengan ID Cargill',
  'pt-BR': 'Entre com o ID da Cargill',
  'pl': 'Zaloguj się za pomocą Cargill ID',
  'es': 'Iniciar sesión con Cargill ID',
  'en': 'Sign In as an Employee'
};
/* harmony default export */ __webpack_exports__["default"] = (translationConfig);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_app__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_storage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_okta__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_locale_js__ = __webpack_require__(8);



var _this = this;












__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
  var isAuth, authUserEmail, userLang;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;
          _context.next = 3;
          return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$auth.isAuthenticated();

        case 3:
          isAuth = _context.sent;

          console.log(isAuth);
          __WEBPACK_IMPORTED_MODULE_8__helpers_okta__["default"].checkTokens().then(function (resp) {
            console.log(resp);
          });

          if (__WEBPACK_IMPORTED_MODULE_5__store__["default"].state.user && __WEBPACK_IMPORTED_MODULE_5__store__["default"].state.user.email) {
            authUserEmail = __WEBPACK_IMPORTED_MODULE_5__store__["default"].state.user.email;

            if (authUserEmail) {
              __WEBPACK_IMPORTED_MODULE_5__store__["default"].commit('setEmail', __WEBPACK_IMPORTED_MODULE_5__store__["default"].state.user.email);
              __WEBPACK_IMPORTED_MODULE_5__store__["default"].commit('setName', __WEBPACK_IMPORTED_MODULE_5__store__["default"].state.user.name);
              __WEBPACK_IMPORTED_MODULE_6__helpers_app__["default"].persistNameToStorage(__WEBPACK_IMPORTED_MODULE_5__store__["default"].state.user.name);
            }
          }

          userLang = 'en';

          if (navigator.userLanguage !== undefined) {
            userLang = navigator.browserLanguage.split('-')[0];
          } else {
            userLang = navigator.language.split('-')[0];
          }
          userLang = __WEBPACK_IMPORTED_MODULE_9__i18n_locale_js__["locale"].lang_obj[userLang] !== undefined ? userLang : 'en';
          window.pref_lang = __WEBPACK_IMPORTED_MODULE_9__i18n_locale_js__["locale"].lang_obj[userLang] !== undefined ? userLang : 'en';
          __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].set('pref_lang', userLang);

          new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
            el: '#app',
            router: __WEBPACK_IMPORTED_MODULE_4__router__["default"],
            store: __WEBPACK_IMPORTED_MODULE_5__store__["default"],
            template: '<App/>',
            components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
          });

        case 13:
        case 'end':
          return _context.stop();
      }
    }
  }, _callee, _this);
}))();

/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Bold.ecdd509.eot";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Light.a990f61.eot";

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Medium.4d9f3f9.eot";

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Regular.30799ef.eot";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Thin.dfe56a8.eot";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(732)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(706),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/components/widgets/SessionTimeout.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SessionTimeout.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2480fbbb", Component.options)
  } else {
    hotAPI.reload("data-v-2480fbbb", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(731)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(705),
  /* scopeId */
  "data-v-202322ac",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/modules/APISettings.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] APISettings.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-202322ac", Component.options)
  } else {
    hotAPI.reload("data-v-202322ac", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(745)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(720),
  /* scopeId */
  "data-v-cf5396ea",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/modules/APISettingsOld.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] APISettingsOld.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cf5396ea", Component.options)
  } else {
    hotAPI.reload("data-v-cf5396ea", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(727)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(701),
  /* scopeId */
  "data-v-04fb9444",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/modules/Admin.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Admin.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-04fb9444", Component.options)
  } else {
    hotAPI.reload("data-v-04fb9444", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(740)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(715),
  /* scopeId */
  "data-v-595e07ce",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/modules/AdminOld.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AdminOld.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-595e07ce", Component.options)
  } else {
    hotAPI.reload("data-v-595e07ce", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(728)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(702),
  /* scopeId */
  "data-v-0fd90017",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/modules/Error.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Error.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0fd90017", Component.options)
  } else {
    hotAPI.reload("data-v-0fd90017", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(736)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(711),
  /* scopeId */
  "data-v-40e44573",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/modules/LoggingIn.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LoggingIn.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-40e44573", Component.options)
  } else {
    hotAPI.reload("data-v-40e44573", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(746)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(721),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/modules/Login.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Login.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d48af610", Component.options)
  } else {
    hotAPI.reload("data-v-d48af610", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(742)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(717),
  /* scopeId */
  "data-v-7a8c026c",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/modules/MyProfile.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MyProfile.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7a8c026c", Component.options)
  } else {
    hotAPI.reload("data-v-7a8c026c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(729)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(703),
  /* scopeId */
  "data-v-17c86ae4",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/modules/Reports.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Reports.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-17c86ae4", Component.options)
  } else {
    hotAPI.reload("data-v-17c86ae4", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(748)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(723),
  /* scopeId */
  "data-v-f5e219ce",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/modules/ResetPassword.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ResetPassword.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f5e219ce", Component.options)
  } else {
    hotAPI.reload("data-v-f5e219ce", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(738)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(713),
  /* scopeId */
  "data-v-4b105266",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/modules/SelfRegistration.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SelfRegistration.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4b105266", Component.options)
  } else {
    hotAPI.reload("data-v-4b105266", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(744)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(719),
  /* scopeId */
  "data-v-84feda02",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/modules/SystemLogs.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SystemLogs.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-84feda02", Component.options)
  } else {
    hotAPI.reload("data-v-84feda02", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(737)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(712),
  /* scopeId */
  "data-v-47e688b5",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/modules/TokenManager.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TokenManager.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-47e688b5", Component.options)
  } else {
    hotAPI.reload("data-v-47e688b5", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(735)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(710),
  /* scopeId */
  "data-v-37d5b43c",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/modules/TokenManagerOld.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TokenManagerOld.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-37d5b43c", Component.options)
  } else {
    hotAPI.reload("data-v-37d5b43c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(743)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(718),
  /* scopeId */
  "data-v-7cc2de36",
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/modules/UserRegistration.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] UserRegistration.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7cc2de36", Component.options)
  } else {
    hotAPI.reload("data-v-7cc2de36", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports = {"1":"United States","7":"Russian Federation","20":"Egypt","27":"South Africa","30":"Greece","31":"Netherlands","32":"Belgium","33":"France","34":"Spain","36":"Hungary","39":"Italy","40":"Romania","41":"Switzerland","43":"Austria","44":"United Kingdom","45":"Denmark","46":"Sweden","47":"Svalbard and Jan Mayen","48":"Poland","49":"Germany","51":"Peru","52":"Mexico","53":"Cuba","54":"Argentina","55":"Brazil","56":"Chile","57":"Colombia","58":"Venezuela, Bolivarian Republic of","60":"Malaysia","61":"Christmas Island","62":"Indonesia","63":"Philippines","64":"New Zealand","65":"Singapore","66":"Thailand","81":"Japan","82":"Korea, Republic of","84":"Vietnam","86":"China","90":"Turkey","91":"India","92":"Pakistan","93":"Afghanistan","94":"Sri Lanka","95":"Myanmar","98":"Iran, Islamic Republic of","211":"Southern Sudan","212":"Western Sahara","213":"Algeria","216":"Tunisia","218":"Libya","220":"Gambia","221":"Senegal","222":"Mauritania","223":"Mali","224":"Guinea","225":"Ivory Coast","226":"Burkina Faso","227":"Niger","228":"Togo","229":"Benin","230":"Mauritius","231":"Liberia","232":"Sierra Leone","233":"Ghana","234":"Nigeria","235":"Chad","236":"Central African Republic","237":"Cameroon","238":"Cape Verde","239":"Sao Tome and Principe","240":"Equatorial Guinea","241":"Gabon","242":"Congo","243":"Congo, Democratic Republic of the","244":"Angola","245":"Guinea Bissau","246":"British Indian Ocean Territory","248":"Seychelles","249":"Sudan","250":"Rwanda","251":"Ethiopia","252":"Somalia","253":"Djibouti","254":"Kenya","255":"Tanzania, United Republic of","256":"Uganda","257":"Burundi","258":"Mozambique","260":"Zambia","261":"Madagascar","262":"Reunion","263":"Zimbabwe","264":"Namibia","265":"Malawi","266":"Lesotho","267":"Botswana","268":"Swaziland","269":"Comoros","290":"Saint Helena, Ascension and Tristan da Cunha","291":"Eritrea","297":"Aruba","298":"Faroe Islands","299":"Greenland","350":"Gibraltar","351":"Portugal","352":"Luxembourg","353":"Ireland","354":"Iceland","355":"Albania","356":"Malta","357":"Cyprus","358":"Finland","359":"Bulgaria","370":"Lithuania","371":"Latvia","372":"Estonia","373":"Moldavia","374":"Armenia","375":"Belarus","376":"Andorra","377":"Monaco","378":"San Marino","379":"Holy See (Vatican City State)","380":"Ukraine","381":"Serbia","382":"Montenegro","385":"Croatia","386":"Slovenia","387":"Bosnia and Herzegovina","389":"Macedonia","420":"Czech republic","421":"Slovakia","423":"Liechtenstein","500":"South Georgia and the South Sandwich Islands","501":"Belize","502":"Guatemala","503":"El Salvador","504":"Honduras","505":"Nicaragua","506":"Costa Rica","507":"Panama","508":"Saint Pierre and Miquelon","509":"Haiti","590":"Guadeloupe","591":"Bolivia","592":"Guyana","593":"Ecuador","595":"Paraguay","596":"Martinique","597":"Suriname","598":"Uruguay","599":"Netherlands Antilles","670":"Timor-Leste","672":"Norfolk Island","673":"Brunei Darussalam","674":"Nauru","675":"Papua New Guinea","676":"Tonga","677":"Solomon Islands","678":"Vanuatu","679":"Fiji","680":"Palau","681":"Wallis and Futuna","682":"Cook Islands","683":"Niue","685":"Samoa","686":"Kiribati","687":"New Caledonia","688":"Tuvalu","689":"French Polynesian","690":"Tokelau","691":"Micronesia","692":"Marshall Islands","850":"Korea, Democratic People's Republic of","852":"Hong Kong","853":"Macao","855":"Cambodia","856":"Lao People's Democratic Republic","880":"Bangladesh","886":"Taiwan","960":"Maldives","961":"Lebanon","962":"Jordan","963":"Syrian Arab Republic","964":"Iraq","965":"Kuwait","966":"Saudi Arabia","967":"Yemen","968":"Oman","970":"Palestine","971":"United Arab Emirates","972":"Israel","973":"Bahrain","974":"Qatar","975":"Bhutan","976":"Mongolia","977":"Nepal","992":"Tajikistan","993":"Turkmenistan","994":"Azerbaijan","995":"Georgia","996":"Kyrgyzstan","998":"Uzbekistan","1242":"Bahamas","1246":"Barbados","1264":"Anguilla","1268":"Antigua and Barbuda","1284":"Virgin Islands, British","1340":"Virgin Islands, US","1345":"Cayman Islands","1441":"Bermuda","1473":"Grenada","1649":"Turks and Caicos Islands","1664":"Montserrat","1670":"Northern Mariana Islands","1671":"Guam","1684":"American Samoa","1758":"Saint Lucia","1767":"Dominica","1784":"Saint Vincent and the Grenadines","1787":"Puerto Rico","1809":"Dominican Republic","1868":"Trinidad and Tobago","1869":"Saint Kitts and Nevis","1876":"Jamaica","441481":"Guernsey","441534":"Jersey","registration":"Регистрация","hello":"Здравейте ","welcome_cargill":"Добре дошли в ","user_reg":"Потребителска регистрация","enter_new_pwd":"Въведете нова парола","pwd_rule":"Вашата парола трябва да съдържа поне 8 символа, малка буква, главна буква, номер, без части от потребителското ви име.","repeat_pwd":"Повтори новата парола ","choose_forgot_pwd_qtn":"Изберете въпрос за забравена парола","stock_qtn":"Списък с въпроси","disliked_food":"Каква е храната, която най-малко харесваш като дете?","name_of_first_plush_toy":"Какво е името на първото ти животно?","first_award":"За какво си спечелил първия си медал или награда?","favorite_security_question":"Кой е любимият ви въпрос за сигурност?","favorite_toy":"Каква е играчката / пълненото животно, което най-много ви хареса като дете?","first_computer_game":"Каква беше първата компютърна игра, която играхте?","favorite_movie_quote":"Коя е любимата ви цитат?","first_sports_team_mascot":"Какъв беше талисманът на първия спортен отбор, на който играехте?","first_music_purchase":"Кой музикален албум или песен сте закупили за първи път?","favorite_art_piece":"Кое е любимото ви произведение на изкуството?","grandmother_favorite_desert":"Кой беше любимият ти десерт на баба ви?","first_thing_cooked":"Какво е първото нещо, което сте научили да готвите?","childhood_dream_job":"Каква беше мечтаната ти работа като дете?","place_where_significant_other_was_met":"Къде срещнахте съпруга / съпругата си / другия?","favorite_vacation_location":"Къде отидохте за любимата си почивка?","new_years_two_thousand":"Къде бяхте на Нова година през 2000 година?","favorite_speaker_actor":"Кой е любимият ви говорител / оратор?","favorite_book_movie_character":"Кой е любимият ти филм / филм?","favorite_sports_player":"Кой е любимият ти играч?","custom_qtn":"Персонален въпрос","own_sec_qtn":"Създайте свой собствен защитен въпрос","answer":"Отговор","phone_inst":"Допълнителна опция: Моля въведете телефонен номер, който да бъде използван в случай на проблеми с вашият потребител. Телефонния номер ще бъде използвам само и единствено за получаване на код за потвърждени.","optional":"(По желание)","sms_inst":"Okta може да ви изпрати текстово съобщение с код за възстановяване. Тази функция е полезна, когато нямате достъп до имейла си.","add_ph_no":"Добавете телефонен номер","create_acc":"Създай моя акаунт","forgot_pwd_header":"Забравена парола /Текстово съобщение","enter_phone_no":"Въведете телефонния номер, който ще използвате, за да получавате кодове чрез текстово съобщение, след което кликнете върху Изпращане на кода, за да проверите дали работи.","country":"Държава","country_inst":"Изберете страната, в която е регистриран вашият телефон.","back":"Изпрати отново","phone_number":"Телефонен номер","phone_number_inst":"Въведете номера си по начина, по който го набирате. Не добавяйте кода на вашата страна","code_prefix":"код на държавата.","send_code":"Изпращане на код","done":"Завършен","verify":"Потвърди","enter_code":"Въведете кода","enter_code_rule":"Проверете телефона си за паролата и го въведете по-долу. Вашето съобщение трябва да пристигне за по-малко от минута.","verify_success":"Телефонният номер бе успешно потвърден!","click":"Кликнете","finish_setup":" , за да завършите настройката.","error_review":"Моля, прегледайте формуляра, за да коригирате следните грешки","phone_no_not_found":"Текстовото съобщение не може да бъде изпратено, защото в базата данни не е намерен телефонен номер.","noLowerCase":"Трябва да съдържа поне една малка буква","noUpperCase":"Трябва да съдържа поне една главна буква","noNumber":"Трябва да съдържа поне един номер","noSpecialCharacter":"Трябва да съдържа поне един специален знак","notMinLength":"Трябва да съдържа поне $ знака","noUsernameSubstring":"Не трябва да съдържа част от потребителското име","noFirstnameSubstring":"Не трябва да съдържа част от вашето първо име","noLastnameSubstring":"Не трябва да съдържа част от вашето фамилно име","tokenNotValid":"Маркерът ви за активиране вече не е валиден","tokenInvalidInfo":"Това може да се случи, ако кликнете върху връзката за активиране след създаването на профила си, връзката ви за активиране е изтекла или URL адресът е неправилен","reqNewToken":"Заявете нов знак","passcodeNotValid":"Вашата парола не съответства на нашите записи. Моля, опитайте отново.","OTPEnableAfter30Sec":"Наскоро бе изпратено SMS съобщение. Моля, изчакайте 30 секунди, преди да опитате отново.","phoneNoAlreadySet":"Телефонният номер вече е потвърден от този потребител.","emptypassword":"Паролата не може да бъде празна","passwordlength":"Паролата не може да бъде празна","passwordnotvalid":"Паролата не е валидна","passwordnotmatching":"Паролите трябва да съвпадат","answerlength":"Отговорът трябва да бъде поне $ символи","phonenumbermissing":"Проверете паролата, която сте получили, за да продължите.","customQuestionEmpty":"Персонализираният въпрос не може да бъде празно поле","customQAsame":"Персонализираният въпрос и отговор не могат да бъдат същите","passwordSameasPrev":"Паролата не може да бъде текущата ви парола","answerWrong":"Отговорът на въпроса за възстановяване не съответства на нашите записи","phonealreadyactive":"Този номер вече е потвърден, ако искате да актуализирате опитайте с друг номер","first_name":"Първо име","last_name":"Фамилия","enter_email":"Email ID","emailNotValid":"Email ID не е валиден","registeredapps":"Регистрирани приложения","waitingapps":"Приложения, чакащи одобрение","requestaccess":"Поискване на достъп","admin":"Admin","selectLang":"Избери език","dashboardLabel":"Табло","resetpwd":"Нулиране на парола","ansForgotten":"Отговорете на забравеното предизвикателство с паролата","resetOktaPwd":"Нулирайте парола на","newpwd":"нова парола","rptpwd":"Повтори паролата","adminLabel":"Ръководство на потребителя","userAdministration":"Ръководство на потребителя","adduser":"Добавяне на нов потребител","function":"функция","emailAddress":"Имейл адрес","filterApp":"Филтър","create":"създавам","logoutConfirm":"Наистина ли искате да излезете от профила си?","no":"Не","yes":"да","logout":"Излез от профила си","expireWarning":"Вашата сесия ще изтече след% минути, натиснете ОК, за да останете влезли в профила си или натиснете Отказ, за ​​да излезете. Ако сте прекъснали, всички промени ще бъдат загубени","update":"Актуализация","activateDeactivate":"Активиране / деактивиране","attention":"внимание","cancel":"Отказ","sessionTimedout":"Сесията ви е изтекла. Моля, влезте отново","username":"Потребител","primary_mail":"Основен имейл","secondary_mail":"Вторичен имейл (по избор)","groups":"Групи","must_email":"Трябва да е имейл","ieNotSupported":"IE не се поддържа","tryChrome":"Internet Explorer не се поддържа. Препоръчваме ви да използвате Chrome за това приложение.","close":"Затвори","forgotSQA":"забравих отговора на сигурността?","resetSecQA":"Нулиране на въпрос и парола за сигурност","retry":"Назад","nofactorpresent":"Тази опция не може да се използва, тъй като мобилният номер не е зададен. Моля, свържете се с вашия администратор.","emptypasscode":"Кодът не може да бъде празен","provisioned":"Този потребител все още не е регистриран. Паролата може да бъде нулирана само след като потребителят е активен","deprovisioned":"Този потребител е деактивиран. Паролата може да бъде нулирана само след като потребителят е активен","resetsuccesspopupmsg":"Връзката за нулиране на паролата е изпратена на имейл адреса. Моля, затворете изскачащия прозорец с помощта на бутона X.","wanttoreset":"Искате ли да зададете отново паролата?","wanttoactivate":"Искате ли да активирате потребителя?","wanttodeactivate":"Искате ли да деактивирате потребителя? ","wanttodelete":"Искате ли да изтриете потребителя?","updateprofile":"Актуализиране на профила","updatesuccess":"Потребителят бе актуализиран успешно","usercreated":"* Потребителят е създаден","errorcreatinguser":"* Грешка при създаването на потребител / имейл вече съществува","privacypolicy":"Политика за поверителност","termsandconditions":"Правила и условия","uname-email":"Потребител / Е-мейл","password_placeholder":"парола","sign-in":"Влизам","resetmailsent":"Имейл е изпратен на% с връзката за възстановяване на паролата.","smssent":"изпратен","resendcode":"Препрати кода","needhelp":"Нуждаете се от помощ при влизане?","forgotPassword":"Забравена парола?","helplink":"Помогне","smsusage":"SMS може да се използва само ако е конфигуриран номер на мобилен телефон.","backtosignin":"Назад към Вход","resetviasms":"Нулиране чрез SMS","resetviaemail":"Нулиране чрез имейл","didntreceivecode":"Не сте получили код? нулиране чрез имейл","emailsent":"Имейлът е изпратен!","recoverycredentialsnotset":"Функцията Забравена парола не е възможно, тъй като идентификационните данни за възстановяване не са зададени за потребителя","usernotpresent":"Потребителят не присъства","mobilenumbernotset":"Мобилният номер не е зададен","invalidcreds":"Невалидно потребителско име или парола","emailreq":"Изисква се имейл","emailinvalid":"Имейлът е невалиден","pwdreq":"изисква се парола","otplength":"OTP трябва да е с дължина 6 знака","passcodeinvalid":"Невалидна OTP","firstnamereq":"Изисква се първо име","lastnamereq":"Необходимо е фамилно име","notallowedincurrentstate":"Тази операция не е разрешена в текущото състояние на удостоверяване","nopartsofusername":"Паролата не може да съдържа части от потребителското ви име, да включва името или фамилията ви","passwordusedrecently":"Паролата е използвана твърде скоро","passwordnotmetrequirements":"Паролата не отговаря на изискванията за сложност на текущата политика за пароли","antar":"Antarctica","aus":"Australia","can":"Canada","falk":"Falkland Islands (Malvinas)","kazak":"Kazakhstan","mayotte":"Mayotte","morocco":"Morocco","norway":"Norway","pitcairn":"Pitcairn","filteruser":"Филтрирайте потребителите по App","selectgroups":"Изберете Приложение","status":"Статус","atleastonegroup":"Изберете най-малко една група, за да зададете на потребителя","answerchallenge":"Отговорете на предизвикателството за забравена парола","entersmscode":"Въведете кода за потвърждение, изпратен чрез SMS","enterusercreds":"Въведете потребителските данни","inviteuser":"Поканете нов потребител","assignApplication":"Присвояване на приложение","availablegroups":"Налични групи","selectedgroups":"Присвоени групи","emailsenttouser":"Имейлът е изпратен успешно","pendingactivation":"Предстоящо активиране на профила","exit":"изход","myprofile":"Моят профил","activatesuccess":"Потребителят е активиран успешно и е изпратено съобщение за активиране","deactivatesuccess":" бе успешно деактивирано","deletesuccess":" бе успешно изтрито","edituser":"Редактиране на потребител","getstarted":"Първи стъпки","congrats":"Честито!","accountsetup":"Успешно сте завършили настройката на профила си.","edit":"редактиране","assignedapps":"Присвоени приложения","assignedgroups":"Присвоени групи","oldpwd":"Въведете старата парола","changepwd":"Промяна на паролата","updatephone":"Актуализиране на телефона","pwdupdated":"Паролата бе актуализирана успешно","QAupdated":"Отговорът на въпроса за сигурност е актуализиран успешно","phonenumberinvalid":"Телефонният номер е невалиден","phoneupdated":"Телефонният номер е актуализиран успешно","showmore":"Покажи повече","verifypassword":"Потвърдете паролата","filterusergrp":"Филтрирайте потребителите по групи","allactiveusers":"Всички активни потребители","viewuser":"Преглед на потребителя","partofokta":"Този потребител е част от организацията Okta","userdeactive":"Потребителят е неактивен","showing":"показване","of":"на","answerpartofquestion":"Отговорът не трябва да е част от въпроса","activationpending":"Вашият фактор е в очакване на активиране. Моля, актуализирайте телефонния си номер, в противен случай SMS-ите ще бъдат изпратени на предишния ви активен номер","change_forgot_pwd_qtn":"Промяна на защитния въпрос","basicinfo":"Основна информация","gotoapp":"Кликнете върху приложението, което искате да ползвате","passwordresetsuccess":"Паролата ви е нулирана успешно","passwordreset":"Паролата е възстановена","searchinfotext":"* Търсене се прави само на приложение","tmlabel":"Конфигурация","delete":"Изтрий","search":"Търсене","nop":"номер","nop_inst":"Въведете номера си по начина, по който го набирате. Не добавяйте кода на вашата страна","nopMobile":"Мобилен номер","statusactive":"Активен","statuspending":"Предстоящо активиране","globalsearch":"Търсете други потребители","permissiondenied":"Не можете да изтриете / деактивирате този потребител. потребител, зададен на други групи. Вместо това можете да откажете потребителя","activestatus":"АКТИВЕН","provisionedstatus":"Обезпечени","deprovisionedstatus":"необезпечени","save":"Запази","admingroup":"Административна група","application":"Приложение","selectadmingroup":"Изберете администраторска група","selectapp":"Изберете приложение","adminConfigIncomplete":"Редът е непълен. Моля, назначете администраторска група, за да запазите или премахнете ред","adminconfigdeletesuccess":"Изтрито успешно","adminconfigupdatesuccess":"Конфигурацията бе актуализирана успешно","wanttodeleteadminconfig":"Искате ли да изтриете този конфиг?","cannotdeleteconfig":"Този конфиг не може да бъде изтрит","nonanoktauser":"Не е разрешено това действие. Доставчикът на самоличността на този потребител не е Okta.","reactivate":"Изпратете отново поканата","wanttoreactivate":"Искате ли да изпратите отново връзката за активиране към потребителя?","iread1":"Съгласен съм, че порталите, приложенията и услугите на клиентите на Cargill, които са достъпни чрез тях, са предмет на потребителския портал на Cargill","iread2":"Правила и условия","iread3":", които могат да бъдат допълнени или изменени със специфични условия за всяка приложима бизнес услуга.","iagree1":"Приемам и приемам, че обработката на Cargill на лични данни във връзка с клиентските портали на Cargill, приложенията и услугите е предмет на Cargill's","iagree2":"Декларация за поверителност онлайн","iagree3":", които могат да бъдат допълнени или изменени с „Съобщения за поверителност“ за всяка приложима бизнес услуга.","privacypolicy_link":"https://www.cargill.com/page/privacy","termsandconditions_link":"https://www.cargill.com/portal-terms","resetreactivate":"Reset / Повторно","emailinvaliddomain":"Потребител с този домейн не може да бъде добавен","administeredgroups":"Администрирани групи","selectgroupslist":"Изберете Групи","alreadyactive":"Вие сте активен потребител!","alreadyactivesetup":"Вашият профил не изисква регистрация. Използвайте вход за служители на Cargill, за да влезете във вашите приложения.","selectBrand":"Изберете марка","permissiondeniedreset":"Не можете да възстановите паролата за този потребител. ","unlockaccount":"Отключване на профил","unlockaccountsuccess":"Профилът ви бе отключен успешно","accountunlocked":"Профилът е отключен!","copyrefid":"Please copy the reference Id from the bottom of the email you received and paste it below to proceed.","securityquestionanswerweak":"Отговорът на защитния въпрос е твърде слаб, отговорът не трябва да е част от въпроса","securityanswermatchesquestion":"Невалиден отговор за сигурност: Отговорът не трябва да съдържа $, което е част от защитния въпрос","copysecurityanswermatchesquestion":"Невалиден отговор за сигурност: Отговорът не трябва да съдържа $, което е част от защитния въпрос","tokenInvalidShortMessage":"Вашата връзка за активация вече не е валидна.","browserspecificmsg":"Моля, помислете за използването на Google Chrome","enterActivationDetails":"За изисканата по-долу информация направете справка с Вашия имейл за активация.","resendActivation":"Повторно изпращане на имейл за активация","reinvite":"Повторно изпращане на покана","reinviteEmailMessage":"Ако информацията, която сте предоставили, е коректна, ще получите нов имейл за активация.","reinviteContactAdminMessage":"Моля, свържете се с Вашия контакт за бизнес дейности в Cargill, ако не получите новия имейл за активация.","activationOk":"Ok","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","disableExistingUserOnboard":"Disable Existing User","selfRegSubGrps":"Self registration additional group:","selectReggroup":"Select Registration group","selfRegister":"Register","selfRegFormTitle":"Sign-up","E0001":"Sorry, there was a problem setting up your account. Please","E0001_1":" contact us ","E0001_2":"for help setting up your account.","E0002":" for assistance with setting up your account.","E0003":"Your account has been successfully registered. An email has been sent to ","E0003_1":" with instructions for activating your account.","E0004":"Your account has been successfully registered. You may now login to the application using your existing password. If you do not remember your password, please use the “Forgot Password�? option on the application to reset your password.","E0005":"User already exists with status ","E0005_1":" Please contact ","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"Изискванията за парола не са изпълнени. Изисквания за паролата: поне 8 знака, малка буква, главна буква, цифра, без части от вашето потребителско име. Вашата парола не може да бъде която и да е от последните 24 пароли.","acceptTerms":"Моля, приемете нашата Политика за поверителност и Правила и условия, за да продължите.","phoneVerificationNotCompleted":"Моля, потвърдете/премахнете телефонния си номер, за да продължите.","verifyPhoneWarning":"Моля, кликнете върху „Изпращане на код“, за да потвърдите телефонния си номер","viewMoreInfo":"Вижте повече информация","infoContent":"Вижте повече информация за Потребителя","createdDate":"Дата на създаване","activatedDate":"Дата на активиране","lastLoginDate":"Дата на последно влизане","lastUpdatedDate":"Дата на последно актуализиране","passwordChangedDate":"Дата на промяна на паролата","statusChangedDate":"Дата на промяна на състоянието","createdDateDescription":"Дата и час, когато е създаден потребителският запис в Okta.","activatedDateDescription":"Дата и час, когато е изпратен последният имейл за активиране на потребителя.","statusChangedDateDescription":"Дата и час, когато статусът на потребителя е бил последно променен в Okta.","lastLoginDateDescription":"Дата и час на последното влизане на потребителя в Okta (не е специфично за приложението).","lastUpdatedDateDescription":"Дата и час на последното актуализиране на потребителския запис в Okta.","passwordChangedDateDescription":"Дата и час, когато потребителят за последна промяна на паролата си.","resetMFATitle":"Нулиране на многофакторна автентификация","noFactorExist":"Не съществува фактор за този потребител.","mfaValidation":"Моля, изберете фактор за нулиране.","resetButton":"Нулиране","mfaResetModalTitle":"MFA Нулиране","factorResetSuccess":"Факторът е нулиран успешно.","resetConfirmation":"Наистина ли искате да нулирате MFA за този потребител?","copyrights":"Cargill, Incorporated. Всички права запазени.","reportLabel":"Докладвай","bulkUploadLabel":"Потребители за групово качване","availableIndependentGroups":"Налични независими групи:","selectedBrand":"Избрана марка:","bulkUploadOptionsLabel":"Опции за групово качване","bulkCreateUsers":"Групово създаване на потребители","bulkReinviteUsers":"Групово повторно поканване на потребители","confirm":"Потвърдете","downloadExcelTemplate":"Изтеглете шаблон на Excel:","uploadInstruction":"След като изтеглите шаблона, попълнете листа в Excel и го качете, като използвате раздела по-долу","uploadWarningOne":"Разрешени са максимум само 50 потребители наведнъж.","uploadWarningTwo":"Уверете се, че полето за имейл не е оставено празно.","uploadWarningThree":"Уверете се, че предоставените имейл адреси се администрират от вас.","uploadWarningFour":"Уверете се, че няма празни полета.","uploadWarningFive":"Уверете се, че всички стойности на полетата са валидни.","uploadWarningSix":"Уверете се, че предоставените групови идентификатори се администрират от вас.","uploadNote":"Поканите, изпратени чрез този процес, следват стандартния имейл за покана за акаунт в Cargill.","uploadLabel":"Качване","action":"Действия","userword":"потребители","note":"Забележка:","authentication":"Удостоверяване","noTableData":"Няма данни за таблицата.","readOnlyGroup":"Това е група само за четене. Присвояването на тази група трябва да се извършва само чрез access.cargill.com","adminPermissionDenied":"Вашите потребителски администраторски права нямат разрешения за промяна на това назначение на групата.","msgForGenericErrorUA":"В момента сме изправени пред проблем с обработката на вашата заявка. Моля, опитайте отново по-късно. Ако продължавате да виждате тази грешка, свържете се с вашия представител за обслужване на клиенти за допълнителна помощ.","passcodeRateLimit":"Заявката ви не може да бъде обработена, моля, опитайте отново след 5 минути.","passcodeNotEntered":"Моля, въведете паролата за потвърждение.","msgForUnhandledResponse":"Заявката не може да бъде обработена, моля, свържете се с вашия представител за обслужване на клиенти.","groupUnavailable":"Групата вече не е налична в Okta. Групата може да е изтрита.","groupCannotBeAssigned":"Групата $ вече не е налична в Okta и следователно не може да бъде присвоена на потребителя. Моля, премахнете групата и продължете.","copyGroupCannotBeAssigned":"Групата $ вече не е налична в Okta и следователно не може да бъде присвоена на потребителя. Моля, премахнете групата и продължете."}

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = {"1":"美国","7":"俄罗斯联邦","20":"埃及","27":"南非洲","30":"希腊","31":"介质","32":"比利时","33":"法国","34":"西班牙","36":"匈牙利","39":"意大利","40":"罗马尼亚","41":"瑞士","43":"奥地利","44":"英国","45":"丹麦","46":"瑞典","47":"斯瓦尔巴和简·马恩","48":"波兰","49":"德国","51":"秘鲁","52":"墨西哥","53":"古巴","54":"阿根廷","55":"巴西","56":"智利","57":"哥伦比亚","58":"委内瑞拉，玻利维亚共和国","60":"马来西亚","61":"圣诞岛","62":"印度尼西亚","63":"菲律宾","64":"新西兰","65":"新加坡","66":"泰国","81":"日本","82":"韩国","84":"越南","86":"中国","90":"火鸡","91":"印度","92":"巴基斯坦","93":"阿富汗","94":"斯里兰卡","95":"缅甸","98":"伊朗，伊斯兰共和国","211":"南方苏丹","212":"撒哈拉西部","213":"阿尔及利亚","216":"突尼斯","218":"利比亚","220":"冈比亚","221":"塞内加尔","222":"毛里塔尼亚","223":"马里","224":"几内亚","225":"象牙海岸","226":"布基纳法索","227":"尼日尔","228":"多哥","229":"贝宁","230":"毛里求斯","231":"利比里亚","232":"塞拉利昂","233":"加纳","234":"尼日利亚","235":"查德","236":"中非共和国","237":"喀麦隆","238":"绿色角","239":"圣多美和普林西比","240":"几内亚","241":"加蓬","242":"刚果","243":"刚果民主共和国","244":"安哥拉","245":"几内亚比绍","246":"英国印第安海洋领土","248":"塞舌尔","249":"苏丹","250":"卢旺达","251":"埃塞俄比亚","252":"索马里","253":"吉布提","254":"肯尼亚","255":"坦桑尼亚联合共和国","256":"乌干达","257":"布隆迪","258":"莫桑比克","260":"赞比亚","261":"马达加斯加","262":"留尼汪岛","263":"津巴布韦","264":"纳米比亚","265":"马拉维","266":"莱索托","267":"博茨瓦纳","268":"斯威士兰","269":"科摩罗","290":"圣海伦娜，阿森松岛和特里斯坦·达库尼亚","291":"厄立特里亚","297":"阿鲁巴","298":"法罗群岛","299":"格陵兰岛","350":"直布罗陀","351":"葡萄牙","352":"卢森堡","353":"爱尔兰","354":"冰岛","355":"阿尔巴尼亚","356":"马耳他","357":"塞浦路斯","358":"芬兰","359":"保加利亚","370":"立陶宛","371":"拉脱维亚","372":"爱沙尼亚","373":"摩尔多瓦","374":"亚美尼亚","375":"白俄罗斯","376":"安道尔","377":"慕尼黑","378":"圣马力诺","379":"神圣之城","380":"乌克兰","381":"塞尔维亚","382":"黑山","385":"克罗地亚","386":"斯洛文尼亚","387":"波斯尼亚-黑塞哥维那","389":"马其顿","420":"捷克共和","421":"斯洛伐克","423":"列支敦士登","500":"南乔治亚和南三明治岛","501":"伯利兹","502":"危地马拉","503":"萨尔瓦多","504":"洪都拉斯","505":"尼加拉瓜","506":"哥斯达黎加","507":"巴拿马","508":"圣皮埃尔和密克隆","509":"海地","590":"瓜德罗普","591":"玻利维亚","592":"圭亚那","593":"厄瓜多尔","595":"巴拉圭","596":"马提尼克","597":"苏里南","598":"乌拉圭","599":"荷兰安地列斯","670":"东帝汶","672":"诺福克岛","673":"文莱","674":"找瑙鲁","675":"巴布亚新几内亚","676":"汤加","677":"所罗门群岛","678":"瓦努阿图","679":"斐济","680":"帕劳","681":"沃利斯和富图纳","682":"库克群岛","683":"纽埃岛","685":"萨摩亚","686":"基里巴斯","687":"纽约加里多尼亚","688":"图瓦卢","689":"法国波利尼西亚","690":"托克劳","691":"密克罗尼西亚","692":"马歇尔群岛","850":"朝鲜","852":"中国香港","853":"中国澳门","855":"柬埔寨","856":"老挝人民民主共和国","880":"孟加拉国","886":"中国台湾","960":"马尔代夫","961":"黎巴嫩","962":"乔丹","963":"叙利亚阿拉伯共和国","964":"伊拉克","965":"科威特","966":"沙特阿拉伯","967":"也门","968":"阿曼","970":"巴勒斯坦","971":"联合阿拉伯酋长国","972":"伊斯雷尔","973":"巴林","974":"卡塔尔","975":"不丹","976":"蒙古","977":"尼泊尔","992":"塔吉克斯坦","993":"土库曼斯坦","994":"阿塞拜疆","995":"乔治亚州","996":"吉尔吉斯斯坦","998":"乌兹别克斯坦","1242":"巴哈马","1246":"巴巴多斯","1264":"安圭拉岛","1268":"安提瓜和巴布达","1284":"英国维珍岛","1340":"维珍岛，美国","1345":"开曼群岛","1441":"百慕大","1473":"格林纳达","1649":"特克斯和凯科斯群岛","1664":"蒙特塞拉特","1670":"北马里亚纳群岛","1671":"关岛","1684":"美国萨摩亚","1758":"圣卢西亚","1767":"多米尼加","1784":"圣文森特和格林纳丁斯","1787":"波多黎各","1809":"共和同伙","1868":"特立尼达和多巴哥","1869":"圣基茨和尼维斯","1876":"牙买加","441481":"根西岛","441534":"泽西岛","registration":"注册","hello":"您好","welcome_cargill":"欢迎","user_reg":"注册用户","enter_new_pwd":"输入新密码","pwd_rule":"密码必须至少由8个字符组成，必须包括小写字母、大写字母和数字，并且不能和用户名的一部分一致。","repeat_pwd":"再次输入新密码","choose_forgot_pwd_qtn":"选择安全问题","stock_qtn":"股票问题","disliked_food":"您小时候最不喜欢的食物是什么?","name_of_first_plush_toy":"您的第一个毛绒玩具叫什么名字?","first_award":"您第一次获得得奖是什么奖项?","favorite_security_question":"您最喜欢的安全问题是什么?","favorite_toy":"您小时候最喜欢的玩具是什么?","first_computer_game":"您玩的第一个电脑游戏是什么?","favorite_movie_quote":"您最喜欢的电影台词是什么?","first_sports_team_mascot":"您参加的第一个运动队的吉祥物是什么?","first_music_purchase":"您第一次购买的音乐专辑或歌曲是什么?","favorite_art_piece":"您最喜欢的艺术品是什么?","grandmother_favorite_desert":"您祖母最喜欢的甜点是什么?","first_thing_cooked":"您学的第一道菜是什么？","childhood_dream_job":"您小时候梦想的工作是什么?","place_where_significant_other_was_met":"您在哪里遇见您的配偶/另一半?","favorite_vacation_location":"您最喜欢去哪里度假?","new_years_two_thousand":"2000年的除夕您在哪里?","favorite_speaker_actor":"您最喜欢的演说家是谁?","favorite_book_movie_character":"您最喜欢的书/电影角色是谁?","favorite_sports_player":"您最喜欢的运动员是谁?","custom_qtn":"自定义","own_sec_qtn":"创建安全问题","answer":"回答","phone_inst":"添加一个电话号码用于重置密码或解锁帐户中使用短信。","optional":"可选项","sms_inst":"OKTA会向您发送带有验证码的文本消息。当您无法访问电子邮件时，此功能非常有用。","add_ph_no":"添加联系方式","create_acc":"创建我的账户","forgot_pwd_header":"忘记密码短信","enter_phone_no":"输入您将用于接收验证码的联系方式，然后单击发送代码以验证它是否工作。","country":"国家/地区","country_inst":"选择手机注册的国家。","back":"重新发送","phone_number":"联系方式","phone_number_inst":"按您平常拨电话号码的方式输入您的手机号码。无需添加您的国家代码。","code_prefix":"国家代码前缀","send_code":"发送验证码","done":"完成","verify":"验证","enter_code":"输入代码","enter_code_rule":"输入您的联系方式以收到验证码。验证码将在一分钟内送达。","verify_success":"联系方式验证成功!","click":"点击","finish_setup":"完成设置","error_review":"请检查表格以纠正以下错误","phone_no_not_found":"无法发送文本消息，因为数据库中没有找到联系方式。","noLowerCase":"应该包含至少一个小写字母","noUpperCase":"应该包含至少一个大写字母","noNumber":"应该包含至少一个数字","noSpecialCharacter":"应该包含至少一个特殊字符","notMinLength":"应该至少$个字符","noUsernameSubstring":"不应该包含部分用户名","noFirstnameSubstring":"不应该包含部分名字","noLastnameSubstring":"不应该包含部分姓氏","tokenNotValid":"激活流程失效","tokenInvalidInfo":"如果在创建帐户后单击激活链接、激活链接过期或链接不正确，就会发生这种情况","reqNewToken":"请求新的激活流程","passcodeNotValid":"您的密码不符。请再试一次。","OTPEnableAfter30Sec":"短信已发出。请30秒后重试。","phoneNoAlreadySet":"该用户已验证了联系方式","emptypassword":"密码不能为空。","passwordlength":"密码不能为空。","passwordnotvalid":"密码无效。","passwordnotmatching":"两次密码必须一致。","answerlength":"答案应该至少是$字符长","phonenumbermissing":"验证您收到的密码以继续","customQuestionEmpty":"自定义问题不能为空","customQAsame":"自定义的问题和答案不能相同","passwordSameasPrev":"密码不能是您的当前密码","answerWrong":"安全问题的答案不符","phonealreadyactive":"此联系方式已经过验证，如果要更新请尝试另一个联系方式","first_name":"名字","last_name":"姓氏","enter_email":"邮件地址","emailNotValid":"邮件地址无效","registeredapps":"已注册应用程序","waitingapps":"应用程序等待审批","requestaccess":"请求权限","admin":"管理员","selectLang":"选择语言","dashboardLabel":"启动板","resetpwd":"密码重置","ansForgotten":"回答安全问题","resetOktaPwd":"重置密码","newpwd":"新密码","rptpwd":"重复密码","adminLabel":"用户管理","userAdministration":"用户管理","adduser":"增加新用户","function":"功能","emailAddress":"邮箱地址","filterApp":"筛选应用程序","create":"创建","logoutConfirm":"您确定要登出吗?","no":"否","yes":"是","logout":"登出","expireWarning":"您的会话将在%分钟内过期，请按确认按钮继续保持登录或按取消按钮注销。如果断开连接，任何更改都不会被保存。","update":"更新","activateDeactivate":"激活/注销","attention":"注意","cancel":"取消","sessionTimedout":"您的会话已过期，请重新登录。","username":"用户名","primary_mail":"常用电子邮件","secondary_mail":"备用电子邮件（选填）","groups":"用户组","must_email":"必须是电子邮件","ieNotSupported":"不支持IE","tryChrome":"不支持Internet Explorer。我们建议这个应用程序使用Chrome。","close":"关闭","forgotSQA":"忘记安全答案？","resetSecQA":"重置安全问题和答案","retry":"返回","nofactorpresent":"由于未设置手机号码，因此无法使用此选项。请与您的管理员联系。","emptypasscode":"代码不得为空","provisioned":"此用户尚未注册。密码只能在用户激活后重置","deprovisioned":"此用户已停用。密码只能在用户激活后重置","resetsuccesspopupmsg":"密码重置链接已发送到电子邮件地址。请使用X按钮关闭弹出窗口。","wanttoreset":"是否重置密码?","wanttoactivate":"是否激活用户?","wanttodeactivate":"是否停用用户?","wanttodelete":"是否删除用户?","updateprofile":"更新个人资料","updatesuccess":"用户已成功更新","usercreated":"*用户创建","errorcreatinguser":"*创建用户/电子邮件时出错","privacypolicy":"隐私政策","termsandconditions":"条款和条件","uname-email":"用户名/电子邮件","password_placeholder":"密码","sign-in":"登陆","resetmailsent":"已将带有重置密码链接的电子邮件发送到%。","smssent":"已发送","resendcode":"再次发送代码","needhelp":"需要登陆帮助？","forgotPassword":"忘记密码？","helplink":"帮助","smsusage":"短信功能只能在已配置联系方式的情况下使用。","backtosignin":"返回登陆页","resetviasms":"通过短信重置","resetviaemail":"通过邮件重置","didntreceivecode":"没有收到代码?通过邮件重置","emailsent":"邮件已发送","recoverycredentialsnotset":"不允许忘记密码，因为没有为用户设置恢复凭据","usernotpresent":"用户不存在","mobilenumbernotset":"手机号码未设置","invalidcreds":"用户名或密码无效","emailreq":"需要邮件","emailinvalid":"邮件无效","pwdreq":"需要密码","otplength":"动态验证码应为六位字符","passcodeinvalid":"无效的验证码","firstnamereq":"需要名字","lastnamereq":"需要姓氏","notallowedincurrentstate":"当前身份验证状态不允许此操作。","nopartsofusername":"密码不能包含您的部分用户名，包括您的姓氏或名字。","passwordusedrecently":"密码使用过于频繁","passwordnotmetrequirements":"密码不符合当前密码策略的复杂性要求","antar":"南极洲","aus":"澳大利亚","can":"加拿大","falk":"福克兰群岛(马尔维纳斯)","kazak":"哈萨克斯坦","mayotte":"马约特","morocco":"安的列斯群岛","norway":"挪威","pitcairn":"皮特克恩","filteruser":"应用程序筛选用户","selectgroups":"选择应用程序","status":"状态","atleastonegroup":"分配此用户到至少一个用户组","answerchallenge":"回答安全问题","entersmscode":"输入通过短信发送的验证码","enterusercreds":"输入用户详细信息","inviteuser":"邀请新用户","assignApplication":"分配给应用程序","availablegroups":"可用的用户组","selectedgroups":"已分配的用户组","emailsenttouser":"电子邮件已成功发送至","pendingactivation":"等待账户激活","exit":"退出","myprofile":"我的资料","activatesuccess":"已成功激活用户，并已向其发送激活邮件","deactivatesuccess":"已成功停用","deletesuccess":"已成功删除","edituser":"编辑用户","getstarted":"开始","congrats":"恭喜您!","accountsetup":"您已经成功地完成了您的帐户设置。","edit":"编辑","assignedapps":"指定应用程序","assignedgroups":"分配组","oldpwd":"输入旧密码","changepwd":"更改密码","updatephone":"更新手机","pwdupdated":"密码已成功更新","QAupdated":"安全问题答案已成功更新","phonenumberinvalid":"电话号码无效","phoneupdated":"电话号码更新成功","showmore":"显示更多","verifypassword":"验证密码","filterusergrp":"按组筛选用户","allactiveusers":"所有活跃用户","viewuser":"查看用户","partofokta":"该用户是Okta组织的一部分","userdeactive":"用户已失效","showing":"显示","of":"的","answerpartofquestion":"答案不能为问题的一部分","activationpending":"您的账户正在等待激活，请更新您的电话号码，否则重置的短信将发送到您以前的活动号码","change_forgot_pwd_qtn":"更改安全问题","basicinfo":"基本信息","gotoapp":"单击转至目标应用程序","passwordresetsuccess":"您的密码已被成功重置","passwordreset":"密码重置!","searchinfotext":"应用程序内搜索完毕","tmlabel":"配置","delete":"删除","search":"搜索","nop":"手机号码","nop_inst":"按您平常拨电话号码的方式输入您的号码。不添加您的国家代码","nopMobile":"手机号码","statusactive":"已激活","statuspending":"等待激活","globalsearch":"搜索其他用户","permissiondenied":"无法删除/停用此用户。分配给其他组的用户。您可以取消对用户的分配","activestatus":"激活","provisionedstatus":"已分配","deprovisionedstatus":"未分配","save":"保存","admingroup":"管理员组","application":"应用程序","selectadmingroup":"选择管理员组","selectapp":"选择应用程序","adminConfigIncomplete":"该行不完整。请分配一个管理组来保存或删除行。","adminconfigdeletesuccess":"成功删除","adminconfigupdatesuccess":"配置成功更新","wanttodeleteadminconfig":"要删除此配置吗?","cannotdeleteconfig":"无法删除此配置","nonanoktauser":"不允许执行此操作。此用户的身份提供程序不是OKTA。","reactivate":"重新发送邀请","wanttoreactivate":"要将激活链接重新发送给用户吗?","iread1":"我同意嘉吉客户门户网站、应用程序和服务均受嘉吉客户门户网站的约束。","iread2":"条款和条件","iread3":"，并可就每项适用的业务服务，以特定条款及细则加以补充或修订。","iagree1":"本人承认及接受嘉吉公司处理有关嘉吉客户入门网站、申请及服务的个人资料，均属嘉吉公司所有","iagree2":"在线隐私政策","iagree3":"，并可就每项适用的业务服务作出“隐私通知”的补充或修订。","privacypolicy_link":"","termsandconditions_link":"","resetreactivate":"重置/激活","emailinvaliddomain":"无法添加此域的用户","administeredgroups":"管理组","selectgroupslist":"选择组","alreadyactive":"您是一个已激活的用户！","alreadyactivesetup":"您的个人资料不需要注册。使用嘉吉员工登录登录到您的应用程序。","selectBrand":"选择品牌","permissiondeniedreset":"您无法重置该用户的密码。","unlockaccount":"解锁帐户","unlockaccountsuccess":"您的帐户已成功解锁","accountunlocked":"帐户已解锁","copyrefid":"Please copy the reference Id from the bottom of the email you received and paste it below to proceed.","securityquestionanswerweak":"安全问题答案太弱，答案不能是问题的一部分","securityanswermatchesquestion":"安全答案无效：答案不得包含作为安全问题一部分的 $","copysecurityanswermatchesquestion":"安全答案无效：答案不得包含作为安全问题一部分的 $","tokenInvalidShortMessage":"您的激活链接已失效","enterActivationDetails":"如需下面要求的信息，请查阅您的激活电子邮件。","resendActivation":"重新发送激活电子邮件","reinvite":"重新发送邀请","reinviteEmailMessage":"如果您提供的信息正确无误，将会收到一封新的激活电子邮件。","reinviteContactAdminMessage":"如果您没有收到新的激活电子邮件，请与您的嘉吉业务联系人联系。","activationOk":"Ok","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","selfRegSubGrps":"Self registration additional group:","disableExistingUserOnboard":"Disable Existing User","selectReggroup":"Select Registration group","selfRegister":"注册","selfRegFormTitle":"注册","E0001":"很抱歉，在设置您的帐号时遇到了问题。请","E0001_1":"联系我们","E0001_2":"获取设置帐号的帮助.","E0002":" for assistance with setting up your account.","E0003":"您的帐号已成功注册。我们已经将有关激活帐号说明的电子邮件发送到 ","E0003_1":" 有关激活帐户的说明。","E0004":"您的帐号已成功注册。现在，您可以使用当前密码登陆应用。如果您不记得您的密码，请使用应用中的“忘记密码”选项重新设置您的密码.","E0005":"User already exists with status ","E0005_1":" Please contact ","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"密码不符合要求。密码需包含小写字母，大写字母和数字，长度至少8位，且不能与用户名相同。不能与曾使用过的24个密码重复。","acceptTerms":"请接受我们的隐私政策和条款和条件以继续。","phoneVerificationNotCompleted":"请验证/删除您的电话号码以继续。","verifyPhoneWarning":"请点击“发送代码”以验证您的电话号码","viewMoreInfo":"查看更多信息","infoContent":"查看有关用户的更多信息","createdDate":"创建日期","activatedDate":"激活日期","lastLoginDate":"上次登录日期","lastUpdatedDate":"最后更新日期","passwordChangedDate":"密码更改日期","statusChangedDate":"状态更改日期","createdDateDescription":"在 Okta 中创建用户记录的日期和时间。","activatedDateDescription":"上次发送用户激活电子邮件的日期和时间。","statusChangedDateDescription":"上次在 Okta 中更改用户状态的日期和时间。","lastLoginDateDescription":"用户上次登录 Okta 的日期和时间（不是特定于应用程序）。","lastUpdatedDateDescription":"上次在 Okta 中更新用户记录的日期和时间。","passwordChangedDateDescription":"用户上次更改密码的日期和时间。","resetMFATitle":"重置多因素身份验证","noFactorExist":"此用户不存在任何因素。","mfaValidation":"请选择要重置的因素。","resetButton":"重置","mfaResetModalTitle":"MFA 重置","factorResetSuccess":"因子已成功重置。","resetConfirmation":"您确定要为此用户重置 MFA 吗？","copyrights":"Cargill, 成立。版权所有。","reportLabel":"报告","bulkUploadLabel":"批量上传用户","availableIndependentGroups":"可用的独立组：","selectedBrand":"所选品牌：","bulkUploadOptionsLabel":"批量上传选项","bulkCreateUsers":"批量创建用户","bulkReinviteUsers":"批量重新邀请用户","confirm":"确认","downloadExcelTemplate":"下载 Excel 模板：","uploadInstruction":"下载模板后，填写 excel 表并使用以下部分上传","uploadWarningOne":"一次最多只允许 50 个用户。","uploadWarningTwo":"确保电子邮件字段未留空。","uploadWarningThree":"确保提供的电子邮件 ID 由您管理。","uploadWarningFour":"确保没有字段留空。","uploadWarningFive":"确保所有字段值都有效。","uploadWarningSix":"确保提供的组 ID 由您管理。","uploadNote":"通过此过程发送的邀请遵循标准嘉吉帐户邀请电子邮件。","uploadLabel":"上传","action":"动作","userword":"用户","note":"笔记:","authentication":"验证","noTableData":"表中没有数据。","readOnlyGroup":"这是一个只读组。该组的分配只能通过 access.cargill.com 进行","adminPermissionDenied":"您的用户管理员权限无权修改此组分配。","msgForGenericErrorUA":"目前我们在处理您的请求时遇到问题。请稍后再试。如果您仍然看到此错误，请联系您的客户服务代表以获取进一步帮助。","passcodeRateLimit":"无法处理您的请求，请在 5 分钟后重试。","passcodeNotEntered":"请输入密码进行验证。","msgForUnhandledResponse":"无法处理请求，请联系您的客户服务代表。","groupUnavailable":"该组在 Okta 中不再可用。该群组可能已被删除。","groupCannotBeAssigned":"组 $ 在 Okta 中不再可用，因此无法分配给用户。请删除该组并继续。","copyGroupCannotBeAssigned":"组 $ 在 Okta 中不再可用，因此无法分配给用户。请删除该组并继续。"}

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports = {"1":"Vereinigte Staaten","7":"Russische Föderation","20":"Ägypten","27":"Südafrika","30":"Griechenland","31":"Niederlande","32":"Belgien","33":"Frankreich","34":"Spanien","36":"Ungarn","39":"Italien","40":"Rumänien","41":"Schweiz","43":"Österreich","44":"Großbritannien","45":"Dänemark","46":"Schweden","47":"Spitzbergen und Jan Mayen","48":"Polen","49":"Deutschland","51":"Peru","52":"Mexiko","53":"Kuba","54":"Argentinien","55":"Brasilien","56":"Chile","57":"Kolumbien","58":"Venezuela, Bolivarische Republik","60":"Malaysia","61":"Weihnachtsinsel","62":"Indonesien","63":"Philippinen","64":"Neuseeland","65":"Singapur","66":"Thailand","81":"Japan","82":"Korea, Republik von","84":"Vietnam","86":"China","90":"Türkei","91":"Indien","92":"Pakistan","93":"Afghanistan","94":"Sri Lanka","95":"Myanmar","98":"Iran, Islamische Republik","211":"Südsudan","212":"Westsahara","213":"Algerien","216":"Tunesien","218":"Libyen","220":"Gambia","221":"Senegal","222":"Mauretanien","223":"Mali","224":"Guinea","225":"Elfenbeinküste","226":"Burkina Faso","227":"Niger","228":"Gehen","229":"Benin","230":"Mauritius","231":"Liberia","232":"Sierra Leone","233":"Ghana","234":"Nigeria","235":"Tschad","236":"Zentralafrikanische Republik","237":"Kamerun","238":"Kap Verde","239":"Sao Tome und Principe","240":"Äquatorialguinea","241":"Gabun","242":"Kongo","243":"Kongo, Demokratische Republik","244":"Angola","245":"Guinea Bissau","246":"Britisches Territorium des Indischen Ozeans","248":"Seychellen","249":"Sudan","250":"Ruanda","251":"Äthiopien","252":"Somalia","253":"Dschibuti","254":"Kenia","255":"Tansania, Vereinigte Republik","256":"Uganda","257":"Burundi","258":"Mosambik","260":"Sambia","261":"Madagaskar","262":"Wiedervereinigung","263":"Zimbabwe","264":"Namibia","265":"Malawi","266":"Lesotho","267":"Botswana","268":"Swasiland","269":"Komoren","290":"St. Helena, Himmelfahrt und Tristan da Cunha","291":"Eritrea","297":"Aruba","298":"Färöer Inseln","299":"Grönland","350":"Gibraltar","351":"Portugal","352":"Luxemburg","353":"Irland","354":"Island","355":"Albanien","356":"Malta","357":"Zypern","358":"Finnland","359":"Bulgarien","370":"Litauen","371":"Lettland","372":"Estland","373":"Moldau","374":"Armenien","375":"Weißrussland","376":"Andorra","377":"Monaco","378":"San Marino","379":"Heiliger Stuhl","380":"Ukraine","381":"Serbien","382":"Montenegro","385":"Kroatien","386":"Slowenien","387":"Bosnien und Herzegowina","389":"Mazedonien","420":"Tschechische Republik","421":"Slowakei","423":"Liechtenstein","500":"Süd-Georgien und die südlichen Sandwich-Inseln","501":"Belize","502":"Guatemala","503":"El Salvador","504":"Honduras","505":"Nicaragua","506":"Costa Rica","507":"Panama","508":"Saint Pierre und Miquelon","509":"Haiti","590":"Guadeloupe","591":"Bolivien","592":"Guyana","593":"Ecuador","595":"Paraguay","596":"Martinique","597":"Suriname","598":"Uruguay","599":"Niederländische Antillen","670":"Timor-Leste","672":"Norfolkinsel","673":"Brunei Darussalam","674":"Nauru","675":"Papua Neu-Guinea","676":"Tonga","677":"Salomon-Inseln","678":"Vanuatu","679":"Fidschi","680":"Palau","681":"Wallis und Futuna","682":"Cookinseln","683":"Niue","685":"Samoa","686":"Kiribati","687":"Neu-Kaledonien","688":"Tuvalu","689":"Französisch-Polynesier","690":"Tokelau","691":"Mikronesien","692":"Marshallinseln","850":"Korea, Demokratische Volksrepublik","852":"Hongkong","853":"Macao","855":"Kambodscha","856":"Demokratische Volksrepublik Laos","880":"Bangladesch","886":"Taiwan","960":"Malediven","961":"Libanon","962":"Jordan","963":"Syrische Arabische Republik","964":"Irak","965":"Kuwait","966":"Saudi Arabien","967":"Jemen","968":"Oman","970":"Palästina","971":"Vereinigte Arabische Emirate","972":"Israel","973":"Bahrain","974":"Katar","975":"Bhutan","976":"Mongolei","977":"Nepal","992":"Tadschikistan","993":"Turkmenistan","994":"Aserbaidschan","995":"Georgia","996":"Kirgisistan","998":"Usbekistan","1242":"Bahamas","1246":"Barbados","1264":"Anguilla","1268":"Antigua und Barbuda","1284":"Virgin Inseln, Britisch","1340":"Amerikanische Jungferninseln","1345":"Cayman Inseln","1441":"Bermuda","1473":"Grenada","1649":"Turks- und Caicosinseln","1664":"Montserrat","1670":"Nördliche Marianneninseln","1671":"Guam","1684":"Amerikanischen Samoa-Inseln","1758":"St. Lucia","1767":"Dominica","1784":"St. Vincent und die Grenadinen","1787":"Puerto Rico","1809":"Dominikanische Republik","1868":"Trinidad und Tobago","1869":"St. Kitts und Nevis","1876":"Jamaika","441481":"Guernsey","441534":"Jersey","registration":"Anmeldung","hello":"Hallo","welcome_cargill":"Willkommen zu","user_reg":"Benutzer Registration","enter_new_pwd":"Neues Passwort eingeben","pwd_rule":"Ihr Passwort muss aus mindestens 8 Zeichen, einem Kleinbuchstaben, einem Großbuchstaben, einer Zahl und keinem Teil Ihres Benutzernamens bestehen.","repeat_pwd":"Wiederhole das neue Passwort","choose_forgot_pwd_qtn":"Wählen Sie eine Sicherheitsfrage","stock_qtn":"Frage speichern","disliked_food":"Was hat Ihnen als Kind am wenigsten geschmeckt?","name_of_first_plush_toy":"Wie heißt dein erstes Kuscheltier?","first_award":"Wofür haben Sie Ihre erste Medaille oder Auszeichnung erhalten?","favorite_security_question":"Was ist Ihre liebste Sicherheitsfrage?","favorite_toy":"Was war das Spielzeug / Stofftier, das du als Kind am meisten gemocht hast?","first_computer_game":"Was war das erste Computerspiel, das du gespielt hast?","favorite_movie_quote":"Was ist dein Lieblingszitat?","first_sports_team_mascot":"Was war das Maskottchen der ersten Sportmannschaft, in der du gespielt hast?","first_music_purchase":"Welches war das erste Musikalbum oder Lied, das Sie gekauft haben?","favorite_art_piece":"Was ist Ihr Lieblingskunstwerk?","grandmother_favorite_desert":"Was war das Lieblingsdessert deiner Großmutter?","first_thing_cooked":"Was hast du als erstes kochen gelernt?","childhood_dream_job":"Was war Ihr Traumberuf als Kind?","place_where_significant_other_was_met":"Wo haben Sie Ihren Ehepartner / Lebensgefährten getroffen?","favorite_vacation_location":"Wohin sind Sie für Ihren Lieblingsurlaub gefahren?","new_years_two_thousand":"Wo waren Sie an Silvester im Jahr 2000?","favorite_speaker_actor":"Wer ist Ihr Lieblingsredner / Referent?","favorite_book_movie_character":"Wer ist dein Lieblingsbuch- / Filmcharakter?","favorite_sports_player":"Wer ist Ihr Lieblingssportler?","custom_qtn":"Benutzerdefinierte Frage","own_sec_qtn":"Erstellen Sie Ihre eigene Sicherheitsfrage","answer":"Antwort","phone_inst":"Freiwillige Option: Geben Sie eine Mobilnummer zur Wiederherstellung Ihres Accounts an. Diese Nummer wird ausschließlich zur Zusendung des Verifizierungscodes per SMS genutzt.","optional":"(Optional)","sms_inst":"Okta kann Ihnen eine SMS mit einem Wiederherstellungscode senden. Diese Funktion ist nützlich, wenn Sie keinen Zugriff auf Ihre E-Mail haben.","add_ph_no":"Telefonnummer hinzufügen","create_acc":"Meinen Account erstellen","forgot_pwd_header":"Passwort vergessen SMS","enter_phone_no":"Geben Sie die Telefonnummer ein, unter der Sie die Codes per SMS erhalten möchten, und klicken Sie dann auf Code senden, um die Funktionsfähigkeit zu überprüfen.","country":"Land","country_inst":"Wählen Sie das Land aus, in dem Ihr Telefon registriert ist.","back":"Erneut senden","phone_number":"Telefonnummer","phone_number_inst":"Geben Sie Ihre Nummer wie gewohnt ein. Fügen Sie nicht Ihre Landesvorwahl hinzu","code_prefix":"Ländercode-Präfix.","send_code":"Code senden","done":"Fertig","verify":"Überprüfen","enter_code":"Code eingeben","enter_code_rule":"Überprüfen Sie Ihr Telefon auf den Passcode und geben Sie ihn unten ein. Ihre Nachricht sollte in weniger als einer Minute eingehen.","verify_success":"Telefonnummer erfolgreich verifiziert!","click":"Klicken","finish_setup":"um das Setup zu beenden.","error_review":"Bitte überprüfen Sie das Formular, um die folgenden Fehler zu beheben","phone_no_not_found":"Die Textnachricht kann nicht gesendet werden, da in der Datenbank keine Telefonnummer gefunden wurde.","noLowerCase":"Sollte mindestens einen Kleinbuchstaben enthalten","noUpperCase":"Sollte mindestens einen Großbuchstaben enthalten","noNumber":"Sollte mindestens eine Nummer enthalten","noSpecialCharacter":"Sollte mindestens ein Sonderzeichen enthalten","notMinLength":"Sollte mindestens $ Zeichen enthalten","noUsernameSubstring":"Sollte keinen Teil des Benutzernamens enthalten","noFirstnameSubstring":"Sollte keinen Teil Ihres Vornamens enthalten","noLastnameSubstring":"Sollte keinen Teil Ihres Nachnamens enthalten","tokenNotValid":"Ihr Aktivierungs-Token ist nicht mehr gültig","tokenInvalidInfo":"Dies kann passieren, wenn Sie nach dem Erstellen Ihres Kontos auf Ihren Aktivierungslink geklickt haben, Ihr Aktivierungslink abgelaufen ist oder die URL falsch ist","reqNewToken":"Fordern Sie einen neuen Token an","passcodeNotValid":"Ihr Code stimmt nicht mit unseren Aufzeichnungen überein. Bitte versuchen Sie es erneut.","OTPEnableAfter30Sec":"Eine SMS-Nachricht wurde kürzlich gesendet. Bitte warten Sie 30 Sekunden, bevor Sie es erneut versuchen.","phoneNoAlreadySet":"Die Telefonnummer wurde bereits von diesem Benutzer bestätigt.","emptypassword":"Passwort kann nicht leer sein","passwordlength":"Passwort kann nicht leer sein","passwordnotvalid":"Passwort ist ungültig","passwordnotmatching":"Passwörter sollten übereinstimmen","answerlength":"Die Antwort sollte mindestens $ Zeichen lang sein","phonenumbermissing":"Bestätigen Sie den erhaltenen Passcode, um fortzufahren.","customQuestionEmpty":"Benutzerdefinierte Frage darf nicht leer sein","customQAsame":"Benutzerdefinierte Fragen und Antworten können nicht identisch sein","passwordSameasPrev":"Das Passwort kann nicht Ihr aktuelles Passwort sein","answerWrong":"Die Antwort auf die Frage zur Wiederherstellung entsprach nicht unseren Aufzeichnungen","phonealreadyactive":"Diese Nummer wurde bereits überprüft. Wenn Sie ein Update durchführen möchten, versuchen Sie es mit einer anderen Nummer","first_name":"Vorname","last_name":"Nachname","enter_email":"E-Mail-ID","emailNotValid":"Email ID nicht gültig","registeredapps":"Registrierte Apps","waitingapps":"Apps warten auf Genehmigung","requestaccess":"Zugang anfragen","admin":"Administrator","selectLang":"Sprache auswählen","dashboardLabel":"Übersicht","resetpwd":"Passwort zurücksetzen","ansForgotten":"Passwort vergessen?","resetOktaPwd":"Setzen Sie Ihr Passwort zurück","newpwd":"Neues Passwort","rptpwd":"Wiederhole das Passwort","adminLabel":"Benutzerverwaltung","userAdministration":"Benutzerverwaltung","adduser":"Neuen Benutzer hinzufügen","function":"Funktion","emailAddress":"E-Mail-Addresse","filterApp":"Filteranwendung","create":"erstellen","logoutConfirm":"Möchten Sie sich wirklich abmelden?","no":"Nein","yes":"Ja","logout":"Ausloggen","expireWarning":"Ihre Sitzung läuft in% Minuten ab. Drücken Sie OK, um angemeldet zu bleiben, oder Abbrechen, um sich abzumelden. Wenn Sie nicht verbunden sind, gehen alle Änderungen verloren","update":"Aktualisieren","activateDeactivate":"Aktivieren / Deaktivieren","attention":"Achtung","cancel":"Abbrechen","sessionTimedout":"Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an","username":"Nutzername","primary_mail":"Primäre Email","secondary_mail":"Sekundäre E-Mail (optional)","groups":"Gruppen","must_email":"Es muss sich um eine E-Mail Adresse handeln. ","ieNotSupported":"Internet Explorer wird nicht unterstützt","tryChrome":"Internet Explorer wird nicht unterstützt. Wir empfehlen, Chrome für diese App zu verwenden.","close":"Schließen","forgotSQA":"Sicherheitsantwort vergessen?","resetSecQA":"Sicherheitsfrage und Passwort zurücksetzen","retry":"Zurück","nofactorpresent":"Diese Option kann nicht verwendet werden, da die Mobiltelefonnummer nicht festgelegt ist. Bitte wenden Sie sich an Ihren Administrator.","emptypasscode":"Code darf nicht leer sein","provisioned":"Dieser Benutzer ist noch nicht registriert. Das Passwort kann nur zurückgesetzt werden, wenn der Benutzer aktiv ist","deprovisioned":"Dieser Benutzer ist deaktiviert. Das Passwort kann nur zurückgesetzt werden, wenn der Benutzer aktiv ist","resetsuccesspopupmsg":"Der Link zum Zurücksetzen des Passworts wurde an die E-Mail-Adresse gesendet. Bitte schließen Sie das Popup mit der X-Taste.","wanttoreset":"Möchten Sie das Passwort zurücksetzen?","wanttoactivate":"Möchten Sie den Benutzer aktivieren?","wanttodeactivate":"Möchten Sie den Benutzer deaktivieren? ","wanttodelete":"Möchten Sie den Benutzer löschen?","updateprofile":"Profil aktualisieren","updatesuccess":"Benutzer wurde erfolgreich aktualisiert","usercreated":"* Benutzer erstellt","errorcreatinguser":"* Fehler beim Erstellen des Benutzers / der E-Mail ist bereits vorhanden","privacypolicy":"Datenschutz-Bestimmungen","termsandconditions":"Impressum","uname-email":"Benutzername / E-Mail","password_placeholder":"Passwort","sign-in":"Einloggen","resetmailsent":"Eine E-Mail mit dem Link zum Zurücksetzen des Passworts wurde an% gesendet.","smssent":"abschicken","resendcode":"Code erneut senden","needhelp":"Benötigen Sie Hilfe beim Anmelden?","forgotPassword":"Passwort vergessen?","helplink":"Hilfe","smsusage":"SMS können nur verwendet werden, wenn eine Mobiltelefonnummer konfiguriert wurde.","backtosignin":"Zurück zur Anmeldung","resetviasms":"Per SMS zurücksetzen","resetviaemail":"Per E-Mail zurücksetzen","didntreceivecode":"Haben Sie keinen Code erhalten? per Email zurücksetzen","emailsent":"E-Mail gesendet!","recoverycredentialsnotset":"Passwort vergessen nicht möglich, da für den Benutzer keine Wiederherstellungsdaten festgelegt wurden","usernotpresent":"Benutzer nicht anwesend","mobilenumbernotset":"Handynummer nicht festgelegt","invalidcreds":"ungültiger Benutzername oder Passwort","emailreq":"Email (erforderlich","emailinvalid":"E-Mail ungültig","pwdreq":"Passwort erforderlich","otplength":"OTP sollte 6 Zeichen lang sein","passcodeinvalid":"Ungültiges OTP","firstnamereq":"Vorname (erforderlich","lastnamereq":"Nachname erforderlich","notallowedincurrentstate":"Dieser Vorgang ist im aktuellen Authentifizierungsstatus nicht zulässig","nopartsofusername":"Das Passwort darf keine Teile Ihres Benutzernamens enthalten, einschließlich Ihres Vor- oder Nachnamens","passwordusedrecently":"Das Passwort wurde zu kürzlich verwendet","passwordnotmetrequirements":"Das Passwort entspricht nicht den Komplexitätsanforderungen der aktuellen Passwortrichtlinie","antar":"Antarktis","aus":"Australien","can":"Kanada","falk":"Falklandinseln (Malvinas)","kazak":"Kasachstan","mayotte":"Mayotte","morocco":"Marokko","norway":"Norwegen","pitcairn":"Pitcairn","filteruser":"Benutzer nach App filtern","selectgroups":"Wählen Sie Anwendung","status":"Status","atleastonegroup":"Wählen Sie mindestens eine Gruppe aus, der Sie einen Benutzer zuweisen möchten","answerchallenge":"Passwort vergessen?","entersmscode":"Geben Sie den Bestätigungscode ein, der per SMS gesendet wurde","enterusercreds":"Benutzerdetails eingeben","inviteuser":"Neuen Benutzer einladen","assignApplication":"Anwendung zuweisen","availablegroups":"Verfügbare Gruppen","selectedgroups":"Zugewiesene Gruppen","emailsenttouser":"E-Mail erfolgreich gesendet an","pendingactivation":"Ausstehende Kontoaktivierung","exit":"Ausgang","myprofile":"Mein Profil","activatesuccess":"Der Benutzer wurde erfolgreich aktiviert und eine Aktivierungsmail wurde an gesendet","deactivatesuccess":"wurde erfolgreich deaktiviert","deletesuccess":"wurde erfolgreich gelöscht","edituser":"Benutzer bearbeiten","getstarted":"Loslegen","congrats":"Herzlichen Glückwunsch!","accountsetup":"Sie haben Ihre Kontoeinrichtung erfolgreich abgeschlossen.","edit":"Bearbeiten","assignedapps":"Zugewiesene Anwendungen","assignedgroups":"Zugewiesene Gruppen","oldpwd":"Geben Sie das alte Passwort ein","changepwd":"Passwort ändern","updatephone":"Telefon aktualisieren","pwdupdated":"Passwort wurde erfolgreich aktualisiert","QAupdated":"Antwort der Sicherheitsfrage wurde erfolgreich aktualisiert","phonenumberinvalid":"Die Telefonnummer ist ungültig","phoneupdated":"Telefonnummer erfolgreich aktualisiert","showmore":"Mehr anzeigen","verifypassword":"Passwort bestätigen","filterusergrp":"Benutzer nach Gruppe filtern","allactiveusers":"Alle aktiven Benutzer","viewuser":"Benutzer anzeigen","partofokta":"Dieser Benutzer ist Teil der Okta-Organisation","userdeactive":"Benutzer ist deaktiviert","showing":"Zeigen","of":"von","answerpartofquestion":"Die Antwort darf nicht Teil der Frage sein","activationpending":"Ihr Faktor wartet auf Aktivierung. Aktualisieren Sie bitte Ihre Telefonnummer, da sonst die zurückgesetzten SMS an Ihre vorherige aktive Nummer gesendet werden","change_forgot_pwd_qtn":"Sicherheitsfrage ändern","basicinfo":"Basisinformation","gotoapp":"Klicken Sie auf die Anwendung, zu der Sie wechseln möchten","passwordresetsuccess":"Ihr Passwort wurde erfolgreich zurückgesetzt","passwordreset":"Passwort zurücksetzen!","searchinfotext":"* Die Suche wird nur in der App durchgeführt","tmlabel":"Konfiguration","delete":"Löschen","search":"Suche","nop":"Nummer","nop_inst":"Geben Sie Ihre Nummer wie gewohnt ein. Fügen Sie nicht Ihre Landesvorwahl hinzu","nopMobile":"Handynummer","statusactive":"Aktiv","statuspending":"Aktivierung ausstehend","globalsearch":"Suchen Sie andere Benutzer","permissiondenied":"Sie können diesen Benutzer nicht löschen / deaktivieren. Benutzer, der anderen Gruppen zugewiesen ist. Sie können stattdessen die Zuweisung des Benutzers aufheben","activestatus":"AKTIV","provisionedstatus":"VORGESEHEN","deprovisionedstatus":"DEPROVISIERT","save":"Speichern","admingroup":"Admin-Gruppe","application":"Anwendung","selectadmingroup":"Wählen Sie die Administratorgruppe aus","selectapp":"Anwendung auswählen","adminConfigIncomplete":"Zeile unvollständig. Weisen Sie bitte eine Administratorgruppe zu, um die Zeile zu speichern oder zu entfernen","adminconfigdeletesuccess":"Erfolgreich gelöscht","adminconfigupdatesuccess":"Konfiguration erfolgreich aktualisiert","wanttodeleteadminconfig":"Möchten Sie diese Konfiguration löschen?","cannotdeleteconfig":"Diese Konfiguration kann nicht gelöscht werden","nonanoktauser":"Diese Aktion darf nicht ausgeführt werden. Der Identitätsanbieter dieses Benutzers ist nicht Okta.","reactivate":"Erneut einladen","wanttoreactivate":"Möchten Sie den Aktivierungslink erneut an den Benutzer senden?","iread1":"Ich bin damit einverstanden, dass die Cargill-Kundenportale, -Anwendungen und -Dienste, die über sie verfügbar sind, dem Cargill-Kundenportal unterliegen","iread2":"Geschäftsbedingungen","iread3":", die durch spezifische Geschäftsbedingungen für die jeweilige Unternehmensdienstleistung ergänzt oder geändert werden können.","iagree1":"Ich erkenne an und akzeptiere, dass die Verarbeitung personenbezogener Daten durch Cargill in Verbindung mit Cargill-Kundenportalen, -Anwendungen und -Diensten Cargills unterliegt","iagree2":"Online-Datenschutzrichtlinie","iagree3":", der für jeden zutreffenden Unternehmensdienst durch 'Datenschutzhinweise' ergänzt oder geändert werden kann.","privacypolicy_link":"https://www.cargill.com/page/privacy","termsandconditions_link":"https://www.cargill.com/portal-terms","resetreactivate":"Zurücksetzen / Reaktivieren","emailinvaliddomain":"Benutzer mit dieser Domain können nicht hinzugefügt werden","administeredgroups":"Verwaltete Gruppen","selectgroupslist":"Gruppen wählen","alreadyactive":"Sie sind ein aktiver Benutzer!","alreadyactivesetup":"Ihr Profil erfordert keine Registrierung. Verwenden Sie das Cargill-Mitarbeiter-Login, um sich bei Ihren Anwendungen anzumelden.","selectBrand":"Marke auswählen","permissiondeniedreset":"Sie können das Kennwort für diesen Benutzer nicht zurücksetzen. ","unlockaccount":"Konto entsperren","unlockaccountsuccess":"Ihr Konto wurde erfolgreich entsperrt","accountunlocked":"Konto freigeschaltet!","copyrefid":"Kopieren Sie die Referenz-ID unten in die E-Mail, die Sie erhalten haben, und fügen Sie sie unten ein, um fortzufahren.","securityquestionanswerweak":"Die Antwort auf die Sicherheitsfrage ist zu schwach. Die Antwort darf nicht Teil der Frage sein","securityanswermatchesquestion":"Sicherheitsantwort ungültig: Die Antwort darf kein $ enthalten, das Teil der Sicherheitsfrage ist","copysecurityanswermatchesquestion":"Sicherheitsantwort ungültig: Die Antwort darf kein $ enthalten, das Teil der Sicherheitsfrage ist","tokenInvalidShortMessage":"Ihr Aktivierungslink ist nicht mehr gültig.","browserspecificmsg":"Bitte erwägen Sie die Verwendung des Google Chrome-Browsers","enterActivationDetails":"Die unten angeforderten Informationen finden Sie in Ihrer Aktivierungs-E-Mail.","resendActivation":"Aktivierungs-E-Mail erneut senden","reinvite":"Einladung erneut senden","reinviteEmailMessage":"Wenn die von Ihnen angegebenen Informationen korrekt sind, erhalten Sie eine neue Aktivierungs-E-Mail.","reinviteContactAdminMessage":"Wenden Sie sich bitte an Ihren geschäftlichen Cargill-Ansprechpartner, falls Sie keine neue Aktivierungs-E-Mail erhalten haben.","activationOk":"Ok","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","disableExistingUserOnboard":"Disable Existing User","selfRegSubGrps":"Self registration additional group:","selectReggroup":"Select Registration group","selfRegister":"Melden Sie sich an","selfRegFormTitle":"Registrieren Sie sich","E0001":"Es tut uns leid, es gab ein Problem bei der Einrichtung Ihres Kontos. Bitte","E0001_1":" kontaktieren Sie uns, ","E0001_2":"wenn Sie Hilfe bei der Einrichtung Ihres Kontos brauchen.","E0002":" for assistance with setting up your account.","E0003":"Ihr Konto wurde erfolgreich registriert. Es wurde eine E-Mail an ","E0003_1":" mit Anweisungen zur Aktivierung Ihres Kontos gesendet.","E0004":"Ihr Konto wurde erfolgreich registriert. Sie können sich nun mit Ihrem vorhandenen Passwort in die App einloggen. Wenn Sie sich nicht mehr an Ihr Passwort erinnern, verwenden Sie bitte die Option “Passwort vergessen“ auf der App, um Ihr Passwort zurückzusetzen.","E0005":"User already exists with status ","E0005_1":" Please contact ","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"Kennwortanforderungen wurden nicht erfüllt. Passwortanforderungen: mindestens 8 Zeichen, ein Kleinbuchstabe, ein Großbuchstabe, eine Zahl, keine Teile Ihres Benutzernamens. Ihr Passwort darf nicht eines Ihrer letzten 24 Passwörter sein.","acceptTerms":"Bitte akzeptieren Sie unsere Datenschutzrichtlinie und unsere Allgemeinen Geschäftsbedingungen, um fortzufahren.","phoneVerificationNotCompleted":"Bitte bestätigen/entfernen Sie Ihre Telefonnummer, um fortzufahren.","verifyPhoneWarning":"PBitte klicken Sie auf „Code senden“, um Ihre Telefonnummer zu bestätigen","viewMoreInfo":"Weitere Informationen anzeigen","infoContent":"Weitere Informationen über den Benutzer anzeigen","createdDate":"Erstellungsdatum","activatedDate":"Aktivierungsdatum","lastLoginDate":"Letzter Log-in","lastUpdatedDate":"Datum der letzten Aktualisierung","passwordChangedDate":"Datum der Kennwortänderung","statusChangedDate":"Datum der Statusänderung","createdDateDescription":"Datum und Uhrzeit der Erstellung des Benutzerdatensatzes in Okta.","activatedDateDescription":"Datum und Uhrzeit des Versands der letzten Benutzeraktivierungs-E-Mail.","statusChangedDateDescription":"Datum und Uhrzeit der letzten Änderung des Benutzerstatus in Okta.","lastLoginDateDescription":"Datum und Uhrzeit der letzten Anmeldung des Benutzers bei Okta (nicht anwendungsspezifisch).","lastUpdatedDateDescription":"Datum und Uhrzeit der letzten Aktualisierung des Benutzerdatensatzes in Okta.","passwordChangedDateDescription":"Datum und Uhrzeit, wann der Benutzer sein Passwort zuletzt geändert hat.","resetMFATitle":"Multifaktor-Authentifizierung zurücksetzen","noFactorExist":"Für diesen Benutzer ist kein Faktor vorhanden.","mfaValidation":"Bitte wählen Sie einen Faktor zum Zurücksetzen aus.","resetButton":"Zurücksetzen","mfaResetModalTitle":"MFA-Reset","factorResetSuccess":"Faktor wurde erfolgreich zurückgesetzt.","resetConfirmation":"Möchten Sie MFA für diesen Benutzer wirklich zurücksetzen?","copyrights":"Cargill, Eingetragen. Alle Rechte vorbehalten.","reportLabel":"Bericht","bulkUploadLabel":"Massen-Upload von Benutzern","availableIndependentGroups":"Verfügbare unabhängige Gruppen:","selectedBrand":"Ausgewählte Marke:","bulkUploadOptionsLabel":"Massen-Upload-Optionen","bulkCreateUsers":"Massenerstellung von Benutzern","bulkReinviteUsers":"Mehrere Benutzer erneut einladen","confirm":"Bestätigen","downloadExcelTemplate":"Excel-Vorlage herunterladen:","uploadInstruction":"Nachdem Sie die Vorlage heruntergeladen haben, füllen Sie die Excel-Tabelle aus und laden Sie sie mithilfe des Abschnitts unten hoch","uploadWarningOne":"Es sind maximal nur 50 Benutzer gleichzeitig zulässig.","uploadWarningTwo":"Stellen Sie sicher, dass das E-Mail-Feld nicht leer bleibt.","uploadWarningThree":"Stellen Sie sicher, dass die angegebenen E-Mail-IDs von Ihnen verwaltet werden.","uploadWarningFour":"Stellen Sie sicher, dass keine Felder leer bleiben.","uploadWarningFive":"Stellen Sie sicher, dass alle Feldwerte gültig sind.","uploadWarningSix":"Stellen Sie sicher, dass die angegebenen Gruppen-IDs von Ihnen verwaltet werden.","uploadNote":"Einladungen, die über diesen Prozess gesendet werden, folgen der standardmäßigen Einladungs-E-Mail für ein Cargill-Konto.","uploadLabel":"Hochladen","action":"Aktionen","userword":"Benutzer","note":"Notiz:","authentication":"Authentifizierung","noTableData":"Keine Daten für die Tabelle.","readOnlyGroup":"Dies ist eine schreibgeschützte Gruppe. Die Zuweisung für diese Gruppe sollte nur über access.cargill.com erfolgen","adminPermissionDenied":"Ihre Benutzeradministratorrechte verfügen nicht über die Berechtigung, diese Gruppenzuweisung zu ändern.","msgForGenericErrorUA":"Derzeit haben wir ein Problem mit der Bearbeitung Ihrer Anfrage. Bitte versuchen Sie es später noch einmal. Wenn dieser Fehler weiterhin auftritt, wenden Sie sich für weitere Unterstützung an Ihren Kundendienstmitarbeiter.","passcodeRateLimit":"Ihre Anfrage konnte nicht verarbeitet werden. Bitte versuchen Sie es in 5 Minuten erneut.","passcodeNotEntered":"Bitte geben Sie den Passcode zur Bestätigung ein.","msgForUnhandledResponse":"Die Anfrage konnte nicht bearbeitet werden. Bitte wenden Sie sich an Ihren Kundendienstmitarbeiter.","groupUnavailable":"Die Gruppe ist in Okta nicht mehr verfügbar. Möglicherweise wurde die Gruppe gelöscht.","groupCannotBeAssigned":"Die Gruppe $ ist in Okta nicht mehr verfügbar und kann daher dem Benutzer nicht zugewiesen werden. Bitte entfernen Sie die Gruppe und fahren Sie fort.","copyGroupCannotBeAssigned":"Die Gruppe $ ist in Okta nicht mehr verfügbar und kann daher dem Benutzer nicht zugewiesen werden. Bitte entfernen Sie die Gruppe und fahren Sie fort."}

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports = {"1":"United States","7":"Russian Federation","20":"Egypt","27":"South Africa","30":"Greece","31":"Netherlands","32":"Belgium","33":"France","34":"Spain","36":"Hungary","39":"Italy","40":"Romania","41":"Switzerland","43":"Austria","44":"United Kingdom","45":"Denmark","46":"Sweden","47":"Svalbard and Jan Mayen","48":"Poland","49":"Germany","51":"Peru","52":"Mexico","53":"Cuba","54":"Argentina","55":"Brazil","56":"Chile","57":"Colombia","58":"Venezuela, Bolivarian Republic of","60":"Malaysia","61":"Christmas Island","62":"Indonesia","63":"Philippines","64":"New Zealand","65":"Singapore","66":"Thailand","81":"Japan","82":"Korea, Republic of","84":"Vietnam","86":"China","90":"Turkey","91":"India","92":"Pakistan","93":"Afghanistan","94":"Sri Lanka","95":"Myanmar","98":"Iran, Islamic Republic of","211":"Southern Sudan","212":"Western Sahara","213":"Algeria","216":"Tunisia","218":"Libya","220":"Gambia","221":"Senegal","222":"Mauritania","223":"Mali","224":"Guinea","225":"Ivory Coast","226":"Burkina Faso","227":"Niger","228":"Togo","229":"Benin","230":"Mauritius","231":"Liberia","232":"Sierra Leone","233":"Ghana","234":"Nigeria","235":"Chad","236":"Central African Republic","237":"Cameroon","238":"Cape Verde","239":"Sao Tome and Principe","240":"Equatorial Guinea","241":"Gabon","242":"Congo","243":"Congo, Democratic Republic of the","244":"Angola","245":"Guinea Bissau","246":"British Indian Ocean Territory","248":"Seychelles","249":"Sudan","250":"Rwanda","251":"Ethiopia","252":"Somalia","253":"Djibouti","254":"Kenya","255":"Tanzania, United Republic of","256":"Uganda","257":"Burundi","258":"Mozambique","260":"Zambia","261":"Madagascar","262":"Reunion","263":"Zimbabwe","264":"Namibia","265":"Malawi","266":"Lesotho","267":"Botswana","268":"Swaziland","269":"Comoros","290":"Saint Helena, Ascension and Tristan da Cunha","291":"Eritrea","297":"Aruba","298":"Faroe Islands","299":"Greenland","350":"Gibraltar","351":"Portugal","352":"Luxembourg","353":"Ireland","354":"Iceland","355":"Albania","356":"Malta","357":"Cyprus","358":"Finland","359":"Bulgaria","370":"Lithuania","371":"Latvia","372":"Estonia","373":"Moldavia","374":"Armenia","375":"Belarus","376":"Andorra","377":"Monaco","378":"San Marino","379":"Holy See (Vatican City State)","380":"Ukraine","381":"Serbia","382":"Montenegro","383":"Kosovo","385":"Croatia","386":"Slovenia","387":"Bosnia and Herzegovina","389":"Macedonia","420":"Czech republic","421":"Slovakia","423":"Liechtenstein","500":"South Georgia and the South Sandwich Islands","501":"Belize","502":"Guatemala","503":"El Salvador","504":"Honduras","505":"Nicaragua","506":"Costa Rica","507":"Panama","508":"Saint Pierre and Miquelon","509":"Haiti","590":"Guadeloupe","591":"Bolivia","592":"Guyana","593":"Ecuador","595":"Paraguay","596":"Martinique","597":"Suriname","598":"Uruguay","599":"Netherlands Antilles","670":"Timor-Leste","672":"Norfolk Island","673":"Brunei Darussalam","674":"Nauru","675":"Papua New Guinea","676":"Tonga","677":"Solomon Islands","678":"Vanuatu","679":"Fiji","680":"Palau","681":"Wallis and Futuna","682":"Cook Islands","683":"Niue","685":"Samoa","686":"Kiribati","687":"New Caledonia","688":"Tuvalu","689":"French Polynesian","690":"Tokelau","691":"Micronesia","692":"Marshall Islands","850":"Korea, Democratic People's Republic of","852":"Hong Kong","853":"Macao","855":"Cambodia","856":"Lao People's Democratic Republic","880":"Bangladesh","886":"Taiwan","960":"Maldives","961":"Lebanon","962":"Jordan","963":"Syrian Arab Republic","964":"Iraq","965":"Kuwait","966":"Saudi Arabia","967":"Yemen","968":"Oman","970":"Palestine","971":"United Arab Emirates","972":"Israel","973":"Bahrain","974":"Qatar","975":"Bhutan","976":"Mongolia","977":"Nepal","992":"Tajikistan","993":"Turkmenistan","994":"Azerbaijan","995":"Georgia","996":"Kyrgyzstan","998":"Uzbekistan","1242":"Bahamas","1246":"Barbados","1264":"Anguilla","1268":"Antigua and Barbuda","1284":"Virgin Islands, British","1340":"Virgin Islands, US","1345":"Cayman Islands","1441":"Bermuda","1473":"Grenada","1649":"Turks and Caicos Islands","1664":"Montserrat","1670":"Northern Mariana Islands","1671":"Guam","1684":"American Samoa","1758":"Saint Lucia","1767":"Dominica","1784":"Saint Vincent and the Grenadines","1787":"Puerto Rico","1809":"Dominican Republic","1868":"Trinidad and Tobago","1869":"Saint Kitts and Nevis","1876":"Jamaica","441481":"Guernsey","441534":"Jersey","registration":"Registration","hello":"Hello ","welcome_cargill":"Welcome to ","user_reg":"User Registration","enter_new_pwd":"Enter new password","pwd_rule":"Your password must have atleast 8 characters, a lowercase letter, an uppercase letter, a number, no parts of your username.","repeat_pwd":"Repeat new password ","choose_forgot_pwd_qtn":"Choose a forgot password question","stock_qtn":"Stock questions","disliked_food":"What is the food you least liked as a child?","name_of_first_plush_toy":"What is the name of your first stuffed animal?","first_award":"What did you earn your first medal or award for?","favorite_security_question":"What is your favorite security question?","favorite_toy":"What is the toy/stuffed animal you liked the most as a kid?","first_computer_game":"What was the first computer game you played?","favorite_movie_quote":"What is your favorite movie quote?","first_sports_team_mascot":"What was the mascot of the first sports team you played on?","first_music_purchase":"What music album or song did you first purchase?","favorite_art_piece":"What is your favorite piece of art?","grandmother_favorite_desert":"What was your grandmother's favorite dessert?","first_thing_cooked":"What was the first thing you learned to cook?","childhood_dream_job":"What was your dream job as a child?","place_where_significant_other_was_met":"Where did you meet your spouse/significant other?","favorite_vacation_location":"Where did you go for your favorite vacation?","new_years_two_thousand":"Where were you on New Year's Eve in the year 2000?","favorite_speaker_actor":"Who is your favorite speaker/orator?","favorite_book_movie_character":"Who is your favorite book/movie character?","favorite_sports_player":"Who is your favorite sports player?","custom_qtn":"Custom question","own_sec_qtn":"Create your own security question","answer":"Answer","phone_inst":"Optional. Enter an account recovery phone number. This phone number entry will only be used for sending text message verification codes.","optional":"(Optional)","sms_inst":"Okta can send you a text message with a recovery code. This feature is useful when you don't have access to your email.","add_ph_no":"+ Add Phone Number","create_acc":"Create My Account","forgot_pwd_header":"Forgot Password Text Message","enter_phone_no":"Enter the phone number you'll use to receive codes via text message, then click Send Code to verify that it works.","country":"Country","country_inst":"Select the country where your phone is registered.","back":"Re-Send","phone_number":"Phone number","phone_number_inst":"Enter your number the way you normally dial it. Do not add your country code","code_prefix":"country code prefix.","send_code":"Send Code","done":"Done","verify":"Verify","enter_code":"Enter Code","enter_code_rule":"Check your phone for the passcode and enter it below. Your message should arrive in less than a minute.","verify_success":"Phone number successfully verified!","click":"Click","finish_setup":" to finish setup.","error_review":"Please review the form to correct the following errors:","phone_no_not_found":"The text message cannot be sent because no phone number was found in the database.","noLowerCase":"Should contain atleast one lowercase letter","noUpperCase":"Should contain atleast one uppercase letter","noNumber":"Should contain atleast one number","noSpecialCharacter":"Should contain atleast one special character","notMinLength":"Should contain atleast $ characters","noUsernameSubstring":"Should not contain part of username","noFirstnameSubstring":"Should not contain part of your firstname","noLastnameSubstring":"Should not contain part of your lastname","tokenNotValid":"Your activation token is no longer valid","tokenInvalidInfo":"This can happen if you clicked your activation link after creating your account, your activation link expired, or the URL is incorrect","reqNewToken":"Request a new token","passcodeNotValid":"Your passcode doesn't match our records. Please try again.","OTPEnableAfter30Sec":"An SMS message was recently sent. Please wait 30 seconds before trying again.","phoneNoAlreadySet":"The phone number has already been verified by this user.","emptypassword":"Password cannot be empty","passwordlength":"Password cannot be empty","passwordnotvalid":"Password is not valid","passwordnotmatching":"Passwords should match","answerlength":"Answer should be atleast $ characters long","phonenumbermissing":"Verify the passcode you received to proceed.","customQuestionEmpty":"Custom question cannot be empty","customQAsame":"Custom question and answer cannot be same","passwordSameasPrev":"Password cannot be your current password","answerWrong":"The recovery question answer did not match our records","phonealreadyactive":"This number has already been verified, if you want to update try another number","first_name":"First name","last_name":"Last name","enter_email":"Email Id","emailNotValid":"Email ID not valid","registeredapps":"Registered Apps","waitingapps":"Apps waiting for approval","requestaccess":"Request Access","admin":"Admin","selectLang":"Select language","dashboardLabel":"Dashboard","resetpwd":"Reset Password","ansForgotten":"Answer forgotten password challenge","resetOktaPwd":"Reset your password","newpwd":"New Password","rptpwd":"Repeat Password","adminLabel":"User Management","userAdministration":"User Management","adduser":"Add New User","function":"Function","emailAddress":"Email address","filterApp":"Filter Application","create":"create","logoutConfirm":"Are you sure you want to log out?","no":"No","yes":"Yes","logout":"Logout","expireWarning":"Your session will expire in % minutes, press OK to remain logged in or press Cancel to log out. If you are disconnected, any changes will be lost","update":"Update","activateDeactivate":"Activate/Deactivate","attention":"Attention","cancel":"Cancel","sessionTimedout":"Your session has expired. Please login again","username":"Username","primary_mail":"Primary email","secondary_mail":"Secondary email (optional)","groups":"Groups","must_email":"Must be an email","ieNotSupported":"IE is not supported","tryChrome":"Internet Explorer is not supported. We recommend using Chrome for this app.","close":"Close","forgotSQA":"forgot security answer?","resetSecQA":"Reset Security Question and Password","retry":"Go Back","nofactorpresent":"This option cannot be used because mobile number not set. Please contact your administrator.","emptypasscode":"Code cannot be empty","provisioned":"This user is not yet registered. Password can only be reset after the user is active","deprovisioned":"This user is deactivated. Password can only be reset after the user is active","resetsuccesspopupmsg":"Password reset link has been sent to email address. Please close the popup using the X button.","wanttoreset":"Do you want to reset the password?","wanttoactivate":"Do you want to activate the user?","wanttodeactivate":"Do you want to deactivate the user?","wanttodelete":"Do you want to delete the user?","updateprofile":"Update Profile","updatesuccess":"User has been updated successfully","usercreated":"*User Created","errorcreatinguser":"*Error Creating User/ email already exists","privacypolicy":"Privacy policy","termsandconditions":"Terms and conditions","uname-email":"Username/Email","password_placeholder":"Password","sign-in":"Log In","resetmailsent":"An Email has been sent to % with the reset password link.","smssent":"sent","resendcode":"Re-send code","needhelp":"Need help signing in?","forgotPassword":"Forgot password?","helplink":"Help","smsusage":"SMS can only be used if a mobile phone number has been configured.","backtosignin":"Back to Sign In","resetviasms":"Reset via SMS","resetviaemail":"Reset via Email","didntreceivecode":"Didn't receive a code? reset via Email","emailsent":"Email sent!","recoverycredentialsnotset":"Forgot password not allowed since recovery credentials not set for the user","usernotpresent":"User not present","mobilenumbernotset":"Mobile number not set","invalidcreds":"Invalid username or password","emailreq":"Email required","emailinvalid":"Email invalid","pwdreq":"Password required","otplength":"OTP should be 6 characters long","passcodeinvalid":"Invalid OTP","firstnamereq":"First name required","lastnamereq":"Last name required","notallowedincurrentstate":"This operation is not allowed in the current authentication state","nopartsofusername":"Password cannot contain parts of your username, include your first name or your last name","passwordusedrecently":"Password has been used too recently","passwordnotmetrequirements":"The password does not meet the complexity requirements of the current password policy","antar":"Antarctica","aus":"Australia","can":"Canada","falk":"Falkland Islands (Malvinas)","kazak":"Kazakhstan","mayotte":"Mayotte","morocco":"Morocco","norway":"Norway","pitcairn":"Pitcairn","filteruser":"Filter users by App:","selectgroups":"Select Application","status":"Status","atleastonegroup":"Select atleast one group to assign user to","answerchallenge":"Answer forgotton password challenge","entersmscode":"Enter verification code sent via SMS","enterusercreds":"Enter User Details","inviteuser":"Invite New User","assignApplication":"Assign to Application","availablegroups":"Available Groups","selectedgroups":"Assigned Groups","emailsenttouser":"Email successfully sent to ","pendingactivation":"Pending account activation","exit":"Exit","myprofile":"My Profile","activatesuccess":"User has been successfully activated and an activation mail has been sent to","deactivatesuccess":" has been successfully deactivated","deletesuccess":" has been successfully deleted","edituser":"Edit User","getstarted":"Get Started","congrats":"Congratulations!","accountsetup":"You have successfully completed your account setup.","edit":"Edit","assignedapps":"Assigned Applications","assignedgroups":"Assigned Groups","oldpwd":"Enter old password","changepwd":"Change password","updatephone":"Update phone","pwdupdated":"Password has been updated successfully","QAupdated":"Security Question Answer has been updated successfully","phonenumberinvalid":"Phone number is invalid","phoneupdated":"Phone number updated successfully","showmore":"Show More","verifypassword":"Verify Password","filterusergrp":"Filter users by group:","allactiveusers":"All active users","viewuser":"View user","partofokta":"This user is part of Okta organization","userdeactive":"User is deactive","showing":"Showing","of":"of","answerpartofquestion":"Answer must not be part of the question","activationpending":"Your factor is pending activation, Kindly update your phone number otherwise the reset SMSs will be sent to your previous active number","change_forgot_pwd_qtn":"Change security question:","basicinfo":"Basic information","gotoapp":"Please click below to access your application.","passwordresetsuccess":"Your password has been reset successfully","passwordreset":"Password Reset!","searchinfotext":"*Search is done only on app","tmlabel":"Configuration","delete":"Delete","search":"Search","nop":"Number","nop_inst":"Please do not add country code and no dashes.  Please enter only the mobile #","nopMobile":"Mobile Number","statusactive":"Active","statuspending":"Pending activation","globalsearch":"Search other users","permissiondenied":"You cannot delete/deactivate this user. user assigned to other groups. You can unassign the user instead","activestatus":"ACTIVE","provisionedstatus":"PROVISIONED","deprovisionedstatus":"DEPROVISIONED","save":"Save","admingroup":"Admin group","application":"Application","selectadmingroup":"Select admin group","selectapp":"Select application","adminConfigIncomplete":"Row incomplete. Kindly assign a admin group, brand and administered groups to save or remove row","adminconfigdeletesuccess":"Deleted Successfully","adminconfigupdatesuccess":"Config successfully updated","wanttodeleteadminconfig":"Do you want to delete this config?","cannotdeleteconfig":"This config cannot be deleted","nonanoktauser":"Not allowed to do this action. This user's identity provider is not Okta.","reactivate":"Resend Invite","wanttoreactivate":"Do you want to resend activation link to the user?","iread1":"I agree that the Cargill customer portals, applications and services available through them are subject to Cargill’s Customer Portal","iread2":"Terms and Conditions","iread3":", which may be supplemented or amended by specific terms and conditions for each applicable business service.","iagree1":"I acknowledge and accept that Cargill’s processing of personal data in connection with Cargill customer portals, applications and services are subject to Cargill’s ","iagree2":"Online Privacy Policy","iagree3":", which may be supplemented or amended by 'Privacy Notices' for each applicable business service.","privacypolicy_link":"https://www.cargill.com/page/privacy","termsandconditions_link":"https://www.cargill.com/portal-terms","resetreactivate":"Reset/Reactivate","emailinvaliddomain":"User with this domain cannot be added","administeredgroups":"Administered Groups","selectgroupslist":"Select Groups","alreadyactive":"You are an active user!","alreadyactivesetup":"Your profile doesn't require registration. Use Cargill employee login to signin to your applications.","selectBrand":"Select Brand","permissiondeniedreset":"You cannot reset password for this user.","unlockaccount":"Unlock Account","unlockaccountsuccess":"Your account has been unlocked successfully","accountunlocked":"Account Unlocked!","copyrefid":"Please copy the reference Id from the bottom of the email you received and paste it below to proceed.","securityquestionanswerweak":"The security question answer is too weak, answer must not be part of the question","securityanswermatchesquestion":"Security answer invalid: Answer must not contain $ which is part of the security question","copysecurityanswermatchesquestion":"Security answer invalid: Answer must not contain $ which is part of the security question","tokenInvalidShortMessage":"Your activation link is no longer valid.","browserspecificmsg":"Please consider using Google Chrome browser.","enterActivationDetails":"For the information requested below, please consult your activation email.","resendActivation":"Resend Activation Mail","reinvite":"Resend Invite","reinviteEmailMessage":"If the information you have provided is correct then you will receive a new activation email.","reinviteContactAdminMessage":"Please reach out to your Cargill business contact if you do not receive the new activation email.","activationOk":"Ok","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","disableExistingUserOnboard":"Disable Existing User","selfRegSubGrps":"Self registration additional group:","selectReggroup":"Select Registration group","selfRegister":"Register","selfRegFormTitle":"Sign-up","E0001":"Sorry, there was a problem setting up your account. Please","E0001_1":" contact us ","E0001_2":"for help setting up your account.","E0002":" for help setting up your account.","E0003":"Your account has been successfully registered. An email has been sent to ","E0003_1":" with instructions for activating your account.","E0004":"Your account has been successfully registered. You may now login to the application using your existing password. If you do not remember your password, please use the “Forgot Password“ option on the application to reset your password.","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"Password requirements were not met. Password requirements: at least 8 characters, a lowercase letter, an uppercase letter, a number, no parts of your username. Your password cannot be any of your last 24 passwords.","acceptTerms":"Please accept our Privacy Policy and Terms & Conditions to proceed.","phoneVerificationNotCompleted":"Please verify / remove your phone number to proceed.","verifyPhoneWarning":"Please click on 'Send Code' to verify your phone number","viewMoreInfo":"View more Info","infoContent":"View more info about the User","createdDate":"Created Date","activatedDate":"Activated Date","lastLoginDate":"Last Login Date","lastUpdatedDate":"Last Updated Date","passwordChangedDate":"Password Changed Date","statusChangedDate":"Status Changed Date","createdDateDescription":"Date and time when user record was created in Okta.","activatedDateDescription":"Date and time when the last user activation email was sent.","statusChangedDateDescription":"Date and time when user status was last changed in Okta.","lastLoginDateDescription":"Date and time when user last logged into Okta (not application specific).","lastUpdatedDateDescription":"Date and time when user record was last updated in Okta.","passwordChangedDateDescription":"Date and time when user last changed their password.","resetMFATitle":"Reset Multifactor Authentication","noFactorExist":"No factor exists for this user.","mfaValidation":"Please select a factor to reset.","resetButton":"Reset","mfaResetModalTitle":"MFA Reset","factorResetSuccess":"Factor was reset successfully.","resetConfirmation":"Are you sure you want to reset MFA for this user?","copyrights":"Cargill, Incorporated. All Rights Reserved.","reportLabel":"Report","bulkUploadLabel":"Bulk Upload Users","availableIndependentGroups":"Available independent groups:","selectedBrand":"Selected Brand:","bulkUploadOptionsLabel":"Bulk Upload Options","bulkCreateUsers":"Bulk Create Users","bulkReinviteUsers":"Bulk Re-Invite Users","confirm":"Confirm","downloadExcelTemplate":"Download Excel Template:","uploadInstruction":"After downloading the template, fill up the excel sheet and upload using the section below","uploadWarningOne":"Maximum of only 50 users allowed at a time","uploadWarningTwo":"Ensure the email field is not left empty","uploadWarningThree":"Ensure the email ids provided are administrated by you.","uploadWarningFour":"Ensure no fields left empty","uploadWarningFive":"Ensure all field values are valid","uploadWarningSix":"Ensure the group ids provided are administrated by you.","uploadNote":"Invites sent through this process follow the standard Cargill account invite email.","uploadLabel":"Upload","action":"Actions","userword":"users","note":"Note:","authentication":"Authentication","noTableData":"No data for table.","readOnlyGroup":"This is a read-only group. Assignement for this group should be made only via access.cargill.com","adminPermissionDenied":"Your User Admin rights do not have permissions to modify this group assignment.","msgForGenericErrorUA":"Currently we are facing an issue with processing your request. Please try again later. If you continue to see this error, contact your customer service representative for further assistance.","passcodeRateLimit":"Unable to process your request, please try again in 5 minutes.","passcodeNotEntered":"Please enter the passcode to verify.","msgForUnhandledResponse":"Unable to process the request, please contact your customer service representative.","groupUnavailable":"The group is no longer available in Okta. The group may have been deleted.","groupCannotBeAssigned":"The group $ is no longer available in Okta and hence cannot be assigned to the user. Please remove the group and proceed.","copyGroupCannotBeAssigned":"The group $ is no longer available in Okta and hence cannot be assigned to the user. Please remove the group and proceed."}

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports = {"1":"États Unis","7":"Fédération Russe","20":"Egypte","27":"Afrique du Sud","30":"Grèce","31":"Pays-Bas","32":"Belgique","33":"France","34":"Espagne","36":"Hongrie","39":"Italie","40":"Roumanie","41":"Suisse","43":"L'Autriche","44":"Royaume-Uni","45":"Danemark","46":"Suède","47":"Svalbard et Jan Mayen","48":"Pologne","49":"Allemagne","51":"Pérou","52":"Mexique","53":"Cuba","54":"Argentine","55":"Brésil","56":"Chili","57":"Colombie","58":"Venezuela, République bolivarienne du","60":"Malaisie","61":"L'île de noël","62":"Indonésie","63":"Philippines","64":"Nouvelle-Zélande","65":"Singapour","66":"Thaïlande","81":"Japon","82":"Corée, République de","84":"Vietnam","86":"Chine","90":"dinde","91":"Inde","92":"Pakistan","93":"Afghanistan","94":"Sri Lanka","95":"Myanmar","98":"Iran (République islamique d","211":"Sud Soudan","212":"Sahara occidental","213":"Algérie","216":"Tunisie","218":"Libye","220":"Gambie","221":"Sénégal","222":"Mauritanie","223":"Mali","224":"Guinée","225":"Côte d'Ivoire","226":"Burkina Faso","227":"Niger","228":"Aller","229":"Bénin","230":"Maurice","231":"Libéria","232":"Sierra Leone","233":"Ghana","234":"Nigeria","235":"Tchad","236":"République centrafricaine","237":"Cameroun","238":"Cap-Vert","239":"Sao Tomé et Principe","240":"Guinée Équatoriale","241":"Gabon","242":"Congo","243":"Congo, République Démocratique du","244":"Angola","245":"Guinée Bissau","246":"Territoire britannique de l'océan Indien","248":"les Seychelles","249":"Soudan","250":"Rwanda","251":"Ethiopie","252":"Somalie","253":"Djibouti","254":"Kenya","255":"Tanzanie, République Unie de","256":"Ouganda","257":"Burundi","258":"Mozambique","260":"Zambie","261":"Madagascar","262":"Réunion","263":"Zimbabwe","264":"Namibie","265":"Malawi","266":"Lesotho","267":"Botswana","268":"Swaziland","269":"Les Comores","290":"Sainte Hélène, Ascension et Tristan da Cunha","291":"Erythrée","297":"Aruba","298":"Îles Féroé","299":"Groenland","350":"Gibraltar","351":"le Portugal","352":"Luxembourg","353":"Irlande","354":"Islande","355":"Albanie","356":"Malte","357":"Chypre","358":"Finlande","359":"Bulgarie","370":"Lituanie","371":"Lettonie","372":"Estonie","373":"Moldavie","374":"Arménie","375":"Biélorussie","376":"Andorre","377":"Monaco","378":"Saint Marin","379":"Saint-Siège (État de la cité du Vatican)","380":"Ukraine","381":"Serbie","382":"Monténégro","385":"Croatie","386":"La Slovénie","387":"Bosnie Herzégovine","389":"Macédoine","420":"République Tchèque","421":"Slovaquie","423":"Liechtenstein","500":"Géorgie du Sud et les îles Sandwich du Sud","501":"Belize","502":"Guatemala","503":"Le Salvador","504":"Honduras","505":"Nicaragua","506":"Costa Rica","507":"Panama","508":"Saint-Pierre-et-Miquelon","509":"Haïti","590":"Guadeloupe","591":"Bolivie","592":"Guyane","593":"Équateur","595":"Le Paraguay","596":"Martinique","597":"Suriname","598":"Uruguay","599":"Antilles néerlandaises","670":"Timor-Leste","672":"l'ile de Norfolk","673":"Brunei Darussalam","674":"Nauru","675":"Papouasie Nouvelle Guinée","676":"Tonga","677":"Les îles Salomon","678":"Vanuatu","679":"Fidji","680":"Palau","681":"Wallis et Futuna","682":"les Îles Cook","683":"Niue","685":"Samoa","686":"Kiribati","687":"Nouvelle Calédonie","688":"Tuvalu","689":"Polynésien Français","690":"Tokélaou","691":"Micronésie","692":"Iles Marshall","850":"République populaire démocratique de Corée","852":"Hong Kong","853":"Macao","855":"Cambodge","856":"République démocratique populaire lao","880":"Bangladesh","886":"Taïwan","960":"Maldives","961":"Liban","962":"Jordan","963":"République arabe syrienne","964":"Irak","965":"Koweit","966":"Arabie Saoudite","967":"Yémen","968":"Oman","970":"Palestine","971":"Emirats Arabes Unis","972":"Israël","973":"Bahrein","974":"Qatar","975":"Bhoutan","976":"Mongolie","977":"Népal","992":"Tadjikistan","993":"Turkménistan","994":"Azerbaïdjan","995":"Géorgie","996":"Kirghizistan","998":"Ouzbekistan","1242":"Bahamas","1246":"Barbade","1264":"Anguilla","1268":"Antigua-et-Barbuda","1284":"Îles vierges britanniques","1340":"Îles Vierges américaines","1345":"Îles Caïmans","1441":"Bermudes","1473":"Grenade","1649":"îles Turques-et-Caïques","1664":"Montserrat","1670":"Îles Mariannes du Nord","1671":"Guam","1684":"Samoa américaines","1758":"Sainte-Lucie","1767":"La Dominique","1784":"Saint-Vincent-et-les-Grenadines","1787":"Porto Rico","1809":"République Dominicaine","1868":"Trinité-et-Tobago","1869":"Saint-Christophe-et-Niévès","1876":"Jamaïque","441481":"Guernesey","441534":"Jersey","registration":"enregistrement","hello":"Bonjour","welcome_cargill":"Bienvenue chez","user_reg":"Enregistrement de l'utilisateur","enter_new_pwd":"Entrez un nouveau mot de passe","pwd_rule":"Votre mot de passe doit comporter au moins 8 caractères, une lettre minuscule, une lettre majuscule, un chiffre et aucune partie de votre nom d'utilisateur.","repeat_pwd":"Répétez le nouveau mot de passe","choose_forgot_pwd_qtn":"Sélectionnez une question de sécurité","stock_qtn":"Questions de sécurité","disliked_food":"Quel est le plat que vous avez le moins aimé en tant qu'enfant?","name_of_first_plush_toy":"Quel est le nom de votre premier animal en peluche?","first_award":"A quelle occasion avez-vous gagné votre première médaille ou récompense?","favorite_security_question":"Quelle est votre question de sécurité préférée?","favorite_toy":"Quel est le jouet / animal en peluche que tu aimes le plus en tant qu'enfant?","first_computer_game":"Quel a été le premier jeu d'ordinateur auquel tu as joué?","favorite_movie_quote":"Quelle est votre réplique de film préférée?","first_sports_team_mascot":"Quelle était la mascotte de votre premier club sportif?","first_music_purchase":"Quel album ou chanson avez-vous acheté en premier?","favorite_art_piece":"Quelle est votre œuvre d'art préférée?","grandmother_favorite_desert":"Quel était le dessert préféré de votre grand-mère?","first_thing_cooked":"Quelle est la première chose que vous avez appris à cuisiner?","childhood_dream_job":"Quel métier rêviez-vous de faire enfant?","place_where_significant_other_was_met":"Où avez-vous rencontré votre conjoint ?","favorite_vacation_location":"Quelle est votre destination de vacances préférée?","new_years_two_thousand":"Où étiez-vous le 31 décembre 2000?","favorite_speaker_actor":"Qui est votre orateur préféré?","favorite_book_movie_character":"Quel est votre personnage de livre / film préféré?","favorite_sports_player":"Qui est votre joueur de sport préféré?","custom_qtn":"Question personnalisée","own_sec_qtn":"Créez votre propre question de sécurité","answer":"Réponse","phone_inst":"Optionnel. Entrez un numéro de téléphone de récupération de compte Saisissez un numéro de téléphone de récupération de compte. Cette entrée de numéro de téléphone ne sera utilisée que pour envoyer des codes de vérification de message texte.","optional":"(Facultatif)","sms_inst":"Okta peut vous envoyer un message texte avec un code de récupération. Cette fonctionnalité est utile lorsque vous n'avez pas accès à votre courrier électronique.","add_ph_no":"Ajouter un numéro de téléphone","create_acc":"Créer mon compte","forgot_pwd_header":"SMS mot de passe oublié","enter_phone_no":"Entrez le numéro de téléphone que vous utiliserez pour recevoir les codes via un message texte, puis cliquez sur Envoyer le code pour vérifier que cela fonctionne.","country":"Pays","country_inst":"Sélectionnez le pays où votre téléphone est enregistré.","back":"Renvoyer","phone_number":"Numéro de téléphone","phone_number_inst":"Entrez votre numéro comme vous le composez normalement. N'ajoutez pas votre code pays","code_prefix":"préfixe de code de pays.","send_code":"Entrer le code","done":"Terminé","verify":"Vérifier","enter_code":"Entrez le code","enter_code_rule":"Récupérez le code d'authentification sur votre téléphone et entrez le ci-dessous.","verify_success":"Numéro de téléphone vérifié avec succès!","click":"Cliquez sur","finish_setup":"pour terminer la configuration.","error_review":"Veuillez réviser le formulaire pour corriger les erreurs ","phone_no_not_found":"Le SMS ne peut pas être envoyé car aucun numéro de téléphone n'a été trouvé dans la base de données.","noLowerCase":"Doit contenir au moins une lettre minuscule","noUpperCase":"Doit contenir au moins une lettre majuscule","noNumber":"Doit contenir au moins un chiffre","noSpecialCharacter":"Doit contenir au moins un caractère spécial","notMinLength":"Doit contenir au moins $ caractères","noUsernameSubstring":"Ne doit pas contenir une partie du nom d'utilisateur","noFirstnameSubstring":"Ne doit pas contenir une partie de votre prénom","noLastnameSubstring":"Ne doit pas contenir une partie de votre nom de famille","tokenNotValid":"Le code d'activation  n'est plus valide","tokenInvalidInfo":"Cela peut arriver si vous avez cliqué sur votre lien d'activation après avoir créé votre compte, que votre lien d'activation a expiré ou que l'URL est incorrecte.","reqNewToken":"Demander un nouveau code d'activation","passcodeNotValid":"Votre code d'accès ne correspond pas à nos enregistrements. Veuillez réessayer.","OTPEnableAfter30Sec":"Un SMS a été envoyé récemment. Veuillez patienter 30 secondes avant de réessayer.","phoneNoAlreadySet":"Le numéro de téléphone a déjà été vérifié par cet utilisateur.","emptypassword":"Le mot de passe ne peut pas être vide","passwordlength":"Le mot de passe ne peut pas être vide","passwordnotvalid":"Le mot de passe n'est pas valide","passwordnotmatching":"Les mots de passe doivent correspondre","answerlength":"La réponse doit contenir  au moins $ caractères ","phonenumbermissing":"Vérifiez le mot de passe que vous avez reçu pour continuer","customQuestionEmpty":"Une question personnalisée ne peut pas être vide","customQAsame":"La question personnalisée et la réponse ne peuvent pas être identiques","passwordSameasPrev":"Le nouveau mot de passe doit être différent de l'ancien","answerWrong":"La réponse à la question de récupération ne correspond pas à nos enregistrements","phonealreadyactive":"Ce numéro a déjà été vérifié, si vous voulez mettre à jour essayez un autre numéro","first_name":"Prénom","last_name":"Nom de famille","enter_email":"adresse mail ","emailNotValid":"adresse mail non valide","registeredapps":"Applications enregistrées","waitingapps":"Applications en attente d'approbation","requestaccess":"Demande d'accès","admin":"Admin","selectLang":"Choisir la langue","dashboardLabel":"Tableau de bord","resetpwd":"réinitialiser le mot de passe","ansForgotten":"Répondre à la question de sécurité","resetOktaPwd":"Réinitialiser votre mot de passe","newpwd":"nouveau mot de passe","rptpwd":"Répéter le mot de passe","adminLabel":"Gestion des utilisateurs","userAdministration":"Gestion des utilisateurs","adduser":"Ajouter un nouvel utilisateur","function":"fonction","emailAddress":"Adresse mail","filterApp":"Appliquer des filtre","create":"créer","logoutConfirm":"Êtes-vous sûr de vouloir vous déconnecter?","no":"Non","yes":"Oui","logout":"Se déconnecter","expireWarning":"Votre session expirera dans% minutes, appuyez sur OK pour rester connecté ou sur Annuler pour vous déconnecter. Si vous êtes déconnecté, tous les changements seront perdus","update":"Mise à jour","activateDeactivate":"Activer / Désactiver","attention":"Attention","cancel":"Annuler","sessionTimedout":"Votre session a expiré. Veuillez vous reconnecter","username":"Nom d'utilisateur","primary_mail":"Email principal","secondary_mail":"Email secondaire (facultatif)","groups":"Groupes","must_email":"Doit être un email","ieNotSupported":"Internet Explorer n'est pas supporté","tryChrome":"Internet Explorer n'est pas pris en charge. Nous vous recommandons d'utiliser Chrome pour cette application.","close":"Fermer","forgotSQA":"Vous avez oublié la réponse ?","resetSecQA":"Réinitialiser la question de sécurité et le mot de passe","retry":"Retourner","nofactorpresent":"Cette option ne peut pas être utilisée car le numéro de mobile n'est pas défini. Veuillez contacter votre administrateur.","emptypasscode":"Le code ne peut pas être vide","provisioned":"Cet utilisateur n'est pas encore enregistré. Le mot de passe ne peut être réinitialisé qu'une fois l'utilisateur actif","deprovisioned":"Cet utilisateur est désactivé. Le mot de passe ne peut être réinitialisé qu'une fois l'utilisateur actif","resetsuccesspopupmsg":"Le lien de réinitialisation du mot de passe a été envoyé à une adresse électronique. Veuillez fermer la fenêtre en utilisant le bouton X.","wanttoreset":"Voulez-vous réinitialiser le mot de passe?","wanttoactivate":"Voulez-vous activer l'utilisateur?","wanttodeactivate":"Voulez-vous désactiver l'utilisateur? ","wanttodelete":"Voulez-vous supprimer l'utilisateur?","updateprofile":"Mettre à jour le profil","updatesuccess":"L'utilisateur a été mis à jour avec succès","usercreated":"* Utilisateur créé","errorcreatinguser":"* Erreur de création utilisateur / email existe déjà","privacypolicy":"Politique de confidentialité","termsandconditions":"Conditions générales","uname-email":"Nom d'utilisateur / Email","password_placeholder":"Mot de passe","sign-in":"S'identifier","resetmailsent":"Un email a été envoyé à% avec le lien de réinitialisation du mot de passe.","smssent":"envoyé","resendcode":"Renvoyer le code","needhelp":"Besoin d'aide pour vous connecter?","forgotPassword":"Mot de passe oublié?","helplink":"Aide","smsusage":"La fonction SMS peut être utilisé  si un numéro de téléphone mobile a été configuré.","backtosignin":"Retour à l'identification","resetviasms":"Réinitialiser par SMS","resetviaemail":"Réinitialiser par e-mail","didntreceivecode":"Vous n'avez pas reçu de code? réinitialiser par e-mail","emailsent":"Email envoyé!","recoverycredentialsnotset":"fonction Mot de passe oublié non disponible si les informations d'identification sont incomplètes","mobilenumbernotset":"Numéro de téléphone non défini","invalidcreds":"Nom d'utilisateur ou mot de passe invalide","emailreq":"Email requis","emailinvalid":"Email invalide","pwdreq":"Mot de passe requis","otplength":"OTP doit comporter 6 caractères","passcodeinvalid":"OTP invalide","firstnamereq":"Prénom requis","lastnamereq":"Nom de famille requis","notallowedincurrentstate":"Cette opération n'est pas autorisée dans l'état actuel de l'authentification.","nopartsofusername":" Votre nom d'utilisateur, votre prénom ou votre nom de famille ne peuvent être inclus dans votre mot de passe","passwordusedrecently":"Le mot de passe a déjà été utilisé récemment","passwordnotmetrequirements":"Le mot de passe ne répond pas aux exigences de complexité de la politique de mot de passe actuelle","antar":"Antarctique","aus":"Australie","can":"Canada","falk":"Îles Falkland (Malvinas)","kazak":"Kazakhstan","mayotte":"Mayotte","morocco":"Maroc","norway":"Norvège","pitcairn":"Pitcairn","filteruser":"Filtrer par application","selectgroups":"Sélectionnez une application","status":"Statut","atleastonegroup":"Sélectionnez au moins un groupe auquel affecter l'utilisateur","answerchallenge":"Répondre à la question de sécurité","entersmscode":"Entrez le code de vérification envoyé par SMS","enterusercreds":"Entrer les détails de l'utilisateur","inviteuser":"Inviter un nouvel utilisateur","assignApplication":"Assigner à l'application","availablegroups":"Groupes disponibles","selectedgroups":"Groupes assignés","emailsenttouser":"Email envoyé avec succès à","pendingactivation":"En attente d'activation du compte","exit":"Sortie","myprofile":"Mon profil","activatesuccess":"L'utilisateur a été activé avec succès et un courrier d'activation a été envoyé à","deactivatesuccess":"a été désactivé avec succès","deletesuccess":"a été supprimé avec succès","edituser":"Modifier l'utilisateur","getstarted":"Commencer","congrats":"Toutes nos félicitations!","accountsetup":"Vous avez terminé avec succès la configuration de votre compte.","edit":"Modifier","assignedapps":"Applications assignées","assignedgroups":"Groupes assignés","oldpwd":"Entrez l'ancien mot de passe","changepwd":"Changer le mot de passe","updatephone":"Modifier le téléphone","pwdupdated":"Le mot de passe a été mis à jour avec succès","QAupdated":"La réponse à la question de sécurité a été mise à jour avec succès","phonenumberinvalid":"Le numéro de téléphone est invalide","phoneupdated":"Numéro de téléphone mis à jour avec succès","showmore":"Visualiser plus","verifypassword":"vérifier le mot de passe","filterusergrp":"Filtrer les utilisateurs par groupe","allactiveusers":"Tous les utilisateurs actifs","viewuser":"Voir l'utilisateur","partofokta":"Cet utilisateur fait partie de l'organisation Okta","userdeactive":"L'utilisateur est désactivé","showing":"Afficher","of":"sur","answerpartofquestion":"La réponse ne doit pas faire partie de la question","activationpending":"Votre compte est en attente d'activation. Veuillez mettre à jour votre numéro de téléphone afin que les SMS de réinitialisation vous parviennent.","change_forgot_pwd_qtn":"Changer la question de sécurité","basicinfo":"Informations de base","gotoapp":"Veuillez cliquer ci-dessous pour accéder à votre compte.","passwordresetsuccess":"Votre mot de passe a été réinitialisé avec succès","passwordreset":"mot de passe réinitialisé!","searchinfotext":"* La recherche est effectuée uniquement sur l'application","tmlabel":"Configuration","delete":"Effacer","search":"Chercher","nop":"Numéro de téléphone","nop_inst":"Entrez votre numéro comme vous le composez normalement. N'ajoutez pas votre code pays","nopMobile":"Numéro de portable","statusactive":"ACTIF","statuspending":"En attente d'activation","globalsearch":"Rechercher d'autres utilisateurs","permissiondenied":"Vous ne pouvez pas supprimer / désactiver cet utilisateur. utilisateur assigné à d'autres groupes. Vous pouvez annuler l'attribution de l'utilisateur","activestatus":"ACTIF","provisionedstatus":"Invitation envoyée","deprovisionedstatus":"Invitation non activée","save":"Sauvegarder","admingroup":"Groupe administrateur","application":"Application","selectadmingroup":"Sélectionner un groupe d'administrateurs","selectapp":"Sélectionnez une application","adminConfigIncomplete":"Saisie incomplète. Veuillez affecter un groupe d'administrateurs pour enregistrer ou supprimer une ligne.","adminconfigdeletesuccess":"Supprimé avec succès","adminconfigupdatesuccess":"Configuration mise à jour avec succès","wanttodeleteadminconfig":"Voulez-vous supprimer cette configuration?","cannotdeleteconfig":"Cette configuration ne peut pas être supprimée","nonanoktauser":"Non autorisé à faire cette action. Le fournisseur d'identité de cet utilisateur n'est pas Okta.","reactivate":"Renvoyer Inviter","wanttoreactivate":"Voulez-vous renvoyer le lien d'activation à l'utilisateur?","iread1":"J'accepte que les portails clients de Cargill, les applications et les services disponibles par leur intermédiaire soient soumis aux ","iread2":"Conditions générales","iread3":" du portail client de Cargill, qui peuvent être complétées ou modifiées par des conditions générales spécifiques à chaque site.","iagree1":"Je reconnais et accepte que le traitement des données personnelles par Cargill en relation avec les portails, les applications et les services des clients de Cargill soit soumis à la ","iagree2":"Politique de confidentialité en ligne","iagree3":", du portail client de Cargill, qui peut être complétée ou modifiée par le biais d'avis de confidentialité pour chaque service commercial applicable.","privacypolicy_link":"https://www.cargill.com/page/privacy","termsandconditions_link":"https://www.cargill.com/portal-terms","resetreactivate":"Réinitialiser / Réactiver","emailinvaliddomain":"L'utilisateur avec ce domaine ne peut pas être ajouté","administeredgroups":"Groupes Administrés","selectgroupslist":"Sélectionner des groupes","alreadyactive":"Vous êtes un utilisateur actif!","alreadyactivesetup":"Votre profil ne nécessite pas d'inscription. Utilisez l’identifiant employé de Cargill pour vous connecter à vos applications.","selectBrand":"Sélectionnez une marque","permissiondeniedreset":"Vous ne pouvez pas réinitialiser le mot de passe pour cet utilisateur. ","unlockaccount":"Déverrouiller compte","unlockaccountsuccess":"Votre compte a été débloqué avec succès","accountunlocked":"Compte débloqué!","copyrefid":"Veuillez copier l'ID de référence au bas de l'email que vous avez reçu et collez-le ci-dessous pour continuer.","securityquestionanswerweak":"La réponse à la question de sécurité est trop faible, la réponse ne doit pas faire partie de la question","securityanswermatchesquestion":"Réponse de sécurité invalide : la réponse ne doit pas contenir de $ qui fait partie de la question de sécurité","copysecurityanswermatchesquestion":"Réponse de sécurité invalide : la réponse ne doit pas contenir de $ qui fait partie de la question de sécurité","tokenInvalidShortMessage":"Votre lien d'activation n'est plus valide.","browserspecificmsg":"Veuillez envisager d'utiliser le navigateur de navigateur Google Chrome.","enterActivationDetails":"Pour les informations demandées ci-dessous, veuillez consulter votre e-mail d'activation.","resendActivation":"Renvoyer l'e-mail d'activation","reinvite":"Renvoyer l'invitation","reinviteEmailMessage":"Si les informations fournies sont correctes, vous recevrez un nouvel e-mail d'activation.","reinviteContactAdminMessage":"Veuillez vous adresser à votre contact professionnel Cargill si vous ne recevez pas le nouvel e-mail d'activation.","activationOk":"Ok","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","selfRegSubGrps":"Self registration additional group:","disableExistingUserOnboard":"Disable Existing User","selectReggroup":"Select Registration group","selfRegister":"S'enregistrer","selfRegFormTitle":"S'inscrire","E0001":"Désolé, une erreur s'est produite lors de la tentative de création de votre compte Veuillez","E0001_1":" nous contacter ","E0001_2":"pour obtenir de l'aide avec la création de votre compte","E0002":" for assistance with setting up your account.","E0003":"Votre compte a été enregistré avec succès. Un e-mail a été envoyé à ","E0003_1":" avec des instructions pour activer votre compte.","E0004":"Votre compte a été enregistré avec succès. Vous pouvez maintenant vous connecter à l’application à l’aide de votre mot de passe existant. Si vous ne vous souvenez pas de votre mot de passe, utilisez l’option « Mot de passe oublié » sur l’application pour réinitialiser votre mot de passe","E0005":"User already exists with status ","E0005_1":" Please contact ","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"Les exigences relatives au mot de passe n'ont pas été respectées. Exigences relatives au mot de passe : au moins 8 caractères, une lettre minuscule, une lettre majuscule, un chiffre, aucune partie de votre nom d'utilisateur. Votre mot de passe ne peut pas être l'un de vos 24 derniers mots de passe.","acceptTerms":"Veuillez accepter notre politique de confidentialité et nos conditions générales pour continuer.","phoneVerificationNotCompleted":"Veuillez vérifier/supprimer votre numéro de téléphone pour continuer.","verifyPhoneWarning":"Veuillez cliquer sur 'Envoyer le code' pour vérifier votre numéro de téléphone","viewMoreInfo":"Afficher plus d'informations","infoContent":"Afficher plus d'informations sur l'utilisateur","createdDate":"Date de création","activatedDate":"Date d'activation","lastLoginDate":"Date de la dernière connexion","lastUpdatedDate":"Date de la dernière mise à jour","passwordChangedDate":"Date de modification du mot de passe","statusChangedDate":"Date de changement de statut","createdDateDescription":"Date et heure de création de l'enregistrement utilisateur dans Okta.","activatedDateDescription":"Date et heure d'envoi du dernier e-mail d'activation de l'utilisateur.","statusChangedDateDescription":"Date et heure auxquelles le statut de l'utilisateur a été modifié pour la dernière fois dans Okta.","lastLoginDateDescription":"Date et heure de la dernière connexion de l'utilisateur à Okta (non spécifique à l'application).","lastUpdatedDateDescription":"Date et heure de la dernière mise à jour de l'enregistrement utilisateur dans Okta.","passwordChangedDateDescription":"Date et heure auxquelles l'utilisateur a modifié son mot de passe pour la dernière fois.","resetMFATitle":"Réinitialiser l'authentification multifacteur","noFactorExist":"Aucun facteur n'existe pour cet utilisateur.","mfaValidation":"Veuillez sélectionner un facteur à réinitialiser.","resetButton":"Réinitialiser","mfaResetModalTitle":"Réinitialisation MFA","factorResetSuccess":"Le facteur a été réinitialisé avec succès.","resetConfirmation":"Voulez-vous vraiment réinitialiser MFA pour cet utilisateur?","copyrights":"Cargill, Incorporé. Tous les droits sont réservés.","reportLabel":"Rapport","bulkUploadLabel":"Importation groupée d'utilisateurs","availableIndependentGroups":"Groupes indépendants disponibles :","selectedBrand":"Marque sélectionnée :","bulkUploadOptionsLabel":"Options de téléchargement groupé","bulkCreateUsers":"Créer des utilisateurs en masse","bulkReinviteUsers":"Réinviter des utilisateurs en masse","confirm":"Confirmer","downloadExcelTemplate":"Télécharger le modèle Excel :","uploadInstruction":"Après avoir téléchargé le modèle, remplissez la feuille Excel et téléchargez-la en utilisant la section ci-dessous","uploadWarningOne":"Maximum de seulement 50 utilisateurs autorisés à la fois.","uploadWarningTwo":"Assurez-vous que le champ e-mail n'est pas laissé vide.","uploadWarningThree":"Assurez-vous que les identifiants de messagerie fournis sont gérés par vous.","uploadWarningFour":"Assurez-vous qu'aucun champ n'est laissé vide.","uploadWarningFive":"Assurez-vous que toutes les valeurs de champ sont valides.","uploadWarningSix":"Assurez-vous que les identifiants de groupe fournis sont gérés par vous.","uploadNote":"Les invitations envoyées via ce processus suivent l'e-mail d'invitation standard du compte Cargill.","uploadLabel":"Télécharger","action":"Actions","userword":"utilisatrices","note":"Note:","authentication":"Authentification","noTableData":"Aucune donnée pour le tableau.","readOnlyGroup":"Il s'agit d'un groupe en lecture seule. L'affectation pour ce groupe doit être effectuée uniquement via access.cargill.com","adminPermissionDenied":"Vos droits d'administrateur d'utilisateurs ne vous permettent pas de modifier cette attribution de groupe.","msgForGenericErrorUA":"Nous sommes actuellement confrontés à un problème avec le traitement de votre demande. Veuillez réessayer plus tard. Si vous continuez à voir cette erreur, contactez votre représentant du service client pour obtenir de l'aide.","passcodeRateLimit":"Impossible de traiter votre demande, veuillez réessayer dans 5 minutes.","passcodeNotEntered":"Veuillez saisir le mot de passe pour vérifier.","msgForUnhandledResponse":"Impossible de traiter la demande, veuillez contacter votre représentant du service client.","groupUnavailable":"Le groupe n'est plus disponible dans Okta. Le groupe a peut-être été supprimé.","groupCannotBeAssigned":"Le groupe $ n'est plus disponible dans Okta et ne peut donc pas être attribué à l'utilisateur. Veuillez supprimer le groupe et continuer.","copyGroupCannotBeAssigned":"Le groupe $ n'est plus disponible dans Okta et ne peut donc pas être attribué à l'utilisateur. Veuillez supprimer le groupe et continuer."}

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports = {"1":"United States","7":"Russian Federation","20":"Egypt","27":"South Africa","30":"Greece","31":"Netherlands","32":"Belgium","33":"France","34":"Spain","36":"Hungary","39":"Italy","40":"Romania","41":"Switzerland","43":"Austria","44":"United Kingdom","45":"Denmark","46":"Sweden","47":"Svalbard and Jan Mayen","48":"Poland","49":"Germany","51":"Peru","52":"Mexico","53":"Cuba","54":"Argentina","55":"Brazil","56":"Chile","57":"Colombia","58":"Venezuela, Bolivarian Republic of","60":"Malaysia","61":"Christmas Island","62":"Indonesia","63":"Philippines","64":"New Zealand","65":"Singapore","66":"Thailand","81":"Japan","82":"Korea, Republic of","84":"Vietnam","86":"China","90":"Turkey","91":"India","92":"Pakistan","93":"Afghanistan","94":"Sri Lanka","95":"Myanmar","98":"Iran, Islamic Republic of","211":"Southern Sudan","212":"Western Sahara","213":"Algeria","216":"Tunisia","218":"Libya","220":"Gambia","221":"Senegal","222":"Mauritania","223":"Mali","224":"Guinea","225":"Elefántcsontpart","226":"Burkina Faso","227":"Niger","228":"Togo","229":"Benin","230":"Mauritius","231":"Liberia","232":"Sierra Leone","233":"Ghana","234":"Nigeria","235":"Chad","236":"Central African Republic","237":"Cameroon","238":"Cape Verde","239":"Sao Tome and Principe","240":"Equatorial Guinea","241":"Gabon","242":"Congo","243":"Congo, Democratic Republic of the","244":"Angola","245":"Guinea Bissau","246":"British Indian Ocean Territory","248":"Seychelles","249":"Sudan","250":"Rwanda","251":"Ethiopia","252":"Somalia","253":"Djibouti","254":"Kenya","255":"Tanzania, United Republic of","256":"Uganda","257":"Burundi","258":"Mozambique","260":"Zambia","261":"Madagascar","262":"Reunion","263":"Zimbabwe","264":"Namibia","265":"Malawi","266":"Lesotho","267":"Botswana","268":"Swaziland","269":"Comoros","290":"Saint Helena, Ascension and Tristan da Cunha","291":"Eritrea","297":"Aruba","298":"Faroe Islands","299":"Greenland","350":"Gibraltar","351":"Portugal","352":"Luxembourg","353":"Ireland","354":"Iceland","355":"Albania","356":"Malta","357":"Cyprus","358":"Finland","359":"Bulgaria","370":"Lithuania","371":"Latvia","372":"Estonia","373":"Moldavia","374":"Armenia","375":"Belarus","376":"Andorra","377":"Monaco","378":"San Marino","379":"Holy See (Vatican City State)","380":"Ukraine","381":"Serbia","382":"Montenegro","385":"Croatia","386":"Slovenia","387":"Bosnia and Herzegovina","389":"Macedonia","420":"Czech republic","421":"Slovakia","423":"Liechtenstein","500":"South Georgia and the South Sandwich Islands","501":"Belize","502":"Guatemala","503":"El Salvador","504":"Honduras","505":"Nicaragua","506":"Costa Rica","507":"Panama","508":"Saint Pierre and Miquelon","509":"Haiti","590":"Guadeloupe","591":"Bolivia","592":"Guyana","593":"Ecuador","595":"Paraguay","596":"Martinique","597":"Suriname","598":"Uruguay","599":"Netherlands Antilles","670":"Timor-Leste","672":"Norfolk Island","673":"Brunei Darussalam","674":"Nauru","675":"Papua New Guinea","676":"Tonga","677":"Solomon Islands","678":"Vanuatu","679":"Fiji","680":"Palau","681":"Wallis and Futuna","682":"Cook Islands","683":"Niue","685":"Samoa","686":"Kiribati","687":"New Caledonia","688":"Tuvalu","689":"French Polynesian","690":"Tokelau","691":"Micronesia","692":"Marshall Islands","850":"Korea, Democratic People's Republic of","852":"Hong Kong","853":"Macao","855":"Cambodia","856":"Lao People's Democratic Republic","880":"Bangladesh","886":"Taiwan","960":"Maldives","961":"Lebanon","962":"Jordan","963":"Syrian Arab Republic","964":"Iraq","965":"Kuwait","966":"Saudi Arabia","967":"Yemen","968":"Oman","970":"Palestine","971":"United Arab Emirates","972":"Israel","973":"Bahrain","974":"Qatar","975":"Bhutan","976":"Mongolia","977":"Nepal","992":"Tajikistan","993":"Turkmenistan","994":"Azerbaijan","995":"Georgia","996":"Kyrgyzstan","998":"Uzbekistan","1242":"Bahamas","1246":"Barbados","1264":"Anguilla","1268":"Antigua and Barbuda","1284":"Virgin Islands, British","1340":"Virgin Islands, US","1345":"Cayman Islands","1441":"Bermuda","1473":"Grenada","1649":"Turks and Caicos Islands","1664":"Montserrat","1670":"Northern Mariana Islands","1671":"Guam","1684":"American Samoa","1758":"Saint Lucia","1767":"Dominica","1784":"Saint Vincent and the Grenadines","1787":"Puerto Rico","1809":"Dominican Republic","1868":"Trinidad and Tobago","1869":"Saint Kitts and Nevis","1876":"Jamaica","441481":"Guernsey","441534":"Jersey","registration":"Regisztráció","hello":"Üdvözöljük  ","welcome_cargill":"Üdvözöljük a ","user_reg":"felhasználó regisztráció","enter_new_pwd":"Adjon meg új jelszót","pwd_rule":"Jelszavának legalább 8 karakterből kell állnia. Tartalmazzon legalább egy kisbetűt, egy nagybetűt, egy számot, de ne tartalmazza felhasználónevének részeit.","repeat_pwd":"Ismételje meg az új jelszót","choose_forgot_pwd_qtn":"Válasszon egy biztonsági kérdést elfelejtett jelszó esetére","stock_qtn":"Tárolt kérdések","disliked_food":"Melyik ételt szereti a legkevésbé?","name_of_first_plush_toy":"Mi volt a neve az első háziállatának?","first_award":"Mi volt a márkája az első autójának?","favorite_security_question":"Mi a kedvenc biztonsági kérdése?","favorite_toy":"Mi volt a neve az első háziállatának?","first_computer_game":"Mi volt az első számítógépes játék, amivel játszott?","favorite_movie_quote":"Mi a kedvenc filmje?","first_sports_team_mascot":"Mi a kedvenc sportcsapata?","first_music_purchase":"Mi a kedvenc zenekara?","favorite_art_piece":"Mi a kedvenc autója? ","grandmother_favorite_desert":"Mi az édesanyja keresztneve? ","first_thing_cooked":"Mi a kedvenc étele?","childhood_dream_job":"Mi szeretett volna lenni gyerekként? ","place_where_significant_other_was_met":"Hol született?","favorite_vacation_location":"Mi a kedvenc nyaralóhelye?","new_years_two_thousand":"Hol töltötte a 2000-es év szilveszterét?","favorite_speaker_actor":"Ki a kedvenc énekese?","favorite_book_movie_character":"Ki a kedvenc színésze?","favorite_sports_player":"Ki a kedvenc sportolója?","custom_qtn":"Egyéni kérdés","own_sec_qtn":"Hozza létre saját biztonsági kérdését","answer":"Válasz","phone_inst":"Megadhat egy telefonszámot, amit a fiók visszaállításához tud használni. Erre a telefonszámra csak a fiók visszaállításához szükséges ellenőrző kódokat fogjuk Önnek elküldeni.","optional":"(Opcionális)","sms_inst":"Az Okta szöveges üzenetet küldhet helyreállítási kóddal. Ez a funkció akkor hasznos, ha nincs hozzáférése az e-mailhez.","add_ph_no":"Telefonszám hozzáadása","create_acc":"Felhasználói fiók létrehozása","forgot_pwd_header":"Elfelejtett jelszó SMS","enter_phone_no":"Adja meg a telefonszámot, amire sms-ben kéri a kódokat, majd klikkeljen a Kód küldése gombra a működés ellenőrzéséhez","country":"Ország","country_inst":"Válassza ki azt az országot, ahol a telefon regisztrálva van.","back":"Újraküldés","phone_number":"Telefonszám","phone_number_inst":"Adja meg a mobiltelefonszámát országkód nélkül.","code_prefix":"országkód","send_code":"Kód küldése","done":"Kész","verify":"Ellenőrzés","enter_code":"Írja be a kódot","enter_code_rule":"Ellenőrizze a telefonon kapott jelszót, és írja be alább. Az üzenetnek kevesebb mint egy percen belül kell megérkeznie.","verify_success":"A telefonszám sikeresen ellenőrizve!","click":"Kattintson","finish_setup":" a beállítás befejezéséhez.","error_review":"Kérjük, tekintse át az űrlapot a következő hibák kijavításához","phone_no_not_found":"Üzenet nem küldhető, mert az adatbázisban nem található telefonszám.","noLowerCase":"Tartalmazzon legalább egy kisbetűt","noUpperCase":"Tartalmazzon legalább egy nagybetűt","noNumber":"Tartalmazzon legalább egy számot ","noSpecialCharacter":"Tartalmazzon legalább egy különleges karaktert","notMinLength":"Tartalmazzon legalább egy $ karaktert","noUsernameSubstring":"Nem tartalmazhatja a felhasználónév részeit","noFirstnameSubstring":"Nem tartalmazhatja az Ön vezetéknevének részeit","noLastnameSubstring":"Nem tartalmazhatja vezetéknevének részeit","tokenNotValid":"Az aktiváló token már nem érvényes","tokenInvalidInfo":"Ez akkor fordulhat elő, ha az aktiválási linkre a fiók létrehozása után kattintott, az aktiválási link lejárt, vagy az URL nem megfelelő","reqNewToken":"Új token kérése","passcodeNotValid":"A jelszó nem egyezik az általunk rögzítettel. Kérem, pórbálja újra.","OTPEnableAfter30Sec":"Elküldtük az SMS-t. Kérjük, várjon 30 másodpercet, mielőtt újra próbálkozna.","phoneNoAlreadySet":"A telefonszámot a felhasználó már ellenőrizte.","emptypassword":"A jelszó nem lehet üres","passwordlength":"A jelszó nem lehet üres","passwordnotvalid":"A jelszó nem érvényes","passwordnotmatching":"A jelszavaknak meg kell egyezniük","answerlength":"A válasznak legalább $ karakter hosszúnak kell lennie","phonenumbermissing":"A folytatáshoz ellenőrizze a kapott jelszót","customQuestionEmpty":"Az egyéni kérdés nem lehet üres","customQAsame":"Az egyéni kérdés és válasz nem lehet azonos","passwordSameasPrev":"A jelszó nem lehet az Ön jelenlegi jelszava","answerWrong":"A helyreállítási kérdésre adott válasz nem egyezik az általunk rögzítettel","phonealreadyactive":"Ezt a számot már ellenőrizték, ha frissíteni szeretne, próbáljon egy másik számot","first_name":"Keresztnév","last_name":"Vezetéknév","enter_email":"Email azonosító","emailNotValid":"Az e-mail azonosító nem érvényes","registeredapps":"Regisztrált alkalmazások","waitingapps":"A jóváhagyásra váró alkalmazások","requestaccess":"Hozzáférés kérése","admin":"admin","selectLang":"Válasszon nyelvet","dashboardLabel":"Áttekintés","resetpwd":"Jelszó visszaállítása","ansForgotten":"Válaszoljon az elfelejtett jelszó kérdésre","resetOktaPwd":"Állítsa vissza az Okta jelszavát","newpwd":"új jelszó","rptpwd":"Jelszó újra","adminLabel":"Felhasználói kezelés","userAdministration":"Felhasználói kezelés","adduser":"Új felhasználó hozzáadása","function":"Funkció","emailAddress":"Email cím","filterApp":"Szűrő alkalmazás","create":"létrehoz","logoutConfirm":"Biztosan szeretne kijelentkezni?","no":"Nem","yes":"Igen","logout":"Kijelentkezés","expireWarning":"A munkamenet % perc múlva lejár, nyomja meg az OK gombot, hogy bejelentkezve maradjon, vagy nyomja meg a Mégse gombot a kijelentkezéshez. Ha nincs csatlakoztatva, a módosítások elvesznek","update":"frissítés","activateDeactivate":"Aktiválás/Deaktiválás","attention":"Figyelem","cancel":"Törlés","sessionTimedout":"A munkamenet lejárt. Kérjük, jelentkezzen be újra","username":"Felhasználónév","primary_mail":"elsődleges email","secondary_mail":"Másodlagos e-mail (nem kötelező)","groups":"csoportok","must_email":"E-mailnek kell lennie","ieNotSupported":"Az Internet Explorer nem támogatott","tryChrome":"Az Internet Explorer nem támogatott. Javasoljuk a Chrome használatát az alkalmazás számára.","close":"Bezárás","forgotSQA":"Elfelejtette a biztonsági választ?","resetSecQA":"Biztonsági kérdés és jelszó visszaállítása","retry":"Vissza","nofactorpresent":"Ezt az opciót nem lehet használni, mert a mobilszám nincs beállítva. Vegye fel a kapcsolatot a rendszergazdával.","emptypasscode":"A kód nem lehet üres","provisioned":"Ez a felhasználó még nem regisztrált. A jelszó csak akkor állítható vissza, ha a felhasználó aktív","deprovisioned":"Ez a felhasználó ki van kapcsolva. A jelszó csak akkor állítható vissza, ha a felhasználó aktív","resetsuccesspopupmsg":"A jelszó visszaállítása linket e-mail címre küldték. Az X gombbal zárja be a felugró ablakot.","wanttoreset":"Szeretné visszaállítani a jelszót?","wanttoactivate":"Szeretné aktiválni a felhasználót?","wanttodeactivate":"Ki akarja kapcsolni a felhasználót? ","wanttodelete":"Törli a felhasználót?","updateprofile":"Profil frissítése","updatesuccess":"A felhasználó sikeresen frissítve","usercreated":"* Felhasználó létrehozva","errorcreatinguser":"* Hiba: a felhasználó / e-mail már létezik","privacypolicy":"Adatvédelmi irányelvek","termsandconditions":"Felhasználási feltételek","uname-email":"Felhasználónév / e-mail","password_placeholder":"Jelszó","sign-in":"Belépés","resetmailsent":"A jelszó visszaállításához szükséges linket elküldtük a megadott e-mail címre.","smssent":"Elküldve","resendcode":"Kód újraküldése","needhelp":"Segítségre van szüksége a bejelentkezéshez?","forgotPassword":"Elfelejtett jelszó?","helplink":"Segítség","smsusage":"Az SMS csak akkor használható, havan megadva mobiltelefonszám..","backtosignin":"Vissza a bejelentkezéshez","resetviasms":"Visszaállítás SMS-ben","resetviaemail":"Visszaállítás e-mailben","didntreceivecode":"Nem kapott kódot? Visszaállítás e-mailben","emailsent":"Email elküldve!","recoverycredentialsnotset":"Elfelejtett jelszó nem engedélyezett, mert nincsenek helyreállítási hitelesítő adatok ehhez a felhasználóhoz","usernotpresent":"Nincs felhasználó","mobilenumbernotset":"A mobilszám nincs beállítva","invalidcreds":"Érvénytelen felhasználónév vagy jelszó","emailreq":"E-mail szükséges","emailinvalid":"Az e-mail érvénytelen","pwdreq":"jelszó szükséges","otplength":"Az OTP-nek 6 karakter hosszúnak kell lennie","passcodeinvalid":"Érvénytelen OTP","firstnamereq":"Keresztnév szükséges","lastnamereq":"Vezetéknév szükséges","notallowedincurrentstate":"Ez a művelet nem engedélyezett az aktuális hitelesítési állapotban","nopartsofusername":"A jelszó nem tartalmazhatja felhasználónevének részeit, vagy kereszt- ill. vezetéknevét","passwordusedrecently":"A jelszót már nemrég használták","passwordnotmetrequirements":"A jelszó nem felel meg a jelenlegi jelszószabályzat összetettségi követelményeinek","antar":"Antarctica","aus":"Australia","can":"Canada","falk":"Falkland Islands (Malvinas)","kazak":"Kazakhstan","mayotte":"Mayotte","morocco":"Morocco","norway":"Norway","pitcairn":"Pitcairn","filteruser":"Felhasználók szűrése az App segítségével","selectgroups":"Válassza az Alkalmazás lehetőséget","status":"Állapot","atleastonegroup":"Válasszon ki legalább egy csoportot a felhasználó hozzárendeléséhez ","answerchallenge":"Válasz az elfelejtett jelszó kérdésre","entersmscode":"Írja be az SMS-ben kapott ellenőrző kódot","enterusercreds":"Adja meg a felhasználói adatokat","inviteuser":"Új felhasználó meghívása","assignApplication":"Alkalmazás hozzárendelése","availablegroups":"Elérhető csoportok","selectedgroups":"Hozzárendelt csoportok","emailsenttouser":"Az e-mail sikeresen elküldve","pendingactivation":"A fiók aktiválása függőben van","exit":"Kilépés","myprofile":"A profilom","activatesuccess":"Felhasználó sikeresen aktiválódott, aktiváló e-mail elküldve","deactivatesuccess":"sikeresen deaktiválva","deletesuccess":" sikeresen törölve","edituser":"Felhasználó szerkesztése","getstarted":"Kezdés","congrats":"Gratulálunk!","accountsetup":"Sikeresen befejezte a fiók beállítását.","edit":"Szerkesztés","assignedapps":"Hozzárendelt alkalmazások","assignedgroups":"Hozzárendelt csoportok","oldpwd":"Adja meg a régi jelszót","changepwd":"Jelszó módosítása","updatephone":"Telefon frissítése","pwdupdated":"A jelszó sikeresen frissült","QAupdated":"A biztonsági kérdésre adott válasz sikeresen frissült","phonenumberinvalid":"A telefonszám érvénytelen","phoneupdated":"A telefonszám sikeresen frissült","showmore":"Mutass többet","verifypassword":"Jelszó Megerösítése","filterusergrp":"Felhasználók szűrése csoport szerint","allactiveusers":"Minden aktív felhasználó","viewuser":"A felhasználó megtekintése","partofokta":"Ez a felhasználó az Okta szervezet része","userdeactive":"A felhasználó inaktív","showing":"Mutasd","of":"nak","answerpartofquestion":"A válasz nem lehet része a kérdésnek","activationpending":"Ez a szám függőben van. Kérjük, frissítse telefonszámát, különben a helyreállító sms a korábbi aktív telefonszámra érkezik.","change_forgot_pwd_qtn":"A biztonsági kérdés megváltoztatása","basicinfo":"Alapinformációk","gotoapp":"Kattintson az alábbi gombra, hogy hozzáférjen az alkalmazáshoz","passwordresetsuccess":"A jelszavát sikeresen visszaállította","passwordreset":"Jelszó visszaállítása!","searchinfotext":"* A keresés csak az alkalmazásban történik","tmlabel":"Konfiguráció","delete":"Töröl","search":"Keresés","nop":"Szám","nop_inst":"Adja meg a mobiltelefonszámát az országkód nélkül.","nopMobile":"Mobil szám","statusactive":"Aktív","statuspending":"Aktiválás folyamatban","globalsearch":"Más felhasználók keresése","permissiondenied":"Ezt a felhasználót nem lehet törölni/inaktiválni. Más csoportokhoz rendelt felhasználó. Inkább rendelje át a felhasználót.","activestatus":"AKTÍV","provisionedstatus":"Ideiglenes","deprovisionedstatus":"Törölt","save":"Mentés","admingroup":"Admin csoport","application":"Alkalmazás","selectadmingroup":"Válassza az adminisztrátori csoportot","selectapp":"Válassza ki az alkalmazást","adminConfigIncomplete":"Hiányos kitöltés. Kérjük, hozzon létre egy adminisztrátor csoportot a sor mentéséhez vagy eltávolításához","adminconfigdeletesuccess":"Sikeresen törölve","adminconfigupdatesuccess":"A konfiguráció sikeresen frissült","wanttodeleteadminconfig":"Törli ezt a konfigurációt?","cannotdeleteconfig":"Ez a konfiguráció nem törölhető","nonanoktauser":"Nem lehet ezt a műveletet végrehajtani. A felhasználó azonosító szolgáltatója nem az Okta.","reactivate":"Meghívás újraküldése","wanttoreactivate":"Szeretné újraküldeni az aktiválási linket a felhasználónak?","iread1":"Egyetértek azzal, hogy a Cargill ügyfélportáljai, az általuk elérhető alkalmazások és szolgáltatások a Cargill Ügyfélportáljára vonatkoznak","iread2":"Felhasználási feltételek","iread3":", amely kiegészíthető vagy módosítható az egyes üzleti szolgáltatásokra vonatkozó különös feltételekkel.","iagree1":"Tudomásul veszem és elfogadom, hogy a Cargill által a személyes adatok feldolgozása a Cargill ügyfélportáljaival, alkalmazásokkal és szolgáltatásokkal kapcsolatban a Cargill","iagree2":"Online adatvédelmi irányelvek","iagree3":", amely kiegészíthető vagy módosítható az egyes üzleti szolgáltatásokra vonatkozó „Adatvédelmi nyilatkozatok”-kal.","privacypolicy_link":"https://www.cargill.com/page/privacy","termsandconditions_link":"https://www.cargill.com/portal-terms","resetreactivate":"Visszaállítás/Újraaktiválás","emailinvaliddomain":"Ezzel a domainnel nem lehet felhasználót hozzáadni","administeredgroups":"Beadott csoportok","selectgroupslist":"Válassza a Csoportok lehetőséget","alreadyactive":"Ön aktív felhasználó!","alreadyactivesetup":"Az Ön profilját nem kell regisztrálni. Használja a Cargill dolgozói bejelentkezést az alkalmazásokba történő bejelentkezéshez.","selectBrand":"Válassza ki a Brand lehetőséget","permissiondeniedreset":"Nem állíthatja vissza a felhasználó jelszavát. ","unlockaccount":"Fiók feloldása","unlockaccountsuccess":"Fiókját sikeresen feloldotta","accountunlocked":"Fiók sikeresen feloldva","copyrefid":"Please copy the reference Id from the bottom of the email you received and paste it below to proceed.","securityquestionanswerweak":"A biztonsági kérdés válasza túl gyenge, a válasz nem lehet a kérdés része","securityanswermatchesquestion":"A biztonsági válasz érvénytelen: A válasz nem tartalmazhat $ ami a biztonsági kérdés része","copysecurityanswermatchesquestion":"A biztonsági válasz érvénytelen: A válasz nem tartalmazhat $ ami a biztonsági kérdés része","tokenInvalidShortMessage":"Az Ön aktiváló hivatkozása már nem érvényes.","browserspecificmsg":"Fontolja meg a Google Chrome böngésző használatát.","enterActivationDetails":"Az alábbiakban kért adatokhoz, kérjük, tekintse meg az Önnek küldött aktiváló e-mailt.","resendActivation":"Aktiváló e-mail újraküldése","reinvite":"Meghívó újraküldése","reinviteEmailMessage":"Ha az Ön által megadott adatok helyesek, új aktiváló e-mailt fog kapni.","reinviteContactAdminMessage":"Ha az új aktiváló e-mail nem érkezik meg, kérjük, forduljon az Ön Cargill üzleti kapcsolattartójához.","activationOk":"Ok","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","disableExistingUserOnboard":"Disable Existing User","selfRegSubGrps":"Self registration additional group:","selectReggroup":"Select Registration group","selfRegister":"Feliratkozás","selfRegFormTitle":"Regisztráció","E0001":"Sajnáljuk, probléma lépett fel a fiókja beállítása során. Kérjük, a fiókja beállításához nyújtott segítségért","E0001_1":" keressen fel minket.","E0001_2":"","E0002":" for assistance with setting up your account.","E0003":"Fiókjának regisztrációja sikeresen megtörtént. A fiókja aktiválásának lépéseit e-mailben küldtük el a következő címre: ","E0003_1":" utasításokkal a fiók aktiválásához.","E0004":"Fiókjának regisztrációja sikeresen megtörtént. Meglévő jelszavával most már be tud jelentkezni az alkalmazásba. Ha nem emlékszik a jelszavára, kérjük, jelszava ismételt beállításához használja az alkalmazásban az „Elfelejtett jelszó” lehetőséget.","E0005":"User already exists with status ","E0005_1":" Please contact ","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"A jelszóra vonatkozó követelmények nem teljesültek. Jelszó követelmények: legalább 8 karakter, egy kisbetű, egy nagybetű, egy szám, a felhasználónév részei nélkül. Jelszava nem lehet az utolsó 24 jelszava egyike sem.","acceptTerms":"A folytatáshoz kérjük, fogadja el Adatvédelmi szabályzatunkat és Általános Szerződési Feltételeinket.","phoneVerificationNotCompleted":"Kérjük, ellenőrizze/távolítsa el telefonszámát a folytatáshoz.","verifyPhoneWarning":"Kérjük, kattintson a 'Kód küldése' gombra a telefonszám megerősítéséhez","viewMoreInfo":"További információk megtekintése","infoContent":"További információk megtekintése a Felhasználóról","createdDate":"Létrehozás dátuma","activatedDate":"Aktiválás dátuma","lastLoginDate":"Utolsó bejelentkezés dátuma","lastUpdatedDate":"Utolsó frissítés dátuma","passwordChangedDate":"Jelszóváltás dátuma","statusChangedDate":"Állapot Változás dátuma","createdDateDescription":"A felhasználói rekord létrehozásának dátuma és időpontja az Oktában.","activatedDateDescription":"Az utolsó felhasználóaktiváló e-mail elküldésének dátuma és időpontja.","statusChangedDateDescription":"A felhasználói állapot legutóbbi módosításának dátuma és időpontja az Oktában.","lastLoginDateDescription":"Dátum és idő, amikor a felhasználó utoljára bejelentkezett az Oktába (nem alkalmazásfüggő).","lastUpdatedDateDescription":"A felhasználói rekord utolsó frissítésének dátuma és időpontja az Oktában.","passwordChangedDateDescription":"Dátum és idő, amikor a felhasználó utoljára megváltoztatta jelszavát.","resetMFATitle":"Állítsa vissza a többtényezős hitelesítést","noFactorExist":"Ehhez a felhasználóhoz nem tartozik tényező.","mfaValidation":"Kérjük, válasszon egy tényezőt a visszaállításhoz.","resetButton":"Visszaállítás","mfaResetModalTitle":"MFA visszaállítás","factorResetSuccess":"A tényező sikeresen visszaállításra került.","resetConfirmation":"Biztosan visszaállítja az MFA-t ehhez a felhasználóhoz?","copyrights":"Cargill, Bejegyzett. Minden jog fenntartva.","reportLabel":"Jelentés","bulkUploadLabel":"Felhasználók tömeges feltöltése","availableIndependentGroups":"Elérhető független csoportok:","selectedBrand":"Kiválasztott márka:","bulkUploadOptionsLabel":"Tömeges feltöltési lehetőségek","bulkCreateUsers":"Felhasználók tömeges létrehozása","bulkReinviteUsers":"Felhasználók tömeges újrahívása","confirm":"megerősít","downloadExcelTemplate":"Töltse le az Excel sablont:","uploadInstruction":"A sablon letöltése után töltse ki az Excel lapot, és töltse fel az alábbi szakasz segítségével","uploadWarningOne":"Egyszerre legfeljebb 50 felhasználó engedélyezett.","uploadWarningTwo":"Győződjön meg arról, hogy az e-mail mező nem marad üresen.","uploadWarningThree":"Győződjön meg arról, hogy a megadott e-mail-azonosítókat Ön kezeli.","uploadWarningFour":"Ügyeljen arra, hogy ne maradjon üres mező.","uploadWarningFive":"Győződjön meg arról, hogy minden mezőérték érvényes.","uploadWarningSix":"Győződjön meg arról, hogy a megadott csoportazonosítókat Ön kezeli.","uploadNote":"Az ezzel a folyamattal küldött meghívók a Cargill-fiók szabványos meghívó e-mailjét követik.","uploadLabel":"Feltöltés","action":"Akciók","userword":"felhasználókat","note":"jegyzet:","authentication":"Hitelesítés","noTableData":"Nincs adat a táblázathoz.","readOnlyGroup":"Ez egy csak olvasható csoport. Ehhez a csoporthoz csak az access.cargill.com oldalon szabad hozzárendelni","adminPermissionDenied":"Az Ön felhasználói adminisztrátori jogai nem jogosultak a csoporthozzárendelés módosítására.","msgForGenericErrorUA":"Jelenleg problémával állunk szemben a kérelme feldolgozásával. Kérlek, próbáld újra később. Ha továbbra is ezt a hibát látja, további segítségért forduljon ügyfélszolgálati képviselőjéhez.","passcodeRateLimit":"Nem tudjuk feldolgozni kérését, próbálja újra 5 perc múlva.","passcodeNotEntered":"Az ellenőrzéshez adja meg a jelszót.","msgForUnhandledResponse":"Nem tudjuk feldolgozni a kérést, kérjük, forduljon ügyfélszolgálati képviselőjéhez.","groupUnavailable":"A csoport már nem elérhető Oktán. Lehet, hogy a csoportot törölték.","groupCannotBeAssigned":"A $ csoport már nem érhető el az Oktában, ezért nem rendelhető hozzá a felhasználóhoz. Kérjük, távolítsa el a csoportot, és folytassa.","copyGroupCannotBeAssigned":"A $ csoport már nem érhető el az Oktában, ezért nem rendelhető hozzá a felhasználóhoz. Kérjük, távolítsa el a csoportot, és folytassa."}

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports = {"1":"stati Uniti","7":"Federazione Russa","20":"Egitto","27":"Sud Africa","30":"Grecia","31":"Olanda","32":"Belgio","33":"Francia","34":"Spagna","36":"Ungheria","39":"Italia","40":"Romania","41":"Svizzera","43":"Austria","44":"Regno Unito","45":"Danimarca","46":"Svezia","47":"Svalbard e Jan Mayen","48":"Polonia","49":"Germania","51":"Perù","52":"Messico","53":"Cuba","54":"Argentina","55":"Brasile","56":"Cile","57":"Colombia","58":"Venezuela","60":"Malaysia","61":"Isola di Natale","62":"Indonesia","63":"Filippine","64":"Nuova Zelanda","65":"Singapore","66":"Thailandia","81":"Giappone","82":"Corea del Sud","84":"Vietnam","86":"Cina","90":"Turchia","91":"India","92":"Pakistan","93":"Afghanistan","94":"Sri Lanka","95":"Myanmar","98":"Repubblica Islamica dell'Iran","211":"Sudan meridionale","212":"Sahara occidentale","213":"algeria","216":"Tunisia","218":"Libia","220":"Gambia","221":"Senegal","222":"Mauritania","223":"Mali","224":"Guinea","225":"Costa d'Avorio","226":"Burkina Faso","227":"Niger","228":"Togo","229":"Benin","230":"Mauritius","231":"Liberia","232":"Sierra Leone","233":"Ghana","234":"Nigeria","235":"Chad","236":"Repubblica Centrafricana","237":"Camerun","238":"capo Verde","239":"Sao Tome e Principe","240":"Guinea Equatoriale","241":"Gabon","242":"Congo","243":"Congo, Repubblica Democratica del","244":"angola","245":"Guinea Bissau","246":"Territorio britannico dell'Oceano Indiano","248":"Seychelles","249":"Sudan","250":"Ruanda","251":"Etiopia","252":"Somalia","253":"Gibuti","254":"Kenia","255":"Repubblica Unita di Tanzania","256":"Uganda","257":"Burundi","258":"Mozambico","260":"Zambia","261":"Madagascar","262":"Reunion","263":"Zimbabwe","264":"Namibia","265":"Malawi","266":"Lesoto","267":"Botswana","268":"Swaziland","269":"Comoros","290":"Sant'Elena, Ascensione e Tristan da Cunha","291":"Eritrea","297":"aruba","298":"Isole Faroe","299":"Groenlandia","350":"Gibilterra","351":"Portogallo","352":"Lussemburgo","353":"Irlanda","354":"Islanda","355":"Albania","356":"Malta","357":"Cipro","358":"Finlandia","359":"Bulgaria","370":"Lituania","371":"Lettonia","372":"Estonia","373":"Moldavia","374":"Armenia","375":"Bielorussia","376":"Andorra","377":"Monaco","378":"San Marino","379":"Santa Sede (Stato della Città del Vaticano)","380":"Ucraina","381":"Serbia","382":"Montenegro","385":"Croazia","386":"Slovenia","387":"Bosnia Erzegovina","389":"Macedonia","420":"Repubblica Ceca","421":"Slovacchia","423":"Liechtenstein","500":"Georgia del Sud e Isole Sandwich Meridionali","501":"Belize","502":"Guatemala","503":"El Salvador","504":"Honduras","505":"Nicaragua","506":"Costa Rica","507":"Panama","508":"Saint Pierre e Miquelon","509":"Haiti","590":"Guadeloupe","591":"Bolivia","592":"Guyana","593":"Ecuador","595":"Paraguay","596":"Martinique","597":"Suriname","598":"Uruguay","599":"Antille Olandesi","670":"Timor Est","672":"Isole Norfolk","673":"Brunei Darussalam","674":"Nauru","675":"Papua Nuova Guinea","676":"tonga","677":"Isole Salomone","678":"Vanuatu","679":"Fiji","680":"Palau","681":"Wallis e Futuna","682":"Isole Cook","683":"Niue","685":"Samoa","686":"Kiribati","687":"Nuova Caledonia","688":"Tuvalu","689":"Polinesia Francese","690":"Tokelau","691":"Micronesia","692":"Isole Marshall","850":"Corea del Nord","852":"Hong Kong","853":"Macao","855":"Cambogia","856":"Repubblica Democratica Popolare del Laos","880":"Bangladesh","886":"Taiwan","960":"Maldive","961":"Libano","962":"Giordania","963":"Repubblica Araba Siriana","964":"Iraq","965":"Kuwait","966":"Arabia Saudita","967":"yemen","968":"Oman","970":"Palestina","971":"Emirati Arabi Uniti","972":"Israele","973":"Bahrain","974":"Qatar","975":"Bhutan","976":"Mongolia","977":"Nepal","992":"Tajikistan","993":"Turkmenistan","994":"Azerbaijan","995":"Georgia","996":"Kyrgyzstan","998":"Uzbekistan","1242":"Bahamas","1246":"Barbados","1264":"Anguilla","1268":"Antigua e Barbuda","1284":"Isole Vergini Britanniche","1340":"Isole Vergini Americane","1345":"Isole Cayman","1441":"Bermuda","1473":"Grenada","1649":"Isole Turks e Caicos","1664":"Montserrat","1670":"Isole Marianne settentrionali","1671":"Guam","1684":"Samoa americane","1758":"Santa Lucia","1767":"Dominica","1784":"Saint Vincent e Grenadine","1787":"Puerto Rico","1809":"Repubblica Dominicana","1868":"Trinidad e Tobago","1869":"Saint Kitts e Nevis","1876":"Giamaica","441481":"Guernsey","441534":"Jersey","registration":"Registrazione","hello":"Ciao","welcome_cargill":"Benvenuto a","user_reg":"Registrazione Utente","enter_new_pwd":"Inserire una nuova password","pwd_rule":"La password deve contenere almeno 8 caratteri, una lettera minuscola, una lettera maiuscola, un numero, nessuna parte del nome utente.","repeat_pwd":"ripetere la nuova password","choose_forgot_pwd_qtn":"Scegli una domanda per la password dimenticata","stock_qtn":"Domande di magazzino","disliked_food":"Qual è il cibo che meno ti è piaciuto da bambino?","name_of_first_plush_toy":"Qual è il nome del tuo primo animale di peluche?","first_award":"Per cosa hai guadagnato la tua prima medaglia o premio?","favorite_security_question":"Qual è la tua domanda di sicurezza preferita?","favorite_toy":"Qual è il giocattolo / animale di peluche che ti è piaciuto di più da bambino?","first_computer_game":"Qual è stato il primo gioco per computer a cui hai giocato?","favorite_movie_quote":"Qual è la tua citazione di film preferita?","first_sports_team_mascot":"Qual è stata la mascotte della prima squadra sportiva su cui hai giocato?","first_music_purchase":"Quale album musicale o canzone hai acquistato per la prima volta?","favorite_art_piece":"Qual è la tua opera d'arte preferita?","grandmother_favorite_desert":"Qual è stato il dessert preferito di tua nonna?","first_thing_cooked":"Qual è stata la prima cosa che hai imparato a cucinare?","childhood_dream_job":"qual era il lavoro dei tuoi sogni da bambino?","place_where_significant_other_was_met":"Dove hai incontrato il tuo coniuge / partner ?","favorite_vacation_location":"Dove sei andato per la tua vacanza preferita?","new_years_two_thousand":"Dov'eri a capodanno nel 2000?","favorite_speaker_actor":"Chi è il oratore preferito?","favorite_book_movie_character":"Chi è il tuo personaggio del libro / film preferito?","favorite_sports_player":"Chi è il tuo giocatore sportivo preferito?","custom_qtn":"Domanda personalizzata","own_sec_qtn":"Crea la tua domanda di sicurezza","answer":"Risposta","phone_inst":"Opzionale. Inserisci un numero di telefono cellulare per il recupero dell’account. Questo numero di telefono sarà usato solo per inviare codici di verifica tramite messaggi di testo.","optional":"(Opzionale)","sms_inst":"Okta può inviarti un messaggio di testo con un codice di recupero. Questa funzione è utile quando non hai accesso alla tua email.","add_ph_no":"Aggiungi numero di telefono","create_acc":"Crea il mio account","forgot_pwd_header":"Hai dimenticato il messaggio di testo della password","enter_phone_no":"Inserisci il numero di telefono che utilizzerai per ricevere i codici tramite SMS, quindi fai clic su Invia codice per verificare che funzioni.","country":"Nazione","country_inst":"Seleziona il paese in cui è registrato il telefono.","back":"Rimanda","phone_number":"Numero di telefono","phone_number_inst":"Inserisci il tuo numero nel modo in cui lo componi normalmente. Non aggiungere il prefisso internazionale","code_prefix":"Prefisso internazionale per nazione","send_code":"Manda il codice","done":"Fatto","verify":"Verifica","enter_code":"Inserisci il codice","enter_code_rule":"Verifica il passcode sul telefono e inseriscilo di seguito. Il tuo messaggio dovrebbe arrivare in meno di un minuto.","verify_success":"Numero di telefono verificato correttamente!","click":"Cliccare","finish_setup":"per terminare l'installazione.","error_review":"Si prega di rivedere il modulo per correggere i seguenti errori","phone_no_not_found":"Il messaggio di testo non può essere inviato perché non è stato trovato alcun numero di telefono nel database.","noLowerCase":"Dovrebbe contenere almeno una lettera minuscola","noUpperCase":"Dovrebbe contenere almeno una lettera maiuscola","noNumber":"Dovrebbe contenere almeno un numero","noSpecialCharacter":"Dovrebbe contenere almeno un carattere speciale","notMinLength":"Dovrebbe contenere almeno $ caratteri","noUsernameSubstring":"Non deve contenere parte del nome utente","noFirstnameSubstring":"Non deve contenere parte del tuo nome di battesimo","noLastnameSubstring":"Non deve contenere parte del tuo cognome","tokenNotValid":"Il token di attivazione non è più valido","tokenInvalidInfo":"Ciò può accadere se si fa clic sul collegamento di attivazione dopo aver creato l'account, il collegamento di attivazione è scaduto o l'URL non è corretto","reqNewToken":"Richiedi un nuovo token","passcodeNotValid":"Il tuo passcode non corrisponde ai nostri record. Per favore, riprova.","OTPEnableAfter30Sec":"Un messaggio SMS è stato inviato di recente. Attendi 30 secondi prima di riprovare.","phoneNoAlreadySet":"Il numero di telefono è già stato verificato da questo utente.","emptypassword":"La password non può essere vuota","passwordlength":"La password non può essere vuota","passwordnotvalid":"La password non è valida","passwordnotmatching":"Le password devono corrispondere","answerlength":"La risposta dovrebbe essere lunga almeno $ $","phonenumbermissing":"Verifica il passcode che hai ricevuto per procedere","customQuestionEmpty":"La domanda personalizzata non può essere vuota","customQAsame":"La domanda e la risposta personalizzate non possono essere uguali","passwordSameasPrev":"La password non può essere la tua password attuale","answerWrong":"La risposta alla domanda di recupero non corrisponde ai nostri record","phonealreadyactive":"Questo numero è già stato verificato, se si desidera aggiornare provare un altro numero","first_name":"nome di battesimo","last_name":"Cognome","enter_email":"E-mail identificativo utente","emailNotValid":"ID e-mail non valido","registeredapps":"App registrate","waitingapps":"App in attesa di approvazione","requestaccess":"Richiesta di accesso","admin":"Admin","selectLang":"Seleziona la lingua","dashboardLabel":"Dashboard","resetpwd":"Resetta la password","ansForgotten":"Rispondi alla domanda di sicurezza per la password dimenticata","resetOktaPwd":"Reimposta la tua password Okta","newpwd":"nuova password","rptpwd":"Ripeti la password","adminLabel":"Gestione utenti","userAdministration":"Gestione utenti","adduser":"Aggiungi nuovo utente","function":"Funzione","emailAddress":"Indirizzo email","filterApp":"Applicazione filtro","create":"creare","logoutConfirm":"Sei sicuro di voler uscire?","no":"No","yes":"sì","logout":"Disconnettersi","expireWarning":"La sessione scadrà tra% minuti, premere OK per rimanere connesso o premere Annulla per disconnettersi. Se si è disconnessi, eventuali modifiche andranno perse","update":"Aggiornare","activateDeactivate":"Attiva / Disattiva","attention":"Attenzione","cancel":"Annulla","sessionTimedout":"La tua sessione è scaduta. Per favore esegui l'accesso di nuovo","username":"Nome utente","primary_mail":"E-mail primario","secondary_mail":"Email secondaria (opzionale)","groups":"gruppi","must_email":"Deve essere una email","ieNotSupported":"Internet Explorer non è supportato","tryChrome":"Internet Explorer non è supportato. Ti consigliamo di utilizzare Chrome per questa app.","close":"Chiudere","forgotSQA":"hai dimenticato la risposta di sicurezza?","resetSecQA":"Reimposta domanda di sicurezza e password","retry":"Torna indietro","nofactorpresent":"Questa opzione non può essere utilizzata perché il numero di cellulare non è impostato. Si prega di contattare l'amministratore.","emptypasscode":"Il codice non può essere vuoto","provisioned":"Questo utente non è ancora registrato. La password può essere ripristinata solo dopo che l'utente è attivo","deprovisioned":"Questo utente è disattivato. La password può essere ripristinata solo dopo che l'utente è attivo","resetsuccesspopupmsg":"Il link di reimpostazione della password è stato inviato all'indirizzo e-mail. Chiudi il popup utilizzando il pulsante X.","wanttoreset":"Vuoi reimpostare la password?","wanttoactivate":"Vuoi attivare l'utente?","wanttodeactivate":"Vuoi disattivare l'utente? ","wanttodelete":"Vuoi eliminare l'utente?","updateprofile":"Aggiorna il profilo","updatesuccess":"L'utente è stato aggiornato con successo","usercreated":"* Utente creato","errorcreatinguser":"* L'errore durante la creazione dell'utente / e-mail esiste già","privacypolicy":"Politica sulla riservatezza","termsandconditions":"Termini e condizioni","uname-email":"Username / email","password_placeholder":"Password","sign-in":"Accesso","resetmailsent":"È stata inviata un'e-mail a% con il collegamento reimposta password.","smssent":"inviato","resendcode":"Re-invio codice","needhelp":"Hai bisogno di aiuto per accedere?","forgotPassword":"Ha dimenticato la password?","helplink":"Aiuto","smsusage":"Gli SMS possono essere utilizzati solo se è stato configurato un numero di cellulare.","backtosignin":"Torna a Accedi","resetviasms":"Ripristina via SMS","resetviaemail":"Ripristina via e-mail","didntreceivecode":"Non hai ricevuto un codice? resettare via e-mail","emailsent":"Email inviata!","recoverycredentialsnotset":"Password dimenticata non consentita poiché le credenziali di recupero non sono impostate per l'utente","usernotpresent":"Utente non presente","mobilenumbernotset":"Numero di cellulare non impostato","invalidcreds":"Username o password non validi","emailreq":"Email (obbligatorio","emailinvalid":"Email non valida","pwdreq":"Password richiesta","otplength":"OTP (One Time Password) deve contenere 6 caratteri","passcodeinvalid":"OTP (One Time Password) non valida","firstnamereq":"Nome di battesimo obbligatorio","lastnamereq":"Cognome obbligatorio","notallowedincurrentstate":"Questa operazione non è consentita nello stato di autenticazione corrente","nopartsofusername":"La password non può contenere parti del tuo nome utente, incluso il tuo nome o il tuo cognome","passwordusedrecently":"La password è stata utilizzata troppo recentemente","passwordnotmetrequirements":"La password non soddisfa i requisiti di complessità della politica password corrente","antar":"Antartide","aus":"Australia","can":"Canada","falk":"Isole Falkland (Malvinas)","kazak":"Kazakistan","mayotte":"Mayotte","morocco":"Marocco","norway":"Norvegia","pitcairn":"Pitcairn","filteruser":"Filtra gli utenti per app","selectgroups":"Seleziona applicazione","status":"Stato","atleastonegroup":"Seleziona almeno un gruppo a cui assegnare l'utente","answerchallenge":"Rispondi sfida password dimenticata","entersmscode":"Inserisci il codice di verifica inviato via SMS","enterusercreds":"Inserisci i dettagli dell'utente","inviteuser":"Invita un nuovo utente","assignApplication":"Assegna all'applicazione","availablegroups":"Gruppi disponibili","selectedgroups":"Gruppi assegnati","emailsenttouser":"Email inviata con successo a","pendingactivation":"Attivazione dell'account in sospeso","exit":"Uscita","myprofile":"Il mio profilo","activatesuccess":"L'utente è stato attivato con successo e una mail di attivazione è stata inviata a","deactivatesuccess":"è stato disattivato correttamente","deletesuccess":"è stato cancellato con successo","edituser":"Modifica utente","getstarted":"Iniziare","congrats":"Congratulazioni!","accountsetup":"Hai completato con successo la configurazione del tuo account.","edit":"modificare","assignedapps":"Applicazioni assegnate","assignedgroups":"Gruppi assegnati","oldpwd":"Inserisci la vecchia password","changepwd":"Cambia la password","updatephone":"Aggiorna telefono","pwdupdated":"La password è stata aggiornata con successo","QAupdated":"La risposta alla domanda di sicurezza è stata aggiornata correttamente","phonenumberinvalid":"Il numero di telefono non è valido","phoneupdated":"Numero di telefono aggiornato correttamente","showmore":"Mostra di più","verifypassword":"Verifica la password","filterusergrp":"Filtra gli utenti per gruppo","allactiveusers":"Tutti gli utenti attivi","viewuser":"Visualizza utente","partofokta":"Questo utente fa parte dell'organizzazione Okta","userdeactive":"L'utente è disattivo","showing":"Mostrando","of":"di","answerpartofquestion":"La risposta non deve far parte della domanda","activationpending":"Il tuo fattore è in attesa di attivazione, aggiorna gentilmente il tuo numero di telefono, altrimenti gli SMS di ripristino verranno inviati al tuo numero attivo precedente","change_forgot_pwd_qtn":"Cambia domanda di sicurezza","basicinfo":"Informazioni di base","gotoapp":"Fai clic qui sotto per accedere alla tua applicazione","passwordresetsuccess":"La tua password è stata ripristinata correttamente","passwordreset":"Reimpostazione della password!","searchinfotext":"* La ricerca viene eseguita solo sull'app","tmlabel":"Configurazione","delete":"Elimina","search":"Ricerca","nop":"Numero","nop_inst":"Inserisci il tuo numero nel modo in cui lo componi normalmente. Non aggiungere il prefisso internazionale","nopMobile":"Numero di cellulare","statusactive":"Attivo","statuspending":"In attesa di attivazione","globalsearch":"Cerca altri utenti","permissiondenied":"Non è possibile eliminare / disattivare questo utente. utente assegnato ad altri gruppi. È possibile annullare l'assegnazione dell'utente","activestatus":"ATTIVO","provisionedstatus":"Attivazione account","deprovisionedstatus":"Disattivazione account","save":"Salva","admingroup":"Gruppo di amministrazione","application":"Applicazione","selectadmingroup":"Seleziona il gruppo di amministratori","selectapp":"Seleziona applicazione","adminConfigIncomplete":"Riga incompleta. Si prega di assegnare un gruppo di amministratori per salvare o rimuovere la riga","adminconfigdeletesuccess":"Eliminato con successo","adminconfigupdatesuccess":"Configurazione aggiornata correttamente","wanttodeleteadminconfig":"Vuoi eliminare questa configurazione?","cannotdeleteconfig":"Questa configurazione non può essere eliminata","nonanoktauser":"Non è consentito eseguire questa azione. Il provider di identità di questo utente non è Okta.","reactivate":"Rinvia Invito","wanttoreactivate":"Vuoi inviare nuovamente il link di attivazione all'utente?","iread1":"Accetto che i portali, le applicazioni e i servizi dei clienti Cargill disponibili attraverso di essi siano soggetti al Portale clienti di Cargill","iread2":"Termini e condizioni","iread3":", che può essere integrato o modificato da termini e condizioni specifici per ciascun servizio commerciale applicabile.","iagree1":"Riconosco e accetto che il trattamento dei dati personali da parte di Cargill in relazione ai portali, alle applicazioni e ai servizi dei clienti di Cargill è soggetto alla legislazione Cargill","iagree2":"Informativa sulla privacy online","iagree3":", che può essere integrato o modificato da 'Note sulla privacy' per ciascun servizio applicabile.","privacypolicy_link":"https://www.cargill.com/page/privacy","termsandconditions_link":"https://www.cargill.com/portal-terms","resetreactivate":"Reset / Riattiva","emailinvaliddomain":"L'utente con questo dominio non può essere aggiunto","administeredgroups":"Gruppi amministrati","selectgroupslist":"Seleziona gruppi","alreadyactive":"Sei un utente attivo!","alreadyactivesetup":"Il tuo profilo non richiede registrazione. Usa l'accesso dei dipendenti Cargill per accedere alle tue applicazioni.","selectBrand":"Seleziona marchio","permissiondeniedreset":"Non è possibile reimpostare la password per questo utente. ","unlockaccount":"Sblocca l'account","unlockaccountsuccess":"Il tuo account è stato sbloccato correttamente","accountunlocked":"Account sbloccato!","copyrefid":"Copia l'ID di riferimento dalla parte inferiore dell'e-mail che hai ricevuto e incollalo di seguito per procedere.","securityquestionanswerweak":"La risposta alla domanda di sicurezza è troppo debole, la risposta non deve far parte della domanda","securityanswermatchesquestion":"Risposta di sicurezza non valida: la risposta non deve contenere $ che fa parte della domanda di sicurezza","copysecurityanswermatchesquestion":"Risposta di sicurezza non valida: la risposta non deve contenere $ che fa parte della domanda di sicurezza","tokenInvalidShortMessage":"link di attivazione non è più valido.","browserspecificmsg":"Si prega di considerare l'utilizzo del browser Google Chrome.","enterActivationDetails":"Per le informazioni richieste di seguito, consultare l'e-mail di attivazione.","resendActivation":"Invia di nuovo e-mail di attivazione","reinvite":"Invia invito di nuovo","reinviteEmailMessage":"Se le informazioni fornite sono corrette, si riceverà una nuova e-mail di attivazione.","reinviteContactAdminMessage":"Contattare il referente aziendale Cargill se non si riceve la nuova e-mail di attivazione.","activationOk":"Ok","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","disableExistingUserOnboard":"Disable Existing User","selfRegSubGrps":"Self registration additional group:","selectReggroup":"Select Registration group","selfRegister":"Accedi","selfRegFormTitle":"Registrati","E0001":"Spiacenti, si è verificato un problema durante l'impostazione dell'account.","E0001_1":" Contattaci ","E0001_2":"per assistenza durante l'impostazione dell'account.","E0002":" for assistance with setting up your account.","E0003":"Il tuo account è stato registrato correttamente. È stata inviata un'e-mail all'indirizzo ","E0003_1":" con le istruzioni per l'attivazione dell'account.","E0004":"Il tuo account è stato registrato correttamente. Ora puoi accedere all'applicazione usando la password esistente. Se non ricordi la password, usa l'opzione “Password dimenticata” sull'applicazione per reimpostare la password.","E0005":"User already exists with status ","E0005_1":" Please contact ","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"I requisiti per la password non sono stati soddisfatti. Requisiti per la password: almeno 8 caratteri, una lettera minuscola, una lettera maiuscola, un numero, nessuna parte del tuo nome utente. La tua password non può essere nessuna delle ultime 24 password.","acceptTerms":"Si prega di accettare la nostra politica sulla privacy e i termini e le condizioni per procedere.","phoneVerificationNotCompleted":"Verifica/rimuovi il tuo numero di telefono per procedere.","verifyPhoneWarning":"Fai clic su 'Invia codice' per verificare il tuo numero di telefono","viewMoreInfo":"Visualizza ulteriori informazioni","infoContent":"Visualizza maggiori informazioni sull'utente","createdDate":"Data di Creazione","activatedDate":"Data di attivazione","lastLoginDate":"Data dell'ultimo accesso","lastUpdatedDate":"Data ultimo aggiornamento","passwordChangedDate":"Data di modifica della password","statusChangedDate":"Data di modifica dello stato","createdDateDescription":"Data e ora in cui è stato creato il record utente in Okta.","activatedDateDescription":"Data e ora in cui è stata inviata l'ultima email di attivazione dell'utente.","statusChangedDateDescription":"Data e ora dell'ultima modifica dello stato utente in Okta.","lastLoginDateDescription":"Data e ora dell'ultimo accesso dell'utente a Okta (non specifico dell'applicazione).","lastUpdatedDateDescription":"Data e ora dell'ultimo aggiornamento del record utente in Okta.","passwordChangedDateDescription":"Data e ora dell'ultima modifica della password da parte dell'utente.","resetMFATitle":"Reimposta l'autenticazione a più fattori","noFactorExist":"Non esiste alcun fattore per questo utente.","mfaValidation":"Seleziona un fattore da ripristinare.","resetButton":"Ripristina","mfaResetModalTitle":"Ripristino dell'AMF","factorResetSuccess":"Il fattore è stato ripristinato correttamente.","resetConfirmation":"Sei sicuro di voler reimpostare l'autenticazione a più fattori per questo utente?","copyrights":"Cargill, Incorporato. Tutti i diritti riservati.","reportLabel":"Rapporto","bulkUploadLabel":"Caricamento collettivo degli utenti","availableIndependentGroups":"Gruppi indipendenti disponibili:","selectedBrand":"Marca selezionata:","bulkUploadOptionsLabel":"Opzioni di caricamento collettivo","bulkCreateUsers":"Crea utenti in blocco","bulkReinviteUsers":"Invita nuovamente gli utenti in blocco","confirm":"Confermare","downloadExcelTemplate":"Scarica modello Excel:","uploadInstruction":"Dopo aver scaricato il template, compila il foglio excel e caricalo utilizzando la sezione sottostante","uploadWarningOne":"Massimo di soli 50 utenti consentiti alla volta.","uploadWarningTwo":"Assicurati che il campo email non sia lasciato vuoto.","uploadWarningThree":"Assicurati che gli ID e-mail forniti siano gestiti da te.","uploadWarningFour":"Assicurati che nessun campo sia lasciato vuoto.","uploadWarningFive":"Assicurati che tutti i valori dei campi siano validi.","uploadWarningSix":"Assicurati che gli ID di gruppo forniti siano gestiti da te.","uploadNote":"Gli inviti inviati tramite questo processo seguono l'e-mail standard di invito dell'account Cargill.","uploadLabel":"Caricamento","action":"Azioni","userword":"utenti","note":"Nota:","authentication":"Autenticazione","noTableData":"Nessun dato per la tabella.","readOnlyGroup":"Questo è un gruppo di sola lettura. L'assegnazione per questo gruppo deve essere effettuata solo tramite access.cargill.com","adminPermissionDenied":"I tuoi diritti di amministratore utente non dispongono delle autorizzazioni per modificare questa assegnazione di gruppo.","msgForGenericErrorUA":"Attualmente stiamo affrontando un problema con l'elaborazione della tua richiesta. Per favore riprova più tardi. Se continui a visualizzare questo errore, contatta il rappresentante del servizio clienti per ulteriore assistenza.","passcodeRateLimit":"Impossibile elaborare la tua richiesta, riprova tra 5 minuti.","passcodeNotEntered":"Inserisci il passcode per verificare.","msgForUnhandledResponse":"Impossibile elaborare la richiesta, contattare il rappresentante del servizio clienti.","groupUnavailable":"Il gruppo non è più disponibile in Okta. Il gruppo potrebbe essere stato eliminato.","groupCannotBeAssigned":"Il gruppo $ non è più disponibile in Okta e quindi non può essere assegnato all'utente. Rimuovi il gruppo e procedi.","copyGroupCannotBeAssigned":"Il gruppo $ non è più disponibile in Okta e quindi non può essere assegnato all'utente. Rimuovi il gruppo e procedi."}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = {"1":"미국","7":"러시아 연방","20":"이집트","27":"남아프리카 공화국","30":"그리스","31":"네덜란드","32":"벨기에","33":"프랑스","34":"스페인","36":"헝가리","39":"이탈리아","40":"루마니아","41":"스위스","43":"오스트리아","44":"영국","45":"덴마크","46":"스웨덴","47":"스발 바르와 얀 마옌","48":"폴란드","49":"독일","51":"페루","52":"멕시코","53":"쿠바","54":"아르헨티나","55":"브라질","56":"칠레","57":"콜롬비아","58":"베네수엘라, 볼리바르 공화국","60":"말레이시아","61":"크리스마스 섬","62":"인도네시아","63":"필리핀","64":"뉴질랜드","65":"싱가포르","66":"태국","81":"일본","82":"대한민국","84":"베트남","86":"중국","90":"터키","91":"인도","92":"파키스탄","93":"아프가니스탄","94":"스리랑카","95":"미얀마","98":"이란, 이슬람 공화국","211":"남부 수단","212":"서부 사하라","213":"알제리","216":"튀니지","218":"리비아","220":"감비아","221":"세네갈","222":"모리타니","223":"말리","224":"기니","225":"코트디부아르","226":"부르 키나 파소","227":"니제르","228":"토고","229":"베냉","230":"모리셔스","231":"라이베리아","232":"시에라 리온","233":"가나","234":"나이지리아","235":"차드","236":"중앙 아프리카 공화국","237":"카메룬","238":"카보 베르데","239":"상투메프린시페","240":"적도 기니","241":"가봉","242":"콩고","243":"콩고 민주 공화국","244":"앙골라","245":"기니 비사우","246":"영국령 인도양 영토","248":"세이셸","249":"수단","250":"르완다","251":"에티오피아","252":"소말리아","253":"지부티","254":"케냐","255":"탄자니아, 연합 공화국","256":"우간다","257":"부룬디","258":"모잠비크","260":"잠비아","261":"마다가스카르","262":"동창회","263":"짐바브웨","264":"나미비아","265":"말라위","266":"레소토","267":"보츠와나","268":"스와질란드","269":"코모로","290":"세인트 헬레나, 승천, 트리스탄 다 쿠냐","291":"에리트레아","297":"아루바","298":"페로 제도","299":"그린란드","350":"지브롤터","351":"포르투갈","352":"룩셈부르크","353":"아일랜드","354":"아이슬란드","355":"알바니아","356":"몰타","357":"키프로스","358":"핀란드","359":"불가리아","370":"리투아니아","371":"라트비아","372":"에스토니아","373":"몰다비아","374":"아르메니아","375":"벨로루시","376":"안도라","377":"모나코","378":"산 마리노","379":"교황청 (바티칸 시국)","380":"우크라이나","381":"세르비아","382":"몬테네그로","383":"코소보","385":"크로아티아","386":"슬로베니아","387":"보스니아 헤르체고비나","389":"마케도니아","420":"체코 공화국","421":"슬로바키아","423":"리히텐슈타인","500":"사우스 조지아와 사우스 샌드위치 제도","501":"벨리즈","502":"과테말라","503":"엘살바도르","504":"온두라스","505":"니카라과","506":"코스타리카","507":"파나마","508":"생 피에르 미클롱","509":"아이티","590":"과들루프","591":"볼리비아","592":"가이아나","593":"에콰도르","595":"파라과이","596":"마르티니크","597":"수리남","598":"우루과이","599":"네덜란드 령 앤 틸리 스 제도","670":"동 티모르","672":"노퍽 섬","673":"브루나이 다루살람","674":"나우루","675":"파푸아 뉴기니","676":"통가","677":"솔로몬 제도","678":"바누아투","679":"피지","680":"궁전","681":"왈리스와 푸 투나","682":"쿡 제도","683":"니우에","685":"사모아","686":"키리바시","687":"뉴 칼레도니아","688":"투발루","689":"프랑스 령 폴리네시아","690":"토켈 라우","691":"미크로네시아","692":"마샬 군도","850":"조선민주주의인민공화국","852":"홍콩","853":"마카오","855":"캄보디아","856":"라오스 인민 민주 공화국","880":"방글라데시","886":"대만","960":"몰디브","961":"레바논","962":"요르단","963":"시리아 아랍 공화국","964":"이라크","965":"쿠웨이트","966":"사우디 아라비아","967":"예멘","968":"오만","970":"팔레스타인","971":"아랍 에미리트 연합","972":"이스라엘","973":"바레인","974":"카타르","975":"부탄","976":"몽골","977":"네팔","992":"타지키스탄","993":"투르크 메니스탄","994":"아제르바이잔","995":"조지아","996":"키르기스스탄","998":"우즈베키스탄","1242":"바하마","1246":"바베이도스","1264":"앵 귈라","1268":"앤티가 바부 다","1284":"버진 아일랜드, 영국","1340":"미국령 버진 아일랜드","1345":"케이맨 제도","1441":"버뮤다","1473":"그레나다","1649":"터크 스 케이 커스 제도","1664":"몬세 라트","1670":"북 마리아나 제도","1671":"괌","1684":"아메리칸 사모아","1758":"세인트 루시아","1767":"도미니카","1784":"세인트 빈센트 그레나딘","1787":"푸에르토 리코","1809":"도미니카 공화국","1868":"트리니다드 토바고","1869":"세인트 키츠 네비스","1876":"자메이카","441481":"건지","441534":"저지","registration":"등록","hello":"안녕하세요","welcome_cargill":"Welcome to","user_reg":"사용자 등록","enter_new_pwd":"새 비밀번호 입력","pwd_rule":"비밀번호 요구 사항: 비밀번호는 최소 8자 이상이어야 하며, 소문자, 대문자, 숫자가 포함되고, 아이디와 겹치는 부분이 없어야 합니다.","repeat_pwd":"새 비밀번호 확인","choose_forgot_pwd_qtn":"비밀번호를 잊었을 때 답하실 인증용 질문을 선택하시오","stock_qtn":"주식 질문","disliked_food":"어렸을 때 가장 싫어했던 음식은 무엇입니까?","name_of_first_plush_toy":"첫 번째 인형의 이름은 무엇입니까?","first_award":"무엇 때문에 첫 메달이나 상을 받았습니까?","favorite_security_question":"가장 좋아하는 보안 질문은 무엇입니까?","favorite_toy":"어렸을 때 가장 좋아했던 장난감 / 인형은 무엇입니까?","first_computer_game":"당신이 처음으로 한 컴퓨터 게임은 무엇이었습니까?","favorite_movie_quote":"가장 좋아하는 영화의 명대사는 무엇입니까","first_sports_team_mascot":"당신이 뛰었던 첫 번째 스포츠 팀의 마스코트는 무엇이었습니까?","first_music_purchase":"처음 구입한 음악 앨범이나 노래는 무엇입니까?","favorite_art_piece":"가장 좋아하는 예술 작품은 무엇입니까?","grandmother_favorite_desert":"할머니가 가장 좋아하신 디저트는 무엇이었습니까?","first_thing_cooked":"가장 먼저 배운 요리는 무엇입니까?","childhood_dream_job":"어렸을 때 꿈꾸던 직업은 무엇이었습니까?","place_where_significant_other_was_met":"배우자를 어디에서 만났습니까?","favorite_vacation_location":"가장 인상적인 휴가지는 어디입니까?","new_years_two_thousand":"2000년 새해 첫 날 어디에 있었습니까?","favorite_speaker_actor":"가장 좋아하는 연사/연설가는 누구입니까?","favorite_book_movie_character":"가장 좋아하는 책 주인공/영화 주인공는 누구입니까?","favorite_sports_player":"가장 좋아하는 스포츠 선수는 누구입니까?","custom_qtn":"사용자 지정 질문","own_sec_qtn":"나만의 보안 질문 만들기","answer":"답변","phone_inst":"선택 사항입니다. 계정 복구 전화번호를 입력하세요. 입력하신 전화번호는 문자 메시지 인증 코드 발신에 사용됩니다.","optional":"(선택 사항)","sms_inst":"Okta는 복구 코드가 포함된 문자 메시지를 보낼 수 있습니다. 이 기능은 이메일에 액세스할 수 없을 때 유용합니다.","add_ph_no":"+ 전화번호 추가","create_acc":"내 계정 만들기","forgot_pwd_header":"비밀번호 분실 시 전송되는 문자 메시지","enter_phone_no":"문자 메시지로 코드를 수신할 전화번호를 입력하세요. 그리고 코드 보내기를 클릭하여 작동하는지 확인하세요.","country":"국가","country_inst":"휴대 전화가 등록 된 국가를 선택하십시오.","back":"다시 보내기","phone_number":"전화 번호","phone_number_inst":"평소에 전화를 거는 방식으로 번호를 입력하십시오. 국가 코드를 앞에 추가하지 마십시오.","code_prefix":"국가별 앞자리 코드.","send_code":"본인 인증","done":"완료","verify":"확인","enter_code":"코드 입력","enter_code_rule":"휴대 전화로 발신된 인증번호를 확인하시고 아래에 입력하십시오. 메시지는 1분 이내에 도착해야 합니다.","verify_success":"전화 번호 확인에 성공했습니다!","click":"클릭","finish_setup":"설정을 마칩니다.","error_review":"다음 오류를 수정하려면 양식을 검토하십시오.","phone_no_not_found":"데이터베이스에서 전화번호를 찾을 수 없어 문자 메시지를 보낼 수 없습니다.","noLowerCase":"하나 이상의 소문자를 포함해야 합니다","noUpperCase":"하나 이상의 대문자를 포함해야 합니다","noNumber":"하나 이상의 숫자를 포함해야 합니다","noSpecialCharacter":"하나 이상의 특수 문자를 포함해야 합니다.","notMinLength":"최소한 $개의 문자를 포함해야 함","noUsernameSubstring":"아이디의 일부를 포함해서는 안됩니다","noFirstnameSubstring":"이름의 일부를 포함해서는 안됩니다","noLastnameSubstring":"성의 일부를 포함해서는 안됩니다","tokenNotValid":"활성화 토큰이 더 이상 유효하지 않습니다.","tokenInvalidInfo":"이는 계정을 만든 후 활성화 링크를 클릭했거나, 활성화 링크가 만료되었거나, URL이 올바르지 않은 경우 발생할 수 있습니다.","reqNewToken":"새 토큰 요청하기","passcodeNotValid":"귀하의 비밀번호가 일치하지 않습니다. 다시 시도하십시오.","OTPEnableAfter30Sec":"SMS 메시지를 전송하였습니다. 다시 시도하기 전에 30초 동안 기다려 주십시오.","phoneNoAlreadySet":"이 사용자가 이미 전화번호를 확인했습니다.","emptypassword":"비밀번호란은 비워 둘 수 없습니다.","passwordlength":"비밀번호란은 비워 둘 수 없습니다.","passwordnotvalid":"비밀번호가 유효하지 않습니다","passwordnotmatching":"비밀번호가 일치해야 합니다","answerlength":"답변은 최소한 $개의 문자여야 합니다.","phonenumbermissing":"계속하려면 받으신 코드를 확인해주세요.","customQuestionEmpty":"사용자 지정 질문은 비워 둘 수 없습니다.","customQAsame":"사용자 지정 질문과 답변은 같을 수 없습니다","passwordSameasPrev":"새 비밀번호는 현재 비밀번호와 일치할 수 없습니다.","answerWrong":"복구용 질문과 답변이 기록과 일치하지 않습니다.","phonealreadyactive":"이 번호는 이미 확인되었습니다.","first_name":"이름","last_name":"성","enter_email":"이메일 ID","emailNotValid":"이메일 ID가 유효하지 않습니다","registeredapps":"등록 된 앱","waitingapps":"승인 대기 중인 앱","requestaccess":"액세스 요청","admin":"관리자","selectLang":"언어 선택","dashboardLabel":"대시 보드","resetpwd":"비밀번호 재설정","ansForgotten":"분실된 비밀번호 찾기용 질문에 답변하세요","resetOktaPwd":"비밀번호 재설정","newpwd":"새 비밀번호","rptpwd":"새 비밀번호 확인","adminLabel":"사용자 관리","userAdministration":"사용자 관리","adduser":"새 사용자 추가","function":"기능","emailAddress":"이메일 주소","filterApp":"필터 애플리케이션","create":"새로 만들기","logoutConfirm":"로그아웃하시겠습니까?","no":"아니요","yes":"예","logout":"로그아웃","expireWarning":"세션이 % 분 후에 만료되며, 로그인을 유지하려면 OK를 누르고, 로그아웃하려면 Cancel을 누릅니다. 연결이 끊긴 후 모든 변경사항은 저장되지 않습니다.","update":"업데이트","activateDeactivate":"활성화/비활성화","attention":"주의","cancel":"취소","sessionTimedout":"세션이 만료되었습니다. 다시 로그인하십시오","username":"아이디","primary_mail":"기본 이메일","secondary_mail":"보조 이메일(선택 사항)","groups":"그룹","must_email":"이메일이어야 합니다","ieNotSupported":"IE는 지원되지 않습니다","tryChrome":"Internet Explorer는 지원되지 않습니다. 이 앱에는 Chrome을 사용하는 것이 좋습니다.","close":"닫기","forgotSQA":"보안 답변을 잊으셨습니까?","resetSecQA":"보안 질문 및 비밀번호 재설정","retry":"돌아가기","nofactorpresent":"휴대폰 번호가 설정되지 않았기 때문에 이 옵션을 사용할 수 없습니다. 관리자에게 문의하십시오.","emptypasscode":"코드란은 비워 둘 수 없습니다.","provisioned":"이 사용자는 아직 등록되지 않았습니다. 사용자가 활성 상태 일때만 비밀번호를 재설정할 수 있습니다.","deprovisioned":"이 사용자는 비활성화되었습니다. 사용자가 활성 상태 일때만 비밀번호를 재설정할 수 있습니다.","resetsuccesspopupmsg":"비밀번호 재설정 링크가 이메일 주소로 전송되었습니다. X 버튼을 사용하여 팝업을 닫으십시오.","wanttoreset":"비밀번호를 재설정 하시겠습니까?","wanttoactivate":"사용자를 활성화하시겠습니까?","wanttodeactivate":"사용자를 비활성화 하시겠습니까?","wanttodelete":"사용자를 삭제하시겠습니까?","updateprofile":"프로필 업데이트","updatesuccess":"사용자가 성공적으로 업데이트되었습니다","usercreated":"*사용자가 생성되었습니다","errorcreatinguser":"*사용자/이메일 생성 중 오류가 생겼습니다.","privacypolicy":"개인 정보 보호 정책","termsandconditions":"이용 약관","uname-email":"아이디/이메일","password_placeholder":"비밀번호","sign-in":"로그인","resetmailsent":"비밀번호 재설정 링크가 %로 이메일이 전송되었습니다.","smssent":"전송되었습니다","resendcode":"코드 재전송","needhelp":"로그인하는 데 도움이 필요하세요?","forgotPassword":"비밀번호를 잊으셨나요?","helplink":"도움말","smsusage":"SMS는 휴대폰 번호가 설정된 경우에만 사용할 수 있습니다.","backtosignin":"로그인으로 돌아가기","resetviasms":"SMS를 통해 재설정","resetviaemail":"이메일을 통해 재설정","didntreceivecode":"코드를 받지 못하셨나요? 이메일을 통해 재설정","emailsent":"이메일이 전송되었습니다!","recoverycredentialsnotset":"사용자에 대한 복구 자격의 증명이 설정되지 않아 비밀번호 찾기 기능을 사용하실 수 없습니다.","usernotpresent":"사용자가 없습니다","mobilenumbernotset":"휴대폰 번호가 설정되지 않았습니다","invalidcreds":"잘못된 아이디 또는 비밀번호입니다","emailreq":"이메일이 필요합니다","emailinvalid":"이메일이 잘못되었습니다","pwdreq":"비밀번호가 필요합니다","otplength":"OTP는 여섯자리여야 합니다.","passcodeinvalid":"잘못된 OTP입니다","firstnamereq":"이름 필수","lastnamereq":"성 필수","notallowedincurrentstate":"이 작업은 현재 인증 상태에서 허용되지 않습니다.","nopartsofusername":"비밀번호는 사용자 이름의 일부를 포함할 수 없으며 이름이나 성을 포함할 수 없습니다.","passwordusedrecently":"비밀번호가 너무 최근에 사용되었습니다.","passwordnotmetrequirements":"암호가 현재 암호 정책의 요구 사항을 충족하지 않습니다.","antar":"남극 대륙","aus":"호주","can":"캐나다","falk":"포클랜드 제도 (말 비나스)","kazak":"카자흐스탄","mayotte":"마요트 섬","morocco":"모로코","norway":"노르웨이","pitcairn":"핏 케언","filteruser":"앱별 사용자 필터링:","selectgroups":"애플리케이션 선택","status":"상태","atleastonegroup":"사용자를 배치할 그룹을 하나 이상 선택하세요","answerchallenge":"분실된 비밀번호 찾기용 질문에 답변하세요","entersmscode":"SMS로 전송된 인증번호 입력","enterusercreds":"사용자 세부 정보 입력","inviteuser":"새 사용자 초대","assignApplication":"애플리케이션에 배치","availablegroups":"사용 가능한 그룹","selectedgroups":"배치된 그룹","emailsenttouser":"이메일이 성공적으로 전송되었습니다.","pendingactivation":"계정 활성화 보류 중","exit":"종료","myprofile":"내 프로필","activatesuccess":"사용자계정이 성공적으로 활성화되었으며 완료 메일이 전송되었습니다.","deactivatesuccess":"이(가) 성공적으로 비활성화되었습니다","deletesuccess":"이(가) 성공적으로 삭제되었습니다","edituser":"사용자 편집","getstarted":"시작하기","congrats":"축하합니다!","accountsetup":"계정 설정을 성공적으로 완료했습니다.","edit":"편집","assignedapps":"배치된 애플리케이션","assignedgroups":"배치된 그룹","oldpwd":"예전 비밀번호를 입력하세요","changepwd":"비밀번호 변경","updatephone":"전화기 업데이트","pwdupdated":"비밀번호가 성공적으로 업데이트되었습니다.","QAupdated":"보안 질문의 답변이 성공적으로 업데이트되었습니다.","phonenumberinvalid":"전화번호가 잘못되었습니다","phoneupdated":"전화 번호가 성공적으로 업데이트되었습니다","showmore":"더 보기","verifypassword":"비밀번호 확인하기","filterusergrp":"그룹별로 사용자 필터링:","allactiveusers":"모든 활성 사용자","viewuser":"사용자 보기","partofokta":"이 사용자는 Okta 조직의 일부입니다.","userdeactive":"사용자가 비활성 상태입니다","showing":"보여주기","of":"의","answerpartofquestion":"대답은 질문의 일부가 아니어야 합니다.","activationpending":"귀하의 요청이 활성화 대기 중입니다, 전화번호를 업데이트하지 않으면 SMS가 재설정 이전 전화번호로 전송됩니다.","change_forgot_pwd_qtn":"보안 질문 변경:","basicinfo":"기본 정보","gotoapp":"어플리케이션에 접속하려면 아래를 클릭하십시오.","passwordresetsuccess":"비밀번호가 성공적으로 재설정되었습니다.","passwordreset":"비밀번호 재설정 완료","searchinfotext":"*검색은 앱에서만 수행됩니다","tmlabel":"구성","delete":"삭제","search":"검색","nop":"숫자","nop_inst":"국가 코드번호 없이 전화번호 숫자만 입력해주세요","nopMobile":"휴대폰 번호","statusactive":"액티브","statuspending":"활성화 보류 중","globalsearch":"다른 사용자 검색","permissiondenied":"이 사용자를 삭제/비활성화할 수 없습니다. 다른 그룹에 배치된 사용자입니다. 대신 사용자 할당을 취소할 수 있습니다.","activestatus":"활성","provisionedstatus":"프로비저닝","deprovisionedstatus":"프로비저닝 해제","save":"저장","admingroup":"관리자 그룹","application":"애플리케이션","selectadmingroup":"관리자 그룹 선택","selectapp":"애플리케이션 선택","adminConfigIncomplete":"행이 불완전합니다. 관리자 그룹, 브랜드 및 관리 그룹을 배치하여 행을 저장하거나 제거하십시오.","adminconfigdeletesuccess":"성공적으로 삭제되었습니다","adminconfigupdatesuccess":"구성이 성공적으로 업데이트되었습니다","wanttodeleteadminconfig":"이 구성을 삭제하시겠습니까?","cannotdeleteconfig":"이 구성은 삭제할 수 없습니다.","nonanoktauser":"이 행동을 실행할 수 없습니다. 이 사용자의 ID 공급자는 Okta가 아닙니다.","reactivate":"초대 다시 보내기","wanttoreactivate":"사용자에게 활성화 링크를 다시 보내시겠습니까?","iread1":"본인은 카길 고객 포털 및 이를 통해 사용할 수 있는 애플리케이션 및 서비스가 카길 고객 포털의 적용을 받는다는 데 동의합니다.","iread2":"이용 약관","iread3":", 이는 각 해당 비즈니스 서비스에 대한 특정 이용 약관에 의해 보완되거나 수정될 수 있습니다.","iagree1":"본인은 카길이 카길의 고객 포털, 애플리케이션 및 서비스와 관련된 개인 데이터 처리에 있어 카길의 영향하에 있음을 인지하고 동의합니다","iagree2":"온라인 개인 정보 보호 정책","iagree3":", 각 해당 비즈니스 서비스에 대한 '개인 정보 보호 고지'에 의해 보완되거나 수정될 수 있습니다.","privacypolicy_link":"https://www.cargill.com/page/privacy","termsandconditions_link":"https://www.cargill.com/portal-terms","resetreactivate":"재설정/재활성화:","emailinvaliddomain":"기본 정보","administeredgroups":"신청서에 액세스하려면 아래를 클릭하십시오.","selectgroupslist":"비밀번호가 성공적으로 재설정되었습니다.","alreadyactive":"사용자 활성화 완료!","alreadyactivesetup":"당신의 계정은 등록이 요구되지 않습니다. 카길 직원의 아이디로 로그인하여 신청내역서에 로그인하세요.","selectBrand":"구성을 선택하세요","permissiondeniedreset":"본 사용자는 비밀번호 재설정이 불가합니다.","unlockaccount":"계정 잠금 해제하기","unlockaccountsuccess":"당신의 계정을 성공적으로 잠금 해제하였습니다","accountunlocked":"계정 잠금 해제 완료!","copyrefid":"계속하기 위하여 수신하신 이메일 하단의 참조 아이디를 복사하여, 아래에 붙여넣기를 하세요.","securityquestionanswerweak":"보안 질문 답변이 너무 약합니다. 답변이 질문의 내용이 포함되지 않아야 합니다","securityanswermatchesquestion":"보안 답변이 잘못되었습니다: 답변에 보안 질문의 일부인 $가 포함되어서는 안 됩니다","copysecurityanswermatchesquestion":"보안 답변이 잘못되었습니다: 답변에 보안 질문의 일부인 $가 포함되어서는 안 됩니다","tokenInvalidShortMessage":"활성화 링크가 더 이상 유효하지 않습니다.","browserspecificmsg":"최적의 환경을 위해 Chrome 사용을 권장합니다.","enterActivationDetails":"아래 요청된 정보를 보실려면 활성화 이메일을 참조하세요.","resendActivation":"활성화 이메일 다시 보내기","reinvite":"초대 다시 보내기","reinviteEmailMessage":"제공한 정보가 올바르면 새 활성화 이메일을 받게 됩니다.","reinviteContactAdminMessage":"새 활성화 이메일을 받지 못한 경우 Cargill 비즈니스 담당자에게 문의하십시오.","activationOk":"Ok","activationTitle":"다시 초대하기 양식 선택","activationDescription":"다시 초대하기를 위한 이메일 양식을 선택해주세요","template":"양식","isDxpApp":"구성이 성공적으로 업데이트되었습니다","cargillActivation":"카길 활성화 양식","activationTemplateTitle":"활성화 양식 선택","activationTemplateDescription":"활성화를 위한 이메일 양식을 선택해주세요","selfRegistrationGrp":"초대 다시 보내기","maxNoUsers":"회원가입 가능한 사용자 수의 한계에 다달았습니다.","dxpActivation":"DXP 활성화","selfRegistration":"셀프 등록","selfApp":"셀프 등록 그룹","selfRegGrp":"셀프 등록 하위 그룹","disableExistingUserOnboard":"기존 사용자 비활성화하기","selfRegSubGrps":"셀프 등록 추가 그룹","selectReggroup":"등록 그룹 선택","selfRegister":"등록","selfRegFormTitle":"가입","E0001":"죄송합니다. 계정 설정에 있어 문제가 발생하였습니다.","E0001_1":"에 문의하여주시기 바랍니다. 감사합니다","E0001_2":"계정 설정에 도움이 필요하시다면.","E0002":"계정 설정에 도움이 필요하시다면.","E0003":"귀하의 계정이 성공적으로 등록되었습니다. ","E0003_1":"계정 활성화 지침과 함께.","E0004":"귀하의 계정이 성공적으로 등록되었습니다. 이제 기존 비밀번호를 사용하여 어플리케이션에 로그인 하실 수 있습니다. 비밀번호가 기억나지 않으시면 어플리케이션의 \"비밀번호 찾기\" 옵션을 사용하여 비밀번호를 재설정하십시오.","noSpecialCharacters":"특수 문자는 허용되지 않습니다","nameUpdated":"이름 및 성이 성공적으로 업데이트되었습니다.","selfRegistrationEmailId":"이메일 ID/웹페이지 URL","phoneValidationErrorMessage":"암호 요구 사항이 충족되지 않았습니다. 비밀번호 요구 사항: 비밀번호는 최소 8자 이상이어야 하며, 소문자, 대문자, 숫자가 포함되고, 아이디와 겹치는 부분이 없어야 합니다. 새 비밀번호는 최근 24개의 예전 비밀번호와 일치할 수 없습니다.","acceptTerms":"계속 진행하려면 개인 정보 보호 정책 및 이용 약관에 동의하세요.","phoneVerificationNotCompleted":"계속하려면 전화 번호를 확인 / 제거하십시오.","verifyPhoneWarning":"전화번호를 인증하려면 '인증번호 보내기'를 클릭하세요.","viewMoreInfo":"더 많은 정보 보기","infoContent":"사용자에 대한 자세한 정보 보기","createdDate":"만든 날짜","activatedDate":"활성화 된 날짜","lastLoginDate":"마지막 로그인 날짜","lastUpdatedDate":"마지막 업데이트 날짜","passwordChangedDate":"비밀번호 변경 날짜","statusChangedDate":"상태 변경 날짜","createdDateDescription":"Okta에서 사용자 기록이 생성된 날짜 및 시간.","activatedDateDescription":"마지막 사용자 활성화 이메일이 전송된 날짜 및 시간","statusChangedDateDescription":"Okta에서 사용자 상태가 마지막으로 변경된 날짜 및 시간","lastLoginDateDescription":"Okta에서 사용자가 마지막으로 로그인한 날짜 및 시간(특정 애플리케이션 아님).","lastUpdatedDateDescription":"Okta에서 사용자 레코드가 마지막으로 업데이트된 날짜 및 시간","passwordChangedDateDescription":"사용자가 마지막으로 비밀번호를 변경한 날짜 및 시간","resetMFATitle":"다단계 인증 재설정","noFactorExist":"이 사용자에 대한 요청이 없습니다.","mfaValidation":"재설정할 요청을 선택하십시오.","resetButton":"재설정","mfaResetModalTitle":"MFA 재설정","factorResetSuccess":"팩터가 성공적으로 재설정되었습니다.","resetConfirmation":"이 사용자에 대해 MFA를 다시 설정하시겠습니까?","copyrights":"Cargill, 통합. 판권 소유.","reportLabel":"보고서","bulkUploadLabel":"대량 업로드 사용자","availableIndependentGroups":"사용 가능한 독립 그룹:","selectedBrand":"선택한 브랜드:","bulkUploadOptionsLabel":"대량 업로드 옵션","bulkCreateUsers":"사용자 대량 생성","bulkReinviteUsers":"사용자 대량 재초대","confirm":"확인하다","downloadExcelTemplate":"엑셀 템플릿 다운로드:","uploadInstruction":"템플릿 다운로드 후 엑셀 시트를 작성하여 아래 섹션을 사용하여 업로드","uploadWarningOne":"한 번에 최대 50명의 사용자만 허용됩니다.","uploadWarningTwo":"이메일 필드가 비어 있지 않은지 확인하십시오.","uploadWarningThree":"제공된 이메일 ID를 귀하가 관리하는지 확인하십시오.","uploadWarningFour":"비어 있는 필드가 없는지 확인하십시오.","uploadWarningFive":"모든 필드 값이 유효한지 확인하십시오.","uploadWarningSix":"제공된 그룹 ID를 귀하가 관리하는지 확인하십시오.","uploadNote":"이 프로세스를 통해 전송된 초대는 표준 카길 계정 초대 이메일을 따릅니다.","uploadLabel":"업로드","action":"행위","userword":"사용자","note":"메모:","authentication":"입증","noTableData":"테이블에 대한 데이터가 없습니다.","readOnlyGroup":"이것은 읽기 전용 그룹입니다. 이 그룹에 대한 할당은 access.cargill.com을 통해서만 이루어져야 합니다.","adminPermissionDenied":"사용자 관리자 권한에는 이 그룹 할당을 수정할 수 있는 권한이 없습니다.","msgForGenericErrorUA":"현재 귀하의 요청을 처리하는 데 문제가 있습니다. 나중에 다시 시도 해주십시오. 이 오류가 계속 표시되면 고객 서비스 담당자에게 문의하여 추가 지원을 받으십시오.","passcodeRateLimit":"요청을 처리할 수 없습니다. 5분 후에 다시 시도하십시오.","passcodeNotEntered":"확인하려면 비밀번호를 입력하세요.","msgForUnhandledResponse":"요청을 처리할 수 없습니다. 고객 서비스 담당자에게 문의하세요.","groupUnavailable":"해당 그룹은 더 이상 Okta에서 사용할 수 없습니다. 그룹이 삭제되었을 수 있습니다.","groupCannotBeAssigned":"$ 그룹은 더 이상 Okta에서 사용할 수 없으므로 사용자에게 할당할 수 없습니다. 그룹을 삭제하고 진행해주세요.","copyGroupCannotBeAssigned":"$ 그룹은 더 이상 Okta에서 사용할 수 없으므로 사용자에게 할당할 수 없습니다. 그룹을 삭제하고 진행해주세요."}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports = {"1":"Verenigde Staten","7":"Russische Federatie","20":"Egypte","27":"Zuid-Afrika","30":"Griekenland","31":"Nederland","32":"België","33":"Frankrijk","34":"Spanje","36":"Hongarije","39":"Italië","40":"Roemenië","41":"Zwitserland","43":"Oostenrijk","44":"Verenigd Koningkrijk","45":"Denemarken","46":"Zweden","47":"Svalbard en Jan Mayen","48":"Polen","49":"Duitsland","51":"Peru","52":"Mexico","53":"Cuba","54":"Argentinië","55":"Brazilië","56":"Chili","57":"Colombia","58":"Venezuela, Bolivariaanse Republiek","60":"Maleisië","61":"Kersteiland","62":"Indonesië","63":"Filippijnen","64":"Nieuw-Zeeland","65":"Singapore","66":"Thailand","81":"Japan","82":"Korea, republiek van","84":"Vietnam","86":"China","90":"kalkoen","91":"Indië","92":"Pakistan","93":"Afghanistan","94":"Sri Lanka","95":"Myanmar","98":"Iran, Islamitische Republiek","211":"Zuid-Soedan","212":"Westelijke Sahara","213":"Algerije","216":"Tunesië","218":"Libië","220":"Gambia","221":"Senegal","222":"Mauritanië","223":"Mali","224":"Guinea","225":"Ivoorkust","226":"Burkina Faso","227":"Niger","228":"Gaan","229":"Benin","230":"Mauritius","231":"Liberia","232":"Sierra Leone","233":"Ghana","234":"Nigeria","235":"Tsjaad","236":"Centraal Afrikaanse Republiek","237":"Kameroen","238":"Kaapverdië","239":"Sao Tomé en Principe","240":"Equatoriaal-Guinea","241":"Gabon","242":"Congo","243":"Congo, Democratische Republiek van de","244":"Angola","245":"Guinee-Bissau","246":"Brits-Indisch oceaan gebied","248":"Seychellen","249":"Soedan","250":"Rwanda","251":"Ethiopië","252":"Somalië","253":"Djibouti","254":"Kenia","255":"Tanzania, Verenigde Republiek","256":"Oeganda","257":"Boeroendi","258":"Mozambique","260":"Zambia","261":"Madagascar","262":"Bijeenkomst","263":"Zimbabwe","264":"Namibië","265":"Malawi","266":"Lesotho","267":"Botswana","268":"Swaziland","269":"Comoren","290":"Sint-Helena, Ascension en Tristan da Cunha","291":"Eritrea","297":"Aruba","298":"Faeröer","299":"Groenland","350":"Gibraltar","351":"Portugal","352":"Luxemburg","353":"Ierland","354":"IJsland","355":"Albanië","356":"Malta","357":"Cyprus","358":"Finland","359":"Bulgarije","370":"Litouwen","371":"Letland","372":"Estland","373":"Moldavië","374":"Armenië","375":"Wit-Rusland","376":"Andorra","377":"Monaco","378":"San Marino","379":"Heilige Stoel (Vaticaanstad)","380":"Oekraïne","381":"Servië","382":"Montenegro","385":"Kroatië","386":"Slovenië","387":"Bosnië-Herzegovina","389":"Macedonië","420":"Tsjechische Republiek","421":"Slowakije","423":"Liechtenstein","500":"Zuid-Georgië en de Zuidelijke Sandwicheilanden","501":"Belize","502":"Guatemala","503":"El Salvador","504":"Honduras","505":"Nicaragua","506":"Costa Rica","507":"Panama","508":"Saint Pierre en Miquelon","509":"Haïti","590":"Guadeloupe","591":"Bolivia","592":"Guyana","593":"Ecuador","595":"Paraguay","596":"Martinique","597":"Suriname","598":"Uruguay","599":"Nederlandse Antillen","670":"Timor-Leste","672":"Norfolkeiland","673":"Brunei Darussalam","674":"Nauru","675":"Papoea-Nieuw-Guinea","676":"Tonga","677":"Solomon eilanden","678":"Vanuatu","679":"Fiji","680":"Palau","681":"Wallis en Futuna","682":"Cookeilanden","683":"Niue","685":"Samoa","686":"Kiribati","687":"Nieuw-Caledonië","688":"Tuvalu","689":"Frans Polynesisch","690":"Tokelau","691":"Micronesië","692":"Marshall eilanden","850":"Korea, Democratische Volksrepubliek","852":"Hong Kong","853":"Macao","855":"Cambodja","856":"Lao Democratische Volksrepubliek","880":"Bangladesh","886":"Taiwan","960":"Maldiven","961":"Libanon","962":"Jordanië","963":"Syrische Arabische Republiek","964":"Irak","965":"Koeweit","966":"Saoedi-Arabië","967":"Jemen","968":"Oman","970":"Palestina","971":"Verenigde Arabische Emiraten","972":"Israël","973":"Bahrein","974":"Katar","975":"Bhutan","976":"Mongolië","977":"Nepal","992":"Tadzjikistan","993":"Turkmenistan","994":"Azerbeidzjan","995":"Georgië","996":"Kirgizië","998":"Oezbekistan","1242":"Bahamas","1246":"Barbados","1264":"Anguilla","1268":"Antigua en Barbuda","1284":"Britse Maagdeneilanden","1340":"Maagdeneilanden, VS.","1345":"Kaaiman Eilanden","1441":"Bermuda","1473":"Grenada","1649":"Turks- en Caicoseilanden","1664":"Montserrat","1670":"noordelijke Mariana eilanden","1671":"Guam","1684":"Amerikaans Samoa","1758":"Saint Lucia","1767":"Dominica","1784":"Saint Vincent en de Grenadines","1787":"Puerto Rico","1809":"Dominicaanse Republiek","1868":"Trinidad en Tobago","1869":"Saint Kitts en Nevis","1876":"Jamaica","441481":"Guernsey","441534":"Jersey","registration":"registratie","hello":"Hallo","welcome_cargill":"Welkom bij","user_reg":"Gebruikersregistratie","enter_new_pwd":"Voer nieuw wachtwoord in","pwd_rule":"Uw wachtwoord moet minimaal 8 tekens bevatten, een kleine letter, een hoofdletter, een nummer, geen delen van uw gebruikersnaam.","repeat_pwd":"Herhaal nieuw wachtwoord","choose_forgot_pwd_qtn":"Kies een vergeten wachtwoordvraag","stock_qtn":"Standaard vragen","disliked_food":"Wat is het voedsel dat je als kind het minst lekker vond?","name_of_first_plush_toy":"Wat is de naam van je eerste knuffeldier?","first_award":"Waarvoor heb je je eerste medaille of prijs verdiend?","favorite_security_question":"Wat is je favoriete beveiligingsvraag?","favorite_toy":"Wat is het speelgoed / knuffeldier dat je het leukst vond als kind?","first_computer_game":"Wat was het eerste computerspel dat je speelde?","favorite_movie_quote":"Wat is je favoriete filmcitaat?","first_sports_team_mascot":"Wat was de mascotte van het eerste sportteam waarop je speelde?","first_music_purchase":"Welk muziekalbum of nummer heb je voor het eerst gekocht?","favorite_art_piece":"Wat is je favoriete kunstwerk?","grandmother_favorite_desert":"Wat was het favoriete dessert van je oma?","first_thing_cooked":"Wat was het eerste dat je leerde koken?","childhood_dream_job":"Wat was je droombaan als kind?","place_where_significant_other_was_met":"Waar hebt u uw echtgenoot / echtgenote ontmoet?","favorite_vacation_location":"Waar ben je naartoe gegaan voor je favoriete vakantie?","new_years_two_thousand":"Waar was je op oudejaarsavond in het jaar 2000?","favorite_speaker_actor":"Wie is je favoriete spreker / redenaar?","favorite_book_movie_character":"Wie is je favoriete boek / filmpersonage?","favorite_sports_player":"Wie is je favoriete sportspeler?","custom_qtn":"Aangepaste vraag","own_sec_qtn":"Maak je eigen beveiligingsvraag","answer":"Antwoord","phone_inst":"Optioneel: Voer een telefoonnummer voor accountherstel in. Dit telefoonnummer wordt alleen gebruikt voor het verzenden van verificatiecodes voor sms-berichten.","optional":"(Optioneel)","sms_inst":"Okta kan u een sms-bericht sturen met een herstelcode. Deze functie is handig als u geen toegang hebt tot uw e-mail.","add_ph_no":"Voeg telefoonnummer toe","create_acc":"Maak mijn account","forgot_pwd_header":"Wachtwoord vergeten Tekstbericht","enter_phone_no":"Voer het telefoonnummer in dat u gebruikt om codes per sms te ontvangen en klik vervolgens op Code verzenden om te controleren of het werkt.","country":"land","country_inst":"Selecteer het land waar uw telefoon is geregistreerd.","back":"Opnieuw verzenden","phone_number":"Telefoonnummer","phone_number_inst":"Voer uw nummer in zoals u het normaal kiest. Voeg niet uw landcode toe","code_prefix":"landcode prefix.","send_code":"Code verzenden","done":"Gedaan","verify":"Verifiëren","enter_code":"Voer code in","enter_code_rule":"Controleer uw telefoon op de toegangscode en voer deze hieronder in. Uw bericht zou binnen een minuut moeten aankomen.","verify_success":"Telefoonnummer succesvol geverifieerd!","click":"Klik","finish_setup":"om de installatie te voltooien.","error_review":"Controleer het formulier om de volgende fouten te corrigeren","phone_no_not_found":"Het sms-bericht kan niet worden verzonden omdat er geen telefoonnummer in de database is gevonden.","noLowerCase":"Moet ten minste één kleine letter bevatten","noUpperCase":"Moet ten minste één hoofdletter bevatten","noNumber":"Moet ten minste één nummer bevatten","noSpecialCharacter":"Moet minimaal één speciaal teken bevatten","notMinLength":"Moet minimaal $ tekens bevatten","noUsernameSubstring":"Mag geen deel van de gebruikersnaam bevatten","noFirstnameSubstring":"Mag geen deel van uw voornaam bevatten","noLastnameSubstring":"Mag geen deel van uw achternaam bevatten","tokenNotValid":"Uw activeringstoken is niet langer geldig","tokenInvalidInfo":"Dit kan gebeuren als u op uw activeringslink hebt geklikt na het maken van uw account, uw activeringslink is verlopen of de URL onjuist is","reqNewToken":"Vraag een nieuw token aan","passcodeNotValid":"Uw toegangscode komt niet overeen met onze gegevens. Probeer het opnieuw.","OTPEnableAfter30Sec":"Er is onlangs een sms-bericht verzonden. Wacht 30 seconden voordat u het opnieuw probeert.","phoneNoAlreadySet":"Het telefoonnummer is al geverifieerd door deze gebruiker.","emptypassword":"Wachtwoord mag niet leeg zijn","passwordlength":"Wachtwoord mag niet leeg zijn","passwordnotvalid":"Wachtwoord is niet geldig","passwordnotmatching":"Wachtwoorden moeten overeenkomen","answerlength":"Het antwoord moet minimaal $ tekens lang zijn","phonenumbermissing":"Verifieer de toegangscode die je hebt ontvangen om door te gaan","customQuestionEmpty":"Aangepaste vraag mag niet leeg zijn","customQAsame":"Aangepaste vraag en antwoord kunnen niet hetzelfde zijn","passwordSameasPrev":"Wachtwoord kan niet uw huidige wachtwoord zijn","answerWrong":"Het antwoord op de herstelvraag kwam niet overeen met onze gegevens","phonealreadyactive":"Dit nummer is al geverifieerd. Probeer een ander nummer als u wilt bijwerken","first_name":"Voornaam","last_name":"Achternaam","enter_email":"E-mail identiteit","emailNotValid":"Email ID niet geldig","registeredapps":"Geregistreerde apps","waitingapps":"Apps wachten op goedkeuring","requestaccess":"Toegang vragen","admin":"beheerder","selectLang":"Selecteer taal","dashboardLabel":"Dashboard","resetpwd":"Reset wachtwoord","ansForgotten":"Antwoord vergeten wachtwoord uitdaging","resetOktaPwd":"Reset uw Okta-wachtwoord","newpwd":"nieuw paswoord","rptpwd":"Herhaal wachtwoord","adminLabel":"Gebruikersbeheer","userAdministration":"Gebruikersbeheer","adduser":"Voeg een nieuwe gebruiker toe","function":"Functie","emailAddress":"E-mailadres","filterApp":"Filtertoepassing","create":"creëren","logoutConfirm":"Weet u zeker dat u wilt uitloggen?","no":"Nee","yes":"Ja","logout":"Uitloggen","expireWarning":"Uw sessie verloopt over% minuten, druk op OK om ingelogd te blijven of druk op Annuleren om uit te loggen. Als u de verbinding verbreekt, gaan wijzigingen verloren","update":"Bijwerken","activateDeactivate":"Activeren / deactiveren","attention":"Aandacht","cancel":"annuleren","sessionTimedout":"Uw sessie is verlopen. Log alsjeblieft nogmaals in","username":"Gebruikersnaam","primary_mail":"primaire email","secondary_mail":"Secundaire e-mail (optioneel)","groups":"groepen","must_email":"Moet een e-mail zijn","ieNotSupported":"IE wordt niet ondersteund","tryChrome":"Internet Explorer wordt niet ondersteund. We raden aan Chrome voor deze app te gebruiken.","close":"Dichtbij","forgotSQA":"beveiligingsantwoord vergeten?","resetSecQA":"Reset beveiligingsvraag en wachtwoord","retry":"Ga terug","nofactorpresent":"Deze optie kan niet worden gebruikt omdat het mobiele nummer niet is ingesteld. Neem contact op met uw beheerder.","emptypasscode":"Code mag niet leeg zijn","provisioned":"Deze gebruiker is nog niet geregistreerd. Wachtwoord kan alleen worden gereset nadat de gebruiker actief is","deprovisioned":"Deze gebruiker is gedeactiveerd. Wachtwoord kan alleen worden gereset nadat de gebruiker actief is","resetsuccesspopupmsg":"Wachtwoord reset link is verzonden naar e-mailadres. Sluit de pop-up met de X-knop.","wanttoreset":"Wilt u het wachtwoord opnieuw instellen?","wanttoactivate":"Wilt u de gebruiker activeren?","wanttodeactivate":"Wilt u de gebruiker deactiveren? ","wanttodelete":"Wilt u de gebruiker verwijderen?","updateprofile":"Profiel bijwerken","updatesuccess":"Gebruiker is succesvol bijgewerkt","usercreated":"* Gebruiker gemaakt","errorcreatinguser":"* Fout bij het aanmaken van gebruiker / e-mailadres bestaat al","privacypolicy":"Privacybeleid","termsandconditions":"Voorwaarden","uname-email":"Gebruikersnaam / e-mail","password_placeholder":"Wachtwoord","sign-in":"Log in","resetmailsent":"Er is een e-mail verzonden naar% met de link voor het opnieuw instellen van het wachtwoord.","smssent":"verzonden","resendcode":"Code nogmaals versturen","needhelp":"Hulp nodig bij het inloggen?","forgotPassword":"Wachtwoord vergeten?","helplink":"Helpen","smsusage":"SMS kan alleen worden gebruikt als er een mobiel telefoonnummer is geconfigureerd.","backtosignin":"Terug naar inloggen","resetviasms":"Resetten via sms","resetviaemail":"Resetten via e-mail","didntreceivecode":"Geen code ontvangen? resetten via e-mail","emailsent":"Email verzonden!","recoverycredentialsnotset":"Wachtwoord vergeten niet toegestaan ​​omdat herstelreferenties niet zijn ingesteld voor de gebruiker","usernotpresent":"Gebruiker niet aanwezig","mobilenumbernotset":"Mobiel nummer niet ingesteld","invalidcreds":"ongeldige gebruikersnaam of wachtwoord","emailreq":"Email verplicht","emailinvalid":"Email ongeldig","pwdreq":"wachtwoord benodigd","otplength":"OTP moet 6 tekens lang zijn","passcodeinvalid":"Ongeldige OTP","firstnamereq":"Voornaam (verplicht","lastnamereq":"Achternaam verplicht","notallowedincurrentstate":"Deze bewerking is niet toegestaan ​​in de huidige verificatiestatus","nopartsofusername":"Wachtwoord mag geen delen van uw gebruikersnaam bevatten, inclusief uw voornaam of uw achternaam","passwordusedrecently":"Wachtwoord is te recent gebruikt","passwordnotmetrequirements":"Het wachtwoord voldoet niet aan de complexiteitseisen van het huidige wachtwoordbeleid","antar":"Antarctica","aus":"Australië","can":"Canada","falk":"Falkland Eilanden (Malvinas)","kazak":"Kazachstan","mayotte":"Mayotte","morocco":"Marokko","norway":"Noorwegen","pitcairn":"Pitcairn","filteruser":"Filter gebruikers op app","selectgroups":"Selecteer toepassing","status":"Status","atleastonegroup":"Selecteer ten minste één groep waaraan u een gebruiker wilt toewijzen","answerchallenge":"Antwoord vergeet wachtwoord uitdaging","entersmscode":"Voer verificatiecode in die is verzonden via sms","enterusercreds":"Voer gebruikersgegevens in","inviteuser":"Nieuwe gebruiker uitnodigen","assignApplication":"Toewijzen aan toepassing","availablegroups":"Beschikbare groepen","selectedgroups":"Toegewezen groepen","emailsenttouser":"E-mail succesvol verzonden naar","pendingactivation":"In afwachting van accountactivering","exit":"Uitgang","myprofile":"Mijn profiel","activatesuccess":"Gebruiker is succesvol geactiveerd en een activeringsmail is verzonden naar","deactivatesuccess":"is succesvol gedeactiveerd","deletesuccess":"is succesvol verwijderd","edituser":"bewerk gebruiker","getstarted":"Begin","congrats":"Gefeliciteerd!","accountsetup":"U hebt uw accountconfiguratie voltooid.","edit":"Bewerk","assignedapps":"Toegewezen toepassingen","assignedgroups":"Toegewezen groepen","oldpwd":"Voer oud wachtwoord in","changepwd":"Wachtwoord wijzigen","updatephone":"Update telefoon","pwdupdated":"Wachtwoord is succesvol bijgewerkt","QAupdated":"Antwoord op beveiligingsvraag is succesvol bijgewerkt","phonenumberinvalid":"Telefoonnummer is ongeldig","phoneupdated":"Telefoonnummer succesvol bijgewerkt","showmore":"Laat meer zien","verifypassword":"Bevestig wachtwoord","filterusergrp":"Filter gebruikers op groep","allactiveusers":"Alle actieve gebruikers","viewuser":"Bekijk gebruiker","partofokta":"Deze gebruiker maakt deel uit van Okta-organisatie","userdeactive":"Gebruiker is deactive","showing":"Resultaat","of":"van","answerpartofquestion":"Antwoord mag geen deel uitmaken van de vraag","activationpending":"Uw factor is in afwachting van activering. Werk uw telefoonnummer bij, anders worden de reset-sms'jes verzonden naar uw vorige actieve nummer","change_forgot_pwd_qtn":"Wijzig beveiligingsvraag","basicinfo":"Basis informatie","gotoapp":"Klik op de toepassing waarnaar u wilt gaan","passwordresetsuccess":"Uw wachtwoord is succesvol gereset","passwordreset":"Wachtwoord reset!","searchinfotext":"* Zoeken gebeurt alleen op app","tmlabel":"Configuratie","delete":"Verwijder","search":"Zoeken","nop":"Aantal","nop_inst":"Voer uw nummer in zoals u het normaal kiest. Voeg niet uw landcode toe","nopMobile":"Mobiel nummer","statusactive":"Actief","statuspending":"In afwachting van activering","globalsearch":"Zoeken naar andere gebruikers","permissiondenied":"U kunt deze gebruiker niet verwijderen / deactiveren. gebruiker toegewezen aan andere groepen. U kunt in plaats daarvan de toewijzing van de gebruiker ongedaan maken","activestatus":"ACTIEF","provisionedstatus":"bevoorraad","deprovisionedstatus":"uitgeschreven","save":"Opslaan","admingroup":"Beheerdersgroep","application":"Toepassing","selectadmingroup":"Selecteer beheerdersgroep","selectapp":"Selecteer toepassing","adminConfigIncomplete":"Rij onvolledig. Wijs een beheerdersgroep toe om de rij op te slaan of te verwijderen","adminconfigdeletesuccess":"Met succes verwijderd","adminconfigupdatesuccess":"Config succesvol bijgewerkt","wanttodeleteadminconfig":"Wilt u deze configuratie verwijderen?","cannotdeleteconfig":"Deze configuratie kan niet worden verwijderd","nonanoktauser":"Niet toegestaan ​​om deze actie te doen. De identiteitsprovider van deze gebruiker is niet Okta.","reactivate":"Uitnodiging opnieuw verzenden","wanttoreactivate":"Wilt u de activeringslink opnieuw naar de gebruiker verzenden?","iread1":"Ik ga ermee akkoord dat de Cargill-klantportals, -applicaties en -services die via hen beschikbaar zijn, onder de klantenportal van Cargill vallen","iread2":"Voorwaarden","iread3":", die kan worden aangevuld of gewijzigd met specifieke voorwaarden voor elke toepasselijke zakelijke service.","iagree1":"Ik erken en accepteer dat Cargill's verwerking van persoonsgegevens in verband met Cargill-klantportals, -applicaties en -diensten onderhevig is aan","iagree2":"Online privacybeleid","iagree3":", die kan worden aangevuld of gewijzigd met 'Privacykennisgevingen' voor elke toepasselijke zakelijke service.","privacypolicy_link":"https://www.cargill.com/page/privacy","termsandconditions_link":"https://www.cargill.com/portal-terms","resetreactivate":"Reset / opnieuw activeren","emailinvaliddomain":"Gebruiker met dit domein kan niet worden toegevoegd","administeredgroups":"Beheerde groepen","selectgroupslist":"Selecteer groepen","alreadyactive":"U bent een actieve gebruiker!","alreadyactivesetup":"Uw profiel vereist geen registratie. Gebruik Cargill-werknemerslogin om u aan te melden bij uw applicaties.","selectBrand":"Selecteer merk","permissiondeniedreset":"U kunt het wachtwoord voor deze gebruiker niet opnieuw instellen. ","unlockaccount":"Account ontgrendelen","unlockaccountsuccess":"Uw account is succesvol ontgrendeld","accountunlocked":"Account ontgrendeld!","copyrefid":"Kopieer de referentie-ID onder aan de e-mail die u hebt ontvangen en plak deze hieronder om door te gaan.","securityquestionanswerweak":"Het antwoord op de beveiligingsvraag is te zwak, het antwoord mag geen deel uitmaken van de vraag","securityanswermatchesquestion":"Beveiligingsantwoord ongeldig: het antwoord mag geen $ bevatten, wat deel uitmaakt van de beveiligingsvraag","copysecurityanswermatchesquestion":"Beveiligingsantwoord ongeldig: het antwoord mag geen $ bevatten, wat deel uitmaakt van de beveiligingsvraag","tokenInvalidShortMessage":"Uw activatielink is niet meer geldig.","browserspecificmsg":"Overweeg om de Google Chrome-browser te gebruiken.","enterActivationDetails":"Raadpleeg uw activatiemail voor de informatie die hieronder wordt opgevraagd.","resendActivation":"Activatiemail opnieuw verzenden","reinvite":"Uitnodiging opnieuw verzenden","reinviteEmailMessage":"Als de informatie die hebt opgegeven juist is, dan ontvangt u een nieuwe activatiemail.","reinviteContactAdminMessage":"Neem contact op met uw Cargill-contactpersoon als u de nieuwe activatiemail niet ontvangt.","activationOk":"Ok","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","disableExistingUserOnboard":"Disable Existing User","selfRegSubGrps":"Self registration additional group:","selectReggroup":"Select Registration group","selfRegister":"Aanmelden","selfRegFormTitle":"Registreren","E0001":"Er is helaas een probleem opgetreden bij het instellen van uw account. Neem","E0001_1":" contact met ons ","E0001_2":"op voor hulp bij het instellen van uw account.","E0002":" for assistance with setting up your account.","E0003":"Uw account is geregistreerd. Er is een e-mail gestuurd naar ","E0003_1":" met instructies voor het activeren van uw account.","E0004":"Uw account is geregistreerd. U kunt nu met uw bestaande wachtwoord inloggen bij de app.  Als u uw wachtwoord niet meer weet, kunt u de optie 'Wachtwoord vergeten' gebruiken om uw wachtwoord voor de app te resetten","E0005":"User already exists with status ","E0005_1":" Please contact ","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"Er is niet voldaan aan de wachtwoordvereisten. Wachtwoordvereisten: minimaal 8 tekens, een kleine letter, een hoofdletter, een cijfer, geen delen van uw gebruikersnaam. Uw wachtwoord mag niet een van uw laatste 24 wachtwoorden zijn.","acceptTerms":"Accepteer ons privacybeleid en onze algemene voorwaarden om door te gaan.","phoneVerificationNotCompleted":"Verifieer/verwijder uw telefoonnummer om door te gaan.","verifyPhoneWarning":"Klik op 'Code verzenden' om uw telefoonnummer te verifiëren","viewMoreInfo":"Bekijk meer informatie","infoContent":"Bekijk meer info over de Gebruiker","createdDate":"Aanmaakdatum","activatedDate":"Geactiveerde datum","lastLoginDate":"Laatste inlogdatum","lastUpdatedDate":"Datum laatste update","passwordChangedDate":"Datum wachtwoord gewijzigd","statusChangedDate":"Status gewijzigde datum","createdDateDescription":"Datum en tijd waarop gebruikersrecord is gemaakt in Okta.","activatedDateDescription":"Datum en tijd waarop de laatste activeringsmail van de gebruiker is verzonden.","statusChangedDateDescription":"Datum en tijd waarop de gebruikersstatus voor het laatst is gewijzigd in Okta.","lastLoginDateDescription":"Datum en tijd waarop de gebruiker zich voor het laatst heeft aangemeld bij Okta (niet toepassingsspecifiek).","lastUpdatedDateDescription":"Datum en tijd waarop het gebruikersrecord voor het laatst is bijgewerkt in Okta.","passwordChangedDateDescription":"Datum en tijd waarop de gebruiker zijn wachtwoord voor het laatst heeft gewijzigd.","resetMFATitle":"Meerfactorauthenticatie resetten","noFactorExist":"Er bestaat geen factor voor deze gebruiker.","mfaValidation":"Selecteer een factor om te resetten.","resetButton":"Resetten","mfaResetModalTitle":"MFA-reset","factorResetSuccess":"Factor is succesvol gereset.","resetConfirmation":"Weet u zeker dat u MFA voor deze gebruiker wilt resetten?","copyrights":"Cargill, opgenomen. Alle rechten voorbehouden.","reportLabel":"Rapport","bulkUploadLabel":"Gebruikers in bulk uploaden","availableIndependentGroups":"Beschikbare onafhankelijke groepen:","selectedBrand":"Geselecteerd merk:","bulkUploadOptionsLabel":"Opties voor bulkuploads","bulkCreateUsers":"Gebruikers in bulk aanmaken","bulkReinviteUsers":"Gebruikers in bulk opnieuw uitnodigen","confirm":"Bevestigen","downloadExcelTemplate":"Excel-sjabloon downloaden:","uploadInstruction":"Vul na het downloaden van de sjabloon het Excel-blad in en upload het met behulp van het onderstaande gedeelte","uploadWarningOne":"Maximaal slechts 50 gebruikers tegelijkertijd toegestaan.","uploadWarningTwo":"Zorg ervoor dat het e-mailveld niet leeg is.","uploadWarningThree":"Zorg ervoor dat de verstrekte e-mail-ID's door u worden beheerd.","uploadWarningFour":"Zorg ervoor dat er geen velden leeg zijn.","uploadWarningFive":"Zorg ervoor dat alle veldwaarden geldig zijn.","uploadWarningSix":"Zorg ervoor dat de verstrekte groeps-ID's door u worden beheerd.","uploadNote":"Uitnodigingen die via dit proces worden verzonden, volgen de standaard Cargill-accountuitnodigingsmail.","uploadLabel":"Uploaden","action":"Acties","userword":"gebruikers","note":"Opmerking:","authentication":"Authenticatie","noTableData":"Geen gegevens voor tabel.","readOnlyGroup":"Dit is een alleen-lezen groep. Toewijzing voor deze groep dient uitsluitend te geschieden via access.cargill.com","adminPermissionDenied":"Uw gebruikersbeheerdersrechten hebben geen machtigingen om deze groepsopdracht te wijzigen.","msgForGenericErrorUA":"Momenteel ondervinden wij een probleem bij het verwerken van uw verzoek. Probeer het later opnieuw. Als u deze fout blijft zien, neem dan contact op met uw klantenservicemedewerker voor verdere hulp.","passcodeRateLimit":"Kan uw verzoek niet verwerken, probeer het over 5 minuten opnieuw.","passcodeNotEntered":"Voer de toegangscode in om te verifiëren.","msgForUnhandledResponse":"Kan het verzoek niet verwerken, neem dan contact op met uw klantenservicemedewerker.","groupUnavailable":"De groep is niet langer beschikbaar in Okta. Mogelijk is de groep verwijderd.","groupCannotBeAssigned":"De groep $ is niet langer beschikbaar in Okta en kan daarom niet aan de gebruiker worden toegewezen. Verwijder de groep en ga verder.","copyGroupCannotBeAssigned":"De groep $ is niet langer beschikbaar in Okta en kan daarom niet aan de gebruiker worden toegewezen. Verwijder de groep en ga verder."}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports = {"1":"Stany Zjednoczone","7":"Federacja Rosyjska","20":"Egipt","27":"Afryka Południowa","30":"Grecja","31":"Holandia","32":"Belgia","33":"Francja","34":"Hiszpania","36":"Węgry","39":"Włochy","40":"Rumunia","41":"Szwajcaria","43":"Austria","44":"Zjednoczone Królestwo","45":"Dania","46":"Szwecja","47":"Svalbard i Jan Mayen","48":"Polska","49":"Niemcy","51":"Peru","52":"Meksyk","53":"Kuba","54":"Argentyna","55":"Brazylia","56":"Chile","57":"Kolumbia","58":"Wenezuela, Boliwariańska Republika","60":"Malezja","61":"Wyspa Bożego Narodzenia","62":"Indonezja","63":"Filipiny","64":"Nowa Zelandia","65":"Singapur","66":"Tajlandia","81":"Japonia","82":"Republika Korei","84":"Wietnam","86":"Chiny","90":"indyk","91":"Indie","92":"Pakistan","93":"Afganistan","94":"Sri Lanka","95":"Myanmar","98":"Iran (Islamska Republika","211":"Południowy Sudan","212":"Sahara Zachodnia","213":"Algieria","216":"Tunezja","218":"Libia","220":"Gambia","221":"Senegal","222":"Mauretania","223":"Mali","224":"Gwinea","225":"Wybrzeże Kości Słoniowej","226":"Burkina Faso","227":"Niger","228":"Iść","229":"Benin","230":"Mauritius","231":"Liberia","232":"Sierra Leone","233":"Ghana","234":"Nigeria","235":"Chad","236":"Republika Środkowoafrykańska","237":"Kamerun","238":"Wyspy Zielonego Przylądka","239":"Sao Tome and Principe","240":"Gwinea Równikowa","241":"Gabon","242":"Kongo","243":"Kongo, Demokratyczna Republika","244":"Angola","245":"Gwinea Bissau","246":"Brytyjskie Terytorium Oceanu Indyjskiego","248":"Seszele","249":"Sudan","250":"Rwanda","251":"Etiopia","252":"Somali","253":"Dżibuti","254":"Kenia","255":"Tanzania, United Republic of","256":"Uganda","257":"Burundi","258":"Mozambik","260":"Zambia","261":"Madagaskar","262":"Reuion","263":"Zimbabwe","264":"Namibia","265":"Malawi","266":"Lesotho","267":"Botswana","268":"Suazi","269":"Komory","290":"Święta Helena, Wniebowstąpienie i Tristan da Cunha","291":"Erytrea","297":"Aruba","298":"Wyspy Owcze","299":"Grenlandia","350":"Gibraltar","351":"Portugalia","352":"Luksemburg","353":"Irlandia","354":"Islandia","355":"Albania","356":"Malta","357":"Cypr","358":"Finlandia","359":"Bułgaria","370":"Litwa","371":"Łotwa","372":"Estonia","373":"Mołdawia","374":"Armenia","375":"Białoruś","376":"Andora","377":"Monaco","378":"San Marino","379":"Stolica Apostolska (Państwo Watykańskie)","380":"Ukraina","381":"Serbia","382":"Czarnogóra","385":"Chorwacja","386":"Słowenia","387":"Bośnia i Hercegowina","389":"Macedonia","420":"Republika Czeska","421":"Słowacja","423":"Liechtenstein","500":"Georgia Południowa i Sandwich Południowy","501":"Belize","502":"Gwatemala","503":"Salwador","504":"Honduras","505":"Nikaragua","506":"Kostaryka","507":"panama","508":"Saint Pierre i Miquelon","509":"Haiti","590":"Gwadelupa","591":"Boliwia","592":"Gujana","593":"Ekwador","595":"Paragwaj","596":"Martynika","597":"Surinam","598":"Urugwaj","599":"Antyle Holenderskie","670":"Timor-Leste","672":"Wyspa Norfolk","673":"Brunei Darussalam","674":"Nauru","675":"Papua Nowa Gwinea","676":"Tonga","677":"Wyspy Salomona","678":"Vanuatu","679":"Fidżi","680":"Palau","681":"Wallis i Futuna","682":"Wyspy Cooka","683":"Niue","685":"Samoa","686":"Kiribati","687":"Nowa Kaledonia","688":"Tuvalu","689":"Francuski Polinezji","690":"Tokelau","691":"Meksyk","692":"Wyspy Marshalla","850":"Korea, Demokratyczna Republika Ludowa","852":"Hongkong","853":"Makao","855":"Kambodża","856":"Laotańska Republika Ludowo-Demokratyczna","880":"Bangladesz","886":"Tajwan","960":"Malediwy","961":"Liban","962":"Jordania","963":"Republika Syryjsko-Arabska","964":"Irak","965":"Kuwejt","966":"Arabia Saudyjska","967":"Jemen","968":"Oman","970":"Palestyna","971":"Zjednoczone Emiraty Arabskie","972":"Izrael","973":"Bahrajn","974":"Katar","975":"Bhutan","976":"Mongolia","977":"Nepal","992":"Tadżykistan","993":"Turkmenia","994":"Azerbejdżan","995":"Gruzja","996":"Kirgistan","998":"Uzbekistan","1242":"Bahamy","1246":"Barbados","1264":"Anguilla","1268":"Antigua i Barbuda","1284":"Wyspy Dziewicze, Brytyjskie","1340":"Wyspy Dziewicze, USA","1345":"Kajmany","1441":"Bermudy","1473":"Grenada","1649":"Wyspy Turks i Caicos","1664":"Montserrat","1670":"Mariany Północne","1671":"Guam","1684":"Samoa Amerykańskie","1758":"święta Lucia","1767":"Dominika","1784":"Saint Vincent i Grenadyny","1787":"Portoryko","1809":"Republika Dominikany","1868":"Trynidad i Tobago","1869":"Saint Kitts i Nevis","1876":"Jamajka","441481":"Guernsey","441534":"Golf","registration":"Rejestracja","hello":"Dzień dobry","welcome_cargill":"Witamy w ","user_reg":"Rejestracja Użytkownika","enter_new_pwd":"Wprowadź nowe hasło","pwd_rule":"Twoje hasło musi mieć co najmniej 8 znaków, małą literę, wielką literę, cyfrę, brak części nazwy użytkownika.","repeat_pwd":"Powtórz nowe hasło","choose_forgot_pwd_qtn":"Wybierz pytanie o zapomniane hasło","stock_qtn":"Pytania magazynowe","disliked_food":"Jakie jedzenie najmniej lubisz jako dziecko?","name_of_first_plush_toy":"Jak nazywa się twoje pierwsze wypchane zwierzę?","first_award":"Za co zdobyłeś swój pierwszy medal lub nagrodę?","favorite_security_question":"Jakie jest twoje ulubione pytanie ochronne?","favorite_toy":"Czym jest zabawka / wypchane zwierzę, które najbardziej lubiłeś jako dziecko?","first_computer_game":"Jaka była pierwsza gra komputerowa, w którą grałeś?","favorite_movie_quote":"Jaki jest twój ulubiony cytat z filmu?","first_sports_team_mascot":"Jaka była maskotka pierwszej drużyny sportowej, w której grałeś?","first_music_purchase":"Jaki album lub utwór muzyczny kupiłeś po raz pierwszy?","favorite_art_piece":"Jakie jest twoje ulubione dzieło sztuki?","grandmother_favorite_desert":"Jaki był ulubiony deser twojej babci?","first_thing_cooked":"Jaka była pierwsza rzecz, której nauczyłeś się gotować?","childhood_dream_job":"Jaka była twoja wymarzona praca jako dziecko?","place_where_significant_other_was_met":"Gdzie spotkałeś swojego małżonka / znaczącego innego?","favorite_vacation_location":"Gdzie poszedłeś na swoje ulubione wakacje?","new_years_two_thousand":"Gdzie byłeś w sylwestra w 2000 roku?","favorite_speaker_actor":"Kto jest twoim ulubionym mówcą / oratorem?","favorite_book_movie_character":"Jaka jest twoja ulubiona postać z książki / filmu?","favorite_sports_player":"Kto jest twoim ulubionym graczem sportowym?","custom_qtn":"Niestandardowe pytanie","own_sec_qtn":"Stwórz własne pytanie bezpieczeństwa","answer":"Odpowiedź","phone_inst":"Opcjonalnie. Proszę wprowadzić zapasowy numer telefonu komórkowego. Numer ten będzie wykorzystywyany wyłącznie do otrzymywania kodów weryfikacyjnych.","optional":"(Opcjonalny)","sms_inst":"Okta może wysłać wiadomość tekstową z kodem odzyskiwania. Ta funkcja jest przydatna, gdy nie masz dostępu do poczty e-mail.","add_ph_no":"+ Dodaj numer telefonu","create_acc":"Stwórz moje konto","forgot_pwd_header":"Zapomniałem hasła wiadomość tekstową","enter_phone_no":"Wprowadź numer telefonu, którego będziesz używać do odbierania kodów za pomocą wiadomości tekstowych, a następnie kliknij przycisk Wyślij kod, aby sprawdzić, czy działa.","country":"Kraj","country_inst":"Wybierz kraj, w którym zarejestrowany jest Twój telefon.","back":"Wysłać ponownie","phone_number":"Numer telefonu","phone_number_inst":"Wprowadź swój numer w taki sposób, w jaki zwykle wybierasz numer. Nie dodawaj swojego kodu kraju","code_prefix":"prefiks kodu kraju.","send_code":"Wyślij kod","done":"Gotowe","verify":"Zweryfikuj","enter_code":"Wprowadź kod","enter_code_rule":"Sprawdź swój telefon pod kątem hasła i wprowadź go poniżej. Twoja wiadomość powinna dotrzeć w mniej niż minutę.","verify_success":"Numer telefonu został pomyślnie zweryfikowany!","click":"Kliknij","finish_setup":"aby ukończyć konfigurację.","error_review":"Przejrzyj formularz, aby poprawić następujące błędy:","phone_no_not_found":"Nie można wysłać wiadomości tekstowej, ponieważ w bazie danych nie znaleziono numeru telefonu.","noLowerCase":"Powinien zawierać co najmniej jedną małą literę","noUpperCase":"Powinien zawierać co najmniej jedną wielką literę","noNumber":"Powinien zawierać co najmniej jeden numer","noSpecialCharacter":"Powinien zawierać co najmniej jeden znak specjalny","notMinLength":"Powinien zawierać co najmniej $ znaków","noUsernameSubstring":"Nie powinien zawierać części nazwy użytkownika","noFirstnameSubstring":"Nie powinien zawierać części twojego imienia","noLastnameSubstring":"Nie powinien zawierać części twojego nazwiska","tokenNotValid":"Twój token aktywacyjny nie jest już ważny","tokenInvalidInfo":"Może się to zdarzyć, jeśli klikniesz link aktywacyjny po utworzeniu konta, wygasł link aktywacyjny lub adres URL jest niepoprawny","reqNewToken":"Poproś o nowy token","passcodeNotValid":"Twoje hasło nie pasuje do naszych danych. Proszę spróbuj ponownie.","OTPEnableAfter30Sec":"Wiadomość SMS została niedawno wysłana. Poczekaj 30 sekund, zanim spróbujesz ponownie.","phoneNoAlreadySet":"Numer telefonu został już zweryfikowany przez tego użytkownika.","emptypassword":"Hasło nie może być puste","passwordlength":"Hasło nie może być puste","passwordnotvalid":"Hasło jest nieprawidłowe","passwordnotmatching":"Hasła powinny się zgadzać","answerlength":"Odpowiedź powinna wynosić co najmniej $ znaków","phonenumbermissing":"Sprawdź otrzymane hasło, aby kontynuować","customQuestionEmpty":"Pytanie niestandardowe nie może być puste","customQAsame":"Niestandardowe pytanie i odpowiedź nie mogą być takie same","passwordSameasPrev":"Hasło nie może być twoim aktualnym hasłem","answerWrong":"Odpowiedź na pytanie zwrotne nie zgadza się z naszymi danymi","phonealreadyactive":"Ten numer został już zweryfikowany, jeśli chcesz zaktualizować, spróbuj podać inny numer","first_name":"Imię","last_name":"Nazwisko","enter_email":"ID e-mail","emailNotValid":"Identyfikator e-maila jest nieprawidłowy","registeredapps":"Zarejestrowane aplikacje","waitingapps":"Aplikacje czekające na zatwierdzenie","requestaccess":"Poproś o dostęp","admin":"Administrator","selectLang":"Wybierz język","dashboardLabel":"Deska rozdzielcza","resetpwd":"Zresetuj hasło","ansForgotten":"Odpowiedz na zapomniane hasło","resetOktaPwd":"Zresetuj swoje hasło","newpwd":"nowe hasło","rptpwd":"Powtórz hasło","adminLabel":"Zarządzanie użytkownikami","userAdministration":"Zarządzanie użytkownikami","adduser":"Dodaj nowego użytkownika","function":"Funkcjonować","emailAddress":"Adres e-mail","filterApp":"Filtruj aplikację","create":"Stwórz","logoutConfirm":"Czy na pewno chcesz się wylogować?","no":"Nie","yes":"tak","logout":"Wyloguj","expireWarning":"Twoja sesja wygaśnie za% minut, naciśnij OK, aby pozostać zalogowanym lub naciśnij Anuluj, aby się wylogować. W przypadku rozłączenia wszelkie zmiany zostaną utracone","update":"Aktualizacja","activateDeactivate":"Aktywuj / dezaktywuj","attention":"Uwaga","cancel":"Anuluj","sessionTimedout":"Twoja sesja wygasła. Proszę, zaloguj się ponownie","username":"Nazwa Użytkownika","primary_mail":"główny email","secondary_mail":"Drugi adres e-mail (opcjonalnie)","groups":"Grupy","must_email":"Musi to być e-mail","ieNotSupported":"IE nie jest obsługiwany","tryChrome":"Internet Explorer nie jest obsługiwany. Zalecamy korzystanie z Chrome dla tej aplikacji.","close":"Blisko","forgotSQA":"zapomniałeś odpowiedzi bezpieczeństwa?","resetSecQA":"Zresetuj pytanie bezpieczeństwa i hasło","retry":"Wróć","nofactorpresent":"Nie można użyć tej opcji, ponieważ numer telefonu komórkowego nie jest ustawiony. Skontaktuj się z administratorem.","emptypasscode":"Kod nie może być pusty","provisioned":"Ten użytkownik nie jest jeszcze zarejestrowany. Hasło można zresetować tylko po aktywacji użytkownika","deprovisioned":"Ten użytkownik jest dezaktywowany. Hasło można zresetować tylko po aktywacji użytkownika","resetsuccesspopupmsg":"Link do resetowania hasła został wysłany na adres e-mail. Proszę zamknąć popup, używając przycisku X.","wanttoreset":"Czy chcesz zresetować hasło?","wanttoactivate":"Czy chcesz aktywować użytkownika?","wanttodeactivate":"Czy chcesz dezaktywować użytkownika?","wanttodelete":"Czy chcesz usunąć użytkownika?","updateprofile":"Zaktualizować profil","updatesuccess":"Pomyślnie zaktualizowane","usercreated":"* Użytkownik został utworzony","errorcreatinguser":"* Błąd podczas tworzenia użytkownika / adresu e-mail już istnieje","privacypolicy":"Polityka prywatności","termsandconditions":"Regulamin","uname-email":"Nazwa użytkownika / e-mail","password_placeholder":"Hasło","sign-in":"Zaloguj Się","resetmailsent":"E-mail został wysłany do% z linkiem resetowania hasła.","smssent":"wysłane","resendcode":"Ponownie wyślij kod","needhelp":"Potrzebujesz pomocy przy logowaniu?","forgotPassword":"Zapomniałeś hasła?","helplink":"Wsparcie","smsusage":"SMS można używać tylko wtedy, gdy skonfigurowano numer telefonu komórkowego.","backtosignin":"Powrót do logowania","resetviasms":"Zresetuj za pomocą wiadomości SMS","resetviaemail":"Zresetuj przez e-mail","didntreceivecode":"Nie otrzymałeś kodu? zresetuj przez e-mail","emailsent":"E-mail wysłany!","recoverycredentialsnotset":"Zapomniane hasło jest niedozwolone, ponieważ poświadczenia odzyskiwania nie są ustawione dla użytkownika","usernotpresent":"Użytkownik nieobecny","mobilenumbernotset":"Nie ustawiono numeru telefonu komórkowego","invalidcreds":"Nieprawidłowa nazwa użytkownika lub hasło","emailreq":"Email (wymagany","emailinvalid":"Email jest nieprawidłowy","pwdreq":"wymagane hasło","otplength":"OTP powinno mieć 6 znaków","passcodeinvalid":"Nieprawidłowy OTP","firstnamereq":"Imię (wymagane","lastnamereq":"Wymagane jest nazwisko","notallowedincurrentstate":"Ta operacja nie jest dozwolona w bieżącym stanie uwierzytelniania","nopartsofusername":"Hasło nie może zawierać części nazwy użytkownika, zawierać imienia ani nazwiska","passwordusedrecently":"Hasło zostało użyte zbyt niedawno","passwordnotmetrequirements":"Hasło nie spełnia wymagań dotyczących złożoności obecnych zasad dotyczących haseł","antar":"Antarktyda","aus":"Australia","can":"Kanada","falk":"Falkland Islands (Malvinas)","kazak":"Kazachstan","mayotte":"Majotta","morocco":"Maroko","norway":"Norwegia","pitcairn":"Pitcairn","filteruser":"Filtruj użytkowników według aplikacji:","selectgroups":"Wybierz aplikację","status":"Status","atleastonegroup":"Wybierz co najmniej jedną grupę, do której chcesz przypisać użytkownika","answerchallenge":"Odpowiedz na wyzwanie dotyczące hasła forgotton","entersmscode":"Wpisz kod weryfikacyjny wysłany SMS-em","enterusercreds":"Wprowadź dane użytkownika","inviteuser":"Zaproś nowego użytkownika","assignApplication":"Przypisanie do aplikacji","availablegroups":"Dostępne grupy","selectedgroups":"Przypisane grupy","emailsenttouser":"E-mail został pomyślnie wysłany na adres","pendingactivation":"Oczekuje na aktywację konta","exit":"Wyjście","myprofile":"Mój profil","activatesuccess":"Użytkownik został pomyślnie aktywowany i wysłano pocztę aktywacyjną","deactivatesuccess":"został pomyślnie dezaktywowany","deletesuccess":"został pomyślnie usunięty","edituser":"Edytuj użytkownika","getstarted":"Zaczynać","congrats":"Gratulacje!","accountsetup":"Pomyślnie zakończyłeś/aś konfigurację konta.","edit":"Edytować","assignedapps":"Przypisane aplikacje","assignedgroups":"Przypisane grupy","oldpwd":"Wprowadź stare hasło","changepwd":"Zmień hasło","updatephone":"Zaktualizuj telefon","pwdupdated":"Hasło zostało pomyślnie zaktualizowane","QAupdated":"Pytanie bezpieczeństwa Odpowiedź została pomyślnie zaktualizowana","phonenumberinvalid":"Numer telefonu jest nieprawidłowy","phoneupdated":"Numer telefonu został pomyślnie zaktualizowany","showmore":"Pokaż więcej","verifypassword":"Zweryfikuj hasło","filterusergrp":"Filtruj użytkowników według grup:","allactiveusers":"Wszyscy aktywni użytkownicy","viewuser":"Wyświetl użytkownika","partofokta":"Ten użytkownik jest częścią organizacji Okta","userdeactive":"Użytkownik jest nieaktywny","showing":"Seans","of":"z","answerpartofquestion":"Odpowiedź nie może być częścią pytania","activationpending":"Twój czynnik oczekuje na aktywację, zaktualizuj swój numer telefonu, w przeciwnym razie zresetowane SMS-y zostaną wysłane na poprzedni aktywny numer","change_forgot_pwd_qtn":"Zmień pytanie ochronne","basicinfo":"Podstawowe informacje","gotoapp":"Kliknij poniżej, aby uzyskać dostęp do aplikacji.","passwordresetsuccess":"Twoje hasło zostało zresetowane pomyślnie","passwordreset":"Zresetowanie hasła!","searchinfotext":"* Wyszukiwanie odbywa się tylko w aplikacji","tmlabel":"Zarządzanie tokenem","delete":"Kasować","search":"Szukaj","nop":"Numer","nop_inst":"Wprowadź swój numer w taki sposób, w jaki zwykle wybierasz numer. Nie dodawaj swojego kodu kraju","nopMobile":"Numer telefonu komórkowego","statusactive":"Aktywny","statuspending":"Oczekuje na aktywację","globalsearch":"Wyszukiwanie globalne","permissiondenied":"Nie można usuwać / dezaktywować tego użytkownika, użytkownika przypisanego do innych grup. Zamiast tego można cofnąć przypisanie użytkownika","activestatus":"AKTYWNY","provisionedstatus":"ZABEZPIECZONY","deprovisionedstatus":"WYREJESTROWANY","save":"Zapisz","admingroup":"Grupa administracyjna","application":"Aplikacja","selectadmingroup":"Wybierz grupę administracyjną","selectapp":"Wybierz aplikację","adminConfigIncomplete":"wiersz niekompletny. Przypisz grupę administracyjną, markę i grupy administrowane, aby zapisać lub usunąć wiersz","adminconfigdeletesuccess":"Usunięte","adminconfigupdatesuccess":"Konfiguracja pomyślnie zaktualizowana","wanttodeleteadminconfig":"Czy chcesz usunąć tę konfigurację?","cannotdeleteconfig":"Ta konfiguracja nie może zostać usunięta","nonanoktauser":"Nie można wykonać tej czynności. Użytkownik nie należy do Okta.","reactivate":"Wyślij ponownie zaproszenie","wanttoreactivate":"Czy chcesz ponownie wysłać link aktywacyjny do użytkownika?","iread1":"Zgadzam się, że portale firmy Cargill oraz aplikacje i usługi dostępne za ich pośrednictwem podlegają ","iread2":"Warunkom ","iread3":"i Postanowieniom Portalu Klienta firmy Cargill. Mogą być uzupełniane lub zmieniane na podstawie szczegółowych warunków dla każdej stosownej usługi biznesowej.","iagree1":"Przyjmuję do wiadomości i akceptuję fakt, że przetwarzanie danych osobowych przez firmę Cargill w związku z portalami, aplikacjami i usługami firmy Cargill podlega ","iagree2":"Zasady ochrony prywatności online firmy Cargill","iagree3":"mogą także być uzupełniane Informacjami o ochronie prywatności dla każdej stosownej usługi biznesowej.","privacypolicy_link":"https://www.cargill.com/page/privacy","termsandconditions_link":"https://www.cargill.com/portal-terms","administeredgroups":"Administrowane grupy","selectgroupslist":"Wybierz grupy","alreadyactive":"Jesteś aktywnym użytkownikiem!","alreadyactivesetup":"Twój profil nie wymaga rejestracji. Korzystaj z logowania pracowników firmy Cargill, aby zalogować się do swoich aplikacji.","selectBrand":"Wybierz markę","permissiondeniedreset":"Nie można zresetować hasła tego użytkownika.","unlockaccount":"Odblokuj konto","unlockaccountsuccess":"Twoje konto zostało pomyślnie odblokowane","accountunlocked":"Konto odblokowane!","copyrefid":"Please copy the reference Id from the bottom of the email you received and paste it below to proceed.","securityquestionanswerweak":"Odpowiedź na pytanie zabezpieczające jest zbyt słaba, odpowiedź nie może być częścią pytania","securityanswermatchesquestion":"Nieprawidłowa odpowiedź zabezpieczająca: Odpowiedź nie może zawierać $, który jest częścią pytania zabezpieczającego","copysecurityanswermatchesquestion":"Nieprawidłowa odpowiedź zabezpieczająca: Odpowiedź nie może zawierać $, który jest częścią pytania zabezpieczającego","tokenInvalidShortMessage":"Twoje łącze aktywacyjne straciło ważność.","browserspecificmsg":"Rozważ użycie przeglądarki Google Chrome.","enterActivationDetails":"Aby uzyskać informacje wymagane poniżej, zapoznaj się z aktywacyjną wiadomością e-mail.","resendActivation":"Ponownie wyślij aktywacyjną wiadomość e-mail","reinvite":"Wyślij zaproszenie ponownie","reinviteEmailMessage":"Jeśli podane przez Ciebie informacje są prawidłowe, otrzymasz nową aktywacyjną wiadomość e-mail.","reinviteContactAdminMessage":"Jeśli nie otrzymasz nowej aktywacyjnej wiadomości e-mail, skontaktuj się z osobą kontaktową w biznesie Cargill.","activationOk":"Ok","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","selfRegSubGrps":"Self registration additional group:","selectReggroup":"Select Registration group","selfRegister":"Podpisz","disableExistingUserOnboard":"Disable Existing User","selfRegFormTitle":"Zarejestruj","E0001":"Przepraszamy, wystąpił problem podczas zakładania konta. Proszę się z nami","E0001_1":" skontaktować w celu uzyskania pomocy ","E0001_2":"podczas zakładania konta","E0002":" w celu uzyskania pomocy podczas zakładania konta.","E0003":"Twoje konto zostało zarejestrowane pomyślnie. Wysłano e-mail na adres ","E0003_1":" z instrukcjami dotyczącymi aktywacji konta.","E0004":"Twoje konto zostało zarejestrowane pomyślnie. Możesz teraz zalogować się do aplikacji wykorzystując istniejące hasło. Jeśli nie pamiętasz swojego hasła, skorzystaj z opcji „Zapomniałem hasło“ w aplikacji, aby zresetować swoje hasło.","E0005":"User already exists with status ","E0005_1":" Please contact ","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"Wymagania dotyczące hasła nie zostały spełnione. Wymagania dotyczące hasła: co najmniej 8 znaków, mała litera, wielka litera, cyfra, bez części nazwy użytkownika. Twoje hasło nie może być żadnym z ostatnich 24 haseł.","acceptTerms":"Aby kontynuować, zaakceptuj naszą Politykę prywatności i Regulamin.","phoneVerificationNotCompleted":"Aby kontynuować, zweryfikuj/usuń swój numer telefonu.","verifyPhoneWarning":"Kliknij „Wyślij kod”, aby zweryfikować swój numer telefonu","viewMoreInfo":"Zobacz więcej informacji","infoContent":"Zobacz więcej informacji o użytkowniku","createdDate":"stworz Date","activatedDate":"Data aktywacji","lastLoginDate":"Data ostatniego zalogowania się","lastUpdatedDate":"Data ostatniej aktualizacji","passwordChangedDate":"Data zmiany hasła","statusChangedDate":"Data zmiany statusu","createdDateDescription":"Data i godzina utworzenia rekordu użytkownika w Okta.","activatedDateDescription":"Data i godzina wysłania ostatniego e-maila aktywacyjnego użytkownika.","statusChangedDateDescription":"Data i godzina ostatniej zmiany statusu użytkownika w Okta.","lastLoginDateDescription":"Data i godzina ostatniego logowania użytkownika do Okta (nie dotyczy konkretnej aplikacji).","lastUpdatedDateDescription":"Data i godzina ostatniej aktualizacji rekordu użytkownika w Okta.","passwordChangedDateDescription":"Data i godzina ostatniej zmiany hasła przez użytkownika.","resetMFATitle":"Zresetuj uwierzytelnianie wieloskładnikowe","noFactorExist":"Dla tego użytkownika nie istnieje żaden współczynnik.","mfaValidation":"Wybierz czynnik do zresetowania.","resetButton":"Resetowanie","mfaResetModalTitle":"Resetowanie MFA","factorResetSuccess":"Współczynnik został pomyślnie zresetowany.","resetConfirmation":"Czy na pewno chcesz zresetować usługę MFA dla tego użytkownika?","copyrights":"Cargill, Rejestrowy. Wszelkie prawa zastrzeżone.","reportLabel":"Raport","bulkUploadLabel":"Przesyłanie zbiorcze użytkowników","availableIndependentGroups":"Dostępne niezależne grupy:","selectedBrand":"Wybrana marka:","bulkUploadOptionsLabel":"Opcje przesyłania zbiorczego","bulkCreateUsers":"Zbiorcze tworzenie użytkowników","bulkReinviteUsers":"Masowe ponowne zapraszanie użytkowników","confirm":"Potwierdzać","downloadExcelTemplate":"Pobierz szablon Excela:","uploadInstruction":"Po pobraniu szablonu wypełnij arkusz programu Excel i prześlij go, korzystając z poniższej sekcji","uploadWarningOne":"Maksymalnie tylko 50 użytkowników może jednocześnie.","uploadWarningTwo":"Upewnij się, że pole e-mail nie jest puste.","uploadWarningThree":"Upewnij się, że podane identyfikatory e-mail są administrowane przez Ciebie.","uploadWarningFour":"Upewnij się, że żadne pola nie pozostały puste.","uploadWarningFive":"Upewnij się, że wszystkie wartości pól są prawidłowe.","uploadWarningSix":"Upewnij się, że podane identyfikatory grup są administrowane przez Ciebie.","uploadNote":"Zaproszenia wysyłane w ramach tego procesu są wysyłane zgodnie ze standardową wiadomością e-mail z zaproszeniem do konta Cargill.","uploadLabel":"Wgrywać","action":"działania","userword":"użytkownicy","note":"Notatka:","authentication":"Uwierzytelnianie","noTableData":"Brak danych do tabeli.","readOnlyGroup":"To jest grupa tylko do odczytu. Przydziału do tej grupy należy dokonać wyłącznie za pośrednictwem witryny access.cargill.com","adminPermissionDenied":"Twoje uprawnienia administratora użytkownika nie mają uprawnień do modyfikowania tego przypisania do grupy.","msgForGenericErrorUA":"Obecnie mamy problem z przetwarzaniem Twojego żądania. Spróbuj ponownie później. Jeśli ten błąd nadal się pojawia, skontaktuj się z przedstawicielem obsługi klienta w celu uzyskania dalszej pomocy.","passcodeRateLimit":"Nie można przetworzyć Twojego żądania. Spróbuj ponownie za 5 minut.","passcodeNotEntered":"Wprowadź hasło, aby zweryfikować.","msgForUnhandledResponse":"Nie można przetworzyć żądania. Skontaktuj się z przedstawicielem obsługi klienta.","groupUnavailable":"Grupa nie jest już dostępna w Okcie. Grupa mogła zostać usunięta.","groupCannotBeAssigned":"Grupa $ nie jest już dostępna w Okcie i dlatego nie można jej przypisać do użytkownika. Usuń grupę i kontynuuj.","copyGroupCannotBeAssigned":"Grupa $ nie jest już dostępna w Okcie i dlatego nie można jej przypisać do użytkownika. Usuń grupę i kontynuuj."}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports = {"1":"Estados Unidos","7":"Federação Russa","20":"Egito ","27":"África do Sul ","30":"Grécia ","31":"Países Baixos","32":"Bélgica","33":"França ","34":"Espanha ","36":"Hungria","39":"Itália ","40":"Roménia ","41":"Suíça ","43":"Áustria ","44":"Reino Unido","45":"Dinamarca ","46":"Suécia ","47":"Svalbard e Jan Mayen","48":"Polônia ","49":"Alemanha ","51":"Peru","52":"México ","53":"Cuba","54":"Argentina","55":"Brasil","56":"Chile","57":"Colômbia ","58":"Venezuela, República Bolivariana do","60":"Malásia ","61":"Ilha do Natal","62":"Indonésia ","63":"Filipinas ","64":"Nova Zelândia","65":"Cingapura ","66":"Tailândia ","81":"Japão ","82":"Coreia República do","84":"Vietnã ","86":"China","90":"Peru ","91":"Índia ","92":"Paquistão ","93":"Afeganistão","94":"Sri Lanka","95":"Mianmar ","98":"Irão, República Islâmica do","211":"Sudão do Sul ","212":"Sahara Ocidental ","213":"Argélia ","216":"Tunísia ","218":"Líbia ","220":"Gâmbia ","221":"Senegal","222":"Mauritânia ","223":"Mali","224":"Guiné ","225":"Costa do Marfim","226":"Burkina Faso","227":"Níger ","228":"Ir","229":"Benin","230":"Maurício ","231":"Libéria ","232":"Serra Leoa","233":"Gana ","234":"Nigéria ","235":"Chade","236":"República Centro-Africana","237":"Camarões ","238":"Cabo Verde","239":"São Tomé e Príncipe","240":"Guiné Equatorial","241":"Gabão ","242":"Congo","243":"Congo, República Democrática das","244":"Angola","245":"Guiné-Bissau ","246":"Território britânico do Oceano Índico ","248":"Seychelles","249":"Sudão ","250":"Ruanda ","251":"Etiópia ","252":"Somália ","253":"Djibouti","254":"Quénia ","255":"Tanzânia, República Unida da ","256":"Uganda","257":"Burundi","258":"Moçambique ","260":"Zâmbia ","261":"Madagáscar","262":"Reunião","263":"Zimbábue","264":"Namíbia ","265":"Malawi","266":"Lesotho","267":"Botsuana ","268":"Suazilândia ","269":"Comoros","290":"Santa Helena, Ascensão e Tristão da Cunha","291":"Eritrea","297":"Aruba","298":"Ilhas Faroé","299":"Gronelândia ","350":"Gibraltar","351":"Portugal","352":"Luxemburgo ","353":"Irlanda ","354":"Islândia ","355":"Albânia ","356":"Malta","357":"Chipre ","358":"Finlândia ","359":"Bulgária ","370":"Lituânia ","371":"Letónia ","372":"Estônia ","373":"Moldávia ","374":"Armênia ","375":"Bielorrússia","376":"Andorra","377":"Mônaco ","378":"San Marino","379":"Santa Sé (Estado da Cidade do Vaticano) ","380":"Ucrânia ","381":"Sérvia ","382":"Montenegro","385":"Croácia ","386":"Eslovênia ","387":"Bósnia e Herzegovina","389":"Macedónia ","420":"República Tcheca","421":"Eslováquia ","423":"Liechtenstein","500":"Ilhas Geórgia do Sul e Sandwich do Sul","501":"Belize","502":"Guatemala","503":"El Salvador","504":"Honduras","505":"Nicarágua ","506":"Costa Rica","507":"Panamá ","508":"São Pedro e Miquelon","509":"Haiti","590":"Guadeloupe","591":"Bolívia ","592":"Guyana ","593":"Equador","595":"Paraguai ","596":"Martinica ","597":"Suriname","598":"Uruguai ","599":"Antilhas Holandesas","670":"Timor-Leste","672":"Ilha Norfolk","673":"Brunei Darussalam","674":"Nauru","675":"Papua Nova Guiné","676":"Tonga","677":"Ilhas Salomão","678":"Vanuatu","679":"Fiji","680":"Palau","681":"Wallis e Futuna","682":"Ilhas Cook","683":"Niue","685":"Samoa","686":"Quiribati","687":"Nova Caledónia","688":"Tuvalu","689":"Polinésia Francesa","690":"Tokelau ","691":"Micronesia ","692":"Ilhas Marshall ","850":"Coréia, República Popular Democrática da","852":"Hong Kong","853":"Macao","855":"Camboja","856":"República Democrática Popular Lao","880":"Bangladesh","886":"Taiwan","960":"Maldivas ","961":"Líbano ","962":"Jordânia ","963":"República Árabe Síria ","964":"Iraque ","965":"Kuwait","966":"Arábia Saudita","967":"Iémen ","968":"Omã ","970":"Palestina ","971":"Emiratos Árabes Unidos","972":"Israel","973":"Barém","974":"Catar","975":"Butão ","976":"Mongólia ","977":"Nepal","992":"Tajiquistão ","993":"Turquemenistão ","994":"Azerbaijão ","995":"Geórgia ","996":"Quirguistão ","998":"Uzbequistão ","1242":"Bahamas","1246":"Barbados","1264":"Anguilla","1268":"Antígua e Barbuda","1284":"Ilhas Virgens, Britânicas","1340":"Ilhas Virgens, EUA","1345":"Caimão Ilhas","1441":"Bermudas","1473":"Granada","1649":"Ilhas Turcas e Caicos ","1664":"Montserrat","1670":"Ilhas Marianas do Norte","1671":"Guam","1684":"Samoa Americana","1758":"Santa Lúcia","1767":"Dominica","1784":"São Vicente e Granadinas","1787":"Porto Rico","1809":"República Dominicana","1868":"Trinidad e Tobago","1869":"São Cristóvão e Nevis","1876":"Jamaica","441481":"Guernsey","441534":"Jérsei ","registration":"Cadastro","hello":"Olá ","welcome_cargill":"Bem-vindo à ","user_reg":"Registro de usuário","enter_new_pwd":"Insira a nova senha","pwd_rule":"Sua senha deve ter pelo menos 8 caracteres, uma letra minúscula, uma letra maiúscula, um número, nenhuma parte do seu nome de usuário.","repeat_pwd":"Repita a nova senha","choose_forgot_pwd_qtn":"Escolha uma pergunta de senha esquecida","stock_qtn":"Perguntas sobre ações","disliked_food":"Qual é a comida que você menos gostou quando era criança?","name_of_first_plush_toy":"Qual o nome do seu primeiro animal de pelúcia?","first_award":"Para qual ganhou sua primeira medalha ou prêmio?","favorite_security_question":"Qual é a sua pergunta de segurança favorita?","favorite_toy":"Qual é o brinquedo / bicho de pelúcia que você mais gostava quando criança?","first_computer_game":"Qual foi o primeiro jogo de computador que você jogou?","favorite_movie_quote":"Qual é a sua citação de filme favorita?","first_sports_team_mascot":"Qual foi a mascote da primeira equipe de esportes em que você jogou?","first_music_purchase":"Qual álbum de música ou música você comprou pela primeira vez?","favorite_art_piece":"Qual é a sua obra de arte favorita?","grandmother_favorite_desert":"Qual foi a sobremesa favorita da sua avó?","first_thing_cooked":"Qual foi a primeira coisa que você aprendeu a cozinhar?","childhood_dream_job":"Qual foi o seu trabalho ideal quando criança?","place_where_significant_other_was_met":"Onde você conheceu seu cônjuge / outro significativo?","favorite_vacation_location":"Onde você foi para suas férias favoritas?","new_years_two_thousand":"Onde você estava na véspera de Ano Novo no ano 2000?","favorite_speaker_actor":"Quem é seu orador / orador favorito?","favorite_book_movie_character":"Qual é o seu personagem favorito do livro / filme?","favorite_sports_player":"Quem é seu jogador de esportes favorito?","custom_qtn":"Pergunta personalizada","own_sec_qtn":"Crie sua própria pergunta de segurança","answer":"Responda","phone_inst":"Opcional. Digite um número de telefone para recuperar sua conta. Este número será usado apenas para enviar mensagens de texto com códigos de verificaçao.","optional":"(Opcional)","sms_inst":"O Okta pode enviar uma mensagem de texto com um código de recuperação. Esse recurso é útil quando você não tem acesso ao seu email.","add_ph_no":"Adicionar número de telefone","create_acc":"Criar a minha conta","forgot_pwd_header":"Esqueceu a senha da mensagem de texto","enter_phone_no":"Digite o número de telefone que você usará para receber códigos via mensagem de texto e, em seguida, clique em Enviar código para verificar se ele funciona.","country":"País","country_inst":"Selecione o país onde seu telefone está registrado.","back":"Reenviar","phone_number":"Número de telefone","phone_number_inst":"Digite seu número como você normalmente liga. Não adicione o código do seu país","code_prefix":"prefixo de código de país.","send_code":"Enviar código","done":"Feito","verify":"Verificar","enter_code":"Coloque o código","enter_code_rule":"Verifique o seu telefone para a senha e entre abaixo. Sua mensagem deve chegar em menos de um minuto.","verify_success":"O número de telefone foi verificado com sucesso!","click":"Clique","finish_setup":" para finalizar a instalação.","error_review":"Revise o formulário para corrigir os seguintes erros","phone_no_not_found":"A mensagem de texto não pode ser enviada porque nenhum número de telefone foi encontrado no banco de dados.","noLowerCase":"Deve conter pelo menos uma letra minúscula","noUpperCase":"Deve conter pelo menos uma letra maiúscula","noNumber":"Deve conter pelo menos um número","noSpecialCharacter":"Deve conter pelo menos um caractere especial","notMinLength":"Deve conter pelo menos $ caracteres","noUsernameSubstring":"Não deve conter parte do nome de usuário","noFirstnameSubstring":"Não deve conter parte do seu primeiro nome","noLastnameSubstring":"Não deve conter parte do seu sobrenome","tokenNotValid":"Seu token de ativação não é mais válido","tokenInvalidInfo":"Isso pode acontecer se você clicou em seu link de ativação depois de criar sua conta, seu link de ativação expirou ou o URL está incorreto","reqNewToken":"Solicite um novo token","passcodeNotValid":"Sua senha não corresponde aos nossos registros. Por favor, tente novamente.","OTPEnableAfter30Sec":"Uma mensagem SMS foi enviada recentemente. Aguarde 30 segundos antes de tentar novamente.","phoneNoAlreadySet":"O número de telefone já foi verificado por este usuário.","emptypassword":"A senha não pode estar vazia","passwordlength":"A senha não pode estar vazia","passwordnotvalid":"A senha não é válida","passwordnotmatching":"As senhas devem corresponder","answerlength":"A resposta deve ter no mínimo $ caracteres","phonenumbermissing":"Verifique a senha que você recebeu para continuar","customQuestionEmpty":"A pergunta personalizada não pode estar vazia","customQAsame":"Perguntas e respostas personalizadas não podem ser iguais","passwordSameasPrev":"Senha não pode ser sua senha atual","answerWrong":"A resposta à pergunta de recuperação não corresponde aos nossos registros","phonealreadyactive":"Este número já foi verificado, se você deseja atualizar, tente outro número","first_name":"Primeiro nome","last_name":"Último nome","enter_email":"Identificação do email","emailNotValid":"ID de email não válida","registeredapps":"Aplicativos registrados","waitingapps":"Aplicativos aguardando aprovação","requestaccess":"Solicitar acesso","admin":"Admin","selectLang":"Selecione o idioma","dashboardLabel":"Painel de controle","resetpwd":"Redefinir Senha","ansForgotten":"Respondido desafio de senha esquecida","resetOktaPwd":"Redefina sua senha do Okta","newpwd":"Nova senha","rptpwd":"Repita a senha","adminLabel":"Gerenciamento de usuários","userAdministration":"Administração de usuários","adduser":"Adicionar usuário","function":"Função","emailAddress":"Endereco de e-mail","filterApp":"Aplicação de Filtro","create":"crio","logoutConfirm":"Tem certeza que deseja sair?","no":"Não","yes":"Sim","logout":"Sair","update":"Atualizar","activateDeactivate":"Ativar/Desativar","expireWarning":"Sua sessao expirar em % minutos, pressione OK para permanecer logado ou pressione Cancelar para fazer logoff. Se voce estiver desconectado, qualquer alteracao sera perdida","attention":"Atenção","cancel":"Cancelar","sessionTimedout":"Sua sessao expirou. Por favor faca login novamente","username":"Nome de usuário","primary_mail":"E-mail primário","secondary_mail":"E-mail secundário (opcional)","groups":"Grupos","must_email":"Deve ser um e-mail","ieNotSupported":"IE não é suportado","tryChrome":"Internet Explorer não é suportado. É recomendada a utilização de Chrome para esta aplicação.","close":"Fechar","forgotSQA":"esqueceu a resposta de segurança?","resetSecQA":"Redefinir pergunta de segurança e senha","retry":"Volte","nofactorpresent":"Esta opção não pode ser usada porque o número do celular não está definido. Entre em contato com seu administrador.","emptypasscode":"O código não pode estar vazio","provisioned":"Este usuário ainda não está registrado. A senha só pode ser reiniciada após o usuário estar ativo","deprovisioned":"Este usuário está desativado. A senha só pode ser reiniciada após o usuário estar ativo","resetsuccesspopupmsg":"O link de redefinição de senha foi enviado para o seu endereço de e-mail. Por favor, feche o pop-up usando o botão Fechar ou X","wanttoreset":"Deseja redefinir a senha?","wanttoactivate":"Você deseja ativar o usuário?","wanttodeactivate":"Deseja desativar o usuário?","wanttodelete":"Deseja excluir o usuário?","updateprofile":"Atualizar perfil","updatesuccess":"Usuário foi atualizado com sucesso","usercreated":"*Criado pelo usuário","errorcreatinguser":"*Erro ao criar o usuário/ e-mail já existe","privacypolicy":"Política de Privacidade","termsandconditions":"Termos e Condições","uname-email":"Nome de usuário /O email","password_placeholder":"Senha","sign-in":"Entrar","resetmailsent":"Um e-mail foi enviado para % com o link redefinir senha.","smssent":"enviei","resendcode":"Reenviar código","needhelp":"Precisa de ajuda para entrar?","forgotPassword":"Esqueceu a senha?","helplink":"Socorro","smsusage":"O SMS só pode ser usado se um número de telefone celular tiver sido configurado.","backtosignin":"Voltar para Iniciar sessão","resetviasms":"Redefinir por SMS","resetviaemail":"Redefinir por Email","didntreceivecode":"Não recebeu um código? redefinir via e-mail","emailsent":"E-mail enviado!","recoverycredentialsnotset":"Esqueceu a senha não permitida uma vez que as credenciais de recuperação não foram definidas para o usuário","usernotpresent":"Usuário não presente","mobilenumbernotset":"Número de celular não definido","invalidcreds":"Nome de usuário ou senha inválidos","emailreq":"Email (obrigatório","emailinvalid":"Email inválido","pwdreq":"Senha requerida","otplength":"OTP deve ter 6 caracteres","passcodeinvalid":"OTP inválido","firstnamereq":"Primeiro nome (necessário","lastnamereq":"Sobrenome necessário","notallowedincurrentstate":"Esta operação não é permitida no estado de autenticação atual","nopartsofusername":"A senha não pode conter partes do seu nome de usuário, inclua seu primeiro nome ou seu sobrenome","passwordusedrecently":"A senha já foi usada recentemente","passwordnotmetrequirements":"A senha não atende aos requisitos de complexidade da política de senha atual","antar":"Antártica ","aus":"Austrália ","can":"Canadá ","falk":"Ilhas Falkland (Malvinas)","kazak":"Cazaquistão ","mayotte":"Mayotte","morocco":"Marrocos ","norway":"Noruega ","pitcairn":"Pitcairn","filteruser":"Filtrar usuários por aplicativo","selectgroups":"Selecionar Aplicativo","status":"Status","atleastonegroup":"Selecione pelo menos um grupo para atribuir usuário","answerchallenge":"Respondido forgotton password challenge","entersmscode":"Digite o código de verificação enviado via SMS","enterusercreds":"Digite os detalhes do usuário","inviteuser":"Convidar novo usuário","assignApplication":"Atribuir ao aplicativo","availablegroups":"Grupos Disponíveis","selectedgroups":"Grupos atribuídos","emailsenttouser":"E-mail enviado com sucesso para ","pendingactivation":"Ativação de conta pendente","exit":"Saída","myprofile":"Meu perfil","activatesuccess":"O usuário foi atualizado com sucesso","deactivatesuccess":" foi desativado com sucesso","deletesuccess":" foi eliminado com sucesso","edituser":"Editar usuário","getstarted":"Iniciar","congrats":"Parabéns!","accountsetup":"Você concluiu com êxito a configuração da senha da sua conta.","edit":"Editar","assignedapps":"Aplicações Atribuídas","assignedgroups":"Grupos Designados","oldpwd":"Digite a senha antiga","changepwd":"Mudar senha","updatephone":"Atualizar telefone","pwdupdated":"A senha foi atualizada com sucesso","QAupdated":"Pergunta de segurança Resposta foi atualizada com sucesso","phonenumberinvalid":"O número de telefone é inválido","phoneupdated":"Número de telefone atualizado com sucesso","showmore":"Mostre mais","verifypassword":"Verifique a senha","filterusergrp":"Filtrar usuários por grupo:","allactiveusers":"Todos os usuários ativos","viewuser":"Ver usuário","partofokta":"Este usuário é parte da organização do Okta","userdeactive":"Usuário desativado","showing":"Mostrando","of":"do","answerpartofquestion":"A resposta não deve fazer parte da pergunta","activationpending":"Seu fator está pendente de ativação, por favor, atualize seu número de telefone caso contrário, a redefinição de SMS será enviada para o seu número ativo anterior","change_forgot_pwd_qtn":"Alterar pergunta de segurança:","basicinfo":"Informação básica","gotoapp":"Clique no aplicativo que você deseja acessar","passwordresetsuccess":"Sua senha foi redefinida com sucesso","passwordreset":"Resetar a senha!","searchinfotext":"*A pesquisa é feita apenas no aplicativo","tmlabel":"Configuração","delete":"Excluir","search":"Procurar","nop":"Número","nop_inst":"Digite seu número como você normalmente liga. Não adicione o código do seu país","nopMobile":"Número de telemóvel","statusactive":"Ativo","statuspending":"Ativação pendente","globalsearch":"Pesquisar outros usuários","permissiondenied":"Você não pode excluir / desativar este usuário. usuário atribuído a outros grupos. Você pode cancelar a atribuição do usuário","activestatus":"ATIVO","provisionedstatus":"FORNECIDO","deprovisionedstatus":"DESPROVISIONADO","save":"Salve","admingroup":"Grupo de administradores","application":"Aplicação","selectadmingroup":"Selecione o grupo Administradores","selectapp":"Selecione o aplicativo","adminConfigIncomplete":"Linha incompleta. Por favor, atribua um grupo de administração, marca e grupos administrados para salvar ou remover a linha","adminconfigdeletesuccess":"Apagado com sucesso","adminconfigupdatesuccess":"Configuração atualizada com sucesso","wanttodeleteadminconfig":"Deseja excluir esta configuração?","cannotdeleteconfig":"Esta configuração não pode ser excluída","nonanoktauser":"Não é permitido executar esta ação. O provedor de identidade deste usuário não é Okta.","reactivate":"Reenvie convite","wanttoreactivate":"Deseja reenviar o link de ativação para o usuário?","iread1":"Concordo que os portais de clientes, aplicativos e serviços da Cargill disponíveis por meio deles estão sujeitos ao Portal do Cliente da Cargill","iread2":"Termos e Condições","iread3":", que pode ser complementado ou alterado por termos e condições específicos para cada serviço comercial aplicável.","iagree1":"Reconheço e aceito que o processamento de dados pessoais da Cargill em conexão com portais de clientes, aplicativos e serviços da Cargill está sujeito aos","iagree2":"Política de Privacidade Online","iagree3":", que pode ser complementado ou alterado por 'Avisos de privacidade' para cada serviço comercial aplicável.","privacypolicy_link":"https://www.cargill.com/page/privacy-compromisso-privacidade","termsandconditions_link":"https://www.cargill.com/portal-terms-pt","resetreactivate":"Redefinir/Reativar","emailinvaliddomain":"Usuário com este domínio não pode ser adicionado","administeredgroups":"Administered Groups","selectgroupslist":"Select Groups","alreadyactive":"You are an active user!","alreadyactivesetup":"Your profile doesn't requires registration. Use Cargill employee login to signin to your applications.","selectBrand":"Select Brand","permissiondeniedreset":"No puede restablecer la contraseña para este usuario.","unlockaccount":"Desbloquear a conta","unlockaccountsuccess":"Sua conta foi desbloqueada com sucesso","accountunlocked":"Conta Desbloqueada!","copyrefid":"Please copy the reference Id from the bottom of the email you received and paste it below to proceed.","securityquestionanswerweak":"A resposta da pergunta de segurança é muito fraca, a resposta não deve fazer parte da pergunta","securityanswermatchesquestion":"Resposta de segurança inválida: a resposta não deve conter $, que faz parte da pergunta de segurança","copysecurityanswermatchesquestion":"Resposta de segurança inválida: a resposta não deve conter $, que faz parte da pergunta de segurança","tokenInvalidShortMessage":"O link de ativação expirou.","enterActivationDetails":"Para fornecer as informações solicitadas abaixo, consulte seu e-mail de ativação.","resendActivation":"Reenviar e-mail de ativação.","reinvite":"Enviar convite novamente","reinviteEmailMessage":"Se as informações fornecidas estiverem corretas, você receberá um novo e-mail de ativação.","reinviteContactAdminMessage":"Caso não receba um novo e-mail de ativação, fale com seu contato comercial da Cargill.","activationOk":"Ok","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","disableExistingUserOnboard":"Disable Existing User","selfRegSubGrps":"Self registration additional group:","selectReggroup":"Select Registration group","selfRegister":"Inscrever-se","selfRegFormTitle":"Cadastrar-se","E0001":"Lamentamos, ocorreu um erro ao criar sua conta. Entre em","E0001_1":" contato conosco ","E0001_2":"para obter ajuda ao configurar sua conta.","E0002":" para obter ajuda ao configurar sua conta.","E0003":"Sua conta foi criada com sucesso. Um e-mail foi enviado para ","E0003_1":" com instruções para ativar sua conta.","E0004":"Sua conta foi criada com sucesso. Agora você pode fazer o login no aplicativo usando sua senha existente. Se você não se lembra de sua senha, use a opção “Esqueci minha senha“ no aplicativo para redefinir sua senha.","E0005":"User already exists with status ","E0005_1":" Please contact ","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"Os requisitos de senha não foram atendidos. Requisitos de senha: pelo menos 8 caracteres, uma letra minúscula, uma letra maiúscula, um número, sem partes do seu nome de usuário. Sua senha não pode ser nenhuma das últimas 24 senhas.","acceptTerms":"Por favor, aceite nossa Política de Privacidade e Termos e Condições para continuar.","phoneVerificationNotCompleted":"Verifique / remova seu número de telefone para prosseguir.","verifyPhoneWarning":"Clique em 'Enviar código' para verificar seu número de telefone","viewMoreInfo":"Ver mais informações","infoContent":"Veja mais informações sobre o usuário","createdDate":"Data de criação","activatedDate":"Data de ativação","lastLoginDate":"Última data de logon","lastUpdatedDate":"Data da última atualização","passwordChangedDate":"Data de alteração da senha","statusChangedDate":"Data de alteração do status","createdDateDescription":"Data e hora em que o registro do usuário foi criado no Okta.","activatedDateDescription":"Data e hora em que o último e-mail de ativação do usuário foi enviado.","statusChangedDateDescription":"Data e hora em que o status do usuário foi alterado pela última vez no Okta.","lastLoginDateDescription":"Data e hora do último login do usuário no Okta (não específico do aplicativo).","lastUpdatedDateDescription":"Data e hora em que o registro do usuário foi atualizado pela última vez no Okta.","passwordChangedDateDescription":"Data e hora em que o usuário alterou sua senha pela última vez.","resetMFATitle":"Redefinir autenticação multifator","noFactorExist":"Não existe nenhum fator para este usuário.","mfaValidation":"Selecione um fator para redefinir.","resetButton":"Redefinir","mfaResetModalTitle":"Redefinição de MFA","factorResetSuccess":"O fator foi redefinido com sucesso.","resetConfirmation":"Tem certeza de que deseja redefinir a MFA para este usuário?","copyrights":"Cargill, Incorporado. Todos os direitos reservados.","reportLabel":"Relatório","bulkUploadLabel":"Usuários de upload em massa","availableIndependentGroups":"Grupos independentes disponíveis:","selectedBrand":"Marca selecionada:","bulkUploadOptionsLabel":"Opções de upload em massa","bulkCreateUsers":"Criar usuários em massa","bulkReinviteUsers":"Re-convidar usuários em massa","confirm":"confirme","downloadExcelTemplate":"Baixar modelo Excel:","uploadInstruction":"Depois de baixar o modelo, preencha a planilha do Excel e faça o upload usando a seção abaixo","uploadWarningOne":"Máximo de apenas 50 usuários permitidos por vez.","uploadWarningTwo":"Certifique-se de que o campo de e-mail não esteja vazio.","uploadWarningThree":"Certifique-se de que os IDs de e-mail fornecidos sejam administrados por você.","uploadWarningFour":"Certifique-se de que nenhum campo fique vazio.","uploadWarningFive":"Certifique-se de que todos os valores de campo sejam válidos.","uploadWarningSix":"Certifique-se de que os IDs de grupo fornecidos sejam administrados por você.","uploadNote":"Os convites enviados por meio desse processo seguem o e-mail padrão de convite da conta da Cargill.","uploadLabel":"Carregar","action":"Ações","userword":"usuários","note":"Observação:","authentication":"Autenticação","noTableData":"Não há dados para a tabela.","readOnlyGroup":"Este é um grupo somente leitura. A atribuição para este grupo deve ser feita apenas via access.cargill.com","adminPermissionDenied":"Seus direitos de administrador de usuário não têm permissões para modificar esta atribuição de grupo.","msgForGenericErrorUA":"Atualmente estamos enfrentando um problema no processamento da sua solicitação. Por favor, tente novamente mais tarde. Se você continuar vendo esse erro, entre em contato com seu representante de atendimento ao cliente para obter mais assistência.","passcodeRateLimit":"Não foi possível processar sua solicitação, tente novamente em 5 minutos.","passcodeNotEntered":"Por favor, digite a senha para verificar.","msgForUnhandledResponse":"Não foi possível processar a solicitação. Entre em contato com seu representante de atendimento ao cliente.","groupUnavailable":"O grupo não está mais disponível no Okta. O grupo pode ter sido excluído.","groupCannotBeAssigned":"O grupo $ não está mais disponível no Okta e, portanto, não pode ser atribuído ao usuário. Remova o grupo e prossiga.","copyGroupCannotBeAssigned":"O grupo $ não está mais disponível no Okta e, portanto, não pode ser atribuído ao usuário. Remova o grupo e prossiga."}

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = {"1":"Statele Unite","7":"Federația Rusă","20":"Egipt","27":"Africa de Sud","30":"Grecia","31":"Olanda","32":"Belgia","33":"Franţa","34":"Spania","36":"Ungaria","39":"Italia","40":"România","41":"Elveţia","43":"Austria","44":"Regatul Unit","45":"Danemarca","46":"Suedia","47":"Svalbard și Jan Mayen","48":"Polonia","49":"Germania","51":"Peru","52":"Mexic","53":"Cuba","54":"Argentina","55":"Brazilia","56":"Chile","57":"Columbia","58":"Venezuela","60":"Malaezia","61":"Insula Craciunului","62":"Indonezia","63":"Filipine","64":"Noua Zeelanda","65":"Singapore","66":"Tailanda","81":"Japonia","82":"Republica Coreea","84":"Vietnam","86":"China","90":"Turcia","91":"India","92":"Pakistan","93":"Afganistan","94":"Sri Lanka","95":"Myanmar","98":"Iran","211":"Sudanul de Sud","212":"sahara de Vest","213":"Algeria","216":"Tunisia","218":"Libia","220":"Gambia","221":"Senegal","222":"Mauritania","223":"Mali","224":"Guineea","225":"coasta de Fildes","226":"Burkina Faso","227":"Niger","228":"Togo","229":"Benin","230":"Mauritius","231":"Liberia","232":"Sierra Leone","233":"Ghana","234":"Nigeria","235":"Ciad","236":"Republica Central - Africană","237":"Camerun","238":"capul Verde","239":"Sao Tome și Principe","240":"Guineea Ecuatorială","241":"Gabon","242":"Congo","243":"Republica Democrată Congo","244":"Angola","245":"Guinea Bissau","246":"Teritoriul Britanic al Oceanului Indian","248":"Seychelles","249":"Sudan","250":"Rwanda","251":"Etiopia","252":"Somalia","253":"Djibouti","254":"Kenia","255":"Tanzania","256":"Uganda","257":"Burundi","258":"Mozambic","260":"Zambia","261":"Madagascar","262":"Insula Reunion","263":"Zimbabwe","264":"Namibia","265":"Malawi","266":"Lesotho","267":"Botswana","268":"Swaziland","269":"Comore","290":"Sfânta Elena, Ascension și Tristan da Cunha","291":"Eritreea","297":"Aruba","298":"Insulele Feroe","299":"Groenlanda","350":"Gibraltar","351":"Portugalia","352":"Luxemburg","353":"Irlanda","354":"Islanda","355":"Albania","356":"Malta","357":"Cipru","358":"Finlanda","359":"Bulgaria","370":"Lituania","371":"Letonia","372":"Estonia","373":"Moldova","374":"Armenia","375":"Belarus","376":"Andorra","377":"Monaco","378":"San Marino","379":"Vatican","380":"Ucraina","381":"Serbia","382":"Muntenegru","385":"Croaţia","386":"Slovenia","387":"Bosnia si Hertegovina","389":"Macedonia","420":"Republica Cehă","421":"Slovacia","423":"Liechtenstein","500":"Georgia de Sud și Insulele Sandwich de Sud","501":"Belize","502":"Guatemala","503":"El Salvador","504":"Honduras","505":"Nicaragua","506":"Costa Rica","507":"Panama","508":"Sfântul Pierre și Miquelon","509":"Haiti","590":"Guadelupa","591":"Bolivia","592":"Guyana","593":"Ecuador","595":"Paraguay","596":"Martinica","597":"Surinam","598":"Uruguay","599":"Antilele Olandeze","670":"Timorul de Est","672":"Insula Norfolk","673":"Brunei Darussalam","674":"Nauru","675":"Papua Noua Guinee","676":"Tonga","677":"Insulele Solomon","678":"Vanuatu","679":"Fiji","680":"Palau","681":"Wallis și Futuna","682":"Insulele Cook","683":"Niue","685":"Samoa","686":"Kiribati","687":"Noua Caledonie","688":"Tuvalu","689":"Polynesia franceza","690":"Tokelau","691":"Micronezia","692":"Insulele Marshall","850":"Republica Populară Democrată din Coreea","852":"Hong Kong","853":"Macao","855":"Cambogia","856":"Republica Populară Democrată Laos","880":"Bangladesh","886":"Taiwan","960":"Maldive","961":"Liban","962":"Iordania","963":"Siria","964":"Irak","965":"Kuweit","966":"Arabia Saudită","967":"Yemen","968":"Oman","970":"Palestina","971":"Emiratele Arabe Unite","972":"Israel","973":"Bahrain","974":"Qatar","975":"Bhutan","976":"Mongolia","977":"Nepal","992":"Tadjikistan","993":"Turkmenistan","994":"Azerbaidjan","995":"Georgia","996":"Kârgâzstan","998":"Uzbekistan","1242":"Bahamas","1246":"Barbados","1264":"Anguilla","1268":"Antigua si Barbuda","1284":"Insulele Virgine Britanice","1340":"Insulele Virgine, SUA","1345":"Insulele Cayman","1441":"Bermuda","1473":"Grenada","1649":"Insulele Turks și Caicos","1664":"Montserrat","1670":"Insulele Mariane de Nord","1671":"Guam","1684":"Samoa Americană","1758":"Sfânta Lucia","1767":"Dominica","1784":"Sfântul Vincent și Grenadine","1787":"Puerto Rico","1809":"Republica Dominicana","1868":"Trinidad și Tobago","1869":"Sfantul Kitts și Nevis","1876":"Jamaica","441481":"Guernsey","441534":"Jersey","registration":"Înregistrare","hello":"Buna","welcome_cargill":"Bun venit la","user_reg":"Înregistrare utilizator","enter_new_pwd":"Introduceți o parolă nouă","pwd_rule":"Parola dvs. trebuie să aibă cel puțin 8 caractere, o literă minusculă, o scrisoare cu majuscule, un număr, fără părți din numele de utilizator.","repeat_pwd":"repeta noua parola","choose_forgot_pwd_qtn":"Alegeți o întrebare pentru cazul in care uitati parola","stock_qtn":"Întrebări de rezerva","disliked_food":"Care este mâncarea care ți-a plăcut cel mai putin in copilarie?","name_of_first_plush_toy":"Care era numele primului tau animal de plus?","first_award":"Pentru ce ai câștigat prima ta medalie sau premiu?","favorite_security_question":"Care este întrebarea ta preferată de securitate?","favorite_toy":"Care este jucaria / animalul de plus care ti-a placut cel mai mult in copilarie?","first_computer_game":"Care a fost primul joc pe computer pe care l-ai jucat?","favorite_movie_quote":"Care este citatul dvs. preferat de film?","first_sports_team_mascot":"Care a fost mascota primei echipe sportive la care ai jucat?","first_music_purchase":"Ce album de muzică sau melodie ați cumpărat prima dată?","favorite_art_piece":"Care este piesa ta de artă preferată?","grandmother_favorite_desert":"Care a fost desertul preferat al bunicii tale?","first_thing_cooked":"Care a fost primul lucru pe care l-ai învățat să gătești?","childhood_dream_job":"Care a fost meseria dvs. de vis in copilarie?","place_where_significant_other_was_met":"Unde v-ați întâlnit soțul / alta persoana importanta?","favorite_vacation_location":"Cine este vorbitorul / oratorul preferat?","new_years_two_thousand":"Unde ai fost în Revelion în anul 2000?","favorite_speaker_actor":"Cine este vorbitorul / oratorul preferat?","favorite_book_movie_character":"Cine este personajul tău preferat de carte / film?","favorite_sports_player":"Cine este jucătorul tău preferat de sport?","custom_qtn":"Întrebare personalizată","own_sec_qtn":"Creați-vă propria întrebare de securitate","answer":"Răspuns","phone_inst":"Opțional. Vă rugăm să introduceți un număr de telefon pentru a vă putea recupera contul. Acest număr de telefon va fi folosit doar pentru a vă transmite codul de verificare.","optional":"(Opțional)","sms_inst":"Okta vă poate trimite un mesaj text cu un cod de recuperare. Această caracteristică este utilă atunci când nu aveți acces la e-mailul dvs.","add_ph_no":"Adauga numarul de telefon","create_acc":"Crează-mi contul","forgot_pwd_header":"Ați uitat mesajul text cu parolă","enter_phone_no":"Introduceți numărul de telefon pe care îl veți utiliza pentru a primi coduri prin mesaj text, apoi faceți clic pe Trimiteți cod pentru a verifica dacă funcționează.","country":"Țară","country_inst":"Selectați țara în care este înregistrat telefonul dvs.","back":"Retrimiteți","phone_number":"Numar de telefon","phone_number_inst":"Introduceți numărul dvs. în modul în care îl formați în mod normal. Nu adăugați codul de țară","code_prefix":"prefixul codului de țară.","send_code":"Trimite codul","done":"Realizat","verify":"Verifica","enter_code":"Introdu codul","enter_code_rule":"Verificați telefonul pentru parola dvs. și introduceți-l mai jos. Mesajul dvs. ar trebui să sosească în mai puțin de un minut.","verify_success":"Număr de telefon verificat cu succes!","click":"Clic","finish_setup":"pentru a termina configurarea.","error_review":"Vă rugăm să consultați formularul pentru a corecta următoarele erori","phone_no_not_found":"Mesajul text nu poate fi trimis deoarece nu a fost găsit niciun număr de telefon în baza de date.","noLowerCase":"Ar trebui să conțină cel puțin o literă mică","noUpperCase":"Ar trebui să conțină cel puțin o literă mare","noNumber":"Ar trebui să conțină cel puțin un număr","noSpecialCharacter":"Trebuie să conțină cel puțin un caracter special","notMinLength":"Ar trebui să conțină cel puțin $ caractere","noUsernameSubstring":"Nu trebuie să conțină o parte din nume de utilizator","noFirstnameSubstring":"Nu trebuie să conțină o parte din prenumele dvs.","noLastnameSubstring":"Nu trebuie să conțină o parte din numele de familie","tokenNotValid":"Jetonul dvs. de activare nu mai este valabil","tokenInvalidInfo":"Acest lucru se poate întâmpla dacă ați făcut clic pe linkul de activare după crearea contului, link-ul dvs. de activare a expirat sau URL-ul este incorect","reqNewToken":"Solicitați un cod nou","passcodeNotValid":"Codul dvs. de acces nu se potrivește cu înregistrările noastre. Vă rugăm să încercați din nou.","OTPEnableAfter30Sec":"Un mesaj SMS a fost trimis recent. Așteptați 30 de secunde înainte de a încerca din nou.","phoneNoAlreadySet":"Numărul de telefon a fost deja verificat pentru acest utilizator.","emptypassword":"Parola nu poate fi goală","passwordlength":"Parola nu poate fi goală","passwordnotvalid":"Parola nu este validă","passwordnotmatching":"Răspunsul trebuie să aibă cel mult $ caractere","answerlength":"Răspunsul trebuie să aibă cel mult $ caractere","phonenumbermissing":"Verificați codul de acces pe care l-ați primit pentru a continua","customQuestionEmpty":"Întrebarea personalizată nu poate fi goală","customQAsame":"Întrebarea și răspunsul personalizat nu pot fi aceleași","passwordSameasPrev":"Noua parola nu poate fi parola dvs. curentă","answerWrong":"Răspunsul la întrebarea de recuperare nu a corespuns înregistrărilor noastre","phonealreadyactive":"Acest număr a fost deja verificat, dacă doriți să actualizați, încercați un alt număr","first_name":"Prenume","last_name":"Numele de familie","enter_email":"E-mail","emailNotValid":"E-mail nu este valid","registeredapps":"Aplicații înregistrate","waitingapps":"Aplicații care așteaptă aprobarea","requestaccess":"Cere acces","admin":"Administrator","selectLang":"Selecteaza limba","dashboardLabel":"Tablou de bord","resetpwd":"Reseteaza parola","ansForgotten":"Răspundeți la intrebarea de securitate setata pentru parola","resetOktaPwd":"Resetați parola Okta","newpwd":"Parolă Nouă","rptpwd":"Repeta parola","adminLabel":"Managementul utilizatorilor","userAdministration":"Managementul utilizatorilor","adduser":"Adăugați un utilizator nou","function":"Funcţie","emailAddress":"Adresa de email","filterApp":"Filtru Aplicatie","create":"Creeaza","logoutConfirm":"Sigur vrei să te deconectezi?","no":"Nu","yes":"da","logout":"Deconectare","expireWarning":"Sesiunea dvs. va expira în% minute, apăsați OK pentru a rămâne conectat sau apăsați Cancel pentru a vă deconecta. Dacă sunteți deconectat, orice modificare va fi pierdută","update":"Actualizați","activateDeactivate":"Activare / Dezactivare","attention":"Atenţie","cancel":"Anulare","sessionTimedout":"Sesiunea dumneavoastră a expirat. Te rog Logheaza te din nou","username":"Nume de utilizator","primary_mail":"Adresa de e-mail principala","secondary_mail":"Adresa de e-mail secundara (opțional)","groups":"Grupuri","must_email":"Trebuie să fie un e-mail","ieNotSupported":"Internet Explorer nu este acceptat","tryChrome":"Internet Explorer nu este acceptat. Vă recomandăm să folosiți Chrome pentru această aplicație.","close":"Închide","forgotSQA":"Ai uitat răspunsul de securitate?","resetSecQA":"Resetați întrebarea de securitate și parola","retry":"Întoarce-te","nofactorpresent":"Această opțiune nu poate fi utilizată, deoarece numărul de telefon nu este setat. Vă rugăm să contactați administratorul.","emptypasscode":"Codul nu poate fi gol","provisioned":"Acest utilizator nu este încă înregistrat. Parola poate fi resetată numai după ce utilizatorul este activ","deprovisioned":"Acest utilizator este dezactivat. Parola poate fi resetată numai după ce utilizatorul este activ","resetsuccesspopupmsg":"Linkul de resetare a parolei a fost trimis la adresa de e-mail. Închideți fereastra pop-up folosind butonul X.","wanttoreset":"Doriți să resetați parola?","wanttoactivate":"Doriți să activați utilizatorul?","wanttodeactivate":"Doriți să dezactivați utilizatorul? ","wanttodelete":"Doriți să ștergeți utilizatorul?","updateprofile":"Actualizati profilul","updatesuccess":"Utilizatorul a fost actualizat cu succes","usercreated":"* Utilizator creat","errorcreatinguser":"* Eroare la crearea utilizatorului / e-mailului există deja","privacypolicy":"Politica de Confidențialitate","termsandconditions":"Termeni si conditii","uname-email":"Nume de utilizator / E-mail","password_placeholder":"Parola","sign-in":"Autentificare","resetmailsent":"Un e-mail a fost trimis la% cu linkul de resetare a parolei.","smssent":"Trimis","resendcode":"Retrimite codul","needhelp":"Ai nevoie de ajutor la conectare?","forgotPassword":"Ați uitat parola?","helplink":"Ajutor","smsusage":"SMS-ul poate fi utilizat numai dacă a fost configurat un număr de telefon mobil.","backtosignin":"Înapoi la Autentificare","resetviasms":"Resetați prin SMS","resetviaemail":"Resetați prin e-mail","didntreceivecode":"Nu ați primit un cod?Resetați prin e-mail","emailsent":"Email trimis!","recoverycredentialsnotset":"Nu se poate recupera parola uitata, deoarece datele de identificare pentru recuperare nu sunt setate pentru acest utilizator","usernotpresent":"Utilizatorul nu este prezent","mobilenumbernotset":"Numărul mobil nu este setat","invalidcreds":"Nume de utilizator sau parola incorecte","emailreq":"E-mail obligatoriu","emailinvalid":"Adresa de e-mail nu este valida.","pwdreq":"Parola obligatorie","otplength":"Parola unica ar trebui să aibă 6 caractere","passcodeinvalid":"Parola unica invalida","firstnamereq":"Prenume obligatoriu","lastnamereq":"Numele obligatoriu","notallowedincurrentstate":"Această operație nu este permisă în starea de autentificare curentă","nopartsofusername":"Parola nu poate conține părți din numele dvs. de utilizator, nu includeți prenumele sau prenumele","passwordusedrecently":"Parola a fost folosită prea recent","passwordnotmetrequirements":"Parola nu îndeplinește cerințele de complexitate ale politicii actuale privind parolele","antar":"Antarctica","aus":"Australia","can":"Canada","falk":"Insulele Falkland (Malvinas)","kazak":"Kazahstan","mayotte":"Mayotte","morocco":"Maroc","norway":"Norvegia","pitcairn":"Pitcairn","filteruser":"Filtrați utilizatorii după aplicație","selectgroups":"Selectați aplicație","status":"Status","atleastonegroup":"Selectați cel puțin un grup pentru a atribui utilizatorului","answerchallenge":"Răspundeți la intrebarea de uitare a parolei","entersmscode":"Introduceți codul de verificare trimis prin SMS","enterusercreds":"Introduceți detaliile utilizatorului","inviteuser":"Invitați un utilizator nou","assignApplication":"Alocare la cerere","availablegroups":"Grupuri disponibile","selectedgroups":"Grupuri alocate","emailsenttouser":"E-mail trimis cu succes catre","pendingactivation":"Se asteapta activarea contului","exit":"Ieșire","myprofile":"Profilul meu","activatesuccess":"Utilizatorul a fost activat cu succes și a fost trimis un e-mail de activare","deactivatesuccess":"a fost dezactivat cu succes","deletesuccess":"a fost șters cu succes","edituser":"Editare utilizator","getstarted":"Incepe","congrats":"Felicitări!","accountsetup":"Ați finalizat cu succes configurarea contului.","edit":"Editați | ×","assignedapps":"Aplicații atribuite","assignedgroups":"Grupuri alocate","oldpwd":"Introduceți parola veche","changepwd":"Schimbați parola","updatephone":"Actualizați nr. de telefon","pwdupdated":"Parola a fost actualizată cu succes","QAupdated":"Răspunsul la întrebările de securitate a fost actualizat cu succes","phonenumberinvalid":"Numărul de telefon nu este valid","phoneupdated":"Numărul de telefon a fost actualizat cu succes","showmore":"Afișați mai multe","verifypassword":"Verifică parola","filterusergrp":"Filtrați utilizatorii după grup","allactiveusers":"Toți utilizatorii activi","viewuser":"Vizualizare utilizator","partofokta":"Acest utilizator face parte din organizația Okta","userdeactive":"Utilizatorul este dezactivat","showing":"Se afișează","of":"de","answerpartofquestion":"Răspunsul nu trebuie să facă parte din întrebare","activationpending":"Codul dvs. este în așteptare pentru activare, vă rugăm să actualizați numărul dvs. de telefon, altfel resetarile SMS vor fi trimise la numărul dvs. activ anterior","change_forgot_pwd_qtn":"Schimbă întrebarea de securitate","basicinfo":"Informatii de baza","gotoapp":"Faceți clic pe Aplicația pe care doriți să o accesați","passwordresetsuccess":"Parola dvs. a fost resetată cu succes","passwordreset":"Parola a fost resetata!","searchinfotext":"* Căutarea se face doar pe aplicație","tmlabel":"configurație","delete":"Șterge","search":"Căutare","nop":"Număr","nop_inst":"Introduceți numărul dvs. în modul în care îl formați în mod normal. Nu adăugați codul de țară","nopMobile":"Număr de telefon mobil","statusactive":"Activ","statuspending":"În așteptare pentru activare","globalsearch":"Căutați alți utilizatori","permissiondenied":"Nu puteți șterge/dezactiva acest utilizator. Utilizatorul este alocat altor grupuri. Puteți scoate utilizatorul din grup.","activestatus":"ACTIV","provisionedstatus":"In asteptare","deprovisionedstatus":"NEPLANIFICAT","save":"Salvați","admingroup":"Grup de administratori","application":"Cerere/Aplicatie","selectadmingroup":"Selectați grupul de administratori","selectapp":"Selectați aplicația","adminConfigIncomplete":"Rândul incomplet. Vă rugăm să alocați un grup de admin pentru salvarea sau eliminarea rândului","adminconfigdeletesuccess":"Șters cu succes","adminconfigupdatesuccess":"Configurarea a fost actualizată cu succes","wanttodeleteadminconfig":"Doriți să ștergeți această configurare?","cannotdeleteconfig":"Această configurație nu poate fi ștearsă","nonanoktauser":"Nu este permis să facă această acțiune. Furnizorul de identitate al acestui utilizator nu este Okta.","reactivate":"Retransmite invitația","wanttoreactivate":"Doriți să retrimiteți linkul de activare către utilizator?","iread1":"Sunt de acord că portalurile, aplicațiile și serviciile pentru clienți Cargill disponibile prin intermediul acestora fac obiectul portalului clienților Cargill","iread2":"Termeni si conditii","iread3":", care poate fi completat sau modificat prin termeni și condiții specifice pentru fiecare serviciu de afaceri aplicabil.","iagree1":"Recunosc și accept că prelucrarea de către Cargill a datelor cu caracter personal în legătură cu portalurile, aplicațiile și serviciile clienților Cargill sunt supuse Cargill's","iagree2":"Politica de confidențialitate online","iagree3":", care poate fi completat sau modificat prin „Anunțuri de confidențialitate” pentru fiecare serviciu de afaceri aplicabil.","privacypolicy_link":"https://www.cargill.com/page/privacy","termsandconditions_link":"https://www.cargill.com/portal-terms","resetreactivate":"Reset / Reactivare","emailinvaliddomain":"Utilizatorul cu acest domeniu nu poate fi adăugat","administeredgroups":"Grupuri administrate","selectgroupslist":"Selectați Grupuri","alreadyactive":"Sunteți un utilizator activ!","alreadyactivesetup":"Profilul dvs. nu necesită înregistrare. Utilizați conectarea angajaților Cargill pentru a vă conecta la aplicațiile dvs.","selectBrand":"Selectați marca","permissiondeniedreset":"Nu puteți reseta parola pentru acest utilizator. ","unlockaccount":"Deblochează contul","unlockaccountsuccess":"Contul dvs. a fost deblocat cu succes","accountunlocked":"Cont deblocat!","copyrefid":"Vă rugăm să copiați ID-ul de referință din partea de jos a e-mailului pe care l-ați primit și lipiți-l mai jos pentru a continua.","securityquestionanswerweak":"Răspunsul la întrebarea de securitate este prea slab, răspunsul nu trebuie să facă parte din întrebare","securityanswermatchesquestion":"Răspuns de securitate invalid: răspunsul nu trebuie să conțină $, care face parte din întrebarea de securitate","copysecurityanswermatchesquestion":"Răspuns de securitate invalid: răspunsul nu trebuie să conțină $, care face parte din întrebarea de securitate","tokenInvalidShortMessage":"Linkul de activare nu mai este valid.","browserspecificmsg":"Vă rugăm să luați în considerare utilizarea browserului Chrome Google.","enterActivationDetails":"Pentru informaţiile solicitate mai jos, citiţi e-mailul de activare.","resendActivation":"Retrimitere e-mail de reactivare","reinvite":"Retrimitere invitaţie","reinviteEmailMessage":"Dacă informaţiile pe care le-aţi introdus sunt corecte, veţi primi un nou e-mail de activare.","reinviteContactAdminMessage":"Contactaţi-vă reprezentantul Cargill dacă nu primiţi noul e-mail de activare.","activationOk":"Ok","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","disableExistingUserOnboard":"Disable Existing User","selfRegSubGrps":"Self registration additional group:","selectReggroup":"Select Registration group","selfRegister":"Înscriere","selfRegFormTitle":"Înregistrare","E0001":"Ne pare rău, a apărut o problemă la configurarea contului dumneavoastră.","E0001_1":" Contactați-ne ","E0001_2":"dacă aveți nevoie de ajutor pentru configurarea contului dumneavoastră.","E0002":" for assistance with setting up your account.","E0003":"Contul dumneavoastră a fost înregistrat cu succes. Un e-mail a fost trimis la ","E0003_1":" cu instrucțiuni pentru activarea contului.","E0004":"Contul dumneavoastră a fost înregistrat cu succes. Vă puteți conecta la aplicație folosind parola existentă. Dacă nu vă amintiți parola, folosiți opțiunea „Parolă uitată” oferită de aplicație pentru a reseta parola.","E0005":"User already exists with status ","E0005_1":" Please contact ","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"Cerințele privind parola nu au fost îndeplinite. Cerințe privind parola: cel puțin 8 caractere, o literă mică, o literă mare, un număr, fără părți din numele dvs. de utilizator. Parola dvs. nu poate fi nici una dintre ultimele dvs. 24 de parole.","acceptTerms":"Vă rugăm să acceptați Politica noastră de confidențialitate și Termenii și condițiile pentru a continua.","phoneVerificationNotCompleted":"Vă rugăm să verificați/eliminați numărul de telefon pentru a continua.","verifyPhoneWarning":"Vă rugăm să faceți clic pe „Trimite codul” pentru a vă verifica numărul de telefon","viewMoreInfo":"Vezi mai multe informații","infoContent":"Vedeți mai multe informații despre utilizator","createdDate":"data creata","activatedDate":"Data activarii","lastLoginDate":"Data ultimei autentificare","lastUpdatedDate":"Data ultimei actualizări","passwordChangedDate":"Data modificării parolei","statusChangedDate":"Data modificării statutului","createdDateDescription":"Data și ora la care a fost creată înregistrarea utilizatorului în Okta.","activatedDateDescription":"Data și ora la care a fost trimis ultimul e-mail de activare a utilizatorului.","statusChangedDateDescription":"Data și ora la care starea utilizatorului a fost modificată ultima dată în Okta.","lastLoginDateDescription":"Data și ora la care utilizatorul sa conectat ultima dată la Okta (nu specifică aplicației).","lastUpdatedDateDescription":"Data și ora la care înregistrarea utilizatorului a fost actualizată ultima dată în Okta.","passwordChangedDateDescription":"Data și ora la care utilizatorul și-a schimbat ultima dată parola.","resetMFATitle":"Resetați autentificarea multifactor","noFactorExist":"Nu există niciun factor pentru acest utilizator.","mfaValidation":"Vă rugăm să selectați un factor de resetat.","resetButton":"Resetează","mfaResetModalTitle":"Resetare MFA","factorResetSuccess":"Factorul a fost resetat cu succes.","resetConfirmation":"Sigur doriți să resetați MFA pentru acest utilizator?","copyrights":"Cargill, Încorporat. Toate drepturile rezervate.","reportLabel":"Raport","bulkUploadLabel":"Utilizatori de încărcare în bloc","availableIndependentGroups":"Grupuri independente disponibile:","selectedBrand":"Marca selectată:","bulkUploadOptionsLabel":"Opțiuni de încărcare în bloc","bulkCreateUsers":"Creați utilizatori în bloc","bulkReinviteUsers":"Reinvitați în bloc utilizatorii","confirm":"A confirma","downloadExcelTemplate":"Descărcați șablonul Excel:","uploadInstruction":"După descărcarea șablonului, completați foaia excel și încărcați folosind secțiunea de mai jos","uploadWarningOne":"Numai 50 de utilizatori sunt permisi simultan.","uploadWarningTwo":"Asigurați-vă că câmpul de e-mail nu este lăsat gol.","uploadWarningThree":"Asigurați-vă că ID-urile de e-mail furnizate sunt administrate de dvs.","uploadWarningFour":"Asigurați-vă că nu există câmpuri rămase goale.","uploadWarningFive":"Asigurați-vă că toate valorile câmpurilor sunt valide.","uploadWarningSix":"Asigurați-vă că ID-urile de grup furnizate sunt administrate de dvs.","uploadNote":"Invitațiile trimise prin acest proces urmează e-mailul standard de invitare a contului Cargill.","uploadLabel":"Încărcați","action":"Acțiuni","userword":"utilizatorii","note":"Notă:","authentication":"Autentificare","noTableData":"Nu există date pentru tabel.","readOnlyGroup":"Acesta este un grup numai pentru citire. Alocarea pentru acest grup trebuie făcută numai prin access.cargill.com","adminPermissionDenied":"Drepturile dvs. de administrator de utilizator nu au permisiuni pentru a modifica această atribuire de grup.","msgForGenericErrorUA":"În prezent, ne confruntăm cu o problemă cu procesarea solicitării dvs. Vă rugăm să încercați din nou mai târziu. Dacă continuați să vedeți această eroare, contactați reprezentantul serviciului pentru clienți pentru asistență suplimentară.","passcodeRateLimit":"Nu se poate procesa solicitarea dvs., vă rugăm să încercați din nou în 5 minute.","passcodeNotEntered":"Vă rugăm să introduceți parola pentru a verifica.","msgForUnhandledResponse":"Nu se poate procesa cererea, vă rugăm să contactați reprezentantul serviciului pentru clienți.","groupUnavailable":"Grupul nu mai este disponibil în Okta. Este posibil ca grupul să fi fost șters.","groupCannotBeAssigned":"Grupul $ nu mai este disponibil în Okta și, prin urmare, nu poate fi atribuit utilizatorului. Vă rugăm să eliminați grupul și să continuați.","copyGroupCannotBeAssigned":"Grupul $ nu mai este disponibil în Okta și, prin urmare, nu poate fi atribuit utilizatorului. Vă rugăm să eliminați grupul și să continuați."}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = {"1":"Соединенные Штаты","7":"Российская Федерация","20":"Египет","27":"Южная Африка","30":"Греция","31":"Нидерланды","32":"Бельгия","33":"Франция","34":"Испания","36":"Венгрия","39":"Италия","40":"Румыния","41":"Швейцария","43":"Австрия","44":"Соединенное Королевство","45":"Дания","46":"Швеция","47":"Шпицберген и Ян Майен","48":"Польша","49":"Германия","51":"Перу","52":"Мексика","53":"Куба","54":"Аргентина","55":"Бразилия","56":"Чили","57":"Колумбия","58":"Венесуэла, Боливарианская Республика","60":"Малайзия","61":"Остров Рождества","62":"Индонезия","63":"Филиппины","64":"Новая Зеландия","65":"Сингапур","66":"Таиланд","81":"Япония","82":"Корея, Республика","84":"Вьетнам","86":"Китай","90":"индюк","91":"Индия","92":"Пакистан","93":"Афганистан","94":"Шри-Ланка","95":"Мьянма","98":"Иран, Исламская Республика","211":"Южный Судан","212":"Западная Сахара","213":"Алжир","216":"Тунис","218":"Ливия","220":"Гамбия","221":"Сенегал","222":"Мавритания","223":"Мали","224":"Гвинея","225":"Кот-д'Ивуар","226":"Буркина-Фасо","227":"Нигер","228":"Идти","229":"Бенин","230":"Маврикий","231":"Либерия","232":"Сьерра-Леоне","233":"Гана","234":"Нигерия","235":"Чад","236":"Центрально-Африканская Республика","237":"Камерун","238":"Кабо-Верде","239":"Сан-Томе и Принсипи","240":"Экваториальная Гвинея","241":"Габон","242":"Конго","243":"Конго, Демократическая Республика","244":"Ангола","245":"Гвинея-Бисау","246":"Британская территория Индийского океана","248":"Сейшельские острова","249":"Судан","250":"Руанда","251":"Эфиопия","252":"Сомали","253":"Джибути","254":"Кения","255":"Танзания, Объединенная Республика","256":"Уганда","257":"Бурунди","258":"Мозамбик","260":"Замбия","261":"Мадагаскар","262":"воссоединение","263":"Зимбабве","264":"Намибия","265":"Малави","266":"Лесото","267":"Ботсвана","268":"Свазиленд","269":"Коморские острова","290":"Святой Елены, Вознесения и Тристан-да-Кунья","291":"Эритрея","297":"Аруба","298":"Фарерские острова","299":"Гренландия","350":"Гибралтар","351":"Португалия","352":"Люксембург","353":"Ирландия","354":"Исландия","355":"Албания","356":"Мальта","357":"Кипр","358":"Финляндия","359":"Болгария","370":"Литва","371":"Латвия","372":"Эстония","373":"Молдавия","374":"Армения","375":"Беларусь","376":"Aндорра","377":"Монако","378":"Сан-Марино","379":"Святой Престол (город-государство Ватикан)","380":"Украина","381":"Сербия","382":"Черногория","385":"Хорватия","386":"Словения","387":"Босния и Герцеговина","389":"Македония","420":"Республика Чехия","421":"Словакия","423":"Лихтенштейн","500":"Южная Георгия и Южные Сандвичевы острова","501":"Белиз","502":"Гватемала","503":"Эль Сальвадор","504":"Гондурас","505":"Никарагуа","506":"Коста Рика","507":"Панама","508":"Сен-Пьер и Микелон","509":"Гаити","590":"Гваделупа","591":"Боливия","592":"Гайана","593":"Эквадор","595":"Парагвай","596":"Мартиника","597":"Суринам","598":"Уругвай","599":"Нидерландские Антильские острова","670":"Восточный Тимор","672":"Остров Норфолк","673":"Бруней-Даруссалам","674":"Науру","675":"Папуа - Новая Гвинея","676":"Тонга","677":"Соломоновы острова","678":"Вануату","679":"Фиджи","680":"Palau","681":"Уоллис и Футуна","682":"Острова Кука","683":"Niue","685":"Самоа","686":"Кирибати","687":"Новая Каледония","688":"Тувалу","689":"Французский полинезийский","690":"Токелау","691":"Микронезия","692":"Маршалловы острова","850":"Корейская Народно-Демократическая Республика","852":"Гонконг","853":"Macao","855":"Камбоджа","856":"Лаосская Народно-Демократическая Республика","880":"Бангладеш","886":"Тайвань","960":"Мальдивы","961":"Ливан","962":"Иордания","963":"Сирийская Арабская Республика","964":"Ирак","965":"Кувейт","966":"Саудовская Аравия","967":"Йемен","968":"Оман","970":"Палестина","971":"Объединенные Арабские Эмираты","972":"Израиль","973":"Бахрейн","974":"Катар","975":"Бутан","976":"Монголия","977":"Непал","992":"Таджикистан","993":"Туркменистан","994":"Азербайджан","995":"Грузия","996":"Киргизия","998":"Узбекистан","1242":"Багамские о-ва","1246":"Барбадос","1264":"Ангилья","1268":"Антигуа и Барбуда","1284":"Виргинские острова, Британские","1340":"Виргинские острова, США","1345":"Каймановы острова","1441":"Бермудские острова","1473":"Гренада","1649":"Острова Теркс и Кайкос","1664":"Монсеррат","1670":"Северные Марианские острова","1671":"Гуам","1684":"Aмериканское Самоа","1758":"Санкт-Люсия","1767":"Доминика","1784":"Святой Винсент и Гренадины","1787":"Пуэрто-Рико","1809":"Доминиканская Респблика","1868":"Тринидад и Тобаго","1869":"Сент-Китс и Невис","1876":"Ямайка","441481":"шерстяная фуфайка","441534":"Джерси","registration":"Регистрация","hello":"Добрый день","welcome_cargill":"Добро пожаловать в","user_reg":"Регистрация пользователя","enter_new_pwd":"Введите новый пароль","pwd_rule":"Ваш пароль должен содержать не менее 8 символов, строчную букву, заглавную букву, цифру, без частей вашего имени пользователя.","repeat_pwd":"Повторите новый пароль","choose_forgot_pwd_qtn":"Выберите секретный вопрос ","stock_qtn":"Фондовые вопросы","disliked_food":"Kакая еда вам меньше всего понравилась в детстве?","name_of_first_plush_toy":"Как зовут вашего первого чучела?","first_award":"За что вы заработали свою первую медаль или награду?","favorite_security_question":"Какой ваш любимый секретный вопрос?","favorite_toy":"Какая игрушка / чучело тебе понравилось больше всего в детстве?","first_computer_game":"В какую первую компьютерную игру ты играл?","favorite_movie_quote":"Какая твоя любимая цитата из фильма?","first_sports_team_mascot":"Каким был талисман первой спортивной команды, в которой ты играл?","first_music_purchase":"Какой музыкальный альбом или песню вы впервые купили?","favorite_art_piece":"Какое ваше любимое произведение искусства?","grandmother_favorite_desert":"Какой был любимый десерт вашей бабушки?","first_thing_cooked":"Что было первым, что вы научились готовить?","childhood_dream_job":"О чем вы мечтали в детстве?","place_where_significant_other_was_met":"Где вы встретили своего супруга / значимого друга?","favorite_vacation_location":"Куда вы ходили на любимые каникулы?","new_years_two_thousand":"Где вы были в канун Нового года в 2000 году?","favorite_speaker_actor":"Кто ваш любимый оратор / оратор?","favorite_book_movie_character":"Кто ваш любимый персонаж книги / фильма?","favorite_sports_player":"Кто ваш любимый спортивный игрок?","custom_qtn":"Пользовательский вопрос","own_sec_qtn":"Создайте свой собственный контрольный вопрос","answer":"Введите ответ на секретный вопрос","phone_inst":"Дополнительно. Введите номер телефона для восстановления учетной записи. Данный номер телефона будет использоваться только для отправки проверочных СМС-кодов.","optional":"(по желанию)","sms_inst":"Okta может отправить вам текстовое сообщение с кодом восстановления. Эта функция полезна, когда у вас нет доступа к электронной почте.","add_ph_no":"Добавьте номер телефона","create_acc":"Создать учётную запись","forgot_pwd_header":"Забыли пароль Текстовое сообщение","enter_phone_no":"Введите номер телефона, который вы будете использовать для получения кодов через текстовое сообщение, затем нажмите «Отправить код», чтобы убедиться, что он работает.","country":"Страна","country_inst":"Выберите страну, в которой зарегистрирован Ваш телефон","back":"Отправить","phone_number":"Номер телефона","phone_number_inst":"Введите свой номер так, как вы его обычно набираете. Не добавляйте код своей страны","code_prefix":"Nрефикс кода страны.","send_code":"Отправить код","done":"Готово","verify":"Проверить","enter_code":"Введите код","enter_code_rule":"Код подтверждения был отправлен на Ваш телефон. Код должен прийти менее чем через минуту.","verify_success":"Номер телефона успешно подтвержден!","click":"Нажмите","finish_setup":"закончить настройку.","error_review":"Пожалуйста, просмотрите форму, чтобы исправить следующие ошибки","phone_no_not_found":"Текстовое сообщение не может быть отправлено, так как в базе данных не найден номер телефона.","noLowerCase":"Должен содержать как минимум одну строчную букву","noUpperCase":"Должен содержать как минимум одну заглавную букву","noNumber":"Должен содержать хотя бы одно число","noSpecialCharacter":"Должен содержать хотя бы один специальный символ","notMinLength":"Должен содержать не менее $ символов","noUsernameSubstring":"Не должен содержать часть имени пользователя","noFirstnameSubstring":"Не должно содержать часть вашего имени","noLastnameSubstring":"Не должно содержать часть вашей фамилии","tokenNotValid":"Ваш токен активации больше не действителен","tokenInvalidInfo":"Это может произойти, если вы щелкнули ссылку активации после создания учетной записи, срок действия ссылки активации истек или неправильный URL-адрес","reqNewToken":"Запросить новый токен","passcodeNotValid":"Ваш пароль не соответствует нашим записям. Пожалуйста, попробуйте еще раз.","OTPEnableAfter30Sec":"SMS-сообщение было недавно отправлено. Пожалуйста, подождите 30 секунд, прежде чем пытаться снова.","phoneNoAlreadySet":"Номер телефона уже подтвержден этим пользователем.","emptypassword":"Пароль не может быть пустым","passwordlength":"Пароль не может быть пустым","passwordnotvalid":"Пароль не действителен","passwordnotmatching":"Пароли должны совпадать","answerlength":"Ответ должен быть длиной не менее $ символов","phonenumbermissing":"Чтобы продолжить, проверьте полученный пароль.","customQuestionEmpty":"Пользовательский вопрос не может быть пустым","customQAsame":"Пользовательский вопрос и ответ не могут быть одинаковыми","passwordSameasPrev":"Пароль не может быть вашим текущим паролем","answerWrong":"Ответ на вопрос восстановления не соответствует нашим записям","phonealreadyactive":"Этот номер уже подтвержден, если вы хотите обновить, попробуйте другой номер","first_name":"Имя","last_name":"Фамилия","enter_email":"Электронный идентификатор","emailNotValid":"Идентификатор электронной почты недействителен","registeredapps":"Зарегистрированные приложения","waitingapps":"Приложения ждут подтверждения","requestaccess":"Запрос доступа","admin":"Администратор","selectLang":"Выберите язык","dashboardLabel":"Приборная доска","resetpwd":"Сброс пароля","ansForgotten":"Ответьте на секретный вопрос для восстановления пароля","resetOktaPwd":"Сбросить свой пароль","newpwd":"новый пароль","rptpwd":"Повторите пароль","adminLabel":"Управление пользователями","userAdministration":"Управление пользователями","adduser":"Добавить нового пользователя","function":"функция","emailAddress":"Адрес электронной почты","filterApp":"Применение фильтра","create":"Создайте","logoutConfirm":"Вы действительно хотите выйти?","no":"нет","yes":"да","logout":"Выйти","expireWarning":"Ваш сеанс истекает через% минут, нажмите OK, чтобы остаться в системе, или нажмите Отмена, чтобы выйти. Если вы отключены, любые изменения будут потеряны","update":"Обновить","activateDeactivate":"Включение / выключение","attention":"Внимание","cancel":"Отмена","sessionTimedout":"Время сеанса истекло. Пожалуйста, войдите снова","username":"имя пользователя","primary_mail":"Основной адрес электронной почты","secondary_mail":"Дополнительный адрес электронной почты (необязательно)","groups":"группы","must_email":"Должно быть электронная почта","ieNotSupported":"IE не поддерживается","tryChrome":"Internet Explorer не поддерживается. Мы рекомендуем использовать Chrome для этого приложения.","close":"близко","forgotSQA":"забыли секретный ответ?","resetSecQA":"Сбросить секретный вопрос и пароль","retry":"Вернитесь назад","nofactorpresent":"Эта опция не может быть использована, потому что номер мобильного телефона не привязан. Пожалуйста, свяжитесь с вашим администратором.","emptypasscode":"Код не может быть пустым","provisioned":"Этот пользователь еще не зарегистрирован. Пароль может быть сброшен только после того, как пользователь активен","deprovisioned":"Этот пользователь деактивирован. Пароль может быть сброшен только после того, как пользователь активен","resetsuccesspopupmsg":"Ссылка для сброса пароля была отправлена ​​на адрес электронной почты. Пожалуйста, закройте всплывающее окно, используя кнопку X.","wanttoreset":"Вы хотите сбросить пароль?","wanttoactivate":"Вы хотите активировать пользователя?","wanttodeactivate":"Вы хотите деактивировать пользователя? ","wanttodelete":"Вы хотите удалить пользователя?","updateprofile":"Обновить профиль","updatesuccess":"Пользователь был успешно обновлен","usercreated":"* Пользователь создан","errorcreatinguser":"* Ошибка создания пользователя / адрес электронной почты уже существует","privacypolicy":"Политика конфиденциальности","termsandconditions":"Yсловия и положения","uname-email":"Имя пользователя / Email","password_placeholder":"пароль","sign-in":"Авторизоваться","resetmailsent":"Письмо было отправлено в% со ссылкой для сброса пароля.","smssent":"Nослал","resendcode":"Отправить код еще раз","needhelp":"Нужна помощь при входе?","forgotPassword":"забыл пароль?","helplink":"Помогите","smsusage":"СМС можно использовать только в том случае, если номер мобильного телефона был настроен.","backtosignin":"Вернуться к входу","resetviasms":"Сброс через СМС","resetviaemail":"Сброс по электронной почте","didntreceivecode":"Не получили код? сброс через электронную почту","emailsent":"Письмо отправлено!","recoverycredentialsnotset":"Забытый пароль не разрешен, поскольку учетные данные восстановления не заданы для пользователя","usernotpresent":"Пользователь не присутствует","mobilenumbernotset":"Мобильный номер не установлен","invalidcreds":"неправильное имя пользователя или пароль","emailreq":"Требуется электронная почта","emailinvalid":"Email недействителен","pwdreq":"Требуется пароль","otplength":"OTP должен быть длиной 6 символов","passcodeinvalid":"Неверный OTP","firstnamereq":"Имя обязательно","lastnamereq":"Фамилия требуется","notallowedincurrentstate":"Эта операция не разрешена в текущем состоянии аутентификации","nopartsofusername":"Пароль не может содержать части вашего имени пользователя, включая ваше имя или вашу фамилию","passwordusedrecently":"Пароль был использован слишком недавно","passwordnotmetrequirements":"Пароль не соответствует требованиям к сложности текущей политики паролей.","antar":"Антарктида","aus":"Австралия","can":"Канада","falk":"Фолклендские (Мальвинские) острова","kazak":"Казахстан","mayotte":"Майотта","morocco":"Марокко","norway":"Норвегия","pitcairn":"Питкэрн","filteruser":"Фильтрация пользователей по приложению","selectgroups":"Выберите приложение","status":"Статус","atleastonegroup":"Выберите хотя бы одну группу, чтобы назначить пользователя","answerchallenge":"Ответ на забытый пароль","entersmscode":"Введите код подтверждения, отправленный с помощью SMS","enterusercreds":"Введите данные пользователя","inviteuser":"Пригласить нового пользователя","assignApplication":"Назначить приложению","availablegroups":"Доступные группы","selectedgroups":"Назначенные группы","emailsenttouser":"Письмо успешно отправлено на адрес","pendingactivation":"Ожидание активации аккаунта","exit":"Выход","myprofile":"Мой профайл","activatesuccess":"Пользователь был успешно активирован, и письмо было отправлено","deactivatesuccess":"был успешно деактивирован","deletesuccess":"был успешно удален","edituser":"Редактировать пользователя","getstarted":"Начать","congrats":"Поздравляем!","accountsetup":"Вы успешно завершили настройку своего аккаунта.","edit":"редактировать","assignedapps":"Назначенные приложения","assignedgroups":"Назначенные группы","oldpwd":"Введите старый пароль","changepwd":"Измени пароль","updatephone":"Обновить телефон","pwdupdated":"Пароль был успешно обновлен","QAupdated":"Секретный вопрос Ответ был успешно обновлен","phonenumberinvalid":"Номер телефона недействителен","phoneupdated":"Номер телефона успешно обновлен","showmore":"Показать больше","verifypassword":"подтвердите пароль","filterusergrp":"Фильтровать пользователей по группам","allactiveusers":"Все активные пользователи","viewuser":"Просмотр пользователя","partofokta":"Этот пользователь является частью организации Okta","userdeactive":"Пользователь неактивен","showing":"показ","of":"из","answerpartofquestion":"Ответ не должен быть частью вопроса","activationpending":"Ваш фактор в ожидании активации. Пожалуйста, обновите свой номер телефона, в противном случае SMS-сообщения о сбросе будут отправлены на ваш предыдущий активный номер.","change_forgot_pwd_qtn":"Изменить секретный вопрос","basicinfo":"Основная информация","gotoapp":"Пожалуйста, нажмите на значок ниже, чтобы перейти на портал.","passwordresetsuccess":"Ваш пароль был успешно сброшен","passwordreset":"Восстановление пароля!","searchinfotext":"* Поиск осуществляется только в приложении","tmlabel":"конфигурация","delete":"удалять","search":"Поиск","nop":"Номер телефона","nop_inst":"Введите Ваш номер телефона без кода страны","nopMobile":"Номер мобильного телефона","statusactive":"активный","statuspending":"Ожидание активации","globalsearch":"Поиск других пользователей","permissiondenied":"Вы не можете удалить / деактивировать этого пользователя. пользователь назначен на другие группы. Вы можете отменить назначение пользователя вместо","activestatus":"ACTIVE","provisionedstatus":"Предоставлен","deprovisionedstatus":"Деинициализированные","save":"Сохранить","admingroup":"Административная группа","application":"заявка","selectadmingroup":"Выберите группу администратора","selectapp":"Выберите приложение","adminConfigIncomplete":"Строка неполная. Пожалуйста, назначьте группу администраторов, чтобы сохранить или удалить строку","adminconfigdeletesuccess":"Удалено успешно","adminconfigupdatesuccess":"Конфиг успешно обновлен","wanttodeleteadminconfig":"Вы хотите удалить этот конфиг?","cannotdeleteconfig":"Этот конфиг не может быть удален","nonanoktauser":"Не разрешено делать это действие. Поставщик удостоверений этого пользователя не Okta.","reactivate":"Отправить приглашение","wanttoreactivate":"Хотите отправить ссылку активации пользователю?","iread1":"Я согласен с тем, что клиентские порталы, приложения и услуги Cargill, доступные через них, подпадают под действие ","iread2":"положений и условий клиентского портала ","iread3":"Cargill, которые  могут быть дополнены или изменены конкретными условиями и положениями для каждой предоставляемой бизнес- услуги.","iagree1":"Я осознаю и принимаю тот факт, что обработка персональных данных Cargill связанная с клиентскими порталами, приложениями и услугами Cargill регулируется ","iagree2":"политикой конфиденциальности Cargill в сети Интернет","iagree3":", которая может быть дополнена или изменена \"Уведомлениями о конфиденциальности\" для каждой предоставляемой бизнес- услуги.","privacypolicy_link":"https://www.cargill.com/page/privacy","termsandconditions_link":"https://www.cargill.com/portal-terms","resetreactivate":"Сброс / Возобновить","emailinvaliddomain":"Пользователь с этим доменом не может быть добавлен","administeredgroups":"Администрируемые группы","selectgroupslist":"Выберите группы","alreadyactive":"Вы активный пользователь!","alreadyactivesetup":"Ваш профиль не требует регистрации. Используйте логин сотрудника Cargill для входа в свои приложения.","selectBrand":"Выберите бренд","permissiondeniedreset":"Вы не можете сбросить пароль для этого пользователя. ","unlockaccount":"Разблокировать аккаунт","unlockaccountsuccess":"Ваш аккаунт был успешно разблокирован","accountunlocked":"Аккаунт разблокирован!","copyrefid":"Пожалуйста, скопируйте \"Имя пользователя\" из нижней части письма, которое Вы получили, и вставьте его в поле ниже, чтобы продолжить.","securityquestionanswerweak":"Ответ на секретный вопрос слишком слабый, ответ не должен быть частью вопроса","securityanswermatchesquestion":"Неверный контрольный ответ: ответ не должен содержать символ $, являющийся частью секретного вопроса.","copysecurityanswermatchesquestion":"Неверный контрольный ответ: ответ не должен содержать символ $, являющийся частью секретного вопроса.","tokenInvalidShortMessage":"Ваша ссылка для активации более не действительна","browserspecificmsg":"Пожалуйста, подумайте об использовании браузера Google Chrome.","enterActivationDetails":"Для ввода информации, запрашиваемой ниже, пожалуйста, используйте первоначальное письмо со ссылкой для активации","resendActivation":"Повторная отправка ссылки для активации учетной записи","reinvite":"Повторно отправить сообщение","reinviteEmailMessage":"Если предоставленная Вами информация верна, то Вы получите новое письмо для со ссылкой для активации.","reinviteContactAdminMessage":"Пожалуйста, свяжитесь с представителем Cargill, если Вы не получили новое письмо со ссылкой для активации.","activationOk":"Хорошо","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","disableExistingUserOnboard":"Disable Existing User","selfRegSubGrps":"Self registration additional group:","selectReggroup":"Select Registration group","selfRegister":"Зарегистрироваться","selfRegFormTitle":"Регистрация","E0001":"К сожалению, при настройке Вашей учетной записи возникла проблема.","E0001_1":" Обратитесь к нам ","E0001_2":"за помощью в настройке Вашей учетной записи.","E0002":" for assistance with setting up your account.","E0003":"Ваша учетная запись успешно зарегистрирована. На адрес ","E0003_1":" отправлены инструкции по активации Вашей учетной записи.","E0004":"Ваша учетная запись успешно зарегистрирована. Теперь Вы можете войти в систему приложения, используя свой текущий пароль. Если Вы не помните свой пароль, нажмите параметр Forgot Password (Забыли пароль) в приложении, чтобы сбросить свой пароль.","E0005":"User already exists with status ","E0005_1":" Please contact ","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"Требования к паролю не были выполнены. Требования к паролю: не менее 8 символов, строчная буква, заглавная буква, цифра, никаких частей Вашего имени пользователя. Ваш пароль не должен повторять Ваши последние 24 пароля.","acceptTerms":"Пожалуйста, примите нашу Политику конфиденциальности и Условия использования, чтобы продолжить.","phoneVerificationNotCompleted":"Пожалуйста, подтвердите / удалите свой номер телефона, чтобы продолжить.","verifyPhoneWarning":"Нажмите «Отправить код», чтобы подтвердить свой номер телефона.","viewMoreInfo":"Посмотреть больше информации","infoContent":"Просмотр дополнительной информации о пользователе","createdDate":"Дата создания","activatedDate":"Дата активации","lastLoginDate":"Дата последнего входа в систему","lastUpdatedDate":"Дата последнего обновления","passwordChangedDate":"Дата изменения пароля","statusChangedDate":"Дата изменения статуса","createdDateDescription":"Дата и время создания записи пользователя в Okta.","activatedDateDescription":"Дата и время, когда было отправлено последнее электронное письмо с активацией пользователя.","statusChangedDateDescription":"Дата и время последнего изменения статуса пользователя в Okta.","lastLoginDateDescription":"Дата и время последнего входа пользователя в Okta (независимо от приложения).","lastUpdatedDateDescription":"Дата и время последнего обновления записи пользователя в Okta.","passwordChangedDateDescription":"Дата и время последней смены пароля пользователем.","resetMFATitle":"Сбросить многофакторную аутентификацию","noFactorExist":"Для этого пользователя не существует коэффициента.","mfaValidation":"Пожалуйста, выберите коэффициент для сброса.","resetButton":"Сброс настроек","mfaResetModalTitle":"Сброс МFА","factorResetSuccess":"Фактор успешно сброшен.","resetConfirmation":"Вы уверены, что хотите сбросить MFA для этого пользователя?","copyrights":"Cargill, Инкорпорейтед. Все права защищены.","reportLabel":"Отчет","bulkUploadLabel":"Массовая загрузка пользователей","availableIndependentGroups":"Доступные независимые группы:","selectedBrand":"Выбранный бренд:","bulkUploadOptionsLabel":"Параметры массовой загрузки","bulkCreateUsers":"Загрузить","bulkReinviteUsers":"Массовое повторное приглашение пользователей","confirm":"Подтверждать","downloadExcelTemplate":"Скачать шаблон Excel:","uploadInstruction":"После загрузки шаблона заполните лист Excel и загрузите его, используя раздел ниже.","uploadWarningOne":"Одновременно допускается не более 50 пользователей.","uploadWarningTwo":"Убедитесь, что поле электронной почты не осталось пустым.","uploadWarningThree":"Убедитесь, что предоставленные идентификаторы электронной почты администрируются вами.","uploadWarningFour":"Убедитесь, что ни одно поле не осталось пустым.","uploadWarningFive":"Убедитесь, что все значения полей действительны.","uploadWarningSix":"Убедитесь, что предоставленные идентификаторы групп администрируются вами.","uploadNote":"Приглашения, отправленные в рамках этого процесса, следуют стандартному электронному приглашению учетной записи Cargill.","uploadLabel":"Загрузить","action":"Действия","userword":"пользователи","note":"Примечание:","authentication":"Аутентификация","noTableData":"Нет данных для таблицы.","readOnlyGroup":"Это группа только для чтения. Назначение для этой группы должно быть сделано только через access.cargill.com","adminPermissionDenied":"Ваши права администратора пользователя не позволяют изменять это групповое назначение.","msgForGenericErrorUA":"В настоящее время у нас возникла проблема с обработкой вашего запроса. Пожалуйста, повторите попытку позже. Если вы продолжаете видеть эту ошибку, обратитесь к представителю службы поддержки клиентов за дальнейшей помощью.","passcodeRateLimit":"Невозможно обработать ваш запрос. Повторите попытку через 5 минут.","passcodeNotEntered":"Пожалуйста, введите пароль для проверки.","msgForUnhandledResponse":"Не удалось обработать запрос. Обратитесь к представителю службы поддержки клиентов.","groupUnavailable":"Группа больше не доступна в Окте. Возможно, группа была удалена.","groupCannotBeAssigned":"Группа $ больше не доступна в Okta и, следовательно, не может быть назначена пользователю. Пожалуйста, удалите группу и продолжайте.","copyGroupCannotBeAssigned":"Группа $ больше не доступна в Okta и, следовательно, не может быть назначена пользователю. Пожалуйста, удалите группу и продолжайте."}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = {"1":"Amerika Birleşik Devletleri","7":"Rusya Federasyonu","20":"Mısır","27":"Güney Afrika","30":"Yunanistan","31":"Hollanda","32":"Belçika","33":"Fransa","34":"ispanya","36":"Macaristan","39":"İtalya","40":"Romanya","41":"İsviçre","43":"Avusturya","44":"Birleşik Krallık","45":"Danimarka","46":"İsveç","47":"Svalbard ve Jan Mayen","48":"Polonya","49":"Almanya","51":"Peru","52":"Meksika","53":"Küba","54":"Arjantin","55":"Brezilya","56":"Şili","57":"Kolombiya","58":"Venezuela, Bolivarya Cumhuriyeti","60":"Malezya","61":"Noel Adası","62":"Endonezya","63":"Filipinler","64":"Yeni Zelanda","65":"Singapur","66":"Tayland","81":"Japonya","82":"Kore Cumhuriyeti","84":"Vietnam","86":"Çin","90":"Türkiye","91":"Hindistan","92":"Pakistan","93":"Afganistan","94":"Sri Lanka","95":"Myanmar","98":"İran İslam Cumhuriyeti","211":"Güney Sudan","212":"Batı Sahra","213":"Cezayir","216":"Tunus","218":"Libya","220":"Gambiya","221":"Senegal","222":"Moritanya","223":"Mali","224":"Gine","225":"Fildişi Sahili","226":"Burkina Faso","227":"Nijer","228":"Gitmek","229":"Benin","230":"Mauritius","231":"Liberya","232":"Sierra Leone","233":"Gana","234":"Nijerya","235":"Çad","236":"Orta Afrika Cumhuriyeti","237":"Kamerun","238":"Yeşil Burun Adaları","239":"Sao Tome ve Principe","240":"Ekvator Ginesi","241":"Gabon","242":"Kongo","243":"Kongo, Demokratik Cumhuriyeti","244":"Angora","245":"Gine Bissau","246":"Britanya Hint Okyanusu Toprakları","248":"Seyşeller","249":"Sudan","250":"Ruanda","251":"Etiyopya","252":"Somali","253":"Cibuti","254":"Kenya","255":"Tanzanya Birleşik Cumhuriyeti","256":"Uganda","257":"Burundi","258":"Mozambik","260":"Zambiya","261":"Madagaskar","262":"Birleşme","263":"Zimbabve","264":"Namibya","265":"Malawi","266":"Lesotho","267":"Botsvana","268":"Svaziland","269":"Komorlar","290":"Saint Helena, Ascension ve Tristan da Cunha","291":"Eritre","297":"Aruba","298":"Faroe Adaları","299":"Grönland","350":"Cebelitarık","351":"Portekiz","352":"Lüksemburg","353":"İrlanda","354":"İzlanda","355":"Arnavutluk","356":"Malta","357":"Kıbrıs","358":"Finlandiya","359":"Bulgaristan","370":"Litvanya","371":"Letonya","372":"Estonya","373":"Buğdan","374":"Ermenistan","375":"Belarus","376":"Andorra","377":"Monako","378":"San Marino","379":"Holy See (Vatikan Şehir Devleti)","380":"Ukrayna","381":"Sırbistan","382":"Karadağ","385":"Hırvatistan","386":"Slovenya","387":"Bosna Hersek","389":"Makedonya","420":"Çek Cumhuriyeti","421":"Slovakya","423":"Lihtenştayn","500":"Güney Georgia ve Güney Sandwich Adaları","501":"Belize","502":"Guatemala","503":"El Salvador","504":"Honduras","505":"Nikaragua","506":"Kosta Rika","507":"Panama","508":"Saint Pierre ve Miquelon","509":"Haiti","590":"Guadeloupe","591":"Bolivya","592":"Guyana","593":"Ekvador","595":"Paraguay","596":"Martinik","597":"Surinam","598":"Uruguay","599":"Hollanda Antilleri","670":"Timor-Leste","672":"Norfolk Adası","673":"Brunei Sultanlığı","674":"Nauru","675":"Papua Yeni Gine","676":"Tonga","677":"Solomon Adaları","678":"Vanuatu","679":"Fiji","680":"Palau","681":"Wallis ve Futuna","682":"Cook Adaları","683":"Niue","685":"Samoa","686":"Kiribati","687":"Yeni Kaledonya","688":"Tuvalu","689":"Fransız Polinezyası","690":"Tokelau","691":"Mikronezya","692":"Marşal Adaları","850":"Kore Demokratik Halk Cumhuriyeti","852":"Hong Kong","853":"Macao","855":"Kamboçya","856":"Lao Demokratik Halk Cumhuriyeti","880":"Bangladeş","886":"Tayvan","960":"Maldivler","961":"Lübnan","962":"Ürdün","963":"Suriye Arap Cumhuriyeti","964":"Irak","965":"Kuveyt","966":"Suudi Arabistan","967":"Yemen","968":"Umman","970":"Filistin","971":"Birleşik Arap Emirlikleri","972":"İsrail","973":"Bahreyn","974":"Katar","975":"Butan","976":"Moğolistan","977":"Nepal","992":"Tacikistan","993":"Türkmenistan","994":"Azerbeycan","995":"Gürcistan","996":"Kırgızistan","998":"Özbekistan","1242":"Bahamalar","1246":"Barbados","1264":"Anguilla","1268":"Antigua ve Barbuda","1284":"Virgin Adaları, İngiliz","1340":"Virjin Adaları, ABD","1345":"Cayman Adaları","1441":"Bermuda","1473":"Grenada","1649":"Turks ve Caicos Adaları","1664":"Montserrat","1670":"Kuzey Mariana Adaları","1671":"Guam","1684":"Amerikan Samoası","1758":"Saint Lucia","1767":"Dominika","1784":"Saint Vincent ve Grenadinler","1787":"Porto Riko","1809":"Dominik Cumhuriyeti","1868":"Trinidad ve Tobago","1869":"Saint Kitts ve Nevis","1876":"Jamaika","441481":"bir tür inek","441534":"Jersey","registration":"Kayıt","hello":"Merhaba ","welcome_cargill":"Hoşgeldiniz ","user_reg":"Kullanıcı Kayıt","enter_new_pwd":"Yeni Şifreyi Giriniz","pwd_rule":"Şifreniz en az 8 karakter, 1 küçük harf, 1 büyük harf ve 1 numara içermelidir. Kullanıcı adınızın herhangi bir kısmı olmamalıdır.","repeat_pwd":"Yeni Şifreyi Tekrar Giriniz ","choose_forgot_pwd_qtn":"Şifremi unuttum sorusu seçiniz","stock_qtn":"Stok soruları","disliked_food":"Çocukken en az sevdiğiniz yemek neydi?","name_of_first_plush_toy":"İlk oyuncak hayvanınızın adı neydi?","first_award":"İlk aldığınız madalya veya ödül ne içindi?","favorite_security_question":"Favori güvenlik sorunuz nedir?","favorite_toy":"Çocukken en çok sevdiğiniz oyuncak / doldurulmuş hayvan neydi?","first_computer_game":"İlk oynadığın bilgisayar oyunu neydi?","favorite_movie_quote":"En sevdiğiniz film repliği nedir?","first_sports_team_mascot":"Oynadığın ilk spor takımının maskotu neydi?","first_music_purchase":"İlk olarak hangi müzik albümünü veya şarkıyı satın aldınız?","favorite_art_piece":"En sevdiğiniz sanat eseri nedir?","grandmother_favorite_desert":"Büyükannenizin favori tatlısı neydi?","first_thing_cooked":"Pişirmeyi öğrendiğin ilk şey neydi?","childhood_dream_job":"Çocukken hayal ettiğiniz iş neydi?","place_where_significant_other_was_met":"Eşinizle nerede tanıştınız?","favorite_vacation_location":"En sevdiğin tatil için nereye gitmiştin?","new_years_two_thousand":"2000 yılında Yılbaşı Akşamı neredeydiniz?","favorite_speaker_actor":"En sevdiğiniz konuşmacı kimdir?","favorite_book_movie_character":"En sevdiğin kitap / film karakteri kimdir?","favorite_sports_player":"En sevdiğiniz sporcu kimdir?","custom_qtn":"Özel soru","own_sec_qtn":"Kendi güvenlik sorunuzu oluşturun","answer":"Cevap","phone_inst":"Şifrenizi kullanarak şifrenizi sıfırlamak veya hesabınızın kilidini açmak için bir telefon numarası ekleyin.","optional":"İsteğe bağlı","sms_inst":"Okta size kurtarma kodu içeren bir kısa mesaj gönderebilir. Bu özellik, e-postanıza erişiminiz olmadığında kullanışlıdır.","add_ph_no":"+ Telefon Numarası Ekleyin","create_acc":"Hesabımı Oluşturun","forgot_pwd_header":"Şifremi Unuttum Kısa Mesaj","enter_phone_no":"Kodları kısa mesajla almak için kullanacağınız telefon numarasını girin ve çalıştığını doğrulamak için Kod Gönder'i tıklayın.","country":"Ülke","country_inst":"Telefonunuzun kayıtlı olduğu ülkeyi seçin.","back":"Tekrar-Gönder","phone_number":"Telefon numarası","phone_number_inst":"Numaranızı arama yaparken yazdığınız gibi girin. Ülke kodu eklemeyin","code_prefix":"ülke kodu öneki.","send_code":"Kod Gönder","done":"Tamam","verify":"Doğrulayın","enter_code":"Kodu Girin","enter_code_rule":"Parola için telefonunuzu kontrol edin ve aşağıya girin. Mesajınız bir dakikadan daha kısa sürede ulaşmalıdır.","verify_success":"Telefon numarası başarıyla doğrulandı!","click":"Tıklayın","finish_setup":" kurulumu tamamlamak için.","error_review":"Aşağıdaki hataları düzeltmek için lütfen formu inceleyin:","phone_no_not_found":"Veritabanında hiçbir telefon numarası bulunamadığından kısa mesaj gönderilemiyor.","noLowerCase":"En az bir küçük harf içermelidir","noUpperCase":"En az bir büyük harf içermelidir","noNumber":"En az bir sayı içermelidir","noSpecialCharacter":"En az bir özel karakter içermelidir","notMinLength":"En az $ karakter içermelidir","noUsernameSubstring":"Kullanıcı adının bir kısmını içermemelidir","noFirstnameSubstring":"Adınızın bir kısmını içermemelidir","noLastnameSubstring":"Soyadınızın bir kısmını içermemelidir","tokenNotValid":"Etkinleştirme kodunuz artık geçerli değil","tokenInvalidInfo":"Hesabınızı oluşturduktan sonra etkinleştirme bağlantınızı tıkladıysanız, etkinleştirme bağlantınızın süresi dolduysa veya URL yanlışsa bu olabilir","reqNewToken":"Yeni bir kod isteyin","passcodeNotValid":"Parolanız kayıtlarımızla eşleşmiyor. Lütfen tekrar deneyin.","OTPEnableAfter30Sec":"Kısa süre önce bir SMS mesajı gönderildi. Lütfen tekrar denemeden önce 30 saniye bekleyin.","phoneNoAlreadySet":"Telefon numarası bu kullanıcı tarafından zaten doğrulandı.","emptypassword":"Şifre boş olamaz","passwordlength":"Şifre boş olamaz","passwordnotvalid":"Şifre geçerli değil","passwordnotmatching":"Parolalar eşleşmelidir","answerlength":"Cevap en az $ karakter uzunluğunda olmalı","phonenumbermissing":"Devam etmek için aldığınız şifreyi doğrulayın","customQuestionEmpty":"Özel soru boş bırakılamazy","customQAsame":"Özel soru ve cevap aynı olamaz","passwordSameasPrev":"Şifre mevcut şifreniz olamaz","answerWrong":"Kurtarma sorusunun yanıtı kayıtlarımızla eşleşmedi","phonealreadyactive":"Bu numara zaten doğrulandı, güncellemek istiyorsanız başka bir numara deneyin","first_name":"İsim","last_name":"Soyadı","enter_email":"E-posta kimliği","emailNotValid":"E-posta kimliği geçerli değil","registeredapps":"Kayıtlı Uygulamalar","waitingapps":"Onay bekleyen uygulamalar","requestaccess":"Erişim talebi","admin":"Yönetici","selectLang":"Dil Seçin","dashboardLabel":"Gösterge Paneli","resetpwd":"Şifreyi yenile","ansForgotten":"Şifremi unuttum sorusunu yanıtlayın","resetOktaPwd":"Şifrenizi sıfırlayın","newpwd":"Yeni Şifre","rptpwd":"Şifreyi tekrar girin","adminLabel":"Kullanıcı yönetimi","userAdministration":"Kullanıcı yönetimi","adduser":"Yeni Kullanıcı Ekle","function":"Fonksiyon","emailAddress":"E-posta adresi","filterApp":"Filtre Uygulaması","create":"Oluştur","logoutConfirm":"Çıkış yapmak istediğinizden emin misiniz?","no":"Hayır","yes":"Evet","logout":"Çıkış Yap","expireWarning":"Oturumunuzun süresi % dakika içinde dolacak, oturumunuzu açık tutmak için Tamam'a veya oturumu kapatmak için İptal'e basın. Bağlantınız kesilirse, değişiklikler kaybolacak","update":"Güncelleme","activateDeactivate":"Devreye al / Devreden çıkart","attention":"Dikkat","cancel":"İptal et","sessionTimedout":"Oturumunuz sona erdi. Lütfen tekrar giriş yapın","username":"Kullanıcı adı","primary_mail":"Öncelikli E-posta","secondary_mail":"İkincil e-posta (isteğe bağlı)","groups":"Gruplar","must_email":"Bir e-posta olmalı","ieNotSupported":"IE desteklenmiyor","tryChrome":"Internet Explorer desteklenmemektedir. Bu uygulama için Chrome kullanmanızı öneririz.","close":"Kapat","forgotSQA":"güvenlik cevabını mı unuttun?","resetSecQA":"Güvenlik Sorusunu ve Parolasını Sıfırla","retry":"Geri dön","nofactorpresent":"Cep telefonu ayarlanmadığı için bu seçenek kullanılamaz. Lütfen yöneticinize başvurun.","emptypasscode":"Kod boş olamaz","provisioned":"Bu kullanıcı henüz kayıtlı değil. Şifre yalnızca kullanıcı aktif olduktan sonra sıfırlanabilir","deprovisioned":"Bu kullanıcı devre dışı. Şifre yalnızca kullanıcı aktif olduktan sonra sıfırlanabilir","resetsuccesspopupmsg":"E-posta adresine şifre sıfırlama bağlantısı gönderildi. Lütfen X düğmesini kullanarak açılır pencereyi kapatın.","wanttoreset":"Parolayı sıfırlamak istiyor musunuz?","wanttoactivate":"Kullanıcıyı etkinleştirmek ister misiniz?","wanttodeactivate":"Kullanıcıyı devre dışı bırakmak istiyor musunuz?","wanttodelete":"Kullanıcıyı silmek istiyor musunuz?","updateprofile":"Profili Güncelle","updatesuccess":"Başarıyla güncellendi","usercreated":"* Kullanıcı Oluşturuldu","errorcreatinguser":"* Kullanıcı / e-posta oluşturma hatası zaten var","privacypolicy":"Gizlilik Politikası","termsandconditions":"Şartlar ve koşullar","uname-email":"Kullanıcı adı / E-posta","password_placeholder":"Parola","sign-in":"Oturum aç","resetmailsent":"Şifre sıfırlama bağlantısı ile %'e bir E-posta gönderildi.","smssent":"gönderildi","resendcode":"Kodu yeniden gönder","needhelp":"Oturum açmak için yardıma mı ihtiyacınız var?","forgotPassword":"Parolanızı mı unuttunuz?","helplink":"Yardım","smsusage":"SMS yalnızca bir cep telefonu numarası yapılandırıldıysa kullanılabilir.","backtosignin":"Oturum Açmaya Geri Dön","resetviasms":"SMS ile sıfırla","resetviaemail":"E-posta ile sıfırla","didntreceivecode":"Kod almadınız mı? E-posta ile sıfırla","emailsent":"E-posta gönderildi!","recoverycredentialsnotset":"Kullanıcı için kurtarma kimlik bilgileri ayarlanmadığından şifreyi unuttum kullanılamaz","usernotpresent":"Kullanıcı mevcut değil","mobilenumbernotset":"Cep telefonu numarası ayarlanmadı","invalidcreds":"Geçersiz kullanıcı adı veya şifre","emailreq":"E-posta gerekli","emailinvalid":"E-posta geçersiz","pwdreq":"Şifre gerekli","otplength":"OTP 6 karakter uzunluğunda olmalıdır","passcodeinvalid":"Geçersiz OTP","firstnamereq":"İsim gerekli","lastnamereq":"Soyadı gerekli","notallowedincurrentstate":"Geçerli kimlik doğrulama durumunda bu işleme izin verilmiyor","nopartsofusername":"Şifre, kullanıcı adınızın bir bölümünü içeremez, adınızı veya soyadınızı içeremez","passwordusedrecently":"Şifre çok yakın zamanda kullanıldı","passwordnotmetrequirements":"Parola, geçerli parola politikasının karmaşıklık gereksinimlerini karşılamıyor","antar":"Antarktika","aus":"Avustralya","can":"Kanada","falk":"Falkland Adaları (Malvinas)","kazak":"Kazakistan","mayotte":"Mayotte","morocco":"Fas","norway":"Norveç","pitcairn":"Pitcairn","filteruser":"Kullanıcıları Uygulamaya göre filtreleyin:","selectgroups":"Uygulama Seçin","status":"Durum","atleastonegroup":"Kullanıcıyı atamak için en az bir grup seçin","answerchallenge":"Şifremi unuttum sorusunu cevapla","entersmscode":"SMS ile gönderilen doğrulama kodunu girin","enterusercreds":"Kullanıcı Bilgilerini Girin","inviteuser":"Yeni Kullanıcı Davet Et","assignApplication":"Uygulamaya Ata","availablegroups":"Kullanılabilir Gruplar","selectedgroups":"Atanan Gruplar","emailsenttouser":"E-posta başarıyla gönderildi ","pendingactivation":"Hesap etkinleştirmesi bekleniyor","exit":"Çıkış","myprofile":"Profilim","activatesuccess":"Kullanıcı başarıyla etkinleştirildi ve adresine bir etkinleştirme postası gönderildi","deactivatesuccess":" başarıyla devre dışı bırakıldı","deletesuccess":" başarıyla silindi","edituser":"Kullanıcıyı Düzenle","getstarted":"Başla","congrats":"Tebrikler!","accountsetup":"Hesap kurulumunuzu başarıyla tamamladınız.","edit":"Düzenle","assignedapps":"Atanan Uygulamalar","assignedgroups":"Atanan Gruplar","oldpwd":"Eski şifreyi girin","changepwd":"Şifre değiştir","updatephone":"Telefonu güncelleyin","pwdupdated":"Şifre başarıyla güncellendi","QAupdated":"Güvenlik Sorusu Cevabı başarıyla güncellendi","phonenumberinvalid":"Telefon numarası geçersiz","phoneupdated":"Telefon numarası başarıyla güncellendi","showmore":"Daha fazla göster","verifypassword":"Parolayı Doğrula","filterusergrp":"Kullanıcıları gruba göre filtrele:","allactiveusers":"Tüm aktif kullanıcılar","viewuser":"Kullanıcıyı görüntüle","partofokta":"Bu kullanıcı Okta organizasyonunun bir parçası","userdeactive":"Kullanıcı devre dışı","showing":"Gösteriliyor","of":"of","answerpartofquestion":"Cevap sorunun bir parçası olmamalıdır","activationpending":"Faktörünüz etkinleştirilmeyi bekliyor, lütfen telefon numaranızı güncelleyin, aksi takdirde sıfırlama SMS'leri önceki etkin numaranıza gönderilir","change_forgot_pwd_qtn":"Güvenlik sorusunu değiştirin:","basicinfo":"Temel bilgiler","gotoapp":"Başvurunuza erişmek için lütfen aşağıya tıklayın.","passwordresetsuccess":"Parolanız başarıyla sıfırlandı","passwordreset":"Parola sıfırlama!","searchinfotext":"* Arama yalnızca uygulamada yapılır","tmlabel":"Yapılandırma","delete":"Sil","search":"Arama","nop":"Numara","nop_inst":"Lütfen ülke kodu eklemeyin ve kısa çizgi eklemeyin. Lütfen yalnızca cep telefonu numarasını girin","nopMobile":"Cep numarası","statusactive":"Aktif","statuspending":"Etkinleştirme bekleniyor","globalsearch":"Diğer kullanıcıları ara","permissiondenied":"Bu kullanıcıyı silemez / devre dışı bırakamazsınız. kullanıcı diğer gruplara atanmış durumda. Bunun yerine kullanıcının atamasını kaldırabilirsiniz","activestatus":"AKTİF","provisionedstatus":"KARŞILIK AYRILDI","deprovisionedstatus":"KARŞILIK AYRILMADI","save":"Kaydet","admingroup":"Yönetici grubu","application":"Uygulama","selectadmingroup":"Yönetici grubunu seçin","selectapp":"Uygulama seçin","adminConfigIncomplete":"Satır eksik. Lütfen satırı kaydetmek veya kaldırmak için bir yönetici grubu, marka ve yönetilen gruplar atayın","adminconfigdeletesuccess":"Başarıyla silindi","adminconfigupdatesuccess":"Yapılandırma başarıyla güncellendi","wanttodeleteadminconfig":"Bu yapılandırmayı silmek istiyor musunuz?","cannotdeleteconfig":"Bu yapılandırma silinemez","nonanoktauser":"Bu işlemin yapılmasına izin verilmiyor. Bu kullanıcının kimlik sağlayıcısı Okta değil.","reactivate":"Daveti Tekrar Gönder","wanttoreactivate":"Aktivasyon bağlantısını kullanıcıya tekrar göndermek istiyor musunuz?","iread1":"Cargill müşteri portallarının, bunların aracılığıyla sunulan uygulamaların ve hizmetlerin Cargill'in Müşteri Portalı'na tabi olduğunu kabul ediyorum","iread2":"Şartlar ve Koşullar","iread3":", geçerli her ticari hizmet için belirli şartlar ve koşullar ile desteklenebilir veya değiştirilebilir.","iagree1":"Cargill'in kişisel verileri Cargill müşteri portalları, uygulamaları ve hizmetleriyle bağlantılı olarak işlemesinin Cargill'e tabi olduğunu kabul ve beyan ederim. ","iagree2":"Çevrimiçi Gizlilik Politikası","iagree3":", geçerli her ticari hizmet için 'Gizlilik Bildirimleri' ile desteklenebilir veya değiştirilebilir.","privacypolicy_link":"https://www.cargill.com/page/privacy","termsandconditions_link":"https://www.cargill.com/portal-terms","resetreactivate":"Yeniden başlat / Yeniden etkinleştir","emailinvaliddomain":"Bu etki alanına sahip kullanıcı eklenemez","administeredgroups":"Yönetilen Gruplar","selectgroupslist":"Grupları Seçin","alreadyactive":"Aktif bir kullanıcısınız!","alreadyactivesetup":"Profiliniz kayıt gerektirmiyor. Uygulamalarınızda oturum açmak için Cargill çalışan giriş bilgilerini kullanın.","selectBrand":"Marka Seçin","permissiondeniedreset":"Bu kullanıcı için şifreyi sıfırlayamazsınız.","unlockaccount":"Hesabın Kilidini Aç","unlockaccountsuccess":"Hesabınızın kilidi başarıyla açıldı","accountunlocked":"Hesap Kilidi Açıldı!","copyrefid":"Lütfen referans kimliğini aldığınız e-postanın alt kısmından kopyalayın ve devam etmek için aşağıya yapıştırın.","securityquestionanswerweak":"Güvenlik sorusunun yanıtı çok zayıf, cevap sorunun bir parçası olmamalı","securityanswermatchesquestion":"Güvenlik yanıtı geçersiz: Yanıt, güvenlik sorusunun bir parçası olan $ değerini içermemelidir","copysecurityanswermatchesquestion":"Güvenlik yanıtı geçersiz: Yanıt, güvenlik sorusunun bir parçası olan $ değerini içermemelidir","tokenInvalidShortMessage":"Etkinleştirme bağlantınız artık geçerli değil.","enterActivationDetails":"Aşağıda istenen bilgiler için lütfen etkinleştirme e-postanıza bakın.","resendActivation":"Aktivasyon Postasını Tekrar Gönder","reinvite":"Daveti Tekrar Gönder","reinviteEmailMessage":"Verdiğiniz bilgiler doğruysa, yeni bir etkinleştirme e-postası alırsınız.","reinviteContactAdminMessage":"Yeni etkinleştirme e-postasını almazsanız, lütfen Cargill iş kontağınıza başvurun.","activationOk":"Ok","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","selfRegSubGrps":"Self registration additional group:","disableExistingUserOnboard":"Disable Existing User","selectReggroup":"Select Registration group","selfRegister":"Kaydol","selfRegFormTitle":"Kaydet","E0001":"Maalesef hesabınız ayarlanırken bir sorun oluştu. Hesabınızı ayarlamayla ilgili yardım için lütfen","E0001_1":" bize ulaşın","E0001_2":"","E0002":" for assistance with setting up your account.","E0003":"Hesabınız başarıyla kaydedildi. ","E0003_1":" adresine hesabınızı etkinleştirme talimatlarını içeren bir e-posta gönderildi.","E0004":"Hesabınız başarıyla kaydedildi. Artık mevcut parolanızı kullanarak uygulamada oturum açabilirsiniz. Parolanızı hatırlamıyorsanız lütfen parolanızı sıfırlamak için uygulamadaki “Parolamı Unuttum” seçeneğini kullanın.","E0005":"User already exists with status ","E0005_1":" Please contact ","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"Şifre gereksinimleri karşılanmadı. Şifre gereksinimleri: en az 8 karakter, bir küçük harf, bir büyük harf, bir sayı, kullanıcı adınızın hiçbir kısmı yok. Şifreniz, son 24 şifrenizden biri olamaz.","acceptTerms":"Devam etmek için lütfen Gizlilik Politikamızı ve Şartlar ve Koşullarımızı kabul edin.","phoneVerificationNotCompleted":"Devam etmek için lütfen telefon numaranızı doğrulayın / kaldırın.","verifyPhoneWarning":"Telefon numaranızı doğrulamak için lütfen 'Kodu Gönder'e tıklayın","viewMoreInfo":"Daha Fazla Bilgi Görüntüle","infoContent":"Kullanıcı hakkında daha fazla bilgi görüntüleyin","createdDate":"Oluşturulma Tarihi","activatedDate":"Aktivasyon Tarihi","lastLoginDate":"Son giriş tarihi","lastUpdatedDate":"Son Güncelleme Tarihi","passwordChangedDate":"Şifre Değiştirme Tarihi","statusChangedDate":"Durum Değiştirilme Tarihi","createdDateDescription":"Okta'da kullanıcı kaydının oluşturulduğu tarih ve saat.","activatedDateDescription":"Son kullanıcı aktivasyon e-postasının gönderildiği tarih ve saat.","statusChangedDateDescription":"Okta'da kullanıcı durumunun en son değiştirildiği tarih ve saat.","lastLoginDateDescription":"Kullanıcının Okta'da en son oturum açtığı tarih ve saat (uygulamaya özel değil).","lastUpdatedDateDescription":"Okta'da kullanıcı kaydının en son güncellendiği tarih ve saat.","passwordChangedDateDescription":"Kullanıcının parolasını en son değiştirdiği tarih ve saat.","resetMFATitle":"Çok Faktörlü Kimlik Doğrulamayı Sıfırla","noFactorExist":"Bu kullanıcı için hiçbir faktör yok.","mfaValidation":"Lütfen sıfırlanacak bir faktör seçin.","resetButton":"Sıfırla","mfaResetModalTitle":"MFA Sıfırlama","factorResetSuccess":"Faktör başarıyla sıfırlandı.","resetConfirmation":"Bu kullanıcı için MFA'yı Sıfırlamak istediğinizden emin misiniz?","copyrights":"Cargill, Anonim. Her hakkı saklıdır.","reportLabel":"Rapor","bulkUploadLabel":"Toplu Yükleme Kullanıcıları","availableIndependentGroups":"Mevcut bağımsız gruplar:","selectedBrand":"Seçilen Marka:","bulkUploadOptionsLabel":"Toplu Yükleme Seçenekleri","bulkCreateUsers":"Toplu Kullanıcı Oluşturma","bulkReinviteUsers":"Kullanıcıları Toplu Olarak Yeniden Davet Etme","confirm":"Onaylamak","downloadExcelTemplate":"Excel Şablonunu İndirin:","uploadInstruction":"Şablonu indirdikten sonra excel sayfasını doldurun ve aşağıdaki bölümü kullanarak yükleyin","uploadWarningOne":"Aynı anda en fazla 50 kullanıcıya izin verilir.","uploadWarningTwo":"E-posta alanının boş bırakılmadığından emin olun.","uploadWarningThree":"Sağlanan e-posta kimliklerinin sizin tarafınızdan yönetildiğinden emin olun.","uploadWarningFour":"Hiçbir alanın boş bırakılmadığından emin olun.","uploadWarningFive":"Tüm alan değerlerinin geçerli olduğundan emin olun.","uploadWarningSix":"Sağlanan grup kimliklerinin sizin tarafınızdan yönetildiğinden emin olun.","uploadNote":"Bu süreçte gönderilen davetler, standart Cargill hesabı davet e-postasını takip eder.","uploadLabel":"Yüklemek","action":"Hareketler","userword":"kullanıcılar","note":"Not:","authentication":"kimlik doğrulama","noTableData":"Tablo için veri yok.","readOnlyGroup":"Bu salt okunur bir gruptur. Bu grup için atama sadece access.cargill.com üzerinden yapılmalıdır.","adminPermissionDenied":"Kullanıcı Yöneticisi haklarınız, bu grup atamasını değiştirme iznine sahip değil.","msgForGenericErrorUA":"Şu anda isteğinizi işleme koyarken bir sorunla karşı karşıyayız. Lütfen daha sonra tekrar deneyiniz. Bu hatayı görmeye devam ederseniz daha fazla yardım için müşteri hizmetleri temsilcinizle iletişime geçin.","passcodeRateLimit":"İsteğiniz işlenemiyor, lütfen 5 dakika sonra tekrar deneyin.","passcodeNotEntered":"Doğrulamak için lütfen şifreyi girin.","msgForUnhandledResponse":"Talebiniz işlenemiyor, lütfen müşteri hizmetleri temsilcinizle iletişime geçin.","groupUnavailable":"Grup artık Okta'da mevcut değil. Grup silinmiş olabilir.","groupCannotBeAssigned":"$ grubu artık Okta'da mevcut değil ve bu nedenle kullanıcıya atanamıyor. Lütfen grubu kaldırın ve devam edin.","copyGroupCannotBeAssigned":"$ grubu artık Okta'da mevcut değil ve bu nedenle kullanıcıya atanamıyor. Lütfen grubu kaldırın ve devam edin."}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = {"1":"Сполучені Штати Америки","7":"Російська Федерація","20":"Єгипет","27":"Південна Африка","30":"Греція","31":"Нідерланди","32":"Бельгія","33":"Франція","34":"Іспанія","36":"Угорщина","39":"Італія","40":"Румунія","41":"Швейцарія","43":"Австрія","44":"Велика Британія та Північна Ірландія, Сполучене Королівство","45":"Данія","46":"Швеція","47":"Шпицберген та Ян Майен","48":"Польща","49":"Німеччина","51":"Перу","52":"Мексика","53":"Куба","54":"Аргентина","55":"Бразилія","56":"Чилі","57":"Колумбія","58":"Венесуела, Боліварська Республіка","60":"Малайзія","61":"Острів Різдва","62":"Індонезія","63":"Філіппіни","64":"Нова Зеландія","65":"Сінгапур","66":"Таїланд","81":"Японія","82":"Корея Південна, Республіка","84":"В'єтнам","86":"Китай","90":"Туреччина","91":"Індія","92":"Пакистан","93":"Афганістан","94":"Шрі Ланка","95":"М'янма","98":"Іран, Ісламська Республіка","211":"Південний Судан","212":"Західна Сахара","213":"Алжир","216":"Туніс","218":"Лівія","220":"Гамбія","221":"Сенегал","222":"Мавританія","223":"Малі","224":"Гвінея","225":"Берег Слонової Кістки","226":"Буркіна-Фасо","227":"Нігер","228":"Того","229":"Бенін","230":"Маврикій","231":"Ліберія","232":"Сьєрра-Леоне","233":"Гана","234":"Нігерія","235":"Чад","236":"Центральноафриканська республіка","237":"Камерун","238":"Кабо-Верде","239":"Сан-Томе і Принсіпі","240":"Екваторіальна Гвінея","241":"Габон","242":"Конго","243":"Конго, Демократична Республіка","244":"Ангола","245":"Гвінея Бісау","246":"Британська Територія Індійського Океану","248":"Сейшельські острови","249":"Судан","250":"Руанда","251":"Ефіопія","252":"Сомалі","253":"Джибуті","254":"Кенія","255":"Танзанія, Об'єднана Республіка","256":"Уганда","257":"Бурунді","258":"Мозамбік","260":"Замбія","261":"Мадагаскар","262":"Реюньйон","263":"Зімбабве","264":"Намібія","265":"Малаві","266":"Лесото","267":"Ботсвана","268":"Есватіні (Свазіленд)","269":"Коморські острови","290":"Острів Святої Єлени, Острів Вознесіння та Острови Тристан да Кунья","291":"Еритрея","297":"Аруба","298":"Фарерські острови","299":"Гренландія","350":"Гібралтар","351":"Португалія","352":"Люксембург","353":"Ірландія","354":"Ісландія","355":"Албанія","356":"Мальта","357":"Кіпр","358":"Фінляндія","359":"Болгарія","370":"Литва","371":"Латвія","372":"Естонія","373":"Молдова","374":"Вірменія","375":"Білорусь","376":"Андорра","377":"Монако","378":"Сан-Марино","379":"Святий Престол (місто Ватикан)","380":"Україна","381":"Сербія","382":"Чорногорія","383":"Косово, Республіка","385":"Хорватія","386":"Словенія","387":"Боснія і Герцеговина","389":"Північна Македонія","420":"Чеська Республіка","421":"Словаччина","423":"Ліхтенштейн","500":"Південна Джорджія та Південні Сандвічеві острови","501":"Беліз","502":"Гватемала","503":"Сальвадор","504":"Гондурас","505":"Нікарагуа","506":"Коста-Ріка","507":"Панама","508":"Сен-П'єр і Мікелон","509":"Гаїті","590":"Гваделупа","591":"Болівія","592":"Гайана","593":"Еквадор","595":"Парагвай","596":"Мартініка","597":"Сурінам","598":"Уругвай","599":"Нідерландські Антильські острови","670":"Тимор-Лешті","672":"Острів Норфолк","673":"Бруней Даруссалам","674":"Науру","675":"Папуа-Нова Гвінея","676":"Тонга","677":"Соломонові острови","678":"Вануату","679":"Фіджі","680":"Палау","681":"Уолліс і Футуна","682":"Острови Кука","683":"Ніуе","685":"Самоа","686":"Кірібаті","687":"Нова Каледонія","688":"Тувалу","689":"Французька Полінезія","690":"Токелау","691":"Мікронезія","692":"Маршаллові острови","850":"Корея Північна, Демократична Народна Республіка","852":"Гонконг","853":"Макао","855":"Камбоджа","856":"Лаос, Народна Демократична Республіка","880":"Бангладеш","886":"Тайвань","960":"Мальдіви","961":"Ліван","962":"Йорданія","963":"Сирійська Арабська Республіка","964":"Ірак","965":"Кувейт","966":"Саудівська Аравія","967":"Ємен","968":"Оман","970":"Палестина","971":"Об'єднані Арабські Емірати","972":"Ізраїль","973":"Бахрейн","974":"Катар","975":"Бутан","976":"Монголія","977":"Непал","992":"Таджикистан","993":"Туркменістан","994":"Азербайджан","995":"Грузія","996":"Киргизстан","998":"Узбекистан","1242":"Багамські Острови","1246":"Барбадос","1264":"Ангілья","1268":"Антигуа та Барбуда","1284":"Віргінські острови, Британські","1340":"Віргінські острови, Американські","1345":"Кайманові острови","1441":"Бермудські Острови","1473":"Гренада","1649":"Острови Теркс і Кайкос","1664":"Монтсеррат","1670":"Північні Маріанські острови","1671":"Гуам","1684":"Американське Самоа","1758":"Сент-Люсія","1767":"Домініка","1784":"Сент-Вінсент і Гренадини","1787":"Пуерто-Рико","1809":"Домініканська республіка","1868":"Тринідад і Тобаго","1869":"Сент-Кітс і Невіс","1876":"Ямайка","441481":"Гернсі","441534":"Джерсі","registration":"Реєстрація","hello":"Здравствуйте","welcome_cargill":"Вітаємо на","user_reg":"РеєстВведіть новий парольрація користувача","enter_new_pwd":"Введіть новий пароль","pwd_rule":"Ваш пароль повинен містити принаймні 8 символів, малу літеру, малі літери, цифру, а також частину вашого імені користувача.","repeat_pwd":"Введіть новий пароль повторно","choose_forgot_pwd_qtn":"Виберіть контрольне питання","stock_qtn":"Контрольне питання","disliked_food":"Яка їжа вам найбільше сподобалася в дитинстві?","name_of_first_plush_toy":"Як називається ваша перша опудала тварина?","first_award":"За що ти заробив свою першу медаль чи нагороду?","favorite_security_question":"Яке улюблене питання безпеки?","favorite_toy":"Яка іграшка / опудала тварина вам сподобалась у дитинстві найбільше?","first_computer_game":"У яку першу комп’ютерну гру ви грали?","favorite_movie_quote":"Яка твоя улюблена цитата у фільмі?","first_sports_team_mascot":"Яким був талісман першої спортивної команди, на якій ви грали?","first_music_purchase":"Який музичний альбом чи пісню ви вперше придбали?","favorite_art_piece":"Який ваш улюблений витвір мистецтва?","grandmother_favorite_desert":"Що було улюбленим десертом вашої бабусі?","first_thing_cooked":"Що було першим, що ти навчився готувати?","childhood_dream_job":"Якою була ваша мрія як дитина?","place_where_significant_other_was_met":"Де ти познайомився зі своїм чоловіком / значним іншим?","favorite_vacation_location":"Куди ви поїхали на улюблений відпочинок?","new_years_two_thousand":"Де ти був у новорічну ніч у 2000 році?","favorite_speaker_actor":"Хто ваш улюблений оратор / оратор?","favorite_book_movie_character":"Хто ваш улюблений персонаж книги / фільму?","favorite_sports_player":"Хто ваш улюблений спортивний гравець?","custom_qtn":"Створити власне контрольне питання","own_sec_qtn":"Створіть власне питання безпеки","answer":"Ваша відповідь на контрольне питання","phone_inst":"Опціонально. Введіть номер мобільного телефону для відновлення облікового запису. Цей номер буде використовуватися тільки для надсилання текстового повідомлення з кодом підтвердження.","optional":"(необов’язково)","sms_inst":"Okta може надіслати вам текстове повідомлення з кодом відновлення. Ця функція корисна, коли у вас немає доступу до електронної пошти.","add_ph_no":"Додати номер телефону","create_acc":"Створити обліковий запис","forgot_pwd_header":"Текстове повідомлення забутого пароля","enter_phone_no":"Введіть номер телефону, який ви будете використовувати для отримання кодів за допомогою текстового повідомлення, а потім натисніть Надіслати код, щоб переконатися, що він працює.","country":"Код країни","country_inst":"Виберіть країну, де зареєстрований ваш телефон.","back":"Надіслати код повторно","phone_number":"Номер телефону","phone_number_inst":"Введіть свій номер так, як ви його звичайно набираєте. Не додайте код своєї країни","code_prefix":"префікс коду країни.","send_code":"Надіслати код підтвердження","done":"Зроблено","verify":"Перевірити","enter_code":"Ввести код","enter_code_rule":"Повідомлення має прийти менш ніж за хвилину. Перевірте телефон і введіть отриманий код в поле нижче.","verify_success":"Номер телефону успішно підтверджено!","click":"Клацніть","finish_setup":"завершити налаштування.","error_review":"Перегляньте форму, щоб виправити наступні помилки","phone_no_not_found":"Текстове повідомлення неможливо надіслати, оскільки в базі даних не знайдено номер телефону.","noLowerCase":"Повинен містити принаймні одну малу літеру","noUpperCase":"Повинен містити принаймні одну велику літеру","noNumber":"Має містити принаймні одне число","noSpecialCharacter":"Повинен містити принаймні один спеціальний символ","notMinLength":"Повинен містити не менше $ символів","noUsernameSubstring":"Не повинна містити частину імені користувача","noFirstnameSubstring":"Не повинен містити частини вашого імені","noLastnameSubstring":"Не повинна містити частину вашого прізвища","tokenNotValid":"Ваш маркер активації більше не дійсний","tokenInvalidInfo":"Це може статися, якщо ви натиснули посилання на активацію після створення свого облікового запису, термін дії вашої активаційної посилання закінчився або URL-адреса неправильна","reqNewToken":"Попросити новий маркер","passcodeNotValid":"Ваш пароль не відповідає нашим записам. Будь ласка спробуйте ще раз.","OTPEnableAfter30Sec":"Нещодавно було надіслано SMS-повідомлення. Зачекайте 30 секунд, перш ніж повторити спробу.","phoneNoAlreadySet":"Номер телефону вже підтверджений цим користувачем.","emptypassword":"Пароль не може бути порожнім","passwordlength":"Пароль не може бути порожнім","passwordnotvalid":"Пароль недійсний","passwordnotmatching":"Паролі повинні збігатися","answerlength":"Відповідь має бути не менше $ символів","phonenumbermissing":"Щоб продовжити, підтвердьте отриманий пароль","customQuestionEmpty":"Спеціальне запитання не може бути порожнім","customQAsame":"Спеціальні запитання та відповіді не можуть бути однаковими","passwordSameasPrev":"Пароль не може бути вашим поточним паролем","answerWrong":"Відповідь на питання відновлення не відповідала нашим записам","phonealreadyactive":"Цей номер уже підтверджено, якщо ви хочете оновити, спробуйте інший номер","first_name":"Ім'я","last_name":"Прізвище","enter_email":"Ідентифікатор електронної пошти","emailNotValid":"Ідентифікатор електронної пошти недійсний","registeredapps":"Зареєстровані програми","waitingapps":"Додатки, які чекають затвердження","requestaccess":"Попросити доступ","admin":"Адміністратор","selectLang":"Оберіть мову","dashboardLabel":"Панель приладів","resetpwd":"Скинути пароль","ansForgotten":"Відповісти на секретне питання","resetOktaPwd":"Скиньте пароль","newpwd":"Новий пароль","rptpwd":"Введіть пароль повторно","adminLabel":"Управління користувачами","userAdministration":"Управління користувачами","adduser":"Додати нового користувача","function":"Функція","emailAddress":"Адреса електронної пошти","filterApp":"Застосування фільтру","create":"творити","logoutConfirm":"Ви впевнені, що хочете вийти?","no":"Немає","yes":"Так","logout":"Вийти","expireWarning":"Ваш сеанс закінчується через% хвилин, натисніть кнопку OK, щоб залишитись увійти в систему, або натисніть Скасувати, щоб вийти. Якщо ви відключились, будь-які зміни будуть втрачені","update":"Оновлення","activateDeactivate":"Активувати / деактивувати","attention":"Увага","cancel":"Скасувати","sessionTimedout":"Ваш сеанс закінчився Будь ласка, увійдіть ще раз","username":"Ім'я користувача","primary_mail":"Основна електронна пошта","secondary_mail":"Вторинна електронна адреса (необов’язково)","groups":"Групи","must_email":"Повинен бути електронний лист","ieNotSupported":"IE не підтримується","tryChrome":"Internet Explorer не підтримується. Ми рекомендуємо використовувати Chrome для цього додатка.","close":"Закрити","forgotSQA":"забули відповідь на секретне питання?","resetSecQA":"Скиньте питання безпеки та пароль","retry":"Повернутися","nofactorpresent":"Цю опцію не можна використовувати, оскільки номер мобільного телефону не задано. Зверніться до Вашого адміністратора.","emptypasscode":"Код не може бути порожнім","provisioned":"Цей користувач ще не зареєстрований. Скинути пароль можна лише після активного користування","deprovisioned":"Цей користувач вимкнено. Скинути пароль можна лише після активного користування","resetsuccesspopupmsg":"Посилання для скидання пароля надіслано на електронну адресу. Закрийте спливаюче вікно за допомогою кнопки X.","wanttoreset":"Ви хочете скинути пароль?","wanttoactivate":"Ви хочете активувати користувача?","wanttodeactivate":"Ви хочете відключити користувача? ","wanttodelete":"Ви хочете видалити користувача?","updateprofile":"Оновити профіль","updatesuccess":"Користувача оновлено успішно","usercreated":"* Створено користувачем","errorcreatinguser":"* Помилка створення користувача / електронної пошти вже існує","privacypolicy":"Політика конфіденційності","termsandconditions":"Правила та умови","uname-email":"Ім'я користувача / електронна пошта","password_placeholder":"Пароль","sign-in":"Увійти","resetmailsent":"Електронний лист надіслано на% із посиланням для скидання пароля.","smssent":"надісланий","resendcode":"Надіслати код повторно","needhelp":"Потрібна допомога входу?","forgotPassword":"Забули пароль?","helplink":"Довідка","smsusage":"SMS можна використовувати лише в тому випадку, якщо було налаштовано номер мобільного телефону.","backtosignin":"Назад до входу","resetviasms":"Скидання через SMS","resetviaemail":"Скидання електронною поштою","didntreceivecode":"Не отримали код? скидання через електронну пошту","emailsent":"Листа відправлено!","recoverycredentialsnotset":"Забутий пароль не дозволений, оскільки облікові дані відновлення не встановлені для користувача","usernotpresent":"Користувача немає","mobilenumbernotset":"Номер мобільного телефону не встановлений","invalidcreds":"Неправильне ім'я користувача або пароль","emailreq":"Потрібна електронна адреса","emailinvalid":"Недійсний електронний лист","pwdreq":"Потрібен пароль","otplength":"OTP має бути 6 символів","passcodeinvalid":"Недійсний OTP","firstnamereq":"Ім'я обов'язково","lastnamereq":"Потрібно прізвище","notallowedincurrentstate":"Ця операція заборонена в поточному стані аутентифікації","nopartsofusername":"Пароль не може містити частин вашого імені користувача, включати ваше ім’я або прізвище","passwordusedrecently":"Пароль недавно використовували","passwordnotmetrequirements":"Пароль не відповідає вимогам складності поточної політики паролів","aus":"Австралія","antar":"Антарктида","kazak":"Казахстан","can":"Канада","mayotte":"Майотта","morocco":"Марокко","norway":"Норвегія","pitcairn":"Піткерн","falk":"Фолклендські острови (Мальвіни)","filteruser":"Фільтруйте користувачів за допомогою програми","selectgroups":"Виберіть програму","status":"Статус","atleastonegroup":"Виберіть принаймні одну групу, якій потрібно призначити користувача","answerchallenge":"Відповідь на виклик пароля забутий","entersmscode":"Введіть код підтвердження, надісланий через SMS","enterusercreds":"Введіть реквізити користувача","inviteuser":"Запросити нового користувача","assignApplication":"Призначити до програми","availablegroups":"Доступні групи","selectedgroups":"Призначені групи","emailsenttouser":"Електронний лист успішно надіслано","pendingactivation":"Очікує активація облікового запису","exit":"Вхід","myprofile":"Мій профіль","activatesuccess":"Користувача успішно активовано і надіслано повідомлення про активацію","deactivatesuccess":"успішно деактивовано","deletesuccess":"було успішно видалено","edituser":"Редагувати користувача","getstarted":"Почати","congrats":"Вітаємо!","accountsetup":"Ви успішно закінчили налаштування Вашого облікового запису.","edit":"Редагувати","assignedapps":"Призначені програми","assignedgroups":"Призначені групи","oldpwd":"Введіть старий пароль","changepwd":"Змінити пароль","updatephone":"Оновіть телефон","pwdupdated":"Пароль успішно оновлений","QAupdated":"Відповідь на питання щодо безпеки успішно оновлено","phonenumberinvalid":"Номер телефону недійсний","phoneupdated":"Номер телефону успішно оновлений","showmore":"Показати більше","verifypassword":"Підтвердіть пароль","filterusergrp":"Фільтруйте користувачів за групами","allactiveusers":"Усі активні користувачі","viewuser":"Переглянути користувача","partofokta":"Цей користувач входить до організації Okta","userdeactive":"Користувач діє","showing":"Показ","of":"з","answerpartofquestion":"Відповідь не повинна бути частиною запитання","activationpending":"Ваш фактор очікує активації. Будь ласка, оновіть свій номер телефону, інакше SMS-повідомлення, що скидаються, будуть відправлені на ваш попередній активний номер","change_forgot_pwd_qtn":"Зміна питання безпеки","basicinfo":"Основна інформація","gotoapp":"Скористуйтеся посиланням нижче, щоб перейти на Портал.","passwordresetsuccess":"Ваш пароль успішно перевстановлено","passwordreset":"Скинути пароль!","searchinfotext":"* Пошук здійснюється тільки в додатку","tmlabel":"Конфігурація","delete":"Видалити","search":"Пошук","nop":"Номер моб.телефону для отримання коду підтвердження","nop_inst":"Введіть свій номер так, як ви його звичайно набираєте. Не додайте код своєї країни","nopMobile":"Номер моб.телефону","statusactive":"Активний","statuspending":"До активації","globalsearch":"Шукайте інших користувачів","permissiondenied":"Ви не можете видалити / відключити цього користувача. користувача, призначеного для інших груп. Ви можете скасувати призначення цього користувача","activestatus":"АКТИВНІ","provisionedstatus":"ЗАБЕЗПЕЧЕНО","deprovisionedstatus":"ВИЗНАЧЕНО","save":"Зберегти","admingroup":"Група адміністраторів","application":"Застосування","selectadmingroup":"Виберіть групу адміністратора","selectapp":"Виберіть програму","adminConfigIncomplete":"Рядок неповний. Будь ласка, призначте групу адміністратора, щоб зберегти або видалити рядок","adminconfigdeletesuccess":"Видалено успішно","adminconfigupdatesuccess":"Налаштування успішно оновлено","wanttodeleteadminconfig":"Ви хочете видалити цю конфігурацію?","cannotdeleteconfig":"Цю конфігурацію неможливо видалити","nonanoktauser":"Не дозволяється робити цю дію. Постачальником посвідчення цього користувача не є Okta.","reactivate":"Повторне запрошення","wanttoreactivate":"Ви хочете надіслати користувачу посилання для активації?","iread1":"Я погоджуюся, що портали клієнтів Cargill, додатки та послуги, доступні через них, підпорядковуються","iread2":"Положенням та Умовам Клієнтського Порталу компанії Cargill","iread3":", які можуть бути доповнені або доповнені конкретними умовами для кожної ділової послуги.","iagree1":"Я усвідомлюю і приймаю той факт, що обробка персональних даних, яка пов'язана з клієнтськими порталами, додатками і послугами компанії Cargill, регулюється Політикою ","iagree2":"Конфіденційності Cargill в Інтернеті","iagree3":", яка, в свою чергу, може бути доповнена або змінена через \"Повідомлення про Конфіденційність\" для кожної наданої бізнес-послуги.","privacypolicy_link":"https://www.cargill.com/page/privacy","termsandconditions_link":"https://www.cargill.com/portal-terms","resetreactivate":"Скидання / повторна активація","emailinvaliddomain":"Користувача з цим доменом не можна додати","administeredgroups":"Групи адміністраторів","selectgroupslist":"Виберіть Групи","alreadyactive":"Ви активний користувач!","alreadyactivesetup":"Ваш профіль не потребує реєстрації. Використовуйте вхід для співробітників Cargill для входу у свої програми.","selectBrand":"Виберіть бренд","permissiondeniedreset":"Ви не можете скинути пароль для цього користувача. ","unlockaccount":"Розблокувати обліковий запис","unlockaccountsuccess":"Ваш обліковий запис успішно розблоковано!","accountunlocked":"Обліковий запис розблоковано!","copyrefid":"Скопіюйте ідентифікатор посилання знизу отриманого електронного листа та вставте його нижче, щоб продовжити.","securityquestionanswerweak":"Відповідь на питання безпеки є занадто слабкою, відповідь не повинна бути частиною запитання","securityanswermatchesquestion":"Недійсна відповідь безпеки: відповідь не повинна містити $, що є частиною таємного запитання","copysecurityanswermatchesquestion":"Недійсна відповідь безпеки: відповідь не повинна містити $, що є частиною таємного запитання","tokenInvalidShortMessage":"Ваше посилання для активації більше не доступне.","browserspecificmsg":"Будь ласка, розгляньте можливість використання браузера Google Chrome.","enterActivationDetails":"Для отримання запитаної нижче інформації див. електронний лист із даними для активації.","resendActivation":"Надіслати повторно електронний лист із даними для активації","reinvite":"Надіслати запрошення повторно","reinviteEmailMessage":"Якщо інформація, яку ви надали, правильна, ви отримаєте новий електронний лист із даними для активації.","reinviteContactAdminMessage":"Зверніться до контактної особи компанії Каргілл для отримання нового електронного листа з даними для активації.","activationOk":"Ok","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","disableExistingUserOnboard":"Disable Existing User","selfRegSubGrps":"Self registration additional group:","selectReggroup":"Select Registration group","selfRegister":"Реєстрація","selfRegFormTitle":"Зареєструватися","E0001":"На жаль, виникла проблема з налаштуванням вашого облікового запису.","E0001_1":" Зверніться до нас, ","E0001_2":"і ми допоможемо налаштувати ваш обліковий запис.","E0002":" for assistance with setting up your account.","E0003":"Ваш обліковий запис зареєстровано. На адресу електронної пошти ","E0003_1":" надіслано листа з інструкціями щодо активації вашого облікового запису.","E0004":"Ваш обліковий запис зареєстровано. Тепер ви можете ввійти в додаток, використовуючи наявний пароль. Якщо ви забули свій пароль, скористайтеся в додатку варіантом «Не пам’ятаю пароль», щоб скинути його.","E0005":"User already exists with status ","E0005_1":" Please contact ","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"Вимоги до пароля не виконано. Вимоги до пароля: щонайменше 8 символів, мала літера, велика літера, цифра, без частин вашого імені користувача. Ваш пароль не може бути жодним із ваших останніх 24 паролів.","acceptTerms":"Щоб продовжити, прийміть нашу Політику конфіденційності та Умови використання.","phoneVerificationNotCompleted":"Підтвердьте/видаліть свій номер телефону, щоб продовжити.","verifyPhoneWarning":"Натисніть «Надіслати код», щоб підтвердити свій номер телефону","viewMoreInfo":"Переглянути більше інформації","infoContent":"Переглянути більше інформації про Користувача","createdDate":"Дата створення","activatedDate":"Дата активації","lastLoginDate":"Дата останнього входу","lastUpdatedDate":"Дата останнього оновлення","passwordChangedDate":"Дата зміни пароля","statusChangedDate":"Дата зміни статусу","createdDateDescription":"Дата та час створення запису користувача в Okta.","activatedDateDescription":"Дата та час, коли було надіслано останнє повідомлення електронної пошти про активацію користувача.","statusChangedDateDescription":"Дата та час останньої зміни статусу користувача в Okta.","lastLoginDateDescription":"Дата та час останнього входу користувача в Okta (не залежить від програми).","lastUpdatedDateDescription":"Дата та час останнього оновлення запису користувача в Okta.","passwordChangedDateDescription":"Дата та час, коли користувач востаннє змінив свій пароль.","resetMFATitle":"Скинути багатофакторну аутентифікацію","noFactorExist":"Для цього користувача не існує жодного фактора.","mfaValidation":"Виберіть фактор для скидання.","resetButton":"Скинути","mfaResetModalTitle":"Скидання MFA","factorResetSuccess":"Фактор успішно скинуто.","resetConfirmation":"Ви впевнені, що хочете скинути MFA для цього користувача?","copyrights":"Cargill, зареєстрована. Всі права захищені.","reportLabel":"звіт","bulkUploadLabel":"Масове завантаження користувачів","availableIndependentGroups":"Доступні незалежні групи:","selectedBrand":"Вибраний бренд:","bulkUploadOptionsLabel":"Параметри масового завантаження","bulkCreateUsers":"Масове створення користувачів","bulkReinviteUsers":"Масове повторне запрошення користувачів","confirm":"Підтвердити","downloadExcelTemplate":"Завантажити шаблон Excel:","uploadInstruction":"Після завантаження шаблону заповніть таблицю Excel і завантажте її, використовуючи розділ нижче0","uploadWarningOne":"Одночасно дозволено не більше 50 користувачів.","uploadWarningTwo":"Переконайтеся, що поле електронної пошти не залишилося порожнім.","uploadWarningThree":"Переконайтеся, що надані ідентифікатори електронної пошти адмініструються вами.","uploadWarningFour":"Переконайтеся, що поля не заповнені.","uploadWarningFive":"Переконайтеся, що всі значення полів дійсні.","uploadWarningSix":"Переконайтеся, що ви керуєте наданими ідентифікаторами груп.","uploadNote":"Запрошення, надіслані за допомогою цього процесу, відповідають стандартній електронній пошті запрошення до облікового запису Cargill.","uploadLabel":"Завантажити","action":"Дії","userword":"користувачів","note":"Примітка:","authentication":"Аутентифікація","noTableData":"Немає даних для таблиці.","readOnlyGroup":"Це група лише для читання. Призначення для цієї групи має здійснюватися лише через access.cargill.com","adminPermissionDenied":"Ваші права адміністратора користувача не мають дозволу змінювати це призначення групи.","msgForGenericErrorUA":"Зараз у нас виникла проблема з обробкою вашого запиту. Будь-ласка спробуйте пізніше. Якщо ви продовжуєте бачити цю помилку, зверніться до представника служби підтримки клієнтів, щоб отримати подальшу допомогу.","passcodeRateLimit":"Неможливо обробити ваш запит, повторіть спробу через 5 хвилин.","passcodeNotEntered":"Будь ласка, введіть пароль для підтвердження.","msgForUnhandledResponse":"Неможливо обробити запит, зверніться до представника служби підтримки клієнтів.","groupUnavailable":"Група більше не доступна в Okta. Можливо, групу було видалено.","groupCannotBeAssigned":"Група $ більше недоступна в Okta, тому її не можна призначити користувачеві. Будь ласка, видаліть групу та продовжуйте.","copyGroupCannotBeAssigned":"Група $ більше недоступна в Okta, тому її не можна призначити користувачеві. Будь ласка, видаліть групу та продовжуйте."}

/***/ }),
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAUCAIAAAA7jDsBAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjczOTQ2QzM3NjI3MDExRTdBM0FGQzMwNUI3NzFBMUY2IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjczOTQ2QzM4NjI3MDExRTdBM0FGQzMwNUI3NzFBMUY2Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzM5NDZDMzU2MjcwMTFFN0EzQUZDMzA1Qjc3MUExRjYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzM5NDZDMzY2MjcwMTFFN0EzQUZDMzA1Qjc3MUExRjYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5ikueWAAAAQ0lEQVR42rTRyw0AMAgCUPGz/4iOYrtA4WDK9SUSFd1t7+TMEHajSQCM3dmAjAjGVcX4ZsGie8dib3G1FYuPfeUjwAAQOQZBt0dezwAAAABJRU5ErkJggg=="

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/weathericons-regular-webfont.e7ef2b4.eot";

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Bold.e31fcf1.ttf";

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Bold.dc81817.woff";

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Bold.39b2c30.woff2";

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Light.46e48ce.ttf";

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Light.3b813c2.woff";

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Light.69f8a06.woff2";

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Medium.894a2ed.ttf";

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Medium.fc78759.woff";

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Medium.574fd0b.woff2";

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Regular.df7b648.ttf";

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Regular.ba3dcd8.woff";

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Regular.2751ee4.woff2";

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Thin.9499847.ttf";

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Thin.7500519.woff";

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Thin.954bbde.woff2";

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(733)

var Component = __webpack_require__(7)(
  /* script */
  null,
  /* template */
  __webpack_require__(708),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/components/widgets/TncTopNavFooter.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TncTopNavFooter.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3000ba72", Component.options)
  } else {
    hotAPI.reload("data-v-3000ba72", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 326 */,
/* 327 */,
/* 328 */
/***/ (function(module, exports) {

module.exports = {"1":"Hoa Kỳ","7":"Liên bang Nga","20":"Ai Cập","27":"Nam Phi","30":"Hy Lạp","31":"Hà Lan","32":"Belgium","33":"France","34":"Spain","36":"Hungary","39":"Italy","40":"Romania","41":"Thụy Sĩ","43":"Áo","44":"Vương quốc Anh","45":"Đan Mạch","46":"Thụy Điển","47":"Svalbard và Jan Mayen","48":"Ba Lan","49":"Đức","51":"Peru","52":"Mexico","53":"Cuba","54":"Argentina","55":"Brazil","56":"Chile","57":"Colombia","58":"Venezuela, Cộng hòa Bolivia","60":"Malaysia","61":"Đảo Christmas","62":"Indonesia","63":"Philippines","64":"New Zealand","65":"Singapore","66":"Thái Lan","81":"Nhật Bản","82":"Hàn Quốc","84":"Việt Nam","86":"Trung Quốc","90":"Thổ","91":"Ấn Độ","92":"Hoa Kỳ","93":"Afghanistan","94":"Sri Lanka","95":"Myanmar","98":"Iran, Cộng hòa Hồi giáo","211":"South Sudan","212":"Tây Sahara","213":"Algeria","216":"Tunisia","218":"Libya","220":"Gambia","221":"Senegal","222":"Mauritania","223":"Mali","224":"Guinea","225":"Ivory Coast","226":"Burkina Faso","227":"Niger","228":"Togo","229":"Benin","230":"Mauritius","231":"Liberia","232":"Sierra Leone","233":"Ghana","234":"Nigeria","235":"Chad","236":"Cộng hòa Trung Phi","237":"Cameroon","238":"Cape Verde","239":"Sao Tome và Principe","240":"Guinea Xích đạo","241":"Gabon","242":"Congo","243":"Cộng hòa Dân chủ Congo","244":"Angola","245":"Guinea-Bissau","246":"Lãnh thổ Ấn Độ Dương của Anh","248":"Seychelles","249":"Sudan","250":"Rwanda","251":"Ethiopia","252":"Somalia","253":"Djibouti","254":"Kenya","255":"Tanzania, Cộng hòa Liên bang","256":"Uganda","257":"Burundi","258":"Nam Phi","260":"Zambia","261":"Madagascar","262":"Reunion","263":"Zimbabwe","264":"Namibia","265":"Nước Malawi","266":"Lesotho","267":"Botswana","268":"Swaziland","269":"Comoros","290":"Saint Helena, Lên trên và Tristan da Cunha","291":"Eritrea","297":"Aruba","298":"Quần đảo Faroe","299":"Greenland","350":"Gibraltar","351":"Bồ Đào Nha","352":"Luxembourg","353":"Ireland","354":"Iceland","355":"Albani","356":"Malta","357":"Cyprus","358":"Nước Phần Lan","359":"Bulgaria","370":"Lithuania","371":"Latvia","372":"Estonia","373":"Moldavia","374":"Armenia","375":"Belarus","376":"Andorra","377":"Monaco","378":"San Marino","379":"Tòa thánh (Nhà nước Vatican City)","380":"Ukraina","381":"Serbia","382":"Montenegro","385":"Croatia","386":"Slovenia","387":"Bosnia và Herzegovina","389":"Macedonia","420":"Cộng hòa Séc","421":"Slovakia","423":"Liechtenstein","500":"Nam Georgia và quần đảo Nam Sandwich","501":"Belize","502":"Guatemala","503":"El Salvador","504":"Honduras","505":"Nicaragua","506":"Costa Rica","507":"Panama","508":"Saint Pierre và Miquelon","509":"Haiti","590":"Guadeloupe","591":"Bolivia","592":"Guyana","593":"Ecuador","595":"Paraguay","596":"Martinique","597":"Suriname","598":"Uruguay","599":"Antille thuộc Hà Lan","670":"Timor-Leste","672":"Đảo Norfolk","673":"Brunei Darussalam","674":"Nauru","675":"Papua New Guinea","676":"Tonga","677":"Quần đảo Solomon","678":"Vanuatu","679":"Fiji","680":"Palau","681":"Wallis và Futuna","682":"Quần đảo Cook","683":"Niue","685":"Samoa","686":"Kiribati","687":"New Caledonia","688":"Tuvalu","689":"Polynesia thuộc Pháp","690":"Tokelau","691":"Micronesia","692":"Quần đảo Marshall","850":"Hàn Quốc, Cộng hòa Dân chủ Nhân dân","852":"Hồng Kông","853":"Ma Cao","855":"Campuchia","856":"Cộng hoà Dân chủ Nhân dân Lào","880":"Bangladesh","886":"Đài Loan","960":"Maldives","961":"Lebanon","962":"Jordan","963":"Cộng hòa Ả Rập Syria","964":"Iraq","965":"Kuwait","966":"Saudi Arabia","967":"Yemen","968":"Oman","970":"Palestine","971":"United Arab Emirates","972":"Israel","973":"Bahrain","974":"Qatar","975":"Bhutan","976":"Mông Cổ","977":"Nepal","992":"Tajikistan","993":"Turkmenistan","994":"Azerbaijan","995":"Georgia","996":"Kyrgyzstan","998":"Uzbekistan","1242":"Bahamas","1246":"Barbados","1264":"Anguilla","1268":"Antigua và Barbuda","1284":"Quần đảo Virgin, Anh","1340":"Quần đảo Virgin, Hoa Kỳ","1345":"Quần đảo Cayman","1441":"Bermuda","1473":"Grenada","1649":"Quần đảo Turks và Caicos","1664":"Montserrat","1670":"Quần đảo Bắc Mariana","1671":"Đảo Guam","1684":"Samoa thuộc Mỹ","1758":"Saint Lucia","1767":"Dominica","1784":"Saint Vincent và Grenadines","1787":"Puerto Rico","1809":"Cộng hòa Dominican","1868":"Trinidad và Tobago","1869":"Saint Kitts và Nevis","1876":"Jamaica","441481":"Guernsey","441534":"Jersey","registration":"Đăng ký","hello":"xin chào","welcome_cargill":"Chào mừng bạn đến với ","user_reg":"Đăng ký người dùng","enter_new_pwd":"Nhập mật khẩu mới","pwd_rule":"Mật khẩu của bạn phải có ít nhất 8 ký tự, chữ thường, một chữ cái viết hoa, một số, không có phần nào của tên người dùng của bạn.","repeat_pwd":"Lặp lại mật khẩu mới","choose_forgot_pwd_qtn":"Chọn một câu hỏi quên mật khẩu","stock_qtn":"Câu hỏi về cổ phiếu","disliked_food":"Thức ăn mà bạn ít khi thích khi còn nhỏ?","name_of_first_plush_toy":"Tên của con vật đầu tiên của bạn là gì?","first_award":"Bạn đã kiếm được huy chương đầu tiên hay giải thưởng nào?","favorite_security_question":"Câu hỏi bảo mật yêu thích của bạn là gì?","favorite_toy":"Đồ chơi / thú nhồi bông là gì bạn thích nhất khi còn bé?","first_computer_game":"Trò chơi máy tính đầu tiên bạn chơi là gì?","favorite_movie_quote":"Đoạn phim yêu thích của bạn là gì?","first_sports_team_mascot":"Linh vật của đội thể thao đầu tiên bạn chơi trên sân là gì?","first_music_purchase":"Bạn đã mua album nhạc hoặc bài hát nào?","favorite_art_piece":"Nghệ thuật yêu thích của bạn là gì?","grandmother_favorite_desert":"Món tráng miệng yêu thích của bà bà của bạn là gì?","first_thing_cooked":"Điều đầu tiên bạn học nấu ăn là gì?","childhood_dream_job":"Công việc mơ ước lúc nhỏ của bạn là gì?","place_where_significant_other_was_met":"Bạn đã gặp vợ / chồng / bạn đời của bạn ở đâu?","favorite_vacation_location":"Bạn đã đi nghỉ ở đâu?","new_years_two_thousand":"Bạn đã ở đâu vào đêm giao thừa năm 2000?","favorite_speaker_actor":"Người nói / diễn giả yêu thích của bạn là ai?","favorite_book_movie_character":"Sách / nhân vật trong phim yêu thích của bạn là ai?","favorite_sports_player":"Người chơi thể thao yêu thích của bạn là ai?","custom_qtn":"Câu hỏi tùy chỉnh","own_sec_qtn":"Tạo câu hỏi bảo mật của riêng bạn","answer":"Câu trả lời","phone_inst":"Thêm số điện thoại để đặt lại mật khẩu hoặc mở khóa tài khoản của bạn bằng SMS.","optional":"(Không bắt buộc)","sms_inst":"Okta có thể gửi cho bạn tin nhắn văn bản với mã khôi phục. Tính năng này rất hữu ích khi bạn không có quyền truy cập vào email của mình.","add_ph_no":"+ Thêm số điện thoại,","create_acc":"Tạo tài khoản của tôi","forgot_pwd_header":"Quên mật khẩu Text Message","enter_phone_no":"Nhập số điện thoại bạn sẽ sử dụng để nhận mã thông qua tin nhắn văn bản, sau đó nhấp vào Gửi Mã để xác minh nó hoạt động.","country":"Quốc gia","country_inst":"Chọn quốc gia nơi điện thoại của bạn đã được đăng ký.","back":"Gửi lại","phone_number":"Số điện thoại","phone_number_inst":"Nhập số của bạn theo cách bạn thường quay số. Không thêm mã quốc gia của bạn","code_prefix":"tiền tố mã quốc gia.","send_code":"Gửi mã","done":"Làm xong","verify":"Kiểm chứng","enter_code":"Nhập mã","enter_code_rule":"Kiểm tra điện thoại của bạn để có mật mã và nhập nó vào dưới đây. Thông điệp của bạn sẽ đến ít hơn một phút.","verify_success":"Đã xác minh thành công số điện thoại!","click":"Nhấp chuột","finish_setup":"để hoàn thành thiết lập.","error_review":"Vui lòng xem lại biểu mẫu để sửa các lỗi sau:","phone_no_not_found":"Không thể gửi tin nhắn văn bản vì không tìm thấy số điện thoại trong cơ sở dữ liệu.","noLowerCase":"Nên có ít nhất một chữ thường","noUpperCase":"Nên có ít nhất một bức thư in hoa","noNumber":"Nên có ít nhất một số","noSpecialCharacter":"Nên có ít nhất một nhân vật đặc biệt","notMinLength":"Nên có ít nhất $ nhân vật","noUsernameSubstring":"Không nên chứa một phần tên người dùng","noFirstnameSubstring":"Không nên chứa một phần của tên của bạn","noLastnameSubstring":"Không nên chứa một phần của họ của bạn","tokenNotValid":"Mã kích hoạt của bạn không còn hợp lệ","tokenInvalidInfo":"Điều này có thể xảy ra nếu bạn nhấp vào liên kết kích hoạt sau khi tạo tài khoản, liên kết kích hoạt của bạn đã hết hạn hoặc URL không chính xác","reqNewToken":"Yêu cầu một mã thông báo mới","passcodeNotValid":"Mã mật mã của bạn không khớp với hồ sơ của chúng tôi. Vui lòng thử lại.","OTPEnableAfter30Sec":"Gần đây, một tin nhắn SMS đã được gửi. Vui lòng đợi 30 giây trước khi thử lại.","phoneNoAlreadySet":"Số điện thoại đã được xác minh bởi người dùng này.","emptypassword":"Mật khẩu không được để trống","passwordlength":"Mật khẩu không được để trống","passwordnotvalid":"Mật khẩu không hợp lệ","passwordnotmatching":"Mật khẩu phải khớp","answerlength":"Trả lời phải dài ít nhất $ ký tự","phonenumbermissing":"Xác minh mật mã bạn nhận được để tiếp tục","customQuestionEmpty":"Câu hỏi tùy chỉnh không được để trống","customQAsame":"Tuỳ chỉnh câu hỏi và câu trả lời có thể không giống nhau","passwordSameasPrev":"Mật khẩu không thể là mật khẩu hiện tại của bạn","answerWrong":"Câu trả lời câu hỏi khôi phục không khớp với hồ sơ của chúng tôi","phonealreadyactive":"Số này đã được xác minh, nếu bạn muốn cập nhật thử một số khác","first_name":"Tên đầu tiên","last_name":"tên họ","enter_email":"Id email","emailNotValid":"Email ID không hợp lệ","registeredapps":"Ứng dụng đăng ký","waitingapps":"Ứng dụng đang chờ phê duyệt","requestaccess":"Yêu cầu truy cập","admin":"quản trị viên","selectLang":"Chọn ngôn ngữ","dashboardLabel":"bảng điều khiển","resetpwd":"Đặt lại mật khẩu","ansForgotten":"Trả lời thách thức mật khẩu bị quên","resetOktaPwd":"Đặt lại mật khẩu của bạn","newpwd":"mật khẩu mới","rptpwd":"Lặp lại mật khẩu","adminLabel":"quản trị viên","userAdministration":"Quản lý người dùng","adduser":"Thêm người dùng","function":"Chức năng","emailAddress":"Địa chỉ email","filterApp":"Lọc ứng dụng","create":"tạo nên","logoutConfirm":"Bạn có chắc chắn bạn muốn thoát?","no":"Không","yes":"Vâng","logout":"Đăng xuất","expireWarning":"Phiên của bạn sẽ hết hạn trong% phút, nhấn OK để vẫn đăng nhập hoặc nhấn Cancel để đăng xuất. Nếu bạn bị ngắt kết nối, mọi thay đổi sẽ bị mất","update":"Cập nhật","activateDeactivate":"Kích hoạt / hủy kích hoạt","attention":"Chú ý","cancel":"Hủy","sessionTimedout":"Phiên của bạn đã hết hạn. Xin vui lòng đăng nhập lại","username":"Tên đăng nhập","primary_mail":"email chính","secondary_mail":"Email phụ (tùy chọn)","groups":"Các nhóm","must_email":"Phải là một email","ieNotSupported":"IE không được hỗ trợ","tryChrome":"Internet Explorer không được hỗ trợ. Chúng tôi khuyên bạn nên sử dụng Chrome cho ứng dụng này.","close":"Gần","forgotSQA":"quên câu trả lời bảo mật?","resetSecQA":"Đặt lại Câu hỏi và mật khẩu Bảo mật","retry":"Quay lại","nofactorpresent":"Tùy chọn này không thể được sử dụng vì số điện thoại di động không được đặt. Vui lòng liên hệ với quản trị viên của bạn.","emptypasscode":"Mã không thể để trống","provisioned":"Người dùng này chưa được đăng ký. Mật khẩu chỉ có thể được đặt lại sau khi người dùng đang hoạt động","deprovisioned":"Người dùng này đã ngừng hoạt động. Mật khẩu chỉ có thể được đặt lại sau khi người dùng đang hoạt động","resetsuccesspopupmsg":"Liên kết đặt lại mật khẩu đã được gửi đến địa chỉ email của bạn. Vui lòng đóng cửa sổ bật lên bằng cách sử dụng nút Đóng hoặc X.","wanttoreset":"Bạn có muốn đặt lại mật khẩu?","wanttoactivate":"Bạn có muốn kích hoạt người dùng không?","wanttodeactivate":"Bạn có muốn hủy kích hoạt người dùng không?","wanttodelete":"Bạn có muốn xóa người dùng không?","updateprofile":"Cập nhật hồ sơ","updatesuccess":"User has been updated successfully","usercreated":"* Người dùng đã tạo","errorcreatinguser":"* Lỗi khi tạo người dùng/ Email đã tồn tại","privacypolicy":"Chính sách bảo mật","termsandconditions":"Các điều khoản và điều kiện","uname-email":"Tên người dùng / Email","password_placeholder":"Mật khẩu","sign-in":"Đăng nhập","resetmailsent":"Email đã được gửi tới% bằng liên kết đặt lại mật khẩu.","smssent":"gởi","resendcode":"Mã gửi lại","needhelp":"Bạn cần trợ giúp đăng nhập?","forgotPassword":"Quên mật khẩu?","helplink":"Cứu giúp","smsusage":"SMS chỉ có thể được sử dụng nếu một số điện thoại di động đã được cấu hình.","backtosignin":"Trở lại Đăng nhập","resetviasms":"Đặt lại qua SMS","resetviaemail":"Đặt lại qua email","didntreceivecode":"Bạn không nhận được mã? đặt lại qua Email","emailsent":"Đã gửi email!","recoverycredentialsnotset":"Quên mật khẩu không được phép vì các thông tin khôi phục không được đặt cho người dùng","usernotpresent":"Người dùng không có mặt","mobilenumbernotset":"Không đặt số di động","invalidcreds":"Sai username hoặc password","emailreq":"Email bắt buộc","emailinvalid":"Email không hợp lệ","pwdreq":"mật khẩu là bắt buộc","otplength":"OTP phải dài 6 ký tự","passcodeinvalid":"Mã không hợp lệ","firstnamereq":"Tên riêng bắt buộc","lastnamereq":"Tên họ bắt buộc","notallowedincurrentstate":"Thao tác này không được phép trong trạng thái xác thực hiện tại","nopartsofusername":"Mật khẩu không được chứa các phần của tên người dùng của bạn, bao gồm tên hoặc họ của bạn","passwordusedrecently":"Mật khẩu đã được sử dụng quá gần đây","passwordnotmetrequirements":"The password does not meet the complexity requirements of the current password policy","antar":"Nam Cực","aus":"Australia","can":"Canada","falk":"Quần đảo Falkland (Malvinas)","kazak":"Kazakhstan","mayotte":"Mayotte","morocco":"Ma-rốc","norway":"Na Uy","pitcairn":"Pitcairn","filteruser":"Filter users by group:","selectgroups":"Select Application","status":"Status","atleastonegroup":"Select atleast one group to assign user to","answerchallenge":"Answer forgotton password challenge","entersmscode":"Enter verification code sent via SMS","enterusercreds":"Enter User Details","inviteuser":"Invite New User","assignApplication":"Assign to Application","availablegroups":"Available Groups","selectedgroups":"Assigned Groups","emailsenttouser":"Email successfully sent to ","pendingactivation":"Pending account activation","exit":"Exit","myprofile":"My Profile","activatesuccess":"User has been successfully activated and an activation mail has been sent to","deactivatesuccess":" has been successfully deactivated","deletesuccess":" has been successfully deleted","edituser":"Edit User","getstarted":"Get Started","congrats":"Congratulations!","accountsetup":"You’ve successfully completed your account setup.","edit":"Edit","assignedapps":"Assigned Applications","assignedgroups":"Assigned Groups","oldpwd":"Enter old password","changepwd":"Change password","updatephone":"Update phone","pwdupdated":"Password has been updated successfully","QAupdated":"Security Question Answer has been updated successfully","phonenumberinvalid":"Phone number is invalid","phoneupdated":"Phone number updated successfully","showmore":"Show More","verifypassword":"Verify Password","filterusergrp":"Filter users by group:","allactiveusers":"All active users","viewuser":"View user","partofokta":"This user is part of Okta organization","userdeactive":"User is deactive","showing":"Showing","of":"of","answerpartofquestion":"Answer must not be part of the question","activationpending":"Your factor is pending activation, Kindly update your phone number otherwise the reset SMSs will be sent to your previous active number","change_forgot_pwd_qtn":"Change security question:","basicinfo":"Basic information","gotoapp":"Click the Application you want to go to","passwordresetsuccess":"Your password has been reset successfully","passwordreset":"Password Reset!","searchinfotext":"*Search is done only on app","tmlabel":"Configuração","delete":"Delete","search":"Search","nop":"Số điện thoại","nop_inst":"Nhập số của bạn theo cách bạn thường quay số. Không thêm mã quốc gia của bạn","nopMobile":"Số điện thoại","statusactive":"Active","statuspending":"Pending Activation","globalsearch":"Search other users","permissiondenied":"You cannot delete/deactivate this user. user assigned to other groups. You can unassign the user instead","activestatus":"ACTIVE","provisionedstatus":"PROVISIONED","deprovisionedstatus":"DEPROVISIONED","save":"Save","admingroup":"Admin group","application":"Application","selectadmingroup":"Select admin group","selectapp":"Select application","adminConfigIncomplete":"Row incomplete. Kindly assign a admin group, brand and administered groups to save or remove row","adminconfigdeletesuccess":"Deleted Successfully","adminconfigupdatesuccess":"Config successfully updated","wanttodeleteadminconfig":"Do you want to delete this config?","cannotdeleteconfig":"This config cannot be deleted","nonanoktauser":"Not allowed to do this action. This user's identity provider is not Okta.","reactivate":"Resend Invite","wanttoreactivate":"Do you want to resend activation link to the user?","iread1":"I agree that the Cargill customer portals, applications and services available through them are subject to Cargill’s Customer Portal","iread2":"Terms and Conditions","iread3":", which may be supplemented or amended by specific terms and conditions for each applicable business service.","iagree1":"I acknowledge and accept that Cargill’s processing of personal data in connection with Cargill customer portals, applications and services are subject to Cargill’s ","iagree2":"Online Privacy Policy","iagree3":", which may be supplemented or amended by 'Privacy Notices' for each applicable business service.","privacypolicy_link":"https://www.cargill.com/page/privacy-vn","termsandconditions_link":"https://www.cargill.com/portal-terms-vi","resetreactivate":"Reset/Reactivate","emailinvaliddomain":"User with this domain cannot be added","administeredgroups":"Administered Groups","selectgroupslist":"Select Groups","alreadyactive":"You are an active user!","alreadyactivesetup":"Your profile doesn't requires registration. Use Cargill employee login to signin to your applications.","selectBrand":"Select Brand","permissiondeniedreset":"You cannot reset password for this user.","unlockaccount":"Unlock Account","unlockaccountsuccess":"Your account has been unlocked successfully","accountunlocked":"Account Unlocked!","copyrefid":"Please copy the reference Id from the bottom of the email you received and paste it below to proceed.","securityquestionanswerweak":"The security question answer is too weak, answer must not be part of the question","securityanswermatchesquestion":"Security answer invalid: Answer must not contain $ which is part of the security question","copysecurityanswermatchesquestion":"Security answer invalid: Answer must not contain $ which is part of the security question","tokenInvalidShortMessage":"Your activation link is no longer valid.","enterActivationDetails":"For the information requested below, please consult your activation email.","resendActivation":"Resend Activation Mail","reinvite":"Resend Invite","reinviteEmailMessage":"If the information you have provided is correct then you will receive a new activation email.","reinviteContactAdminMessage":"Please reach out to your Cargill business contact if you do not receive the new activation email.","activationOk":"Ok","activationTitle":"Re-invite template selection","activationDescription":"Please select the email template for Re-invite","template":"template","isDxpApp":"Is DXP App","cargillActivation":"Cargill Activation Template","activationTemplateTitle":"Activate template selection","activationTemplateDescription":"Please select the email template for activation","selfRegistrationGrp":"Self Reg Grp","maxNoUsers":"Maximum Registration Users","dxpActivation":"DXP Activation","selfRegistration":"Self Registration","selfApp":"Self Registration Group","selfRegGrp":"Self Registration Sub-Groups","disableExistingUserOnboard":"Disable Existing User","selfRegSubGrps":"Self registration additional group:","selectReggroup":"Select Registration group","selfRegister":"Register","selfRegFormTitle":"Sign-up","E0001":"Sorry, there was a problem setting up your account. Please","E0001_1":" contact us ","E0001_2":"for help setting up your account.","E0002":" for assistance with setting up your account.","E0003":"Your account has been successfully registered. An email has been sent to ","E0003_1":" with instructions for activating your account.","E0004":"Your account has been successfully registered. You may now login to the application using your existing password. If you do not remember your password, please use the “Forgot Password�? option on the application to reset your password.","E0005":"User already exists with status ","E0005_1":" Please contact ","noSpecialCharacters":"No special character allowed","nameUpdated":"Firstname & Lastname has been updated successfully","selfRegistrationEmailId":"Email Id/Webpage URL","phoneValidationErrorMessage":"Password requirements were not met. Password requirements: at least 8 characters, a lowercase letter, an uppercase letter, a number, no parts of your username. Your password cannot be any of your last 24 passwords.","acceptTerms":"Please accept our Privacy Policy and Terms & Conditions to proceed.","phoneVerificationNotCompleted":"Please verify / remove your phone number to proceed.","verifyPhoneWarning":"Please click on 'Send Code' to Verify your phone number","viewMoreInfo":"View more Info","infoContent":"View more info about the User","createdDate":"Created Date","activatedDate":"Activated Date","lastLoginDate":"Last Login Date","lastUpdatedDate":"Last Updated Date","passwordChangedDate":"Password Changed Date","statusChangedDate":"Status Changed Date","createdDateDescription":"Date and time when user record was created in Okta.","activatedDateDescription":"Date and time when the last user activation email was sent.","statusChangedDateDescription":"Date and time when user status was last changed in Okta.","lastLoginDateDescription":"Date and time when user last logged into Okta (not application specific).","lastUpdatedDateDescription":"Date and time when user record was last updated in Okta.","passwordChangedDateDescription":"Date and time when user last changed their password.","resetMFATitle":"Reset Multifactor Authentication","noFactorExist":"No factor exists for this user.","mfaValidation":"Please select a factor to reset.","resetButton":"Reset","mfaResetModalTitle":"MFA Reset","factorResetSuccess":"Factor was reset successfully.","resetConfirmation":"Are you sure you want to Reset MFA for this user?","copyrights":"Cargill, Incorporated. All Rights Reserved.","reportLabel":"Report","bulkUploadLabel":"Bulk Upload Users","availableIndependentGroups":"Available independent groups:","selectedBrand":"Selected Brand:","bulkUploadOptionsLabel":"Bulk Upload Options","bulkCreateUsers":"Bulk Create Users","bulkReinviteUsers":"Bulk Re-Invite Users","confirm":"Confirm","downloadExcelTemplate":"Download Excel Template:","uploadInstruction":"After downloading the template, fill up the excel sheet and upload using the section below","uploadWarningOne":"Maximum of only 50 users allowed at a time","uploadWarningTwo":"Ensure the email field is not left empty","uploadWarningThree":"Ensure the email ids provided are administrated by you.","uploadWarningFour":"Ensure no fields left empty","uploadWarningFive":"Ensure all field values are valid","uploadWarningSix":"Ensure the group ids provided are administrated by you.","uploadNote":"Invites sent through this process follow the standard Cargill account invite email.","uploadLabel":"Upload","action":"Actions","userword":"users","note":"Note:","authentication":"Authentication","noTableData":"No data for table.","readOnlyGroup":"This is a read-only group. Assignement for this group should be made only via access.cargill.com","adminPermissionDenied":"Your User Admin rights do not have permissions to modify this group assignment.","msgForGenericErrorUA":"Currently we are facing an issue with processing your request. Please try again later. If you continue to see this error, contact your customer service representative for further assistance.","passcodeRateLimit":"Unable to process your request, please try again in 5 minutes.","passcodeNotEntered":"Please enter the passcode to verify.","msgForUnhandledResponse":"Unable to process the request, please contact your customer service representative.","groupUnavailable":"The group is no longer available in Okta. The group may have been deleted.","groupCannotBeAssigned":"The group $ is no longer available in Okta and hence cannot be assigned to the user. Please remove the group and proceed.","copyGroupCannotBeAssigned":"The group $ is no longer available in Okta and hence cannot be assigned to the user. Please remove the group and proceed."}

/***/ }),
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_javascript_detect_element_resize__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_javascript_detect_element_resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_javascript_detect_element_resize__);





/* harmony default export */ __webpack_exports__["default"] = ({
  beforeDestroy: function beforeDestroy() {
    removeResizeListener(this.$el.parentElement, this.parentResizing);
    window.removeEventListener('resize', this.windowResizing);
    window.removeEventListener('scroll', this.scrolling);
  },
  data: function data() {
    return {
      affixed: false,
      affixedStyles: { position: 'relative' },
      affixedToBottom: false,
      elementSizes: {},
      parentSizes: {},
      windowSizes: {}
    };
  },


  methods: {
    affixElement: function affixElement() {
      var element = this.$el;
      this.affixedStyles = {
        bottom: this.elementSizes.bottom,
        height: element.offsetHeight,
        left: this.getOffset(element).left,
        top: 0,
        width: element.offsetWidth,
        position: 'fixed'
      };
    },
    affixElementToBottom: function affixElementToBottom() {
      this.affixedStyles = {
        bottom: 0,
        height: this.elementSizes.height,
        left: this.elementSizes.left,
        position: 'absolute',
        width: this.elementSizes.width
      };
    },
    elementResizing: function elementResizing() {
      var element = this.$el;
      this.elementSizes = {
        outerHeight: element.offsetHeight,
        offsetTop: this.getOffset(element).top
      };
      this.elementSizes.offsetBottom = this.elementSizes.outerHeight + this.elementSizes.offsetTop;
    },
    elementShouldBeAtBottom: function elementShouldBeAtBottom(windowScrollTop) {
      var elementBottom = windowScrollTop + this.elementSizes.outerHeight;
      return elementBottom >= this.parentSizes.offsetBottom;
    },
    elementShouldBeAtTop: function elementShouldBeAtTop(windowScrollTop) {
      return windowScrollTop <= this.elementSizes.offsetTop;
    },
    elementShouldBeFixed: function elementShouldBeFixed(windowScrollTop) {
      return windowScrollTop > this.elementSizes.offsetTop;
    },
    getOffset: function getOffset(element) {
      var rect = element.getBoundingClientRect();
      var body = document.body;
      var clientTop = element.clientTop || body.clientTop || 0;
      var clientLeft = element.clientLeft || body.clientLeft || 0;
      var scrollTop = this.getScroll(window, true);
      var scrollLeft = this.getScroll(window);

      return {
        top: rect.top + scrollTop - clientTop,
        left: rect.left + scrollLeft - clientLeft
      };
    },
    getScroll: function getScroll(w, top) {
      var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
      var method = 'scroll' + (top ? 'Top' : 'Left');

      if (typeof ret !== 'number') {
        var d = w.document;

        ret = d.documentElement[method];

        if (typeof ret !== 'number') {
          ret = d.body[method];
        }
      }
      return ret;
    },
    parentResizing: function parentResizing() {
      var parent = this.$el.parentElement;

      this.parentSizes = {
        outerHeight: parent.offsetHeight,
        offsetTop: this.getOffset(parent).top
      };
      this.parentSizes.offsetBottom = this.parentSizes.outerHeight + this.parentSizes.offsetTop;
    },
    scrolling: function scrolling() {
      var element = this.$el;
      var parent = element.parentElement;
      var windowScrollTop = this.getScroll(window, true);

      if (window.innerHeight <= this.elementSizes.outerHeight || this.parentSizes.outerHeight <= this.elementSizes.outerHeight || this.affixed && this.elementShouldBeAtTop(windowScrollTop)) {
        this.affixed = false;
        this.affixedToBottom = false;
        this.unaffixElement();
      } else if (this.elementShouldBeAtBottom(windowScrollTop)) {
        this.affixed = false;
        this.affixedToBottom = true;
        this.affixElementToBottom();
      } else if (!this.affixed && this.elementShouldBeFixed(windowScrollTop)) {
        this.affixed = true;
        this.affixedToBottom = false;
        this.affixElement();
      }
    },
    unaffixElement: function unaffixElement() {
      this.affixedStyles = { position: 'relative' };
    },
    windowResizing: function windowResizing() {
      this.elementResizing();
      this.parentResizing();
    }
  },

  props: {
    disabled: {
      default: false,
      type: Boolean
    }
  },

  ready: function ready() {
    this.$el.parentElement.style.position = 'relative';

    this.elementResizing();
    this.parentResizing();

    addResizeListener(this.$el.parentElement, this.parentResizing);
    window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(this.windowResizing, 200));
    window.addEventListener('scroll', this.scrolling);
  },


  watch: {
    'disabled': function disabled(value) {
      if (value) {
        removeResizeListener(this.$el.parentElement, this.parentResizing);
        window.removeEventListener('resize', this.windowResizing);
        window.removeEventListener('scroll', this.scrolling);
        this.affixed = false;
        this.affixedToBottom = false;
        this.unaffixElement();
      } else {
        addResizeListener(this.$el.parentElement, this.parentResizing);
        window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(this.windowResizing, 200));
        window.addEventListener('scroll', this.scrolling);
      }
    },

    'parentSizes.outerHeight': 'scrolling'
  }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer_footer_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_footer_footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_header_brandBar_brandBar_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_header_brandBar_brandBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_header_brandBar_brandBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_storage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelation_affix__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelation_affix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelation_affix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tether__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tether___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_tether__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery_cookie__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sticky_table_headers__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sticky_table_headers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sticky_table_headers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_toastr__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_file_saverjs__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_file_saverjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_file_saverjs__);














var environment = "stage";
var brandDetails = "";
if (environment === 'production') {
  brandDetails = __webpack_require__(16);
} else if (environment === 'stage') {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    ApplicationFooter: __WEBPACK_IMPORTED_MODULE_2__components_footer_footer_vue___default.a,
    ApplicationBrandBar: __WEBPACK_IMPORTED_MODULE_3__components_header_brandBar_brandBar_vue___default.a,
    affix: __WEBPACK_IMPORTED_MODULE_5_vuelation_affix___default.a
  },
  created: function created() {
    this.isAuthenticated();
    this.$auth.authStateManager.subscribe(this.isAuthenticated);
    this.loadBrandCss();
  },
  mounted: function mounted() {
    cssVars();
  },
  data: function data() {
    return {
      authenticated: false
    };
  },

  watch: {
    '$route': 'isAuthenticated'
  },
  methods: {
    isAuthenticated: function isAuthenticated() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$auth.isAuthenticated();

              case 2:
                _this.authenticated = _context.sent;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    logout: function logout() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$auth.logout();

              case 2:
                _context2.next = 4;
                return _this2.isAuthenticated();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    loadBrandCss: function loadBrandCss() {
      console.log('applying brand specific css...');
      var lnk = document.createElement('link');
      lnk.type = 'text/css';
      lnk.rel = 'stylesheet';
      var brand = brandDetails.data.filter(function (i) {
        return i.applicationUrls.indexOf(document.location.host) > -1;
      });
      var cssToApply = brand.length ? brand[0].cssFileName : 'cargill.css';
      console.log('applying css... : ' + cssToApply);
      __WEBPACK_IMPORTED_MODULE_4__helpers_storage__["default"].set('brand', brand.length ? brand[0].brandName : '');
      lnk.href = '../static/' + cssToApply;
      document.getElementsByTagName('head')[0].appendChild(lnk);
      document.getElementsByTagName('title')[0].text = 'my' + brand[0].brandName + ' Identity';
    }
  }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'spinner',
  props: {
    spinnerOn: false
  }
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_good_table__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_good_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_good_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_auth_api__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__idm_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_storage__ = __webpack_require__(5);











var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";


var environment = "stage";
var brandDetails = "";
console.log('env=====', environment);
if (environment === 'production') {
  brandDetails = __webpack_require__(16);
} else if (environment === 'stage') {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_good_table___default.a);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'test',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default.a
  },
  created: function created() {
    var self = this;
    setTimeout(self.assignUserLang(), 1000);
    setTimeout(function () {}, 300);
  },
  mounted: function mounted() {
    var self = this;
    this.loading = true;
    $("#table").on('click', '[id^="Atualizar"]', function (e) {
      self.onUpdateClick(e.target.id);
    });
    $("#table").on('click', '[id^="resetpwd"]', function (e) {
      self.onResetPwd(e.target.id);
    });
    $("#table").on('click', '[id^="reactivate"]', function (e) {
      self.onReactivate(e.target.id);
    });
    $("#table").on('click', '[id^="deactivate"]', function (e) {
      self.deactivateUserId(e);
    });
    $("#table").on('click', '[id^="unlock!^*$"]', function (e) {
      self.onUnlock(e.target.id);
    });
    $('#searchId').keypress(function (e) {
      if (self.loading && self.getUserType === 'app') {
        e.preventDefault();
        return false;
      }
    });
    self.$root.$on('refreshuserlist', function (language) {
      self.getUserDetails(self.getUserType);
    });
    __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
      self.columns = [{
        label: self.user_lang.first_name,
        field: '_embedded.user.profile.updatelink',
        html: true
      }, {
        label: self.user_lang.last_name,
        field: '_embedded.user.profile.lastName',
        html: false
      }, {
        label: self.user_lang.emailAddress,
        field: '_embedded.user.profile.login',
        html: false
      }, {
        label: self.user_lang.status,
        field: 'showstatus',
        html: true
      }, {
        label: self.user_lang.action,
        field: 'deactivateAt',
        html: true
      }, {
        label: '',
        field: 'resetpwd',
        html: true
      }, {
        label: '',
        field: 'deleteUser',
        html: true
      }];
      self.rows = [];
      self.manipulateJSONtoRender(self.rawRows);
    });
    $(window).on('scroll', function () {
      self.scrollEventHandler();
    });
  },

  props: ['adminAppsArray', 'filterAppId', 'filterGroupId', 'usercreated', 'searchTerm', 'globalsearch', 'adminTo'],
  data: function data() {
    return {
      brandDetails: brandDetails,
      showfloatingcount: false,
      lang: __WEBPACK_IMPORTED_MODULE_5__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_5__i18n_locale_js__["locale"].lang_obj,
      defaultSort: {
        field: '_embedded.user.profile.updatelink',
        type: 'asc'
      },
      columns: [{
        label: 'First name',
        field: '_embedded.user.profile.updatelink',
        html: true
      }, {
        label: 'Last name',
        field: '_embedded.user.profile.lastName',
        html: false
      }, {
        label: 'E-mail',
        field: this.reverseTransformEmail,
        html: false
      }, {
        label: 'Status',
        field: 'showstatus',
        html: true
      }, {
        label: 'Actions',
        field: 'deactivateAt',
        html: true
      }, {
        label: '',
        field: 'resetpwd',
        html: true
      }, {
        label: '',
        field: 'deleteUser',
        html: true
      }],
      rows: [],
      rawRows: [],

      loading: false,
      currentRole: '',
      currentTaxId: '',
      updateSuccess: false,
      emailAddress: '',
      resetSuccess: false,
      currentRoleCode: '',
      firstname: '',
      lastname: '',
      currentemailId: '',
      statusCode: '',
      currentId: '',
      currentSearchTerm: '',
      user_lang: {},
      resetSuccessMsg: "",
      selectedAppId: '',
      selectedGroupId: 'all',
      requestType: '',
      phone: '',
      showMoreString: undefined,
      totalCount: '',
      getUserType: 'app',
      randomMatch: '',
      adminToGroups: [],

      dxpList: [],
      nonDxpList: [],
      appList: [],
      errorAdminMsg: '',
      dxpnewcurrentId: '',
      dxpnewcurrentName: '',
      groupDeleted: false
    };
  },

  watch: {
    lang: function lang() {},
    filterAppId: function filterAppId() {
      this.watchFilterAppId();
    },
    usercreated: function usercreated() {
      this.watchUserCeated();
    },
    filterGroupId: function filterGroupId() {
      this.watchFilterGroupId();
    },
    searchTerm: function searchTerm(newVal, oldVal) {
      this.watchSearchTerm(newVal, oldVal);
    }
  },
  methods: {
    getDxpDetails: function getDxpDetails() {
      var grpsOfUser = JSON.parse(__WEBPACK_IMPORTED_MODULE_8__helpers_storage__["default"].get('grpsOfUser'));
      var grpIds = [];
      grpsOfUser.map(function (grp) {
        grpIds.push(grp.id);
      });
      return grpIds.join(',');
    },
    getListOfSuperUserApps: function getListOfSuperUserApps(userId, adminGrp, action, id) {
      var self = this;
      self.dxpList = [];
      self.nonDxpList = [];
      self.loading = true;
      if (action.indexOf("resendInvite") > -1) {
        __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].getListOfSuperUserApps(apiUrl + '/auth/apps', self.email).then(function (response) {
          self.appList = response.data;
          __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].getDxpDetails(apiUrl + '/auth/users/mapgroup?adminId=' + adminGrp + '&userId=' + userId).then(function (response) {
            if (response.data && response.data.errorMessage) {
              self.errorAdminMsg = response.data.errorMessage;
              $('.adminErrorModal').modal('show');
            }
            if (response.data && response.data.dxpAppList) {
              response.data.dxpAppList.map(function (grp) {
                self.appList.map(function (grpObj) {
                  if (grpObj.id === grp) {
                    self.dxpList.push({
                      id: grpObj.id,
                      label: grpObj.label
                    });
                  }
                });
              });
            }
            if (response.data && response.data.nonDxpAppList) {
              response.data.nonDxpAppList.map(function (grp) {
                self.appList.map(function (grpObj) {
                  if (grpObj.id === grp) {
                    self.nonDxpList.push({
                      id: grpObj.id,
                      label: grpObj.label
                    });
                  }
                });
              });
            }
            if (self.dxpList.length > 0 && self.nonDxpList.length > 0) {
              $('.dxpmodal').modal('show');
            }if (self.dxpList.length === 0 && self.nonDxpList.length > 0) {
              $('.reactivatemodal').modal('show');
            }if (self.dxpList.length === 1 && self.nonDxpList.length === 0) {
              self.dxpnewcurrentId = self.dxpList[0].id;
              self.dxpnewcurrentName = self.dxpList[0].label;
              $('.reactivatedxpnewmodal').modal('show');
            }if (self.dxpList.length > 1 && self.nonDxpList.length === 0) {
              $('.newdxpmodal').modal('show');
            }
            self.loading = false;
          }).catch(function (err) {
            self.loading = false;
            console.log(err);
          });
        }).catch(function (err) {
          self.loading = false;
          console.log(err);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].getDxpDetails(apiUrl + '/auth/users/mapgroup?adminId=' + adminGrp + '&userId=' + userId).then(function (response) {
          if (action.indexOf("resetpwd") > -1) {
            console.log("Works");
            if (response.data && response.data.errorMessage) {
              $('.permissiondeniedreset').modal('show');
            } else if (response.data && (response.data.nonDxpAppList && response.data.nonDxpAppList.length > 0 || response.data.dxpAppList && response.data.dxpAppList.length > 0)) {
              self.onResetPwdPermissionGranted(id);
            }
          } else if (action.indexOf("unlockAccount") > -1) {
            console.log("Unlock");
            if (response.data && response.data.errorMessage) {
              self.errorAdminMsg = response.data.errorMessage;
              $('.adminErrorModal').modal('show');
            } else {
              __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].unlockUser(apiUrl + '/auth/users/' + id + '/unlock').then(function (response) {
                self.loading = false;
                window.alert('Account has been unlocked');
                self.getUserDetails(self.getUserType);
              }).catch(function (err) {
                self.loading = false;
                window.alert('Account unlock failed or the account was not locked. Please try again later.');
                console.log("create Insert CF Error: ", err);
              });
            }
          } else if (action.indexOf("activate") > -1) {
            if (response.data && response.data.errorMessage) {
              self.errorAdminMsg = response.data.errorMessage;
              $('.adminErrorModal').modal('show');
            } else {
              if (id.target.getAttribute('act').toLowerCase() === 'activate') {
                self.statusCode = '0';
              } else {
                if (id.target.getAttribute('act').toLowerCase() === 'delete') {
                  self.requestType = 'deleteoktauser';
                } else {
                  self.requestType = 'deactivateoktauser';
                }
                self.statusCode = '1';
              }
              $('.ativateanddeactivaeemodal').modal('show');
            }
          }
          self.loading = false;
        }).catch(function (err) {
          self.loading = false;
          console.log(err);
        });
      }
    },
    reverseTransformEmail: function reverseTransformEmail(rows) {
      var em = rows._embedded.user.profile.login;
      if (em.toLowerCase().indexOf('@identity.mycargill.com') > -1 || em.toLowerCase().indexOf('@whitelabel.cargill.com') > -1 || em.toLowerCase().indexOf('@partneridentity.okta-emea.com') > -1) {
        var brname = this.brandDetails.data.filter(function (n) {
          if (n.brandCode.toLowerCase() === em.substr(2, 3)) {
            return n;
          }
        });
        em = em.substring(5, em.indexOf('@')).substring(0, em.substr(0, 2) - 1) + '@' + em.substring(5, em.indexOf('@')).substring(em.substr(0, 2) - 1) + ' [' + brname[0].brandName + ']';
      }
      return em;
    },
    watchFilterGroupId: function watchFilterGroupId() {
      this.selectedGroupId = this.filterGroupId;
      this.getUserDetails('group');
    },
    watchUserCeated: function watchUserCeated() {
      this.selectedAppId = this.filterAppId;
    },
    watchFilterAppId: function watchFilterAppId() {
      this.selectedAppId = this.filterAppId;
      this.getUserDetails('app');
    },
    scrollEventHandler: function scrollEventHandler() {
      var self = this;
      var top = $(window).scrollTop();
      var temp = $('.showingnusers');
      if (temp.length) {
        var divBottom = $('.showingnusers').offset().top + $('.showingnusers').outerHeight();
        if (divBottom > top) {
          self.showfloatingcount = false;
        } else {
          self.showfloatingcount = true;
        }
      }
    },
    watchSearchTerm: function watchSearchTerm(newVal, oldVal) {
      var self = this;
      console.log(self.searchTerm + ' ' + newVal);
      if (newVal.trim().length < oldVal.trim().length && (newVal.trim().length === 2 || newVal.trim().length === 0)) {
        self.loading = true;
        if (self.selectedGroupId === 'all') {
          self.getUserDetails('app');
        } else {
          self.$root.$emit('searchcleared');
          self.selectedGroupId = self.filterGroupId;
          self.getUserDetails('group');
        }
      } else if (newVal.trim().length >= 3) {
        console.log('going to search: ' + self.searchTerm.trim());
        self.currentSearchTerm = self.searchTerm.trim();
        self.loading = true;
        self.getUserDetails('search', self.searchTerm.trim());
      }
    },
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    getUserDetailsInnerFn: function getUserDetailsInnerFn(random, response) {
      var self = this;
      if (random === self.randomMatch) {
        self.loading = false;
        self.showMoreString = response.headers.page;
        self.rawRows = response.data;
        self.manipulateJSONtoRender(response.data);
      }
    },
    getUserDetails: function getUserDetails(type, st) {
      var self = this;
      self.rawRows = [];
      self.rows = [];
      self.groupDeleted = false;
      var delayTimer;
      if (type === 'search') {}
      if (self.selectedAppId === '') {
        self.selectedAppId = this.filterAppId;
      }
      self.loading = true;
      self.showMoreString = '';
      self.totalCount = '';
      type = self.globalsearch ? 'globalsearch' : type;
      console.log("type " + type);
      self.getUserType = type;
      var random = Math.random();
      self.randomMatch = random;
      if (type === 'group' && self.selectedGroupId !== 'all') {
        self.loading = true;
        __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].getUserDetailsOfGroup(apiUrl + '/auth/groups/' + self.selectedGroupId + '/users?limit=50').then(function (response) {
          self.loading = true;
          __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].getGroupStats(apiUrl + '/auth/groups/' + self.selectedGroupId).then(function (response) {
            self.totalCount = response.data._embedded.stats.usersCount;
          }).catch(function (error) {
            console.log(error);
          });
          setTimeout(function () {
            self.getUserDetailsInnerFn(random, response);
          }, 0);
        }).catch(function (error) {
          console.log(error);
          if (error.response.status === 404) {
            self.loading = false;
            self.groupDeleted = true;
            console.log("The group is unavailable in Okta.");
          }
        });
      } else if (type === 'search' && self.searchTerm.trim() !== '' && self.selectedGroupId !== 'all' && self.selectedGroupId !== '') {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function () {
          self.loading = true;
          __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].getUserDetailsOfSearch(apiUrl + '/auth/apps/' + self.selectedAppId + '/users?q=' + self.searchTerm.trim()).then(function (response) {
            setTimeout(function () {
              self.getUserDetailsInnerFn(random, response);
            }, 0);
          });
        }, 500);
      } else if (type === 'search' && self.searchTerm.trim() !== '' && self.selectedGroupId === 'all') {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function () {
          self.loading = true;
          __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].getUserDetailsOfSearch(apiUrl + '/auth/apps/' + self.selectedAppId + '/users?q=' + self.searchTerm.trim()).then(function (response) {
            setTimeout(function () {
              self.getUserDetailsInnerFn(random, response);
            }, 0);
          });
        }, 500);
      } else if (type !== 'search' && type !== 'group' && type !== 'globalsearch') {
        self.loading = true;
        __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].getUserDetailsOfApp(apiUrl + '/auth/apps/' + self.selectedAppId + '/users?limit=50').then(function (response) {
          setTimeout(function () {
            self.getUserDetailsInnerFn(random, response);
          }, 0);
        });
      } else if (type === 'group' && self.selectedGroupId === 'all') {
        self.loading = true;
        __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].getUserDetailsOfApp(apiUrl + '/auth/apps/' + self.selectedAppId + '/users?limit=50').then(function (response) {
          setTimeout(function () {
            self.getUserDetailsInnerFn(random, response);
          }, 0);
        });
      } else if (type === 'globalsearch') {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function () {
          self.loading = true;
          __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].getUserDetailsOfSearch(apiUrl + '/auth/users?search=id%20eq%20"' + self.searchTerm.trim() + '"\n          %20or%20profile.firstName%20sw%20"' + self.searchTerm.trim() + '"\n          %20or%20profile.lastName%20sw%20"' + self.searchTerm.trim() + '"\n          %20or%20profile.email%20sw%20"' + self.searchTerm.trim() + '"&limit=50').then(function (response) {
            setTimeout(function () {
              self.getUserDetailsInnerFn(random, response);
            }, 0);
          });
        }, 500);
      } else {
        self.loading = false;
      }
    },
    manipulateJSONtoRender: function manipulateJSONtoRender(rows) {
      this.loading = true;
      rows = rows || this.rawRows;
      var iscargill = false;
      for (var c = 0; c < rows.length; c++) {
        this.loading = true;
        if (rows[c]['_embedded'] === undefined) {
          rows[c]['_embedded'] = {};
          rows[c]['_embedded']['user'] = {};
          rows[c]['_embedded']['user']['profile'] = rows[c]['profile'];
        }
        var profile = rows[c]['_embedded'] === undefined ? rows[c]['profile'] : rows[c]['_embedded']['user']['profile'];
        iscargill = profile['login'].toLowerCase().indexOf('@crgl-thirdparty.') > -1 || profile['login'].toLowerCase().indexOf('@cargill.') > -1 || profile['login'].toLowerCase().indexOf('@awb') > -1;
        profile['updatelink'] = '';
        if (rows[c]._embedded.user.status !== undefined) {
          rows[c].status = rows[c]._embedded.user.status;
        } else {
          rows[c].status = rows[c].status;
        }
        if (rows[c]['status'].toLowerCase() === 'deprovisioned' || rows[c]['status'].toLowerCase() === 'staged') {
          rows[c]['deactivateAt'] = '<a id="deactivate ' + '~' + rows[c]['id'] + '^' + profile['login'] + ' " style="text-decoration: underline;color: blue;" act="activate">' + this.user_lang.activateDeactivate.split('/')[0] + '</a>';
          rows[c]['deleteUser'] = '<a> <i id="deactivate ' + '~' + rows[c]['id'] + '^' + profile['login'] + ' " style="text-decoration: underline;color: blue;visibility:hidden !important;" act="delete" class="fa fa-trash deleteicon"></i> </a>';
          profile['updatelink'] = '<a id="Atualizar ' + '~$&' + profile['firstName'] + '!^*$' + profile['lastName'] + '!^*$' + rows[c]['id'] + '!^*$' + profile['login'] + '" style="text-decoration: underline;color: blue;" title = "Activate the user to view/update" alt="Activate the user to view/update">' + profile['firstName'] + '</a>';
        } else if (profile['login'] === __WEBPACK_IMPORTED_MODULE_8__helpers_storage__["default"].get('email')) {
          rows[c]['deactivateAt'] = '<a id="reactivate ' + '~' + rows[c]['status'] + '^' + profile['login'] + '~' + rows[c]['id'] + ' " style="text-decoration: underline;color: blue;">' + this.user_lang.reactivate + '</a>';
          rows[c]['resetpwd'] = '<a class = "disabled" disabled = "disabled" id="resetpwd ' + '~' + rows[c]['status'] + '^' + profile['login'] + '~' + rows[c]['id'] + ' " style="text-decoration: underline;color: blue;">' + this.user_lang.resetpwd + '</a>';
          rows[c]['deleteUser'] = '';
          profile['updatelink'] = '<a class = "disabled" disabled = "disabled" id="Atualizar ' + '~$&' + profile['firstName'] + '!^*$' + profile['lastName'] + '!^*$' + rows[c]['id'] + '!^*$' + profile['login'] + '" style="text-decoration: underline;color: blue;">' + profile['firstName'] + '</a>';
        } else if (rows[c]['status'].toLowerCase() === 'provisioned') {
          rows[c]['deactivateAt'] = '';
          rows[c]['resetpwd'] = '<a id="reactivate ' + '~' + rows[c]['status'] + '^' + profile['login'] + '~' + rows[c]['id'] + ' " style="text-decoration: underline;color: blue;">' + this.user_lang.reactivate + '</a>';
          rows[c]['deleteUser'] = '';
          profile['updatelink'] = '<a id="Atualizar ' + '~$&' + profile['firstName'] + '!^*$' + profile['lastName'] + '!^*$' + rows[c]['id'] + '!^*$' + profile['login'] + '" style="text-decoration: underline;color: blue;">' + profile['firstName'] + '</a>';
        } else {
          rows[c]['deactivateAt'] = '<a id="reactivate ' + '~' + rows[c]['status'] + '^' + profile['login'] + '~' + rows[c]['id'] + ' " style="text-decoration: underline;color: blue;">' + this.user_lang.reactivate + '</a>';
          rows[c]['resetpwd'] = '<a id="resetpwd ' + '~' + rows[c]['status'] + '^' + profile['login'] + '~' + rows[c]['id'] + ' " style="text-decoration: underline;color: blue;">' + this.user_lang.resetpwd + '</a>';
          rows[c]['deleteUser'] = '';
          profile['updatelink'] = '<a id="Atualizar ' + '~$&' + profile['firstName'] + '!^*$' + profile['lastName'] + '!^*$' + rows[c]['id'] + '!^*$' + profile['login'] + '" style="text-decoration: underline;color: blue;">' + profile['firstName'] + '</a>';
        }
        if (iscargill) {
          rows[c]['deactivateAt'] = '';
          rows[c]['resetpwd'] = '';
          rows[c]['deleteUser'] = '';
          profile['updatelink'] = '<a id="Atualizar ' + '~$&' + profile['firstName'] + '!^*$' + profile['lastName'] + '!^*$' + rows[c]['id'] + '!^*$' + profile['login'] + '" style="text-decoration: underline;color: blue;">' + profile['firstName'] + '</a>';
        }
        if (rows[c].status === 'ACTIVE') {
          rows[c].showstatus = this.user_lang.activestatus;
        } else if (rows[c].status === 'PROVISIONED') {
          rows[c].showstatus = this.user_lang.provisionedstatus;
        } else if (rows[c].status === 'DEPROVISIONED') {
          rows[c].showstatus = this.user_lang.deprovisionedstatus;
        } else if (rows[c].status === 'LOCKED_OUT') {
          rows[c].showstatus = rows[c].status + ' ' + '<a id="unlock!^*$' + profile['login'] + '" style="text-decoration: underline;color: blue;">Unlock</a>';
        } else {
          rows[c].showstatus = rows[c].status;
        }
        if (c === rows.length - 1) {
          this.loading = false;
        }
      }
      if (rows.length === 0) {
        this.loading = false;
      }

      this.rows = rows.slice();
      if ($($('.table-bordered th')[0]).hasClass('sorting-asc')) {
        $('.table-bordered th')[0].click();
        $('.table-bordered th')[0].click();
      } else if ($($('.table-bordered th')[0]).hasClass('sorting-desc')) {
        $('.table-bordered th')[0].click();
      } else if ($('.table-bordered th')[0] !== undefined) {
        $('.table-bordered th')[0].click();
      }
    },

    deactivateUser: function deactivateUser(row) {
      var self = this;
      self.updateSuccess = false;
      if (this.statusCode === '0') {
        __WEBPACK_IMPORTED_MODULE_3__helpers_auth_api__["default"].activateOktaUser(self.currentId).then(function (response) {
          self.$root.$emit('activatesuccess', self.currentemailId);
          $('.ativateanddeactivaeemodal').modal('hide');
          setTimeout(function () {
            self.getUserDetails(self.getUserType);
          }, 500);
        }).catch(function (err) {
          console.log(err);
          setTimeout(function () {
            self.getUserDetails(self.getUserType);
          }, 500);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3__helpers_auth_api__["default"].deactivateOktaUser(self.currentId, self.requestType).then(function (response) {
          $('.ativateanddeactivaeemodal').modal('hide');
          if (self.requestType === 'deleteoktauser') {
            self.$root.$emit('deletesuccess', self.currentemailId);
          } else {
            self.$root.$emit('deactivatesuccess', self.currentemailId);
          }
          setTimeout(function () {
            self.getUserDetails(self.getUserType);
          }, 500);
        }).catch(function (err) {
          console.log(err);
          setTimeout(function () {
            self.getUserDetails(self.getUserType);
          }, 500);
        });
      }
    },
    deactivateUserId: function deactivateUserId(e) {
      var self = this;
      var temp = e.target.id.split('~');
      self.currentId = temp[1].split('^')[0];
      var id = e.target.id;
      var userId = id.split('~')[1].split('^')[0];
      var adminGrp = self.getDxpDetails();
      self.emailAddress = id.split('~')[1].split('^').slice(-1).join('_').trim();
      if (self.emailAddress.toLowerCase().indexOf('@cargill.') > -1 || self.emailAddress.toLowerCase().indexOf('@crgl-thirdparty.') > -1 || self.emailAddress.toLowerCase().indexOf('@awb') > -1) {
        $('.nonanoktausermodal').modal('show');
      } else {
        self.getListOfSuperUserApps(userId, adminGrp, "activate", e);
      }
    },
    onUpdateClick: function onUpdateClick(row) {
      var self = this;
      self.loading = true;
      console.log(row);
      __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].getGroupsByUserId(apiUrl + '/auth/users/' + row.split('~$&')[1].split('!^*$')[2].trim() + '/groups').then(function (response) {
        self.loading = false;
        var ext = response.data.filter(function (x) {
          return x.profile.name.toLowerCase() === 'azure ad' || x.profile.name.toLowerCase() === 'azuread' || x.profile.name.toLowerCase() === 'cargill internal identities';
        });
        var isAzureORInternalIdentities = ext.length > 0 ? true : false;
        self.updateSuccess = false;
        self.currentId = row.split('~$&')[1].split('!^*$')[2].trim();
        self.firstname = row.split('~$&')[1].split('!^*$')[0].trim();
        self.lastname = row.split('~$&')[1].split('!^*$')[1].trim();
        self.$root.$emit('updatetoggle', [self.firstname, self.lastname, row.split('~$&')[1].split('!^*$')[3].trim(), self.currentId, isAzureORInternalIdentities, true]);
      }).catch(function (err) {
        self.loading = false;
        console.log("create Insert CF Error: ", err);
      });
    },
    onReactivate: function onReactivate(id) {
      var self = this;
      var userId = id.split('~')[2];
      var adminGrp = self.getDxpDetails();
      self.emailAddress = id.split('~')[1].split('^').slice(-1).join('_').trim();
      if (self.emailAddress.toLowerCase().indexOf('@cargill.') > -1 || self.emailAddress.toLowerCase().indexOf('@crgl-thirdparty.') > -1 || self.emailAddress.toLowerCase().indexOf('@awb') > -1) {
        $('.nonanoktausermodal').modal('show');
      } else {
        self.getListOfSuperUserApps(userId, adminGrp, "resendInvite");
      }
    },
    closeModal: function closeModal(modalName) {
      $(modalName).modal('hide');
    },
    onUnlock: function onUnlock(id) {
      var self = this;
      self.loading = true;
      id = id.replace('unlock!^*$', '');
      var userId = id;
      var adminGrp = self.getDxpDetails();
      self.emailAddress = id;
      if (self.emailAddress.toLowerCase().indexOf('@cargill.') > -1 || self.emailAddress.toLowerCase().indexOf('@crgl-thirdparty.') > -1 || self.emailAddress.toLowerCase().indexOf('@awb') > -1) {
        $('.nonanoktausermodal').modal('show');
      } else {
        self.getListOfSuperUserApps(userId, adminGrp, "unlockAccount", id);
      }
    },
    onResetPwd: function onResetPwd(id) {
      var self = this;
      self.loading = true;
      var userId = id.split('~')[2];
      var adminGrp = self.getDxpDetails();
      self.emailAddress = id.split('~')[1].split('^').slice(-1).join('_').trim();
      if (self.emailAddress.toLowerCase().indexOf('@cargill.') > -1 || self.emailAddress.toLowerCase().indexOf('@crgl-thirdparty.') > -1 || self.emailAddress.toLowerCase().indexOf('@awb') > -1) {
        $('.nonanoktausermodal').modal('show');
      } else {
        self.getListOfSuperUserApps(userId, adminGrp, "resetpwd", id);
      }
    },
    onResetPwdPermissionGranted: function onResetPwdPermissionGranted(id) {
      var self = this;
      self.resetSuccess = false;
      self.resetSuccessMsg = self.user_lang.resetsuccesspopupmsg;
      self.emailAddress = id.split('~')[1].split('^').slice(-1).join('_').trim();
      if (id.split('~')[1].split('^')[0].toLowerCase() === 'provisioned') {
        self.resetSuccess = true;
        self.resetSuccessMsg = self.user_lang.provisioned;
      } else if (id.split('~')[1].split('^')[0].toLowerCase() === 'deprovisioned') {
        self.resetSuccess = true;
        self.resetSuccessMsg = self.user_lang.deprovisioned;
      }
      $('.resetpwdemodal').modal('show');
      self.loading = false;
    },
    resetPassword: function resetPassword() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].getUserIdByEmail(apiUrl + '/auth/users/' + self.emailAddress).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].resetPasswordByEmailByAdmin(apiUrl + '/auth/users/' + response.data.id + '/resetpassword', {}).then(function (response) {
          self.resetSuccess = true;
          $('.resetpwdemodal').modal('toggle');
          self.$root.$emit('resetsuccess');
          setTimeout(function () {
            self.getUserDetails(self.getUserType);
          }, 500);
        });
      });
    },
    adminErrorModalClick: function adminErrorModalClick() {
      $('.adminErrorModal').modal('hide');
    },
    sendReInvite: function sendReInvite() {
      var self = this;

      __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].sendDxpReInvite(apiUrl + '/auth/users/' + self.emailAddress + '/reInviteNew').then(function (response) {
        $('.reactivatemodal').modal('hide');
        self.$root.$emit('activatesuccess', self.emailAddress);
      }).catch(function (err) {
        $('.reactivatemodal').modal('hide');
        console.log(err);
      });
    },
    sendDxpReInvite: function sendDxpReInvite() {
      var self = this;
      var url = "";
      var selectedVal = $("input[name='activation']:checked").val();
      if (selectedVal === "0") {
        url = apiUrl + '/auth/users/' + self.emailAddress + '/reInviteNew';
      } else {
        url = apiUrl + '/auth/users/' + self.emailAddress + '/reInviteNew?appId=' + selectedVal;
      }
      __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].sendDxpReInvite(url).then(function (response) {
        $('.dxpmodal').modal('hide');
        $('.newdxpmodal').modal('hide');
        self.$root.$emit('activatesuccess', self.emailAddress);
      }).catch(function (err) {
        $('.dxpmodal').modal('hide');
        $('.newdxpmodal').modal('hide');
        console.log(err);
      });
    },
    sendNewDxpReInvite: function sendNewDxpReInvite() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].sendDxpReInvite(apiUrl + '/auth/users/' + self.emailAddress + '/reInviteNew?appId=' + this.dxpnewcurrentId).then(function (response) {
        $('.reactivatedxpnewmodal').modal('hide');
        self.dxpnewcurrentId = '';
        self.dxpnewcurrentName = '';
        self.$root.$emit('activatesuccess', self.emailAddress);
      }).catch(function (err) {
        $('.reactivatedxpnewmodal').modal('hide');
        self.dxpnewcurrentId = '';
        self.dxpnewcurrentName = '';
        console.log(err);
      });
    },
    containsObject: function containsObject(obj, list) {
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i].id === obj.id) {
          return true;
        }
      }
      return false;
    },
    showMore: function showMore() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_7__idm_api__["default"].getUserDetailsOfApp(apiUrl + '/auth' + self.showMoreString).then(function (response) {
        setTimeout(function () {
          self.loading = false;
          self.showMoreString = response.headers.page;
          self.rawRows = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(self.rawRows), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.data));
          self.manipulateJSONtoRender(self.rawRows);
        }, 300);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_storage__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'applicationFooter',
  created: function created() {
    var self = this;
    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
    });
  },
  data: function data() {
    return {
      lang: __WEBPACK_IMPORTED_MODULE_0__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_0__i18n_locale_js__["locale"].lang_obj,
      user_lang: {},
      brand: __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].get('brand')
    };
  },

  methods: {
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    }
  }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_okta__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_storage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__idm_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(66);









var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";
var onecargilladmingroupid = "00gf4o186i1L3hcDw0h7";
var brandDetails = __webpack_require__(16);
var brand = brandDetails.data.filter(function (i) {
  return i.applicationUrls.indexOf(document.location.host) > -1;
});
var logoUrl = brand.length ? brand[0].homepagelogo : 'assets/img/logo-cargillwhite-help.svg';
console.log(logoUrl);
var homepagelogo = logoUrl;
if (logoUrl.toLowerCase().indexOf('https:') === -1 && logoUrl.toLowerCase().indexOf('http:') === -1) {
  homepagelogo = __webpack_require__(753)("./" + logoUrl);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'applicationBrandBar',
  created: function created() {
    var self = this;
    var uid = __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].get('cf-user');
    if (uid !== undefined && uid !== null) {
      var userId = __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].get('cf-user').sub;
      console.log(userId);
    } else {
      self.$router.push({ path: '/LoggingIn' });
    }
    var adminGroupsArr = [];
    var adminAppsArr = [];
    __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].getListOfAdminConfig(apiUrl + '/auth/appGroupList').then(function (response) {
      adminGroupsArr = response.data.map(function (i) {
        return i.groupId;
      });
      adminAppsArr = response.data.map(function (i) {
        return i.applicationId;
      });
      userId = __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].get('cf-user').sub;
      __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].set('adminConfigMaster', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
      __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].set('adminConfigJSON', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(adminGroupsArr));
      __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].set('adminConfigJSONApps', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(adminAppsArr));
      __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].getGroupsByUserId(apiUrl + '/auth/users/' + userId + '/groups').then(function (response) {
        __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].set('grpsOfUser', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
        __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].set('isServiceAccountGroupMember', response.data.filter(function (x) {
          return x.profile.name.toLowerCase().indexOf('service accounts') > -1;
        }).length > 0 ? true : false);
        var isSuperAdmin = false;
        var isAdmin = false;

        var adminToArr = [];
        adminToArr = response.data.filter(function (i) {
          if (adminGroupsArr.indexOf(i.id) > -1) {
            return i;
          }
        });
        for (var w = 0; w < response.data.length; w++) {
          if (response.data[w].id === onecargilladmingroupid) {
            isSuperAdmin = true;
          }
        }
        if (adminToArr.length > 0) {
          isAdmin = true;
        }

        if (isSuperAdmin) {
          self.isAdmin = 'superadmin';
          __WEBPACK_IMPORTED_MODULE_6__store__["default"].commit('setUserRole', 'superadmin');
        } else if (isAdmin) {
          self.isAdmin = 'admin';
          __WEBPACK_IMPORTED_MODULE_6__store__["default"].commit('setUserRole', 'admin');
        } else {
          self.isAdmin = 'notadmin';
          __WEBPACK_IMPORTED_MODULE_6__store__["default"].commit('setUserRole', 'notadmin');
          self.$router.push({ name: 'MyProfile' });
        }
      }).catch(function (err) {
        self.loading = false;
        console.log("create Insert CF Error: ", err);
      });
    }).catch(function (err) {
      console.log(err);
    });
    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
      self.lang = language;
    });
    $(window).resize(function () {
      $('#sidebar').attr('style', '');
      $('.navbar-toggler').attr('style', '');
    });
  },
  mounted: function mounted() {
    $('.internal-logo').attr('src', homepagelogo);
  },

  methods: {
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    oktaSignOut: function oktaSignOut() {
      __WEBPACK_IMPORTED_MODULE_1__helpers_okta__["default"].oktaSignOut();
      __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].clearAll();
    },

    changeUserLang: function changeUserLang(e) {
      __WEBPACK_IMPORTED_MODULE_4__i18n_locale_js__["locale"].lang = e.target.value;
      this.user_lang = this.lang_obj[e.target.value];
      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].$emit('lang', e.target.value);
    },
    openNav: function openNav(e) {
      $('#sidebar').css('display', 'block');

      $('.navbar-toggler').css('display', 'none');
    },
    closeNav: function closeNav(e) {
      if ($('#sidebar').css('display') === 'none' || $('#sidebar').css('display') === '') {
        this.openNav();
      } else {
        $('#sidebar').css('display', 'none');

        $('.navbar-toggler').css('display', 'block');
        $('.main-content').css('padding-top', '25px');
      }
    }
  },
  data: function data() {
    return {
      isCargillBrandPortal: document.location.href.toLowerCase().indexOf('cargill') > -1,
      lang: __WEBPACK_IMPORTED_MODULE_4__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_4__i18n_locale_js__["locale"].lang_obj,
      lang_def: __WEBPACK_IMPORTED_MODULE_4__i18n_locale_js__["locale"].lang_def,
      user_lang: {},
      isAdmin: 'notadmin',
      navItems: [{
        name: 'MyProfile',
        displayName: "MyProfile",
        query: {}
      }],
      adminItem: {
        name: 'Admin',
        displayName: "Administração",
        to: '/Admin'
      },
      tmItem: {
        name: 'TM',
        displayName: "TM",
        to: '/TokenManager'
      },
      apisetItem: {
        name: 'apisetting',
        displayName: "apisetting",
        to: '/APISettings'
      },
      emailLogItem: {
        name: 'emaillogs',
        displayName: "emaillogs",
        to: '/SystemLogs'
      },
      reports: {
        name: 'reports',
        displayName: "reports",
        to: '/Reports'
      },
      HelpItem: {
        name: 'Help',
        displayName: "Help",
        to: '/Help'
      }
    };
  }
});

$(function () {
  $('[data-toggle="tooltip"]').tooltip();
});
$(document).on('click', function () {
  $('.collapse').collapse('hide');
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bowser__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bowser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_locale_js__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NoTopNavFooter',
  data: function data() {
    return {
      lang: __WEBPACK_IMPORTED_MODULE_2__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_2__i18n_locale_js__["locale"].lang_obj,
      badbrowser: false,
      user_lang: {}
    };
  },
  created: function created() {
    var self = this;
    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
    });
    if (__WEBPACK_IMPORTED_MODULE_0_bowser___default.a.msie) {}
    $(window).load(function () {
      $('#exampleModalLong').modal('show');
    });
  },

  methods: {
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_okta__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_storage__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SessionTimeout',
  data: function data() {
    return {
      lang: __WEBPACK_IMPORTED_MODULE_1__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_1__i18n_locale_js__["locale"].lang_obj,
      sessionIntervalID: 0,
      sessionLastActivity: 0,
      sessionDialogOpen: false,

      sessionPollInterval: 1000,

      sessionExpiration: 10,

      sessionWarning: 8,
      user_lang: {}
    };
  },
  created: function created() {
    this.initSessionMonitor();

    var self = this;
    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
    });
  },

  methods: {
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    oktaSignOut: function oktaSignOut() {
      __WEBPACK_IMPORTED_MODULE_2__helpers_okta__["default"].oktaSignOut();
      __WEBPACK_IMPORTED_MODULE_3__helpers_storage__["default"].clearAll();
    },
    initSessionMonitor: function initSessionMonitor() {
      this.sessionLastActivity = new Date();
      this.setSessionPollingInterval();
      this.registerSessionTimeoutEvents(this.sessionEventResponse);
    },
    setSessionPollingInterval: function setSessionPollingInterval() {
      this.sessionIntervalID = setInterval(this.checkSessionInterval, this.sessionPollInterval);
    },
    clearSessionPollingInterval: function clearSessionPollingInterval() {
      clearInterval(this.sessionIntervalID);
    },
    sessionEventResponse: function sessionEventResponse() {
      if (!this.sessionDialogOpen) {
        this.sessionLastActivity = new Date();
      }
    },
    sessionLogout: function sessionLogout() {
      if (!this.sessionDialogOpen) {
        this.oktaSignOut();
      }
    },
    registerSessionTimeoutEvents: function registerSessionTimeoutEvents(eventResponseFunction) {
      var target = document.body;

      target.addEventListener('touchstart', eventResponseFunction, false);

      target.addEventListener('keypress', eventResponseFunction, false);
      target.addEventListener('keyup', eventResponseFunction, false);
      target.addEventListener('keydown', eventResponseFunction, false);

      target.addEventListener('mouseenter', eventResponseFunction, false);
      target.addEventListener('mouseover', eventResponseFunction, false);
      target.addEventListener('mousemove', eventResponseFunction, false);
      target.addEventListener('mousedown', eventResponseFunction, false);
      target.addEventListener('mouseup', eventResponseFunction, false);
      target.addEventListener('click', eventResponseFunction, false);
      target.addEventListener('dblclick', eventResponseFunction, false);
    },
    checkSessionInterval: function checkSessionInterval() {
      var now = new Date();
      var diff = now - this.sessionLastActivity;
      var diffMins = diff / 1000 / 60;
      if (diffMins >= this.sessionWarning) {
        this.clearSessionPollingInterval();
        $('#sessionLogoutModal').modal('show');
        this.sessionDialogOpen = true;
      } else if (diffMins >= this.sessionExpiration) {
        this.sessionLogout();
      }
    },
    clickLogoutYes: function clickLogoutYes() {
      var _this = this;

      $('#sessionLogoutModal').modal('hide');
      this.sessionDialogOpen = false;
      var now = new Date();
      var diff = now - this.sessionLastActivity;
      var diffMins = diff / 1000 / 60;
      if (diffMins >= this.sessionExpiration) {
        $('#logoutMessageModal').modal('show');

        setTimeout(function () {
          _this.sessionLogout();
        }, 1000);
      } else {
        this.setSessionPollingInterval();
        this.sessionLastActivity = new Date();
      }
    },
    clickLogoutNo: function clickLogoutNo() {
      this.sessionDialogOpen = false;
      this.sessionLogout();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer_footer_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_footer_footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header_brandBar_brandBar_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header_brandBar_brandBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_header_brandBar_brandBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bowser__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bowser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_SessionTimeout_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_SessionTimeout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_widgets_SessionTimeout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_locale_js__ = __webpack_require__(8);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TopNavFooter',
  data: function data() {
    return {
      lang: __WEBPACK_IMPORTED_MODULE_5__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_5__i18n_locale_js__["locale"].lang_obj,
      badbrowser: false,
      user_lang: {}
    };
  },
  created: function created() {
    var self = this;
    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
    });
    if (__WEBPACK_IMPORTED_MODULE_2_bowser___default.a.msie) {}
    $(window).load(function () {
      $('#exampleModalLong').modal('show');
    });
  },

  components: {
    ApplicationFooter: __WEBPACK_IMPORTED_MODULE_0__components_footer_footer_vue___default.a,
    ApplicationBrandBar: __WEBPACK_IMPORTED_MODULE_1__components_header_brandBar_brandBar_vue___default.a,
    SessionTimeout: __WEBPACK_IMPORTED_MODULE_3__components_widgets_SessionTimeout_vue___default.a
  },
  methods: {
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_TopNavFooter__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_TopNavFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_widgets_TopNavFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__idm_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_storage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(29);











var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";
var onecargillappid = "0oa10r32yuaNJCfrw0h8";
var brandDetails = "";
var environment = "stage";
if (environment === "production") {
  brandDetails = __webpack_require__(16);
} else if (environment === "stage") {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "tm",
  components: {
    TopNavFooter: __WEBPACK_IMPORTED_MODULE_2__components_widgets_TopNavFooter___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default.a
  },
  created: function created() {
    var self = this;
    self.loading = true;
    self.userId = __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].get("cf-user").sub;
    self.email = __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].get("email");
    this.user_lang = this.lang_br;
    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["EventBus"].$on("lang", function (language) {
      self.user_lang = self.lang_obj[language];
    });
    self.getListOfSuperUserApps();
  },
  mounted: function mounted() {
    var self = this;
    var tempshowDropDown = {};
    for (var i = 0; i < 100; i++) {
      tempshowDropDown[i.toString()] = false;
    }
    self.showDropDown = tempshowDropDown;
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    $("#search-criteria").on("keyup", function () {
      var g = $(this).val().toLowerCase();
      $(".searchbox .list").each(function () {
        var s = $(this).text().toLowerCase();
        console.log(s + '\n' + g);
        $(this).closest('.searchbox')[s.indexOf(g) !== -1 ? 'show' : 'hide']();
      });
    });
    $(document).on("click", "body", function (e) {
      if (!$("div#dropdown").has(e.target).length) {
        var tempshowDropDown = {};
        for (var i = 0; i < 100; i++) {
          tempshowDropDown[i.toString()] = false;
        }
        self.showDropDown = tempshowDropDown;
      }
    });
  },

  watch: {
    appAdminGroupModal: function appAdminGroupModal() {
      this.watchAppAdminGroupModal();
    }
  },
  methods: {
    watchAppAdminGroupModal: function watchAppAdminGroupModal() {
      var self = this;
      console.log("watch");
      if (this.appAdminGroupModal.length === 0) {
        var newRowObj = $.extend(true, {}, self.rowObj);
        self.appAdminGroupModal.push(newRowObj);
      }
    },
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    addAdditionalGroup: function addAdditionalGroup(index, appid) {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getGroupByName(apiUrl + "/auth/groups/search?groupName=" + self.additionalGroup[index]).then(function (response) {
        self.addAdditionalGroupImpl(response, index, appid);
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    addAdditionalGroupImpl: function addAdditionalGroupImpl(response, index, appid) {
      var self = this;

      self.loading = false;
      if (response.data.length === 0) {
        window.alert("Please enter valid group name");
        self.additionalGroup = [];
      } else {
        var fl = self.appsGroups[appid].filter(function (x) {
          return x.id === response.data[0].id;
        });
        if (fl.length === 0) {
          var indieSubGroupEntry = response.data[0].id + "~~~" + response.data[0].profile.name;
          self.appAdminGroupModal[index].subGroupId.push(indieSubGroupEntry.trim());
          self.tempAppAdminGroupModal = [];
          self.appAdminGroupModal.forEach(function (x, index) {
            self.tempAppAdminGroupModal[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, x);
          });
          self.additionalGroup = [];
        } else {
          window.alert("Please select this group from the dropdown");
          self.additionalGroup = [];
        }
      }
    },
    checkchange: function checkchange(e) {
      console.log(e);
      var self = this;
      var grpid = e.target.id.split("~")[0];
      var idx = e.target.id.split("~")[1];
      var grpname = e.target.value;
      if (self.appAdminGroupModal[idx].subGroupId === undefined) {
        self.appAdminGroupModal[idx]["subGroupId"] = [];
      }
      if (e.target.checked && self.appAdminGroupModal[idx].subGroupId.indexOf(grpid) === -1) {
        self.appAdminGroupModal[idx].subGroupId.push(grpid + '~~~' + grpname);
      } else {
        self.appAdminGroupModal[idx].subGroupId = self.appAdminGroupModal[idx].subGroupId.filter(function (e) {
          return e.indexOf(grpid) === -1;
        });
        self.openDropDown(idx);
      }
    },
    openDropDown: function openDropDown(index) {
      var self = this;
      self.showDropDown[index.toString()] = !self.showDropDown[index.toString()];
      if (self.appAdminGroupModal[index].subGroupId === undefined) {
        self.appAdminGroupModal[index]["subGroupId"] = [];
      }
      for (var i = 0; i < self.appAdminGroupModal[index].subGroupId.length; i++) {
        var sel = "";
        if (self.appAdminGroupModal[index].subGroupId[i].indexOf("~~~") > -1) {
          sel = ".ddwrap" + index + ' [id^="' + self.appAdminGroupModal[index].subGroupId[i].split("~~~")[0] + '"]';
        } else {
          sel = ".ddwrap" + index + ' [id^="' + self.appAdminGroupModal[index].subGroupId[i] + '"]';
        }
        $(sel).prop("checked", true);
      }
    },
    getListOfClientId: function getListOfClientId() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getClientIds(apiUrl + "/apitokenList", self.email).then(function (response) {
        self.loading = false;
        self.clientList = response.data;
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    getListOfSuperUserApps: function getListOfSuperUserApps() {
      var self = this;
      self.clearMessages();
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getListOfSuperUserApps(apiUrl + "/auth/apps", self.email).then(function (response) {
        self.loading = false;
        self.appList = response.data;
        self.appList.sort(function (a, b) {
          return a.label.toLowerCase() > b.label.toLowerCase() ? 1 : b.label.toLowerCase() > a.label.toLowerCase() ? -1 : 0;
        });
        self.getConfigList();
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    changeView: function changeView() {
      var self = this;
      if (self.isNewAppConfig) {
        self.tempAppAdminGroupModal = [];
        self.appAdminGroupModal = self.appAdminGroupModal.slice(0, self.appAdminGroupModal.length - 1);
        self.appAdminGroupModal.forEach(function (x, index) {
          self.tempAppAdminGroupModal[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, x);
        });
        self.applicationIndex = 0;
        self.isNewAppConfig = false;
      }
      self.showAppList = true;
    },
    changeToAppView: function changeToAppView() {
      var self = this;
      self.applicationIndex = self.appAdminGroupModal.length - 1;
      self.showAppList = false;
    },
    getApplicationGroups: function getApplicationGroups(id, index) {
      var self = this;
      self.applicationIndex = index;
      self.showAppList = false;
      self.getGroups(id);
    },
    getGroups: function getGroups(id) {
      var self = this;
      self.clearMessages();
      if (self.appsGroups[id] === undefined && id !== "undefined" && id !== undefined) {
        self.loading = true;
        __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getGroupsByAppId(apiUrl + "/auth/apps/" + id + "/groups").then(function (response) {
          self.loading = false;
          var gmap = response.data.map(function (x) {
            return x.id;
          });
          __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].set(self.appGroupsArrayMap, id, gmap);
          __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].set(self.appsGroups, id, response.data.sort(function (a, b) {
            return a._embedded.group.profile.name.toLowerCase() > b._embedded.group.profile.name.toLowerCase() ? 1 : b._embedded.group.profile.name.toLowerCase() > a._embedded.group.profile.name.toLowerCase() ? -1 : 0;
          }));
          console.log('Apps Groups', self.appsGroups);
          console.log('Apps Groups Array Map', self.appGroupsArrayMap);
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    addConfigRow: function addConfigRow() {
      var self = this;
      self.clearMessages();
      var newRowObj = $.extend(true, {}, self.rowObj);
      self.appAdminGroupModal.push(newRowObj);
      self.tempAppAdminGroupModal.push(newRowObj);
      self.isNewAppConfig = true;
    },
    getNamesOfApp: function getNamesOfApp() {
      var self = this;
      self.appNameList = [];
      self.appAdminGroupModal.forEach(function (x, index) {
        self.appNameList[index] = self.appList.filter(function (y) {
          return y.id === x.applicationId;
        })[0];
      });
      console.log(self.appNameList);
    },
    getConfigList: function getConfigList() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getListOfAdminConfig(apiUrl + "/auth/apiconfig/appGroupList").then(function (response) {
        self.loading = false;
        self.appAdminGroupModal = response.data;
        self.tempAppAdminGroupModal = [];
        self.appAdminGroupModal.forEach(function (x, index) {
          self.tempAppAdminGroupModal[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, x);
        });
        self.getNamesOfApp();

        console.log('App Admin Group Modal', self.appAdminGroupModal);
      }).catch(function (err) {
        console.log(err);
      });
    },
    saveAdminGroups: function saveAdminGroups() {
      var self = this;
      self.clearMessages();
      if (self.isNewAppConfig) {
        self.isNewAppConfig = false;
      }
      self.loading = true;
      var filteredList = self.appAdminGroupModal[self.applicationIndex];
      if (filteredList.brand === 'undefined' || filteredList.brand === undefined || filteredList.subGroupId && filteredList.subGroupId.length === 0) {
        self.isIncomplete = true;
      }
      if (!self.isIncomplete) {
        __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].addToAdminConfigDB(apiUrl + "/auth/apiconfig/appGroup", [filteredList]).then(function (response) {
          self.loading = false;
          self.updateAdminConfigsInLocal();
          if (response.data.status.statusCode === "500") {
            self.getConfigList();
            window.alert(response.data.status.status);
          } else {
            setTimeout(function () {
              self.getConfigList();
              self.saveSuccess = true;
              self.showAppList = true;
              self.applicationIndex = 0;
            }, 500);
          }
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        self.loading = false;
      }
    },
    populateOptionDetails: function populateOptionDetails(appId, index) {
      var self = this;
      self.clearMessages();
      self.appsGroups[appId].some(function (i) {
        if (i.id === self.appAdminGroupModal[index].groupId) {
          self.appAdminGroupModal[index].groupId = i._embedded.group.id;
          return true;
        }
      });
    },
    removeRow: function removeRow(appgrpId, index, gn) {
      var self = this;
      self.currRemoveId = appgrpId;
      self.currRemoveIndex = index;
      if (gn === onecargillappid) {
        self.clearMessages();
        $(".cannotDeleteModal").modal("show");
      } else {
        self.clearMessages();
        $(".deleteConfirmModal").modal("show");
      }
    },
    removeConfirm: function removeConfirm() {
      var self = this;
      self.loading = true;
      self.appAdminGroupModal.splice(self.currRemoveIndex, 1);
      self.appNameList.splice(self.currRemoveIndex, 1);
      var data = { appGrpId: self.currRemoveId };

      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].deleteAdminConfig(apiUrl + "/auth/apiconfig/appGroup", data).then(function (response) {
        self.loading = false;
        self.applicationIndex = 0;
        $(".deleteConfirmModal").modal("hide");
        self.deleteSuccess = true;
        self.updateAdminConfigsInLocal();
        self.getConfigList();
      }).catch(function (err) {
        console.log(err);
      });
    },
    cancelRemove: function cancelRemove() {
      $(".deleteConfirmModal").modal("hide");
    },
    clearMessages: function clearMessages() {
      var self = this;
      self.isIncomplete = false;
      self.saveSuccess = false;
      self.deleteSuccess = false;
    },
    isAlreadyConfiged: function isAlreadyConfiged(id) {
      var self = this;
      var listOfConfigedApps = self.appAdminGroupModal.map(function (i) {
        return i.applicationId;
      });
      return id === onecargillappid && listOfConfigedApps.indexOf(id) > -1;
    },
    updateAdminConfigsInLocal: function updateAdminConfigsInLocal() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getListOfAdminConfig(apiUrl + "/auth/apiconfig/appGroupList").then(function (response) {
        self.getNamesOfApp();
        self.persistInLocal(response);
      }).catch(function (err) {
        console.log(err);
      });
    },
    persistInLocal: function persistInLocal(response) {
      var adminGroupsArr = [];
      var adminAppsArr = [];
      adminGroupsArr = response.data.map(function (i) {
        return i.groupId;
      });
      adminAppsArr = response.data.map(function (i) {
        return i.applicationId;
      });
      __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].set("adminConfigMaster", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
      __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].set("adminConfigJSON", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(adminGroupsArr));
      __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].set("adminConfigJSONApps", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(adminAppsArr));
    }
  },
  data: function data() {
    return {
      brandDetails: brandDetails,
      additionalGroup: [],
      appNameList: [],
      showDropDown: {
        "0": false,
        "1": false,
        "2": false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false
      },
      lang: __WEBPACK_IMPORTED_MODULE_5__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_5__i18n_locale_js__["locale"].lang_obj,
      userId: "",
      loading: false,
      user_lang: {},
      prefLang: "en_US",
      email: "",
      clientList: [],
      appList: [],
      appsGroups: {},
      appGroupsArrayMap: {},
      modalObj: {},
      selectModel: {},
      optionModel: {},
      appAdminGroupModal: [{
        applicationId: "undefined",
        brand: "cargill",
        groupId: "",
        subGroupId: []
      }],
      rowObj: {
        applicationId: "undefined",
        brand: "cargill",
        groupId: "",
        subGroupId: []
      },
      isIncomplete: false,
      saveSuccess: false,
      deleteSuccess: false,
      currRemoveId: "",
      currRemoveIndex: "",
      showAppList: true,
      applicationIndex: 0,
      isNewAppConfig: false,
      tempAppAdminGroupModal: [{
        applicationId: "undefined",
        brand: "cargill",
        groupId: "",
        subGroupId: []
      }]
    };
  },

  computed: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_widgets_TopNavFooter__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_widgets_TopNavFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_widgets_TopNavFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__idm_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_storage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(29);










var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";
var onecargillappid = "0oa10r32yuaNJCfrw0h8";
var brandDetails = "";
var environment = "stage";
if (environment === 'production') {
  brandDetails = __webpack_require__(16);
} else if (environment === 'stage') {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tm',
  components: {
    TopNavFooter: __WEBPACK_IMPORTED_MODULE_1__components_widgets_TopNavFooter___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner___default.a
  },
  created: function created() {
    var self = this;
    self.loading = true;
    self.userId = __WEBPACK_IMPORTED_MODULE_6__helpers_storage__["default"].get('cf-user').sub;
    self.email = __WEBPACK_IMPORTED_MODULE_6__helpers_storage__["default"].get('email');
    this.user_lang = this.lang_br;
    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_5__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
    });
    self.getListOfSuperUserApps();
  },
  mounted: function mounted() {
    var self = this;
    var tempshowDropDown = {};
    for (var i = 0; i < 100; i++) {
      tempshowDropDown[i.toString()] = false;
    }
    self.showDropDown = tempshowDropDown;
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    $(document).on('click', 'body', function (e) {
      if (!$('div#dropdown').has(e.target).length) {
        var tempshowDropDown = {};
        for (var i = 0; i < 100; i++) {
          tempshowDropDown[i.toString()] = false;
        }
        self.showDropDown = tempshowDropDown;
      }
    });
  },

  watch: {
    appAdminGroupModal: function appAdminGroupModal() {
      this.watchAppAdminGroupModal();
    }
  },
  methods: {
    watchAppAdminGroupModal: function watchAppAdminGroupModal() {
      var self = this;
      console.log('watch');
      if (this.appAdminGroupModal.length === 0) {
        var newRowObj = $.extend(true, {}, self.rowObj);
        self.appAdminGroupModal.push(newRowObj);
      }
    },
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    addAdditionalGroup: function addAdditionalGroup(index, appid) {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].getGroupByName(apiUrl + '/auth/groups/search?groupName=' + self.additionalGroup[index]).then(function (response) {
        self.addAdditionalGroupImpl(response, index, appid);
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    addAdditionalGroupImpl: function addAdditionalGroupImpl(response, index, appid) {
      var self = this;

      self.loading = false;
      if (response.data.length === 0) {
        window.alert('Please enter valid group name');
        self.additionalGroup = [];
      } else {
        var fl = self.appsGroups[appid].filter(function (x) {
          return x.id === response.data[0].id;
        });
        if (fl.length === 0) {
          var indieSubGroupEntry = response.data[0].id + '~~~' + response.data[0].profile.name;
          self.appAdminGroupModal[index].subGroupId.push(indieSubGroupEntry.trim());
          self.additionalGroup = [];
        } else {
          window.alert('Please select this group from the dropdown');
          self.additionalGroup = [];
        }
      }
    },
    checkchange: function checkchange(e) {
      console.log(e);
      var self = this;
      var grpid = e.target.id.split('~')[0];
      var idx = e.target.id.split('~')[1];
      if (self.appAdminGroupModal[idx].subGroupId === undefined) {
        self.appAdminGroupModal[idx]['subGroupId'] = [];
      }
      if (e.target.checked && self.appAdminGroupModal[idx].subGroupId.indexOf(grpid) === -1) {
        self.appAdminGroupModal[idx].subGroupId.push(grpid);
      } else {
        self.appAdminGroupModal[idx].subGroupId = self.appAdminGroupModal[idx].subGroupId.filter(function (e) {
          return e.indexOf(grpid) === -1;
        });
      }
    },
    openDropDown: function openDropDown(index) {
      var self = this;
      self.showDropDown[index.toString()] = !self.showDropDown[index.toString()];
      if (self.appAdminGroupModal[index].subGroupId === undefined) {
        self.appAdminGroupModal[index]['subGroupId'] = [];
      }
      for (var i = 0; i < self.appAdminGroupModal[index].subGroupId.length; i++) {
        var sel = '';
        if (self.appAdminGroupModal[index].subGroupId[i].indexOf('~~~') > -1) {
          sel = '.ddwrap' + index + ' [id^="' + self.appAdminGroupModal[index].subGroupId[i].split('~~~')[0] + '"]';
        } else {
          sel = '.ddwrap' + index + ' [id^="' + self.appAdminGroupModal[index].subGroupId[i] + '"]';
        }
        $(sel).attr('checked', true);
      }
    },
    getListOfClientId: function getListOfClientId() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].getClientIds(apiUrl + '/apitokenList', self.email).then(function (response) {
        self.loading = false;
        self.clientList = response.data;
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    getListOfSuperUserApps: function getListOfSuperUserApps() {
      var self = this;
      self.clearMessages();
      __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].getListOfSuperUserApps(apiUrl + '/auth/apps', self.email).then(function (response) {
        self.loading = false;
        self.appList = response.data;
        self.appList.sort(function (a, b) {
          return a.label.toLowerCase() > b.label.toLowerCase() ? 1 : b.label.toLowerCase() > a.label.toLowerCase() ? -1 : 0;
        });
        self.getConfigList();
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    getGroups: function getGroups(id) {
      var self = this;
      self.clearMessages();
      if (self.appsGroups[id] === undefined && id !== 'undefined' && id !== undefined) {
        self.loading = true;
        __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].getGroupsByAppId(apiUrl + '/auth/apps/' + id + '/groups').then(function (response) {
          self.loading = false;
          var gmap = response.data.map(function (x) {
            return x.id;
          });
          __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].set(self.appGroupsArrayMap, id, gmap);
          __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].set(self.appsGroups, id, response.data.sort(function (a, b) {
            return a._embedded.group.profile.name.toLowerCase() > b._embedded.group.profile.name.toLowerCase() ? 1 : b._embedded.group.profile.name.toLowerCase() > a._embedded.group.profile.name.toLowerCase() ? -1 : 0;
          }));
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    addConfigRow: function addConfigRow() {
      var self = this;
      self.clearMessages();
      var newRowObj = $.extend(true, {}, self.rowObj);
      self.appAdminGroupModal.push(newRowObj);
    },
    getConfigList: function getConfigList() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].getListOfAdminConfig(apiUrl + '/auth/apiconfig/appGroupList').then(function (response) {
        self.loading = false;
        self.appAdminGroupModal = response.data;
        if (self.appAdminGroupModal.length > 0) {
          self.appAdminGroupModal.map(function (i) {
            self.getGroups(i.applicationId);
          });
        } else {
          self.addConfigRow();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    saveAdminGroups: function saveAdminGroups() {
      var self = this;
      self.clearMessages();
      self.loading = true;
      var filteredList = self.appAdminGroupModal.filter(function (i) {
        return i.applicationId !== 'undefined' && i.applicationId !== undefined;
      });
      self.isIncomplete = filteredList.some(function (i) {
        if (i.brand === 'undefined' || i.brand === undefined || i.subGroupId && i.subGroupId.length === 0) {
          return true;
        }
      });
      if (!self.isIncomplete) {
        __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].addToAdminConfigDB(apiUrl + '/auth/apiconfig/appGroup', filteredList).then(function (response) {
          self.loading = false;
          self.getConfigList();
          self.updateAdminConfigsInLocal();
          if (response.data.status.statusCode === "500") {
            window.alert(response.data.status.status);
          } else {
            setTimeout(function () {
              self.saveSuccess = true;
            }, 500);
          }
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        self.loading = false;
      }
    },
    populateOptionDetails: function populateOptionDetails(appId, index) {
      var self = this;
      self.clearMessages();
      self.appsGroups[appId].some(function (i) {
        if (i.id === self.appAdminGroupModal[index].groupId) {
          self.appAdminGroupModal[index].groupId = i._embedded.group.id;
          return true;
        }
      });
    },
    removeRow: function removeRow(appgrpId, index, gn) {
      var self = this;
      self.currRemoveId = appgrpId;
      self.currRemoveIndex = index;
      if (gn === onecargillappid) {
        self.clearMessages();
        $('.cannotDeleteModal').modal('show');
      } else {
        self.clearMessages();
        $('.deleteConfirmModal').modal('show');
      }
    },
    removeConfirm: function removeConfirm() {
      var self = this;
      self.loading = true;
      self.appAdminGroupModal.splice(self.currRemoveIndex, 1);
      var data = { "appGrpId": self.currRemoveId };

      __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].deleteAdminConfig(apiUrl + '/auth/apiconfig/appGroup', data).then(function (response) {
        self.loading = false;
        $('.deleteConfirmModal').modal('hide');
        self.deleteSuccess = true;
        self.updateAdminConfigsInLocal();
      }).catch(function (err) {
        console.log(err);
      });
    },
    cancelRemove: function cancelRemove() {
      $('.deleteConfirmModal').modal('hide');
    },
    clearMessages: function clearMessages() {
      var self = this;
      self.isIncomplete = false;
      self.saveSuccess = false;
      self.deleteSuccess = false;
    },
    isAlreadyConfiged: function isAlreadyConfiged(id) {
      var self = this;
      var listOfConfigedApps = self.appAdminGroupModal.map(function (i) {
        return i.applicationId;
      });
      return id === onecargillappid && listOfConfigedApps.indexOf(id) > -1;
    },
    updateAdminConfigsInLocal: function updateAdminConfigsInLocal() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].getListOfAdminConfig(apiUrl + '/auth/apiconfig/appGroupList').then(function (response) {
        self.persistInLocal(response);
      }).catch(function (err) {
        console.log(err);
      });
    },
    persistInLocal: function persistInLocal(response) {
      var adminGroupsArr = [];
      var adminAppsArr = [];
      adminGroupsArr = response.data.map(function (i) {
        return i.groupId;
      });
      adminAppsArr = response.data.map(function (i) {
        return i.applicationId;
      });
      __WEBPACK_IMPORTED_MODULE_6__helpers_storage__["default"].set('adminConfigMaster', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
      __WEBPACK_IMPORTED_MODULE_6__helpers_storage__["default"].set('adminConfigJSON', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(adminGroupsArr));
      __WEBPACK_IMPORTED_MODULE_6__helpers_storage__["default"].set('adminConfigJSONApps', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(adminAppsArr));
    }
  },
  data: function data() {
    return {
      brandDetails: brandDetails,
      additionalGroup: [],
      showDropDown: { "0": false, "1": false, "2": false, "3": false, "4": false, "5": false, "6": false, "7": false, "8": false, "9": false, "10": false },
      lang: __WEBPACK_IMPORTED_MODULE_4__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_4__i18n_locale_js__["locale"].lang_obj,
      userId: '',
      loading: false,
      user_lang: {},
      prefLang: 'en_US',
      email: '',
      clientList: [],
      appList: [],
      appsGroups: {},
      appGroupsArrayMap: {},
      modalObj: {},
      selectModel: {},
      optionModel: {},
      appAdminGroupModal: [{ "applicationId": "undefined", "brand": "cargill", "groupId": "", "subGroupId": [] }],
      rowObj: { "applicationId": "undefined", "brand": "cargill", "groupId": "", "subGroupId": [] },
      isIncomplete: false,
      saveSuccess: false,
      deleteSuccess: false,
      currRemoveId: '',
      currRemoveIndex: ''
    };
  },

  computed: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_TopNavFooter__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_TopNavFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_TopNavFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_blob__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_UserTable__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_UserTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_UserTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__idm_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_storage__ = __webpack_require__(5);



















var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";
var serviceAccountGroupId = "00ggpp1iegUC0PZjc0h7";
var internalUserDomains = __webpack_require__(78).data;
var onecargilladmingroupid = "00gf4o186i1L3hcDw0h7";
var onecargillapplicationgroupid = "00gf1pyoc1uSmFbNl0h7";
var onecargillappid = "0oa10r32yuaNJCfrw0h8";

var environment = "stage";
var brandDetails = "";
console.log("env=====", environment);
if (environment === "production") {
  brandDetails = __webpack_require__(16);
} else if (environment === "stage") {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "admin",
  components: {
    TopNavFooter: __WEBPACK_IMPORTED_MODULE_6__components_widgets_TopNavFooter___default.a,
    UserTable: __WEBPACK_IMPORTED_MODULE_8__components_UserTable___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_10__components_Spinner___default.a
  },
  created: function created() {
    var self = this;
    this.user_lang = this.lang_br;
    self.loading = false;
    self.loggedInUser = __WEBPACK_IMPORTED_MODULE_14__helpers_storage__["default"].get("email");
    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_12__event_bus_js__["EventBus"].$on("lang", function (language) {
      self.user_lang = self.lang_obj[language];
    });
    var uid = __WEBPACK_IMPORTED_MODULE_14__helpers_storage__["default"].get("cf-user");
    if (uid !== undefined && uid !== null) {
      var userId = __WEBPACK_IMPORTED_MODULE_14__helpers_storage__["default"].get("cf-user").sub;
      console.log(userId);
    } else {
      self.$router.push({ path: "/LoggingIn" });
    }
  },
  mounted: function mounted() {
    var self = this;
    $(document).ready(function () {
      $("body").tooltip({
        animation: false,
        selector: "[data-toggle=tooltip]"
      });
    });
    userId = __WEBPACK_IMPORTED_MODULE_14__helpers_storage__["default"].get("cf-user").sub;

    self.indieGroupsAdministered = [];
    var userId = __WEBPACK_IMPORTED_MODULE_14__helpers_storage__["default"].get("cf-user").sub;
    __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getGroupsByUserId(apiUrl + "/auth/users/" + userId + "/groups").then(function (response) {
      response.data.forEach(function (x) {
        self.userGroups.push(x.id);
      });
      __WEBPACK_IMPORTED_MODULE_14__helpers_storage__["default"].set("grpsOfUser", __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(response.data));
      self.getAppGroupConfigData();
      __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getListOfAdminConfig(apiUrl + "/auth/appGroupListNew").then(function (response) {
        self.filterApp();
      }).catch(function (err) {
        console.log(err);
      });
    }).catch(function (err) {
      self.loading = false;
      console.log("create Insert CF Error: ", err);
    });
    self.eventHandlers();
  },

  methods: {
    downloadReport: function downloadReport() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].downloadReport(apiUrl + "/auth/report/" + self.selectedGroupId).then(function (response) {
        var blob = new __WEBPACK_IMPORTED_MODULE_7_blob__["a" /* default */]([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;" });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Report.xlsx";
        self.loading = false;
        link.click();
      }).catch(function (error) {
        window.alert(error);
        self.loading = false;
      });
    },
    disableAvailableGroups: function disableAvailableGroups(isDisabled) {
      return isDisabled ? this.user_lang.readOnlyGroup : false;
    },
    disableSelectedGroups: function disableSelectedGroups(isDisabled, id) {
      return isDisabled ? this.user_lang.readOnlyGroup : !this.checkSubGroupAllowed(id) ? this.user_lang.adminPermissionDenied : false;
    },
    disableSelectedIndieGroups: function disableSelectedIndieGroups(id) {
      return !this.checkSubGroupAllowed(id) ? this.user_lang.adminPermissionDenied : false;
    },
    disableSelectedGroupsOutsideAdmin: function disableSelectedGroupsOutsideAdmin(id) {
      return !this.checkSubGroupAllowed(id) ? this.user_lang.adminPermissionDenied : false;
    },
    getAppGroupConfigData: function getAppGroupConfigData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getAppGroupConfigData(apiUrl + "/auth/fetchUserApps", self.userGroups).then(function (response) {
        console.log(response);
        self.adminConfigFiltered = response.data;
        self.getGroupData();
        if (response.data.length > 0) {
          self.selectedApplication = response.data[0];
          self.selectedAppId = response.data[0].applicationId;
          self.subGroups = response.data[0].subGroupManagement;
          self.selectedGroupId = response.data[0].subGroupManagement[0].subGroupId;
          console.log(self.selectedGroupId);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getGroupData: function getGroupData() {
      var self = this;
      var brands = [];
      self.adminConfigFiltered.forEach(function (app) {
        var appPresent = self.uniqueAppsFiltered.find(function (x) {
          return x.applicationId === app.applicationId;
        });
        if (!appPresent) {
          self.uniqueAppsFiltered.push(app);
        }
        brands.push(app.brand);
        self.adminTo.push(app.applicationId);
        app.subGroupManagement.forEach(function (groups) {
          if (appPresent) {
            if (appPresent.subGroupManagement.some(function (x) {
              return x.subGroupId === groups.subGroupId;
            })) {
              var readOnly = self.uniqueAppsFiltered.find(function (x) {
                return x.applicationId === app.applicationId;
              }).subGroupManagement.find(function (grp) {
                return grp.subGroupId === groups.subGroupId;
              }).isReadOnly;
              self.uniqueAppsFiltered.find(function (x) {
                return x.applicationId === app.applicationId;
              }).subGroupManagement.find(function (grp) {
                return grp.subGroupId === groups.subGroupId;
              }).isReadOnly = groups.isReadOnly || readOnly;
            } else {
              self.uniqueAppsFiltered.find(function (x) {
                return x.applicationId === app.applicationId;
              }).subGroupManagement.push(groups);
            }
          }
          var obj = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(groups);
          obj.applicationId = app.applicationId;
          obj.applicationName = app.applicationName;
          self.adminAppsArray.push(obj);
        });
      });
      self.adminToBrands = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(brands)));
      console.log(self.uniqueAppsFiltered);
    },
    eventResetSuccess: function eventResetSuccess() {
      var self = this;
      self.removeAllNotifications();
      self.resetSuccess = true;
      $("html, body").animate({ scrollTop: 0 }, "fast");
    },
    eventUpdateToggle: function eventUpdateToggle(arr) {
      var self = this;
      window.scrollTo(0, 0);
      self.indieGroupsForNewUser = [];
      self.indieGroupsAdministered = __WEBPACK_IMPORTED_MODULE_14__helpers_storage__["default"].get("MasterIndependentGroupsAdministered");
      self.removeAllNotifications();
      self.clearAddUserFields();
      self.updateToggle = true;
      self.addUserFirstName = arr[0];
      self.addUserLastName = arr[1];
      self.addUserPrimaryEmail = self.reverseTransformEmail(arr[2]);
      if (self.addUserPrimaryEmail.toLowerCase().indexOf("@identity.mycargill.com") > 0 || self.addUserPrimaryEmail.toLowerCase().indexOf("@whitelabel.cargill.com") > -1 || self.addUserPrimaryEmail.toLowerCase().indexOf("@partneridentity.okta-emea.com") > -1) {
        var bcode = self.addUserPrimaryEmail.substring(2, 5);
        self.brand = brandDetails.data.filter(function (n) {
          return n.brandCode === bcode;
        })[0].brandName.toLowerCase();
      } else {
        self.brand = "cargill";
      }
      self.editUserId = arr[3];
      self.isAzureORInternalIdentities = arr[4];
      self.isEdit = arr[5];
      self.initiateUpdateUserView(arr[3]);
      self.getFactorsOfUser(arr[3]);
    },
    reverseTransformEmail: function reverseTransformEmail(em) {
      if (em.toLowerCase().indexOf("@identity.mycargill.com") > -1 || em.toLowerCase().indexOf("@whitelabel.cargill.com") > -1 || em.toLowerCase().indexOf("@partneridentity.okta-emea.com") > -1) {
        em = em.substring(5, em.indexOf("@")).substring(0, em.substr(0, 2) - 1) + "@" + em.substring(5, em.indexOf("@")).substring(em.substr(0, 2) - 1);
      }
      return em;
    },
    eventSearchCleared: function eventSearchCleared(arr) {
      var self = this;
      self.loading = true;
      setTimeout(function () {
        self.selectedGroupId = self.uniqueAppsFiltered.find(function (app) {
          return app.applicationId === self.selectedAppId;
        }).subGroupManagement[0].subGroupId;

        console.log("selected group initial" + self.selectedGroupId);
        self.loading = false;
      }, 2000);
    },
    eventDeactivateSuccess: function eventDeactivateSuccess(email) {
      var self = this;
      self.removeAllNotifications();
      self.deactivateSuccess = true;
      self.activatedemail = email;
      $("html, body").animate({ scrollTop: 0 }, "fast");
    },
    eventActivateSuccess: function eventActivateSuccess(email) {
      var self = this;
      self.removeAllNotifications();
      self.activateSuccess = true;
      self.activatedemail = email;
      $("html, body").animate({ scrollTop: 0 }, "fast");
    },
    eventDeleteSuccess: function eventDeleteSuccess(email) {
      var self = this;
      self.removeAllNotifications();
      self.deleteSuccess = true;
      self.activatedemail = email;
      $("html, body").animate({ scrollTop: 0 }, "fast");
    },
    eventCheckbox: function eventCheckbox(e) {
      var self = this;
      self.userCreationMessage = "";
      $("#userCreationMessage").removeClass("success-bg").removeClass("error-bg");
      self.addUserGroupIds = [];
      var id = Number(e.target.id);
      var currObj = self.uniqueAppsFiltered.find(function (y) {
        return y.appGrpId === id;
      });
      if (e.target.checked) {
        currObj.subGroupManagement.forEach(function (currGrp) {
          if (self.selectedgroups.some(function (group) {
            return currGrp.subGroupId.indexOf(group.subGroupId) > -1;
          })) {
            return;
          }
          if (currGrp.subGroupId.indexOf("~~~") > -1) {
            self.indieGroupsForNewUser.push(currGrp);
          } else {
            currGrp.applicationId = currObj.applicationId;
            currGrp.applicationName = currObj.applicationName;
            self.availablegroups.push(currGrp);
          }
        });
      } else {
        currObj.subGroupManagement.forEach(function (currGrp) {
          self.availablegroups = self.availablegroups.filter(function (grp) {
            return grp.subGroupId !== currGrp.subGroupId;
          });
          self.indieGroupsForNewUser = self.indieGroupsForNewUser.filter(function (grp) {
            return grp.subGroupId !== currGrp.subGroupId;
          });
        });
      }
      var textinputs = document.querySelectorAll(".input-checkbx");
      var empty = [].filter.call(textinputs, function (el) {
        return el.checked;
      });
      if (empty.length === 0) {
        self.checkedAppBrand = "";
        self.brand = "";
      } else {
        var app = self.uniqueAppsFiltered.find(function (x) {
          return x.appGrpId === id;
        });
        self.checkedAppBrand = app ? app.brand : "cargill";
        self.brand = self.checkedAppBrand.toLowerCase();
      }
    },
    eventSelect: function eventSelect(e) {
      var self = this;
      self.userCreationMessage = "";
      $("#userCreationMessage").removeClass("success-bg").removeClass("error-bg");
    },
    eventInput: function eventInput(e) {
      var self = this;
      self.userCreationMessage = "";
      $("#userCreationMessage").removeClass("success-bg").removeClass("error-bg");
    },
    eventBody: function eventBody(e) {
      var self = this;
      if (!$("div#dropdown").has(e.target).length) {
        self.showDropDown = false;
      }
    },
    eventAdminLink: function eventAdminLink(e) {
      var self = this;
      self.goToUserManagement();
    },
    eventTimeout: function eventTimeout() {
      var self = this;
      var app = self.uniqueAppsFiltered.find(function (x) {
        return self.selectedAppId === x.applicationId;
      });
      if (app) {
        self.selectedGroupId = app.subGroupManagement[0].subGroupId;
      } else {
        self.selectedGroupId = '';
      }
    },
    eventHandlers: function eventHandlers() {
      var self = this;
      self.$root.$on("resetsuccess", function () {
        self.eventResetSuccess();
      });
      self.$root.$on("updatetoggle", function (arr) {
        self.eventUpdateToggle(arr);
      });
      self.$root.$on("searchcleared", function (arr) {
        self.eventSearchCleared(arr);
      });
      self.$root.$on("deactivatesuccess", function (email) {
        self.eventDeactivateSuccess(email);
      });
      self.$root.$on("activatesuccess", function (email) {
        self.eventActivateSuccess(email);
      });
      self.$root.$on("deletesuccess", function (email) {
        self.eventDeleteSuccess(email);
      });

      $(document).on("change", ".input-checkbx", function (e) {
        self.eventCheckbox(e);
      });
      $(document).on("change", "select", function (e) {
        self.eventSelect(e);
      });
      $(document).on("input", "input", function (e) {
        self.eventInput(e);
      });
      $(document).on("click", "body", function (e) {
        self.eventBody(e);
      });
      $(document).on("click", "#adminLink", function (e) {
        self.eventAdminLink(e);
      });
      setTimeout(function () {
        self.eventTimeout();
      }, 2000);
    },
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    checkSubGroupAllowed: function checkSubGroupAllowed(id) {
      var self = this;
      return self.adminAppsArray.some(function (grp) {
        return grp.subGroupId === id;
      });
    },
    storeCustomerTaxId: function storeCustomerTaxId() {
      this.$store.commit("setCustomerTaxId", this.customerTaxId);
    },

    filterApp: function filterApp(e) {
      var self = this;
      if (!e) {
        return;
      }
      console.log(e);
      self.loading = true;
      var id = +$("#selectApp option:selected").attr("id");
      console.log(id);
      setTimeout(function () {
        self.subGroups = self.uniqueAppsFiltered.filter(function (config) {
          return config.appGrpId === id;
        })[0].subGroupManagement;
        self.selectedGroupId = self.subGroups[0].subGroupId;
        self.loading = false;
      }, 2000);
    },
    filterGroup: function filterGroup(e) {},
    validEmail: function validEmail(email) {
      var re = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(email);
    },
    validateAddUser: function validateAddUser(e) {
      var self = this;
      this.addUserValidations = [];
      if (!this.addUserFirstName) {
        this.addUserValidations.push(self.user_lang["firstnamereq"]);
        $("html, body").animate({ scrollTop: 0 }, "fast");
      } else if (!this.addUserLastName) {
        this.addUserValidations.push(self.user_lang["lastnamereq"]);
        $("html, body").animate({ scrollTop: 0 }, "fast");
      } else if (!this.addUserPrimaryEmail) {
        this.addUserValidations.push(self.user_lang["emailreq"]);
        $("html, body").animate({ scrollTop: 0 }, "fast");
      } else if (!this.validEmail(this.addUserPrimaryEmail)) {
        this.addUserValidations.push(self.user_lang["emailinvalid"] + ". Must match valid email pattern. Allowed characters are alphabets, numbers and any of the following special characters- !, #, $, %, &, ', *, +, =, /, ?, ^, _, {, |, }, ~, -");
        $("html, body").animate({ scrollTop: 0 }, "fast");
      } else if (document.location.hostname.indexOf("jsicustomer") === -1 && internalUserDomains.filter(function (x) {
        return x.toLowerCase().indexOf(self.addUserPrimaryEmail.split('@')[1].toLowerCase()) > -1;
      }).length > 0) {
        this.addUserValidations.push(self.user_lang["emailinvaliddomain"]);
        $("html, body").animate({ scrollTop: 0 }, "fast");
      } else if (this.addUserSecondaryEmail.trim() !== "" && !this.validEmail(this.addUserSecondaryEmail)) {
        this.addUserValidations.push(self.user_lang["emailinvalid"] + ". Must match valid email pattern. Allowed characters are alphabets, numbers and any of the following special characters- !, #, $, %, &, ', *, +, =, /, ?, ^, _, {, |, }, ~, -");
        $("html, body").animate({ scrollTop: 0 }, "fast");
      } else if (this.selectedgroups.length === 0 && this.selectedIndiegroups.length === 0) {
        this.addUserValidations.push(self.user_lang["atleastonegroup"]);
        $("html, body").animate({ scrollTop: 0 }, "fast");
      } else {
        this.addUserValidations = [];
      }
      return !this.addUserValidations.length;
    },

    displayActivateModal: function displayActivateModal() {
      var _this = this;

      var self = this;
      if (self.validateAddUser()) {
        self.userCreationMessage = "";
        $("#userCreationMessage").removeClass("success-bg").removeClass("error-bg");
        self.addUserGroupIds = [];
        self.dxpList = [];
        self.nonDxpList = [];
        self.loading = true;
        self.selectedgroups.map(function (grpObj) {
          _this.addUserGroupIds.push(grpObj.subGroupId);
        });
        self.selectedIndiegroups.map(function (grpObj) {
          _this.addUserGroupIds.push(grpObj.subGroupId.split("~~~")[0]);
        });
        var groupsToPush = this.addUserGroupIds.slice(0);
        groupsToPush.push(onecargillapplicationgroupid);
        groupsToPush = groupsToPush.join(",");
        __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getListOfSuperUserApps(apiUrl + "/auth/apps", self.email).then(function (response) {
          self.appGrpList = response.data;
          __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getDxpDetails(apiUrl + "/auth/users/userMapGroup?groupId=" + groupsToPush).then(function (response) {
            if (response.data && response.data.dxpAppList) {
              response.data.dxpAppList.map(function (grp) {
                self.appGrpList.map(function (grpObj) {
                  if (grpObj.id === grp) {
                    self.dxpList.push({
                      id: grpObj.id,
                      label: grpObj.label
                    });
                  }
                });
              });
            }
            if (response.data && response.data.nonDxpAppList) {
              response.data.nonDxpAppList.map(function (grp) {
                self.appGrpList.map(function (grpObj) {
                  if (grpObj.id === grp) {
                    self.nonDxpList.push({
                      id: grpObj.id,
                      label: grpObj.label
                    });
                  }
                });
              });
            }
            if (self.dxpList.length > 0 && self.nonDxpList.length > 0) {
              $(".dxpNewmodal").modal("show");
            }
            if (self.dxpList.length === 0 && self.nonDxpList.length > 0) {
              self.createUser("0");
            }
            if (self.dxpList.length === 1 && self.nonDxpList.length === 0) {
              self.createUser(self.dxpList[0].id);
            }
            if (self.dxpList.length > 1 && self.nonDxpList.length === 0) {
              $(".newdxpmodal1").modal("show");
            }
            self.loading = false;
          });
        }).catch(function (err) {
          $(".dxpNewmodal").modal("hide");
          $(".dxpNewmodal1").modal("hide");
          self.loading = false;
          console.log(err);
        });
      }
    },
    closeModal: function closeModal(modalName) {
      $(modalName).modal("hide");
    },
    sendDxpNewInvite: function sendDxpNewInvite() {
      var selectedVal = $("input[name='activation']:checked").val();
      this.createUser(selectedVal);
    },
    getGroupName: function getGroupName(grpId) {
      var self = this;
      var grpName = '';
      self.selectedgroups.forEach(function (x) {
        if (x.subGroupId === grpId) {
          grpName = x.subGroupName;
        }
      });
      self.selectedIndiegroups.forEach(function (x) {
        if (x.subGroupId.indexOf(grpId) > -1) {
          console.log(x.subGroupName);
          grpName = x.subGroupName;
        }
      });
      return grpName;
    },

    createUser: function createUser(appId) {
      var self = this;
      var url = "";
      self.addUserGroupIds = [];
      if (self.validateAddUser()) {
        self.userCreationMessage = "";
        $("#userCreationMessage").removeClass("success-bg").removeClass("error-bg");
        self.loading = true;

        self.selectedgroups.forEach(function (grp) {
          self.addUserGroupIds.push(grp.subGroupId);
        });

        self.selectedIndiegroups.forEach(function (grp) {
          self.addUserGroupIds.push(grp.subGroupId.split('~~~')[0]);
        });

        var groupsToPush = this.addUserGroupIds.slice(0);
        groupsToPush.push(onecargillapplicationgroupid);
        var data = {
          profile: {
            firstName: this.addUserFirstName,
            lastName: this.addUserLastName,
            email: this.addUserPrimaryEmail,
            locale: this.prefLang,
            login: this.addUserPrimaryEmail,
            secondEmail: this.addUserSecondaryEmail
          },
          groupIds: groupsToPush,
          brand: this.brand
        };

        self.userAlreadyExists = false;
        self.existingUserObj = {};
        if (appId === "0") {
          url = apiUrl + "/auth/users/userNew";
        } else {
          url = apiUrl + "/auth/users/userNew?appId=" + appId;
        }
        __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].createUser(url, data).then(function (response) {
          self.isShow = false;
          self.loading = false;
          $(".dxpNewmodal").modal("hide");
          $(".dxpNewmodal1").modal("hide");
          self.userCreationMessage = self.user_lang.usercreated;
          $("#userCreationMessage").removeClass("error-bg").addClass("success-bg");
          $("html, body").animate({ scrollTop: 0 }, "fast");
        }).catch(function (err) {
          $(".dxpNewmodal").modal("hide");
          $(".dxpNewmodal1").modal("hide");
          self.loading = false;
          console.log("create Insert CF Error: ", err);
          if (err.response.data.errorCode === 'E0000007') {
            var grpId = err.response.data.errorSummary.substring(31, 51);
            var grpName = self.getGroupName(grpId);
            self.user_lang.groupCannotBeAssigned = self.user_lang.copyGroupCannotBeAssigned.replace('$', "\"" + grpName + "\"");
            self.isGroupDeleted = true;
          }
          if (err.response.status === 403 || err.response.status === 401) {
            self.addUserValidations.push(err.response.data.errorSummary);
          }
          if (err.response.status === 400) {
            if (err.response.data && err.response.data.errorCauses && err.response.data.errorCauses.length > 0 && (err.response.data.errorCauses[0].errorSummary.indexOf("Does not match required pattern") > -1 || err.response.data.errorCauses[0].errorSummary.indexOf("Username must be in the form of an email address") > -1)) {
              var s = err.response.data.errorCauses[0].errorSummary;
              self.addUserValidations.push(s.charAt(0).toUpperCase() + s.slice(1) + ". Must match valid email pattern. Allowed characters are alphabets, numbers and any of the following special characters- !, #, $, %, &, ', *, +, =, /, ?, ^, _, {, |, }, ~, -");
              $("html, body").animate({ scrollTop: 0 }, "fast");
            } else {
              self.loading = true;
              __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getUserIdByEmail(apiUrl + "/auth/users/" + self.addUserPrimaryEmail).then(function (response) {
                self.existingUserObj = response.data;
                __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getGroupsByUserId(apiUrl + "/auth/users/" + response.data.id + "/groups").then(function (res) {
                  self.loading = false;
                  res.data.forEach(function (grp) {
                    if (self.containsGroupObject(grp.id, self.adminAppsArray)) {
                      self.userAlreadyExists = true;
                    }
                  });
                  if (!self.userAlreadyExists) {
                    self.addUserValidations.push(self.user_lang.partofokta);
                    $("html, body").animate({ scrollTop: 0 }, "fast");
                  } else if (self.userAlreadyExists && self.existingUserObj.status === "DEPROVISIONED") {
                    self.userAlreadyExists = false;
                    self.addUserValidations.push(self.user_lang.userdeactive);
                    $("html, body").animate({ scrollTop: 0 }, "fast");
                  }
                }).catch(function (err) {
                  self.loading = false;
                  console.log(err);
                });
              }).catch(function (err) {
                self.loading = false;
                console.log(err);
              });
              self.addUserValidations.push(self.user_lang.errorcreatinguser);
              $("html, body").animate({ scrollTop: 0 }, "fast");
            }
          }
        });
      }
    },
    handleSelect: function handleSelect(options) {},
    removeFromSelectedGroup: function removeFromSelectedGroup(id) {
      var self = this;
      self.selectedgroups.forEach(function (grp, ind) {
        if (grp.subGroupId === id) {
          self.availablegroups.push(self.selectedgroups.splice(ind, 1)[0]);
        }
      });
    },
    addToSelectedGroup: function addToSelectedGroup(id) {
      var self = this;
      self.availablegroups.forEach(function (grp, ind) {
        if (grp.subGroupId === id) {
          if (self.selectedgroups.some(function (x) {
            return x.subGroupId === grp.subGroupId;
          })) {
            self.availablegroups.splice(ind, 1)[0];
          } else {
            self.selectedgroups.push(self.availablegroups.splice(ind, 1)[0]);
          }
        }
      });
    },
    removeFromSelectedIndieGroup: function removeFromSelectedIndieGroup(id, fromList) {
      var self = this;
      if (fromList === "indie") {
        self.selectedIndiegroups.forEach(function (grp, ind) {
          if (grp.subGroupId.indexOf(id) > -1) {
            self.indieGroupsForNewUser.push(self.selectedIndiegroups.splice(ind, 1)[0]);
            self.loading = true;
            __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].unassignUserFromGroup(apiUrl + "/auth/groups/" + id + "/users/" + self.editUserId).then(function (response) {
              self.loading = false;
            }).catch(function (err) {
              self.loading = false;
              console.log("create Insert CF Error: ", err);
            });
          }
        });
      } else {
        self.selectedGroupsOutsideAdmin.forEach(function (grp, ind) {
          var temp = self.indieGroupsForNewUser.filter(function (q) {
            return q.subGroupId.indexOf(id) > -1;
          }).length;
          if (grp.subGroupId.indexOf(id) > -1 && temp === 0) {
            self.indieGroupsForNewUser.push(grp);
            self.selectedGroupsOutsideAdmin.splice(ind, 1)[0];
          } else if (grp.subGroupId.indexOf(id) > -1) {
            self.selectedGroupsOutsideAdmin.splice(ind, 1)[0];
          }
          self.loading = true;
          __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].unassignUserFromGroup(apiUrl + "/auth/groups/" + id + "/users/" + self.editUserId).then(function (response) {
            self.loading = false;
          }).catch(function (err) {
            self.loading = false;
            console.log("create Insert CF Error: ", err);
          });
        });
      }
    },
    addToSelectedIndieGroup: function addToSelectedIndieGroup(id) {
      var self = this;
      self.indieGroupsForNewUser.forEach(function (grp, ind) {
        if (grp.subGroupId.indexOf(id) > -1) {
          self.selectedIndiegroups.push(self.indieGroupsForNewUser.splice(ind, 1)[0]);
        }
      });
    },
    removeAllNotifications: function removeAllNotifications() {
      this.userCreationMessage = "";
      this.deactivateSuccess = false;
      this.activateSuccess = false;
      this.resetSuccess = false;
      this.deleteSuccess = false;
      this.activatedemail = "";
      this.updatesuccess = false;
      this.userAlreadyExists = false;
      this.existingUserObj = {};
    },
    clearAddUserFields: function clearAddUserFields() {
      this.indieGroupsAdministered = __WEBPACK_IMPORTED_MODULE_14__helpers_storage__["default"].get("MasterIndependentGroupsAdministered");
      this.addUserFirstName = "";
      this.addUserLastName = "";
      this.addUserPrimaryEmail = "";
      this.addUserSecondaryEmail = "";
      this.brand = "";
      this.prefLang = "en_US";
      this.addUserGroupIds = [];
      this.availablegroups = [];
      this.selectedgroups = [];
      this.selectedIndiegroups = [];
      this.selectedGroupsOutsideAdmin = [];
      this.rawUserGroups = [];
      this.addUserValidations = [];
      this.userAlreadyExists = false;
      this.existingUserObj = {};
      this.checkedAppBrand = "";
      this.showTransformedEmail = false;
      this.noEditForWhitelabel = false;
      this.emailTransformed = "";
      $("input[type=checkbox]").attr("checked", false);
    },
    goToUserManagement: function goToUserManagement() {
      var self = this;
      self.isGroupDeleted = false;
      self.showDateFields = false;
      self.isEdit = false;
      self.noFactorSelected = false;
      $("#toggle-arrow").removeClass("fa fa-angle-down").addClass("fa fa-angle-right");
      $("#toggle-mfa-arrow").removeClass("fa fa-angle-down").addClass("fa fa-angle-right");
      $("#toggle-data").hide();
      $("#toggle-mfa-data").hide();
      self.indieGroupsForNewUser = [];
      this.isShow = false;
      this.updateToggle = false;
      self.$root.$emit("refreshuserlist");
      this.indieGroupsAdministered = __WEBPACK_IMPORTED_MODULE_14__helpers_storage__["default"].get("MasterIndependentGroupsAdministered");
    },
    toggleDateFields: function toggleDateFields() {
      var self = this;
      $("#toggle-data").slideToggle();
      $("#toggle-arrow").toggleClass("fa-angle-right fa-angle-down");
      self.showDateFields = true;
    },
    toggleMFAField: function toggleMFAField() {
      var self = this;
      self.noFactorSelected = false;
      $("#toggle-mfa-data").slideToggle();
      $("#toggle-mfa-arrow").toggleClass("fa-angle-right fa-angle-down");
      self.showDateFields = true;
    },
    transformText: function transformText(text) {
      var name = text.toLowerCase().indexOf("okta") > -1 ? this.user_lang.verify : this.user_lang.authentication;
      return text.indexOf("sms") > -1 ? text.toUpperCase() + " " + name : text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() + " " + name;
    },
    isAdminAuthorizedForProfile: function isAdminAuthorizedForProfile() {
      var self = this;
      self.loading = true;
      console.log(self.isAzureORInternalIdentities);
      if (self.addUserPrimaryEmail.toLowerCase().indexOf("@cargill.com") > -1 || self.addUserPrimaryEmail.toLowerCase().indexOf("@crgl-thirdparty.com") > -1) {
        if (!self.isServiceAccGrpPresent) {
          self.isNameEditable = false;
          return;
        }
      }

      var grpsOfUser = JSON.parse(__WEBPACK_IMPORTED_MODULE_14__helpers_storage__["default"].get("grpsOfUser"));
      var grpIds = [];
      grpsOfUser.map(function (grp) {
        grpIds.push(grp.id);
      });
      grpIds.join(",");
      __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getDxpDetails(apiUrl + "/auth/users/mapgroup?adminId=" + grpIds + "&userId=" + self.editUserId).then(function (response) {
        if (response.data && (response.data.nonDxpAppList || response.data.dxpAppList)) {
          self.isNameEditable = true;
        } else {
          self.isNameEditable = false;
        }
        self.loading = false;
      }).catch(function (err) {
        console.log(err);
        self.loading = false;
      });
    },
    isAdminAuthorized: function isAdminAuthorized() {
      var self = this;
      self.loading = true;
      var grpsOfUser = JSON.parse(__WEBPACK_IMPORTED_MODULE_14__helpers_storage__["default"].get("grpsOfUser"));
      var grpIds = [];
      grpsOfUser.map(function (grp) {
        grpIds.push(grp.id);
      });
      grpIds.join(",");
      __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getDxpDetails(apiUrl + "/auth/users/mapgroup?adminId=" + grpIds + "&userId=" + self.editUserId).then(function (response) {
        if (response.data && response.data.errorMessage) {
          self.errorMsgForMFA = response.data.errorMessage;
          self.isAuthorizedForMFA = false;
        } else {
          self.isAuthorizedForMFA = true;
        }
        self.loading = false;
        $(".mfaresetmodal").modal("show");
      }).catch(function (err) {
        console.log(err);
        self.loading = false;
      });
    },
    checkAccess: function checkAccess() {
      var self = this;
      self.isChecked = $("input[name=mfaReset]:checked").size() > 0;
      if (self.isChecked) {
        self.mfaResetSuccess = false;
        self.noFactorSelected = false;
        console.log($("input[name=mfaReset]:checked").attr("id"));
        self.selectedFactorId = $("input[name=mfaReset]:checked").attr("id");
        self.isAdminAuthorized();
      } else {
        self.noFactorSelected = true;
      }
    },
    resetMFA: function resetMFA() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].deleteSMSFactor(apiUrl + "/auth/users/" + self.editUserId + "/factors/" + self.selectedFactorId).then(function (response) {
        console.log(response);
        self.selectedFactorId = "";
        self.mfaResetSuccess = true;
        self.loading = false;
        self.getFactorsOfUser(self.editUserId);
        self.toggleMFAField();
      }).catch(function (err) {
        console.log(err);
        self.loading = false;
      });
    },
    getFactorsOfUser: function getFactorsOfUser(userId) {
      var self = this;
      self.loading = true;
      self.userFactorList = [];
      __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getFactorByUserId(apiUrl + "/auth/users/" + userId + "/factors/secure").then(function (response) {
        self.userFactorList = response.data;
        self.loading = false;
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    formatDate: function formatDate(date) {
      var d = date.split("T");
      var time = d[1].split(".");
      var t = time[0].split(":");
      var hh = t[0] % 12 || 12;
      if (hh < 10) {
        hh = "0" + hh;
      }
      var mm = t[1];
      var ss = t[2];
      var amOrPm = time[0].split(":")[0] >= 12 ? "PM" : "AM";
      return d[0] + " " + hh + ":" + mm + ":" + ss + " " + amOrPm + " UTC";
    },
    assignDateFields: function assignDateFields(res) {
      var self = this;
      var empty = "";
      self.dateInfo.createdDate = res && res.created ? self.formatDate(res.created) : empty;
      self.dateInfo.activatedDate = res && res.activated ? self.formatDate(res.activated) : empty;
      self.dateInfo.lastLogin = res && res.lastLogin ? self.formatDate(res.lastLogin) : empty;
      self.dateInfo.lastUpdated = res && res.lastUpdated ? self.formatDate(res.lastUpdated) : empty;
      self.dateInfo.passwordChanged = res && res.passwordChanged ? self.formatDate(res.passwordChanged) : empty;
      self.dateInfo.statusChanged = res && res.statusChanged ? self.formatDate(res.statusChanged) : empty;
    },
    initiateUpdateUserView: function initiateUpdateUserView(userId) {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getUserIdByEmail(apiUrl + "/auth/users/" + userId).then(function (response) {
        self.loading = false;
        self.assignDateFields(response.data);

        var loc = response.data.profile.locale && response.data.profile.locale.toLowerCase();
        var transEmail = response.data.profile.login;
        var secondEmail = response.data.profile.secondEmail;
        if (secondEmail) {
          self.addUserSecondaryEmail = secondEmail;
          if (secondEmail.toLowerCase().indexOf("mycargillidentity_svcaccount") > -1) {
            self.noEditForWhitelabel = true;
          }
        }
        if (transEmail.indexOf("partneridentity.okta-emea.com") > -1 || transEmail.indexOf("identity.mycargill.com") > -1) {
          self.emailTransformed = response.data.profile.login;
          self.showTransformedEmail = true;
        }
        if (loc !== undefined && loc !== null && loc.trim() !== "") {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_11__i18n_locale_js__["locale"].lang_obj).forEach(function (i) {
            if (loc.toLowerCase().indexOf(i.toLowerCase()) > -1) {
              self.prefLang = i;
            }
          });
        } else {
          self.prefLang = "en_US";
        }
      });
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getActiveAppNames(apiUrl + "/auth/apps/" + userId).then(function (response) {
        self.editUserApps = response.data.filter(function (item) {
          if (item.name !== "bookmark" && item._embedded.user._links.group !== undefined && item.id !== onecargillappid) {
            return item;
          }
        });
      }).catch(function (err) {
        self.loading = false;
        console.log("create Insert CF Error: ", err);
      });
      __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getGroupsByUserId(apiUrl + "/auth/users/" + userId + "/groups").then(function (response) {
        self.initiateAfterGetGroups(response);
      }).catch(function (err) {
        self.loading = false;
        console.log("create Insert CF Error: ", err);
      });
    },
    initiateAfterGetGroups: function initiateAfterGetGroups(response) {
      var self = this;
      self.isServiceAccGrpPresent = false;

      var _loop = function _loop() {
        var groupId = response.data[k].id;
        if (groupId === serviceAccountGroupId) {
          self.isServiceAccGrpPresent = true;
        }
        var obj = self.adminAppsArray.find(function (val) {
          return val.subGroupId.indexOf(groupId) > -1;
        });
        if (obj) {
          self.selectedgroups.push(obj);
        } else {
          var groupName = response.data[k]._embedded ? response.data[k]._embedded.group.profile.name : response.data[k].profile.name;
          var _obj = {};
          _obj.subGroupId = groupId;
          _obj.subGroupName = groupName;
          _obj.isReadOnly = false;
          if (!self.containsGroupObject(groupId, self.selectedGroupsOutsideAdmin) && !self.containsGroupObject(groupId, self.selectedgroups) && groupName.toLowerCase().trim() !== "everyone") {
            self.selectedGroupsOutsideAdmin.push(_obj);
          }
        }
      };

      for (var k = 0; k < response.data.length; k++) {
        _loop();
      }
      self.rawUserGroups = self.selectedgroups.slice(0);
      self.isAdminAuthorizedForProfile();
      self.loading = false;
    },
    getGroupDisabledVal: function getGroupDisabledVal(obj) {
      var self = this;
      var temp = self.appAdminGroupModal.filter(function (x) {
        return x.applicationId === obj.appId;
      });
      return temp.some(function (grp) {
        return grp.subGroupsMap[obj.id];
      });
    },
    updateUser: function updateUser() {
      var _this2 = this;

      var self = this;
      self.isGroupDeleted = false;
      if (this.addUserSecondaryEmail.trim() !== "" && !this.validEmail(this.addUserSecondaryEmail)) {
        return false;
      }
      var data = { profile: { firstName: self.addUserFirstName, lastName: self.addUserLastName, secondEmail: self.addUserSecondaryEmail } };
      __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].updateName(apiUrl + "/auth/users/updateUser?userId=" + self.editUserId, data).then(function (response) {}).catch(function (error) {
        console.log(error);
      });
      if (self.selectedgroups.length > 0 || self.selectedIndiegroups.length > 0) {
        self.selectedIndiegroups.forEach(function (grp) {
          self.loading = true;
          __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].assignUserToGroup(apiUrl + "/auth/groups/" + grp.subGroupId.split("~~~")[0] + "/users/" + self.editUserId).then(function (response) {
            self.loading = false;
          }).catch(function (err) {
            self.loading = false;
            console.log("create Insert CF Error: ", err);
            if (err.response.data.errorCode === 'E0000007') {
              self.user_lang.groupCannotBeAssigned = self.user_lang.copyGroupCannotBeAssigned.replace('$', "\"" + grp.subGroupName + "\"");
              self.isGroupDeleted = true;
            }
          });
        });
        self.selectedgroups.forEach(function (grp, ind) {
          if (!self.containsGroupObject(grp.subGroupId, self.rawUserGroups)) {
            self.loading = true;
            __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].assignUserToGroup(apiUrl + "/auth/groups/" + grp.subGroupId + "/users/" + self.editUserId).then(function (response) {
              self.loading = false;
            }).catch(function (err) {
              self.loading = false;
              console.log("create Insert CF Error: ", err);
              if (err.response.data.errorCode === 'E0000007') {
                self.user_lang.groupCannotBeAssigned = self.user_lang.copyGroupCannotBeAssigned.replace('$', "\"" + grp.subGroupName + "\"");
                self.isGroupDeleted = true;
              }
            });
          }
          if (ind === self.selectedgroups.length - 1) {
            setTimeout(function () {
              self.rawUserGroups.forEach(function (grp, index) {
                if (!self.containsGroupObject(grp.subGroupId, self.selectedgroups)) {
                  self.loading = true;
                  __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].unassignUserFromGroup(apiUrl + "/auth/groups/" + grp.subGroupId + "/users/" + self.editUserId).then(function (response) {
                    self.loading = false;
                  }).catch(function (err) {
                    self.loading = false;
                    console.log("create Insert CF Error: ", err);
                  });
                }
              });

              if (!self.isGroupDeleted) {
                self.goToUserManagement();
                self.updatesuccess = true;
              } else {
                console.log("Group Deleted");
              }
            }, 1000);
          }
        });
      } else {
        self.rawUserGroups.forEach(function (grp, ind) {
          if (!self.containsGroupObject(grp.subGroupId, self.selectedgroups)) {
            self.loading = true;
            __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].unassignUserFromGroup(apiUrl + "/auth/groups/" + grp.subGroupId + "/users/" + self.editUserId).then(function (response) {
              self.loading = false;
            }).catch(function (err) {
              self.loading = false;
              console.log("create Insert CF Error: ", err);
            });
          }
          if (ind === _this2.rawUserGroups.length - 1) {
            self.goToUserManagement();
            self.updatesuccess = true;
          }
        });
        if (self.rawUserGroups.length === 0) {
          self.goToUserManagement();
          self.updatesuccess = true;
        }
      }
    },
    containsGroupObject: function containsGroupObject(id, list) {
      return list.some(function (val) {
        return val.subGroupId === id;
      });
    },
    isChildren: function isChildren(id) {
      return this.selectedgroups.some(function (group) {
        return group.applicationId === id;
      });
    },
    goToExistingUser: function goToExistingUser() {
      var self = this;
      self.$root.$emit("updatetoggle", [self.existingUserObj.profile.firstName, self.existingUserObj.profile.lastName, self.existingUserObj.profile.login, self.existingUserObj.id]);
    },
    clearSelectedOptions: function clearSelectedOptions() {
      var self = this;
      $("input[name=bulkUpload]").attr("checked", false);
      self.optionsNotSelected = false;
    },
    submitFile: function submitFile(isReinvite) {
      var self = this;
      self.clearSelectedOptions();
      if (isReinvite) {
        self.loading = true;
        var adminsGroupIds = [];
        JSON.parse(__WEBPACK_IMPORTED_MODULE_14__helpers_storage__["default"].get("grpsOfUser")).forEach(function (x) {
          adminsGroupIds.push(x.id);
        });
        var adminEmail = __WEBPACK_IMPORTED_MODULE_14__helpers_storage__["default"].get("email");
        var formData = new window.FormData();
        formData.append("file", this.file);
        formData.append("adminsGroupIds", adminsGroupIds);
        formData.append("adminEmail", adminEmail);
        $(".bulkReinviteModal").modal("hide");
        __WEBPACK_IMPORTED_MODULE_13_axios___default.a.post(apiUrl + "/auth/uploadusers/reInvite", formData, { headers: { "Content-Type": "multipart/form-data" } }).then(function (response) {
          self.loading = false;
          console.log(response.data);
          self.reInviteMessage = response.data.Status;
          $(".bulkReinviteMessageModal").modal("show");
          self.clearFile();
        }).catch(function (error) {
          self.loading = false;
          console.log(error.response);
          $(".bulkReinviteModal").modal("hide");
          if (error.response.status === 406) {
            self.reInviteMessage = "Maximum users allowed is 50";
          } else if (error.response.status === 400) {
            self.reInviteMessage = error.response.data.Status;
          } else {
            self.reInviteMessage = "Something went wrong. please check the data and try again";
          }
          $(".bulkReinviteMessageModal").modal("show");
          self.clearFile();
        });
      } else {
        self.loading = true;
        var adminToGroups = [];
        self.adminAppsArray.forEach(function (grp) {
          if (grp.subGroupId.indexOf("~~~") > -1) {
            adminToGroups.push(grp.subGroupId.split("~~~")[0]);
          } else {
            adminToGroups.push(grp.subGroupId);
          }
        });
        console.log(adminToGroups);

        var _formData = new window.FormData();
        _formData.append("file", this.file);
        _formData.append("groupids", adminToGroups);
        $(".bulkCreateModal").modal("hide");
        __WEBPACK_IMPORTED_MODULE_13_axios___default.a.post(apiUrl + "/auth/uploadusers", _formData, { headers: { "Content-Type": "multipart/form-data" } }).then(function (response) {
          self.loading = false;
          console.log(response.data);
          if (response.data && response.data.length > 0) {
            var n = "Submitted Successfully.\n\nBelow Users are not successfully processed:\n\n" + response.data.map(function (i) {
              return "Email: " + i.email + "\nError: " + i.error;
            }).join("\r\n\n");
            window.alert(n);
          } else {
            window.alert("Users are created Successfully!");
          }
          self.clearFile();
        }).catch(function (e) {
          self.loading = false;
          $(".bulkCreateModal").modal("hide");
          if (e.response && e.response.status === 406) {
            window.alert(e.response.data);
          } else {
            window.alert("Something went wrong. please check the data and try again");
          }
          self.clearFile();
        });
      }
    },
    handleFileUpload: function handleFileUpload(isReinvite) {
      this.file = isReinvite ? this.$refs.reinviteFile.files[0] : this.$refs.file.files[0];
      var filename = this.file.name;
      if (filename.slice(filename.lastIndexOf(".")).indexOf("xl") === -1) {
        window.alert("Only Excel file type is allowed.");
        this.clearFile();
        this.isExcel = false;
      } else {
        this.isExcel = true;
      }
    },
    clearFile: function clearFile() {
      var _this3 = this;

      this.uploadReady = false;
      this.$nextTick(function () {
        _this3.uploadReady = true;
      });
    },
    showBulkUploadWindow: function showBulkUploadWindow() {
      $(".bulkUploadOptionsModal").modal("show");
    },
    openbulkModals: function openbulkModals() {
      var self = this;
      var isChecked = $("input[name=bulkUpload]:checked").size() > 0;
      if (isChecked) {
        var selectedId = $("input[name=bulkUpload]:checked").attr("id");
        if (selectedId === "bulkCreate") {
          $(".bulkCreateModal").modal("show");
        } else {
          $(".bulkReinviteModal").modal("show");
        }
        $(".bulkUploadOptionsModal").modal("hide");
      } else {
        self.optionsNotSelected = true;
      }
    },
    resetTotalCount: function resetTotalCount() {
      this.reportTotalCount = undefined;
    },
    downloadUsersOfGroupRecursively: function downloadUsersOfGroupRecursively(nextSet) {
      var self = this;
      self.loading = true;
      self.showProgress = true;
      if (nextSet === undefined) {
        nextSet = "/groupReport/" + self.selectedGroupId + "/users?limit=1000";
        self.downloadReportSet = [];
        console.log("Download Start: " + new Date());
      }
      if (self.reportTotalCount === undefined) {
        __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getGroupStats(apiUrl + "/auth/groups/" + self.selectedGroupId).then(function (res) {
          self.reportTotalCount = res.data._embedded.stats.usersCount;
          __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getUserDetailsOfGroup(apiUrl + "/auth" + nextSet).then(function (response) {
            self.loading = false;
            self.downloadReportSet = self.downloadReportSet.concat(response.data);
            nextSet = response.headers.page;
            if (self.downloadReportSet.length < self.reportTotalCount && nextSet !== undefined) {
              self.downloadUsersOfGroupRecursively(nextSet);
            } else {
              console.log(self.downloadReportSet.length);
              self.showProgress = false;
              self.jsonToExcel(self.downloadReportSet, "report", true);
              console.log("Download End: " + new Date());
            }
          }).catch(function (e) {
            self.loading = false;
            self.showProgress = false;
            window.alert("Something went wrong. Try again later!");
            console.log(e);
          });
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_9__idm_api__["default"].getUserDetailsOfGroup(apiUrl + "/auth" + nextSet).then(function (response) {
          self.loading = false;
          self.downloadReportSet = self.downloadReportSet.concat(response.data);
          nextSet = response.headers.page;
          if (self.downloadReportSet.length < self.reportTotalCount && nextSet) {
            self.downloadUsersOfGroupRecursively(nextSet);
          } else {
            console.log(self.downloadReportSet.length);
            self.showProgress = false;
            self.jsonToExcel(self.downloadReportSet, "report", true);
            console.log("Download End: " + new Date());
          }
        }).catch(function (e) {
          self.loading = false;
          self.showProgress = false;
          window.alert("Something went wrong. Try again later!");
          console.log(e);
        });
      }
    },
    jsonToExcel: function jsonToExcel(JSONData, FileTitle, ShowLabel) {
      JSONData = JSONData ? JSONData : [{ sdf: "sdd" }];
      var arrData = (typeof JSONData === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(JSONData)) !== "object" ? JSON.parse(JSONData) : JSONData;
      var CSV = "";

      if (ShowLabel) {
        var row = "";

        for (var index in arrData[0]) {
          row += index + ",";
        }
        row = row.slice(0, -1);

        CSV += row + "\r\n";
      }

      for (var i = 0; i < arrData.length; i++) {
        var Row = "";

        for (var Index in arrData[i]) {
          Row += '"' + arrData[i][Index] + '",';
        }
        Row.slice(0, Row.length - 1);

        CSV += Row + "\r\n";
      }
      if (CSV === "") {
        window.alert("Invalid data");
        return;
      }

      var filename = FileTitle;
      var blob = new __WEBPACK_IMPORTED_MODULE_7_blob__["a" /* default */](["\uFEFF" + CSV], {
        type: "text/csv;charset=utf-8;"
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          var url = window.URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.style = "visibility:hidden";
          link.download = filename + ".csv";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }
  },
  watch: {
    selectedAppId: function selectedAppId() {
      this.searchTerm = "";
    },
    selectedGroupId: function selectedGroupId() {
      this.searchTerm = "";
    },
    searchTerm: function searchTerm() {},
    globalsearch: function globalsearch() {
      this.searchTerm = "";
    }
  },
  data: function data() {
    return {
      downloadReportSet: [],
      reportTotalCount: undefined,
      appUrl: document.location.href,
      checkedAppBrand: "",
      adminToBrands: [],
      brandDetails: brandDetails,
      admingrpmodalfirstsubgrpidlist: [],
      isAzureORInternalIdentities: false,
      selectedIndiegroups: [],
      indieGroupsAdministered: [],
      appAdminGroupModal: [],
      updateToggle: false,
      resetSuccess: false,
      activateSuccess: false,
      deactivateSuccess: false,
      deleteSuccess: false,
      activatedemail: "",
      isShow: false,
      showDropDown: false,
      lang: __WEBPACK_IMPORTED_MODULE_11__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_11__i18n_locale_js__["locale"].lang_obj,
      lang_def: __WEBPACK_IMPORTED_MODULE_11__i18n_locale_js__["locale"].lang_def,
      addUserClicked: false,
      deactivateForm: false,
      row: {},
      searchTerm: "",
      userrole: "",
      customerTaxId: "",
      combined_name_and_tax_id: "",
      searchUser: "",
      oktauserId: "",
      email: "",
      customers: {},
      loading: false,
      user_lang: {},
      grouplist: [],
      editUserApps: [],
      selectedAppId: "",
      selectedApplication: {},
      subGroups: [],
      addUserFirstName: "",
      addUserLastName: "",
      addUserPrimaryEmail: "",
      addUserSecondaryEmail: "",
      addUserGroupIds: [],
      addUserValidations: [],
      prefLang: "",
      brand: "",
      userCreationMessage: "",
      adminItem: {
        name: "Admin",
        displayName: "Administração",
        to: "/Admin"
      },
      listToMultiselect: [],
      availablegroups: [],
      selectedgroups: [],
      appGroupMap: {},
      rawUserGroups: [],
      editUserId: "",
      adminAppsArray: [],
      updatesuccess: false,
      appList: [],
      uniqueAppList: [],
      selectedGroupId: "",
      userAlreadyExists: false,
      loggedInUser: __WEBPACK_IMPORTED_MODULE_14__helpers_storage__["default"].get("email"),
      globalsearch: false,
      adminTo: [],
      selectedGroupsOutsideAdmin: [],
      onecargillusersgroupid: onecargillapplicationgroupid,
      onecargilladmingroupid: onecargilladmingroupid,
      adminType: __WEBPACK_IMPORTED_MODULE_14__helpers_storage__["default"].get("cf-userRole"),
      file: "",
      isExcel: false,
      uploadReady: true,
      dxpList: [],
      nonDxpList: [],
      appGrpList: [],
      hostName: window.location.host,
      indieGroupsForNewUser: [],
      showProgress: false,
      showDateFields: false,
      isEdit: false,
      userFactorList: [],
      isChecked: false,
      selectedFactorId: "",
      errorMsgForMFA: "",
      mfaResetSuccess: false,
      isAuthorizedForMFA: false,
      isNameEditable: false,
      noFactorSelected: false,
      isAzureId: false,
      isServiceAccountGroupMember: false,
      reInviteMessage: "",
      optionsNotSelected: false,
      showTransformedEmail: false,
      noEditForWhitelabel: false,
      isServiceAccGrpPresent: false,
      emailTransformed: "",
      userGroups: [],
      adminConfigFiltered: [],
      uniqueAppsFiltered: [],
      userAppList: [],
      isGroupDeleted: false,
      dateInfo: { createdDate: "", activatedDate: "", lastLogin: "", lastUpdated: "", passwordChanged: "", statusChanged: "" }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_TopNavFooter__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_TopNavFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_TopNavFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_blob__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_UserTable__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_UserTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_UserTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__idm_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_storage__ = __webpack_require__(5);




















var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";
var serviceAccountGroupId = "00ggpp1iegUC0PZjc0h7";
var internalUserDomains = __webpack_require__(78).data;
var onecargilladmingroupid = "00gf4o186i1L3hcDw0h7";
var onecargillapplicationgroupid = "00gf1pyoc1uSmFbNl0h7";
var onecargillappid = "0oa10r32yuaNJCfrw0h8";

var environment = "stage";
var brandDetails = "";
console.log('env=====', environment);
if (environment === 'production') {
  brandDetails = __webpack_require__(16);
} else if (environment === 'stage') {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'adminold',
  components: {
    TopNavFooter: __WEBPACK_IMPORTED_MODULE_6__components_widgets_TopNavFooter___default.a,
    UserTable: __WEBPACK_IMPORTED_MODULE_9__components_UserTable___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_11__components_Spinner___default.a
  },
  created: function created() {
    var self = this;
    this.user_lang = this.lang_br;
    self.loading = false;
    self.loggedInUser = __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('email');
    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_13__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
    });
    var uid = __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('cf-user');
    if (uid !== undefined && uid !== null) {
      var userId = __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('cf-user').sub;
      console.log(userId);
    } else {
      self.$router.push({ path: '/LoggingIn' });
    }
  },
  mounted: function mounted() {
    var self = this;
    $(document).ready(function () {
      $("body").tooltip({
        animation: false,
        selector: '[data-toggle=tooltip]'
      });
    });
    userId = __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('cf-user').sub;

    self.indieGroupsAdministered = [];
    var userId = __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('cf-user').sub;
    __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getGroupsByUserId(apiUrl + '/auth/users/' + userId + '/groups').then(function (response) {
      response.data.forEach(function (x) {
        self.userGroups.push(x.id);
      });
      __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].set('grpsOfUser', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(response.data));
      self.getAppGroupConfigData();
      __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getListOfAdminConfig(apiUrl + '/auth/appGroupListNew').then(function (response) {
        self.mountPage(response);
        self.filterApp();
      }).catch(function (err) {
        console.log(err);
      });
    }).catch(function (err) {
      self.loading = false;
      console.log("create Insert CF Error: ", err);
    });
    self.eventHandlers();
  },

  methods: {
    downloadReport: function downloadReport() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].downloadReport(apiUrl + '/auth/report/' + self.selectedGroupId).then(function (response) {
        var blob = new __WEBPACK_IMPORTED_MODULE_8_blob__["a" /* default */]([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Report.xlsx';
        self.loading = false;
        link.click();
      }).catch(function (error) {
        window.alert(error);
        self.loading = false;
      });
    },
    disableAvailableGroups: function disableAvailableGroups(isDisabled) {
      return isDisabled ? this.user_lang.readOnlyGroup : false;
    },
    disableSelectedGroups: function disableSelectedGroups(isDisabled, id) {
      return isDisabled ? this.user_lang.readOnlyGroup : !this.checkAllowedSubGroup('all', id) ? this.user_lang.adminPermissionDenied : false;
    },
    disableSelectedIndieGroups: function disableSelectedIndieGroups(id) {
      return !this.checkAllowedSubGroup('all', id) ? this.user_lang.adminPermissionDenied : false;
    },
    disableSelectedGroupsOutsideAdmin: function disableSelectedGroupsOutsideAdmin(id) {
      return this.adminTo.indexOf(id) === -1 && !this.checkAllowedSubGroup('all', id) ? this.user_lang.adminPermissionDenied : false;
    },
    getAppGroupConfigData: function getAppGroupConfigData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getAppGroupConfigData(apiUrl + '/auth/fetchUserApps', self.userGroups).then(function (response) {
        console.log(response);
        self.adminConfigFiltered = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    mountPage: function mountPage(response) {
      var self = this;
      var adminGroupsArr = [];
      var adminAppsArr = [];
      self.appAdminGroupModal = response.data;
      var lenn = self.appAdminGroupModal.filter(function (x) {
        return x.applicationId === self.selectedAppId;
      }).length;
      if (lenn > 0) {
        var grpsOfUser = JSON.parse(__WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('grpsOfUser'));
        self.admingrpmodalfirstsubgrpidlist = [];
        self.appAdminGroupModal.forEach(function (x) {
          if (x.applicationId === self.selectedAppId && grpsOfUser.some(function (y) {
            return y.id === x.groupId;
          })) {
            self.admingrpmodalfirstsubgrpidlist = self.admingrpmodalfirstsubgrpidlist.concat(x.subGroupId);
          }
        });
      }
      var adminGroupsArrtemp = response.data.map(function (i) {
        return i.subGroupId;
      });
      adminGroupsArr = adminGroupsArrtemp.reduce(function (a, b) {
        return a.concat(b);
      }, []);
      self.indieGroupsAdministered = adminGroupsArr.filter(function (item, pos) {
        if (item.indexOf('~~~') > -1 && adminGroupsArr.indexOf(item) === pos) {
          return item;
        }
      });
      __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].set('MasterIndependentGroupsAdministered', self.indieGroupsAdministered);
      adminGroupsArr = adminGroupsArr.map(function (y) {
        if (y.indexOf('~~~') > -1) {
          return y.split('~~~')[0];
        } else {
          return y;
        }
      });
      adminAppsArr = response.data.map(function (i) {
        return i.applicationId;
      });
      __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].set('adminConfigMaster', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(response.data));
      __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].set('adminConfigJSON', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(adminGroupsArr));
      __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].set('adminConfigJSONApps', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(adminAppsArr));
      var adminConfig = adminGroupsArr;

      setTimeout(function () {
        if (adminConfig.length === 0) {
          self.loading = false;
          return false;
        }
        __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getActiveAppNames(apiUrl + '/auth/apps/' + __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('cf-user').sub).then(function (response) {
          self.mountAfterApps(response);
        }).catch(function (err) {
          self.loading = false;
          console.log("create Insert CF Error: ", err);
        });
      }, 300);
    },
    mountAfterApps: function mountAfterApps(response) {
      var self = this;
      var tempStack = [];
      var groupsOfUser = JSON.parse(__WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('grpsOfUser'));
      var adminConfigMaster = JSON.parse(__WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('adminConfigMaster'));
      response.data.map(function (app) {
        for (var n = 0; n < groupsOfUser.length; n++) {
          for (var m = 0; m < adminConfigMaster.length; m++) {
            if (adminConfigMaster[m].groupId === groupsOfUser[n].id && app.name !== 'bookmark') {
              self.selectedAppId = adminConfigMaster[m].applicationId;
              for (var o = 0; o < response.data.length; o++) {
                if (response.data[o].id === adminConfigMaster[m].applicationId) {
                  self.appList.push(response.data[o]);
                  self.uniqueAppList = self.appList.filter(function (app, index, self) {
                    return self.findIndex(function (t) {
                      return t.id === app.id;
                    }) === index;
                  });
                }
              }
              tempStack.push(groupsOfUser[n].id);
            }
          }
        }
      });
      __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].set('email', response.data[0]._embedded.user.profile.login ? response.data[0]._embedded.user.profile.login : response.data[0]._embedded.user.profile.email);
      self.grouplist = self.uniqueAppList.filter(function (item) {
        __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getGroupsByAppId(apiUrl + '/auth/apps/' + item.id + '/groups').then(function (response) {
          self.mountAfterGroups(response, item);
        }).catch(function (err) {
          self.loading = false;
          console.log("create Insert CF Error: ", err);
        });
        if (item.name !== 'bookmark') {
          var temp = self.adminConfigFiltered.filter(function (app) {
            return app.applicationId === item.id;
          });
          if (temp.length > 1) {
            temp.forEach(function (val) {
              var obj = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(item);
              obj.groupId = val.groupId;
              obj.adminGroupName = val.adminGroupName;
              self.userAppList.push(obj);
            });
          } else {
            self.userAppList.push(item);
          }
          return item;
        }
      });
      self.grouplist.map(function (x) {
        return x.brand = adminConfigMaster.filter(function (y) {
          return y.applicationId === x.id;
        })[0].brand;
      });
      self.adminToBrands = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(self.grouplist.map(function (z) {
        return z.brand;
      }))));
      setTimeout(function () {
        var lis = self.appAdminGroupModal.filter(function (x) {
          return self.selectedAppId === x.applicationId;
        });
        if (lis.length > 0) {
          self.selectedGroupId = lis[0].subGroupId[0].split('~~~')[0];
        } else {
          self.selectedGroupId = '';
        }
      }, 2000);
    },
    mountAfterGroups: function mountAfterGroups(response, item) {
      var self = this;
      var glist = response.data;
      var adminConfig = JSON.parse(__WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('adminConfigJSON'));
      var arr = response.config.url.split('/');
      glist.map(function (obj) {
        obj.appId = arr[arr.length - 2];
        return obj;
      });
      __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].set(self.appGroupMap, item.id, glist);
      for (var q = 0; q < glist.length; q++) {
        if (item.name !== 'bookmark') {
          self.adminAppsArray.push(glist[q]);
        }
        if (adminConfig.indexOf(glist[q].id) > -1) {
          self.adminTo.push(glist[q].appId);
        }
      }
      self.loading = false;
    },
    eventResetSuccess: function eventResetSuccess() {
      var self = this;
      self.removeAllNotifications();
      self.resetSuccess = true;
      $('html, body').animate({ scrollTop: 0 }, 'fast');
    },
    eventUpdateToggle: function eventUpdateToggle(arr) {
      var self = this;
      window.scrollTo(0, 0);
      self.indieGroupsForNewUser = [];
      self.indieGroupsAdministered = __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('MasterIndependentGroupsAdministered');
      self.removeAllNotifications();
      self.clearAddUserFields();
      self.updateToggle = true;
      self.addUserFirstName = arr[0];
      self.addUserLastName = arr[1];
      self.addUserPrimaryEmail = self.reverseTransformEmail(arr[2]);
      if (self.addUserPrimaryEmail.toLowerCase().indexOf('@identity.mycargill.com') > 0 || self.addUserPrimaryEmail.toLowerCase().indexOf('@whitelabel.cargill.com') > -1 || self.addUserPrimaryEmail.toLowerCase().indexOf('@partneridentity.okta-emea.com') > -1) {
        var bcode = self.addUserPrimaryEmail.substring(2, 5);
        self.brand = brandDetails.data.filter(function (n) {
          return n.brandCode === bcode;
        })[0].brandName.toLowerCase();
      } else {
        self.brand = 'cargill';
      }
      self.editUserId = arr[3];
      self.isAzureORInternalIdentities = arr[4];
      self.isEdit = arr[5];
      self.initiateUpdateUserView(arr[3]);
      self.getFactorsOfUser(arr[3]);
    },
    reverseTransformEmail: function reverseTransformEmail(em) {
      if (em.toLowerCase().indexOf('@identity.mycargill.com') > -1 || em.toLowerCase().indexOf('@whitelabel.cargill.com') > -1 || em.toLowerCase().indexOf('@partneridentity.okta-emea.com') > -1) {
        em = em.substring(5, em.indexOf('@')).substring(0, em.substr(0, 2) - 1) + '@' + em.substring(5, em.indexOf('@')).substring(em.substr(0, 2) - 1);
      }
      return em;
    },
    eventSearchCleared: function eventSearchCleared(arr) {
      var self = this;
      self.loading = true;
      setTimeout(function () {
        self.selectedGroupId = self.appAdminGroupModal.filter(function (x) {
          return self.selectedAppId === x.applicationId;
        })[0].subGroupId[0].split('~~~')[0];

        self.loading = false;
      }, 2000);
    },
    eventDeactivateSuccess: function eventDeactivateSuccess(email) {
      var self = this;
      self.removeAllNotifications();
      self.deactivateSuccess = true;
      self.activatedemail = email;
      $('html, body').animate({ scrollTop: 0 }, 'fast');
    },
    eventActivateSuccess: function eventActivateSuccess(email) {
      var self = this;
      self.removeAllNotifications();
      self.activateSuccess = true;
      self.activatedemail = email;
      $('html, body').animate({ scrollTop: 0 }, 'fast');
    },
    eventDeleteSuccess: function eventDeleteSuccess(email) {
      var self = this;
      self.removeAllNotifications();
      self.deleteSuccess = true;
      self.activatedemail = email;
      $('html, body').animate({ scrollTop: 0 }, 'fast');
    },
    eventCheckbox: function eventCheckbox(e) {
      var self = this;
      self.userCreationMessage = '';
      $('#userCreationMessage').removeClass('success-bg').removeClass('error-bg');
      self.addUserGroupIds = [];
      var independentGroups = [];
      independentGroups = self.appAdminGroupModal.filter(function (x) {
        return x.applicationId === e.target.id;
      })[0].subGroupId;

      if (e.target.checked) {
        var val = e.target.value;
        var arr = val.split('-');
        var currObj = self.appAdminGroupModal.find(function (y) {
          return y.applicationId === e.target.id;
        });
        if (arr[1] !== "undefined") {
          currObj = self.appAdminGroupModal.find(function (y) {
            return y.applicationId === e.target.id && y.groupId === arr[0];
          });
        }
        currObj.subGroupId.forEach(function (currGrp) {
          if (self.selectedgroups.some(function (group) {
            return group.id === currGrp;
          })) {
            return;
          }
          if (currGrp.indexOf("~~~") > -1) {
            var grp = {
              groupId: currGrp,
              isDisabled: currObj.subGroupsMap[currGrp]
            };
            self.indieGroupsForNewUser.push(grp);
          } else {
            self.appGroupMap[e.target.id].forEach(function (grp) {
              if (grp.id === currGrp) {
                grp.isDisabled = currObj.subGroupsMap[currGrp];
                self.availablegroups.push(grp);
              }
            });
          }
        });
      } else {
        for (var j = 0; j < self.appGroupMap[e.target.id].length; j++) {
          self.availablegroups = self.availablegroups.filter(function (item) {
            return item.id !== self.appGroupMap[e.target.id][j].id;
          });
        }
        self.indieGroupsForNewUser = self.indieGroupsForNewUser.filter(function (x) {
          return !independentGroups.includes(x.groupId);
        });
      }
      var textinputs = document.querySelectorAll('.input-checkbx');
      var empty = [].filter.call(textinputs, function (el) {
        return el.checked;
      });
      if (empty.length === 0) {
        self.checkedAppBrand = '';
        self.brand = '';
        self.selectedgroups = [];
      } else {
        self.checkedAppBrand = self.grouplist.filter(function (x) {
          return x.id === e.target.id;
        }).length > 0 ? self.grouplist.filter(function (x) {
          return x.id === e.target.id;
        })[0].brand : 'cargill';
        self.brand = self.checkedAppBrand.toLowerCase();
      }
    },
    eventSelect: function eventSelect(e) {
      var self = this;
      self.userCreationMessage = '';
      $('#userCreationMessage').removeClass('success-bg').removeClass('error-bg');
    },
    eventInput: function eventInput(e) {
      var self = this;
      self.userCreationMessage = '';
      $('#userCreationMessage').removeClass('success-bg').removeClass('error-bg');
    },
    eventBody: function eventBody(e) {
      var self = this;
      if (!$('div#dropdown').has(e.target).length) {
        self.showDropDown = false;
      }
    },
    eventAdminLink: function eventAdminLink(e) {
      var self = this;
      self.goToUserManagement();
    },
    eventTimeout: function eventTimeout() {
      var self = this;
      var lis = self.appAdminGroupModal.filter(function (x) {
        return self.selectedAppId === x.applicationId;
      });
      if (lis.length > 0) {
        self.selectedGroupId = lis[0].subGroupId[0].split('~~~')[0];
      } else {
        self.selectedGroupId = '';
      }
    },
    eventHandlers: function eventHandlers() {
      var self = this;
      self.$root.$on('resetsuccess', function () {
        self.eventResetSuccess();
      });
      self.$root.$on('updatetoggle', function (arr) {
        self.eventUpdateToggle(arr);
      });
      self.$root.$on('searchcleared', function (arr) {
        self.eventSearchCleared(arr);
      });
      self.$root.$on('deactivatesuccess', function (email) {
        self.eventDeactivateSuccess(email);
      });
      self.$root.$on('activatesuccess', function (email) {
        self.eventActivateSuccess(email);
      });
      self.$root.$on('deletesuccess', function (email) {
        self.eventDeleteSuccess(email);
      });

      $(document).on('change', '.input-checkbx', function (e) {
        self.eventCheckbox(e);
      });
      $(document).on('change', 'select', function (e) {
        self.eventSelect(e);
      });
      $(document).on('input', 'input', function (e) {
        self.eventInput(e);
      });
      $(document).on('click', 'body', function (e) {
        self.eventBody(e);
      });
      $(document).on('click', '#adminLink', function (e) {
        self.eventAdminLink(e);
      });
      setTimeout(function () {
        self.eventTimeout();
      }, 2000);
    },
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    deepcopy: function deepcopy(items) {
      var itemsCopy = [];
      itemsCopy = items.slice(0);
      return itemsCopy;
    },
    isAlreadyPresent: function isAlreadyPresent(id, index) {
      var self = this;
      return self.appList.slice(0, index).filter(function (x) {
        return x.id === id;
      }).length > 0;
    },
    isPresentInSelectedGroups: function isPresentInSelectedGroups(gid) {
      var self = this;

      var ispresentr = self.selectedGroupsOutsideAdmin.filter(function (x) {
        return x.id === gid;
      });
      var ispresentl = self.selectedgroups.filter(function (x) {
        return x.id === gid;
      });
      return ispresentr.length > 0 || ispresentl.length > 0;
    },
    checkAllowedSubGroup: function checkAllowedSubGroup(appid, subgrpid) {
      var admincfg = JSON.parse(__WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('adminConfigMaster'));
      var grpsOfUser = JSON.parse(__WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('grpsOfUser'));
      var configsforappid = [];
      if (appid !== 'all') {
        configsforappid = admincfg.filter(function (x) {
          return x.applicationId === appid;
        });
      } else {
        configsforappid = admincfg;
      }
      var listofsubgroupsallowed = [];
      for (var i = 0; i < configsforappid.length; i++) {
        for (var j = 0; j < grpsOfUser.length; j++) {
          if (configsforappid[i].groupId === grpsOfUser[j].id) {
            listofsubgroupsallowed = listofsubgroupsallowed.concat(configsforappid[i].subGroupId);
          }
        }
      }

      var ispresent = 0;
      if (subgrpid !== undefined && subgrpid !== null) {
        ispresent = listofsubgroupsallowed.filter(function (n) {
          return n.indexOf(subgrpid) > -1;
        }).length;
      }
      return ispresent > 0;
    },
    storeCustomerTaxId: function storeCustomerTaxId() {
      this.$store.commit('setCustomerTaxId', this.customerTaxId);
    },

    filterApp: function filterApp(e) {
      var self = this;
      self.loading = true;
      setTimeout(function () {
        var lenn = self.appAdminGroupModal.filter(function (x) {
          return x.applicationId === self.selectedAppId;
        }).length;
        if (lenn > 0) {
          var grpsOfUser = JSON.parse(__WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('grpsOfUser'));
          self.admingrpmodalfirstsubgrpidlist = [];

          self.appAdminGroupModal.forEach(function (x) {
            if (x.applicationId === self.selectedAppId && grpsOfUser.some(function (y) {
              return y.id === x.groupId;
            })) {
              self.admingrpmodalfirstsubgrpidlist = self.admingrpmodalfirstsubgrpidlist.concat(x.subGroupId);
            }
          });
          self.selectedGroupId = self.admingrpmodalfirstsubgrpidlist[0];
          if (self.selectedGroupId.indexOf("~~~") > -1) {
            self.selectedGroupId = self.selectedGroupId.split("~~~")[0];
          }
        }

        self.loading = false;
      }, 2000);
    },
    filterGroup: function filterGroup(e) {},
    validEmail: function validEmail(email) {
      var re = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(email);
    },
    validateAddUser: function validateAddUser(e) {
      var self = this;
      this.addUserValidations = [];
      if (!this.addUserFirstName) {
        this.addUserValidations.push(self.user_lang['firstnamereq']);
        $('html, body').animate({ scrollTop: 0 }, 'fast');
      } else if (!this.addUserLastName) {
        this.addUserValidations.push(self.user_lang['lastnamereq']);
        $('html, body').animate({ scrollTop: 0 }, 'fast');
      } else if (!this.addUserPrimaryEmail) {
        this.addUserValidations.push(self.user_lang['emailreq']);
        $('html, body').animate({ scrollTop: 0 }, 'fast');
      } else if (!this.validEmail(this.addUserPrimaryEmail)) {
        this.addUserValidations.push(self.user_lang['emailinvalid'] + ". Must match valid email pattern. Allowed characters are alphabets, numbers and any of the following special characters- !, #, $, %, &, ', *, +, =, /, ?, ^, _, {, |, }, ~, -");
        $('html, body').animate({ scrollTop: 0 }, 'fast');
      } else if (document.location.hostname.indexOf('jsicustomer') === -1 && internalUserDomains.filter(function (x) {
        return x.toLowerCase().indexOf(self.addUserPrimaryEmail.split('@')[1].toLowerCase()) > -1;
      }).length > 0) {
        this.addUserValidations.push(self.user_lang['emailinvaliddomain']);
        $('html, body').animate({ scrollTop: 0 }, 'fast');
      } else if (this.addUserSecondaryEmail.trim() !== '' && !this.validEmail(this.addUserSecondaryEmail)) {
        this.addUserValidations.push(self.user_lang['emailinvalid'] + ". Must match valid email pattern. Allowed characters are alphabets, numbers and any of the following special characters- !, #, $, %, &, ', *, +, =, /, ?, ^, _, {, |, }, ~, -");
        $('html, body').animate({ scrollTop: 0 }, 'fast');
      } else if (this.selectedgroups.length === 0 && this.selectedIndiegroups.length === 0) {
        this.addUserValidations.push(self.user_lang['atleastonegroup']);
        $('html, body').animate({ scrollTop: 0 }, 'fast');
      } else {
        this.addUserValidations = [];
      }
      return !this.addUserValidations.length;
    },

    displayActivateModal: function displayActivateModal() {
      var _this = this;

      var self = this;
      if (self.validateAddUser()) {
        self.userCreationMessage = '';
        $('#userCreationMessage').removeClass('success-bg').removeClass('error-bg');
        self.addUserGroupIds = [];
        self.dxpList = [];
        self.nonDxpList = [];
        self.loading = true;
        self.selectedgroups.map(function (grpObj) {
          _this.addUserGroupIds.push(grpObj.id);
        });
        self.selectedIndiegroups.map(function (grpObj) {
          _this.addUserGroupIds.push(grpObj.split('~~~')[0]);
        });
        var groupsToPush = this.addUserGroupIds.slice(0);
        groupsToPush.push(onecargillapplicationgroupid);
        groupsToPush = groupsToPush.join(',');
        __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getListOfSuperUserApps(apiUrl + '/auth/apps', self.email).then(function (response) {
          self.appGrpList = response.data;
          __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getDxpDetails(apiUrl + '/auth/users/userMapGroup?groupId=' + groupsToPush).then(function (response) {
            if (response.data && response.data.dxpAppList) {
              response.data.dxpAppList.map(function (grp) {
                self.appGrpList.map(function (grpObj) {
                  if (grpObj.id === grp) {
                    self.dxpList.push({
                      id: grpObj.id,
                      label: grpObj.label
                    });
                  }
                });
              });
            }
            if (response.data && response.data.nonDxpAppList) {
              response.data.nonDxpAppList.map(function (grp) {
                self.appGrpList.map(function (grpObj) {
                  if (grpObj.id === grp) {
                    self.nonDxpList.push({
                      id: grpObj.id,
                      label: grpObj.label
                    });
                  }
                });
              });
            }
            if (self.dxpList.length > 0 && self.nonDxpList.length > 0) {
              $('.dxpNewmodal').modal('show');
            }if (self.dxpList.length === 0 && self.nonDxpList.length > 0) {
              self.createUser("0");
            }if (self.dxpList.length === 1 && self.nonDxpList.length === 0) {
              self.createUser(self.dxpList[0].id);
            }if (self.dxpList.length > 1 && self.nonDxpList.length === 0) {
              $('.newdxpmodal1').modal('show');
            }
            self.loading = false;
          });
        }).catch(function (err) {
          $('.dxpNewmodal').modal('hide');
          $('.dxpNewmodal1').modal('hide');
          self.loading = false;
          console.log(err);
        });
      }
    },
    closeModal: function closeModal(modalName) {
      $(modalName).modal('hide');
    },
    sendDxpNewInvite: function sendDxpNewInvite() {
      var selectedVal = $("input[name='activation']:checked").val();
      this.createUser(selectedVal);
    },
    createUser: function createUser(appId) {
      var self = this;
      var url = "";
      self.addUserGroupIds = [];
      if (self.validateAddUser()) {
        self.userCreationMessage = '';
        $('#userCreationMessage').removeClass('success-bg').removeClass('error-bg');
        self.loading = true;

        for (var n = 0; n < self.selectedgroups.length; n++) {
          if (self.selectedgroups[n] && self.selectedgroups[n]['_embedded'] && self.selectedgroups[n]['_embedded']['group'] && self.selectedgroups[n]['_embedded']['group']['profile'] && self.selectedgroups[n]['_embedded']['group']['profile']['name'] && self.selectedgroups[n]['_embedded']['group']['profile']['name'].toLowerCase().trim() !== 'everyone') {
            this.addUserGroupIds.push(self.selectedgroups[n].id);
          }
        }
        for (var m = 0; m < self.selectedIndiegroups.length; m++) {
          this.addUserGroupIds.push(self.selectedIndiegroups[m].split('~~~')[0]);
        }
        var groupsToPush = this.addUserGroupIds.slice(0);
        groupsToPush.push(onecargillapplicationgroupid);
        var data = {
          "profile": {
            "firstName": this.addUserFirstName,
            "lastName": this.addUserLastName,
            "email": this.addUserPrimaryEmail,
            "locale": this.prefLang,
            "login": this.addUserPrimaryEmail,
            "secondEmail": this.addUserSecondaryEmail
          },
          "groupIds": groupsToPush,
          "brand": this.brand
        };

        self.userAlreadyExists = false;
        self.existingUserObj = {};
        if (appId === "0") {
          url = apiUrl + '/auth/users/userNew';
        } else {
          url = apiUrl + '/auth/users/userNew?appId=' + appId;
        }
        __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].createUser(url, data).then(function (response) {
          self.isShow = false;
          self.loading = false;
          $('.dxpNewmodal').modal('hide');
          $('.dxpNewmodal1').modal('hide');
          self.userCreationMessage = self.user_lang.usercreated;
          $('#userCreationMessage').removeClass('error-bg').addClass('success-bg');
          $('html, body').animate({ scrollTop: 0 }, 'fast');
        }).catch(function (err) {
          $('.dxpNewmodal').modal('hide');
          $('.dxpNewmodal1').modal('hide');
          self.loading = false;
          console.log("create Insert CF Error: ", err);
          if (err.response.status === 403 || err.response.status === 401) {
            self.addUserValidations.push(err.response.data.errorSummary);
          }
          if (err.response.status === 400) {
            if (err.response.data && err.response.data.errorCauses && err.response.data.errorCauses.length > 0 && (err.response.data.errorCauses[0].errorSummary.indexOf('Does not match required pattern') > -1 || err.response.data.errorCauses[0].errorSummary.indexOf('Username must be in the form of an email address') > -1)) {
              var s = err.response.data.errorCauses[0].errorSummary;
              self.addUserValidations.push(s.charAt(0).toUpperCase() + s.slice(1) + ". Must match valid email pattern. Allowed characters are alphabets, numbers and any of the following special characters- !, #, $, %, &, ', *, +, =, /, ?, ^, _, {, |, }, ~, -");
              $('html, body').animate({ scrollTop: 0 }, 'fast');
            } else {
              self.loading = true;
              __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getUserIdByEmail(apiUrl + '/auth/users/' + self.addUserPrimaryEmail).then(function (response) {
                self.existingUserObj = response.data;
                __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getGroupsByUserId(apiUrl + '/auth/users/' + response.data.id + '/groups').then(function (response) {
                  self.loading = false;
                  for (var m = 0; m < response.data.length; m++) {
                    if (self.containsObject(response.data[m], self.adminAppsArray)) {
                      self.userAlreadyExists = true;
                    }
                  }
                  if (!self.userAlreadyExists) {
                    self.addUserValidations.push(self.user_lang.partofokta);
                    $('html, body').animate({ scrollTop: 0 }, 'fast');
                  } else if (self.userAlreadyExists && self.existingUserObj.status === 'DEPROVISIONED') {
                    self.userAlreadyExists = false;
                    self.addUserValidations.push(self.user_lang.userdeactive);
                    $('html, body').animate({ scrollTop: 0 }, 'fast');
                  }
                }).catch(function (err) {
                  self.loading = false;
                  console.log(err);
                });
              }).catch(function (err) {
                self.loading = false;
                console.log(err);
              });
              self.addUserValidations.push(self.user_lang.errorcreatinguser);
              $('html, body').animate({ scrollTop: 0 }, 'fast');
            }
          }
        });
      }
    },
    handleSelect: function handleSelect(options) {},
    removeFromSelectedGroup: function removeFromSelectedGroup(id) {
      for (var i = 0; i < this.selectedgroups.length; i++) {
        if (this.selectedgroups[i].id === id) {
          this.availablegroups.push(this.selectedgroups.splice(i, 1)[0]);
        }
      }
    },
    addToSelectedGroup: function addToSelectedGroup(id) {
      var _this2 = this;

      for (var i = 0; i < this.availablegroups.length; i++) {
        if (this.availablegroups[i].id === id) {
          if (this.selectedgroups.some(function (grp) {
            return grp.id === _this2.availablegroups[i].id;
          })) {
            this.availablegroups.splice(i, 1)[0];
          } else {
            this.selectedgroups.push(this.availablegroups.splice(i, 1)[0]);
          }
        }
      }
    },
    removeFromSelectedIndieGroup: function removeFromSelectedIndieGroup(id, fromList) {
      var self = this;
      if (fromList === 'indie') {
        for (var i = 0; i < this.selectedIndiegroups.length; i++) {
          if (this.selectedIndiegroups[i].indexOf(id) > -1) {
            this.indieGroupsAdministered.push(this.selectedIndiegroups[i]);
            this.selectedIndiegroups.splice(i, 1);
            self.loading = true;
            __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].unassignUserFromGroup(apiUrl + '/auth/groups/' + id + '/users/' + self.editUserId).then(function (response) {
              self.loading = false;
            }).catch(function (err) {
              self.loading = false;
              console.log("create Insert CF Error: ", err);
            });
          }
        }
      } else {
        for (var j = 0; j < this.selectedGroupsOutsideAdmin.length; j++) {
          var temp = this.indieGroupsAdministered.filter(function (q) {
            return q.indexOf(id) > -1;
          }).length;
          if (this.selectedGroupsOutsideAdmin[j].id.indexOf(id) > -1 && temp === 0) {
            this.indieGroupsAdministered.push(this.selectedGroupsOutsideAdmin[j].id + '~~~' + this.selectedGroupsOutsideAdmin[j].profile.name);
            this.selectedGroupsOutsideAdmin.splice(j, 1);
          } else if (this.selectedGroupsOutsideAdmin[j].id.indexOf(id) > -1) {
            this.selectedGroupsOutsideAdmin.splice(j, 1);
          }
          self.loading = true;
          __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].unassignUserFromGroup(apiUrl + '/auth/groups/' + id + '/users/' + self.editUserId).then(function (response) {
            self.loading = false;
          }).catch(function (err) {
            self.loading = false;
            console.log("create Insert CF Error: ", err);
          });
        }
      }
    },
    addToSelectedIndieGroup: function addToSelectedIndieGroup(id) {
      for (var i = 0; i < this.indieGroupsAdministered.length; i++) {
        if (this.indieGroupsAdministered[i].indexOf(id) > -1) {
          this.selectedIndiegroups.push(this.indieGroupsAdministered.splice(i, 1)[0]);
        }
      }
    },
    removeAllNotifications: function removeAllNotifications() {
      this.userCreationMessage = '';
      this.deactivateSuccess = false;
      this.activateSuccess = false;
      this.resetSuccess = false;
      this.deleteSuccess = false;
      this.activatedemail = '';
      this.updatesuccess = false;
      this.userAlreadyExists = false;
      this.existingUserObj = {};
    },
    clearAddUserFields: function clearAddUserFields() {
      this.indieGroupsAdministered = __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('MasterIndependentGroupsAdministered');
      this.addUserFirstName = '';
      this.addUserLastName = '';
      this.addUserPrimaryEmail = '';
      this.addUserSecondaryEmail = '';
      this.brand = '';
      this.prefLang = 'en_US';
      this.addUserGroupIds = [];
      this.availablegroups = [];
      this.selectedgroups = [];
      this.selectedIndiegroups = [];
      this.selectedGroupsOutsideAdmin = [];
      this.rawUserGroups = [];
      this.addUserValidations = [];
      this.userAlreadyExists = false;
      this.existingUserObj = {};
      this.checkedAppBrand = '';
      this.showTransformedEmail = false;
      this.noEditForWhitelabel = false;
      this.emailTransformed = '';
      $('input[type=checkbox]').attr('checked', false);
    },
    goToUserManagement: function goToUserManagement() {
      var self = this;
      self.showDateFields = false;
      self.isEdit = false;
      self.noFactorSelected = false;
      $('#toggle-arrow').removeClass('fa fa-angle-down').addClass('fa fa-angle-right');
      $('#toggle-mfa-arrow').removeClass('fa fa-angle-down').addClass('fa fa-angle-right');
      $('#toggle-data').hide();
      $('#toggle-mfa-data').hide();
      self.indieGroupsForNewUser = [];
      this.isShow = false;
      this.updateToggle = false;
      self.$root.$emit('refreshuserlist');
      this.indieGroupsAdministered = __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('MasterIndependentGroupsAdministered');
    },
    toggleDateFields: function toggleDateFields() {
      var self = this;
      $('#toggle-data').slideToggle();
      $('#toggle-arrow').toggleClass("fa-angle-right fa-angle-down");
      self.showDateFields = true;
    },
    toggleMFAField: function toggleMFAField() {
      var self = this;
      self.noFactorSelected = false;
      $('#toggle-mfa-data').slideToggle();
      $('#toggle-mfa-arrow').toggleClass("fa-angle-right fa-angle-down");
      self.showDateFields = true;
    },
    transformText: function transformText(text) {
      var name = text.toLowerCase().indexOf('okta') > -1 ? this.user_lang.verify : this.user_lang.authentication;
      return text.indexOf('sms') > -1 ? text.toUpperCase() + " " + name : text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() + " " + name;
    },
    isAdminAuthorizedForProfile: function isAdminAuthorizedForProfile() {
      var self = this;
      self.loading = true;
      console.log(self.isAzureORInternalIdentities);
      if (self.addUserPrimaryEmail.toLowerCase().indexOf('@cargill.com') > -1 || self.addUserPrimaryEmail.toLowerCase().indexOf('@crgl-thirdparty.com') > -1) {
        if (!self.isServiceAccGrpPresent) {
          self.isNameEditable = false;
          return;
        }
      }

      var grpsOfUser = JSON.parse(__WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('grpsOfUser'));
      var grpIds = [];
      grpsOfUser.map(function (grp) {
        grpIds.push(grp.id);
      });
      grpIds.join(',');
      __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getDxpDetails(apiUrl + '/auth/users/mapgroup?adminId=' + grpIds + '&userId=' + self.editUserId).then(function (response) {
        if (response.data && (response.data.nonDxpAppList || response.data.dxpAppList)) {
          self.isNameEditable = true;
        } else {
          self.isNameEditable = false;
        }
        self.loading = false;
      }).catch(function (err) {
        console.log(err);
        self.loading = false;
      });
    },
    isAdminAuthorized: function isAdminAuthorized() {
      var self = this;
      self.loading = true;
      var grpsOfUser = JSON.parse(__WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('grpsOfUser'));
      var grpIds = [];
      grpsOfUser.map(function (grp) {
        grpIds.push(grp.id);
      });
      grpIds.join(',');
      __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getDxpDetails(apiUrl + '/auth/users/mapgroup?adminId=' + grpIds + '&userId=' + self.editUserId).then(function (response) {
        if (response.data && response.data.errorMessage) {
          self.errorMsgForMFA = response.data.errorMessage;
          self.isAuthorizedForMFA = false;
        } else {
          self.isAuthorizedForMFA = true;
        }
        self.loading = false;
        $('.mfaresetmodal').modal('show');
      }).catch(function (err) {
        console.log(err);
        self.loading = false;
      });
    },
    checkAccess: function checkAccess() {
      var self = this;
      self.isChecked = $('input[name=mfaReset]:checked').size() > 0;
      if (self.isChecked) {
        self.mfaResetSuccess = false;
        self.noFactorSelected = false;
        console.log($('input[name=mfaReset]:checked').attr('id'));
        self.selectedFactorId = $('input[name=mfaReset]:checked').attr('id');
        self.isAdminAuthorized();
      } else {
        self.noFactorSelected = true;
      }
    },
    resetMFA: function resetMFA() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].deleteSMSFactor(apiUrl + '/auth/users/' + self.editUserId + '/factors/' + self.selectedFactorId).then(function (response) {
        console.log(response);
        self.selectedFactorId = "";
        self.mfaResetSuccess = true;
        self.loading = false;
        self.getFactorsOfUser(self.editUserId);
        self.toggleMFAField();
      }).catch(function (err) {
        console.log(err);
        self.loading = false;
      });
    },
    getFactorsOfUser: function getFactorsOfUser(userId) {
      var self = this;
      self.loading = true;
      self.userFactorList = [];
      __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getFactorByUserId(apiUrl + '/auth/users/' + userId + '/factors/secure').then(function (response) {
        self.userFactorList = response.data;
        self.loading = false;
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    formatDate: function formatDate(date) {
      var d = date.split('T');
      var time = d[1].split('.');
      var t = time[0].split(':');
      var hh = t[0] % 12 || 12;
      if (hh < 10) {
        hh = "0" + hh;
      }
      var mm = t[1];
      var ss = t[2];
      var amOrPm = time[0].split(':')[0] >= 12 ? "PM" : "AM";
      return d[0] + " " + hh + ":" + mm + ":" + ss + " " + amOrPm + " UTC";
    },
    assignDateFields: function assignDateFields(res) {
      var self = this;
      var empty = "";
      self.dateInfo.createdDate = res && res.created ? self.formatDate(res.created) : empty;
      self.dateInfo.activatedDate = res && res.activated ? self.formatDate(res.activated) : empty;
      self.dateInfo.lastLogin = res && res.lastLogin ? self.formatDate(res.lastLogin) : empty;
      self.dateInfo.lastUpdated = res && res.lastUpdated ? self.formatDate(res.lastUpdated) : empty;
      self.dateInfo.passwordChanged = res && res.passwordChanged ? self.formatDate(res.passwordChanged) : empty;
      self.dateInfo.statusChanged = res && res.statusChanged ? self.formatDate(res.statusChanged) : empty;
    },
    initiateUpdateUserView: function initiateUpdateUserView(userId) {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getUserIdByEmail(apiUrl + '/auth/users/' + userId).then(function (response) {
        self.loading = false;
        self.assignDateFields(response.data);

        var loc = response.data.profile.locale && response.data.profile.locale.toLowerCase();
        var transEmail = response.data.profile.login;
        var secondEmail = response.data.profile.secondEmail;
        if (secondEmail) {
          self.addUserSecondaryEmail = secondEmail;
        }
        if (secondEmail.toLowerCase().indexOf('mycargillidentity_svcaccount') > -1) {
          self.noEditForWhitelabel = true;
        }
        if (transEmail.indexOf('partneridentity.okta-emea.com') > -1 || transEmail.indexOf('identity.mycargill.com') > -1) {
          self.emailTransformed = response.data.profile.login;
          self.showTransformedEmail = true;
        }
        if (loc !== undefined && loc !== null && loc.trim() !== '') {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_12__i18n_locale_js__["locale"].lang_obj).forEach(function (i) {
            if (loc.toLowerCase().indexOf(i.toLowerCase()) > -1) {
              self.prefLang = i;
            }
          });
        } else {
          self.prefLang = 'en_US';
        }
      });
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getActiveAppNames(apiUrl + '/auth/apps/' + userId).then(function (response) {
        self.editUserApps = response.data.filter(function (item) {
          if (item.name !== 'bookmark' && item._embedded.user._links.group !== undefined && item.id !== onecargillappid) {
            return item;
          }
        });
      }).catch(function (err) {
        self.loading = false;
        console.log("create Insert CF Error: ", err);
      });
      __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getGroupsByUserId(apiUrl + '/auth/users/' + userId + '/groups').then(function (response) {
        self.initiateAfterGetGroups(response);
      }).catch(function (err) {
        self.loading = false;
        console.log("create Insert CF Error: ", err);
      });
    },
    initiateAfterGetGroups: function initiateAfterGetGroups(response) {
      var self = this;
      self.isServiceAccGrpPresent = false;
      for (var k = 0; k < response.data.length; k++) {
        if (response.data[k].id === serviceAccountGroupId) {
          self.isServiceAccGrpPresent = true;
        }
        if (self.containsObject(response.data[k], self.adminAppsArray) && !self.containsObject(response.data[k], self.selectedgroups)) {
          for (var y = 0; y < self.adminAppsArray.length; y++) {
            if (self.adminAppsArray[y].id === response.data[k].id) {
              var objG = response.data[k];
              objG['appId'] = self.adminAppsArray[y].appId;
              objG['isDisabled'] = self.getGroupDisabledVal(objG);
              if (!self.containsObject(objG, self.selectedgroups)) {
                self.selectedgroups.push(objG);
              }
            }
          }
        } else {
          var tempName = response.data[k]._embedded ? response.data[k]._embedded.group.profile.name : response.data[k].profile.name;
          if (!self.containsObject(response.data[k], self.selectedGroupsOutsideAdmin) && !self.containsObject(response.data[k], self.selectedgroups) && tempName.toLowerCase().trim() !== 'everyone') {
            self.selectedGroupsOutsideAdmin.push(response.data[k]);
          }
        }
      }
      self.rawUserGroups = self.selectedgroups.slice(0);
      self.isAdminAuthorizedForProfile();
      self.loading = false;
    },
    getGroupDisabledVal: function getGroupDisabledVal(obj) {
      var self = this;
      var temp = self.appAdminGroupModal.filter(function (x) {
        return x.applicationId === obj.appId;
      });

      return temp.some(function (grp) {
        return grp.subGroupsMap[obj.id];
      });
    },
    updateUser: function updateUser() {
      var self = this;
      if (this.addUserSecondaryEmail.trim() !== '' && !this.validEmail(this.addUserSecondaryEmail)) {
        return false;
      }
      var data = { "profile": { "firstName": self.addUserFirstName, lastName: self.addUserLastName, secondEmail: self.addUserSecondaryEmail } };
      __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].updateName(apiUrl + '/auth/users/updateUser?userId=' + self.editUserId, data).then(function (response) {}).catch(function (error) {
        console.log(error);
      });
      if (this.selectedgroups.length > 0 || this.selectedIndiegroups.length > 0) {
        for (var u = 0; u < this.selectedIndiegroups.length; u++) {
          self.loading = true;
          __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].assignUserToGroup(apiUrl + '/auth/groups/' + self.selectedIndiegroups[u].split('~~~')[0] + '/users/' + self.editUserId).then(function (response) {
            self.loading = false;
          }).catch(function (err) {
            self.loading = false;
            console.log("create Insert CF Error: ", err);
          });
        }
        for (var s = 0; s < this.selectedgroups.length; s++) {
          if (!self.containsObject(this.selectedgroups[s], this.rawUserGroups)) {
            self.loading = true;
            __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].assignUserToGroup(apiUrl + '/auth/groups/' + self.selectedgroups[s].id + '/users/' + self.editUserId).then(function (response) {
              self.loading = false;
            }).catch(function (err) {
              self.loading = false;
              console.log("create Insert CF Error: ", err);
            });
          }
          if (s === self.selectedgroups.length - 1) {
            setTimeout(function () {
              for (var t = 0; t < self.rawUserGroups.length; t++) {
                if (!self.containsObject(self.rawUserGroups[t], self.selectedgroups)) {
                  self.loading = true;
                  __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].unassignUserFromGroup(apiUrl + '/auth/groups/' + self.rawUserGroups[t].id + '/users/' + self.editUserId).then(function (response) {
                    self.loading = false;
                  }).catch(function (err) {
                    self.loading = false;
                    console.log("create Insert CF Error: ", err);
                  });
                }
                if (t === self.rawUserGroups.length - 1) {
                  self.goToUserManagement();
                  self.updatesuccess = true;
                }
              }
              if (self.rawUserGroups.length === 0) {
                self.goToUserManagement();
                self.updatesuccess = true;
              }
            }, 1000);
          }
        }
      } else {
        for (var t = 0; t < this.rawUserGroups.length; t++) {
          if (!self.containsObject(this.rawUserGroups[t], this.selectedgroups)) {
            self.loading = true;
            __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].unassignUserFromGroup(apiUrl + '/auth/groups/' + this.rawUserGroups[t].id + '/users/' + self.editUserId).then(function (response) {
              self.loading = false;
            }).catch(function (err) {
              self.loading = false;
              console.log("create Insert CF Error: ", err);
            });
          }
          if (t === this.rawUserGroups.length - 1) {
            self.goToUserManagement();
            self.updatesuccess = true;
          }
        }
        if (this.rawUserGroups.length === 0) {
          self.goToUserManagement();
          self.updatesuccess = true;
        }
      }
    },
    containsObject: function containsObject(obj, list) {
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i].id === obj.id) {
          return true;
        }
      }
      return false;
    },
    isChildren: function isChildren(id) {
      for (var r = 0; r < this.selectedgroups.length; r++) {
        if (this.selectedgroups[r].appId === id) {
          return true;
        }
      }
      return false;
    },
    goToExistingUser: function goToExistingUser() {
      var self = this;
      self.$root.$emit('updatetoggle', [self.existingUserObj.profile.firstName, self.existingUserObj.profile.lastName, self.existingUserObj.profile.login, self.existingUserObj.id]);
    },
    clearSelectedOptions: function clearSelectedOptions() {
      var self = this;
      $('input[name=bulkUpload]').attr('checked', false);
      self.optionsNotSelected = false;
    },
    submitFile: function submitFile(isReinvite) {
      var _this3 = this;

      var self = this;
      self.clearSelectedOptions();
      if (isReinvite) {
        self.loading = true;
        var adminsGroupIds = [];
        JSON.parse(__WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get("grpsOfUser")).forEach(function (x) {
          adminsGroupIds.push(x.id);
        });
        var adminEmail = __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get("email");
        var formData = new window.FormData();
        formData.append('file', this.file);
        formData.append('adminsGroupIds', adminsGroupIds);
        formData.append('adminEmail', adminEmail);
        $('.bulkReinviteModal').modal('hide');
        __WEBPACK_IMPORTED_MODULE_14_axios___default.a.post(apiUrl + '/auth/uploadusers/reInvite', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
          self.loading = false;
          console.log(response.data);
          self.reInviteMessage = response.data.Status;
          $('.bulkReinviteMessageModal').modal('show');
          self.clearFile();
        }).catch(function (error) {
          self.loading = false;
          console.log(error.response);
          $('.bulkReinviteModal').modal('hide');
          if (error.response.status === 406) {
            self.reInviteMessage = "Maximum users allowed is 50";
          } else if (error.response.status === 400) {
            self.reInviteMessage = error.response.data.Status;
          } else {
            self.reInviteMessage = 'Something went wrong. please check the data and try again';
          }
          $('.bulkReinviteMessageModal').modal('show');
          self.clearFile();
        });
      } else {
        self.loading = true;
        var adminToGroups = this.appAdminGroupModal.filter(function (x) {
          return [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(_this3.adminTo))).indexOf(x.applicationId) > -1;
        }).map(function (x) {
          return x.subGroupId;
        }).flat(1).map(function (x) {
          return x.split('~~~')[0];
        }).join(',');
        var _formData = new window.FormData();
        _formData.append('file', this.file);
        _formData.append('groupids', adminToGroups);
        $('.bulkCreateModal').modal('hide');
        __WEBPACK_IMPORTED_MODULE_14_axios___default.a.post(apiUrl + '/auth/uploadusers', _formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
          self.loading = false;
          console.log(response.data);
          if (response.data && response.data.length > 0) {
            var n = "Submitted Successfully.\n\nBelow Users are not successfully processed:\n\n" + response.data.map(function (i) {
              return "Email: " + i.email + "\nError: " + i.error;
            }).join('\r\n\n');
            window.alert(n);
          } else {
            window.alert('Users are created Successfully!');
          }
          self.clearFile();
        }).catch(function (e) {
          self.loading = false;
          $('.bulkCreateModal').modal('hide');
          if (e.response && e.response.status === 406) {
            window.alert(e.response.data);
          } else {
            window.alert('Something went wrong. please check the data and try again');
          }
          self.clearFile();
        });
      }
    },
    handleFileUpload: function handleFileUpload(isReinvite) {
      this.file = isReinvite ? this.$refs.reinviteFile.files[0] : this.$refs.file.files[0];
      var filename = this.file.name;
      if (filename.slice(filename.lastIndexOf('.')).indexOf('xl') === -1) {
        window.alert('Only Excel file type is allowed.');
        this.clearFile();
        this.isExcel = false;
      } else {
        this.isExcel = true;
      }
    },
    clearFile: function clearFile() {
      var _this4 = this;

      this.uploadReady = false;
      this.$nextTick(function () {
        _this4.uploadReady = true;
      });
    },
    showBulkUploadWindow: function showBulkUploadWindow() {
      $('.bulkUploadOptionsModal').modal('show');
    },
    openbulkModals: function openbulkModals() {
      var self = this;
      var isChecked = $('input[name=bulkUpload]:checked').size() > 0;
      if (isChecked) {
        var selectedId = $('input[name=bulkUpload]:checked').attr('id');
        if (selectedId === "bulkCreate") {
          $('.bulkCreateModal').modal('show');
        } else {
          $('.bulkReinviteModal').modal('show');
        }
        $('.bulkUploadOptionsModal').modal('hide');
      } else {
        self.optionsNotSelected = true;
      }
    },
    resetTotalCount: function resetTotalCount() {
      this.reportTotalCount = undefined;
    },
    downloadUsersOfGroupRecursively: function downloadUsersOfGroupRecursively(nextSet) {
      var self = this;
      self.loading = true;
      self.showProgress = true;
      if (nextSet === undefined) {
        nextSet = '/groupReport/' + self.selectedGroupId + '/users?limit=1000';
        self.downloadReportSet = [];
        console.log("Download Start: " + new Date());
      }
      if (self.reportTotalCount === undefined) {
        __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getGroupStats(apiUrl + '/auth/groups/' + self.selectedGroupId).then(function (res) {
          self.reportTotalCount = res.data._embedded.stats.usersCount;
          __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getUserDetailsOfGroup(apiUrl + '/auth' + nextSet).then(function (response) {
            self.loading = false;
            self.downloadReportSet = self.downloadReportSet.concat(response.data);
            nextSet = response.headers.page;
            if (self.downloadReportSet.length < self.reportTotalCount && nextSet !== undefined) {
              self.downloadUsersOfGroupRecursively(nextSet);
            } else {
              console.log(self.downloadReportSet.length);
              self.showProgress = false;
              self.jsonToExcel(self.downloadReportSet, 'report', true);
              console.log("Download End: " + new Date());
            }
          }).catch(function (e) {
            self.loading = false;
            self.showProgress = false;
            window.alert('Something went wrong. Try again later!');
            console.log(e);
          });
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_10__idm_api__["default"].getUserDetailsOfGroup(apiUrl + '/auth' + nextSet).then(function (response) {
          self.loading = false;
          self.downloadReportSet = self.downloadReportSet.concat(response.data);
          nextSet = response.headers.page;
          if (self.downloadReportSet.length < self.reportTotalCount && nextSet) {
            self.downloadUsersOfGroupRecursively(nextSet);
          } else {
            console.log(self.downloadReportSet.length);
            self.showProgress = false;
            self.jsonToExcel(self.downloadReportSet, 'report', true);
            console.log("Download End: " + new Date());
          }
        }).catch(function (e) {
          self.loading = false;
          self.showProgress = false;
          window.alert('Something went wrong. Try again later!');
          console.log(e);
        });
      }
    },
    jsonToExcel: function jsonToExcel(JSONData, FileTitle, ShowLabel) {
      JSONData = JSONData ? JSONData : [{ "sdf": "sdd" }];
      var arrData = (typeof JSONData === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(JSONData)) !== 'object' ? JSON.parse(JSONData) : JSONData;
      var CSV = '';

      if (ShowLabel) {
        var row = "";

        for (var index in arrData[0]) {
          row += index + ',';
        }
        row = row.slice(0, -1);

        CSV += row + '\r\n';
      }

      for (var i = 0; i < arrData.length; i++) {
        var Row = "";

        for (var Index in arrData[i]) {
          Row += '"' + arrData[i][Index] + '",';
        }
        Row.slice(0, Row.length - 1);

        CSV += Row + '\r\n';
      }
      if (CSV === '') {
        window.alert("Invalid data");
        return;
      }

      var filename = FileTitle;
      var blob = new __WEBPACK_IMPORTED_MODULE_8_blob__["a" /* default */](['\uFEFF' + CSV], {
        type: 'text/csv;charset=utf-8;'
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          var url = window.URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.style = "visibility:hidden";
          link.download = filename + ".csv";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }
  },
  watch: {
    selectedAppId: function selectedAppId() {
      this.searchTerm = '';
    },
    selectedGroupId: function selectedGroupId() {
      this.searchTerm = '';
    },
    searchTerm: function searchTerm() {},
    globalsearch: function globalsearch() {
      this.searchTerm = '';
    }
  },
  data: function data() {
    return {
      downloadReportSet: [],
      reportTotalCount: undefined,
      appUrl: document.location.href,
      checkedAppBrand: '',
      adminToBrands: [],
      brandDetails: brandDetails,
      admingrpmodalfirstsubgrpidlist: [],
      isAzureORInternalIdentities: false,
      selectedIndiegroups: [],
      indieGroupsAdministered: [],
      appAdminGroupModal: [],
      updateToggle: false,
      resetSuccess: false,
      activateSuccess: false,
      deactivateSuccess: false,
      deleteSuccess: false,
      activatedemail: '',
      isShow: false,
      showDropDown: false,
      lang: __WEBPACK_IMPORTED_MODULE_12__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_12__i18n_locale_js__["locale"].lang_obj,
      lang_def: __WEBPACK_IMPORTED_MODULE_12__i18n_locale_js__["locale"].lang_def,
      addUserClicked: false,
      deactivateForm: false,
      row: {},
      searchTerm: '',
      userrole: '',
      customerTaxId: '',
      combined_name_and_tax_id: '',
      searchUser: '',
      oktauserId: '',
      email: '',
      customers: {},
      loading: false,
      user_lang: {},
      grouplist: [],
      editUserApps: [],
      selectedAppId: '',
      addUserFirstName: '',
      addUserLastName: '',
      addUserPrimaryEmail: '',
      addUserSecondaryEmail: '',
      addUserGroupIds: [],
      addUserValidations: [],
      prefLang: '',
      brand: '',
      userCreationMessage: '',
      adminItem: {
        name: 'Admin',
        displayName: "Administração",
        to: '/Admin'
      },
      listToMultiselect: [],
      availablegroups: [],
      selectedgroups: [],
      appGroupMap: {},
      rawUserGroups: [],
      editUserId: '',
      adminAppsArray: [],
      updatesuccess: false,
      appList: [],
      uniqueAppList: [],
      selectedGroupId: '',
      userAlreadyExists: false,
      loggedInUser: __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('email'),
      globalsearch: false,
      adminTo: [],
      selectedGroupsOutsideAdmin: [],
      onecargillusersgroupid: onecargillapplicationgroupid,
      onecargilladmingroupid: onecargilladmingroupid,
      adminType: __WEBPACK_IMPORTED_MODULE_15__helpers_storage__["default"].get('cf-userRole'),
      file: '',
      isExcel: false,
      uploadReady: true,
      dxpList: [],
      nonDxpList: [],
      appGrpList: [],
      hostName: window.location.host,
      indieGroupsForNewUser: [],
      showProgress: false,
      showDateFields: false,
      isEdit: false,
      userFactorList: [],
      isChecked: false,
      selectedFactorId: '',
      errorMsgForMFA: "",
      mfaResetSuccess: false,
      isAuthorizedForMFA: false,
      isNameEditable: false,
      noFactorSelected: false,
      isAzureId: false,
      isServiceAccountGroupMember: false,
      reInviteMessage: '',
      optionsNotSelected: false,
      showTransformedEmail: false,
      noEditForWhitelabel: false,
      isServiceAccGrpPresent: false,
      emailTransformed: '',
      userGroups: [],
      adminConfigFiltered: [],
      userAppList: [],
      dateInfo: { createdDate: '', activatedDate: '', lastLogin: '', lastUpdated: '', passwordChanged: '', statusChanged: '' }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_widgets_NoTopNavFooter__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_widgets_NoTopNavFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_widgets_NoTopNavFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_custom_error__ = __webpack_require__(166);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Error',
  components: {
    NoTopNavFooter: __WEBPACK_IMPORTED_MODULE_0__components_widgets_NoTopNavFooter___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a
  },
  data: function data() {
    return {
      stateToken: '',
      isMobile: "ontouchstart" in document.documentElement,
      loading: false,
      lang: __WEBPACK_IMPORTED_MODULE_2__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_2__i18n_locale_js__["locale"].lang_obj,
      user_lang: {},
      accessDenied: true,
      isMMApp: false,
      location: window.location.href,
      customErrorMsg: '',
      customContact: ''
    };
  },

  props: {},
  computed: {},
  created: function created() {
    var self = this;
    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
    });
    $(document).on('click', '#okta-signin-submit, #cargillLogin', function () {
      self.accessDenied = false;
    });
    if (self.location.indexOf('app=milkMoovement') > -1) {
      self.isMMApp = true;
    }
    self.getAppDetails();
  },
  mounted: function mounted() {},

  methods: {
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    getAppDetails: function getAppDetails() {
      var self = this;
      var appName = self.getParameterByName('app', self.location);
      var appDetails = __WEBPACK_IMPORTED_MODULE_4__helpers_custom_error__["default"].getCustomErrorMsg(appName);
      self.customErrorMsg = appDetails.msg;
      self.customContact = appDetails.contact;
    },

    getParameterByName: function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      var results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_NoTopNavFooter__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_NoTopNavFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_widgets_NoTopNavFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_storage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jwt_decode__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_okta__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__idm_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__event_bus_js__ = __webpack_require__(12);







var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";






var onecargilladmingroupid = "00gf4o186i1L3hcDw0h7";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'logging-in',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default.a,
    NoTopNavFooter: __WEBPACK_IMPORTED_MODULE_3__components_widgets_NoTopNavFooter___default.a
  },
  created: function created() {
    var _this = this;

    var self = this;
    console.log('dev app--------------------------');
    var appname = __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].get('samlapp');
    if (appname !== '') {
      __WEBPACK_IMPORTED_MODULE_8__idm_api__["default"].getGroupsByUserId(apiUrl + '/auth/apps/' + appname + '/search').then(function (response) {
        console.log('redirect to :' + response.data[0]._links.appLinks[0].href);
        window.open(response.data[0]._links.appLinks[0].href, '_self');
      }).catch(function (err) {
        self.loading = false;
        console.log("create Insert CF Error: ", err);
        if (window.location.hash.split('&')[1].split('=')[0] === 'error') {
          __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].clearAll();
          __WEBPACK_IMPORTED_MODULE_7__helpers_okta__["default"].oktaSignOut(window.location.hash.split('&')[1].split('=')[1]);
        }
      });
    } else {
      setTimeout(function () {
        self.loading = true;
        var idt = '';
        var userId = '';
        if (window.location.hash !== undefined && window.location.hash !== '') {
          if (window.location.hash.split('&')[1].split('=')[0] === 'error') {
            __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].clearAll();
            __WEBPACK_IMPORTED_MODULE_7__helpers_okta__["default"].oktaSignOut(window.location.hash.split('&')[1].split('=')[1]);
          }
          idt = window.location.hash.split('&')[0].split('=')[1];
          var jwt = __WEBPACK_IMPORTED_MODULE_6_jwt_decode___default()(idt);
          if (window.location.hash.split('&')[0].split('=')[0].indexOf('access_token') > -1) {
            __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].set('access_token', window.location.hash.split('&')[0].split('=')[1]);
            userId = jwt.uid;
          } else {
            userId = jwt.sub;
          }
          __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].set('cf-user', { 'sub': userId });
          console.log("userIduserId" + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_6_jwt_decode___default()(idt)));
        } else {
          if (__WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].get('okta-token-storage')) {
            userId = __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].get('okta-token-storage').accessToken.claims.uid;
            var accessToken = __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].get('okta-token-storage').accessToken.accessToken;
            __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].set('access_token', accessToken);
            __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].set('cf-user', { 'sub': userId });
            userId = __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].get('cf-user').sub;
          } else {
            self.$router.push({ path: '/Login' });
          }
        }

        _this.setUserLocale(userId);

        var adminGroupsArr = [];
        var adminAppsArr = [];
        __WEBPACK_IMPORTED_MODULE_8__idm_api__["default"].getListOfAdminConfig(apiUrl + '/auth/appGroupList').then(function (response) {
          adminGroupsArr = response.data.map(function (i) {
            return i.groupId;
          });
          adminAppsArr = response.data.map(function (i) {
            return i.applicationId;
          });
          __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].set('adminConfigMaster', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(response.data));
          __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].set('adminConfigJSON', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(adminGroupsArr));
          __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].set('adminConfigJSONApps', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(adminAppsArr));
          __WEBPACK_IMPORTED_MODULE_8__idm_api__["default"].getGroupsByUserId(apiUrl + '/auth/users/' + userId + '/groups').then(function (response) {
            __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].set('grpsOfUser', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(response.data));
            __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].set('isServiceAccountGroupMember', response.data.filter(function (x) {
              return x.profile.name.toLowerCase().indexOf('service accounts') > -1;
            }).length > 0 ? true : false);
            var isSuperAdmin = false;
            var isAdmin = false;

            var adminToArr = [];
            adminToArr = response.data.filter(function (i) {
              if (adminGroupsArr.indexOf(i.id) > -1) {
                return i;
              }
            });
            for (var w = 0; w < response.data.length; w++) {
              if (response.data[w].id === onecargilladmingroupid) {
                isSuperAdmin = true;
              }
            }
            if (adminToArr.length > 0) {
              isAdmin = true;
            }
            if (isSuperAdmin) {
              __WEBPACK_IMPORTED_MODULE_4__store__["default"].commit('setUserRole', 'superadmin');
              self.$router.push({ name: 'Admin' });
            } else if (isAdmin) {
              __WEBPACK_IMPORTED_MODULE_4__store__["default"].commit('setUserRole', 'admin');
              self.$router.push({ name: 'Admin' });
            } else {
              __WEBPACK_IMPORTED_MODULE_4__store__["default"].commit('setUserRole', 'notadmin');
              self.$router.push({ name: 'MyProfile' });
            }
          }).catch(function (err) {
            self.loading = false;
            console.log("create Insert CF Error: ", err);
          });
        }).catch(function (err) {
          console.log(err);
        });
      }, 1000);
    }
  },

  methods: {
    setUserLocale: function setUserLocale(loginId) {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_8__idm_api__["default"].getUserIdByEmail(apiUrl + '/auth/users/' + loginId).then(function (response) {
        self.loading = false;
        __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].set('idprovider', response.data.credentials.provider.type.toLowerCase());
        var profileLang = response.data.profile.locale;
        console.log("profileLang" + profileLang);
        if (profileLang !== undefined) {
          if (profileLang !== null && profileLang.trim() !== '') {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_9__i18n_locale_js__["locale"].lang_obj).forEach(function (i) {
              if (profileLang.toLowerCase().indexOf(i.toLowerCase()) > -1) {
                __WEBPACK_IMPORTED_MODULE_9__i18n_locale_js__["locale"].lang = i;
                __WEBPACK_IMPORTED_MODULE_10__event_bus_js__["EventBus"].$emit('lang', i);
              }
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_9__i18n_locale_js__["locale"].lang = 'en_US';
            __WEBPACK_IMPORTED_MODULE_10__event_bus_js__["EventBus"].$emit('lang', 'en_US');
          }
          __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].set('user-lang', __WEBPACK_IMPORTED_MODULE_9__i18n_locale_js__["locale"].lang);
        } else {
          __WEBPACK_IMPORTED_MODULE_9__i18n_locale_js__["locale"].lang = 'en_US';
          __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].set('user-lang', 'en_US');
          __WEBPACK_IMPORTED_MODULE_10__event_bus_js__["EventBus"].$emit('lang', 'en_US');
        }
      });
    }
  }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_widgets_NoTopNavFooter__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_widgets_NoTopNavFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_widgets_NoTopNavFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_okta__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_storage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__idm_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_64__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_base_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_translationConfig__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_okta_config__ = __webpack_require__(87);













var orgUrl = window.location.href.indexOf("mycargill") > -1 ? "https://login-stage.mycargill.com/" : "https://cargillcustomer-uat.oktapreview.com/";
var ssoUrl = window.location.href.indexOf("mycargill") > -1 ? "sso/saml2/0oauwh443dqUyH3pe0h7?fromURI=https%3A%2F%2Fidentityservices-deprecated.stage.mycargill.com%2FLogin" : "sso/saml2/0oaerr17abt1nX0gO0h7?fromURI=https%3A%2F%2Fcargillcustomer-deprecated.stage.cglcloud.in%2FLogin";
var brandDetails = "";
var environment = "stage";
if (environment === 'production') {
  brandDetails = __webpack_require__(16);
} else if (environment === 'stage') {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
var brand = brandDetails.data.filter(function (i) {
  return i.applicationUrls.indexOf(document.location.host) > -1;
});
var browserEnv = '';
if (document.location.host.indexOf('dev.cglcloud.in') > -1 || document.location.host.indexOf('localhost') > -1) {
  browserEnv = 'Dev';
} else if (document.location.host.indexOf('stage.cglcloud.in') > -1) {
  browserEnv = 'Stage';
} else {
  browserEnv = 'Prod';
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  components: {
    NoTopNavFooter: __WEBPACK_IMPORTED_MODULE_0__components_widgets_NoTopNavFooter___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner___default.a
  },
  data: function data() {
    return {
      samlappname: '',
      brandDetails: brandDetails,
      stateToken: '',
      isMobile: "ontouchstart" in document.documentElement,
      loading: true,
      loginErrors: [],
      resetOptionErrors: [],
      verifyCodeErrors: [],
      resetPasswordErrors: [],
      isFromUserReg: true,
      lang: __WEBPACK_IMPORTED_MODULE_6__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_6__i18n_locale_js__["locale"].lang_obj,
      user_lang: {},
      toggleHelp: false,
      forgotPassword: false,
      resetviaSMS: false,
      resetviaEmail: false,
      mailForReset: '',
      userIdForReset: '',
      countdown_number: 30,
      username: '',
      password: '',
      smsStatus: '',
      resetpassword: '',
      repeatpassword: '',
      passwordPolicyArray: [],
      currPwdPolicy: {},
      pwdComplexity: {},
      pwdErrorArray: [],
      secQuestionErrorArray: [],
      smsFactorId: '',
      stateTokenToResetBySMS: '',
      OTP: '',
      codeVerified: false,
      secQuestionVerified: false,
      recoveryQuestion: '',
      securityAnswer: '',
      minSecurityAnswerLength: '',
      accessDenied: false,
      ssoLangs: __WEBPACK_IMPORTED_MODULE_8__helpers_translationConfig__["default"],
      connectingToLangs: { 'id': 'Terhubung ke',
        'pt-br': 'Conectando à',
        'pl': '�?ączenie z',
        'es': 'Conectado a',
        'en': 'Connecting to' },
      ssoLoginTxt: 'Sign In as an Employee',
      connectingToText: 'Connecting to',
      samlRD: '',
      loginBrandTopText: '',
      loginBrandBottomText: '',
      linkToOldEc: '',
      brandCode: '',
      isEmployeeLoginRequired: true
    };
  },

  props: {},
  computed: {},
  created: function created() {
    var self = this;

    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_7__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
    });
    $(document).on('click', '#okta-signin-submit, #cargillLogin', function () {
      self.accessDenied = false;
    });
    $(document).on('click', '.linkToOldEc', function (e) {
      window.open(e.innerText, '_blank');
    });
  },
  mounted: function mounted() {
    this.getBrandName();
    __WEBPACK_IMPORTED_MODULE_1__helpers_okta__["default"].oktaSignIn();
    var bUrl = document.location.href;
    this.onMountLogin(bUrl);
    __WEBPACK_IMPORTED_MODULE_1__helpers_okta__["default"].oktaWidgetRendered(this.proceedUnlock);
  },

  methods: {
    proceedUnlock: function proceedUnlock() {
      if (window.location.href.indexOf('action=unlock') > -1) {
        document.querySelector('.js-unlock').click();
      }
    },
    onMountLogin: function onMountLogin(bUrl) {
      var fromLogin = this.getParameterByName('fromLogin', bUrl);
      console.log('return url:' + this.getParameterByName('ReturnUrl', bUrl));
      var rd = this.getParameterByName('rd', bUrl);
      var isRdEncode = this.getParameterByName('encode', bUrl);
      if (rd === undefined || rd === null || rd.trim() === '') {
        rd = this.getParameterByName('ReturnUrl', bUrl);
      } else {
        isRdEncode = true;
      }
      if (rd !== undefined && rd !== null && rd.trim() !== '') {
        if (isRdEncode === 'true') {
          rd = __WEBPACK_IMPORTED_MODULE_4_base_64___default.a.decode(rd);
        }
        this.samlRD = ssoUrl.split('=')[0] + '=' + rd;
      }
      var browserLang = 'en';
      var custLang = this.getParameterByName('lang', bUrl);
      console.log("urllang" + custLang);
      if (navigator.userLanguage !== undefined) {
        browserLang = navigator.browserLanguage;
        console.log("browserLang: if " + browserLang);
      } else {
        browserLang = navigator.language;
        console.log("browserLang: else " + browserLang);
      }
      browserLang = custLang != null ? custLang : browserLang;
      console.log("urllang after custLang" + browserLang);
      if (browserLang.startsWith('zh')) {
        if (browserLang.indexOf('zh_CN')) {
          browserLang = 'cn';
        } else {
          browserLang = 'bg';
        }
      } else {
        browserLang = browserLang.replace("_", "-");
        console.log("browserLang: after replace " + browserLang);
        browserLang = __WEBPACK_IMPORTED_MODULE_9__helpers_okta_config__["default"].getBrowserLanguage(browserLang);
        console.log("browser language: final " + browserLang);
      }
      this.ssoLoginTxt = this.ssoLangs[browserLang];
      this.connectingToText = this.connectingToLangs[custLang ? custLang.toLowerCase() : 'en'];
      if (fromLogin !== true && fromLogin !== 'true') {
        __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].set('samlapp', '');
      }
      var stateToken = this.getParameterByName('stateToken', bUrl);
      var fromURI = this.getParameterByName('fromURI', bUrl);
      var self = this;
      self.loading = false;
      var regex = new RegExp("access_denied");
      if (regex.test(bUrl)) {
        self.accessDenied = true;
      }
      if (stateToken !== undefined && stateToken !== null && stateToken !== '') {
        this.stateToken = stateToken;
        var data = {
          "stateToken": stateToken
        };
        __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getCurrentState(data).then(function (response) {
          console.log(response.data._embedded.target.name);
          $('#saml-logo').attr('src', response.data._embedded.target._links.logo.href);
          self.samlappname = response.data._embedded.target.label;

          document.title = response.data._embedded.target.label;
          __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].set('samlapp', '');
        });
      } else if (fromURI !== undefined && fromURI !== null && fromURI !== '') {
        var deconstruct = fromURI.split('/');
        var appname = deconstruct.indexOf('app') > -1 ? deconstruct[deconstruct.indexOf('app') + 1] : '';

        console.log(appname);
        __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].set('samlapp', '');
      }
    },
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    openCargillUserLogin: function openCargillUserLogin() {
      var url = orgUrl + (this.samlRD.trim() !== '' ? this.samlRD : ssoUrl);
      var samlProviderId = ssoUrl.split('/')[2].substr(0, ssoUrl.split('/')[2].indexOf('?'));
      if (window.location.href.toLowerCase().indexOf('cargill') === -1) {
        url = orgUrl + 'sso/saml2/' + samlProviderId + '?fromURI=' + window.location.href;
      }
      window.open(url, '_self');
    },

    getParameterByName: function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      var results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    getBrandName: function getBrandName() {
      var self = this;
      var bgimg = brand.length ? brand[0].bgImageLink.trim() : '';
      this.brandCode = brand.length ? brand[0].brandCode : '';
      this.isEmployeeLoginRequired = brand.length ? brand[0].isEmployeeLoginRequired : true;
      this.loginBrandTopText = brand.length ? brand[0].LoginWidgetTopContent : '';
      var loginBrandBottomText = brand.length ? brand[0].LoginWidgetBottomContent : '';
      var linkToOldEc = brand.length ? brand[0]['linkToOldEC-' + browserEnv] : '';
      this.linkToOldEc = '<span class="linkToOldEc">' + linkToOldEc + '</span>';
      this.loginBrandBottomText = loginBrandBottomText.replace("<INSERT LINK TO OLD EC ENVIRONMENT>", this.linkToOldEc);
      if ($('.splash').length !== 0) {
        if (bgimg !== '') {
          if (bgimg.indexOf('#') !== 0) {
            console.log('before' + $('.splash').attr("src"));
            $('.splash').attr("src", bgimg);
            console.log('after' + $('.splash').attr("src"));
          } else {
            $('.splash').attr("src", "");
            $('.splash').css("background", bgimg);
          }
        }
        if (self.brandCode === '007') {
          setTimeout($('.splash').addClass('opacBg'), 500);
        }
        setTimeout($('.splash').removeClass('hiddden'), 500);
      }
      console.log(self.brandCode);
      setTimeout(function () {
        if ($('.auth-org-logo').length !== 0 && brand.length && brand[0].brandName.toLowerCase() === 'agresource') {}
        if (self.brandCode === '007') {
          document.getElementsByClassName('auth-header')[0].style.paddingBottom = '0px';
        }
      }, 1000);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_widgets_TopNavFooter__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_widgets_TopNavFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_widgets_TopNavFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UserTable__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UserTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_UserTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__idm_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_storage__ = __webpack_require__(5);










var islowerCase = '^(?=.*[a-z])';
var isUpperCase = '^(?=.*[A-Z])';
var isNumber = '^(?=.*[0-9])';
var isSpecialChar = '^(?=.*[!@#$%^&*-])';
var isMinLength = '^(?=.{8,})';
var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'admin',
  components: {
    TopNavFooter: __WEBPACK_IMPORTED_MODULE_1__components_widgets_TopNavFooter___default.a,
    UserTable: __WEBPACK_IMPORTED_MODULE_2__components_UserTable___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default.a
  },
  created: function created() {
    var self = this;
    self.updateAdminConfigsInLocal();
    self.userId = __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].get('cf-user').sub;
    if (__WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].get('idprovider') !== 'federation' || self.isServiceAccountGroupMember) {
      self.getPasswordPolicy();
    }
    self.checkPhoneNumber();
    self.getApps();
    this.user_lang = this.lang_br;
    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
    });
    self.$root.$on('activatesuccess', function () {
      self.resetSuccess = true;
    });
    $(document).on('keypress', 'input', function () {
      self.keyPressHandler();
    });
    $(window).on('beforeunload', function () {
      self.beforeUnloadHandler();
    });
    $(document).on('mousedown', '.donotedit', function (e) {
      e.preventDefault();
    });
    $(document).on('click', '#loggout, .nav-item a', function () {
      self.beforeLoggoutHandler();
    });
  },
  mounted: function mounted() {
    var self = this;
    self.listofsecquestions = __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].get('listofsecquestions');
    self.isServiceAccountGroupMember = __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].get('isServiceAccountGroupMember');
    self.isAzureUser = __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].get('idprovider') === 'federation' ? true : false;
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  },

  watch: {
    codeSent: function codeSent(newVal, oldVal) {
      this.watchcodeSent(newVal, oldVal);
    },
    phN: function phN() {
      this.watchphN();
    },
    passwordsec: function passwordsec() {
      this.watchpasswordsec();
    },
    phnsec: function phnsec() {
      this.watchphnsec();
    },
    secqsec: function secqsec() {
      this.watchsecqsec();
    }
  },
  methods: {
    beforeLoggoutHandler: function beforeLoggoutHandler() {
      var self = this;
      if (self.codeSent) {
        self.enableEdit = false;
      }
    },
    beforeUnloadHandler: function beforeUnloadHandler() {
      var self = this;
      if (self.codeSent) {
        self.setBackOldActiveNumber();
      }
    },
    keyPressHandler: function keyPressHandler() {
      var self = this;
      self.formValidationObj = [];
      self.phoneValidationObj = [];
      self.QAValidationObj = [];
      self.error30SecOTP = false;
      self.phoneNumberNotValid = false;
    },
    watchcodeSent: function watchcodeSent(newVal, oldVal) {
      var self = this;
      if (oldVal && !newVal) {
        self.setBackOldActiveNumber();
      }
    },
    watchphN: function watchphN() {
      var self = this;
      if (self.countryCode === '1') {
        var x = self.phN.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        self.phN = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
      }
    },
    watchpasswordsec: function watchpasswordsec() {
      var self = this;
      if (self.passwordsec) {
        self.phnsec = false;
        self.secqsec = false;
      }
    },
    watchphnsec: function watchphnsec() {
      var self = this;
      if (self.phnsec) {
        self.passwordsec = false;
        self.secqsec = false;
      }
    },
    watchsecqsec: function watchsecqsec() {
      var self = this;
      if (self.secqsec) {
        self.passwordsec = false;
        self.phnsec = false;
      }
    },
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    onf: function onf(e) {
      var self = this;
      if (document.getElementById('pn').hasAttribute('readonly')) {
        console.log(self.isTriggered);
        document.getElementById('pn').removeAttribute('readonly');
        self.isTriggered = true;
        document.getElementById('pn').blur();
        document.getElementById('pn').focus();
      }
    },
    onb: function onb(e) {
      var self = this;
      if (self.isTriggered) {
        self.isTriggered = false;
        e.stopPropagation();
        console.log('triggered by code');
        return;
      } else {
        console.log('triggered by mouse');
        if (!document.getElementById('pn').hasAttribute('readonly')) {
          document.getElementById('pn').setAttribute('readonly', true);
        }
      }
    },
    goToApp: function goToApp(url) {
      window.open(url, '_blank');
    },
    getPasswordPolicy: function getPasswordPolicy() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getPasswordPolicy(apiUrl + '/auth/policies').then(function (response) {
        self.passwordPolicyArray = response.data;
        if (self.passwordPolicyArray.length === 1) {
          self.currPwdPolicy = response.data.filter(function (i) {
            if (i.name === 'Default Policy') return i;
          });
        } else {
          self.currPwdPolicy = response.data.filter(function (i) {
            if (i.name === 'Legacy Policy') return i;
          });
        }
        self.pwdComplexity = self.currPwdPolicy[0].settings.password.complexity;
        self.minAnswerLength = self.currPwdPolicy[0].settings.recovery.factors.recovery_question.properties.complexity.minLength;
        self.loading = false;
      });
    },
    checkPhoneNumber: function checkPhoneNumber() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getFactorByUserId(apiUrl + '/auth/users/' + self.userId + '/factors').then(function (response) {
        self.loading = false;
        var findSmsFactor = response.data.filter(function (x) {
          return x.factorType === 'sms';
        })[0];
        if (findSmsFactor) {
          if (findSmsFactor.status.toLowerCase() === 'active') {
            self.activeNo = findSmsFactor.profile.phoneNumber;
          } else {
            self.activeNo = '';
          }
          self.phone = findSmsFactor.profile.phoneNumber;
          if (findSmsFactor.status.toLowerCase().indexOf('pending') > -1) {
            self.factorStatus = self.user_lang.statuspending;
            self.clearTopNotification();
            self.activationpending = true;
          } else if (findSmsFactor.status.toLowerCase().indexOf('active') > -1) {
            self.factorStatus = self.user_lang.statusactive;
          } else {
            self.factorStatus = findSmsFactor.status;
          }
          self.smsFactorId = findSmsFactor.id;
        }
      });
    },

    getSecurityQuestion: function getSecurityQuestion() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getUserIdByEmail(apiUrl + '/auth/users/' + self.email).then(function (response) {
        if (response.data.profile.secondEmail) {
          self.addUserSecondaryEmail = response.data.profile.secondEmail;
        }
        if (response.data.credentials.recovery_question !== undefined) {
          var secq = response.data.credentials.recovery_question.question;
          var qKey = self.listofsecquestions && self.listofsecquestions.filter(function (x) {
            return x.questionText === secq;
          })[0].question;
          if (self.user_lang[qKey] !== undefined && qKey.indexOf('_') > -1) {
            self.selectedSecQN = qKey;
          } else {
            self.selectedSecQN = 'custom';
            self.custom_question = response.data.credentials.recovery_question.question;
          }
        }
      });
    },
    goBack: function goBack() {
      this.codeSent = false;
      this.setBackOldActiveNumber();
      this.phoneValidationObj = [];
    },
    reverseTransformEmail: function reverseTransformEmail(em) {
      if (em.toLowerCase().indexOf('@identity.mycargill.com') > -1 || em.toLowerCase().indexOf('@whitelabel.cargill.com') > -1 || em.toLowerCase().indexOf('@partneridentity.okta-emea.com') > -1) {
        em = em.substring(5, em.indexOf('@')).substring(0, em.substr(0, 2) - 1) + '@' + em.substring(5, em.indexOf('@')).substring(em.substr(0, 2) - 1);
      }
      return em;
    },
    getApps: function getApps() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getActiveAppNames(apiUrl + '/auth/apps/' + self.userId).then(function (response) {
        $('#userRegistration').css('display', 'block');
        var res = response.data.filter(function (y) {
          return y.name.toLowerCase() === 'oidc_client';
        });
        self.firstname = res[0]._embedded.user.profile.name.split(' ')[0];
        self.lastname = res[0]._embedded.user.profile.name.split(' ')[1];
        self.email = res[0]._embedded.user.profile.login ? res[0]._embedded.user.profile.login : res[0]._embedded.user.profile.email;
        __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].set('email', res[0]._embedded.user.profile.login ? res[0]._embedded.user.profile.login : res[0]._embedded.user.profile.email);
        self.reverseTransformedEmail = self.reverseTransformEmail(self.email);
        self.regApps = response.data.filter(function (item) {
          if (item.name.toLowerCase() !== 'oidc_client' && !item.visibility.hide.web) {
            return item;
          }
        });
        self.getSecurityQuestion();
        self.adminAppsArray = [];
        self.selectedgroups = [];
      }).catch(function (err) {
        self.loading = false;
        console.log("create Insert CF Error: ", err);
      });
    },
    editFields: function editFields() {
      var self = this;
      self.enableEdit = true;
      self.checkPhoneNumber();
      self.clearAllFieldsandValidations();
    },
    clearAllFieldsandValidations: function clearAllFieldsandValidations() {
      this.oldpassword = '';
      this.password = '';
      this.repeatpassword = '';
      this.formValidationObj = [];

      this.phoneValidationObj = [];
      this.QAValidationObj = [];
      this.codeSent = false;
      this.factorDeleted = false;
      this.error30SecOTP = false;
      this.phoneNumberNotValid = false;
      this.passwordsec = false;
      this.phnsec = false;
      this.secqsec = false;
      this.custom_question = '';
      this.answer = '';
      this.selectedSecQN = 'disliked_food';
    },
    validatePwdValues: function validatePwdValues() {
      this.formValidationObj = [];
      if (this.oldpassword.trim() === '' || this.password.trim() === '' || this.repeatpassword.trim() === '') {
        this.formValidationObj.push(this.user_lang.emptypassword);
        return false;
      } else if (this.pwdValidationObj.length) {
        this.formValidationObj.push(this.user_lang.passwordnotvalid);
        return false;
      } else if (this.repeatPwdValidationObj.length) {
        this.formValidationObj.push(this.user_lang.passwordnotmatching);
        return false;
      } else {
        return true;
      }
    },
    sendCode: function sendCode() {
      var self = this;
      self.phoneValidationObj = [];
      self.QAValidationObj = [];
      if (self.countryCode === '' || self.countryCode === undefined) {
        self.phoneValidationObj.push('Please select country code');
        return;
      }
      if (self.phN.replace(/\D/g, '').trim() === '' || !/^\d+$/.test(self.phN.replace(/\D/g, '').trim())) {
        self.phoneValidationObj.push('Please enter valid phone number');
        return;
      }
      self.loading = true;
      self.error30SecOTP = false;
      self.phoneNumberNotValid = false;
      self.iserror = false;
      var data = {
        "factorType": "sms",
        "provider": "OKTA",
        "profile": {
          "phoneNumber": "+" + this.countryCode.replace(/^0+/, '') + this.phN.replace(/\D/g, '')
        }
      };
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].deleteSMSFactor(apiUrl + '/auth/users/' + self.userId + '/factors/' + self.smsFactorId).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].sendCode(apiUrl + '/auth/users/' + self.userId + '/factors?updatePhone=true', data).then(function (response) {
          self.loading = false;
          if (response.data.status.toLowerCase() === 'active') {
            self.iserror = false;

            self.clearTopNotification();
            self.smsFactorId = response.data.id;
            self.errorCode = false;
            self.codeSent = false;
            self.factorDeleted = false;
            self.phoneupdated = true;
            self.enableEdit = false;
            self.phone = response.data.profile.phoneNumber;
          } else {
            self.codeSent = true;
            self.verifycode = '';
            self.smsFactorId = response.data.id;
          }
        }).catch(function (error) {
          console.log(error);
          self.loading = false;
          if (error.response.status === 429) {
            self.error30SecOTP = true;
          }
          if (error.response.status === 400) {
            self.phoneNumberNotValid = true;
          }
        });
      }).catch(function (error) {
        self.loading = false;
        console.log(error.response.status + ' ' + error.response.data);
        if (error.response.status === 404) {
          self.handle404Error(data);
        }
      });
    },
    handle404Error: function handle404Error(data) {
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].sendCode(apiUrl + '/auth/users/' + self.userId + '/factors?updatePhone=true', data).then(function (response) {
        self.loading = false;
        if (response.data.status.toLowerCase() === 'active') {
          self.iserror = false;

          self.clearTopNotification();
          self.smsFactorId = response.data.id;
          self.errorCode = false;
          self.codeSent = false;
          self.factorDeleted = false;
          self.phoneupdated = true;
          self.enableEdit = false;
          self.phone = response.data.profile.phoneNumber;
        } else {
          self.codeSent = true;
          self.verifycode = '';
          self.smsFactorId = response.data.id;
        }
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        if (error.response.status === 429) {
          self.error30SecOTP = true;
        }
        if (error.response.status === 400) {
          self.phoneNumberNotValid = true;
        }
      });
    },
    updatePhone: function updatePhone() {
      var self = this;
      self.factorDeleted = true;
    },
    updatePwd: function updatePwd() {
      var self = this;
      if (self.validatePwdValues()) {
        var data = { "oldPassword": { "value": self.oldpassword }, "newPassword": { "value": self.password } };
        __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].changePassword(apiUrl + '/auth/users/' + self.userId + '/changepassword', data).then(function (response) {
          self.clearTopNotification();
          self.pwdupdated = true;
          self.enableEdit = false;
        }).catch(function (error) {
          console.log(error);
          self.phoneValidationObj = [];
          self.QAValidationObj = [];
          self.formValidationObj.push(error.response.data.errorCauses[0].errorSummary);
        });
      }
    },

    validateSpecialCharacters: function validateSpecialCharacters(text) {
      var re = /^[\w-_.]*$/;
      return re.test(text);
    },
    validEmail: function validEmail(email) {
      var re = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(email);
    },
    updateName: function updateName() {
      var self = this;
      var validate = true;
      if (self.firstname.trim() === '') {
        validate = false;
      } else if (!this.validateSpecialCharacters(self.firstname.trim())) {
        validate = false;
      } else if (self.lastname.trim() === '') {
        validate = false;
      } else if (!this.validateSpecialCharacters(self.lastname.trim())) {
        validate = false;
      } else if (this.addUserSecondaryEmail.trim() !== '' && !this.validEmail(this.addUserSecondaryEmail)) {
        validate = false;
      }
      if (!validate) {
        return;
      }
      var data = { "profile": { "firstName": self.firstname, lastName: self.lastname, secondEmail: self.addUserSecondaryEmail } };
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].updateName(apiUrl + '/auth/users/updateUser?userId=' + self.userId, data).then(function (response) {
        self.clearTopNotification();
        self.nameUeUpdated = true;
        self.enableEdit = false;
      }).catch(function (error) {
        console.log(error);
        self.formValidationObj.push(error.response.data.errorSummary);
      });
    },
    verifySMS: function verifySMS() {
      var self = this;
      var data = { "passCode": self.verifycode };
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].verifyPasscodeOnFactorSetting(apiUrl + '/auth/users/' + self.userId + '/factors/' + self.smsFactorId + '/activate', data).then(function (response) {
        if (response.data.status === 'ACTIVE') {
          self.smsFactorId = response.data.id;
          self.clearTopNotification();
          self.errorCode = false;
          self.codeSent = false;
          self.factorDeleted = false;
          self.phoneupdated = true;
          self.enableEdit = false;
          self.activeNo = response.data.profile.phoneNumber;
          self.phone = response.data.profile.phoneNumber;
        } else {
          self.loading = false;
        }
      }).catch(function (error) {
        self.verifyPasscodeErrorHandler(error);
      });
    },
    verifyPasscodeErrorHandler: function verifyPasscodeErrorHandler(error) {
      console.log(error);
      var self = this;
      self.iserror = true;

      self.phoneValidationObj = [];
      self.QAValidationObj = [];
      self.phoneValidationObj.push(error.response.data.errorCauses[0].errorSummary);

      this.loading = false;
    },
    containsObject: function containsObject(obj, list) {
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i].id === obj.id) {
          return true;
        }
      }
      return false;
    },
    updateQA: function updateQA() {
      var self = this;
      self.loading = true;
      if (self.validateQA()) {
        var data = {
          "credentials": {
            "recovery_question": {
              "question": self.selectedSecQN === 'custom' ? self.custom_question : this.listofsecquestions.filter(function (x) {
                return x.question === self.selectedSecQN;
              })[0].questionText,
              "answer": self.answer
            }
          }
        };
        __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].setUserAccount(apiUrl + '/auth/users/' + self.userId, data).then(function (response) {
          self.loading = false;
          self.clearTopNotification();
          self.QAupdated = true;
          self.enableEdit = false;
          $('html, body').animate({ scrollTop: 0 }, 'fast');
        }).catch(function (error) {
          console.log(error);
          if (error.response.data.errorCauses !== undefined && error.response.data.errorCauses.length > 0) {
            self.QAValidationObj.push(error.response.data.errorCauses[0].errorSummary);
          }
          self.loading = false;
        });
      } else {
        self.loading = false;
      }
    },
    validateQA: function validateQA() {
      var _this = this;

      this.QAValidationObj = [];
      if (this.selectedSecQN === undefined || this.selectedSecQN === null || this.selectedSecQN === '') {
        this.QAValidationObj.push(this.user_lang.choose_forgot_pwd_qtn);
        return false;
      } else if (this.selectedSecQN === 'custom' && this.custom_question.trim() === '') {
        this.QAValidationObj.push(this.user_lang.customQuestionEmpty);
        return false;
      } else if (this.selectedSecQN === 'custom' && this.custom_question.trim() === this.answer.trim()) {
        this.QAValidationObj.push(this.user_lang.customQAsame);
        return false;
      } else if (this.answer.trim().length < this.minAnswerLength) {
        this.QAValidationObj.push(this.user_lang.answerlength.replace('$', this.minAnswerLength));
        return false;
      } else if (this.selectedSecQN === 'custom' && this.custom_question.trim().indexOf(this.answer.trim()) > -1) {
        this.QAValidationObj.push(this.user_lang.answerpartofquestion);
        return false;
      } else {
        var question = this.selectedSecQN === 'custom' ? this.custom_question.trim().toLowerCase() : this.listofsecquestions.filter(function (x) {
          return x.question === _this.selectedSecQN;
        })[0].questionText;
        question = question.replace('?', '');
        console.log(question);
        var questionWordsArray = question.trim().toLowerCase().split(' ');
        console.log(questionWordsArray);
        var answerWordsArray = this.answer.trim().toLowerCase().split(' ');
        console.log(answerWordsArray);
        var isWeak = questionWordsArray.some(function (r) {
          return answerWordsArray.indexOf(r) >= 0 && r.trim() !== '';
        });
        if (isWeak) {
          var term = questionWordsArray.filter(function (r) {
            return answerWordsArray.indexOf(r) >= 0 && r.trim() !== '';
          });
          console.log(term);
          this.user_lang.securityanswermatchesquestion = this.user_lang.copysecurityanswermatchesquestion.replace('$', "\"" + term + "\"");
          this.QAValidationObj.push(this.user_lang.securityanswermatchesquestion);
          return false;
        } else {
          this.QAValidationObj = [];
          return true;
        }
      }
    },
    setBackOldActiveNumber: function setBackOldActiveNumber() {
      if (this.activeNo === '') {
        return;
      }
      var self = this;
      var data = {
        "factorType": "sms",
        "provider": "OKTA",
        "profile": {
          "phoneNumber": this.activeNo
        }
      };
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].sendCode(apiUrl + '/users/' + self.userId + '/factors?activate=true', data).then(function (response) {
        self.smsFactorId = response.data.id;
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
      });
    },
    clearTopNotification: function clearTopNotification() {
      var self = this;
      self.phoneupdated = false;
      self.pwdupdated = false;
      self.QAupdated = false;
      self.activationpending = false;
    },
    updateAdminConfigsInLocal: function updateAdminConfigsInLocal() {
      var adminGroupsArr = [];
      var adminAppsArr = [];
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getListOfAdminConfig(apiUrl + '/auth/appGroupList').then(function (response) {
        adminGroupsArr = response.data.map(function (i) {
          return i.groupId;
        });
        adminAppsArr = response.data.map(function (i) {
          return i.applicationId;
        });
        __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].set('adminConfigMaster', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
        __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].set('adminConfigJSON', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(adminGroupsArr));
        __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].set('adminConfigJSONApps', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(adminAppsArr));
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  data: function data() {
    return {
      listofsecquestions: [],
      lang: __WEBPACK_IMPORTED_MODULE_5__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_5__i18n_locale_js__["locale"].lang_obj,
      addUserClicked: false,
      deactivateForm: false,
      row: {},
      userId: '',
      userrole: '',
      searchUser: '',
      oktauserId: '',
      email: '',
      reverseTransformedEmail: '',
      addUserSecondaryEmail: '',
      customers: {},
      passwordPolicyArray: [],
      formValidationObj: [],
      phoneValidationObj: [],
      QAValidationObj: [],
      currPwdPolicy: {},
      pwdComplexity: {},
      pwdErrorArray: [],
      loading: false,
      user_lang: {},
      firstname: '',
      lastname: '',
      prefLang: 'en_US',
      adminItem: {
        name: 'Admin',
        displayName: "Administração",
        to: '/Admin'
      },
      listToMultiselect: [],
      selectedgroups: [],
      enableEdit: false,
      regApps: [],
      oldpassword: '',
      password: '',
      repeatpassword: '',
      phone: '',
      pwdupdated: false,
      QAupdated: false,
      nameUpdated: false,
      smsFactorId: '',
      error30SecOTP: false,
      phoneNumberNotValid: false,
      codeSent: false,
      emptypasscode: false,
      passCodeInvalid: false,
      verifycode: '',
      factorDeleted: false,
      countryCode: '',
      phN: '',
      phoneupdated: false,
      adminAppsArray: [],
      factorStatus: '',
      selectedSecQN: '',
      custom_question: '',
      answer: '',
      minAnswerLength: '',
      activeNo: '',
      activationpending: false,
      isTriggered: false,
      passwordsec: false,
      phnsec: false,
      secqsec: false,
      isAzureUser: false,
      isServiceAccountGroupMember: false
    };
  },

  computed: {
    pwdValidationObj: function pwdValidationObj() {
      var errors = [];
      var minCharRegex = isMinLength.replace('8', this.pwdComplexity.minLength);

      if (this.password.trim().length > 0) {
        if (this.pwdComplexity.minLowerCase > 0 && !this.password.trim().match(new RegExp(islowerCase))) {
          errors.push(this.user_lang.noLowerCase);
        }
        if (this.pwdComplexity.minUpperCase > 0 && !this.password.trim().match(new RegExp(isUpperCase))) {
          errors.push(this.user_lang.noUpperCase);
        }
        if (this.pwdComplexity.minNumber > 0 && !this.password.trim().match(new RegExp(isNumber))) {
          errors.push(this.user_lang.noNumber);
        }
        if (this.pwdComplexity.minSymbol > 0 && !this.password.trim().match(new RegExp(isSpecialChar))) {
          errors.push(this.user_lang.noSpecialCharacter);
        }
        if (!this.password.trim().match(new RegExp(minCharRegex))) {
          errors.push(this.user_lang.notMinLength.replace('$', this.pwdComplexity.minLength));
        }
        if (this.pwdComplexity.excludeAttributes !== undefined && this.pwdComplexity.excludeAttributes.includes('lastName') && this.password.trim().indexOf(this.lastName) !== -1) {
          errors.push(this.user_lang.noLastnameSubstring);
        }
        if (this.pwdComplexity.excludeAttributes !== undefined && this.pwdComplexity.excludeAttributes.includes('firstName') && this.password.trim().indexOf(this.firstName) !== -1) {
          errors.push(this.user_lang.noFirstnameSubstring);
        }
        if (this.pwdComplexity.excludeUsername && this.email.indexOf(this.password.trim()) > -1) {
          errors.push(this.user_lang.noUsernameSubstring);
        }
        if (errors.length === 0) {
          this.pwdValid = true;
        }
      }
      this.pwdErrorArray = errors;
      return errors;
    },
    repeatPwdValidationObj: function repeatPwdValidationObj() {
      var errors = [];
      if (this.repeatpassword.trim().length > 0) {
        if (this.password.trim() !== this.repeatpassword.trim()) {
          errors.push(this.user_lang.passwordnotmatching);
        }
      }
      this.pwdErrorArray = errors;
      return errors;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_widgets_TopNavFooter__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_widgets_TopNavFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_widgets_TopNavFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__idm_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_storage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_blob__ = __webpack_require__(174);










var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";

var environment = "stage";
var brandDetails = "";
console.log('env=====', environment);
if (environment === 'production') {
  brandDetails = __webpack_require__(16);
} else if (environment === 'stage') {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tm',
  components: {
    TopNavFooter: __WEBPACK_IMPORTED_MODULE_0__components_widgets_TopNavFooter___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default.a
  },
  created: function created() {
    var self = this;
    self.userId = __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].get('cf-user').sub;
    self.email = __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].get('email');
    this.user_lang = this.lang_br;
    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
    });
  },
  mounted: function mounted() {},

  watch: {},
  methods: {
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    downloadReport: function downloadReport() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1__idm_api__["default"].downloadReport(apiUrl + '/auth/report/' + self.gid).then(function (response) {
        var blob = new __WEBPACK_IMPORTED_MODULE_6_blob__["a" /* default */]([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Report.xlsx';
        link.click();
      }).catch(function (error) {
        window.alert(error);
        self.loading = false;
      });
    }
  },
  data: function data() {
    return {
      brandDetails: brandDetails,
      lang: __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang_obj,
      userId: '',
      loading: false,
      user_lang: {},
      prefLang: 'en_US',
      gid: ''
    };
  },

  computed: {}
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_storage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__idm_api__ = __webpack_require__(20);







var islowerCase = '^(?=.*[a-z])';
var isUpperCase = '^(?=.*[A-Z])';
var isNumber = '^(?=.*[0-9])';
var isSpecialChar = '^(?=.*[!@#$%^&*-])';
var isMinLength = '^(?=.{8,})';
var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";
var internalUserDomains = __webpack_require__(78).data;

var environment = "stage";
var brandDetails = "";
console.log('env=====', environment);
if (environment === 'production') {
  brandDetails = __webpack_require__(16);
} else if (environment === 'stage') {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.fetchTokenAndInitiate();
    var self = this;
    $(document).on('keypress', 'input', function () {
      self.errorCode = '';
    });
    $(document).on('keypress', '#phoneNumber,#verifyCode', function (evt) {
      self.keyPressHandler(evt);
    });

    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
      self.lang = language;
    });
  },
  mounted: function mounted() {
    this.getBrandName();
  },
  data: function data() {
    return {
      templateLang: 'en_US',
      enableRefIdApproach: false,
      refId: '',
      recoveryType: '',
      accountunlocked: false,
      brandDetails: brandDetails,
      brand: '',
      tclink: 'https://www.cargill.com/portal-terms',
      pplink: 'https://www.cargill.com/page/privacy',
      listofsecquestions: [],
      lang: __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang_obj,
      fetchResponse: '',
      phoneNumber: '',
      countryCode: 1,
      token: '',
      userId: '00ud1f5tz9guPug9Z0h7',
      firstName: '',
      lastName: '',
      loginId: '',
      errorCode: '',
      password: '',
      showPhNoPane: false,
      selectedSecQN: 'disliked_food',
      repeatpassword: '',
      securityImage: '',
      answer: '',
      custom_question: '',
      issuccess: false,
      iserror: false,
      verifycode: '',
      factorId: '',
      enableOTPSend: true,
      error30SecOTP: false,
      phoneNoAlreadySet: false,
      tokenInvalid: false,
      pwdValid: false,
      activateFactorId: '',
      passwordPolicyArray: [],
      currPwdPolicy: {},
      pwdComplexity: {},
      pwdErrorArray: [],
      errorMessages: {},
      userSecQuestion: '',
      codeSent: false,
      user_lang: __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang_obj['en_US'],
      minAnswerLength: '',
      stateToken: '',
      secQAVerified: false,
      showResetQA: false,
      loading: true,
      smsFactorId: '',
      emptypasscode: '',
      nofactorpresent: false,
      passwordreset: false,
      regApps: [],
      isServiceAccountGroupMember: false
    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default.a
  },
  computed: {
    pwdValidationObj: function pwdValidationObj() {
      var errors = [];
      var minCharRegex = isMinLength.replace('8', this.pwdComplexity.minLength);
      if (this.password.trim().length > 0) {
        if (this.pwdComplexity.minLowerCase > 0 && !this.password.trim().match(new RegExp(islowerCase))) {
          errors.push(this.user_lang.noLowerCase);
        }
        if (this.pwdComplexity.minUpperCase > 0 && !this.password.trim().match(new RegExp(isUpperCase))) {
          errors.push(this.user_lang.noUpperCase);
        }
        if (this.pwdComplexity.minNumber > 0 && !this.password.trim().match(new RegExp(isNumber))) {
          errors.push(this.user_lang.noNumber);
        }
        if (this.pwdComplexity.minSymbol > 0 && !this.password.trim().match(new RegExp(isSpecialChar))) {
          errors.push(this.user_lang.noSpecialCharacter);
        }
        if (!this.password.trim().match(new RegExp(minCharRegex))) {
          errors.push(this.user_lang.notMinLength.replace('$', this.pwdComplexity.minLength));
        }
        if (this.pwdComplexity.excludeAttributes !== undefined && this.pwdComplexity.excludeAttributes.includes('lastName') && this.password.trim().indexOf(this.lastName) !== -1) {
          errors.push(this.user_lang.noLastnameSubstring);
        }
        if (this.pwdComplexity.excludeAttributes !== undefined && this.pwdComplexity.excludeAttributes.includes('firstName') && this.password.trim().indexOf(this.firstName) !== -1) {
          errors.push(this.user_lang.noFirstnameSubstring);
        }
        if (this.pwdComplexity.excludeUsername && this.loginId.indexOf(this.password.trim()) > -1) {
          errors.push(this.user_lang.noUsernameSubstring);
        }
        if (errors.length === 0) {
          this.pwdValid = true;
        }
      }
      this.pwdErrorArray = errors;
      return errors;
    },
    repeatPwdValidationObj: function repeatPwdValidationObj() {
      var errors = [];
      if (this.repeatpassword.trim().length > 0) {
        if (this.password.trim() !== this.repeatpassword.trim()) {
          errors.push(this.user_lang.passwordnotmatching);
        }
      }
      this.pwdErrorArray = errors;
      return errors;
    }
  },
  methods: {
    getParameterByName: function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      var results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    keyPressHandler: function keyPressHandler(evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    },
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    goToApp: function goToApp(url) {
      window.open(url, '_blank');
    },
    getPasswordPolicy: function getPasswordPolicy() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].getPasswordPolicy(apiUrl + '/policies', self.token).then(function (response) {
        self.passwordPolicyArray = response.data;
        if (self.passwordPolicyArray.length === 1) {
          self.currPwdPolicy = response.data.filter(function (i) {
            if (i.name === 'Default Policy') return i;
          });
        } else {
          self.currPwdPolicy = response.data.filter(function (i) {
            if (i.name === 'Legacy Policy') return i;
          });
        }
        self.pwdComplexity = self.currPwdPolicy[0].settings.password.complexity;
        self.minAnswerLength = self.currPwdPolicy[0].settings.recovery.factors.recovery_question.properties.complexity.minLength;
        if (self.currPwdPolicy[0].settings.recovery.factors.recovery_question.status === 'INACTIVE') {
          self.secQAVerified = true;
        }
        self.loading = false;
      });
    },
    getSecQuestion: function getSecQuestion() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].getUserIdByEmail(apiUrl + '/users/' + self.loginId, self.token).then(function (response) {
        var ques = response.data.credentials.recovery_question.question;
        var fq = self.listofsecquestions.filter(function (x) {
          return x.question.trim() === ques.trim();
        });
        if (fq.length > 0) {
          self.userSecQuestion = fq[0].questionText;
        } else {
          self.userSecQuestion = ques;
        }
        self.loading = false;
      });
    },
    resetPasswordImpl: function resetPasswordImpl() {
      var _this = this;

      var self = this;
      var data = {
        "credentials": {
          "password": {
            "value": this.password
          },
          "recovery_question": {
            "question": this.selectedSecQN === 'custom' ? this.custom_question : this.listofsecquestions.filter(function (x) {
              return x.question === _this.selectedSecQN;
            })[0].questionText,
            "answer": this.answer
          }
        }
      };
      __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].setUserAccount(apiUrl + '/users/' + self.userId, data, self.token).then(function (response) {
        self.loading = false;
        if (response.data.status === "ACTIVE") {
          self.passwordreset = true;

          __WEBPACK_IMPORTED_MODULE_1__helpers_storage__["default"].clearAll();
        } else {}
      }).catch(function (error) {
        console.log(error);
        if (error.response && error.response.status === 400 && error.response.data && error.response.data.errorCauses && error.response.data.errorCauses.length && error.response.data.errorCauses[0].errorSummary) {
          window.alert(error.response.data.errorCauses[0].errorSummary);
          self.loading = false;
        }
        self.loading = false;
      });
    },
    resetPassword: function resetPassword() {
      var self = this;
      if (self.validateResetPassword() && self.validateCustomSecAnswerWeakness()) {
        self.resetPasswordImpl();
      }
    },
    validateResetPasswordWithoutQA: function validateResetPasswordWithoutQA() {
      if (this.password.trim() !== '') {
        if (this.password.trim().length) {
          if (this.pwdErrorArray.length === 0) {
            if (this.password.trim() === this.repeatpassword.trim()) {
              this.errorCode = '';
              return true;
            } else {
              this.errorCode = 'passwordnotmatching';
              return false;
            }
          } else {
            this.errorCode = 'passwordnotvalid';
            return false;
          }
        } else {
          this.errorCode = 'passwordlength';
          return false;
        }
      } else {
        this.errorCode = 'emptypassword';
        return false;
      }
    },
    resetPasswordWithoutQAReset: function resetPasswordWithoutQAReset() {
      var self = this;
      console.log('test values: ' + self.password + ' ' + self.repeatpassword);
      if (self.validateResetPasswordWithoutQA()) {
        self.resetPasswordWithoutQAResetImpl();
      }
    },
    resetPasswordWithoutQAResetImpl: function resetPasswordWithoutQAResetImpl() {
      var self = this;
      self.loading = true;
      var data = { "stateToken": this.stateToken, "newPassword": self.password.trim() };
      __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].resetPassword(apiUrl + '/credentials/resetpassword', data).then(function (response) {
        self.loading = false;
        if (response.data.status === "SUCCESS") {
          self.passwordreset = true;

          __WEBPACK_IMPORTED_MODULE_1__helpers_storage__["default"].clearAll();
          __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].getActiveAppNames(apiUrl + '/apps/' + self.userId, self.token).then(function (response) {
            self.regApps = response.data.filter(function (item) {
              if (item.name.toLowerCase() !== 'oidc_client' && !item.visibility.hide.web) {
                return item;
              }
            });
          });
        } else {}
      }).catch(function (error) {
        console.log(error);
        var err = error.response;
        if (err && err.status === 403) {
          if (err && err.data.errorCauses && err.data.errorCauses[0].errorSummary.indexOf('current password') > -1) {
            self.errorCode = 'passwordSameasPrev';
          } else if (err && err.data.errorCauses && err.data.errorCauses[0].errorSummary.indexOf('too recently') > -1) {
            self.errorCode = 'passwordusedrecently';
          } else {
            self.errorCode = 'passwordnotmetrequirements';
          }
        }
        self.loading = false;
      });
    },
    fetchTokenAndInitiate: function fetchTokenAndInitiate() {
      var self = this;
      var actToken = self.getParameterByName('resetPwdToken', document.location.href);
      self.templateLang = self.getParameterByName('lang', document.location.href);
      if (actToken === null || actToken === undefined || actToken.trim() === '') {
        self.setUserLocaleByLanguage(self.templateLang);
        self.enableRefIdApproach = true;
        self.loading = false;
        setTimeout(function () {
          $('.splash').removeClass('hiddden');
          $('#userRegistration').css('display', 'block');
        }, 500);
      } else {
        self.getTokenAndRedirect(actToken);
      }
    },
    getTokenAndRedirect: function getTokenAndRedirect(token) {
      var self = this;
      self.loading = true;
      self.token = token !== null && token !== undefined ? token.trim() : '';
      self.enableRefIdApproach = false;
      self.tokenInvalid = false;
      var data = { "recoveryToken": self.token };
      window.history.replaceState(null, "", document.location.href.split("?")[0]);
      __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].getUserIdByToken(apiUrl + '/recovery/token', data).then(function (response) {
        $('#userRegistration').css('display', 'block');
        self.recoveryType = response.data.recoveryType;
        self.setUserLocaleByLanguage(response.data._embedded.user.profile.locale);
        if (self.recoveryType.toLowerCase() === 'unlock' && response.data.status.toLowerCase() === 'success') {
          self.accountunlocked = true;
          self.loading = false;
          return;
        }
        var responseObj = response.data;

        self.userId = responseObj._embedded.user.id;
        self.firstName = responseObj._embedded.user.profile.firstName;
        self.lastName = responseObj._embedded.user.profile.lastName;
        self.loginId = responseObj._embedded.user.profile.login;
        self.getBrandName(self.loginId);
        self.stateToken = responseObj.stateToken;
        __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].getActiveAppNames(apiUrl + '/apps/' + self.userId, self.token).then(function (response) {
          self.regApps = response.data.filter(function (item) {
            if (item.name.toLowerCase() !== 'oidc_client' && !item.visibility.hide.web) {
              return item;
            }
          });
        });
        __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].getGroupsByUserId(apiUrl + '/users/' + self.userId + '/groups', self.token).then(function (response) {
          self.isServiceAccountGroupMember = response.data.filter(function (x) {
            return x.profile.name.toLowerCase().indexOf('service accounts') > -1 || x.profile.name.toLowerCase().indexOf('brazilian portalapp') > -1 || x.profile.name.toLowerCase().indexOf('cargillonlinefeed') > -1 || x.profile.name.toLowerCase().indexOf('cargillonlinefeedusers') > -1 || x.profile.name.toLowerCase().indexOf('crm velo salesforce') > -1;
          }).length > 0 ? true : false;
          __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].getUserIdByEmail(apiUrl + '/users/' + self.userId, self.token).then(function (response) {
            var emailDomain = self.loginId.split('@').length > 1 ? self.loginId.split('@')[1] : '';
            if (!self.isServiceAccountGroupMember && internalUserDomains.filter(function (x) {
              return x.toLowerCase().indexOf(emailDomain.toLowerCase()) > -1;
            }).length > 0) {
              self.passwordreset = true;
            } else if (response.data.credentials.provider.type.toLowerCase() === 'federation' && !self.isServiceAccountGroupMember) {
              self.passwordreset = true;
            } else {
              self.getPasswordPolicy();
              self.getSecQuestion();
              self.checkPhoneNumber();
            }
          }).catch(function (err) {
            self.loading = false;
            console.log("create Insert CF Error: ", err);
          });
        }).catch(function (err) {
          self.loading = false;
          console.log("create Insert CF Error: ", err);
        });
      }).catch(function (error) {
        $('#userRegistration').css('display', 'block');
        self.setUserLocaleByLanguage(self.templateLang, false);

        self.getBrandName(self.loginId);
        if (error.toString().toLowerCase().indexOf('network error') > -1) {
          console.log('Network Error. please check your connection');
          self.loading = false;
          self.tokenInvalid = true;
          self.enableRefIdApproach = false;
        } else if (error.response.status === 401 || error.response.status === 403) {
          self.loading = false;
          self.tokenInvalid = true;
          self.enableRefIdApproach = false;
        }
      });
    },
    getBrandBg: function getBrandBg() {
      var self = this;
      console.log(self.brandDetails);
      var brand = self.brandDetails.data.filter(function (n) {
        return n.applicationUrls.indexOf(document.location.host) > -1;
      });
      console.log(brand);
      if (brand.length && brand[0].bgImageLink.trim() !== '') {
        $('.splash').attr("src", brand[0].bgImageLink);
      }
      setTimeout($('.splash').removeClass('hiddden'), 500);
    },
    getBrandName: function getBrandName(email) {
      var self = this;
      var bd = self.brandDetails.data.filter(function (n) {
        return n.applicationUrls.indexOf(document.location.host) > -1;
      })[0];

      self.brand = bd.brandName;
      self.tclink = bd.termsandconditionslink;
      self.pplink = bd.privacypolicylink;
      var bgimg = bd.bgImageLink.trim();
      if (bgimg !== '') {
        if (bgimg.indexOf('#') !== 0) {
          $('.splash').attr("src", bgimg);
        } else {
          $('.splash').attr("src", "");
          $('.splash').css("background", bgimg);
        }
      }
      setTimeout($('.splash').removeClass('hiddden'), 500);

      $('.fa-chevron-right').css('color', bd.themeButtonTextColor);
    },
    validateCustomSecAnswerWeakness: function validateCustomSecAnswerWeakness() {
      var self = this;
      if (self.selectedSecQN === 'custom') {
        var questionWordsArray = self.custom_question.trim().toLowerCase().split(' ');
        var answerWordsArray = self.answer.trim().toLowerCase().split(' ');
        var isWeak = questionWordsArray.some(function (r) {
          return answerWordsArray.indexOf(r) >= 0 && r.trim() !== '';
        });
        if (isWeak) {
          this.errorCode = 'securityquestionanswerweak';
          return false;
        } else {
          this.errorCode = '';
          return true;
        }
      } else {
        this.errorCode = '';
        return true;
      }
    },
    validateResetPassword: function validateResetPassword() {
      if (this.password.trim() !== '') {
        if (this.password.trim().length) {
          if (this.pwdErrorArray.length === 0) {
            if (this.password.trim() === this.repeatpassword.trim()) {
              if (this.answer.trim().length >= this.minAnswerLength) {
                if (this.selectedSecQN === 'custom' && this.custom_question.trim() === '') {
                  this.errorCode = 'customQuestionEmpty';
                  return false;
                } else {
                  if (this.selectedSecQN === 'custom' && this.custom_question.trim().toLowerCase().indexOf(this.answer.trim().toLowerCase()) > -1) {
                    this.errorCode = 'customQAsame';
                    return false;
                  } else {
                    this.errorCode = '';
                    return true;
                  }
                }
              } else {
                this.user_lang.answerlength = this.user_lang.answerlength.replace('$', this.minAnswerLength);
                this.errorCode = 'answerlength';
                return false;
              }
            } else {
              this.errorCode = 'passwordnotmatching';
              return false;
            }
          } else {
            this.errorCode = 'passwordnotvalid';
            return false;
          }
        } else {
          this.errorCode = 'passwordlength';
          return false;
        }
      } else {
        this.errorCode = 'emptypassword';
        return false;
      }
    },
    forgotSQA: function forgotSQA() {
      var self = this;
      self.error30SecOTP = false;
      self.loading = true;
      self.emptypasscode = false;
      self.nofactorpresent = false;
      var data = { "passCode": "" };
      if (self.smsFactorId !== '' && self.smsFactorId !== undefined) {
        __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].sendCode(apiUrl + '/users/' + self.userId + '/factors/' + self.smsFactorId + '/verify', data, self.token).then(function (response) {
          self.issuccess = true;
          self.codeSent = true;
          self.loading = false;
        }).catch(function (error) {
          console.log(error);
          self.loading = false;
          if (error.response.status === 429) {
            self.error30SecOTP = true;
          }
        });
      } else {
        self.loading = false;
        self.nofactorpresent = true;
      }
    },
    goBack: function goBack() {
      this.codeSent = false;
    },
    verifySMS: function verifySMS() {
      var self = this;
      self.showResetQA = true;
      self.codeSent = false;
    },
    verifyResendCode: function verifyResendCode() {
      var self = this;
      self.emptypasscode = false;
      if (self.verifycode.trim().length !== 0) {
        var data = { "passCode": this.verifycode.trim() };
        __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].sendCode(apiUrl + '/users/' + self.userId + '/factors/' + self.smsFactorId + '/verify', data, self.token).then(function (response) {
          if (response.data.factorResult === 'SUCCESS') {
            self.showResetQA = true;
            self.codeSent = false;
            self.issuccess = true;
            self.answer = '';
          }
        }).catch(function (error) {
          console.log(error);
          if (error.response.status === 403) {
            self.iserror = true;
          }
          self.loading = false;
        });
      } else {
        self.emptypasscode = true;
      }
    },
    checkPhoneNumber: function checkPhoneNumber() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].getFactorByUserId(apiUrl + '/users/' + self.userId + '/factors', self.token).then(function (response) {
        if (response.data.length > 0) {
          self.smsFactorId = response.data[0].id;
        }
      });
    },
    validateSecQA: function validateSecQA() {
      if (this.answer.trim().length >= this.minAnswerLength) {
        if (this.custom_question.trim() !== this.answer.trim()) {
          this.errorCode = '';
          return true;
        } else {
          this.errorCode = 'customQAsame';
          return false;
        }
      } else {
        this.user_lang.answerlength = this.user_lang.answerlength.replace('$', this.minAnswerLength);
        this.errorCode = 'answerlength';
        return false;
      }
    },
    resetPasswordCheckSecQA: function resetPasswordCheckSecQA() {
      var _this2 = this;

      var self = this;
      self.nofactorpresent = false;
      if (this.validateSecQA()) {
        var data = { "stateToken": this.stateToken, "answer": this.answer.trim() };
        __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].verifySecurityAnswer(apiUrl + '/recovery/answer', data).then(function (response) {
          if (response.data.recoveryType === 'UNLOCK') {
            self.accountunlocked = true;
          } else {
            self.secQAVerified = true;
          }
        }).catch(function (error) {
          console.log(error);
          self.errorCode = 'answerWrong';
          _this2.loading = false;
        });
      }
    },

    changeUserLang: function changeUserLang(e) {
      __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang = e.target.value;
      this.user_lang = this.lang_obj[e.target.value];
      __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["EventBus"].$emit('lang', e.target.value);
    },
    resetSecQA: function resetSecQA() {
      this.resetSecQA = false;
      this.codeSent = false;
      this.secQAVerified = true;
      this.showResetQA = false;
    },
    setUserLocale: function setUserLocale(loginId) {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].getUserIdByEmail(apiUrl + '/users/' + loginId, self.token).then(function (response) {
        self.loading = false;
        var profileLang = response.data.profile.locale;
        if (profileLang !== undefined) {
          if (profileLang !== null && profileLang.trim() !== '') {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang_obj).forEach(function (i) {
              if (profileLang.toLowerCase().indexOf(i.toLowerCase()) > -1) {
                __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang = i;
                __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["EventBus"].$emit('lang', i);
              }
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang = 'en_US';
            __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["EventBus"].$emit('lang', 'en_US');
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang = 'en_US';
          __WEBPACK_IMPORTED_MODULE_1__helpers_storage__["default"].set('user-lang', 'en_US');
          __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["EventBus"].$emit('lang', 'en_US');
        }
      });
    },
    setUserLocaleByLanguage: function setUserLocaleByLanguage(val, istokenvalid) {
      var self = this;

      self.loading = false;
      var profileLang = val;
      if (profileLang !== undefined) {
        if (profileLang !== null && profileLang.trim() !== '') {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang_obj).forEach(function (i) {
            if (profileLang.toLowerCase().indexOf(i.toLowerCase()) > -1) {
              __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang = i;
              __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["EventBus"].$emit('lang', i);
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang = 'en_US';
          __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["EventBus"].$emit('lang', 'en_US');
        }
        if (istokenvalid !== false) {}
      } else {
        __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang = 'en_US';
        __WEBPACK_IMPORTED_MODULE_1__helpers_storage__["default"].set('user-lang', 'en_US');
        __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["EventBus"].$emit('lang', 'en_US');
        if (istokenvalid !== false) {}
      }
    },
    resetSecQAPassword: function resetSecQAPassword() {
      var _this3 = this;

      var self = this;
      var data = {
        "credentials": {
          "password": {
            "value": this.password
          },
          "recovery_question": {
            "question": this.selectedSecQN === 'custom' ? this.custom_question : this.listofsecquestions.filter(function (x) {
              return x.question === _this3.selectedSecQN;
            })[0].questionText,
            "answer": this.answer
          }
        }
      };
      __WEBPACK_IMPORTED_MODULE_5__idm_api__["default"].setUserAccount(apiUrl + '/users/' + self.userId, data, self.token).then(function (response) {});
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__idm_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_common__ = __webpack_require__(115);







var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";
var SITEKEY = "6LdSQasZAAAAAF1410vaTDMpUNtKrqs1RtOZuiLC";
var APPIDRECAPTCHAEXCEPTION = "0oajg4rnuyNU834TA0h7";
var GROUPIDRECAPTCHAEXCEPTION = "00gt5ticy6WkSIieU0h7";
var environment = "stage";
var brandDetails = "";
console.log('env=====', environment);
if (environment === 'production') {
  brandDetails = __webpack_require__(16);
} else if (environment === 'stage') {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.appId = this.getParameterByName('appId', document.location.href);
    this.selfServiceGroup = this.getParameterByName('selfServiceGroup', document.location.href);
    var self = this;
    self.loading = false;
    $(document).on('keypress', 'input', function () {
      self.errorCode = '';
      self.userValidations = '';
    });
    var brand = brandDetails.data.filter(function (i) {
      return i.applicationUrls.indexOf(document.location.host) > -1;
    });
    if (brand[0].brandCode !== '001') {
      self.$router.push({ path: '/Login' });
    }
  },
  mounted: function mounted() {
    this.sendMessageToDatadog('Self Registration loaded for app - ' + this.appId);
    this.langCode = this.getParameterByName('lang', document.location.href);
    if (this.langCode !== null) {
      this.user_lang = __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang_obj[this.langCode];
      this.updateCaptchaWithLocale();
    }
  },
  data: function data() {
    return {
      appId: '',
      lang_def: __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang_def,
      person: { firstName: '', lastName: '', email: '', locale: '', login: '' },
      errorCode: '',
      user_lang: __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang_obj['en_US'],
      loading: true,
      userValidations: '',
      captchaVerified: false,
      inviteSuccess: false,
      sitekey: SITEKEY,
      appIdException: APPIDRECAPTCHAEXCEPTION,
      groupIdException: GROUPIDRECAPTCHAEXCEPTION,
      successCode: '',
      contactMailId: "DXP-Okta-Development-Team-All@Cargill.com",
      statusCode: '',
      mailCheck: true,
      langCode: '',
      selfServiceGroup: ''
    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_0__components_Spinner___default.a,
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__["a" /* default */]
  },
  computed: {},
  watch: {},
  methods: {
    sendMessageToDatadog: function sendMessageToDatadog(msg, data) {
      var url = apiUrl + '/dataDogMessage?message=' + msg;
      __WEBPACK_IMPORTED_MODULE_1__idm_api__["default"].sendMessageToDatadog(url, data).then(function (response) {
        console.log(response);
      }).catch(function (error) {
        console.log(error);
      });
    },
    getUserDetails: function getUserDetails() {
      var self = this;
      var message = 'User Details: Name - ' + self.person.firstName + ' ' + self.person.lastName + '; Email - ' + self.person.email + '; Locale - ' + self.person.locale;
      if (self.person.firstName === '' || self.person.lastName === '' || self.person.email === '') {
        message = 'User Details: No values entered.';
      }
      return self.appId + ':' + message;
    },
    updateCaptchaWithLocale: function updateCaptchaWithLocale() {
      var iframeGoogleCaptcha = $('#captcha_container').find('iframe');
      var lang = __WEBPACK_IMPORTED_MODULE_4__helpers_common__["default"].getLanguage(this.langCode);
      if (lang === 'zh_TW') {
        lang = 'bg';
      }
      lang = lang.replace('_', '-');
      if (iframeGoogleCaptcha && iframeGoogleCaptcha.length > 0) {
        iframeGoogleCaptcha.attr("src", iframeGoogleCaptcha.attr("src").replace(/hl=(.*?)&/, 'hl=' + lang + '&'));
      }
    },
    getParameterByName: function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      var results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    onVerify: function onVerify(resp) {
      var self = this;
      if (resp.length !== 0) {
        self.captchaVerified = true;
        var message = self.getUserDetails();
        self.sendMessageToDatadog('Verified ', message);
      }
    },
    onExpired: function onExpired(resp) {
      var self = this;
      self.captchaVerified = false;
      var message = self.getUserDetails();
      self.sendMessageToDatadog('Expired ', message);
    },
    onError: function onError(error) {
      var self = this;
      console.log(error);
      var message = self.getUserDetails();
      self.sendMessageToDatadog('Error', message);
    },
    onRender: function onRender(id) {
      var self = this;
      if (self.appId === self.appIdException && self.selfServiceGroup === self.groupIdException) {
        $('#captcha_container').css({
          display: "none",
          visibility: "hidden"
        });
        self.captchaVerified = true;
      }
      setTimeout(function () {
        console.log('Render', id);
        window.grecaptcha.reset();
      }, 1000);
    },

    validEmail: function validEmail(email) {
      var re = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(email);
    },
    validateSpecialCharacters: function validateSpecialCharacters(text) {
      return !/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(text);
    },
    validateAndResendInvite: function validateAndResendInvite() {
      var self = this;
      self.userValidations = '';
      if (self.person.firstName.trim() === '') {
        self.userValidations = self.user_lang['firstnamereq'];
      } else if (!this.validateSpecialCharacters(self.person.firstName.trim())) {
        self.userValidations = self.user_lang['noSpecialCharacters'];
      } else if (self.person.lastName.trim() === '') {
        self.userValidations = self.user_lang['lastnamereq'];
      } else if (!this.validateSpecialCharacters(self.person.lastName.trim())) {
        self.userValidations = self.user_lang['noSpecialCharacters'];
      } else if (self.person.email.trim() === '') {
        self.userValidations = self.user_lang['emailreq'];
      } else if (self.person.email.trim().toLowerCase().indexOf('@cargill.') > -1 || self.person.email.trim().toLowerCase().indexOf('@crgl-thirdparty.') > -1 || self.person.email.trim().toLowerCase().indexOf('@awb') > -1) {
        self.userValidations = self.user_lang['emailinvaliddomain'];
      } else if (!this.validEmail(self.person.email.trim())) {
        self.userValidations = self.user_lang['emailinvalid'];
      } else if (self.person.locale.trim() === '') {
        self.userValidations = self.user_lang['selectLang'];
      } else if (!self.captchaVerified) {
        self.userValidations = "Please verify captcha";
      } else {
        self.loading = true;
        var message = self.getUserDetails();
        self.sendMessageToDatadog('Clicked Register button : ', message);
        self.person.firstName = self.person.firstName.trim();
        self.person.lastName = self.person.lastName.trim();
        self.person.email = self.person.email.trim();
        self.person.login = self.person.email;
        var data = { profile: self.person, groupIds: [] };
        var url = '';
        if (self.selfServiceGroup !== '' && self.selfServiceGroup !== null) {
          url = apiUrl + '/selfRegisterUser?appId=' + self.appId + '&selfServiceGroup=' + self.selfServiceGroup;
        } else {
          url = apiUrl + '/selfRegisterUser?appId=' + self.appId;
        }
        __WEBPACK_IMPORTED_MODULE_1__idm_api__["default"].sendSelfRegistration('' + url, data).then(function (response) {
          self.inviteSuccess = true;
          if (response.data) {
            if (response.data.appEmailId !== undefined && response.data.appEmailId !== '') {
              self.contactMailId = response.data.appEmailId;
            }
            if (response.data.status !== undefined && response.data.status !== '') {
              self.contactMailId = self.person.email;
              self.successCode = response.data.status;
            }
            if (!self.validEmail(self.contactMailId)) {
              self.mailCheck = false;
            }
          }
          self.loading = false;
        }).catch(function (error) {
          console.log(error);
          if (error.response && error.response.data) {
            if (error.response.data.errorCode) {
              self.successCode = error.response.data.errorCode;
              if (error.response.data.errorCode === 'E0003') {
                self.contactMailId = self.person.email;
              }
            }
            if (error.response.data.appEmailId !== undefined && error.response.data.appEmailId !== '') {
              self.contactMailId = error.response.data.appEmailId;
            }
            if (error.response.data.errorSummary !== undefined && error.response.data.errorSummary !== '') {
              self.statusCode = error.response.data.errorSummary;
            }
            if (error.response.data.status !== undefined && error.response.data.status !== '') {
              self.contactMailId = self.person.email;
              self.successCode = error.response.data.status;
            }
            if (!self.validEmail(self.contactMailId)) {
              self.mailCheck = false;
            }
          }
          self.inviteSuccess = true;
          self.loading = false;
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_widgets_TopNavFooter__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_widgets_TopNavFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_widgets_TopNavFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__idm_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_storage__ = __webpack_require__(5);









var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";

var environment = "stage";
var brandDetails = "";
console.log('env=====', environment);
if (environment === 'production') {
  brandDetails = __webpack_require__(16);
} else if (environment === 'stage') {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tm',
  components: {
    TopNavFooter: __WEBPACK_IMPORTED_MODULE_0__components_widgets_TopNavFooter___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner___default.a
  },
  created: function created() {
    var self = this;
    self.userId = __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].get('cf-user').sub;
    self.email = __WEBPACK_IMPORTED_MODULE_5__helpers_storage__["default"].get('email');
    this.user_lang = this.lang_br;
    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
    });
  },
  mounted: function mounted() {},

  watch: {},
  methods: {
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    getLogs: function getLogs() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__idm_api__["default"].getLogs(apiUrl + '/auth/userlogs/' + self.searchTerm).then(function (response) {
        self.emptyLogs = false;
        self.logsArr = response.data.reverse();
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 404) {
          self.logsArr = [];
          self.emptyLogs = true;
        } else {
          window.alert(error);
        }
        self.loading = false;
      });
    }
  },
  data: function data() {
    return {
      brandDetails: brandDetails,
      lang: __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_3__i18n_locale_js__["locale"].lang_obj,
      userId: '',
      loading: false,
      user_lang: {},
      prefLang: 'en_US',
      searchTerm: '',
      logsArr: [],
      emptyLogs: false
    };
  },

  computed: {}
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_TopNavFooter__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_TopNavFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_widgets_TopNavFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__idm_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_storage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(29);











var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";
var onecargillappid = "0oa10r32yuaNJCfrw0h8";

var environment = "stage";
var brandDetails = "";
console.log('env=====', environment);
if (environment === 'production') {
  brandDetails = __webpack_require__(16);
} else if (environment === 'stage') {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tm',
  components: {
    TopNavFooter: __WEBPACK_IMPORTED_MODULE_2__components_widgets_TopNavFooter___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default.a
  },
  created: function created() {
    var self = this;
    self.loading = true;
    self.userId = __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].get('cf-user').sub;
    self.email = __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].get('email');
    this.user_lang = this.lang_br;
    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
    });
    self.getListOfSuperUserApps();
  },
  mounted: function mounted() {
    var self = this;

    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    $("#search-criteria").on("keyup", function () {
      self.clearMessages();
      var g = $(this).val().toLowerCase();
      $(".searchbox .list").each(function () {
        var s = $(this).text().toLowerCase();

        $(this).closest('.searchbox')[s.indexOf(g) !== -1 ? 'show' : 'hide']();
      });
    });
    $(document).on('click', 'body', function (e) {
      if (!$('div#dropdown').has(e.target).length) {}
    });
  },

  watch: {
    appAdminGroupModal: function appAdminGroupModal() {
      this.watchAppAdminGroupModal();
    }
  },
  methods: {
    watchAppAdminGroupModal: function watchAppAdminGroupModal() {
      var self = this;
      console.log('watch');
      if (this.appAdminGroupModal.length === 0) {
        var newRowObj = $.extend(true, {}, self.rowObj);
        self.appAdminGroupModal.push(newRowObj);
      }
    },
    selectAdminGroupFromList: function selectAdminGroupFromList(groupDetails) {
      var self = this;
      console.log(groupDetails);
      console.log(self.applicationIndex);
      self.isSearched = false;
      self.groupNameTyped = groupDetails.profile.name;
      self.appAdminGroupModal[self.applicationIndex].groupId = groupDetails.id;
    },
    onSearch: function onSearch() {
      var self = this;
      self.appAdminGroupModal[self.applicationIndex].groupId = "";
      if (self.groupNameTyped.length > 1) {
        self.loading = true;
        clearTimeout(self.timer);
        self.timer = setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getGroupByName(apiUrl + '/auth/groups/search?limit=10&groupName=' + self.groupNameTyped).then(function (response) {
            self.isSearched = true;
            self.loading = false;
            self.searchDropdownData = response.data;
            console.log(response);
          }).catch(function (err) {
            self.loading = false;
            console.log(err);
          });
        }, 1000);
      }
    },
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    addAdditionalGroup: function addAdditionalGroup(index, appid) {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getGroupByName(apiUrl + '/auth/groups/search?groupName=' + self.additionalGroup[index]).then(function (response) {
        self.addAdditionalGroupImpl(response, index, appid);
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    addAdditionalSelfGroup: function addAdditionalSelfGroup(index, appid) {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getGroupByName(apiUrl + '/auth/groups/search?groupName=' + self.additionalSelfGroup[index]).then(function (response) {
        self.addAdditionalGroupSelfImpl(response, index, appid);
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    addAdditionalGroupSelfImpl: function addAdditionalGroupSelfImpl(response, index, appid) {
      var self = this;
      self.loading = false;
      if (response.data.length === 0) {
        window.alert('Please enter valid group name');
        self.additionalSelfGroup = [];
      } else {
        var fl = self.appsSelfGroups[appid].filter(function (x) {
          return x.id === response.data[0].id;
        });
        if (fl.length === 0) {
          var indieSubGroupEntry = response.data[0].id + '~~~' + response.data[0].profile.name;
          self.appAdminGroupModal[index].selfRegGroupList.push(indieSubGroupEntry.trim());
          self.tempAppAdminGroupModal = [];
          self.appAdminGroupModal.forEach(function (x, index) {
            self.tempAppAdminGroupModal[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, x);
          });
          self.additionalSelfGroup = [];
        } else {
          window.alert('Please select this group from the dropdown');
          self.additionalSelfGroup = [];
        }
      }
    },
    addAdditionalGroupImpl: function addAdditionalGroupImpl(response, index, appid) {
      var self = this;

      self.loading = false;
      if (response.data.length === 0) {
        window.alert('Please enter valid group name');
        self.additionalGroup = [];
      } else {
        var fl = self.currGroupIds.indexOf(response.data[0].id) > -1;
        if (!fl) {
          var indieSubGroupEntry = response.data[0].id + '~~~' + response.data[0].profile.name;
          indieSubGroupEntry = indieSubGroupEntry.trim();
          self.appAdminGroupModal[index].subGroupId.push(indieSubGroupEntry);
          var obj = { subGroupId: indieSubGroupEntry, subGroupName: response.data[0].profile.name, isReadOnly: false, roleChanged: false };
          self.appAdminGroupModal[index].subGroupManagement.push(obj);
          self.tempAppAdminGroupModal = [];
          self.appAdminGroupModal.forEach(function (x, index) {
            self.tempAppAdminGroupModal[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, x);
          });
          self.additionalGroup = [];
        } else {
          window.alert('Please select this group from the dropdown');
          self.additionalGroup = [];
        }
      }
    },
    checkchange: function checkchange(e) {
      console.log(e);
      var self = this;
      var grpid = e.target.id.split('~')[0];
      var idx = e.target.id.split('~')[1];
      var grpname = e.target.value;
      if (self.appAdminGroupModal[idx].subGroupId === undefined) {
        self.appAdminGroupModal[idx]['subGroupId'] = [];
      }
      if (self.appAdminGroupModal[idx].subGroupManagement === undefined) {
        self.appAdminGroupModal[idx]['subGroupManagement'] = [];
      }
      if (e.target.checked && self.appAdminGroupModal[idx].subGroupId.indexOf(grpid) === -1) {
        var obj = { subGroupId: grpid, subGroupName: grpname, isReadOnly: false, roleChanged: false };
        self.appAdminGroupModal[idx].subGroupId.push(grpid);
        self.appAdminGroupModal[idx].subGroupManagement.push(obj);
      } else {
        self.appAdminGroupModal[idx].subGroupId = self.appAdminGroupModal[idx].subGroupId.filter(function (e) {
          return e.indexOf(grpid) === -1;
        });
        self.appAdminGroupModal[idx].subGroupManagement = self.appAdminGroupModal[idx].subGroupManagement.filter(function (e) {
          return e.subGroupId.indexOf(grpid) === -1;
        });
      }
    },
    checkSelfchange: function checkSelfchange(e) {
      var self = this;
      var grpid = e.target.id.split('~self')[0];
      var idx = e.target.id.split('~self')[1];
      if (self.appAdminGroupModal[idx].selfRegGroupList === undefined) {
        self.appAdminGroupModal[idx]['selfRegGroupList'] = [];
      }
      if (e.target.checked && self.appAdminGroupModal[idx].selfRegGroupList.indexOf(grpid) === -1) {
        self.appAdminGroupModal[idx].selfRegGroupList.push(grpid);
      } else {
        self.appAdminGroupModal[idx].selfRegGroupList = self.appAdminGroupModal[idx].selfRegGroupList.filter(function (e) {
          return e.indexOf(grpid) === -1;
        });
      }
    },
    openDropDown: function openDropDown(index) {
      var self = this;
      self.showDropdownForGroups = !self.showDropdownForGroups;

      if (self.appAdminGroupModal[index].subGroupId === undefined) {
        self.appAdminGroupModal[index]['subGroupId'] = [];
      }
      for (var i = 0; i < self.appAdminGroupModal[index].subGroupId.length; i++) {
        var sel = '';
        if (self.appAdminGroupModal[index].subGroupId[i].indexOf('~~~') > -1) {
          sel = '.ddwrap' + index + ' [id^="' + self.appAdminGroupModal[index].subGroupId[i].split('~~~')[0] + '"]';
        } else {
          sel = '.ddwrap' + index + ' [id^="' + self.appAdminGroupModal[index].subGroupId[i] + '"]';
        }
        $(sel).attr('checked', true);
      }
    },
    openSelfRegDropDown: function openSelfRegDropDown(index) {
      var self = this;
      self.showDropdownForSelfGroups = !self.showDropdownForSelfGroups;

      if (self.appAdminGroupModal[index].selfRegGroupList === undefined) {
        self.appAdminGroupModal[index]['selfRegGroupList'] = [];
      }
      for (var i = 0; i < self.appAdminGroupModal[index].selfRegGroupList.length; i++) {
        var sel = '';
        if (self.appAdminGroupModal[index].selfRegGroupList[i].indexOf('~~~') > -1) {
          sel = '.ddwrapself' + index + ' [id^="' + self.appAdminGroupModal[index].selfRegGroupList[i].split('~~~')[0] + '"]';
        } else {
          sel = '.ddwrapself' + index + ' [id^="' + self.appAdminGroupModal[index].selfRegGroupList[i] + '"]';
        }
        $(sel).attr('checked', true);
      }
    },
    getListOfClientId: function getListOfClientId() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getClientIds(apiUrl + '/apitokenList', self.email).then(function (response) {
        self.loading = false;
        self.clientList = response.data;
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    getListOfSuperUserApps: function getListOfSuperUserApps() {
      var self = this;
      self.clearMessages();
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getListOfSuperUserApps(apiUrl + '/auth/apps', self.email).then(function (response) {
        self.loading = false;
        self.appList = response.data;
        self.appList.sort(function (a, b) {
          return a.label.toLowerCase() > b.label.toLowerCase() ? 1 : b.label.toLowerCase() > a.label.toLowerCase() ? -1 : 0;
        });
        self.getConfigList();
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    changeView: function changeView() {
      var self = this;
      if (self.isNewAppConfig) {
        self.tempAppAdminGroupModal = [];
        self.appAdminGroupModal = self.appAdminGroupModal.slice(0, self.appAdminGroupModal.length - 1);
        self.appAdminGroupModal.forEach(function (x, index) {
          self.tempAppAdminGroupModal[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, x);
        });
        self.applicationIndex = 0;
        self.isNewAppConfig = false;
      }
      self.isSearched = false;
      self.showDropdownForGroups = false;
      self.showDropdownForSelfGroups = false;
      self.searchDropdownData = [];
      self.showAppList = true;
      window.scrollTo(0, 0);
    },
    changeToAppView: function changeToAppView() {
      var self = this;
      self.clearMessages();
      self.applicationIndex = self.appAdminGroupModal.length - 1;
      self.showAppList = false;
      window.scrollTo(0, 0);
    },
    getApplicationGroups: function getApplicationGroups(id, index) {
      var self = this;
      window.scrollTo(0, 0);
      self.applicationIndex = index;
      self.showAppList = false;
      self.getGroups(id, index);
      self.getAdminGroup(id, index);
    },
    checkForRoleChange: function checkForRoleChange(ind) {
      var self = this;
      if (!self.showAppList) {
        return;
      }
      self.appAdminGroupModal[ind].subGroupManagement.map(function (group) {
        if (group.subGroupId.indexOf('~~~') === -1 && self.currGroupIds.indexOf(group.subGroupId) === -1 || group.subGroupId.indexOf('~~~') > -1 && self.currGroupIds.indexOf(group.subGroupId.split('~~~')[0]) > -1) {
          group.roleChanged = true;
        } else {
          group.roleChanged = false;
        }
      });
      console.log(self.appAdminGroupModal[ind].subGroupManagement);
    },
    getAdminGroup: function getAdminGroup(applicationId, index) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getAdminGroup(apiUrl + '/auth/groups/' + self.appAdminGroupModal[index].groupId).then(function (response) {
        console.log(response);
        self.groupNameTyped = response.data.profile.name;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getGroups: function getGroups(id, ind) {
      var self = this;
      self.clearMessages();
      if ((self.appsGroups[id] === undefined && id !== 'undefined' || self.appsSelfGroups[id] === undefined && id !== 'undefined') && id !== undefined) {
        self.loading = true;
        __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getGroupsByAppId(apiUrl + '/auth/apps/' + id + '/groups').then(function (response) {
          self.loading = false;
          self.currGroupDetails = response.data;
          self.currGroupIds = [];
          response.data.forEach(function (x) {
            self.currGroupIds.push(x.id);
          });
          self.checkForRoleChange(ind);
          var gmap = response.data.map(function (x) {
            return x.id;
          });
          __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].set(self.appGroupsArrayMap, id, gmap);
          __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].set(self.appsGroups, id, response.data.sort(function (a, b) {
            return a._embedded.group.profile.name.toLowerCase() > b._embedded.group.profile.name.toLowerCase() ? 1 : b._embedded.group.profile.name.toLowerCase() > a._embedded.group.profile.name.toLowerCase() ? -1 : 0;
          }));
          __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].set(self.appsSelfGroups, id, response.data.sort(function (a, b) {
            return a._embedded.group.profile.name.toLowerCase() > b._embedded.group.profile.name.toLowerCase() ? 1 : b._embedded.group.profile.name.toLowerCase() > a._embedded.group.profile.name.toLowerCase() ? -1 : 0;
          }));
          console.log('Apps Groups', self.appsGroups);
          console.log('Apps Self Groups', self.appsSelfGroups);
          console.log('Apps Groups Array Map', self.appGroupsArrayMap);
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    addConfigRow: function addConfigRow() {
      var self = this;
      self.clearMessages();
      self.groupNameTyped = "";
      var newRowObj = $.extend(true, {}, self.rowObj);
      self.appAdminGroupModal.push(newRowObj);
      self.tempAppAdminGroupModal.push(newRowObj);
      self.isNewAppConfig = true;
    },
    getNamesOfApp: function getNamesOfApp() {
      var self = this;
      self.appNameList = [];
      self.appAdminGroupModal.forEach(function (x, index) {
        var arr = self.appList.filter(function (y) {
          return y.id === x.applicationId;
        })[0];
        if (arr) {
          self.appNameList[index] = arr;
          x.applicationName = self.appNameList[index].label;
        } else {
          var val = {
            id: x.applicationId,
            label: x.applicationName + " - Deleted App"
          };
          self.appNameList[index] = val;
          x.applicationName = val.label;
        }
      });
      self.appNameList.sort(function (a, b) {
        return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
      });
      self.appAdminGroupModal.sort(function (a, b) {
        return a.applicationName.toLowerCase().localeCompare(b.applicationName.toLowerCase());
      });
      console.log(self.appNameList);
      console.log(self.appAdminGroupModal);
    },
    getConfigList: function getConfigList() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getListOfAdminConfig(apiUrl + '/auth/appGroupListNew').then(function (response) {
        self.appAdminGroupModal = response.data;
        self.tempAppAdminGroupModal = [];
        self.appAdminGroupModal.forEach(function (x, index) {
          self.tempAppAdminGroupModal[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, x);
        });
        self.getNamesOfApp();
      }).catch(function (err) {
        console.log(err);
      });
    },
    saveAdminGroups: function saveAdminGroups() {
      var self = this;
      self.clearMessages();
      var filteredList = self.appAdminGroupModal[self.applicationIndex];
      if (filteredList.brand === 'undefined' || filteredList.brand === undefined || filteredList.groupId === 'undefined' || filteredList.groupId === undefined || filteredList.groupId === '' || filteredList.subGroupId && filteredList.subGroupId.length === 0 || filteredList.isSelfReg && (filteredList.emailId === undefined || filteredList.selfRegGroupId === 'undefined' || filteredList.selfRegGroupList.length === 0 || filteredList.maxSelfRegCount === 0)) {
        self.isIncomplete = true;
      }
      if (!self.isIncomplete) {
        self.loading = true;
        if (self.isNewAppConfig) {
          self.isNewAppConfig = false;
        }
        filteredList.adminGroupName = self.groupNameTyped;
        filteredList.email = self.email;
        filteredList.isSelfRegModal = filteredList.isSelfReg;
        if (!filteredList.isSelfReg) {
          filteredList.maxSelfRegCount = 0;
          delete filteredList.selfRegGroupList;
          delete filteredList.selfRegGroupId;
        }
        if (!filteredList.applicationName) {
          filteredList.applicationName = self.appList.filter(function (y) {
            return y.id === filteredList.applicationId;
          })[0].label;
        }
        console.log(self.currGroupDetails);
        filteredList.subGroupManagement.forEach(function (grp) {
          if (grp.roleChanged) {
            if (grp.subGroupId.indexOf('~~~') > -1) {
              var newGroup = grp.subGroupId.split('~~~')[0];

              filteredList.subGroupsMap[newGroup] = filteredList.subGroupsMap[grp.subGroupId];
              delete filteredList.subGroupsMap[grp.subGroupId];

              filteredList.subGroupId = filteredList.subGroupId.filter(function (x) {
                return x !== grp.subGroupId;
              });
              filteredList.subGroupId.push(newGroup);

              grp.subGroupId = newGroup;
            } else {
              var _newGroup = grp.subGroupId + "~~~" + grp.subGroupName;

              filteredList.subGroupsMap[_newGroup] = filteredList.subGroupsMap[grp.subGroupId];
              delete filteredList.subGroupsMap[grp.subGroupId];

              filteredList.subGroupId = filteredList.subGroupId.filter(function (x) {
                return x !== grp.subGroupId;
              });
              filteredList.subGroupId.push(_newGroup);

              grp.subGroupId = _newGroup;
            }
          }
        });

        __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].addToAdminConfigDB(apiUrl + '/auth/appGroupNew', [filteredList]).then(function (response) {
          self.loading = false;
          self.showDropdownForGroups = false;
          self.showDropdownForSelfGroups = false;
          var el = document.getElementById("search-criteria");
          el.value = '';
          $(".searchbox .list").each(function () {
            var s = $(this).text().toLowerCase();

            $(this).closest('.searchbox')[s.indexOf(el.value) !== -1 ? 'show' : 'hide']();
          });
          console.log(el.value);
          self.getConfigList();
          self.updateAdminConfigsInLocal();
          if (response.data.status.statusCode === "500") {
            window.alert(response.data.status.status);
          } else {
            setTimeout(function () {
              self.saveSuccess = true;
              self.showAppList = true;
              self.applicationIndex = 0;
            }, 500);
          }
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        self.loading = false;
      }
    },
    populateOptionDetails: function populateOptionDetails(appId, index) {
      var self = this;
      self.clearMessages();
      self.appsGroups[appId].some(function (i) {
        if (i.id === self.appAdminGroupModal[index].groupId) {
          self.appAdminGroupModal[index].groupId = i._embedded.group.id;
          return true;
        }
      });
      self.appsSelfGroups[appId].some(function (i) {
        if (i.id === self.appAdminGroupModal[index].groupId) {
          self.appAdminGroupModal[index].groupId = i._embedded.group.id;
          return true;
        }
      });
    },
    removeRow: function removeRow(appgrpId, index, gn) {
      var self = this;
      self.currRemoveId = appgrpId;
      self.currRemoveIndex = index;
      if (gn === onecargillappid) {
        self.clearMessages();
        $('.cannotDeleteModal').modal('show');
      } else {
        self.clearMessages();
        $('.deleteConfirmModal').modal('show');
      }
    },
    removeConfirm: function removeConfirm() {
      var self = this;
      self.loading = true;
      self.appAdminGroupModal.splice(self.currRemoveIndex, 1);
      self.appNameList.splice(self.currRemoveIndex, 1);
      var data = { "appGrpId": self.currRemoveId };

      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].deleteAdminConfig(apiUrl + '/auth/appGroupNew', data).then(function (response) {
        self.loading = false;
        self.applicationIndex = 0;
        $('.deleteConfirmModal').modal('hide');
        self.deleteSuccess = true;
        var el = document.getElementById("search-criteria");
        el.value = '';
        $(".searchbox .list").each(function () {
          var s = $(this).text().toLowerCase();

          $(this).closest('.searchbox')[s.indexOf(el.value) !== -1 ? 'show' : 'hide']();
        });
        self.updateAdminConfigsInLocal();
        self.getConfigList();
      }).catch(function (err) {
        console.log(err);
      });
    },
    cancelRemove: function cancelRemove() {
      $('.deleteConfirmModal').modal('hide');
    },
    clearMessages: function clearMessages() {
      var self = this;
      self.isIncomplete = false;
      self.saveSuccess = false;
      self.deleteSuccess = false;
    },
    isAlreadyConfiged: function isAlreadyConfiged(id) {
      var self = this;
      var listOfConfigedApps = self.appAdminGroupModal.map(function (i) {
        return i.applicationId;
      });
      return id === onecargillappid && listOfConfigedApps.indexOf(id) > -1;
    },
    updateAdminConfigsInLocal: function updateAdminConfigsInLocal() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getListOfAdminConfig(apiUrl + '/auth/appGroupListNew').then(function (response) {
        self.loading = false;
        self.getNamesOfApp();
        self.persistInLocal(response);
      }).catch(function (err) {
        console.log(err);
      });
    },
    persistInLocal: function persistInLocal(response) {
      var adminGroupsArr = [];
      var adminAppsArr = [];
      adminGroupsArr = response.data.map(function (i) {
        return i.groupId;
      });
      adminAppsArr = response.data.map(function (i) {
        return i.applicationId;
      });
      __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].set('adminConfigMaster', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
      __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].set('adminConfigJSON', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(adminGroupsArr));
      __WEBPACK_IMPORTED_MODULE_7__helpers_storage__["default"].set('adminConfigJSONApps', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(adminAppsArr));
    }
  },
  data: function data() {
    return {
      brandDetails: brandDetails,
      additionalGroup: [],
      additionalSelfGroup: [],
      showDropdownForGroups: false,
      showDropdownForSelfGroups: false,
      lang: __WEBPACK_IMPORTED_MODULE_5__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_5__i18n_locale_js__["locale"].lang_obj,
      userId: '',
      loading: false,
      user_lang: {},
      prefLang: 'en_US',
      email: '',
      clientList: [],
      appList: [],
      appsGroups: {},
      appsSelfGroups: {},
      appGroupsArrayMap: {},
      modalObj: {},
      selectModel: {},
      optionModel: {},
      appAdminGroupModal: [{ "applicationId": "undefined", "brand": "undefined", "groupId": "undefined", "subGroupId": [], "subGroupsMap": {}, isDxp: false, email: "undefined", isSelfReg: false, maxSelfRegCount: 0, selfRegGroupList: [], selfRegGroupId: "undefined", isSelfRegModal: false, emailId: "", disableExistingUserOnboard: false }],
      rowObj: { "applicationId": "undefined", "brand": "undefined", "groupId": "undefined", "subGroupId": [], "subGroupsMap": {}, isDxp: false, email: "undefined", isSelfReg: false, maxSelfRegCount: 0, selfRegGroupList: [], selfRegGroupId: "undefined", isSelfRegModal: false, emailId: "", disableExistingUserOnboard: false },
      isIncomplete: false,
      saveSuccess: false,
      deleteSuccess: false,
      currRemoveId: '',
      currRemoveIndex: '',
      appNameList: [],
      showAppList: true,
      applicationIndex: 0,
      isNewAppConfig: false,
      groupNameTyped: "",
      timer: 0,
      isSearched: false,
      searchDropdownData: [],
      currGroupDetails: [],
      currGroupIds: [],
      tempAppAdminGroupModal: [{
        applicationId: "undefined",
        brand: "cargill",
        groupId: "",
        subGroupId: [],
        subGroupsMap: {},
        isDxp: false,
        email: "undefined",
        isSelfReg: false,
        maxSelfRegCount: 0,
        selfRegGroupList: [],
        selfRegGroupId: "undefined",
        isSelfRegModal: false,
        emailId: "",
        disableExistingUserOnboard: false
      }]
    };
  },

  computed: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_widgets_TopNavFooter__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_widgets_TopNavFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_widgets_TopNavFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__idm_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_storage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(29);










var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";
var onecargillappid = "0oa10r32yuaNJCfrw0h8";

var environment = "stage";
var brandDetails = "";
console.log('env=====', environment);
if (environment === 'production') {
  brandDetails = __webpack_require__(16);
} else if (environment === 'stage') {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tm',
  components: {
    TopNavFooter: __WEBPACK_IMPORTED_MODULE_1__components_widgets_TopNavFooter___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner___default.a
  },
  created: function created() {
    var self = this;
    self.loading = true;
    self.userId = __WEBPACK_IMPORTED_MODULE_6__helpers_storage__["default"].get('cf-user').sub;
    self.email = __WEBPACK_IMPORTED_MODULE_6__helpers_storage__["default"].get('email');
    this.user_lang = this.lang_br;
    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_5__event_bus_js__["EventBus"].$on('lang', function (language) {
      self.user_lang = self.lang_obj[language];
    });
    self.getListOfSuperUserApps();
  },
  mounted: function mounted() {
    var self = this;
    var tempshowDropDown = {};
    var tempshowSelfDropDown = {};
    for (var i = 0; i < 100; i++) {
      tempshowDropDown[i.toString()] = false;
      tempshowSelfDropDown[i.toString()] = false;
    }
    self.showDropDown = tempshowDropDown;
    self.showSelfDropDown = tempshowSelfDropDown;
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    $(document).on('click', 'body', function (e) {
      if (!$('div#dropdown').has(e.target).length) {
        var tempshowDropDown = {};
        var tempshowSelfDropDown = {};
        for (var i = 0; i < 100; i++) {
          tempshowDropDown[i.toString()] = false;
          tempshowSelfDropDown[i.toString()] = false;
        }
        self.showDropDown = tempshowDropDown;
        self.showSelfDropDown = tempshowSelfDropDown;
      }
    });
  },

  watch: {
    appAdminGroupModal: function appAdminGroupModal() {
      this.watchAppAdminGroupModal();
    }
  },
  methods: {
    watchAppAdminGroupModal: function watchAppAdminGroupModal() {
      var self = this;
      console.log('watch');
      if (this.appAdminGroupModal.length === 0) {
        var newRowObj = $.extend(true, {}, self.rowObj);
        self.appAdminGroupModal.push(newRowObj);
      }
    },
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    addAdditionalGroup: function addAdditionalGroup(index, appid) {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].getGroupByName(apiUrl + '/auth/groups/search?groupName=' + self.additionalGroup[index]).then(function (response) {
        self.addAdditionalGroupImpl(response, index, appid);
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    addAdditionalSelfGroup: function addAdditionalSelfGroup(index, appid) {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].getGroupByName(apiUrl + '/auth/groups/search?groupName=' + self.additionalSelfGroup[index]).then(function (response) {
        self.addAdditionalGroupSelfImpl(response, index, appid);
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    addAdditionalGroupSelfImpl: function addAdditionalGroupSelfImpl(response, index, appid) {
      var self = this;
      self.loading = false;
      if (response.data.length === 0) {
        window.alert('Please enter valid group name');
        self.additionalSelfGroup = [];
      } else {
        var fl = self.appsSelfGroups[appid].filter(function (x) {
          return x.id === response.data[0].id;
        });
        if (fl.length === 0) {
          var indieSubGroupEntry = response.data[0].id + '~~~' + response.data[0].profile.name;
          self.appAdminGroupModal[index].selfRegGroupList.push(indieSubGroupEntry.trim());
          self.additionalSelfGroup = [];
        } else {
          window.alert('Please select this group from the dropdown');
          self.additionalSelfGroup = [];
        }
      }
    },
    addAdditionalGroupImpl: function addAdditionalGroupImpl(response, index, appid) {
      var self = this;

      self.loading = false;
      if (response.data.length === 0) {
        window.alert('Please enter valid group name');
        self.additionalGroup = [];
      } else {
        var fl = self.appsGroups[appid].filter(function (x) {
          return x.id === response.data[0].id;
        });
        if (fl.length === 0) {
          var indieSubGroupEntry = response.data[0].id + '~~~' + response.data[0].profile.name;
          self.appAdminGroupModal[index].subGroupId.push(indieSubGroupEntry.trim());
          self.additionalGroup = [];
        } else {
          window.alert('Please select this group from the dropdown');
          self.additionalGroup = [];
        }
      }
    },
    checkchange: function checkchange(e) {
      console.log(e);
      var self = this;
      var grpid = e.target.id.split('~')[0];
      var idx = e.target.id.split('~')[1];
      if (self.appAdminGroupModal[idx].subGroupId === undefined) {
        self.appAdminGroupModal[idx]['subGroupId'] = [];
      }
      if (e.target.checked && self.appAdminGroupModal[idx].subGroupId.indexOf(grpid) === -1) {
        self.appAdminGroupModal[idx].subGroupId.push(grpid);
      } else {
        self.appAdminGroupModal[idx].subGroupId = self.appAdminGroupModal[idx].subGroupId.filter(function (e) {
          return e.indexOf(grpid) === -1;
        });
      }
    },
    checkSelfchange: function checkSelfchange(e) {
      var self = this;
      var grpid = e.target.id.split('~self')[0];
      var idx = e.target.id.split('~self')[1];
      if (self.appAdminGroupModal[idx].selfRegGroupList === undefined) {
        self.appAdminGroupModal[idx]['selfRegGroupList'] = [];
      }
      if (e.target.checked && self.appAdminGroupModal[idx].selfRegGroupList.indexOf(grpid) === -1) {
        self.appAdminGroupModal[idx].selfRegGroupList.push(grpid);
      } else {
        self.appAdminGroupModal[idx].selfRegGroupList = self.appAdminGroupModal[idx].selfRegGroupList.filter(function (e) {
          return e.indexOf(grpid) === -1;
        });
      }
    },
    openDropDown: function openDropDown(index) {
      var self = this;
      self.showDropDown[index.toString()] = !self.showDropDown[index.toString()];
      if (self.appAdminGroupModal[index].subGroupId === undefined) {
        self.appAdminGroupModal[index]['subGroupId'] = [];
      }
      for (var i = 0; i < self.appAdminGroupModal[index].subGroupId.length; i++) {
        var sel = '';
        if (self.appAdminGroupModal[index].subGroupId[i].indexOf('~~~') > -1) {
          sel = '.ddwrap' + index + ' [id^="' + self.appAdminGroupModal[index].subGroupId[i].split('~~~')[0] + '"]';
        } else {
          sel = '.ddwrap' + index + ' [id^="' + self.appAdminGroupModal[index].subGroupId[i] + '"]';
        }
        $(sel).attr('checked', true);
      }
    },
    openSelfRegDropDown: function openSelfRegDropDown(index) {
      var self = this;
      self.showSelfDropDown[index.toString()] = !self.showSelfDropDown[index.toString()];
      if (self.appAdminGroupModal[index].selfRegGroupList === undefined) {
        self.appAdminGroupModal[index]['selfRegGroupList'] = [];
      }
      for (var i = 0; i < self.appAdminGroupModal[index].selfRegGroupList.length; i++) {
        var sel = '';
        if (self.appAdminGroupModal[index].selfRegGroupList[i].indexOf('~~~') > -1) {
          sel = '.ddwrap' + index + ' [id^="' + self.appAdminGroupModal[index].selfRegGroupList[i].split('~~~')[0] + '"]';
        } else {
          sel = '.ddwrap' + index + ' [id^="' + self.appAdminGroupModal[index].selfRegGroupList[i] + '"]';
        }
        $(sel).attr('checked', true);
      }
    },
    getListOfClientId: function getListOfClientId() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].getClientIds(apiUrl + '/apitokenList', self.email).then(function (response) {
        self.loading = false;
        self.clientList = response.data;
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    getListOfSuperUserApps: function getListOfSuperUserApps() {
      var self = this;
      self.clearMessages();
      __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].getListOfSuperUserApps(apiUrl + '/auth/apps', self.email).then(function (response) {
        self.loading = false;
        self.appList = response.data;
        self.appList.sort(function (a, b) {
          return a.label.toLowerCase() > b.label.toLowerCase() ? 1 : b.label.toLowerCase() > a.label.toLowerCase() ? -1 : 0;
        });
        self.getConfigList();
      }).catch(function (err) {
        self.loading = false;
        console.log(err);
      });
    },
    getGroups: function getGroups(id) {
      var self = this;
      self.clearMessages();
      if ((self.appsGroups[id] === undefined && id !== 'undefined' || self.appsSelfGroups[id] === undefined && id !== 'undefined') && id !== undefined) {
        self.loading = true;
        __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].getGroupsByAppId(apiUrl + '/auth/apps/' + id + '/groups').then(function (response) {
          self.loading = false;
          var gmap = response.data.map(function (x) {
            return x.id;
          });
          __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].set(self.appGroupsArrayMap, id, gmap);
          __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].set(self.appsGroups, id, response.data.sort(function (a, b) {
            return a._embedded.group.profile.name.toLowerCase() > b._embedded.group.profile.name.toLowerCase() ? 1 : b._embedded.group.profile.name.toLowerCase() > a._embedded.group.profile.name.toLowerCase() ? -1 : 0;
          }));
          __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].set(self.appsSelfGroups, id, response.data.sort(function (a, b) {
            return a._embedded.group.profile.name.toLowerCase() > b._embedded.group.profile.name.toLowerCase() ? 1 : b._embedded.group.profile.name.toLowerCase() > a._embedded.group.profile.name.toLowerCase() ? -1 : 0;
          }));
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    addConfigRow: function addConfigRow() {
      var self = this;
      self.clearMessages();
      var newRowObj = $.extend(true, {}, self.rowObj);
      self.appAdminGroupModal.push(newRowObj);
    },
    getConfigList: function getConfigList() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].getListOfAdminConfig(apiUrl + '/auth/appGroupListNew').then(function (response) {
        self.appAdminGroupModal = response.data;
        if (self.appAdminGroupModal.length > 0) {
          self.appAdminGroupModal.map(function (i) {
            self.loading = true;
            self.getGroups(i.applicationId);
            i.isSelfRegModal = i.isSelfReg;
          });
        } else {
          self.addConfigRow();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    saveAdminGroups: function saveAdminGroups() {
      var self = this;
      self.clearMessages();
      var filteredList = self.appAdminGroupModal.filter(function (i) {
        return i.applicationId !== 'undefined' && i.applicationId !== undefined;
      });
      self.isIncomplete = filteredList.some(function (i) {
        if (i.brand === 'undefined' || i.brand === undefined || i.groupId === 'undefined' || i.groupId === undefined || i.subGroupId && i.subGroupId.length === 0 || i.isSelfReg && (i.emailId === undefined || i.selfRegGroupId === 'undefined' || i.selfRegGroupList.length === 0 || i.maxSelfRegCount === 0)) {
          return true;
        }
      });
      if (!self.isIncomplete) {
        self.loading = true;
        filteredList.map(function (i) {
          i.adminGroupName = self.appsGroups[i.applicationId].filter(function (x) {
            return x.id === i.groupId;
          })[0]._embedded.group.profile.name;
          if (!i.isSelfReg) {
            i.maxSelfRegCount = 0;
            delete i.selfRegGroupList;
            delete i.selfRegGroupId;
          }
          i.email = self.email;
        });

        __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].addToAdminConfigDB(apiUrl + '/auth/appGroupNew', filteredList).then(function (response) {
          self.loading = false;
          self.getConfigList();
          self.updateAdminConfigsInLocal();
          if (response.data.status.statusCode === "500") {
            window.alert(response.data.status.status);
          } else {
            setTimeout(function () {
              self.saveSuccess = true;
            }, 500);
          }
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        self.loading = false;
      }
    },
    populateOptionDetails: function populateOptionDetails(appId, index) {
      var self = this;
      self.clearMessages();
      self.appsGroups[appId].some(function (i) {
        if (i.id === self.appAdminGroupModal[index].groupId) {
          self.appAdminGroupModal[index].groupId = i._embedded.group.id;
          return true;
        }
      });
      self.appsSelfGroups[appId].some(function (i) {
        if (i.id === self.appAdminGroupModal[index].groupId) {
          self.appAdminGroupModal[index].groupId = i._embedded.group.id;
          return true;
        }
      });
    },
    removeRow: function removeRow(appgrpId, index, gn) {
      var self = this;
      self.currRemoveId = appgrpId;
      self.currRemoveIndex = index;
      if (gn === onecargillappid) {
        self.clearMessages();
        $('.cannotDeleteModal').modal('show');
      } else {
        self.clearMessages();
        $('.deleteConfirmModal').modal('show');
      }
    },
    removeConfirm: function removeConfirm() {
      var self = this;
      self.loading = true;
      self.appAdminGroupModal.splice(self.currRemoveIndex, 1);
      var data = { "appGrpId": self.currRemoveId };

      __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].deleteAdminConfig(apiUrl + '/auth/appGroupNew', data).then(function (response) {
        self.loading = false;
        $('.deleteConfirmModal').modal('hide');
        self.deleteSuccess = true;
        self.updateAdminConfigsInLocal();
      }).catch(function (err) {
        console.log(err);
      });
    },
    cancelRemove: function cancelRemove() {
      $('.deleteConfirmModal').modal('hide');
    },
    clearMessages: function clearMessages() {
      var self = this;
      self.isIncomplete = false;
      self.saveSuccess = false;
      self.deleteSuccess = false;
    },
    isAlreadyConfiged: function isAlreadyConfiged(id) {
      var self = this;
      var listOfConfigedApps = self.appAdminGroupModal.map(function (i) {
        return i.applicationId;
      });
      return id === onecargillappid && listOfConfigedApps.indexOf(id) > -1;
    },
    updateAdminConfigsInLocal: function updateAdminConfigsInLocal() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__idm_api__["default"].getListOfAdminConfig(apiUrl + '/auth/appGroupListNew').then(function (response) {
        self.loading = false;
        self.persistInLocal(response);
      }).catch(function (err) {
        console.log(err);
      });
    },
    persistInLocal: function persistInLocal(response) {
      var adminGroupsArr = [];
      var adminAppsArr = [];
      adminGroupsArr = response.data.map(function (i) {
        return i.groupId;
      });
      adminAppsArr = response.data.map(function (i) {
        return i.applicationId;
      });
      __WEBPACK_IMPORTED_MODULE_6__helpers_storage__["default"].set('adminConfigMaster', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
      __WEBPACK_IMPORTED_MODULE_6__helpers_storage__["default"].set('adminConfigJSON', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(adminGroupsArr));
      __WEBPACK_IMPORTED_MODULE_6__helpers_storage__["default"].set('adminConfigJSONApps', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(adminAppsArr));
    }
  },
  data: function data() {
    return {
      brandDetails: brandDetails,
      additionalGroup: [],
      additionalSelfGroup: [],
      showDropDown: { "0": false, "1": false, "2": false, "3": false, "4": false, "5": false, "6": false, "7": false, "8": false, "9": false, "10": false },
      showSelfDropDown: { "0": false, "1": false, "2": false, "3": false, "4": false, "5": false, "6": false, "7": false, "8": false, "9": false, "10": false },
      lang: __WEBPACK_IMPORTED_MODULE_4__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_4__i18n_locale_js__["locale"].lang_obj,
      userId: '',
      loading: false,
      user_lang: {},
      prefLang: 'en_US',
      email: '',
      clientList: [],
      appList: [],
      appsGroups: {},
      appsSelfGroups: {},
      appGroupsArrayMap: {},
      modalObj: {},
      selectModel: {},
      optionModel: {},
      appAdminGroupModal: [{ "applicationId": "undefined", "brand": "undefined", "groupId": "undefined", "subGroupId": [], isDxp: false, email: "undefined", isSelfReg: false, maxSelfRegCount: 0, selfRegGroupList: [], selfRegGroupId: "undefined", isSelfRegModal: false, emailId: "", disableExistingUserOnboard: false }],
      rowObj: { "applicationId": "undefined", "brand": "undefined", "groupId": "undefined", "subGroupId": [], isDxp: false, email: "undefined", isSelfReg: false, maxSelfRegCount: 0, selfRegGroupList: [], selfRegGroupId: "undefined", isSelfRegModal: false, emailId: "", disableExistingUserOnboard: false },
      isIncomplete: false,
      saveSuccess: false,
      deleteSuccess: false,
      currRemoveId: '',
      currRemoveIndex: ''
    };
  },

  computed: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_storage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__idm_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_common__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_country_dropdown_list__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_recaptcha__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_locale_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_country_code__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_group_phone__ = __webpack_require__(167);













var islowerCase = "^(?=.*[a-z])";
var isUpperCase = "^(?=.*[A-Z])";
var isNumber = "^(?=.*[0-9])";
var isSpecialChar = "^(?=.*[!@#$%^&*-])";
var isMinLength = "^(?=.{8,})";
var apiUrl = "https://api.stage.mycargill.com/api/dxo/onecargill/portal/v1";
var APPS_MANDATE_PHONE = ["0oag15jfabJvKVyJn0h7"];
var SITEKEY = "6LdSQasZAAAAAF1410vaTDMpUNtKrqs1RtOZuiLC";

var environment = "stage";
var brandDetails = "";
console.log("env=====", environment);
if (environment === "production") {
  brandDetails = __webpack_require__(16);
} else if (environment === "stage") {
  brandDetails = __webpack_require__(18);
} else {
  brandDetails = __webpack_require__(17);
}
var internalUserDomains = __webpack_require__(78).data;
/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.dropdownList = __WEBPACK_IMPORTED_MODULE_5__helpers_country_dropdown_list__["default"].lang;
    console.log(this.dropdownList);
    this.paramLang = this.getParameterByName("lang", document.location.href);
    this.fetchTokenAndInitiate();
    var self = this;
    $(document).on("keypress", "input", function () {
      self.errorCode = "";
      self.userValidations = "";
    });
    $(document).on("keypress", "#pn,#verifyCode", function (evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    });

    setTimeout(self.assignUserLang(), 1000);
    __WEBPACK_IMPORTED_MODULE_8__event_bus_js__["EventBus"].$on("lang", function (language) {
      self.user_lang = self.lang_obj[language];
      self.lang = language;
    });
    var brand = brandDetails.data.filter(function (i) {
      return i.applicationUrls.indexOf(document.location.host) > -1;
    });
    if (brand[0].brandCode !== "001") {
      self.whitelabelSpecific = true;
    }
  },
  mounted: function mounted() {
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.setDefaultCountry();
    this.getBrandName();
    this.updateCaptchaWithLocale();
  },
  data: function data() {
    return {
      templateLang: "en_US",
      enableRefIdApproach: false,
      refId: "",
      brandDetails: brandDetails,
      brand: "",
      termsArray: [],
      brandtermagree: [],
      tclink: "https://www.cargill.com/portal-terms",
      pplink: "https://www.cargill.com/page/privacy",
      listofsecquestions: [],
      lang: __WEBPACK_IMPORTED_MODULE_7__i18n_locale_js__["locale"].lang,
      lang_obj: __WEBPACK_IMPORTED_MODULE_7__i18n_locale_js__["locale"].lang_obj,
      fetchResponse: "",
      phN: "",
      countryCode: "1",
      token: "",
      userId: "00ud1f5tz9guPug9Z0h7",
      firstName: "",
      lastName: "",
      loginId: "",
      errorCode: "",
      password: "",
      showPhNoPane: false,
      selectedSecQN: "disliked_food",
      repeatpassword: "",
      securityImage: "",
      alreadyRegistered: false,
      answer: "",
      custom_question: "",
      issuccess: false,
      iserror: false,
      verifycode: "",
      factorId: "",
      enableOTPSend: true,
      error30SecOTP: false,
      phoneNumberNotValid: false,
      phoneNoAlreadySet: false,
      tokenInvalid: false,
      pwdValid: false,
      activateFactorId: "",
      factorIdToDelete: "",
      passwordPolicyArray: [],
      currPwdPolicy: {},
      pwdComplexity: {},
      pwdErrorArray: [],
      availableFactorID: null,
      errorMessages: {},
      minAnswerLength: "",
      codeSent: false,
      user_lang: __WEBPACK_IMPORTED_MODULE_7__i18n_locale_js__["locale"].lang_obj["en_US"],
      loading: true,
      accountsetup: false,
      internalUser: false,
      userApps: [],
      regApps: [],
      agreeone: false,
      agreetwo: false,
      isServiceAccountGroupMember: false,
      userEmail: "",
      userLastName: "",
      userValidations: "",
      captchaResponse: "",
      captchaVerified: false,
      inviteSuccess: false,
      isSRCdxp: "",
      sitekey: SITEKEY,
      noTransformEmail: false,
      brandCode: "",
      paramLang: "",
      errorMsg: "",
      localeLang: { uk: "380", fr: "33", ru: "7" },
      defaultLocaleLang: { ph: "63", us: "1", aus: "061" },
      browserLang: "",
      isGroupPhone: false,
      showPasswordError: true,
      whitelabelSpecific: false,
      otpSent: false,
      isPhoneNoNotVerified: false,
      isNetworkError: false,
      verifyCodeError: "",
      verifyClicked: false,
      dropdownList: [],
      genericErrorMsg: false,
      allAvailableFactors: []
    };
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner___default.a,
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_6_vue_recaptcha__["a" /* default */]
  },
  computed: {
    inputOneHasError: function inputOneHasError() {
      if (this.password.length === 0) {
        return "";
      }
      return this.pwdValidationObj.length !== 0 ? "invalid fa fa-exclamation-circle" : "valid fa fa-check-circle";
    },
    inputTwoHasError: function inputTwoHasError() {
      if (this.repeatpassword.length === 0) {
        return "";
      }
      return this.repeatPwdValidationObj.length !== 0 ? "invalid fa fa-exclamation-circle" : "valid fa fa-check-circle";
    },
    borderForInputOne: function borderForInputOne() {
      if (this.password.length === 0) {
        return "";
      }
      return this.pwdValidationObj.length !== 0 ? "red-border" : "green-border";
    },
    borderForInputTwo: function borderForInputTwo() {
      if (this.repeatpassword.length === 0) {
        return "";
      }
      return this.repeatPwdValidationObj.length !== 0 ? "red-border" : "green-border";
    },

    pwdValidationObj: function pwdValidationObj() {
      var errors = [];
      var minCharRegex = isMinLength.replace("8", this.pwdComplexity.minLength);
      if (this.password.trim().length > 0) {
        if (this.pwdComplexity.minLowerCase > 0 && !this.password.trim().match(new RegExp(islowerCase))) {
          errors.push(this.user_lang.noLowerCase);
        }
        if (this.pwdComplexity.minUpperCase > 0 && !this.password.trim().match(new RegExp(isUpperCase))) {
          errors.push(this.user_lang.noUpperCase);
        }
        if (this.pwdComplexity.minNumber > 0 && !this.password.trim().match(new RegExp(isNumber))) {
          errors.push(this.user_lang.noNumber);
        }
        if (this.pwdComplexity.minSymbol > 0 && !this.password.trim().match(new RegExp(isSpecialChar))) {
          errors.push(this.user_lang.noSpecialCharacter);
        }
        if (!this.password.trim().match(new RegExp(minCharRegex))) {
          errors.push(this.user_lang.notMinLength.replace("$", this.pwdComplexity.minLength));
        }
        if (this.pwdComplexity.excludeAttributes !== undefined && this.pwdComplexity.excludeAttributes.includes("lastName") && this.password.trim().indexOf(this.lastName) !== -1) {
          errors.push(this.user_lang.noLastnameSubstring);
        }
        if (this.pwdComplexity.excludeAttributes !== undefined && this.pwdComplexity.excludeAttributes.includes("firstName") && this.password.trim().indexOf(this.firstName) !== -1) {
          errors.push(this.user_lang.noFirstnameSubstring);
        }
        if (this.pwdComplexity.excludeUsername && this.loginId.indexOf(this.password.trim()) > -1) {
          errors.push(this.user_lang.noUsernameSubstring);
        }
        if (errors.length === 0) {
          this.pwdValid = true;
        }
      }
      this.pwdErrorArray = errors;
      return errors;
    },
    repeatPwdValidationObj: function repeatPwdValidationObj() {
      var errors = [];
      if (this.repeatpassword.trim().length > 0) {
        if (this.password.trim() !== this.repeatpassword.trim()) {
          errors.push(this.user_lang.passwordnotmatching);
        }
      }
      this.pwdErrorArray = errors;
      return errors;
    }
  },
  watch: {
    phN: function phN() {
      this.watchphN();
    },
    agreeone: function agreeone() {
      this.watchAgreeTerms();
    },
    agreetwo: function agreetwo() {
      this.watchAgreeTerms();
    },
    brandtermagree: function brandtermagree() {
      this.watchAgreeTerms();
    }
  },
  methods: {
    detectBrowser: function detectBrowser() {
      var isBrowserSpecific = false;
      var userAgent = navigator.userAgent;
      var ieMode = document.documentMode;
      if (ieMode && userAgent.match(/(MSIE|Trident)/)) {
        isBrowserSpecific = true;
      } else if (navigator.vendor && navigator.vendor.indexOf("Apple") > -1 && userAgent && userAgent.indexOf("CriOS") === -1 && userAgent.indexOf("FxiOS") === -1) {
        var version = 0;
        if (userAgent.indexOf("Version") > -1) {
          version = parseInt(userAgent.split("Version/")[1].split(" ")[0], 10);
        }
        if (navigator.platform.indexOf("Mac") > -1) {
          if (userAgent.split("OS X ")[1] && userAgent.split("OS X ")[1].split(" ")[0].indexOf("10_9") > -1 && version >= 7 && version < 8) {
            isBrowserSpecific = true;
          } else if (userAgent.split("OS X ")[1] && userAgent.split("OS X ")[1].split(" ")[0].indexOf("10_10") > -1 && version >= 8 && version < 9) {
            isBrowserSpecific = true;
          }
        } else if (["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || userAgent.includes("Mac") && "ontouchend" in document) {
          if (version >= 6 && version < 7) {
            isBrowserSpecific = true;
          } else if (version >= 7 && version < 8) {
            isBrowserSpecific = true;
          } else if (version >= 8 && version < 9) {
            isBrowserSpecific = true;
          }
        }
      }
      return isBrowserSpecific;
    },
    errorModalClick: function errorModalClick() {
      var self = this;
      $(".errorModal").modal("hide");
      self.showPasswordError = true;
    },
    countryCodeDefaultBasedOnGroups: function countryCodeDefaultBasedOnGroups(groups) {
      var self = this;
      var commonGroups = [];
      groups.forEach(function (group) {
        var groupName = __WEBPACK_IMPORTED_MODULE_9__helpers_country_code__["default"].getGroup(group.profile.name);
        if (groupName.length > 0) {
          commonGroups.push(groupName[0]);
        }
      });
      if (commonGroups.length > 1) {
        self.countryCode = self.defaultLocaleLang["us"];
      } else if (commonGroups.length === 1) {
        self.countryCode = self.defaultLocaleLang[commonGroups[0].lang];
        if (self.templateLang === 'es_ES' && commonGroups[0].lang === "aus") {
          self.countryCode = "61";
        }
      }
      console.log("Common Groups: ", commonGroups);
    },
    setDefaultCountry: function setDefaultCountry() {
      var browserLang = window.navigator.language;
      this.browserLang = browserLang;
      if (browserLang === "uk" || browserLang === "fr" || browserLang === "ru") {
        this.countryCode = this.localeLang[browserLang];
      }
      if (this.templateLang && this.templateLang.toLowerCase() === "ko_kr") {
        this.countryCode = "82";
      }
    },
    updateCaptchaWithLocale: function updateCaptchaWithLocale() {
      var iframeGoogleCaptcha = $("#captcha_container").find("iframe");
      var lang = __WEBPACK_IMPORTED_MODULE_4__helpers_common__["default"].getLanguage(this.paramLang);
      if (lang === "zh_TW") {
        lang = "bg";
      }
      lang = lang.replace("_", "-");
      if (iframeGoogleCaptcha && iframeGoogleCaptcha.length > 0) {
        iframeGoogleCaptcha.attr("src", iframeGoogleCaptcha.attr("src").replace(/hl=(.*?)&/, "hl=" + lang + "&"));
      }
    },
    getParameterByName: function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
      var results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    watchphN: function watchphN() {
      var self = this;
      self.isPhoneNoNotVerified = self.phN.length > 0;
      if (self.countryCode === "1") {
        var x = self.phN.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        self.phN = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
      } else if (self.countryCode === "061" && self.phN.length > 10) {
        self.phN = self.phN.slice(0, 10);
      }
    },
    watchAgreeTerms: function watchAgreeTerms() {
      var self = this;
      if ((self.agreeone || self.agreetwo) && self.errorCode.indexOf("acceptTerms") > -1) {
        self.errorCode = "";
      }
      if (self.brandtermagree.some(function (x) {
        return x === true;
      }) && self.errorCode.indexOf("acceptTerms") > -1) {
        self.errorCode = "";
      }
    },
    assignUserLang: function assignUserLang() {
      var self = this;
      self.user_lang = self.lang_obj[this.lang];
    },
    goToApp: function goToApp(url) {
      window.open(url, "_blank");
    },
    getPasswordPolicy: function getPasswordPolicy() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getPasswordPolicy(apiUrl + "/policies", self.token).then(function (response) {
        self.passwordPolicyArray = response.data;
        if (self.passwordPolicyArray.length === 1) {
          self.currPwdPolicy = response.data.filter(function (i) {
            if (i.name === "Default Policy") return i;
          });
        } else {
          self.currPwdPolicy = response.data.filter(function (i) {
            if (i.name === "Legacy Policy") return i;
          });
        }
        self.pwdComplexity = self.currPwdPolicy[0].settings.password.complexity;
        self.minAnswerLength = self.currPwdPolicy[0].settings.recovery.factors.recovery_question.properties.complexity.minLength;
        self.loading = false;
      });
    },
    isCheckboxDisabled: function isCheckboxDisabled() {
      var self = this;
      if (self.brand.toLowerCase() === "cargill") {
        if (!self.agreeone || !self.agreetwo) {
          self.errorCode = "acceptTerms";
        }
      } else {
        if (self.brandtermagree.filter(function (x) {
          return x === true;
        }).length !== self.termsArray.length) {
          self.errorCode = "acceptTerms";
        }
      }
    },
    setUserAccount: function setUserAccount() {
      var self = this;
      self.loading = true;
      self.errorCode = "";
      $(".errorModal").modal("hide");
      self.showPasswordError = true;
      if (this.validateSetUser() && this.validatePhoneNumberCheck()) {
        var data = {
          credentials: {
            password: {
              value: this.password
            } }
        };
        __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].setUserAccount(apiUrl + "/users/" + self.userId, data, self.token).then(function (response) {
          self.loading = false;
          if (response.data.status === "ACTIVE") {
            __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].clearAll();
            self.accountsetup = true;
          } else {}
        }).catch(function (error) {
          console.log(error);
          if (error.response.data && error.response.data.errorCauses && error.response.data.errorCauses.length && error.response.data.errorCauses[0].errorSummary) {
            var errorSummary = error.response.data.errorCauses[0].errorSummary;
            $(".errorModal").modal("show");
            self.showPasswordError = false;
            if (errorSummary.indexOf("password") !== -1) {
              self.errorMsg = self.user_lang.phoneValidationErrorMessage;
            } else if (errorSummary.indexOf("securityAnswer") !== -1) {
              self.errorMsg = self.user_lang.securityquestionanswerweak;
            } else {
              self.errorMsg = error.response.data.errorCauses[0].errorSummary;
            }
            self.loading = false;
          }
          self.loading = false;
        });
      } else {
        self.loading = false;
      }
    },
    fetchTokenAndInitiate: function fetchTokenAndInitiate() {
      var self = this;
      var actToken = this.getParameterByName("activationToken", document.location.href);
      this.templateLang = this.getParameterByName("lang", document.location.href);
      this.isSRCdxp = this.getParameterByName("src", document.location.href);
      if (actToken === null || actToken === undefined || actToken.trim() === "") {
        this.setUserLocale(self.templateLang);
        this.enableRefIdApproach = true;
        this.loading = false;
        setTimeout(function () {
          $(".splash").removeClass("hiddden");
          $("#userRegistration").css("display", "block");
        }, 500);
      } else {
        this.getTokenAndRedirect(actToken);
      }
    },
    getTokenAndRedirect: function getTokenAndRedirect(token) {
      var self = this;
      self.loading = true;
      this.setDefaultCountry();
      self.token = token !== null && token !== undefined ? token.trim() : "";
      self.enableRefIdApproach = false;
      self.tokenInvalid = false;
      var data = { recoveryToken: self.token };

      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getUserIdByToken(apiUrl + "/recovery/token", data).then(function (response) {
        self.loading = true;
        $("#userRegistration").css("display", "block");
        var responseObj = response.data;

        self.userId = responseObj._embedded.user.id;

        self.firstName = responseObj._embedded.user.profile.firstName;
        self.lastName = responseObj._embedded.user.profile.lastName;
        self.loginId = responseObj._embedded.user.profile.login ? responseObj._embedded.user.profile.login : responseObj._embedded.user.profile.email;
        self.getBrandName(self.loginId);

        __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getActiveAppNames(apiUrl + "/apps/" + self.userId, self.token).then(function (response) {
          self.userApps = response.data;
          self.loading = false;
          self.regApps = response.data.filter(function (item) {
            if (item.name.toLowerCase() !== "oidc_client" && !item.visibility.hide.web) {
              return item;
            }
          });
        });
        self.loading = true;
        __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getGroupsByUserId(apiUrl + "/users/" + self.userId + "/groups", self.token).then(function (response) {
          self.countryCodeDefaultBasedOnGroups(response.data);
          self.isGroupPhone = self.setGroupBasedPhone(response.data);
          console.log("isGroupPhone" + self.isGroupPhone);
          self.isServiceAccountGroupMember = response.data.filter(function (x) {
            return x.profile.name.toLowerCase().indexOf("service accounts") > -1 || x.profile.name.toLowerCase().indexOf("brazilian portalapp") > -1 || x.profile.name.toLowerCase().indexOf("cargillonlinefeed") > -1 || x.profile.name.toLowerCase().indexOf("cargillonlinefeedusers") > -1 || x.profile.name.toLowerCase().indexOf("crm velo salesforce") > -1;
          }).length > 0;
          __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getUserIdByEmail(apiUrl + "/users/" + self.userId, self.token).then(function (response) {
            self.loading = false;
            self.setUserLocale(response.data.profile.locale);
            var emailDomain = self.loginId.split("@").length > 1 ? self.loginId.split("@")[1] : "";
            if (!self.isServiceAccountGroupMember && internalUserDomains.filter(function (x) {
              return x.toLowerCase().indexOf(emailDomain.toLowerCase()) > -1;
            }).length > 0) {
              self.accountsetup = true;
              self.internalUser = true;
              self.loading = false;
              return;
            }
            if (response.data.credentials.provider.type.toLowerCase() === "federation" && !self.isServiceAccountGroupMember) {
              self.accountsetup = true;
            } else {
              self.getPasswordPolicy();
              self.checkPhoneNumber();
            }
            if (self.isServiceAccountGroupMember) {
              self.getPasswordPolicy();
              self.checkPhoneNumber();
            }
          }).catch(function (err) {
            self.loading = false;
            console.log("create Insert CF Error: ", err);
          });
        }).catch(function (err) {
          self.loading = false;
          console.log("create Insert CF Error: ", err);
        });
      }).catch(function (error) {
        $("#userRegistration").css("display", "block");
        self.setUserLocale(self.templateLang, false);

        self.getBrandName(self.loginId);
        if (error.response.status === 401 || error.response.status === 403) {
          self.loading = false;
          self.tokenInvalid = true;
          self.enableRefIdApproach = false;
        } else {
          if (error.toString().toLowerCase().indexOf("network error") > -1) {
            console.log("Network Error. please check your connection");
          }
          self.loading = false;
          self.tokenInvalid = true;
          self.enableRefIdApproach = false;
          self.isNetworkError = true;
        }
      });
    },
    getBrandBg: function getBrandBg() {
      var self = this;
      console.log(self.brandDetails);
      var brand = self.brandDetails.data.filter(function (n) {
        return n.applicationUrls.indexOf(document.location.host) > -1;
      });
      if (brand.length && brand[0].bgImageLink.trim() !== "") {
        $(".splash").attr("src", brand[0].bgImageLink);
      }
      setTimeout($(".splash").removeClass("hiddden"), 500);
    },
    getBrandName: function getBrandName(email) {
      var self = this;
      var bd = self.brandDetails.data.filter(function (n) {
        return n.applicationUrls.indexOf(document.location.host) > -1;
      })[0];

      self.brand = bd.brandName;
      self.termsArray = bd.terms;
      self.noTransformEmail = bd.noTranform;
      self.brandCode = bd.brandCode;
      self.tclink = bd.termsandconditionslink;
      self.pplink = bd.privacypolicylink;
      var bgimg = bd.bgImageLink.trim();
      if (bgimg !== "") {
        if (bgimg.indexOf("#") !== 0) {
          $(".splash").attr("src", bgimg);
        } else {
          $(".splash").attr("src", "");
          $(".splash").css("background", bgimg);
        }
      }
      setTimeout($(".splash").removeClass("hiddden"), 500);
    },
    validatePhoneNumberCheck: function validatePhoneNumberCheck() {
      if (this.otpSent && this.issuccess || !this.otpSent) {
        return true;
      } else {
        this.errorCode = "phonenumbermissing";
        return false;
      }
    },
    validateSetUser: function validateSetUser() {
      if (this.password.trim() !== "") {
        if (this.password.trim().length) {
          if (this.pwdErrorArray.length === 0) {
            if (this.password.trim() === this.repeatpassword.trim()) {
              if (this.isPhoneNoNotVerified && this.brand.toLowerCase() === "cargill") {
                this.errorCode = "phoneVerificationNotCompleted";
                return false;
              }
              if (this.issuccess || this.availableFactorID !== "" || this.alreadyRegistered) {
                if (this.selectedSecQN === "custom" && this.custom_question.trim() === "") {
                  this.errorCode = "customQuestionEmpty";
                  return false;
                } else {
                  if (this.selectedSecQN === "custom" && this.custom_question.trim() === this.answer.trim()) {
                    this.errorCode = "customQAsame";
                    return false;
                  } else {
                    this.errorCode = "";
                    return true;
                  }
                }
              } else {
                if (this.brand.toLowerCase() === "cargill") {
                  this.errorCode = "";
                  return true;
                } else {
                  this.errorCode = "phonenumbermissing";
                  return false;
                }
              }
            } else {
              this.errorCode = "passwordnotmatching";
              return false;
            }
          } else {
            this.errorCode = "passwordnotvalid";
            return false;
          }
        } else {
          this.errorCode = "passwordlength";
          return false;
        }
      } else {
        this.errorCode = "emptypassword";
        return false;
      }
    },
    isPhoneMandatory: function isPhoneMandatory() {
      var appsToMandatePhone = APPS_MANDATE_PHONE.map(function (x) {
        return x.toLowerCase();
      });
      return !this.userApps.some(function (i) {
        return appsToMandatePhone.indexOf(i.id.toLowerCase()) > -1;
      });
    },
    sendCodeNotActive: function sendCodeNotActive(response) {
      var self = this;
      self.alreadyRegistered = false;
      self.codeSent = true;
      self.verifycode = "";
      self.factorId = response.data.id;
    },
    cancelVerification: function cancelVerification() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].deleteSMSFactor(apiUrl + "/users/" + self.userId + "/factors/" + self.factorId, self.token).then(function (response) {
        self.loading = false;
        self.otpSent = false;
        self.codeSent = false;
        self.errorCode = "";
        self.phN = "";
        self.countryCode = "1";
        console.log(response);
      }).catch(function (error) {
        self.loading = false;
        console.log(error.response.status + " " + error.response.data);
      });
    },
    sendCode: function sendCode() {
      var self = this;
      self.error30SecOTP = false;
      self.phoneNumberNotValid = false;
      self.phoneNoAlreadySet = false;
      self.iserror = false;
      self.genericErrorMsg = false;
      var data = {
        factorType: "sms",
        provider: "OKTA",
        profile: {
          phoneNumber: "+" + this.countryCode.replace(/^0+/, "") + this.phN.replace(/\D/g, "")
        }
      };
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].sendCode(apiUrl + "/users/" + self.userId + "/factors?updatePhone=true", data, self.token).then(function (response) {
        self.isPhoneNoNotVerified = false;
        self.loading = false;
        if (response.data.status.toLowerCase() === "active") {
          self.alreadyRegistered = true;
          self.iserror = false;

          self.factorId = response.data.id;
          self.errorCode = false;
        } else {
          self.otpSent = true;
          self.sendCodeNotActive(response);
        }
      }).catch(function (error) {
        self.loading = false;
        var obj = {};
        obj.response = error.response.data;
        obj.url = error.response.config.url;
        obj.status = error.response.status;
        self.sendMessageToDatadog("Send SMS Code", {});
        self.sendMessageToDatadog("Error Response: ", obj);
        self.sendCodeErrorHandler(error);
      });
    },
    sendCodeErrorHandler: function sendCodeErrorHandler(error) {
      console.log(error);
      var self = this;
      if (error.response.status === 429) {
        self.error30SecOTP = true;
        self.alreadyRegistered = false;
      } else if (error.response.status === 400) {
        self.handle400Error(error);
      } else {
        self.genericErrorMsg = true;
      }
    },
    handle400Error: function handle400Error(error) {
      var self = this;

      if (error.response.data.errorSummary && error.response.data.errorSummary.indexOf("invalid") > -1 || error.response.data.errorCauses.length > 0 && error.response.data.errorCauses[0].errorSummary.toLowerCase().indexOf("invalid") > -1) {
        self.phoneNumberNotValid = true;
        self.loading = false;
        return;
      }
      if (error.response.data.errorSummary && error.response.data.errorSummary.toLowerCase().indexOf("factor service error") > -1) {
        self.phoneNumberNotValid = true;
        self.loading = false;
        return;
      }
      if (error.response.data.errorCauses.length > 0 && error.response.data.errorCauses[0].errorSummary.toLowerCase().indexOf("already set up") > -1) {
        self.alreadyRegistered = false;
        self.loading = true;
        __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getFactorByUserId(apiUrl + "/users/" + self.userId + "/factors", self.token).then(function (response) {
          self.loading = false;
          console.log(response.data);
          var factor = response.data.filter(function (x) {
            return x.factorType === "sms";
          })[0];
          if (!factor) {
            self.genericErrorMsg = true;
            return;
          }
          self.factorIdToDelete = factor.id;
          self.loading = true;
          __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].deleteSMSFactor(apiUrl + "/users/" + self.userId + "/factors/" + self.factorIdToDelete, self.token).then(function (response) {
            self.loading = false;
            self.sendCode();
          }).catch(function (error) {
            self.loading = false;
            self.genericErrorMsg = true;
            console.log(error);
          });
        }).catch(function (error) {
          self.loading = false;
          self.genericErrorMsg = true;
          console.log(error);
        });
        return;
      }
      self.genericErrorMsg = true;
    },
    goBack: function goBack() {
      this.codeSent = false;
    },
    verifySMS: function verifySMS() {
      var self = this;
      self.verifyClicked = true;
      if (self.verifycode.length === 0) {
        self.iserror = true;
        self.verifyCodeError = self.user_lang["passcodeNotEntered"];
        self.verifyClicked = false;
        return;
      }
      var data = { passCode: self.verifycode };
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].verifyPasscodeOnFactorSetting(apiUrl + "/users/" + self.userId + "/factors/" + self.factorId + "/activate", data, self.token).then(function (response) {
        self.activateFactorId = response.data.id;
        self.loading = false;
        self.verifyClicked = false;
        if (response.data.status === "ACTIVE") {
          self.iserror = false;
          self.issuccess = true;
          self.errorCode = false;
          self.availableFactorID = response.data.id;
        } else {
          self.iserror = true;

          self.verifyCodeError = self.user_lang["passcodeNotValid"];
          self.sendMessageToDatadog("Verify SMS Code", {});
          self.sendMessageToDatadog("Success Response but not Active: ", response);
        }
      }).catch(function (error) {
        console.log(error);
        self.sendMessageToDatadog("Verify SMS Code", {});
        self.sendMessageToDatadog("Error Response: ", error);
        self.loading = false;
        self.verifyClicked = false;
        self.iserror = true;
        if (error.response.status === 403) {
          self.verifyCodeError = self.user_lang["passcodeNotValid"];
        } else if (error.response.status === 429) {
          self.verifyCodeError = self.user_lang["passcodeRateLimit"];
        } else {
          self.verifyCodeError = self.user_lang["msgForUnhandledResponse"];
        }
      });
    },
    sendMessageToDatadog: function sendMessageToDatadog(message, data) {
      var url = apiUrl + "/dataDogMessage?message=" + message;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].sendMessageToDatadog(url, data).then(function (response) {
        console.log(response);
      }).catch(function (error) {
        console.log(error);
      });
    },
    checkPhoneNumber: function checkPhoneNumber() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].getFactorByUserId(apiUrl + "/users/" + self.userId + "/factors", self.token).then(function (response) {
        self.loading = false;
        self.allAvailableFactors = response.data;
        if (response.data.length > 0) {
          self.availableFactorID = self.allAvailableFactors.filter(function (x) {
            return x.factorType === "sms" && x.status.toLowerCase() === "active";
          })[0];
        } else {
          self.availableFactorID = "";
        }
      });
    },
    setGroupBasedPhone: function setGroupBasedPhone(groups) {
      var phoneGroups = [];
      groups.forEach(function (group) {
        if (__WEBPACK_IMPORTED_MODULE_10__helpers_group_phone__["default"].getGroupPh(group.profile.name)) {
          phoneGroups.push(group);
        }
        console.log("groupPhName Groups: ", phoneGroups);
      });
      if (phoneGroups.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    setLangCookie: function setLangCookie(lang) {
      var landCode = lang.split("_");
      document.cookie = "lang=" + landCode[0];
    },
    setUserLocale: function setUserLocale(val, istokenvalid) {
      var self = this;

      self.loading = false;
      var profileLang = val;
      var checkLang = "";
      var emitTemplate = "en_US";
      if (profileLang !== undefined) {
        if (profileLang !== null && profileLang.trim() !== "") {
          profileLang = __WEBPACK_IMPORTED_MODULE_4__helpers_common__["default"].getLanguage(profileLang);
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__i18n_locale_js__["locale"].lang_obj).forEach(function (i) {
            checkLang = __WEBPACK_IMPORTED_MODULE_4__helpers_common__["default"].getLanguage(i);
            if (checkLang === profileLang) {
              __WEBPACK_IMPORTED_MODULE_7__i18n_locale_js__["locale"].lang = i;
              emitTemplate = i;
            }
          });
          __WEBPACK_IMPORTED_MODULE_8__event_bus_js__["EventBus"].$emit("lang", emitTemplate);
          __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].set("user-lang", emitTemplate);
          this.setLangCookie(emitTemplate);
        } else {
          __WEBPACK_IMPORTED_MODULE_7__i18n_locale_js__["locale"].lang = "en_US";
          __WEBPACK_IMPORTED_MODULE_8__event_bus_js__["EventBus"].$emit("lang", "en_US");
          __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].set("user-lang", "en_US");
          this.setLangCookie("en_US");
        }
        if (istokenvalid !== false) {}
      } else {
        __WEBPACK_IMPORTED_MODULE_7__i18n_locale_js__["locale"].lang = "en_US";
        __WEBPACK_IMPORTED_MODULE_2__helpers_storage__["default"].set("user-lang", "en_US");
        this.setLangCookie("en_US");
        __WEBPACK_IMPORTED_MODULE_8__event_bus_js__["EventBus"].$emit("lang", "en_US");
        if (istokenvalid !== false) {}
      }
    },

    changeUserLang: function changeUserLang(e) {
      __WEBPACK_IMPORTED_MODULE_7__i18n_locale_js__["locale"].lang = e.target.value;
      this.user_lang = this.lang_obj[e.target.value];
      __WEBPACK_IMPORTED_MODULE_8__event_bus_js__["EventBus"].$emit("lang", e.target.value);
    },
    onVerify: function onVerify(resp) {
      var self = this;
      console.log(resp);
      self.captchaResponse = resp;
      var response = window.grecaptcha.getResponse();
      if (response.length !== 0) {
        self.captchaVerified = true;
      }
    },
    onExpired: function onExpired(resp) {
      var self = this;
      console.log(resp);
      self.captchaVerified = false;
    },
    onRender: function onRender(id) {
      setTimeout(function () {
        console.log(id);
        window.grecaptcha.reset();
      }, 1000);
    },

    validEmail: function validEmail(email) {
      var re = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(email);
    },
    validateAndResendInvite: function validateAndResendInvite() {
      var self = this;
      self.userValidations = "";
      if (this.userEmail.trim() === "") {
        self.userValidations = self.user_lang["emailreq"];
      } else if (!this.validEmail(this.userEmail.trim())) {
        self.userValidations = self.user_lang["emailinvalid"];
      } else if (self.userLastName.trim() === "") {
        self.userValidations = self.user_lang["lastnamereq"];
      } else if (!self.captchaVerified) {
        self.userValidations = "Please verify captcha";
      } else {
        var data = {};
        if (self.noTransformEmail !== true) {
          self.userEmail = ("0" + (self.userEmail.indexOf("@") + 1)).slice(-2) + self.brandCode + self.userEmail.split("@").join("") + "@partneridentity.okta-emea.com";
        }
        var url = apiUrl + "/reInvite?userId=" + self.userEmail + "&lastName=" + self.userLastName;
        if (self.isSRCdxp !== null && self.isSRCdxp.trim() !== "" && self.templateLang !== null && self.templateLang.trim() !== "") {
          url = url + ("&src=" + self.isSRCdxp + "&lang=" + self.templateLang);
        }
        __WEBPACK_IMPORTED_MODULE_3__idm_api__["default"].validateUserDetails("" + url, data, self.token).then(function (response) {
          console.log(response);
          self.inviteSuccess = true;
        }).catch(function (error) {
          console.log(error.response);
          self.inviteSuccess = true;
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\nth{\nbackground: var(--theme-secondary) !important;\n    color: white !important;\n    font-weight: normal !important;\n    font-size: 12px !important;\n    padding: 20px 15px !important;\n}\ntr:nth-of-type(odd) {\n    /* background-color: rgba(0, 0, 0, 0.05); */\n}\nth, td{border: 0px !important;font-size: 12px !important;\n    padding: 20px 15px !important;\n}\ntr{border-bottom: 8px solid #eceff1;\n}\nth{cursor: pointer !important\n}\nthead tr:nth-of-type(even) th{\n    background-color: initial !important;\n}\n#searchId {\n    width: 130px !important;\n    box-sizing: border-box !important;\n    border: 1px solid var(--theme-primary) !important;\n    border-radius: 0 !important;\n    font-size: 16px !important;\n    background-color: #f1f1f1 !important;\n    background-position: 10px 10px !important;\n    background-repeat: no-repeat !important;\n    height: 50px !important;\n\tmargin-bottom: 18px !important;\n}\n.btn-secondary {\n    background-color: var(--theme-primary);;\n    border-color: #00433c;\n}\n.btn-secondary:hover {\n    background-color: #00524A;\n    border-color: #00433c;\n}\n.btn {\n    padding: 14px 24px;\n    border: 0 none;\n    font-weight: 700;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n}\n.responsive {\n    width: 100%;\n    overflow-x: auto !important;\n}\n.deleteicon{\ncolor: #2b2b2b !important;\n    font-size: 18px;\n    text-decoration: none !important;\n}\n.table.table-bordered td, .table-bordered th{padding : 15px 15px !important\n}\n.table-bordered{margin-top: 5px;\n}\n.table-footer{padding-bottom:5px !important; background-color: rgb(236, 239, 241) !important;\n    border: 0px !important;margin-bottom:5px !important\n}\n.page-btn span {margin-top:-4px !important;\n}\n.table.table-bordered th:nth-child(5), .table.table-bordered th:nth-child(6), .table.table-bordered th:nth-child(7){pointer-events:none\n}\n@media all and (-ms-high-contrast:none)\n{\n.input-adduser {\n  height: auto !important;\n}\n*::-ms-backdrop, #searchId { padding: 0px 10px !important\n} /* IE11 */\n}\n.disabled{pointer-events:none;opacity:0.6;\n}\n.outOfView{position:fixed;left: 50%;\n    top: 15px;\n    background: rgba(101, 141, 27, 0.89) !important;\n    padding: 10px 10px;\n    border-radius: 8px;color: #fff;\n}\n.v-hidden{opacity:0;\n}\ntd:first-child span {\n    max-width: 100px !important;\n    display: block;\n}\ntd:nth-child(2) span {\n    max-width: 100px !important;\n    display: block;\n}\n.no-data {\n  text-align: center;\n  color: #808080;\n}\n.no-group {\n  background: #546e7a;\n  color: #fff;\n  padding: 10px;\n  margin: 15px 0px 0px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 700;\n}\n", ""]);

// exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\nbody {\n   /* padding-top:64px; */\n}\n.modal-content {\n    -webkit-border-radius: 0;\n    -webkit-background-clip: padding-box;\n    -moz-border-radius: 0;\n    -moz-background-clip: padding;\n    border-radius: 6px;\n    background-clip: padding-box;\n    box-shadow: 0 0 40px rgba(0,0,0,.5);\n    color: #000;\n    background-color: #fff;\n    border: rgba(0,0,0,0);\n}\n.modal-message .modal-body, .modal-message .modal-footer, .modal-message .modal-header, .modal-message .modal-title {\n    background: 0 0;\n    border: none;\n    margin: 0;\n    padding: 0 20px;\n    text-align: center!important;\n}\n.modal-message .modal-title {\n    font-size: 1.5rem;\n    color: #737373;\n    margin-bottom: 3px;\n}\n.modal-message .modal-body {\n    color: #737373;\n    padding-top: 20px;\n}\n.modal-message .modal-header {\n    color: #fff;\n    margin-bottom: 10px;\n    padding: 15px;\n}\n.modal-message .modal-header .fa,\n.modal-message .modal-header\n.glyphicon, .modal-message\n.modal-header .typcn, .modal-message .modal-header .wi {\n    font-size: 3rem;\n}\n.modal-message .modal-footer {\n    margin: 25px 0 20px;\n    padding-bottom: 10px;\n}\n.modal-message.modal-warning .modal-header {\n    color: #f4b400;\n    border-bottom: 3px solid #ffce55;\n}\n", ""]);

// exports


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\n.admintobrand[data-v-04fb9444] {\n  font-weight: bold;\n  font-size: 20px;\n  text-transform: capitalize;\n  background: #eee;\n  padding-left: 10px;\n  display: block;\n}\nul[data-v-04fb9444] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-04fb9444] {\n  display: inline-block;\n  margin: 0 10px;\n  padding: 0;\n}\n.custom-select[data-v-04fb9444] {\n  display: inline-block;\n  max-width: 100%;\n  height: calc(2.5rem + 2px);\n  padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n  line-height: 1.25;\n  background-color: #ececeb;\n  vertical-align: middle;\n  background-size: 8px 10px;\n  border: 1px solid #00524a;\n  border-radius: 0;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\n.card-block[data-v-04fb9444] {\n  background: #eceff1;\n}\n.user-input[data-v-04fb9444] {\n  width: 100%;\n  background: #ffffff;\n  color: #333333;\n  height: 30px;\n}\n.user-select[data-v-04fb9444] {\n  color: #333333;\n  height: 30px;\n}\n#userSearch[data-v-04fb9444] {\n  margin: 10px;\n}\n.good-table th[data-v-04fb9444] {\n  color: #333333 !important;\n}\n.btn-secondary[data-v-04fb9444]:active {\n  background: #007299;\n  box-shadow: none;\n}\n.btn-secondary[data-v-04fb9444] {\n  background: var(--theme-primary);\n  color: #ffffff;\n}\ninput[data-v-04fb9444] {\n  width: 130px;\n  box-sizing: border-box;\n  border: 1px solid var(--theme-primary);\n  border-radius: 0;\n  font-size: 16px;\n  background-color: #f1f1f1;\n  background-position: 10px 10px;\n  background-repeat: no-repeat;\n  padding: 15px 20px;\n  height: 50px;\n}\n.card[data-v-04fb9444] {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  background-color: #33373d;\n  border: 0px solid rgba(0, 0, 0, 0.125);\n  border-radius: 0px;\n  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);\n  box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.4);\n}\n.card[data-v-04fb9444] {\n  margin-bottom: 1rem;\n  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);\n}\n.card-block1[data-v-04fb9444] {\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  padding: 0rem;\n}\n#searchId[data-v-04fb9444] {\n  box-sizing: border-box !important;\n  border: 2px solid #dde3e6 !important;\n  border-radius: 0 !important;\n  background-color: #fff !important;\n  background-position: 10px 10px !important;\n  background-repeat: no-repeat !important;\n  height: 40px !important;\n  margin-bottom: 18px !important;\n  margin-left: 30px !important;\n}\n.filter-label[data-v-04fb9444] {\n  width: 150px;\n  float: left;\n  font-size: 14px;\n  margin-top: 8px;\n  font-weight: bold;\n}\n.btn-secondary[data-v-04fb9444] {\n  background-color: var(--theme-primary);\n  border-color: #00433c;\n}\n.btn-secondary[data-v-04fb9444]:hover {\n  background-color: #00524a;\n  border-color: #00433c;\n}\n.btn[data-v-04fb9444] {\n  padding: 14px 24px;\n  border: 0 none;\n  font-weight: 700;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n/* Pills styles */\n.nav-pills .nav-link.active[data-v-04fb9444],\n.nav-pills .nav-item.show .nav-link[data-v-04fb9444] {\n  padding: 15px 30px;\n  border-top: 1px solid #cececb;\n  border-right: 1px solid #cececb;\n  border-left: 1px solid #cececb;\n  border-bottom: 1px solid #fff;\n  background-color: #fff;\n  color: var(--theme-primary);\n  width: 15rem;\n}\n.nav-pills .nav-link[data-v-04fb9444] {\n  padding: 15px 30px;\n  border-top: 1px solid var(--theme-primary);\n  border-right: 1px solid var(--theme-primary);\n  border-left: 1px solid var(--theme-primary);\n  border-bottom: 1px solid var(--theme-primary);\n  border-radius: 0rem;\n  background-color: var(--theme-primary);\n  color: #fff;\n  width: 15rem;\n}\n.nav-pills .nav-link[data-v-04fb9444]:hover {\n  padding: 15px 30px;\n  border-top: 1px solid #00524a;\n  border-right: 1px solid #00524a;\n  border-left: 1px solid #00524a;\n  border-bottom: 1px solid var(--theme-primary);\n  background-color: #00524a;\n  color: #fff;\n}\n.nav-pills .nav-link.active[data-v-04fb9444]:hover {\n  padding: 15px 30px;\n  border-top: 1px solid #cececb;\n  border-right: 1px solid #cececb;\n  border-left: 1px solid #cececb;\n  border-bottom: 1px solid #fff;\n  background-color: #fff;\n  color: var(--theme-primary);\n}\n.nav-tabs .nav-link[data-v-04fb9444]:focus,\n.nav-tabs .nav-link[data-v-04fb9444]:hover {\n  border-top: 1px solid #cececb;\n  border-right: 1px solid #cececb;\n  border-left: 1px solid #cececb;\n  background-color: #00524a;\n  color: #fff;\n}\n.nav-tabs .nav-link[data-v-04fb9444] {\n  border-top: 1px solid #cececb;\n  border-right: 1px solid #cececb;\n  border-left: 1px solid #cececb;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n.nav-link[data-v-04fb9444]:focus,\n.nav-link[data-v-04fb9444]:hover {\n  text-decoration: none;\n}\n/* Extra small devices (portrait phones, less than 576px) */\n@media (max-width: 575px) {\n.nav-pills[data-v-04fb9444],\n  .nav-link[data-v-04fb9444] {\n    width: 100%;\n}\n.nav-item[data-v-04fb9444] {\n    margin: 5px 0 0 0;\n}\n.nav-pills .nav-link.active[data-v-04fb9444],\n  .nav-pills .nav-item.show .nav-link[data-v-04fb9444] {\n    padding: 15px 30px;\n    border-top: 1px solid #cececb;\n    border-right: 1px solid #cececb;\n    border-left: 1px solid #cececb;\n    border-bottom: 1px solid #cececb;\n    margin: 2px 0;\n    background-color: #fff;\n    color: var(--theme-primary);\n    width: 100%;\n}\n.nav-pills .nav-link[data-v-04fb9444] {\n    padding: 15px 30px;\n    border-top: 1px solid var(--theme-primary);\n    border-right: 1px solid var(--theme-primary);\n    border-left: 1px solid var(--theme-primary);\n    border-bottom: 1px solid var(--theme-primary);\n    margin: 2px 0;\n    border-radius: 0rem;\n    background-color: var(--theme-primary);\n    color: #fff;\n    width: 100%;\n}\n.barchart[data-v-04fb9444] {\n    display: none;\n}\n}\n/* Small devices (landscape phones, 576px and up) */\n@media (min-width: 576px) and (max-width: 767px) {\n.nav-pills[data-v-04fb9444],\n  .nav-link[data-v-04fb9444] {\n    width: 100%;\n}\n.nav-item[data-v-04fb9444] {\n    margin: 0 0 0 1px;\n}\n.nav-link[data-v-04fb9444] {\n    margin: 0;\n}\n.nav-pills .nav-link.active[data-v-04fb9444],\n  .nav-pills .nav-item.show .nav-link[data-v-04fb9444] {\n    padding: 15px 30px;\n    border-top: 1px solid #cececb;\n    border-right: 1px solid #cececb;\n    border-left: 1px solid #cececb;\n    border-bottom: 1px solid #cececb;\n    margin: 2px 0;\n    background-color: #fff;\n    color: var(--theme-primary);\n    width: 100%;\n}\n.nav-pills .nav-link[data-v-04fb9444] {\n    padding: 15px 30px;\n    border-top: 1px solid var(--theme-primary);\n    border-right: 1px solid var(--theme-primary);\n    border-left: 1px solid var(--theme-primary);\n    border-bottom: 1px solid var(--theme-primary);\n    margin: 2px 0;\n    border-radius: 0rem;\n    background-color: var(--theme-primary);\n    color: #fff;\n    width: 100%;\n}\n.barchart[data-v-04fb9444] {\n    display: none;\n}\n}\n.input-adduser[data-v-04fb9444] {\n  height: initial;\n  padding: 5px 15px;\n  width: 100%;\n  background: #fff;\n  margin: 0px !important;\n}\n.input-checkbx[data-v-04fb9444],\n.gsearch[data-v-04fb9444] {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n}\n.preflang[data-v-04fb9444] {\n  width: 100%;\n  min-height: 34px;\n}\n.success-bg[data-v-04fb9444] {\n  background: #90ee90;\n}\n.error-bg[data-v-04fb9444] {\n  background: #ffc0cb;\n}\n.form-control-label[data-v-04fb9444] {\n  min-width: 120px;\n  font-size: 12px;\n}\n.wrap-input[data-v-04fb9444] {\n  display: block;\n  overflow: hidden;\n}\n.form-wrap[data-v-04fb9444] {\n  margin-bottom: 3px;\n}\n.create-btn[data-v-04fb9444] {\n  margin-top: 10px;\n  height: 40px;\n  line-height: 0px;\n  font-size: 12px;\n  float: right;\n}\n.search-icon[data-v-04fb9444] {\n  margin-top: 10px;\n  margin-top: 0px;\n  height: 40px !important;\n  line-height: 0px;\n  padding: 12px 24px 14px 24px;\n  margin-bottom: 10px;\n  border-radius: 0px;\n}\n.tableContainer[data-v-04fb9444] {\n  padding: 0px 15px 30px;\n  overflow-x: auto;\n}\n.input-group[data-v-04fb9444] {\n  width: 100%;\n  background: #fff;\n  margin: 0px -15px 0p;\n  padding: 5px;\n  outline: 15px solid #fff;\n  /* margin: 0px -15px; */\n}\n.input-group-btn[data-v-04fb9444] {\n  max-width: 65px;\n}\n.sub-group[data-v-04fb9444] {\n  display: inline-block;\n}\n@media (max-width: 1050px) {\n.input-group[data-v-04fb9444] {\n    width: 100% !important;\n    display: block;\n}\n}\n@media (max-width: 768px) {\n.sub-group[data-v-04fb9444] {\n    width: 100% !important;\n    display: block;\n}\n.searchId[data-v-04fb9444] {\n    max-width: 230px;\n}\n.filter-text[data-v-04fb9444] {\n    margin-left: 0px !important;\n}\n.adduser-btn[data-v-04fb9444] {\n    margin-left: 0px !important;\n}\n}\n.dropdown div[data-v-04fb9444],\n.dropdown dt[data-v-04fb9444] {\n  margin: 0px;\n  padding: 0px;\n}\n.dropdown ul[data-v-04fb9444] {\n  margin: 0px;\n  padding: 0px;\n}\n.dropdown div[data-v-04fb9444] {\n  position: relative;\n  margin: 0px;\n  padding: 0px;\n}\n.dropdown a[data-v-04fb9444],\n.dropdown a[data-v-04fb9444]:visited {\n  color: #fff;\n  text-decoration: none;\n  outline: none;\n  margin: 0px;\n  padding: 0px;\n  min-height: 30px;\n  border-radius: 3px;\n}\n.dropdown div a[data-v-04fb9444] {\n  background-color: #4f6877;\n  display: block;\n  overflow: hidden;\n  width: 100%;\n  margin: 0px;\n  padding: 0px;\n}\n.dropdown div a span[data-v-04fb9444],\n.multiSel span[data-v-04fb9444] {\n  cursor: pointer;\n  display: inline-block;\n  margin: 0px;\n  padding: 5px 10px;\n}\n.dropdown div ul[data-v-04fb9444] {\n  background-color: #4f6877;\n  top: 1px;\n  color: #fff;\n  display: none;\n  position: absolute;\n  width: 100%;\n  list-style: none;\n  height: 100px;\n  overflow: auto;\n  margin: 0px;\n  padding: 0px;\n}\n.dropdown span.value[data-v-04fb9444] {\n  display: none;\n  border-radius: 3px;\n  margin: 0px;\n  padding: 0px;\n}\n.dropdown div ul li a[data-v-04fb9444] {\n  display: block;\n  margin: 0px;\n  padding: 0px;\n}\n.dropdown div ul li a[data-v-04fb9444]:hover {\n  background-color: #fff;\n  margin: 0px;\n  padding: 0px;\n}\n.selectDropDown[data-v-04fb9444] {\n  border: 2px solid #dde3e6;\n  height: 34px;\n  /* border-radius: 3px; */\n  cursor: pointer;\n  background: #fff;\n  width: 100%;\n}\n#checkboxlist[data-v-04fb9444] {\n  position: relative;\n  margin-top: 0px;\n  background: #fff;\n  border: 1px solid #ccc;\n  min-width: 200px;\n}\n.dd-list-item[data-v-04fb9444]:hover {\n  background: #fff;\n}\nbutton[data-v-04fb9444] {\n  background: var(--theme-primary) !important;\n}\n.adduser-btn[data-v-04fb9444] {\n  margin-left: 20px;\n  max-height: 40px;\n  margin-top: 0px;\n  line-height: 0px;\n  height: 40px;\n  background-color: var(--theme-primary);\n  font-size: 12px;\n}\ninput[data-v-04fb9444],\nselect[data-v-04fb9444] {\n  background: #fff !important;\n  border: 2px solid #dde3e6 !important;\n  padding: 9px !important;\n  font-size: 14px !important;\n}\n.bc[data-v-04fb9444] {\n  font-size: 10px;\n  font-weight: bold;\n}\n.bc-adduser[data-v-04fb9444] {\n  font-size: 10px;\n  font-weight: bold;\n  margin: 15px;\n}\n.bc-nav[data-v-04fb9444]:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.user-creds[data-v-04fb9444] {\n  background: #fff;\n  padding: 7px 15px 15px;\n  margin-bottom: 12px;\n}\n.bb0[data-v-04fb9444] {\n  border-bottom: 0px !important;\n}\n.add-group[data-v-04fb9444] {\n  color: var(--theme-primary);\n  font-size: 18px;\n  float: right;\n  margin-top: 5px;\n  cursor: pointer;\n}\n.remove-group[data-v-04fb9444] {\n  color: #d80842;\n  font-size: 18px;\n  float: right;\n  margin-top: 5px;\n  cursor: pointer;\n}\n.group-div[data-v-04fb9444] {\n  border: 2px solid #eceff1;\n  padding: 3px 10px;\n}\n.group-name[data-v-04fb9444] {\n  display: inline-block;\n  width: 90%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.usercreateinfo[data-v-04fb9444] {\n  margin-top: 10px;\n  background: #546e7a;\n  color: #fff;\n  padding: 10px;\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n@media screen and (max-width: 767px) {\n.main-content[data-v-04fb9444] {\n    padding-top: 25px;\n}\n.main-content[data-v-04fb9444] {\n    padding-left: 0px;\n}\n}\n@media screen and (min-width: 768px) {\n.main-content[data-v-04fb9444] {\n    padding-top: 0px;\n}\n.main-content[data-v-04fb9444] {\n    padding-left: 200px;\n}\n}\n@media screen and (min-width: 991px) {\n.search-bar-wrapper[data-v-04fb9444] {\n    width: 100%;\n}\n.search-bar-select[data-v-04fb9444] {\n}\n}\n@media screen and (max-width: 991px) {\n.search-bar-wrapper[data-v-04fb9444] {\n}\n.search-bar-select[data-v-04fb9444] {\n}\n}\n.cancel-btn[data-v-04fb9444] {\n  float: right;\n  cursor: pointer;\n  display: block;\n  padding: 18px 30px;\n}\n.disabled[data-v-04fb9444] {\n  pointer-events: none;\n  opacity: 0.6;\n}\n.searchinfotext[data-v-04fb9444] {\n  position: absolute;\n  top: 68px;\n  font-size: 12px;\n  z-index: 999;\n  color: #8c8c8c;\n}\n@media all and (-ms-high-contrast: none) {\n.input-adduser[data-v-04fb9444] {\n    height: auto !important;\n}\n}\n.report-link[data-v-04fb9444] {\n  font-weight: bold;\n  float: right;\n  text-decoration: underline;\n  font-size: 16px;\n  color: #658d1b;\n  cursor: pointer;\n}\nbutton.close[data-v-04fb9444] {\n  background: transparent !important;\n}\n.dxpNewmodal input[type=\"radio\"][data-v-04fb9444] {\n  width: 13px !important;\n  height: 13px !important;\n}\n.row.date-field-edit[data-v-04fb9444] {\n  padding: 0px 20px;\n}\n.date-value-edit[data-v-04fb9444] {\n  font-size: 14px;\n}\n.separator[data-v-04fb9444] {\n  line-height: 18px;\n  padding-right: 5px;\n}\n.date-info[data-v-04fb9444] {\n  padding: 0px 5px 0px 2px;\n  font-size: 12px;\n}\n.mfa-list[data-v-04fb9444] {\n  padding: 0px 10px;\n}\n.validation-mfa[data-v-04fb9444] {\n  padding: 0px 10px 10px;\n  font-size: 14px;\n  color: #ff0000;\n}\n.mfa-btn[data-v-04fb9444] {\n  font-size: 12px;\n  height: 35px;\n  margin: 5px 10px;\n  line-height: 0;\n  padding: 10px 15px;\n}\n.checkboxgroup[data-v-04fb9444] {\n  display: -ms-flexbox;\n  display: flex;\n  text-align: center;\n}\n.checkboxgroup label[data-v-04fb9444] {\n  display: inline-block;\n}\n.bulk-list[data-v-04fb9444] {\n  padding: 5px 10px;\n}\n.bulk-list[data-v-04fb9444]:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.bulk-upload-header[data-v-04fb9444] {\n  background-color: #658d1be3;\n  color: #ffffff;\n}\n.bulk-upload-warning[data-v-04fb9444] {\n  color: #ffa900;\n  padding-right: 10px;\n}\n.dropdown-style[data-v-04fb9444] {\n  max-height: 40px;\n  padding: 9px;\n  margin-top: 0px;\n  width: 100%;\n  height: 40px;\n}\n.no-group-error[data-v-04fb9444] {\n  background: #546e7a;\n  color: #fff;\n  padding: 10px;\n  margin-bottom: 12px;\n  font-size: 14px;\n  font-weight: 700;\n}\n", ""]);

// exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\nhtml[data-v-0fd90017], body[data-v-0fd90017] {\n  background-color: #FFF;\n  margin: 0px;\n  height: auto;\n}\n#login-background[data-v-0fd90017] {\n  background-color: #FFF;\n  padding: 0;\n  margin:0;\n  /*background: url(https://www.cargill.com/image/1432079677619/hero-ag-market-landing.jpg) no-repeat !important;*/\n}\n.login-form[data-v-0fd90017], .forgotPasswordSection[data-v-0fd90017]{max-width: 400px;    margin: auto;\n}\n.form-control[data-v-0fd90017]{margin: 10px 0px;\n}\n.non-anchor-link[data-v-0fd90017]{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display: inline-block;margin-top: 3px;\n}\n.fade-enter-active[data-v-0fd90017], .fade-leave-active[data-v-0fd90017] {\n  transition: opacity 0.15s;\n}\n.fade-enter[data-v-0fd90017], .fade-leave-to[data-v-0fd90017] {\n  opacity: 0;\n}\n.logo[data-v-0fd90017]{margin:20px;text-align: center;\n}\n.logo img[data-v-0fd90017] {max-width: 120px;\n\t    width: 120px;\n}\n.instruction[data-v-0fd90017] {font-size:13px;\n}\nbutton[data-v-0fd90017] {text-transform: none !important;\n}\nbutton[data-v-0fd90017]:focus {color: #ffffff !important;\n}\nbody[data-v-0fd90017]{background: #FFF; /* url(https://www.cargill.com/image/1432079677619/hero-ag-market-landing.jpg) no-repeat */\n    background-size: cover;\n}\n#app[data-v-0fd90017], #login-background[data-v-0fd90017], html[data-v-0fd90017]{background:transparent\n}\n.custom-login[data-v-0fd90017]{padding:20px;max-width: 440px;\n    margin: auto;\n    background: #ffffff97;border-radius: 2px;\n}\n.mailsent[data-v-0fd90017], .entersmssent[data-v-0fd90017]{text-align: center;\n    font-weight: bold;\n}\n.emailsenttext[data-v-0fd90017]{font-size: 14px;\n    margin-bottom: 30px;text-align: center;\n}\n.btn[data-v-0fd90017]{cursor:pointer\n}\n.resend-code[data-v-0fd90017]{cursor: pointer\n}\n.resend-code[data-v-0fd90017]:focus{color:#464a4c !important\n}\n.disabled[data-v-0fd90017] {pointer-events:none;opacity:0.5\n}\n.alternateReset[data-v-0fd90017] {font-size: 14px;text-decoration:none;text-align: center; cursor:pointer;margin-bottom:15px;\n}\n#login-background[data-v-0fd90017]{\n    width: calc(100vw);\n    box-sizing: border-box;\n    height: calc(100vh);\n    background-size: cover !important;\n    /* margin-top: -64px; */\n    padding-top: 60px;\n}\n.alternateReset[data-v-0fd90017]:hover {text-decoration:underline;\n}\n.errorList[data-v-0fd90017]{color:#d00000; background: #ffc6d195;\n    padding: 5px;\n}\n.opaqueSpinner[data-v-0fd90017] {background: white !important;\n}\n.pwderror[data-v-0fd90017]{display: block;\n    background: #c5c5c5;\n    padding-left: 10px;\n    color: #ffffff;\n    border-bottom: 1px solid #eaeaea;\n    max-width: 400px;\n}\n.splash[data-v-0fd90017]{\nposition: absolute;\n    top: 0px;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n\t-o-object-fit: cover;\n\t   object-fit: cover;\n}\n.clogindiv[data-v-0fd90017]{\n     max-width: 500px;\n\t width: initial !important;\n    background-color: #fff !important;\n    margin: auto;\n    padding: 20px 30px;\n    z-index: 999999999;\n    margin-top: -7px;\n    border-radius: 0;\n}\n#cargillLogin[data-v-0fd90017]{\n    white-space: normal;\n    background-color: var(--theme-primary);\n    font-weight: normal;\n    width: 100%;\n    border-radius: 1px;\n    font-size: 13px;\n    box-shadow: rgba(0, 0, 0, 0.15) 0 1px 0, rgba(255, 255, 255, 0.1) 0 1px 0 0 inset;\n\tcursor:pointer;\n}\n.error-title[data-v-0fd90017] {\n  display: inline-block;\n  color: #000000;\n  float: left;\n  padding: 8px;\n  font-size: 16px;\n  font-weight: 600;\n}\n.bad-request-title[data-v-0fd90017] {\n  color: #000000;\n  padding: 8px;\n  font-size: 20px;\n  font-weight: bold;\n}\n", ""]);

// exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\nbutton[data-v-17c86ae4] {background:var(--theme-primary) !important\n}\nbutton[data-v-17c86ae4] { height: 32px !important; color: #fff !important\n}\n.get-logs[data-v-17c86ae4]{\npadding: 8px 15px;\n    height: 36px !important;\n    margin-top: -2px;\n}\nth[data-v-17c86ae4], td[data-v-17c86ae4]{\n    padding: 5px 5px !important;\n\tfont-size:14px !important;\n}\n", ""]);

// exports


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=- Brand Bar =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-*/\n/*body {\n    padding-top:64px;\n}*/\n.fixed-top-2 {\n    margin-top: 0;\n}\n.right {\n\tbackground: none\n}\n.btn-navbar {\n\tcolor: #fff;\n\tborder-radius:0;\n\tbackground: var(--theme-primary);\n\tborder: 0px;\n\tpadding: 8px 20px;\n  border: 0 none;\n  font-weight: 400;\n  letter-spacing: 1px;\n\tcursor: pointer;\n}\n.btn-navbar:hover {\n\tcolor: #fff;\n\tbackground: #D9BE5F;\n\ttransition: all 0.3s ease 0s;\n}\n.navbar-inverse .navbar-toggler {\n    border-color: ;\n}\n.brandbar  {\n\tbackground: #fff;\n\tmargin: 0;\n}\n/*brand a {\n  padding-bottom: 10px !important;\n  padding-top: 0px !important;\n  transition: all 0.3s ease;\n}*/\n.navbar-toggleable-md{\n\tmin-height: 80px;\n}\n.navbar-toggler {\n\tmargin-top: 20px;\n  background-color: var(--theme-primary);\n  z-index:9999\n}\n.navbar-collapse {\n\tpadding: 30px 0;\n}\nul.list-inline {\n\tpadding: 0;\n\tmargin: 0;\n\tborder-left: 1px solid #CECECB;\n  padding:0px;\n}\n.list-inline-item {\n\tpadding:0px;\n}\n.fontAwesomeQuestion {\n\tmargin-left:0px;\n\tvertical-align: middle;\n  color: var(--theme-primary);\n}\n.fontAwesomeQuestion:hover, .fa-sign-out:hover {\n  color: #fff;\n}\n.fa-sign-out {\n  margin-left:0px;\n\tvertical-align: middle;\n  color: var(--theme-primary);\n}\n/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=- Nav Bar =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-*/\n.activeHeader {\n  border-left: solid 4px var(--theme-primary);\n padding-top: 15px;\n    padding-bottom: 10px;\n}\n.navbar-default{\n  margin: 0; /* you don't need add this line\n\tpadding: 0 35px;*/\n  border-radius: 0px;\n\tbackground-color:var(--theme-secondary);\n}\n.navbar-nav > li > a {\n\tcolor: #fff;\n  margin-right: 10px;\n  white-space:nowrap;\n  padding-left: 16px;\n  font-size: 14px;\n  font-family: r-med;\n}\n.navbar-nav > li > a:hover,\n.navbar-nav > li > a:focus {\n\tborder-left: 4px solid var(--theme-primary);\n\tpadding-top: 15px;\n    padding-bottom: 10px;\n\ttext-decoration: none;\n\tpadding-left:10px !important;\n}\n.navbar-nav > .nav-item:hover,\n.navbar-nav > .nav-item:focus {\n\tbackground:#323b3c\n}\n.navbar-nav > .active > a,\n.navbar-nav > .active > a:hover,\n.navbar-nav > .active > a:focus {\n\tbackground-color: #454c56;\n\tborder-left: 4px solid #fff;\n\tbackground-repeat: no-repeat;\n\tpadding-top: 15px;\n    padding-bottom: 10px;\n\ttext-decoration: none;\n}\n.navbar-nav-admin > li > a {\n\tcolor: #fff;\n\tmargin-right: 20px;\n  border-right: 0px solid #878a8f;\n  padding-right: 0px;\n}\n.navbar-nav-admin > li > a:hover,\n.navbar-nav-admin > li > a:focus {\n\tbackground-color: #454c56;\n  border-left: 4px solid var(--theme-primary);\n\tpadding-top: 15px;\n    padding-bottom: 10px;\n\ttext-decoration: none;\n  border-right: 0px solid #878a8f;\n}\n.navbar-nav-admin > .active > a,\n.navbar-nav-admin > .active > a:hover,\n.navbar-nav-admin > .active > a:focus {\n\tbackground-color: #454c56;\n\tborder-top: 0px solid #fff;\n\tborder-left: 0px solid #fff;\n\tbackground-repeat: no-repeat;\n\tpadding-top: 10px;\n    padding-bottom: 10px;\n\ttext-decoration: none;\n  border-right: 0px solid #878a8f;\n}\n/*.nav-item {\n  color:#000;\n}*/\n.list-inline-item-help > li >a  {\n\tcolor: #fff;\n\tmargin-right: 40px;\n  border-right: 2px solid #878a8f;\n  padding-right: 0px;\n}\n.list-inline-item-help > li  > a:hover,\n.list-inline-item-help > li  > a:focus {\n\tbackground-color: #454c56;\n  border-top: 0px;\n  border-left: 0px;\n\tpadding-top: 0px;\n\ttext-decoration: none;\n  border-right: 0px solid #878a8f;\n}\n.list-inline-item-help > .active > a,\n.list-inline-item-help > .active > a:hover,\n.list-inline-item-help > .active > a:focus {\n\tbackground-color: #454c56;\n\tborder-top: 0px solid #fff;\n\tborder-left: 0px solid #fff;\n\tbackground-repeat: no-repeat;\n\tpadding-top: 10px;\n    padding-bottom: 10px;\n\ttext-decoration: none;\n  border-right: 0px solid #878a8f;\n}\n.disabled-top-nav-link {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: not-allowed;\n}\n.disabled-top-nav-link a {\n  color: #cdcdcd !important;\n  pointer-events: none;\n}\nli.nav-item {\npadding-top: 10px;\n    padding-bottom: 10px;\n}\n.navbar-brand\n{\n  width: 100%;\n  left: 0;\n  top: 0;\n  /*text-align: left;*/\n  margin: auto;\n  padding:20px 0;\n}\n.modal-open {\n    overflow: hidden;\n    padding-right: 0px !important;\n}\n.btn-primary {\n  border-radius: 0;\n}\n.btn-primary:hover {\n  background-color: var(--theme-primary);\n  border: 1px solid var(--theme-primary);\n}\n/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=- Media Queries =-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */\n@media screen and (max-width: 400px) {\n.navbar-nav > li > a:hover,\n  .navbar-nav > li > a:focus {\n    background-color: #454c56;\n    border-top: 0px solid var(--theme-primary);\n    border-left: 0px solid var(--theme-primary);\n    padding-top: 11px;\n    text-decoration: none;\n}\n.li-navitem {\n    text-align: left;\n}\n.navbar-collapse {\n    padding: 10px 0px;\n}\n}\n/* Small devices (landscape phones, 576px and up) */\n@media (min-width: 325px) and (max-width: 991px) {\n.list-inline-item-help > li  > a:hover,\n  .list-inline-item-help > li  > a:focus {\n    background-color: #454c56;\n    border-top: 0px;\n    border-left: 0px;\n    padding-top: 0px;\n    text-decoration: none;\n    border-right: 0px solid #878a8f;\n}\n.list-inline-item-help > .active > a,\n  .list-inline-item-help > .active > a:hover,\n  .list-inline-item-help > .active > a:focus {\n    background-color: #454c56;\n    border-top: 0px;\n    border-left: 0px;\n    background-repeat: no-repeat;\n    padding-top: 15px;\n    text-decoration: none;\n    border-right: 0px solid #878a8f;\n}\n.navbar-nav-admin > li > a:hover,\n.navbar-nav-admin > li > a:focus {\n  border-top: 0;border-left: 0;\n}\n.navbar-nav > li > a:hover,\n  .navbar-nav > li > a:focus {\n    background-color: #454c56;\n    border-top: 0px;border-left: 0;\n    padding-top: 11px;\n    text-decoration: none;\n}\n.activeHeader {\n    border-left: 0px;\n}\n.navbar-collapse {\n    border-top: 1px solid transparent;\n    border-left: 1px solid transparent;\n    box-shadow: inset 0 1px 0 rgba(255,255,255,0.1);\n}\n.navbar-nav {\n    float: none!important;\n}\n.navbar-nav>li {\n    float: none;\n}\n.navbar-nav>li>a {\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n.fontAwesomeQuestion {\n    margin-top: 10px;\n}\n.fa-sign-out {\n    float: left;\n    margin-top: 50px;\n    margin-left: -50px;\n    vertical-align: middle;\n    color: var(--theme-primary);\n}\n}\n.help-div{\nposition: absolute;\n    bottom: 0px;\n    background: var(--theme-primary);\n    z-index: 9999;\n    width: 99%;\n    padding: 10px;\n    cursor: pointer;\n    color: #fff;outline: 1px solid var(--theme-primary);\n        font-size: 16px;\n    font-family: r-med;\n}\n.navbar-nav{margin-bottom: 20px;\n}\n#applicationbrandbar{\nmax-width: 200px !important;\nheight: 100% !important;\npadding:0px;\n}\n.activeHeader{padding-left:10px !important\n}\n.nav-item {\nmargin-top:5px\n}\n.closebtn{\n    font-size: 35px;\n    z-index: 9999999;\n    position: absolute;\n    color: #fff;\n    left: 170px;\n    top: -10px;\n\tcursor:pointer\n}\n.activeHeader {\n  border-left: solid 4px var(--theme-primary);\n  padding-top: 15px;\n    padding-bottom: 10px;\n}\n.lang-dpd option {\n    background:  var(--theme-secondary);\n    height: 35px;\n\tfont-size: 14px;\n\tfont-family: r-med;\n}\n.lang-dpd{\n    background:  transparent;\n    color: #fff;\n    border: 0px !important;\n    width: 100%;\n    margin: 16px 0px;\n    padding: 0px 13px;\n    height: 35px;\n\t-webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n\t-ms-appearance: none;\n\tz-index: -1;\n\tfont-size: 14px;\n\tfont-family: r-med;\n}\n@media screen and (max-width: 767px) {\n.navbar-toggler{display:block\n}\n.closebtn{display:block\n}\n#sidebar{display:none\n}\n.main-content{padding-left:0px\n}\n}\n@media screen and (min-width: 768px) {\n.navbar-toggler{display:none\n}\n.closebtn{display:none\n}\n#sidebar{display:block\n}\n.main-content{padding-left:200px\n}\n}\n.dots{font-size: 20px;\ncursor:pointer;\n    color: #fff;\n    float: right;\n\tz-index:1;\n    margin-top: -44px;\n\tmargin-right:10px\n}\n.nav-item: hover {\n\tbackground: #fff;\n\ttransition: all 0.3s ease 0s;\n}\n@font-face {\n  font-family: \"r-thin\";\n  src: local(Roboto Thin), url(" + __webpack_require__(200) + ");\n  src: url(" + __webpack_require__(200) + "?#iefix) format(\"embedded-opentype\"),\n  url(" + __webpack_require__(324) + ") format(\"woff2\"),\n  url(" + __webpack_require__(323) + ") format(\"woff\"),\n  url(" + __webpack_require__(322) + ") format(\"truetype\");\n  font-weight: 200;\n}\n@font-face {\n  font-family: \"r-light\";\n  src: local(Roboto Light), url(" + __webpack_require__(197) + ");\n  src: url(" + __webpack_require__(197) + "?#iefix) format(\"embedded-opentype\"),\n  url(" + __webpack_require__(315) + ") format(\"woff2\"),\n  url(" + __webpack_require__(314) + ") format(\"woff\"),\n  url(" + __webpack_require__(313) + ") format(\"truetype\");\n  font-weight: 300;\n}\n@font-face {\n  font-family: \"r-reg\";\n  src: local(Roboto Regular), url(" + __webpack_require__(199) + ");\n  src: url(" + __webpack_require__(199) + "?#iefix) format(\"embedded-opentype\"),\n  url(" + __webpack_require__(321) + ") format(\"woff2\"),\n  url(" + __webpack_require__(320) + ") format(\"woff\"),\n  url(" + __webpack_require__(319) + ") format(\"truetype\");\n  font-weight: 400;\n}\n@font-face {\n  font-family: \"r-med\";\n  src: url(" + __webpack_require__(198) + ");\n  src: url(" + __webpack_require__(198) + "?#iefix) format(\"embedded-opentype\"),\n  url(" + __webpack_require__(318) + ") format(\"woff2\"),\n  url(" + __webpack_require__(317) + ") format(\"woff\"),\n  url(" + __webpack_require__(316) + ") format(\"truetype\");\n  font-weight: 500;\n}\n@font-face {\n  font-family: \"r-bold\";\n  src: url(" + __webpack_require__(196) + ");\n  src: url(" + __webpack_require__(196) + "?#iefix) format(\"embedded-opentype\"),\n  url(" + __webpack_require__(312) + ") format(\"woff2\"),\n  url(" + __webpack_require__(311) + ") format(\"woff\"),\n  url(" + __webpack_require__(310) + ") format(\"truetype\");\n  font-weight: 700;\n}\nselect.lang-dpd::-ms-expand {\n    display: none;\n}\n@media all and (-ms-high-contrast:none)\n {\n*::-ms-backdrop, li.nav-item { min-height: 45px !important\n} /* IE11 */\n}\n", ""]);

// exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\nul[data-v-202322ac] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-202322ac] {\n  display: inline-block;\n  margin: 0 10px;\n  padding: 0;\n}\n.custom-select[data-v-202322ac] {\n  display: inline-block;\n  max-width: 100%;\n  height: calc(2.5rem + 2px);\n  padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n  line-height: 1.25;\n  background-color: #ececeb;\n  vertical-align: middle;\n  background-size: 8px 10px;\n  border: 1px solid #00524a;\n  border-radius: 0;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\n.card-block[data-v-202322ac] {\n  background: #eceff1;\n}\n.user-input[data-v-202322ac] {\n  width: 100%;\n  background: #ffffff;\n  color: #333333;\n  height: 30px;\n}\n.user-select[data-v-202322ac] {\n  color: #333333;\n  height: 30px;\n}\n#userSearch[data-v-202322ac] {\n  margin: 10px;\n}\n.good-table th[data-v-202322ac] {\n  color: #333333 !important;\n}\n.btn-secondary[data-v-202322ac]:active {\n  background: #007299;\n  box-shadow: none;\n}\n.btn-secondary[data-v-202322ac] {\n  background: var(--theme-primary);\n  color: #ffffff;\n}\ninput[data-v-202322ac] {\n  width: 130px;\n  box-sizing: border-box;\n  border: 1px solid var(--theme-primary);\n  border-radius: 0;\n  font-size: 16px;\n  background-color: #f1f1f1;\n  background-position: 10px 10px;\n  background-repeat: no-repeat;\n  padding: 15px 20px;\n  height: 50px;\n}\n.card[data-v-202322ac] {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  background-color: #33373d;\n  border: 0px solid rgba(0, 0, 0, 0.125);\n  border-radius: 0px;\n  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);\n  box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.4);\n}\n.card[data-v-202322ac] {\n  margin-bottom: 1rem;\n  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);\n}\n.card-block1[data-v-202322ac] {\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  padding: 0rem;\n}\n#searchId[data-v-202322ac] {\n  box-sizing: border-box !important;\n  border: 2px solid #dde3e6 !important;\n  border-radius: 0 !important;\n  background-color: #fff !important;\n  background-position: 10px 10px !important;\n  background-repeat: no-repeat !important;\n  height: 40px !important;\n  margin-bottom: 18px !important;\n  margin-left: 30px !important;\n}\n.filter-label[data-v-202322ac] {\n  width: 150px;\n  float: left;\n  font-size: 14px;\n  margin-top: 8px;\n  font-weight: bold;\n}\n.btn-secondary[data-v-202322ac] {\n  background-color: var(--theme-primary);\n  border-color: #00433c;\n}\n.btn-secondary[data-v-202322ac]:hover {\n  background-color: #00524a;\n  border-color: #00433c;\n}\n.btn[data-v-202322ac] {\n  padding: 14px 24px;\n  border: 0 none;\n  font-weight: 700;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n.input-adduser[data-v-202322ac] {\n  height: initial;\n  padding: 5px 15px;\n  width: 100%;\n  background: #fff;\n  margin: 0px !important;\n}\n.input-checkbx-sub[data-v-202322ac] {\n  width: 20px;\n  height: 20px !important;\n  display: inline-block;\n}\n.preflang[data-v-202322ac] {\n  width: 100%;\n  min-height: 34px;\n}\n.success-bg[data-v-202322ac] {\n  background: #90ee90;\n}\n.error-bg[data-v-202322ac] {\n  background: #ffc0cb;\n}\n.form-control-label[data-v-202322ac] {\n  min-width: 120px;\n  font-size: 12px;\n}\n.wrap-input[data-v-202322ac] {\n  display: block;\n  overflow: hidden;\n}\n.form-wrap[data-v-202322ac] {\n  margin-bottom: 3px;\n}\n.create-btn[data-v-202322ac] {\n  margin-top: 10px;\n  height: 40px;\n  line-height: 0px;\n  font-size: 12px;\n  float: right;\n}\n.search-icon[data-v-202322ac] {\n  margin-top: 10px;\n  margin-top: 0px;\n  height: 40px !important;\n  line-height: 0px;\n  padding: 12px 24px 14px 24px;\n  margin-bottom: 10px;\n  border-radius: 0px;\n}\n.tableContainer[data-v-202322ac] {\n  padding: 0px 15px 30px;\n  overflow-x: auto;\n}\n.input-group[data-v-202322ac] {\n  width: 100%;\n  background: #fff;\n  margin: 0px -15px 0p;\n  padding: 5px;\n  outline: 15px solid #fff;\n  /* margin: 0px -15px; */\n}\n.input-group-btn[data-v-202322ac] {\n  max-width: 65px;\n}\n.sub-group[data-v-202322ac] {\n  display: inline-block;\n}\n@media (max-width: 1050px) {\n.input-group[data-v-202322ac] {\n    width: 100% !important;\n    display: block;\n}\n}\n@media (max-width: 768px) {\n.sub-group[data-v-202322ac] {\n    width: 100% !important;\n    display: block;\n}\n.searchId[data-v-202322ac] {\n    max-width: 230px;\n}\n.filter-text[data-v-202322ac] {\n    margin-left: 0px !important;\n}\n.adduser-btn[data-v-202322ac] {\n    margin-left: 0px !important;\n}\n}\n.dropdown div[data-v-202322ac],\n.dropdown dt[data-v-202322ac] {\n  margin: 0px;\n  padding: 0px;\n}\n.dropdown ul[data-v-202322ac] {\n  margin: 0px;\n  padding: 0px;\n}\n.dropdown div[data-v-202322ac] {\n  position: relative;\n  margin: 0px;\n  padding: 0px;\n}\n.dropdown a[data-v-202322ac],\n.dropdown a[data-v-202322ac]:visited {\n  color: #fff;\n  text-decoration: none;\n  outline: none;\n  margin: 0px;\n  padding: 0px;\n  min-height: 30px;\n  border-radius: 3px;\n}\n.dropdown div a[data-v-202322ac] {\n  background-color: #4f6877;\n  display: block;\n  overflow: hidden;\n  width: 100%;\n  margin: 0px;\n  padding: 0px;\n}\n.dropdown div a span[data-v-202322ac],\n.multiSel span[data-v-202322ac] {\n  cursor: pointer;\n  display: inline-block;\n  margin: 0px;\n  padding: 5px 10px;\n}\n.dropdown div ul[data-v-202322ac] {\n  background-color: #4f6877;\n  top: 1px;\n  color: #fff;\n  display: none;\n  position: absolute;\n  width: 100%;\n  list-style: none;\n  height: 100px;\n  overflow: auto;\n  margin: 0px;\n  padding: 0px;\n}\n.dropdown span.value[data-v-202322ac] {\n  display: none;\n  border-radius: 3px;\n  margin: 0px;\n  padding: 0px;\n}\n.dropdown div ul li a[data-v-202322ac] {\n  display: block;\n  margin: 0px;\n  padding: 0px;\n}\n.dropdown div ul li a[data-v-202322ac]:hover {\n  background-color: #fff;\n  margin: 0px;\n  padding: 0px;\n}\n.selectDropDown[data-v-202322ac] {\n  border: 2px solid #dde3e6;\n  height: 34px;\n  /* border-radius: 3px; */\n  cursor: pointer;\n  background: #fff;\n  width: 100%;\n}\n#checkboxlist[data-v-202322ac] {\n  position: relative;\n  margin-top: 0px;\n  background: #fff;\n  border: 1px solid #ccc;\n  min-width: 200px;\n}\n.dd-list-item[data-v-202322ac]:hover {\n  background: #fff;\n}\nbutton[data-v-202322ac] {\n  background: var(--theme-primary) !important;\n}\n.adduser-btn[data-v-202322ac] {\n  margin-left: 20px;\n  max-height: 40px;\n  margin-top: 0px;\n  line-height: 0px;\n  height: 40px;\n  background-color: var(--theme-primary);\n  font-size: 12px;\n}\ninput[data-v-202322ac],\nselect[data-v-202322ac] {\n  background: #fff !important;\n  border: 2px solid #dde3e6 !important;\n  padding-left: 10px !important;\n  font-size: 14px !important;\n}\n.bc[data-v-202322ac] {\n  font-size: 10px;\n  font-weight: bold;\n}\n.bc-adduser[data-v-202322ac] {\n  font-size: 10px;\n  font-weight: bold;\n  margin: 15px;\n}\n.bc-nav[data-v-202322ac]:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.user-creds[data-v-202322ac] {\n  background: #fff;\n  padding: 5px 10px 10px;\n  margin-bottom: 12px;\n}\n.bb0[data-v-202322ac] {\n  border-top: 0px !important;\n}\n.add-group[data-v-202322ac] {\n  color: var(--theme-primary);\n  font-size: 18px;\n  float: right;\n  margin-top: 5px;\n  cursor: pointer;\n}\n.remove-group[data-v-202322ac] {\n  color: #d80842;\n  font-size: 20px;\n  /* float: right; */\n  margin-top: 6px;\n  cursor: pointer;\n}\n.group-div[data-v-202322ac] {\n  border: 2px solid #eceff1;\n  padding: 3px 10px;\n}\n.group-name[data-v-202322ac] {\n  display: inline-block;\n  width: 90%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.usercreateinfo[data-v-202322ac] {\n  margin-top: 10px;\n  background: #546e7a;\n  color: #fff;\n  padding: 10px;\n  margin-bottom: 10px;\n}\n@media screen and (max-width: 767px) {\n.main-content[data-v-202322ac] {\n    padding-top: 25px;\n}\n.main-content[data-v-202322ac] {\n    padding-left: 0px;\n}\n}\n@media screen and (min-width: 768px) {\n.main-content[data-v-202322ac] {\n    padding-top: 0px;\n}\n.main-content[data-v-202322ac] {\n    padding-left: 200px;\n}\n}\n@media screen and (min-width: 991px) {\n.search-bar-wrapper[data-v-202322ac] {\n    width: 100%;\n}\n.search-bar-select[data-v-202322ac] {\n    width: 300px;\n}\n}\n@media screen and (max-width: 991px) {\n.search-bar-wrapper[data-v-202322ac] {\n    width: 75%;\n}\n.search-bar-select[data-v-202322ac] {\n    width: 150px;\n}\n}\n.cancel-btn[data-v-202322ac] {\n  float: right;\n  display: block;\n  padding: 18px 30px;\n}\ninput[data-v-202322ac],\nselect[data-v-202322ac] {\n  height: 32px !important;\n  color: #000 !important;\n}\nbutton[data-v-202322ac] {\n  height: 32px !important;\n  color: #fff !important;\n}\n.disabled[data-v-202322ac] {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.disabledLight[data-v-202322ac] {\n  border: 2px solid #dde3e6 !important;\n  pointer-events: none;\n  opacity: 0.8;\n}\n.error[data-v-202322ac] {\n  color: red;\n  width: 100%;\n  margin-left: 15px;\n}\n.pwderror[data-v-202322ac] {\n  max-width: initial;\n  width: 100%;\n  font-size: 14px;\n}\n.codeVerifybtn[data-v-202322ac] {\n  background: #f9f9f9;\n  color: #595959;\n  border: 1px solid #c3c3c3;\n  font-size: 13px;\n  display: inline-block !important;\n  margin-top: -2px;\n  height: 30px;\n  line-height: 14px;\n  width: 87px;\n}\n.fa-check-circle[data-v-202322ac] {\n  font-size: 40px !important;\n}\nlabel[data-v-202322ac] {\n  margin-bottom: 0px !important;\n  font-weight: normal !important;\n  font-size: 13px;\n}\nuser-creds label[data-v-202322ac] {\n  font-weight: normal !important;\n}\n.sometext-hidden[data-v-202322ac] {\n  -webkit-user-select: none; /* Chrome/Safari */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* IE10+ */\n}\n.configGroupAdmin tr[data-v-202322ac],\ntd[data-v-202322ac],\nth[data-v-202322ac] {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n.configGroupAdmin tr[data-v-202322ac] {\n  border-bottom: 1px solid #eceff1;\n}\n.configGroupAdmin th[data-v-202322ac] {\n  padding: 10px !important;\n}\n.addgrouptxtbox[data-v-202322ac] {\n  width: 75%;\n  border: #ccc 1px solid !important;\n  border-radius: 2px;\n  margin-top: 5px;\n  font-size: 15px !important;\n}\n.deleteconfig[data-v-202322ac] {\n  margin-right: 15px;\n  line-height: 13px;\n  cursor: pointer;\n  padding: 6px;\n  font-size: 13px;\n  border-radius: 3px;\n  background: #bf6161 !important;\n  box-shadow: rgba(216, 21, 33, 0.75) 0px 0px 20px inset;\n  max-height: 30px;\n  /* margin-top: 2px; */\n}\ntd:nth-child(2) span[data-v-202322ac] {\n  max-width: 500px !important;\n  display: block;\n}\n.app-name[data-v-202322ac] {\n  padding-top: 5px;\n}\n.app-name[data-v-202322ac]:hover {\n  text-decoration: underline;\n  color: blue;\n}\n.dropdownWrap[data-v-202322ac] {\n  width:75%; \n  height: 40px !important; \n  padding: 7px !important; \n  font-size: 1rem !important;\n}\n.search-app[data-v-202322ac] {\n  width: 70%;\n  font-size: 1rem !important;\n  border: 0 !important;\n  border-bottom: 1px solid #ccc !important;\n  display: inline;\n}\n", ""]);

// exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\nbody {\n    /* padding-top:64px; */\n}\n.modal-content {\n    -webkit-border-radius: 0;\n    -webkit-background-clip: padding-box;\n    -moz-border-radius: 0;\n    -moz-background-clip: padding;\n    border-radius: 6px;\n    background-clip: padding-box;\n    box-shadow: 0 0 40px rgba(0,0,0,.5);\n    color: #000;\n    background-color: #fff;\n    border: rgba(0,0,0,0);\n}\n.modal-message .modal-body, .modal-message .modal-footer, .modal-message .modal-header, .modal-message .modal-title {\n    background: 0 0;\n    border: none;\n    margin: 0;\n    padding: 0 20px;\n    text-align: center!important;\n}\n.modal-message .modal-title {\n    font-size: 1.5rem;\n    color: #737373;\n    margin-bottom: 3px;\n}\n.modal-message .modal-body {\n    color: #737373;\n    padding-top: 20px;\n}\n.modal-message .modal-header {\n    color: #fff;\n    margin-bottom: 10px;\n    padding: 15px;\n}\n.modal-message .modal-header .fa,\n.modal-message .modal-header\n.glyphicon, .modal-message\n.modal-header .typcn, .modal-message .modal-header .wi {\n    font-size: 3rem;\n}\n.modal-message .modal-footer {\n    margin: 25px 0 20px;\n    padding-bottom: 10px;\n}\n.modal-message.modal-warning .modal-header {\n    color: #f4b400;\n    border-bottom: 3px solid #ffce55;\n}\n", ""]);

// exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=- Brand Bar =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-*/\n/*body {\n    padding-top:64px;\n}*/\n.fixed-top-2 {\n    margin-top: 0;\n}\n.right {\n\tbackground: none\n}\n.btn-navbar {\n\tcolor: #fff;\n\tborder-radius:0;\n\tbackground: #DBAA00;\n\tborder: 0px;\n\tpadding: 8px 20px;\n  border: 0 none;\n  font-weight: 400;\n  letter-spacing: 1px;\n\tcursor: pointer;\n}\n.btn-navbar:hover {\n\tcolor: #fff;\n\tbackground: #D9BE5F;\n\ttransition: all 0.3s ease 0s;\n}\n.navbar-inverse .navbar-toggler {\n    border-color: ;\n}\n.brandbar  {\n\tbackground: #fff;\n\tmargin: 0;\n}\n/*brand a {\n  padding-bottom: 10px !important;\n  padding-top: 0px !important;\n  transition: all 0.3s ease;\n}*/\n.navbar-toggleable-md{\n\tmin-height: 80px;\n}\n.navbar-toggler {\n\tmargin-left: 35px;\n\tmargin-top: 20px;\n  background-color: var(--theme-primary);\n}\n.navbar-collapse {\n\tpadding: 30px 0;\n}\nul.list-inline {\n\tpadding: 0;\n\tmargin: 0;\n\tborder-left: 1px solid #CECECB;\n  padding:0px;\n}\n.list-inline-item {\n\tpadding:0px;\n}\n.fontAwesomeQuestion {\n\tmargin-left:0px;\n\tvertical-align: middle;\n  color: var(--theme-primary);\n}\n.fontAwesomeQuestion:hover, .fa-sign-out:hover {\n  color: #fff;\n}\n.fa-sign-out {\n  margin-left:0px;\n\tvertical-align: middle;\n  color: var(--theme-primary);\n}\n/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=- Nav Bar =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-*/\n.activeHeader {\n  border-top: solid 6px #DBAA00;\n  padding-top: 11px;\n}\n.navbar-default{\n  margin: 0; /* you don't need add this line */\n\tpadding: 0 35px;\n  border-radius: 0px;\n\tbackground-color:#454c56;\n}\n.navbar-nav > li > a {\n\tcolor: #fff;\n  margin-right: 10px;\n  white-space:nowrap;\n}\n.navbar-nav > li > a:hover,\n.navbar-nav > li > a:focus {\n\tcolor: #DBAA00;\n\tbackground-color: #454c56;\n\tborder-top: 6px solid #DBAA00;\n\tpadding-top: 11px;\n\ttext-decoration: none;\n}\n.navbar-nav > .active > a,\n.navbar-nav > .active > a:hover,\n.navbar-nav > .active > a:focus {\n\tcolor: #DBAA00;\n\tbackground-color: #454c56;\n\tborder-top: 6px solid #fff;\n\tbackground-repeat: no-repeat;\n\tpadding-top: 11px;\n\ttext-decoration: none;\n}\n.navbar-nav-admin > li > a {\n\tcolor: #fff;\n\tmargin-right: 20px;\n  border-right: 0px solid #878a8f;\n  padding-right: 0px;\n}\n.navbar-nav-admin > li > a:hover,\n.navbar-nav-admin > li > a:focus {\n\tcolor: #DBAA00;\n\tbackground-color: #454c56;\n  border-top: 6px solid #DBAA00;\n\tpadding-top: 11px;\n\ttext-decoration: none;\n  border-right: 0px solid #878a8f;\n}\n.navbar-nav-admin > .active > a,\n.navbar-nav-admin > .active > a:hover,\n.navbar-nav-admin > .active > a:focus {\n\tcolor: #DBAA00;\n\tbackground-color: #454c56;\n\tborder-top: 0px solid #fff;\n\tbackground-repeat: no-repeat;\n\tpadding-top: 15px;\n\ttext-decoration: none;\n  border-right: 0px solid #878a8f;\n}\n/*.nav-item {\n  color:#000;\n}*/\n.list-inline-item-help > li >a  {\n\tcolor: #fff;\n\tmargin-right: 40px;\n  border-right: 2px solid #878a8f;\n  padding-right: 0px;\n}\n.list-inline-item-help > li  > a:hover,\n.list-inline-item-help > li  > a:focus {\n\tcolor: #DBAA00;\n\tbackground-color: #454c56;\n  border-top: 0px;\n\tpadding-top: 0px;\n\ttext-decoration: none;\n  border-right: 0px solid #878a8f;\n}\n.list-inline-item-help > .active > a,\n.list-inline-item-help > .active > a:hover,\n.list-inline-item-help > .active > a:focus {\n\tcolor: #DBAA00;\n\tbackground-color: #454c56;\n\tborder-top: 0px solid #fff;\n\tbackground-repeat: no-repeat;\n\tpadding-top: 15px;\n\ttext-decoration: none;\n  border-right: 0px solid #878a8f;\n}\n.disabled-top-nav-link {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: not-allowed;\n}\n.disabled-top-nav-link a {\n  color: #cdcdcd !important;\n  pointer-events: none;\n}\nli.nav-item {\n  padding-top: 10px;\n}\n.navbar-brand\n{\n  width: 100%;\n  left: 0;\n  top: 0;\n  /*text-align: left;*/\n  margin: auto;\n  padding:20px 0;\n}\n.modal-open {\n    overflow: hidden;\n    padding-right: 0px !important;\n}\n.btn-primary {\n  border-radius: 0;\n}\n.btn-primary:hover {\n  background-color: var(--theme-primary);\n  border: 1px solid var(--theme-primary);\n}\n/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=- Media Queries =-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */\n@media screen and (max-width: 400px) {\n.navbar-nav > li > a:hover,\n  .navbar-nav > li > a:focus {\n    color: #DBAA00;\n    background-color: #454c56;\n    border-top: 0px solid #DBAA00;\n    padding-top: 11px;\n    text-decoration: none;\n}\n.li-navitem {\n    text-align: left;\n}\n.navbar-collapse {\n    padding: 10px 0px;\n}\n}\n/* Small devices (landscape phones, 576px and up) */\n@media (min-width: 325px) and (max-width: 991px) {\n.list-inline-item-help > li  > a:hover,\n  .list-inline-item-help > li  > a:focus {\n    color: #DBAA00;\n    background-color: #454c56;\n    border-top: 0px;\n    padding-top: 0px;\n    text-decoration: none;\n    border-right: 0px solid #878a8f;\n}\n.list-inline-item-help > .active > a,\n  .list-inline-item-help > .active > a:hover,\n  .list-inline-item-help > .active > a:focus {\n    color: #DBAA00;\n    background-color: #454c56;\n    border-top: 0px;\n    background-repeat: no-repeat;\n    padding-top: 15px;\n    text-decoration: none;\n    border-right: 0px solid #878a8f;\n}\n.navbar-nav-admin > li > a:hover,\n.navbar-nav-admin > li > a:focus {\n  border-top: 0;\n}\n.navbar-nav > li > a:hover,\n  .navbar-nav > li > a:focus {\n    color: #DBAA00;\n    background-color: #454c56;\n    border-top: 0px;\n    padding-top: 11px;\n    text-decoration: none;\n}\n.activeHeader {\n    border-top: 0px;\n}\n.navbar-collapse {\n    border-top: 1px solid transparent;\n    box-shadow: inset 0 1px 0 rgba(255,255,255,0.1);\n}\n.navbar-nav {\n    float: none!important;\n}\n.navbar-nav>li {\n    float: none;\n}\n.navbar-nav>li>a {\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n.fontAwesomeQuestion {\n    margin-top: 10px;\n}\n.fa-sign-out {\n    float: left;\n    margin-top: 50px;\n    margin-left: -50px;\n    vertical-align: middle;\n    color: var(--theme-primary);\n}\n}\n", ""]);

// exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports
exports.i(__webpack_require__(628), "");
exports.i(__webpack_require__(629), "");

// module
exports.push([module.i, "\n@charset \"UTF-8\";\n/*!\n * Bootstrap v4.0.0-alpha.6 (https://getbootstrap.com)\n * Copyright 2011-2017 The Bootstrap Authors\n * Copyright 2011-2017 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n/*! normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css */\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n}\nbody {\n  margin: 0;\n}\narticle,\naside,\nfooter,\nheader,\nnav,\nsection {\n  display: block;\n}\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\nfigcaption,\nfigure,\nmain {\n  display: block;\n}\nfigure {\n  margin: 1em 40px;\n}\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\npre {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\na {\n  background-color: transparent;\n  -webkit-text-decoration-skip: objects;\n}\na:active,\na:hover {\n  outline-width: 0;\n}\nabbr[title] {\n  border-bottom: none;\n  text-decoration: underline;\n  text-decoration: underline dotted;\n}\nb,\nstrong {\n  font-weight: inherit;\n}\nb,\nstrong {\n  font-weight: bolder;\n}\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\ndfn {\n  font-style: italic;\n}\nmark {\n  background-color: #ff0;\n  color: #000;\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\naudio,\nvideo {\n  display: inline-block;\n}\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\nimg {\n  border-style: none;\n}\nsvg:not(:root) {\n  overflow: hidden;\n}\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: sans-serif;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n}\nbutton,\ninput {\n  overflow: visible;\n}\nbutton,\nselect {\n  text-transform: none;\n}\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\nlegend {\n  box-sizing: border-box;\n  color: inherit;\n  display: table;\n  max-width: 100%;\n  padding: 0;\n  white-space: normal;\n}\nprogress {\n  display: inline-block;\n  vertical-align: baseline;\n}\ntextarea {\n  overflow: auto;\n}\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n[type=\"search\"] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  font: inherit;\n}\ndetails,\nmenu {\n  display: block;\n}\nsummary {\n  display: list-item;\n}\ncanvas {\n  display: inline-block;\n}\ntemplate {\n  display: none;\n}\n[hidden] {\n  display: none;\n}\n@media print {\n*,\n  *::before,\n  *::after,\n  p::first-letter,\n  div::first-letter,\n  blockquote::first-letter,\n  li::first-letter,\n  p::first-line,\n  div::first-line,\n  blockquote::first-line,\n  li::first-line {\n    text-shadow: none !important;\n    box-shadow: none !important;\n}\na,\n  a:visited {\n    text-decoration: underline;\n}\nabbr[title]::after {\n    content: \" (\" attr(title) \")\";\n}\npre {\n    white-space: pre-wrap !important;\n}\npre,\n  blockquote {\n    border: 1px solid #999;\n    page-break-inside: avoid;\n}\nthead {\n    display: table-header-group;\n}\ntr,\n  img {\n    page-break-inside: avoid;\n}\np,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n}\nh2,\n  h3 {\n    page-break-after: avoid;\n}\n.navbar {\n    display: none;\n}\n.badge {\n    border: 1px solid #000;\n}\n.table {\n    border-collapse: collapse !important;\n}\n.table td,\n    .table th {\n      background-color: #fff !important;\n}\n.table-bordered th,\n  .table-bordered td {\n    border: 1px solid #ddd !important;\n}\n}\nhtml {\n  box-sizing: border-box;\n}\n*,\n*::before,\n*::after {\n  box-sizing: inherit;\n}\n@-ms-viewport {\n  width: device-width;\n}\nhtml {\n  -ms-overflow-style: scrollbar;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\nbody {\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  font-size: 1rem;\n  font-weight: normal;\n  line-height: 1.5;\n  color: #292b2c;\n  background-color: #fff;\n}\n[tabindex=\"-1\"]:focus {\n  outline: none !important;\n}\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: .5rem;\n}\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\nabbr[title],\nabbr[data-original-title] {\n  cursor: help;\n}\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\ndt {\n  font-weight: bold;\n}\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0;\n}\nblockquote {\n  margin: 0 0 1rem;\n}\na {\n  color: #0275d8;\n  text-decoration: none;\n}\na:focus, a:hover {\n    color: #014c8c;\n    text-decoration: underline;\n}\na:not([href]):not([tabindex]) {\n  color: inherit;\n  text-decoration: none;\n}\na:not([href]):not([tabindex]):focus, a:not([href]):not([tabindex]):hover {\n    color: inherit;\n    text-decoration: none;\n}\na:not([href]):not([tabindex]):focus {\n    outline: 0;\n}\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n}\nfigure {\n  margin: 0 0 1rem;\n}\nimg {\n  vertical-align: middle;\n}\n[role=\"button\"] {\n  cursor: pointer;\n}\na,\narea,\nbutton,\n[role=\"button\"],\ninput,\nlabel,\nselect,\nsummary,\ntextarea {\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n}\ntable {\n  border-collapse: collapse;\n  background-color: transparent;\n}\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #636c72;\n  text-align: left;\n  caption-side: bottom;\n}\nth {\n  text-align: left;\n}\nlabel {\n  display: inline-block;\n  margin-bottom: .5rem;\n}\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\ninput,\nbutton,\nselect,\ntextarea {\n  line-height: inherit;\n}\ninput[type=\"radio\"]:disabled,\ninput[type=\"checkbox\"]:disabled {\n  cursor: not-allowed;\n}\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  -webkit-appearance: listbox;\n}\ntextarea {\n  resize: vertical;\n}\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\nlegend {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: .5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n}\ninput[type=\"search\"] {\n  -webkit-appearance: none;\n}\noutput {\n  display: inline-block;\n}\n[hidden] {\n  display: none !important;\n}\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: 0.5rem;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n}\nh1, .h1 {\n  font-size: 2.5rem;\n}\nh2, .h2 {\n  font-size: 2rem;\n}\nh3, .h3 {\n  font-size: 1.75rem;\n}\nh4, .h4 {\n  font-size: 1.5rem;\n}\nh5, .h5 {\n  font-size: 1.25rem;\n}\nh6, .h6 {\n  font-size: 1rem;\n}\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n.display-1 {\n  font-size: 6rem;\n  font-weight: 300;\n  line-height: 1.1;\n}\n.display-2 {\n  font-size: 5.5rem;\n  font-weight: 300;\n  line-height: 1.1;\n}\n.display-3 {\n  font-size: 4.5rem;\n  font-weight: 300;\n  line-height: 1.1;\n}\n.display-4 {\n  font-size: 3.5rem;\n  font-weight: 300;\n  line-height: 1.1;\n}\nhr {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\nsmall,\n.small {\n  font-size: 80%;\n  font-weight: normal;\n}\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n    margin-right: 5px;\n}\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\n.blockquote {\n  padding: 0.5rem 1rem;\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n  border-left: 0.25rem solid #eceeef;\n}\n.blockquote-footer {\n  display: block;\n  font-size: 80%;\n  color: #636c72;\n}\n.blockquote-footer::before {\n    content: \"\\2014   \\A0\";\n}\n.blockquote-reverse {\n  padding-right: 1rem;\n  padding-left: 0;\n  text-align: right;\n  border-right: 0.25rem solid #eceeef;\n  border-left: 0;\n}\n.blockquote-reverse .blockquote-footer::before {\n  content: \"\";\n}\n.blockquote-reverse .blockquote-footer::after {\n  content: \"\\A0   \\2014\";\n}\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 0.25rem;\n  transition: all 0.2s ease-in-out;\n  max-width: 100%;\n  height: auto;\n}\n.figure {\n  display: inline-block;\n}\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n.figure-caption {\n  font-size: 90%;\n  color: #636c72;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\ncode {\n  padding: 0.2rem 0.4rem;\n  font-size: 90%;\n  color: #bd4147;\n  background-color: #f7f7f9;\n  border-radius: 0.25rem;\n}\na > code {\n    padding: 0;\n    color: inherit;\n    background-color: inherit;\n}\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 90%;\n  color: #fff;\n  background-color: #292b2c;\n  border-radius: 0.2rem;\n}\nkbd kbd {\n    padding: 0;\n    font-size: 100%;\n    font-weight: bold;\n}\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  font-size: 90%;\n  color: #292b2c;\n}\npre code {\n    padding: 0;\n    font-size: inherit;\n    color: inherit;\n    background-color: transparent;\n    border-radius: 0;\n}\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n.container {\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n@media (min-width: 576px) {\n.container {\n      padding-right: 15px;\n      padding-left: 15px;\n}\n}\n@media (min-width: 768px) {\n.container {\n      padding-right: 15px;\n      padding-left: 15px;\n}\n}\n@media (min-width: 992px) {\n.container {\n      padding-right: 15px;\n      padding-left: 15px;\n}\n}\n@media (min-width: 1200px) {\n.container {\n      padding-right: 15px;\n      padding-left: 15px;\n}\n}\n@media (min-width: 576px) {\n.container {\n      width: 540px;\n      max-width: 100%;\n}\n}\n@media (min-width: 768px) {\n.container {\n      width: 720px;\n      max-width: 100%;\n}\n}\n@media (min-width: 992px) {\n.container {\n      width: 960px;\n      max-width: 100%;\n}\n}\n@media (min-width: 1200px) {\n.container {\n      width: 1140px;\n      max-width: 100%;\n}\n}\n.container-fluid {\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n@media (min-width: 576px) {\n.container-fluid {\n      padding-right: 15px;\n      padding-left: 15px;\n}\n}\n@media (min-width: 768px) {\n.container-fluid {\n      padding-right: 15px;\n      padding-left: 15px;\n}\n}\n@media (min-width: 992px) {\n.container-fluid {\n      padding-right: 15px;\n      padding-left: 15px;\n}\n}\n@media (min-width: 1200px) {\n.container-fluid {\n      padding-right: 15px;\n      padding-left: 15px;\n}\n}\n.row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n@media (min-width: 576px) {\n.row {\n      margin-right: -15px;\n      margin-left: -15px;\n}\n}\n@media (min-width: 768px) {\n.row {\n      margin-right: -15px;\n      margin-left: -15px;\n}\n}\n@media (min-width: 992px) {\n.row {\n      margin-right: -15px;\n      margin-left: -15px;\n}\n}\n@media (min-width: 1200px) {\n.row {\n      margin-right: -15px;\n      margin-left: -15px;\n}\n}\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n.no-gutters > .col,\n  .no-gutters > [class*=\"col-\"] {\n    padding-right: 0;\n    padding-left: 0;\n}\n.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl {\n  position: relative;\n  width: 100%;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n@media (min-width: 576px) {\n.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl {\n      padding-right: 15px;\n      padding-left: 15px;\n}\n}\n@media (min-width: 768px) {\n.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl {\n      padding-right: 15px;\n      padding-left: 15px;\n}\n}\n@media (min-width: 992px) {\n.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl {\n      padding-right: 15px;\n      padding-left: 15px;\n}\n}\n@media (min-width: 1200px) {\n.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl {\n      padding-right: 15px;\n      padding-left: 15px;\n}\n}\n.col {\n  -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n  max-width: 100%;\n}\n.col-auto {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  width: auto;\n}\n.col-1 {\n  -ms-flex: 0 0 8.33333%;\n      flex: 0 0 8.33333%;\n  max-width: 8.33333%;\n}\n.col-2 {\n  -ms-flex: 0 0 16.66667%;\n      flex: 0 0 16.66667%;\n  max-width: 16.66667%;\n}\n.col-3 {\n  -ms-flex: 0 0 25%;\n      flex: 0 0 25%;\n  max-width: 25%;\n}\n.col-4 {\n  -ms-flex: 0 0 33.33333%;\n      flex: 0 0 33.33333%;\n  max-width: 33.33333%;\n}\n.col-5 {\n  -ms-flex: 0 0 41.66667%;\n      flex: 0 0 41.66667%;\n  max-width: 41.66667%;\n}\n.col-6 {\n  -ms-flex: 0 0 50%;\n      flex: 0 0 50%;\n  max-width: 50%;\n}\n.col-7 {\n  -ms-flex: 0 0 58.33333%;\n      flex: 0 0 58.33333%;\n  max-width: 58.33333%;\n}\n.col-8 {\n  -ms-flex: 0 0 66.66667%;\n      flex: 0 0 66.66667%;\n  max-width: 66.66667%;\n}\n.col-9 {\n  -ms-flex: 0 0 75%;\n      flex: 0 0 75%;\n  max-width: 75%;\n}\n.col-10 {\n  -ms-flex: 0 0 83.33333%;\n      flex: 0 0 83.33333%;\n  max-width: 83.33333%;\n}\n.col-11 {\n  -ms-flex: 0 0 91.66667%;\n      flex: 0 0 91.66667%;\n  max-width: 91.66667%;\n}\n.col-12 {\n  -ms-flex: 0 0 100%;\n      flex: 0 0 100%;\n  max-width: 100%;\n}\n.pull-0 {\n  right: auto;\n}\n.pull-1 {\n  right: 8.33333%;\n}\n.pull-2 {\n  right: 16.66667%;\n}\n.pull-3 {\n  right: 25%;\n}\n.pull-4 {\n  right: 33.33333%;\n}\n.pull-5 {\n  right: 41.66667%;\n}\n.pull-6 {\n  right: 50%;\n}\n.pull-7 {\n  right: 58.33333%;\n}\n.pull-8 {\n  right: 66.66667%;\n}\n.pull-9 {\n  right: 75%;\n}\n.pull-10 {\n  right: 83.33333%;\n}\n.pull-11 {\n  right: 91.66667%;\n}\n.pull-12 {\n  right: 100%;\n}\n.push-0 {\n  left: auto;\n}\n.push-1 {\n  left: 8.33333%;\n}\n.push-2 {\n  left: 16.66667%;\n}\n.push-3 {\n  left: 25%;\n}\n.push-4 {\n  left: 33.33333%;\n}\n.push-5 {\n  left: 41.66667%;\n}\n.push-6 {\n  left: 50%;\n}\n.push-7 {\n  left: 58.33333%;\n}\n.push-8 {\n  left: 66.66667%;\n}\n.push-9 {\n  left: 75%;\n}\n.push-10 {\n  left: 83.33333%;\n}\n.push-11 {\n  left: 91.66667%;\n}\n.push-12 {\n  left: 100%;\n}\n.offset-1 {\n  margin-left: 8.33333%;\n}\n.offset-2 {\n  margin-left: 16.66667%;\n}\n.offset-3 {\n  margin-left: 25%;\n}\n.offset-4 {\n  margin-left: 33.33333%;\n}\n.offset-5 {\n  margin-left: 41.66667%;\n}\n.offset-6 {\n  margin-left: 50%;\n}\n.offset-7 {\n  margin-left: 58.33333%;\n}\n.offset-8 {\n  margin-left: 66.66667%;\n}\n.offset-9 {\n  margin-left: 75%;\n}\n.offset-10 {\n  margin-left: 83.33333%;\n}\n.offset-11 {\n  margin-left: 91.66667%;\n}\n@media (min-width: 576px) {\n.col-sm {\n    -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    max-width: 100%;\n}\n.col-sm-auto {\n    -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n    width: auto;\n}\n.col-sm-1 {\n    -ms-flex: 0 0 8.33333%;\n        flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n}\n.col-sm-2 {\n    -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n}\n.col-sm-3 {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n    max-width: 25%;\n}\n.col-sm-4 {\n    -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n}\n.col-sm-5 {\n    -ms-flex: 0 0 41.66667%;\n        flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n}\n.col-sm-6 {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n}\n.col-sm-7 {\n    -ms-flex: 0 0 58.33333%;\n        flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n}\n.col-sm-8 {\n    -ms-flex: 0 0 66.66667%;\n        flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n}\n.col-sm-9 {\n    -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n    max-width: 75%;\n}\n.col-sm-10 {\n    -ms-flex: 0 0 83.33333%;\n        flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n}\n.col-sm-11 {\n    -ms-flex: 0 0 91.66667%;\n        flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n}\n.col-sm-12 {\n    -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n    max-width: 100%;\n}\n.pull-sm-0 {\n    right: auto;\n}\n.pull-sm-1 {\n    right: 8.33333%;\n}\n.pull-sm-2 {\n    right: 16.66667%;\n}\n.pull-sm-3 {\n    right: 25%;\n}\n.pull-sm-4 {\n    right: 33.33333%;\n}\n.pull-sm-5 {\n    right: 41.66667%;\n}\n.pull-sm-6 {\n    right: 50%;\n}\n.pull-sm-7 {\n    right: 58.33333%;\n}\n.pull-sm-8 {\n    right: 66.66667%;\n}\n.pull-sm-9 {\n    right: 75%;\n}\n.pull-sm-10 {\n    right: 83.33333%;\n}\n.pull-sm-11 {\n    right: 91.66667%;\n}\n.pull-sm-12 {\n    right: 100%;\n}\n.push-sm-0 {\n    left: auto;\n}\n.push-sm-1 {\n    left: 8.33333%;\n}\n.push-sm-2 {\n    left: 16.66667%;\n}\n.push-sm-3 {\n    left: 25%;\n}\n.push-sm-4 {\n    left: 33.33333%;\n}\n.push-sm-5 {\n    left: 41.66667%;\n}\n.push-sm-6 {\n    left: 50%;\n}\n.push-sm-7 {\n    left: 58.33333%;\n}\n.push-sm-8 {\n    left: 66.66667%;\n}\n.push-sm-9 {\n    left: 75%;\n}\n.push-sm-10 {\n    left: 83.33333%;\n}\n.push-sm-11 {\n    left: 91.66667%;\n}\n.push-sm-12 {\n    left: 100%;\n}\n.offset-sm-0 {\n    margin-left: 0%;\n}\n.offset-sm-1 {\n    margin-left: 8.33333%;\n}\n.offset-sm-2 {\n    margin-left: 16.66667%;\n}\n.offset-sm-3 {\n    margin-left: 25%;\n}\n.offset-sm-4 {\n    margin-left: 33.33333%;\n}\n.offset-sm-5 {\n    margin-left: 41.66667%;\n}\n.offset-sm-6 {\n    margin-left: 50%;\n}\n.offset-sm-7 {\n    margin-left: 58.33333%;\n}\n.offset-sm-8 {\n    margin-left: 66.66667%;\n}\n.offset-sm-9 {\n    margin-left: 75%;\n}\n.offset-sm-10 {\n    margin-left: 83.33333%;\n}\n.offset-sm-11 {\n    margin-left: 91.66667%;\n}\n}\n@media (min-width: 768px) {\n.col-md {\n    -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    max-width: 100%;\n}\n.col-md-auto {\n    -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n    width: auto;\n}\n.col-md-1 {\n    -ms-flex: 0 0 8.33333%;\n        flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n}\n.col-md-2 {\n    -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n}\n.col-md-3 {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n    max-width: 25%;\n}\n.col-md-4 {\n    -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n}\n.col-md-5 {\n    -ms-flex: 0 0 41.66667%;\n        flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n}\n.col-md-6 {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n}\n.col-md-7 {\n    -ms-flex: 0 0 58.33333%;\n        flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n}\n.col-md-8 {\n    -ms-flex: 0 0 66.66667%;\n        flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n}\n.col-md-9 {\n    -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n    max-width: 75%;\n}\n.col-md-10 {\n    -ms-flex: 0 0 83.33333%;\n        flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n}\n.col-md-11 {\n    -ms-flex: 0 0 91.66667%;\n        flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n}\n.col-md-12 {\n    -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n    max-width: 100%;\n}\n.pull-md-0 {\n    right: auto;\n}\n.pull-md-1 {\n    right: 8.33333%;\n}\n.pull-md-2 {\n    right: 16.66667%;\n}\n.pull-md-3 {\n    right: 25%;\n}\n.pull-md-4 {\n    right: 33.33333%;\n}\n.pull-md-5 {\n    right: 41.66667%;\n}\n.pull-md-6 {\n    right: 50%;\n}\n.pull-md-7 {\n    right: 58.33333%;\n}\n.pull-md-8 {\n    right: 66.66667%;\n}\n.pull-md-9 {\n    right: 75%;\n}\n.pull-md-10 {\n    right: 83.33333%;\n}\n.pull-md-11 {\n    right: 91.66667%;\n}\n.pull-md-12 {\n    right: 100%;\n}\n.push-md-0 {\n    left: auto;\n}\n.push-md-1 {\n    left: 8.33333%;\n}\n.push-md-2 {\n    left: 16.66667%;\n}\n.push-md-3 {\n    left: 25%;\n}\n.push-md-4 {\n    left: 33.33333%;\n}\n.push-md-5 {\n    left: 41.66667%;\n}\n.push-md-6 {\n    left: 50%;\n}\n.push-md-7 {\n    left: 58.33333%;\n}\n.push-md-8 {\n    left: 66.66667%;\n}\n.push-md-9 {\n    left: 75%;\n}\n.push-md-10 {\n    left: 83.33333%;\n}\n.push-md-11 {\n    left: 91.66667%;\n}\n.push-md-12 {\n    left: 100%;\n}\n.offset-md-0 {\n    margin-left: 0%;\n}\n.offset-md-1 {\n    margin-left: 8.33333%;\n}\n.offset-md-2 {\n    margin-left: 16.66667%;\n}\n.offset-md-3 {\n    margin-left: 25%;\n}\n.offset-md-4 {\n    margin-left: 33.33333%;\n}\n.offset-md-5 {\n    margin-left: 41.66667%;\n}\n.offset-md-6 {\n    margin-left: 50%;\n}\n.offset-md-7 {\n    margin-left: 58.33333%;\n}\n.offset-md-8 {\n    margin-left: 66.66667%;\n}\n.offset-md-9 {\n    margin-left: 75%;\n}\n.offset-md-10 {\n    margin-left: 83.33333%;\n}\n.offset-md-11 {\n    margin-left: 91.66667%;\n}\n}\n@media (min-width: 992px) {\n.col-lg {\n    -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    max-width: 100%;\n}\n.col-lg-auto {\n    -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n    width: auto;\n}\n.col-lg-1 {\n    -ms-flex: 0 0 8.33333%;\n        flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n}\n.col-lg-2 {\n    -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n}\n.col-lg-3 {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n    max-width: 25%;\n}\n.col-lg-4 {\n    -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n}\n.col-lg-5 {\n    -ms-flex: 0 0 41.66667%;\n        flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n}\n.col-lg-6 {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n}\n.col-lg-7 {\n    -ms-flex: 0 0 58.33333%;\n        flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n}\n.col-lg-8 {\n    -ms-flex: 0 0 66.66667%;\n        flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n}\n.col-lg-9 {\n    -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n    max-width: 75%;\n}\n.col-lg-10 {\n    -ms-flex: 0 0 83.33333%;\n        flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n}\n.col-lg-11 {\n    -ms-flex: 0 0 91.66667%;\n        flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n}\n.col-lg-12 {\n    -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n    max-width: 100%;\n}\n.pull-lg-0 {\n    right: auto;\n}\n.pull-lg-1 {\n    right: 8.33333%;\n}\n.pull-lg-2 {\n    right: 16.66667%;\n}\n.pull-lg-3 {\n    right: 25%;\n}\n.pull-lg-4 {\n    right: 33.33333%;\n}\n.pull-lg-5 {\n    right: 41.66667%;\n}\n.pull-lg-6 {\n    right: 50%;\n}\n.pull-lg-7 {\n    right: 58.33333%;\n}\n.pull-lg-8 {\n    right: 66.66667%;\n}\n.pull-lg-9 {\n    right: 75%;\n}\n.pull-lg-10 {\n    right: 83.33333%;\n}\n.pull-lg-11 {\n    right: 91.66667%;\n}\n.pull-lg-12 {\n    right: 100%;\n}\n.push-lg-0 {\n    left: auto;\n}\n.push-lg-1 {\n    left: 8.33333%;\n}\n.push-lg-2 {\n    left: 16.66667%;\n}\n.push-lg-3 {\n    left: 25%;\n}\n.push-lg-4 {\n    left: 33.33333%;\n}\n.push-lg-5 {\n    left: 41.66667%;\n}\n.push-lg-6 {\n    left: 50%;\n}\n.push-lg-7 {\n    left: 58.33333%;\n}\n.push-lg-8 {\n    left: 66.66667%;\n}\n.push-lg-9 {\n    left: 75%;\n}\n.push-lg-10 {\n    left: 83.33333%;\n}\n.push-lg-11 {\n    left: 91.66667%;\n}\n.push-lg-12 {\n    left: 100%;\n}\n.offset-lg-0 {\n    margin-left: 0%;\n}\n.offset-lg-1 {\n    margin-left: 8.33333%;\n}\n.offset-lg-2 {\n    margin-left: 16.66667%;\n}\n.offset-lg-3 {\n    margin-left: 25%;\n}\n.offset-lg-4 {\n    margin-left: 33.33333%;\n}\n.offset-lg-5 {\n    margin-left: 41.66667%;\n}\n.offset-lg-6 {\n    margin-left: 50%;\n}\n.offset-lg-7 {\n    margin-left: 58.33333%;\n}\n.offset-lg-8 {\n    margin-left: 66.66667%;\n}\n.offset-lg-9 {\n    margin-left: 75%;\n}\n.offset-lg-10 {\n    margin-left: 83.33333%;\n}\n.offset-lg-11 {\n    margin-left: 91.66667%;\n}\n}\n@media (min-width: 1200px) {\n.col-xl {\n    -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    max-width: 100%;\n}\n.col-xl-auto {\n    -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n    width: auto;\n}\n.col-xl-1 {\n    -ms-flex: 0 0 8.33333%;\n        flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n}\n.col-xl-2 {\n    -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n}\n.col-xl-3 {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n    max-width: 25%;\n}\n.col-xl-4 {\n    -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n}\n.col-xl-5 {\n    -ms-flex: 0 0 41.66667%;\n        flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n}\n.col-xl-6 {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n}\n.col-xl-7 {\n    -ms-flex: 0 0 58.33333%;\n        flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n}\n.col-xl-8 {\n    -ms-flex: 0 0 66.66667%;\n        flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n}\n.col-xl-9 {\n    -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n    max-width: 75%;\n}\n.col-xl-10 {\n    -ms-flex: 0 0 83.33333%;\n        flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n}\n.col-xl-11 {\n    -ms-flex: 0 0 91.66667%;\n        flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n}\n.col-xl-12 {\n    -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n    max-width: 100%;\n}\n.pull-xl-0 {\n    right: auto;\n}\n.pull-xl-1 {\n    right: 8.33333%;\n}\n.pull-xl-2 {\n    right: 16.66667%;\n}\n.pull-xl-3 {\n    right: 25%;\n}\n.pull-xl-4 {\n    right: 33.33333%;\n}\n.pull-xl-5 {\n    right: 41.66667%;\n}\n.pull-xl-6 {\n    right: 50%;\n}\n.pull-xl-7 {\n    right: 58.33333%;\n}\n.pull-xl-8 {\n    right: 66.66667%;\n}\n.pull-xl-9 {\n    right: 75%;\n}\n.pull-xl-10 {\n    right: 83.33333%;\n}\n.pull-xl-11 {\n    right: 91.66667%;\n}\n.pull-xl-12 {\n    right: 100%;\n}\n.push-xl-0 {\n    left: auto;\n}\n.push-xl-1 {\n    left: 8.33333%;\n}\n.push-xl-2 {\n    left: 16.66667%;\n}\n.push-xl-3 {\n    left: 25%;\n}\n.push-xl-4 {\n    left: 33.33333%;\n}\n.push-xl-5 {\n    left: 41.66667%;\n}\n.push-xl-6 {\n    left: 50%;\n}\n.push-xl-7 {\n    left: 58.33333%;\n}\n.push-xl-8 {\n    left: 66.66667%;\n}\n.push-xl-9 {\n    left: 75%;\n}\n.push-xl-10 {\n    left: 83.33333%;\n}\n.push-xl-11 {\n    left: 91.66667%;\n}\n.push-xl-12 {\n    left: 100%;\n}\n.offset-xl-0 {\n    margin-left: 0%;\n}\n.offset-xl-1 {\n    margin-left: 8.33333%;\n}\n.offset-xl-2 {\n    margin-left: 16.66667%;\n}\n.offset-xl-3 {\n    margin-left: 25%;\n}\n.offset-xl-4 {\n    margin-left: 33.33333%;\n}\n.offset-xl-5 {\n    margin-left: 41.66667%;\n}\n.offset-xl-6 {\n    margin-left: 50%;\n}\n.offset-xl-7 {\n    margin-left: 58.33333%;\n}\n.offset-xl-8 {\n    margin-left: 66.66667%;\n}\n.offset-xl-9 {\n    margin-left: 75%;\n}\n.offset-xl-10 {\n    margin-left: 83.33333%;\n}\n.offset-xl-11 {\n    margin-left: 91.66667%;\n}\n}\n.table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 1rem;\n}\n.table th,\n  .table td {\n    padding: 0.75rem;\n    vertical-align: top;\n    border-top: 1px solid #eceeef;\n}\n.table thead th {\n    vertical-align: bottom;\n    border-bottom: 2px solid #eceeef;\n}\n.table tbody + tbody {\n    border-top: 2px solid #eceeef;\n}\n.table .table {\n    background-color: #fff;\n}\n.table-sm th,\n.table-sm td {\n  padding: 0.3rem;\n}\n.table-bordered {\n  border: 1px solid #eceeef;\n}\n.table-bordered th,\n  .table-bordered td {\n    border: 1px solid #eceeef;\n}\n.table-bordered thead th,\n  .table-bordered thead td {\n    border-bottom-width: 2px;\n}\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.table-hover tbody tr:hover {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n.table-active,\n.table-active > th,\n.table-active > td {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n.table-hover .table-active:hover {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n.table-hover .table-active:hover > td,\n  .table-hover .table-active:hover > th {\n    background-color: rgba(0, 0, 0, 0.075);\n}\n.table-success,\n.table-success > th,\n.table-success > td {\n  background-color: #dff0d8;\n}\n.table-hover .table-success:hover {\n  background-color: #d0e9c6;\n}\n.table-hover .table-success:hover > td,\n  .table-hover .table-success:hover > th {\n    background-color: #d0e9c6;\n}\n.table-info,\n.table-info > th,\n.table-info > td {\n  background-color: #d9edf7;\n}\n.table-hover .table-info:hover {\n  background-color: #c4e3f3;\n}\n.table-hover .table-info:hover > td,\n  .table-hover .table-info:hover > th {\n    background-color: #c4e3f3;\n}\n.table-warning,\n.table-warning > th,\n.table-warning > td {\n  background-color: #fcf8e3;\n}\n.table-hover .table-warning:hover {\n  background-color: #faf2cc;\n}\n.table-hover .table-warning:hover > td,\n  .table-hover .table-warning:hover > th {\n    background-color: #faf2cc;\n}\n.table-danger,\n.table-danger > th,\n.table-danger > td {\n  background-color: #f2dede;\n}\n.table-hover .table-danger:hover {\n  background-color: #ebcccc;\n}\n.table-hover .table-danger:hover > td,\n  .table-hover .table-danger:hover > th {\n    background-color: #ebcccc;\n}\n.thead-inverse th {\n  color: #fff;\n  background-color: #292b2c;\n}\n.thead-default th {\n  color: #464a4c;\n  background-color: #eceeef;\n}\n.table-inverse {\n  color: #fff;\n  background-color: #292b2c;\n}\n.table-inverse th,\n  .table-inverse td,\n  .table-inverse thead th {\n    border-color: #fff;\n}\n.table-inverse.table-bordered {\n    border: 0;\n}\n.table-responsive {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.table-responsive.table-bordered {\n    border: 0;\n}\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.25;\n  color: #464a4c;\n  background-color: #fff;\n  background-image: none;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n.form-control::-ms-expand {\n    background-color: transparent;\n    border: 0;\n}\n.form-control:focus {\n    color: #464a4c;\n    background-color: #fff;\n    border-color: #5cb3fd;\n    outline: none;\n}\n.form-control:-ms-input-placeholder {\n    color: #636c72;\n    opacity: 1;\n}\n.form-control::placeholder {\n    color: #636c72;\n    opacity: 1;\n}\n.form-control:disabled, .form-control[readonly] {\n    background-color: #eceeef;\n    opacity: 1;\n}\n.form-control:disabled {\n    cursor: not-allowed;\n}\nselect.form-control:not([size]):not([multiple]) {\n  height: calc(2.25rem + 2px);\n}\nselect.form-control:focus::-ms-value {\n  color: #464a4c;\n  background-color: #fff;\n}\n.form-control-file,\n.form-control-range {\n  display: block;\n}\n.col-form-label {\n  padding-top: calc(0.5rem - 1px * 2);\n  padding-bottom: calc(0.5rem - 1px * 2);\n  margin-bottom: 0;\n}\n.col-form-label-lg {\n  padding-top: calc(0.75rem - 1px * 2);\n  padding-bottom: calc(0.75rem - 1px * 2);\n  font-size: 1.25rem;\n}\n.col-form-label-sm {\n  padding-top: calc(0.25rem - 1px * 2);\n  padding-bottom: calc(0.25rem - 1px * 2);\n  font-size: 0.875rem;\n}\n.col-form-legend {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n}\n.form-control-static {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  margin-bottom: 0;\n  line-height: 1.25;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-static.form-control-sm, .input-group-sm > .form-control-static.form-control,\n  .input-group-sm > .form-control-static.input-group-addon,\n  .input-group-sm > .input-group-btn > .form-control-static.btn, .form-control-static.form-control-lg, .input-group-lg > .form-control-static.form-control,\n  .input-group-lg > .form-control-static.input-group-addon,\n  .input-group-lg > .input-group-btn > .form-control-static.btn {\n    padding-right: 0;\n    padding-left: 0;\n}\n.form-control-sm, .input-group-sm > .form-control,\n.input-group-sm > .input-group-addon,\n.input-group-sm > .input-group-btn > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: 0.2rem;\n}\nselect.form-control-sm:not([size]):not([multiple]), .input-group-sm > select.form-control:not([size]):not([multiple]),\n.input-group-sm > select.input-group-addon:not([size]):not([multiple]),\n.input-group-sm > .input-group-btn > select.btn:not([size]):not([multiple]) {\n  height: 1.8125rem;\n}\n.form-control-lg, .input-group-lg > .form-control,\n.input-group-lg > .input-group-addon,\n.input-group-lg > .input-group-btn > .btn {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.25rem;\n  border-radius: 0.3rem;\n}\nselect.form-control-lg:not([size]):not([multiple]), .input-group-lg > select.form-control:not([size]):not([multiple]),\n.input-group-lg > select.input-group-addon:not([size]):not([multiple]),\n.input-group-lg > .input-group-btn > select.btn:not([size]):not([multiple]) {\n  height: 3.16667rem;\n}\n.form-group {\n  margin-bottom: 1rem;\n}\n.form-text {\n  display: block;\n  margin-top: 0.25rem;\n}\n.form-check {\n  position: relative;\n  display: block;\n  margin-bottom: 0.5rem;\n}\n.form-check.disabled .form-check-label {\n    color: #636c72;\n    cursor: not-allowed;\n}\n.form-check-label {\n  padding-left: 1.25rem;\n  margin-bottom: 0;\n  cursor: pointer;\n}\n.form-check-input {\n  position: absolute;\n  margin-top: 0.25rem;\n  margin-left: -1.25rem;\n}\n.form-check-input:only-child {\n    position: static;\n}\n.form-check-inline {\n  display: inline-block;\n}\n.form-check-inline .form-check-label {\n    vertical-align: middle;\n}\n.form-check-inline + .form-check-inline {\n    margin-left: 0.75rem;\n}\n.form-control-feedback {\n  margin-top: 0.25rem;\n}\n.form-control-success,\n.form-control-warning,\n.form-control-danger {\n  padding-right: 2.25rem;\n  background-repeat: no-repeat;\n  background-position: center right 0.5625rem;\n  background-size: 1.125rem 1.125rem;\n}\n.has-success .form-control-feedback,\n.has-success .form-control-label,\n.has-success .col-form-label,\n.has-success .form-check-label,\n.has-success .custom-control {\n  color: #5cb85c;\n}\n.has-success .form-control {\n  border-color: #5cb85c;\n}\n.has-success .input-group-addon {\n  color: #5cb85c;\n  border-color: #5cb85c;\n  background-color: #eaf6ea;\n}\n.has-success .form-control-success {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%235cb85c' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");\n}\n.has-warning .form-control-feedback,\n.has-warning .form-control-label,\n.has-warning .col-form-label,\n.has-warning .form-check-label,\n.has-warning .custom-control {\n  color: #f0ad4e;\n}\n.has-warning .form-control {\n  border-color: #f0ad4e;\n}\n.has-warning .input-group-addon {\n  color: #f0ad4e;\n  border-color: #f0ad4e;\n  background-color: white;\n}\n.has-warning .form-control-warning {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23f0ad4e' d='M4.4 5.324h-.8v-2.46h.8zm0 1.42h-.8V5.89h.8zM3.76.63L.04 7.075c-.115.2.016.425.26.426h7.397c.242 0 .372-.226.258-.426C6.726 4.924 5.47 2.79 4.253.63c-.113-.174-.39-.174-.494 0z'/%3E%3C/svg%3E\");\n}\n.has-danger .form-control-feedback,\n.has-danger .form-control-label,\n.has-danger .col-form-label,\n.has-danger .form-check-label,\n.has-danger .custom-control {\n  color: #d9534f;\n}\n.has-danger .form-control {\n  border-color: #d9534f;\n}\n.has-danger .input-group-addon {\n  color: #d9534f;\n  border-color: #d9534f;\n  background-color: #fdf7f7;\n}\n.has-danger .form-control-danger {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23d9534f' viewBox='-2 -2 7 7'%3E%3Cpath stroke='%23d9534f' d='M0 0l3 3m0-3L0 3'/%3E%3Ccircle r='.5'/%3E%3Ccircle cx='3' r='.5'/%3E%3Ccircle cy='3' r='.5'/%3E%3Ccircle cx='3' cy='3' r='.5'/%3E%3C/svg%3E\");\n}\n.form-inline {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row wrap;\n      flex-flow: row wrap;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.form-inline .form-check {\n    width: 100%;\n}\n@media (min-width: 576px) {\n.form-inline label {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n      margin-bottom: 0;\n}\n.form-inline .form-group {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n      -ms-flex-flow: row wrap;\n          flex-flow: row wrap;\n      -ms-flex-align: center;\n          align-items: center;\n      margin-bottom: 0;\n}\n.form-inline .form-control {\n      display: inline-block;\n      width: auto;\n      vertical-align: middle;\n}\n.form-inline .form-control-static {\n      display: inline-block;\n}\n.form-inline .input-group {\n      width: auto;\n}\n.form-inline .form-control-label {\n      margin-bottom: 0;\n      vertical-align: middle;\n}\n.form-inline .form-check {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n      width: auto;\n      margin-top: 0;\n      margin-bottom: 0;\n}\n.form-inline .form-check-label {\n      padding-left: 0;\n}\n.form-inline .form-check-input {\n      position: relative;\n      margin-top: 0;\n      margin-right: 0.25rem;\n      margin-left: 0;\n}\n.form-inline .custom-control {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n      padding-left: 0;\n}\n.form-inline .custom-control-indicator {\n      position: static;\n      display: inline-block;\n      margin-right: 0.25rem;\n      vertical-align: text-bottom;\n}\n.form-inline .has-feedback .form-control-feedback {\n      top: 0;\n}\n}\n.btn {\n  display: inline-block;\n  font-weight: normal;\n  line-height: 1.25;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  border: 1px solid transparent;\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n  border-radius: 0.25rem;\n  transition: all 0.2s ease-in-out;\n}\n.btn:focus, .btn:hover {\n    text-decoration: none;\n}\n.btn:focus, .btn.focus {\n    outline: 0;\n    box-shadow: 0 0 0 2px rgba(2, 117, 216, 0.25);\n}\n.btn.disabled, .btn:disabled {\n    cursor: not-allowed;\n    opacity: .65;\n}\n.btn:active, .btn.active {\n    background-image: none;\n}\na.btn.disabled,\nfieldset[disabled] a.btn {\n  pointer-events: none;\n}\n.btn-primary {\n  color: #fff;\n  background-color: #0275d8;\n  border-color: #0275d8;\n}\n.btn-primary:hover {\n    color: #fff;\n    background-color: #025aa5;\n    border-color: #01549b;\n}\n.btn-primary:focus, .btn-primary.focus {\n    box-shadow: 0 0 0 2px rgba(2, 117, 216, 0.5);\n}\n.btn-primary.disabled, .btn-primary:disabled {\n    background-color: #0275d8;\n    border-color: #0275d8;\n}\n.btn-primary:active, .btn-primary.active,\n  .show > .btn-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #025aa5;\n    background-image: none;\n    border-color: #01549b;\n}\n.btn-secondary {\n  color: #292b2c;\n  background-color: #fff;\n  border-color: #ccc;\n}\n.btn-secondary:hover {\n    color: #292b2c;\n    background-color: #e6e6e6;\n    border-color: #adadad;\n}\n.btn-secondary:focus, .btn-secondary.focus {\n    box-shadow: 0 0 0 2px rgba(204, 204, 204, 0.5);\n}\n.btn-secondary.disabled, .btn-secondary:disabled {\n    background-color: #fff;\n    border-color: #ccc;\n}\n.btn-secondary:active, .btn-secondary.active,\n  .show > .btn-secondary.dropdown-toggle {\n    color: #292b2c;\n    background-color: #e6e6e6;\n    background-image: none;\n    border-color: #adadad;\n}\n.btn-info {\n  color: #fff;\n  background-color: #5bc0de;\n  border-color: #5bc0de;\n}\n.btn-info:hover {\n    color: #fff;\n    background-color: #31b0d5;\n    border-color: #2aabd2;\n}\n.btn-info:focus, .btn-info.focus {\n    box-shadow: 0 0 0 2px rgba(91, 192, 222, 0.5);\n}\n.btn-info.disabled, .btn-info:disabled {\n    background-color: #5bc0de;\n    border-color: #5bc0de;\n}\n.btn-info:active, .btn-info.active,\n  .show > .btn-info.dropdown-toggle {\n    color: #fff;\n    background-color: #31b0d5;\n    background-image: none;\n    border-color: #2aabd2;\n}\n.btn-success {\n  color: #fff;\n  background-color: #5cb85c;\n  border-color: #5cb85c;\n}\n.btn-success:hover {\n    color: #fff;\n    background-color: #449d44;\n    border-color: #419641;\n}\n.btn-success:focus, .btn-success.focus {\n    box-shadow: 0 0 0 2px rgba(92, 184, 92, 0.5);\n}\n.btn-success.disabled, .btn-success:disabled {\n    background-color: #5cb85c;\n    border-color: #5cb85c;\n}\n.btn-success:active, .btn-success.active,\n  .show > .btn-success.dropdown-toggle {\n    color: #fff;\n    background-color: #449d44;\n    background-image: none;\n    border-color: #419641;\n}\n.btn-warning {\n  color: #fff;\n  background-color: #f0ad4e;\n  border-color: #f0ad4e;\n}\n.btn-warning:hover {\n    color: #fff;\n    background-color: #ec971f;\n    border-color: #eb9316;\n}\n.btn-warning:focus, .btn-warning.focus {\n    box-shadow: 0 0 0 2px rgba(240, 173, 78, 0.5);\n}\n.btn-warning.disabled, .btn-warning:disabled {\n    background-color: #f0ad4e;\n    border-color: #f0ad4e;\n}\n.btn-warning:active, .btn-warning.active,\n  .show > .btn-warning.dropdown-toggle {\n    color: #fff;\n    background-color: #ec971f;\n    background-image: none;\n    border-color: #eb9316;\n}\n.btn-danger {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d9534f;\n}\n.btn-danger:hover {\n    color: #fff;\n    background-color: #c9302c;\n    border-color: #c12e2a;\n}\n.btn-danger:focus, .btn-danger.focus {\n    box-shadow: 0 0 0 2px rgba(217, 83, 79, 0.5);\n}\n.btn-danger.disabled, .btn-danger:disabled {\n    background-color: #d9534f;\n    border-color: #d9534f;\n}\n.btn-danger:active, .btn-danger.active,\n  .show > .btn-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #c9302c;\n    background-image: none;\n    border-color: #c12e2a;\n}\n.btn-outline-primary {\n  color: #0275d8;\n  background-image: none;\n  background-color: transparent;\n  border-color: #0275d8;\n}\n.btn-outline-primary:hover {\n    color: #fff;\n    background-color: #0275d8;\n    border-color: #0275d8;\n}\n.btn-outline-primary:focus, .btn-outline-primary.focus {\n    box-shadow: 0 0 0 2px rgba(2, 117, 216, 0.5);\n}\n.btn-outline-primary.disabled, .btn-outline-primary:disabled {\n    color: #0275d8;\n    background-color: transparent;\n}\n.btn-outline-primary:active, .btn-outline-primary.active,\n  .show > .btn-outline-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #0275d8;\n    border-color: #0275d8;\n}\n.btn-outline-secondary {\n  color: #ccc;\n  background-image: none;\n  background-color: transparent;\n  border-color: #ccc;\n}\n.btn-outline-secondary:hover {\n    color: #fff;\n    background-color: #ccc;\n    border-color: #ccc;\n}\n.btn-outline-secondary:focus, .btn-outline-secondary.focus {\n    box-shadow: 0 0 0 2px rgba(204, 204, 204, 0.5);\n}\n.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {\n    color: #ccc;\n    background-color: transparent;\n}\n.btn-outline-secondary:active, .btn-outline-secondary.active,\n  .show > .btn-outline-secondary.dropdown-toggle {\n    color: #fff;\n    background-color: #ccc;\n    border-color: #ccc;\n}\n.btn-outline-info {\n  color: #5bc0de;\n  background-image: none;\n  background-color: transparent;\n  border-color: #5bc0de;\n}\n.btn-outline-info:hover {\n    color: #fff;\n    background-color: #5bc0de;\n    border-color: #5bc0de;\n}\n.btn-outline-info:focus, .btn-outline-info.focus {\n    box-shadow: 0 0 0 2px rgba(91, 192, 222, 0.5);\n}\n.btn-outline-info.disabled, .btn-outline-info:disabled {\n    color: #5bc0de;\n    background-color: transparent;\n}\n.btn-outline-info:active, .btn-outline-info.active,\n  .show > .btn-outline-info.dropdown-toggle {\n    color: #fff;\n    background-color: #5bc0de;\n    border-color: #5bc0de;\n}\n.btn-outline-success {\n  color: #5cb85c;\n  background-image: none;\n  background-color: transparent;\n  border-color: #5cb85c;\n}\n.btn-outline-success:hover {\n    color: #fff;\n    background-color: #5cb85c;\n    border-color: #5cb85c;\n}\n.btn-outline-success:focus, .btn-outline-success.focus {\n    box-shadow: 0 0 0 2px rgba(92, 184, 92, 0.5);\n}\n.btn-outline-success.disabled, .btn-outline-success:disabled {\n    color: #5cb85c;\n    background-color: transparent;\n}\n.btn-outline-success:active, .btn-outline-success.active,\n  .show > .btn-outline-success.dropdown-toggle {\n    color: #fff;\n    background-color: #5cb85c;\n    border-color: #5cb85c;\n}\n.btn-outline-warning {\n  color: #f0ad4e;\n  background-image: none;\n  background-color: transparent;\n  border-color: #f0ad4e;\n}\n.btn-outline-warning:hover {\n    color: #fff;\n    background-color: #f0ad4e;\n    border-color: #f0ad4e;\n}\n.btn-outline-warning:focus, .btn-outline-warning.focus {\n    box-shadow: 0 0 0 2px rgba(240, 173, 78, 0.5);\n}\n.btn-outline-warning.disabled, .btn-outline-warning:disabled {\n    color: #f0ad4e;\n    background-color: transparent;\n}\n.btn-outline-warning:active, .btn-outline-warning.active,\n  .show > .btn-outline-warning.dropdown-toggle {\n    color: #fff;\n    background-color: #f0ad4e;\n    border-color: #f0ad4e;\n}\n.btn-outline-danger {\n  color: #d9534f;\n  background-image: none;\n  background-color: transparent;\n  border-color: #d9534f;\n}\n.btn-outline-danger:hover {\n    color: #fff;\n    background-color: #d9534f;\n    border-color: #d9534f;\n}\n.btn-outline-danger:focus, .btn-outline-danger.focus {\n    box-shadow: 0 0 0 2px rgba(217, 83, 79, 0.5);\n}\n.btn-outline-danger.disabled, .btn-outline-danger:disabled {\n    color: #d9534f;\n    background-color: transparent;\n}\n.btn-outline-danger:active, .btn-outline-danger.active,\n  .show > .btn-outline-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #d9534f;\n    border-color: #d9534f;\n}\n.btn-link {\n  font-weight: normal;\n  color: #0275d8;\n  border-radius: 0;\n}\n.btn-link, .btn-link:active, .btn-link.active, .btn-link:disabled {\n    background-color: transparent;\n}\n.btn-link, .btn-link:focus, .btn-link:active {\n    border-color: transparent;\n}\n.btn-link:hover {\n    border-color: transparent;\n}\n.btn-link:focus, .btn-link:hover {\n    color: #014c8c;\n    text-decoration: underline;\n    background-color: transparent;\n}\n.btn-link:disabled {\n    color: #636c72;\n}\n.btn-link:disabled:focus, .btn-link:disabled:hover {\n      text-decoration: none;\n}\n.btn-lg, .btn-group-lg > .btn {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.25rem;\n  border-radius: 0.3rem;\n}\n.btn-sm, .btn-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: 0.2rem;\n}\n.btn-block {\n  display: block;\n  width: 100%;\n}\n.btn-block + .btn-block {\n  margin-top: 0.5rem;\n}\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%;\n}\n.fade {\n  opacity: 0;\n  transition: opacity 0.15s linear;\n}\n.fade.show {\n    opacity: 1;\n}\n.collapse {\n  display: none;\n}\n.collapse.show {\n    display: block;\n}\ntr.collapse.show {\n  display: table-row;\n}\ntbody.collapse.show {\n  display: table-row-group;\n}\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n.dropup,\n.dropdown {\n  position: relative;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.3em;\n  vertical-align: middle;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:focus {\n  outline: 0;\n}\n.dropup .dropdown-toggle::after {\n  border-top: 0;\n  border-bottom: 0.3em solid;\n}\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 1rem;\n  color: #292b2c;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n}\n.dropdown-divider {\n  height: 1px;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  background-color: #eceeef;\n}\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 3px 1.5rem;\n  clear: both;\n  font-weight: normal;\n  color: #292b2c;\n  text-align: inherit;\n  white-space: nowrap;\n  background: none;\n  border: 0;\n}\n.dropdown-item:focus, .dropdown-item:hover {\n    color: #1d1e1f;\n    text-decoration: none;\n    background-color: #f7f7f9;\n}\n.dropdown-item.active, .dropdown-item:active {\n    color: #fff;\n    text-decoration: none;\n    background-color: #0275d8;\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n    color: #636c72;\n    cursor: not-allowed;\n    background-color: transparent;\n}\n.show > .dropdown-menu {\n  display: block;\n}\n.show > a {\n  outline: 0;\n}\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n.dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n.dropdown-header {\n  display: block;\n  padding: 0.5rem 1.5rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: #636c72;\n  white-space: nowrap;\n}\n.dropdown-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 990;\n}\n.dropup .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-bottom: 0.125rem;\n}\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n  .btn-group-vertical > .btn {\n    position: relative;\n    -ms-flex: 0 1 auto;\n        flex: 0 1 auto;\n}\n.btn-group > .btn:hover,\n    .btn-group-vertical > .btn:hover {\n      z-index: 2;\n}\n.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,\n    .btn-group-vertical > .btn:focus,\n    .btn-group-vertical > .btn:active,\n    .btn-group-vertical > .btn.active {\n      z-index: 2;\n}\n.btn-group .btn + .btn,\n  .btn-group .btn + .btn-group,\n  .btn-group .btn-group + .btn,\n  .btn-group .btn-group + .btn-group,\n  .btn-group-vertical .btn + .btn,\n  .btn-group-vertical .btn + .btn-group,\n  .btn-group-vertical .btn-group + .btn,\n  .btn-group-vertical .btn-group + .btn-group {\n    margin-left: -1px;\n}\n.btn-toolbar {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n    width: auto;\n}\n.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0;\n}\n.btn-group > .btn:first-child {\n  margin-left: 0;\n}\n.btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n}\n.btn-group > .btn:last-child:not(:first-child),\n.btn-group > .dropdown-toggle:not(:first-child) {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.btn-group > .btn-group {\n  float: left;\n}\n.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group > .btn-group:first-child:not(:last-child) > .btn:last-child,\n.btn-group > .btn-group:first-child:not(:last-child) > .dropdown-toggle {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.btn-group > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.btn-group .dropdown-toggle:active,\n.btn-group.open .dropdown-toggle {\n  outline: 0;\n}\n.btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n.btn + .dropdown-toggle-split::after {\n    margin-left: 0;\n}\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 1.125rem;\n  padding-left: 1.125rem;\n}\n.btn-group-vertical {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.btn-group-vertical .btn,\n  .btn-group-vertical .btn-group {\n    width: 100%;\n}\n.btn-group-vertical > .btn + .btn,\n  .btn-group-vertical > .btn + .btn-group,\n  .btn-group-vertical > .btn-group + .btn,\n  .btn-group-vertical > .btn-group + .btn-group {\n    margin-top: -1px;\n    margin-left: 0;\n}\n.btn-group-vertical > .btn:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.btn-group-vertical > .btn:first-child:not(:last-child) {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn:last-child:not(:first-child) {\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group-vertical > .btn-group:first-child:not(:last-child) > .btn:last-child,\n.btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n[data-toggle=\"buttons\"] > .btn input[type=\"radio\"],\n[data-toggle=\"buttons\"] > .btn input[type=\"checkbox\"],\n[data-toggle=\"buttons\"] > .btn-group > .btn input[type=\"radio\"],\n[data-toggle=\"buttons\"] > .btn-group > .btn input[type=\"checkbox\"] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.input-group {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.input-group .form-control {\n    position: relative;\n    z-index: 2;\n    -ms-flex: 1 1 auto;\n        flex: 1 1 auto;\n    width: 1%;\n    margin-bottom: 0;\n}\n.input-group .form-control:focus, .input-group .form-control:active, .input-group .form-control:hover {\n      z-index: 3;\n}\n.input-group-addon,\n.input-group-btn,\n.input-group .form-control {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.input-group-addon:not(:first-child):not(:last-child),\n  .input-group-btn:not(:first-child):not(:last-child),\n  .input-group .form-control:not(:first-child):not(:last-child) {\n    border-radius: 0;\n}\n.input-group-addon,\n.input-group-btn {\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.input-group-addon {\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  font-weight: normal;\n  line-height: 1.25;\n  color: #464a4c;\n  text-align: center;\n  background-color: #eceeef;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n}\n.input-group-addon.form-control-sm,\n  .input-group-sm > .input-group-addon,\n  .input-group-sm > .input-group-btn > .input-group-addon.btn {\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n    border-radius: 0.2rem;\n}\n.input-group-addon.form-control-lg,\n  .input-group-lg > .input-group-addon,\n  .input-group-lg > .input-group-btn > .input-group-addon.btn {\n    padding: 0.75rem 1.5rem;\n    font-size: 1.25rem;\n    border-radius: 0.3rem;\n}\n.input-group-addon input[type=\"radio\"],\n  .input-group-addon input[type=\"checkbox\"] {\n    margin-top: 0;\n}\n.input-group .form-control:not(:last-child),\n.input-group-addon:not(:last-child),\n.input-group-btn:not(:last-child) > .btn,\n.input-group-btn:not(:last-child) > .btn-group > .btn,\n.input-group-btn:not(:last-child) > .dropdown-toggle,\n.input-group-btn:not(:first-child) > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group-btn:not(:first-child) > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.input-group-addon:not(:last-child) {\n  border-right: 0;\n}\n.input-group .form-control:not(:first-child),\n.input-group-addon:not(:first-child),\n.input-group-btn:not(:first-child) > .btn,\n.input-group-btn:not(:first-child) > .btn-group > .btn,\n.input-group-btn:not(:first-child) > .dropdown-toggle,\n.input-group-btn:not(:last-child) > .btn:not(:first-child),\n.input-group-btn:not(:last-child) > .btn-group:not(:first-child) > .btn {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.form-control + .input-group-addon:not(:first-child) {\n  border-left: 0;\n}\n.input-group-btn {\n  position: relative;\n  font-size: 0;\n  white-space: nowrap;\n}\n.input-group-btn > .btn {\n    position: relative;\n    -ms-flex: 1;\n        flex: 1;\n}\n.input-group-btn > .btn + .btn {\n      margin-left: -1px;\n}\n.input-group-btn > .btn:focus, .input-group-btn > .btn:active, .input-group-btn > .btn:hover {\n      z-index: 3;\n}\n.input-group-btn:not(:last-child) > .btn,\n  .input-group-btn:not(:last-child) > .btn-group {\n    margin-right: -1px;\n}\n.input-group-btn:not(:first-child) > .btn,\n  .input-group-btn:not(:first-child) > .btn-group {\n    z-index: 2;\n    margin-left: -1px;\n}\n.input-group-btn:not(:first-child) > .btn:focus, .input-group-btn:not(:first-child) > .btn:active, .input-group-btn:not(:first-child) > .btn:hover,\n    .input-group-btn:not(:first-child) > .btn-group:focus,\n    .input-group-btn:not(:first-child) > .btn-group:active,\n    .input-group-btn:not(:first-child) > .btn-group:hover {\n      z-index: 3;\n}\n.custom-control {\n  position: relative;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  min-height: 1.5rem;\n  padding-left: 1.5rem;\n  margin-right: 1rem;\n  cursor: pointer;\n}\n.custom-control-input {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n}\n.custom-control-input:checked ~ .custom-control-indicator {\n    color: #fff;\n    background-color: #0275d8;\n}\n.custom-control-input:focus ~ .custom-control-indicator {\n    box-shadow: 0 0 0 1px #fff, 0 0 0 3px #0275d8;\n}\n.custom-control-input:active ~ .custom-control-indicator {\n    color: #fff;\n    background-color: #8fcafe;\n}\n.custom-control-input:disabled ~ .custom-control-indicator {\n    cursor: not-allowed;\n    background-color: #eceeef;\n}\n.custom-control-input:disabled ~ .custom-control-description {\n    color: #636c72;\n    cursor: not-allowed;\n}\n.custom-control-indicator {\n  position: absolute;\n  top: 0.25rem;\n  left: 0;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  pointer-events: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  background-color: #ddd;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 50% 50%;\n}\n.custom-checkbox .custom-control-indicator {\n  border-radius: 0.25rem;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-indicator {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\");\n}\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-indicator {\n  background-color: #0275d8;\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E\");\n}\n.custom-radio .custom-control-indicator {\n  border-radius: 50%;\n}\n.custom-radio .custom-control-input:checked ~ .custom-control-indicator {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\");\n}\n.custom-controls-stacked {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.custom-controls-stacked .custom-control {\n    margin-bottom: 0.25rem;\n}\n.custom-controls-stacked .custom-control + .custom-control {\n      margin-left: 0;\n}\n.custom-select {\n  display: inline-block;\n  max-width: 100%;\n  height: calc(2.25rem + 2px);\n  padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n  line-height: 1.25;\n  color: #464a4c;\n  vertical-align: middle;\n  background: #fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right 0.75rem center;\n  background-size: 8px 10px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\n.custom-select:focus {\n    border-color: #5cb3fd;\n    outline: none;\n}\n.custom-select:focus::-ms-value {\n      color: #464a4c;\n      background-color: #fff;\n}\n.custom-select:disabled {\n    color: #636c72;\n    cursor: not-allowed;\n    background-color: #eceeef;\n}\n.custom-select::-ms-expand {\n    opacity: 0;\n}\n.custom-select-sm {\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  font-size: 75%;\n}\n.custom-file {\n  position: relative;\n  display: inline-block;\n  max-width: 100%;\n  height: 2.5rem;\n  margin-bottom: 0;\n  cursor: pointer;\n}\n.custom-file-input {\n  min-width: 14rem;\n  max-width: 100%;\n  height: 2.5rem;\n  margin: 0;\n  filter: alpha(opacity=0);\n  opacity: 0;\n}\n.custom-file-control {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 5;\n  height: 2.5rem;\n  padding: 0.5rem 1rem;\n  line-height: 1.5;\n  color: #464a4c;\n  pointer-events: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n}\n.custom-file-control:lang(en)::after {\n    content: \"Choose file...\";\n}\n.custom-file-control::before {\n    position: absolute;\n    top: -1px;\n    right: -1px;\n    bottom: -1px;\n    z-index: 6;\n    display: block;\n    height: 2.5rem;\n    padding: 0.5rem 1rem;\n    line-height: 1.5;\n    color: #464a4c;\n    background-color: #eceeef;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-radius: 0 0.25rem 0.25rem 0;\n}\n.custom-file-control:lang(en)::before {\n    content: \"Browse\";\n}\n.nav {\n  display: -ms-flexbox;\n  display: flex;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.nav-link {\n  display: block;\n  padding: 0.5em 1em;\n}\n.nav-link:focus, .nav-link:hover {\n    text-decoration: none;\n}\n.nav-link.disabled {\n    color: #636c72;\n    cursor: not-allowed;\n}\n.nav-tabs {\n  border-bottom: 1px solid #ddd;\n}\n.nav-tabs .nav-item {\n    margin-bottom: -1px;\n}\n.nav-tabs .nav-link {\n    border: 1px solid transparent;\n    border-top-right-radius: 0.25rem;\n    border-top-left-radius: 0.25rem;\n}\n.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {\n      border-color: #eceeef #eceeef #ddd;\n}\n.nav-tabs .nav-link.disabled {\n      color: #636c72;\n      background-color: transparent;\n      border-color: transparent;\n}\n.nav-tabs .nav-link.active,\n  .nav-tabs .nav-item.show .nav-link {\n    color: #464a4c;\n    background-color: #fff;\n    border-color: #ddd #ddd #fff;\n}\n.nav-tabs .dropdown-menu {\n    margin-top: -1px;\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n}\n.nav-pills .nav-link {\n  border-radius: 0.25rem;\n}\n.nav-pills .nav-link.active,\n.nav-pills .nav-item.show .nav-link {\n  color: #fff;\n  cursor: default;\n  background-color: #0275d8;\n}\n.nav-fill .nav-item {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  text-align: center;\n}\n.nav-justified .nav-item {\n  -ms-flex: 1 1 100%;\n      flex: 1 1 100%;\n  text-align: center;\n}\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n.navbar {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding: 0.5rem 1rem;\n}\n.navbar-brand {\n  display: inline-block;\n  padding-top: .25rem;\n  padding-bottom: .25rem;\n  margin-right: 1rem;\n  font-size: 1.25rem;\n  line-height: inherit;\n  white-space: nowrap;\n}\n.navbar-brand:focus, .navbar-brand:hover {\n    text-decoration: none;\n}\n.navbar-nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n}\n.navbar-text {\n  display: inline-block;\n  padding-top: .425rem;\n  padding-bottom: .425rem;\n}\n.navbar-toggler {\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n  padding: 0.25rem 0.75rem;\n  font-size: 1.25rem;\n  line-height: 1;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n.navbar-toggler:focus, .navbar-toggler:hover {\n    text-decoration: none;\n}\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%;\n}\n.navbar-toggler-left {\n  position: absolute;\n  left: 1rem;\n}\n.navbar-toggler-right {\n  position: absolute;\n  right: 1rem;\n}\n@media (max-width: 575px) {\n.navbar-toggleable .navbar-nav .dropdown-menu {\n    position: static;\n    float: none;\n}\n.navbar-toggleable > .container {\n    padding-right: 0;\n    padding-left: 0;\n}\n}\n@media (min-width: 576px) {\n.navbar-toggleable {\n    -ms-flex-direction: row;\n        flex-direction: row;\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.navbar-toggleable .navbar-nav {\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n.navbar-toggleable .navbar-nav .nav-link {\n        padding-right: .5rem;\n        padding-left: .5rem;\n}\n.navbar-toggleable > .container {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: nowrap;\n          flex-wrap: nowrap;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.navbar-toggleable .navbar-collapse {\n      display: -ms-flexbox !important;\n      display: flex !important;\n      width: 100%;\n}\n.navbar-toggleable .navbar-toggler {\n      display: none;\n}\n}\n@media (max-width: 767px) {\n.navbar-toggleable-sm .navbar-nav .dropdown-menu {\n    position: static;\n    float: none;\n}\n.navbar-toggleable-sm > .container {\n    padding-right: 0;\n    padding-left: 0;\n}\n}\n@media (min-width: 768px) {\n.navbar-toggleable-sm {\n    -ms-flex-direction: row;\n        flex-direction: row;\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.navbar-toggleable-sm .navbar-nav {\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n.navbar-toggleable-sm .navbar-nav .nav-link {\n        padding-right: .5rem;\n        padding-left: .5rem;\n}\n.navbar-toggleable-sm > .container {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: nowrap;\n          flex-wrap: nowrap;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.navbar-toggleable-sm .navbar-collapse {\n      display: -ms-flexbox !important;\n      display: flex !important;\n      width: 100%;\n}\n.navbar-toggleable-sm .navbar-toggler {\n      display: none;\n}\n}\n@media (max-width: 991px) {\n.navbar-toggleable-md .navbar-nav .dropdown-menu {\n    position: static;\n    float: none;\n}\n.navbar-toggleable-md > .container {\n    padding-right: 0;\n    padding-left: 0;\n}\n}\n@media (min-width: 992px) {\n.navbar-toggleable-md {\n    -ms-flex-direction: row;\n        flex-direction: row;\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.navbar-toggleable-md .navbar-nav {\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n.navbar-toggleable-md .navbar-nav .nav-link {\n        padding-right: .5rem;\n        padding-left: .5rem;\n}\n.navbar-toggleable-md > .container {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: nowrap;\n          flex-wrap: nowrap;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.navbar-toggleable-md .navbar-collapse {\n      display: -ms-flexbox !important;\n      display: flex !important;\n      width: 100%;\n}\n.navbar-toggleable-md .navbar-toggler {\n      display: none;\n}\n}\n@media (max-width: 1199px) {\n.navbar-toggleable-lg .navbar-nav .dropdown-menu {\n    position: static;\n    float: none;\n}\n.navbar-toggleable-lg > .container {\n    padding-right: 0;\n    padding-left: 0;\n}\n}\n@media (min-width: 1200px) {\n.navbar-toggleable-lg {\n    -ms-flex-direction: row;\n        flex-direction: row;\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.navbar-toggleable-lg .navbar-nav {\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n.navbar-toggleable-lg .navbar-nav .nav-link {\n        padding-right: .5rem;\n        padding-left: .5rem;\n}\n.navbar-toggleable-lg > .container {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: nowrap;\n          flex-wrap: nowrap;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.navbar-toggleable-lg .navbar-collapse {\n      display: -ms-flexbox !important;\n      display: flex !important;\n      width: 100%;\n}\n.navbar-toggleable-lg .navbar-toggler {\n      display: none;\n}\n}\n.navbar-toggleable-xl {\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.navbar-toggleable-xl .navbar-nav .dropdown-menu {\n    position: static;\n    float: none;\n}\n.navbar-toggleable-xl > .container {\n    padding-right: 0;\n    padding-left: 0;\n}\n.navbar-toggleable-xl .navbar-nav {\n    -ms-flex-direction: row;\n        flex-direction: row;\n}\n.navbar-toggleable-xl .navbar-nav .nav-link {\n      padding-right: .5rem;\n      padding-left: .5rem;\n}\n.navbar-toggleable-xl > .container {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.navbar-toggleable-xl .navbar-collapse {\n    display: -ms-flexbox !important;\n    display: flex !important;\n    width: 100%;\n}\n.navbar-toggleable-xl .navbar-toggler {\n    display: none;\n}\n.navbar-light .navbar-brand,\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-brand:focus, .navbar-light .navbar-brand:hover,\n  .navbar-light .navbar-toggler:focus,\n  .navbar-light .navbar-toggler:hover {\n    color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.5);\n}\n.navbar-light .navbar-nav .nav-link:focus, .navbar-light .navbar-nav .nav-link:hover {\n    color: rgba(0, 0, 0, 0.7);\n}\n.navbar-light .navbar-nav .nav-link.disabled {\n    color: rgba(0, 0, 0, 0.3);\n}\n.navbar-light .navbar-nav .open > .nav-link,\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.open,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-toggler {\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E\");\n}\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.5);\n}\n.navbar-inverse .navbar-brand,\n.navbar-inverse .navbar-toggler {\n  color: white;\n}\n.navbar-inverse .navbar-brand:focus, .navbar-inverse .navbar-brand:hover,\n  .navbar-inverse .navbar-toggler:focus,\n  .navbar-inverse .navbar-toggler:hover {\n    color: white;\n}\n.navbar-inverse .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.5);\n}\n.navbar-inverse .navbar-nav .nav-link:focus, .navbar-inverse .navbar-nav .nav-link:hover {\n    color: rgba(255, 255, 255, 0.75);\n}\n.navbar-inverse .navbar-nav .nav-link.disabled {\n    color: rgba(255, 255, 255, 0.25);\n}\n.navbar-inverse .navbar-nav .open > .nav-link,\n.navbar-inverse .navbar-nav .active > .nav-link,\n.navbar-inverse .navbar-nav .nav-link.open,\n.navbar-inverse .navbar-nav .nav-link.active {\n  color: white;\n}\n.navbar-inverse .navbar-toggler {\n  border-color: rgba(255, 255, 255, 0.1);\n}\n.navbar-inverse .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E\");\n}\n.navbar-inverse .navbar-text {\n  color: rgba(255, 255, 255, 0.5);\n}\n.card {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  border-radius: 0.25rem;\n}\n.card-block {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  padding: 1.25rem;\n}\n.card-title {\n  margin-bottom: 0.75rem;\n}\n.card-subtitle {\n  margin-top: -0.375rem;\n  margin-bottom: 0;\n}\n.card-text:last-child {\n  margin-bottom: 0;\n}\n.card-link:hover {\n  text-decoration: none;\n}\n.card-link + .card-link {\n  margin-left: 1.25rem;\n}\n.card > .list-group:first-child .list-group-item:first-child {\n  border-top-right-radius: 0.25rem;\n  border-top-left-radius: 0.25rem;\n}\n.card > .list-group:last-child .list-group-item:last-child {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.card-header {\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 0;\n  background-color: #f7f7f9;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n}\n.card-header:first-child {\n    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;\n}\n.card-footer {\n  padding: 0.75rem 1.25rem;\n  background-color: #f7f7f9;\n  border-top: 1px solid rgba(0, 0, 0, 0.125);\n}\n.card-footer:last-child {\n    border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);\n}\n.card-header-tabs {\n  margin-right: -0.625rem;\n  margin-bottom: -0.75rem;\n  margin-left: -0.625rem;\n  border-bottom: 0;\n}\n.card-header-pills {\n  margin-right: -0.625rem;\n  margin-left: -0.625rem;\n}\n.card-primary {\n  background-color: #0275d8;\n  border-color: #0275d8;\n}\n.card-primary .card-header,\n  .card-primary .card-footer {\n    background-color: transparent;\n}\n.card-success {\n  background-color: #5cb85c;\n  border-color: #5cb85c;\n}\n.card-success .card-header,\n  .card-success .card-footer {\n    background-color: transparent;\n}\n.card-info {\n  background-color: #5bc0de;\n  border-color: #5bc0de;\n}\n.card-info .card-header,\n  .card-info .card-footer {\n    background-color: transparent;\n}\n.card-warning {\n  background-color: #f0ad4e;\n  border-color: #f0ad4e;\n}\n.card-warning .card-header,\n  .card-warning .card-footer {\n    background-color: transparent;\n}\n.card-danger {\n  background-color: #d9534f;\n  border-color: #d9534f;\n}\n.card-danger .card-header,\n  .card-danger .card-footer {\n    background-color: transparent;\n}\n.card-outline-primary {\n  background-color: transparent;\n  border-color: #0275d8;\n}\n.card-outline-secondary {\n  background-color: transparent;\n  border-color: #ccc;\n}\n.card-outline-info {\n  background-color: transparent;\n  border-color: #5bc0de;\n}\n.card-outline-success {\n  background-color: transparent;\n  border-color: #5cb85c;\n}\n.card-outline-warning {\n  background-color: transparent;\n  border-color: #f0ad4e;\n}\n.card-outline-danger {\n  background-color: transparent;\n  border-color: #d9534f;\n}\n.card-inverse {\n  color: rgba(255, 255, 255, 0.65);\n}\n.card-inverse .card-header,\n  .card-inverse .card-footer {\n    background-color: transparent;\n    border-color: rgba(255, 255, 255, 0.2);\n}\n.card-inverse .card-header,\n  .card-inverse .card-footer,\n  .card-inverse .card-title,\n  .card-inverse .card-blockquote {\n    color: #fff;\n}\n.card-inverse .card-link,\n  .card-inverse .card-text,\n  .card-inverse .card-subtitle,\n  .card-inverse .card-blockquote .blockquote-footer {\n    color: rgba(255, 255, 255, 0.65);\n}\n.card-inverse .card-link:focus, .card-inverse .card-link:hover {\n    color: #fff;\n}\n.card-blockquote {\n  padding: 0;\n  margin-bottom: 0;\n  border-left: 0;\n}\n.card-img {\n  border-radius: calc(0.25rem - 1px);\n}\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem;\n}\n.card-img-top {\n  border-top-right-radius: calc(0.25rem - 1px);\n  border-top-left-radius: calc(0.25rem - 1px);\n}\n.card-img-bottom {\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n@media (min-width: 576px) {\n.card-deck {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: row wrap;\n        flex-flow: row wrap;\n}\n.card-deck .card {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex: 1 0 0px;\n          flex: 1 0 0;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.card-deck .card:not(:first-child) {\n        margin-left: 15px;\n}\n.card-deck .card:not(:last-child) {\n        margin-right: 15px;\n}\n}\n@media (min-width: 576px) {\n.card-group {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: row wrap;\n        flex-flow: row wrap;\n}\n.card-group .card {\n      -ms-flex: 1 0 0px;\n          flex: 1 0 0;\n}\n.card-group .card + .card {\n        margin-left: 0;\n        border-left: 0;\n}\n.card-group .card:first-child {\n        border-bottom-right-radius: 0;\n        border-top-right-radius: 0;\n}\n.card-group .card:first-child .card-img-top {\n          border-top-right-radius: 0;\n}\n.card-group .card:first-child .card-img-bottom {\n          border-bottom-right-radius: 0;\n}\n.card-group .card:last-child {\n        border-bottom-left-radius: 0;\n        border-top-left-radius: 0;\n}\n.card-group .card:last-child .card-img-top {\n          border-top-left-radius: 0;\n}\n.card-group .card:last-child .card-img-bottom {\n          border-bottom-left-radius: 0;\n}\n.card-group .card:not(:first-child):not(:last-child) {\n        border-radius: 0;\n}\n.card-group .card:not(:first-child):not(:last-child) .card-img-top,\n        .card-group .card:not(:first-child):not(:last-child) .card-img-bottom {\n          border-radius: 0;\n}\n}\n@media (min-width: 576px) {\n.card-columns {\n    column-count: 3;\n    column-gap: 1.25rem;\n}\n.card-columns .card {\n      display: inline-block;\n      width: 100%;\n      margin-bottom: 0.75rem;\n}\n}\n.breadcrumb {\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: #eceeef;\n  border-radius: 0.25rem;\n}\n.breadcrumb::after {\n    display: block;\n    content: \"\";\n    clear: both;\n}\n.breadcrumb-item {\n  float: left;\n}\n.breadcrumb-item + .breadcrumb-item::before {\n    display: inline-block;\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n    color: #636c72;\n    content: \"/\";\n}\n.breadcrumb-item + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n}\n.breadcrumb-item + .breadcrumb-item:hover::before {\n    text-decoration: none;\n}\n.breadcrumb-item.active {\n    color: #636c72;\n}\n.pagination {\n  display: -ms-flexbox;\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n  border-radius: 0.25rem;\n}\n.page-item:first-child .page-link {\n  margin-left: 0;\n  border-bottom-left-radius: 0.25rem;\n  border-top-left-radius: 0.25rem;\n}\n.page-item:last-child .page-link {\n  border-bottom-right-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.page-item.active .page-link {\n  z-index: 2;\n  color: #fff;\n  background-color: #0275d8;\n  border-color: #0275d8;\n}\n.page-item.disabled .page-link {\n  color: #636c72;\n  pointer-events: none;\n  cursor: not-allowed;\n  background-color: #fff;\n  border-color: #ddd;\n}\n.page-link {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #0275d8;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n.page-link:focus, .page-link:hover {\n    color: #014c8c;\n    text-decoration: none;\n    background-color: #eceeef;\n    border-color: #ddd;\n}\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.25rem;\n}\n.pagination-lg .page-item:first-child .page-link {\n  border-bottom-left-radius: 0.3rem;\n  border-top-left-radius: 0.3rem;\n}\n.pagination-lg .page-item:last-child .page-link {\n  border-bottom-right-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n}\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n}\n.pagination-sm .page-item:first-child .page-link {\n  border-bottom-left-radius: 0.2rem;\n  border-top-left-radius: 0.2rem;\n}\n.pagination-sm .page-item:last-child .page-link {\n  border-bottom-right-radius: 0.2rem;\n  border-top-right-radius: 0.2rem;\n}\n.badge {\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: bold;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n}\n.badge:empty {\n    display: none;\n}\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\na.badge:focus, a.badge:hover {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n.badge-pill {\n  padding-right: 0.6em;\n  padding-left: 0.6em;\n  border-radius: 10rem;\n}\n.badge-default {\n  background-color: #636c72;\n}\n.badge-default[href]:focus, .badge-default[href]:hover {\n    background-color: #4b5257;\n}\n.badge-primary {\n  background-color: #0275d8;\n}\n.badge-primary[href]:focus, .badge-primary[href]:hover {\n    background-color: #025aa5;\n}\n.badge-success {\n  background-color: #5cb85c;\n}\n.badge-success[href]:focus, .badge-success[href]:hover {\n    background-color: #449d44;\n}\n.badge-info {\n  background-color: #5bc0de;\n}\n.badge-info[href]:focus, .badge-info[href]:hover {\n    background-color: #31b0d5;\n}\n.badge-warning {\n  background-color: #f0ad4e;\n}\n.badge-warning[href]:focus, .badge-warning[href]:hover {\n    background-color: #ec971f;\n}\n.badge-danger {\n  background-color: #d9534f;\n}\n.badge-danger[href]:focus, .badge-danger[href]:hover {\n    background-color: #c9302c;\n}\n.jumbotron {\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  background-color: #eceeef;\n  border-radius: 0.3rem;\n}\n@media (min-width: 576px) {\n.jumbotron {\n      padding: 4rem 2rem;\n}\n}\n.jumbotron-hr {\n  border-top-color: #d0d5d8;\n}\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  border-radius: 0;\n}\n.alert {\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n.alert-heading {\n  color: inherit;\n}\n.alert-link {\n  font-weight: bold;\n}\n.alert-dismissible .close {\n  position: relative;\n  top: -0.75rem;\n  right: -1.25rem;\n  padding: 0.75rem 1.25rem;\n  color: inherit;\n}\n.alert-success {\n  background-color: #dff0d8;\n  border-color: #d0e9c6;\n  color: #3c763d;\n}\n.alert-success hr {\n    border-top-color: #c1e2b3;\n}\n.alert-success .alert-link {\n    color: #2b542c;\n}\n.alert-info {\n  background-color: #d9edf7;\n  border-color: #bcdff1;\n  color: #31708f;\n}\n.alert-info hr {\n    border-top-color: #a6d5ec;\n}\n.alert-info .alert-link {\n    color: #245269;\n}\n.alert-warning {\n  background-color: #fcf8e3;\n  border-color: #faf2cc;\n  color: #8a6d3b;\n}\n.alert-warning hr {\n    border-top-color: #f7ecb5;\n}\n.alert-warning .alert-link {\n    color: #66512c;\n}\n.alert-danger {\n  background-color: #f2dede;\n  border-color: #ebcccc;\n  color: #a94442;\n}\n.alert-danger hr {\n    border-top-color: #e4b9b9;\n}\n.alert-danger .alert-link {\n    color: #843534;\n}\n@keyframes progress-bar-stripes {\nfrom {\n    background-position: 1rem 0;\n}\nto {\n    background-position: 0 0;\n}\n}\n.progress {\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  text-align: center;\n  background-color: #eceeef;\n  border-radius: 0.25rem;\n}\n.progress-bar {\n  height: 1rem;\n  color: #fff;\n  background-color: #0275d8;\n}\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 1rem 1rem;\n}\n.progress-bar-animated {\n  animation: progress-bar-stripes 1s linear infinite;\n}\n.media {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: start;\n      align-items: flex-start;\n}\n.media-body {\n  -ms-flex: 1;\n      flex: 1;\n}\n.list-group {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n}\n.list-group-item-action {\n  width: 100%;\n  color: #464a4c;\n  text-align: inherit;\n}\n.list-group-item-action .list-group-item-heading {\n    color: #292b2c;\n}\n.list-group-item-action:focus, .list-group-item-action:hover {\n    color: #464a4c;\n    text-decoration: none;\n    background-color: #f7f7f9;\n}\n.list-group-item-action:active {\n    color: #292b2c;\n    background-color: #eceeef;\n}\n.list-group-item {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row wrap;\n      flex-flow: row wrap;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n}\n.list-group-item:first-child {\n    border-top-right-radius: 0.25rem;\n    border-top-left-radius: 0.25rem;\n}\n.list-group-item:last-child {\n    margin-bottom: 0;\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n}\n.list-group-item:focus, .list-group-item:hover {\n    text-decoration: none;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n    color: #636c72;\n    cursor: not-allowed;\n    background-color: #fff;\n}\n.list-group-item.disabled .list-group-item-heading, .list-group-item:disabled .list-group-item-heading {\n      color: inherit;\n}\n.list-group-item.disabled .list-group-item-text, .list-group-item:disabled .list-group-item-text {\n      color: #636c72;\n}\n.list-group-item.active {\n    z-index: 2;\n    color: #fff;\n    background-color: #0275d8;\n    border-color: #0275d8;\n}\n.list-group-item.active .list-group-item-heading,\n    .list-group-item.active .list-group-item-heading > small,\n    .list-group-item.active .list-group-item-heading > .small {\n      color: inherit;\n}\n.list-group-item.active .list-group-item-text {\n      color: #daeeff;\n}\n.list-group-flush .list-group-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.list-group-flush:first-child .list-group-item:first-child {\n  border-top: 0;\n}\n.list-group-flush:last-child .list-group-item:last-child {\n  border-bottom: 0;\n}\n.list-group-item-success {\n  color: #3c763d;\n  background-color: #dff0d8;\n}\na.list-group-item-success,\nbutton.list-group-item-success {\n  color: #3c763d;\n}\na.list-group-item-success .list-group-item-heading,\n  button.list-group-item-success .list-group-item-heading {\n    color: inherit;\n}\na.list-group-item-success:focus, a.list-group-item-success:hover,\n  button.list-group-item-success:focus,\n  button.list-group-item-success:hover {\n    color: #3c763d;\n    background-color: #d0e9c6;\n}\na.list-group-item-success.active,\n  button.list-group-item-success.active {\n    color: #fff;\n    background-color: #3c763d;\n    border-color: #3c763d;\n}\n.list-group-item-info {\n  color: #31708f;\n  background-color: #d9edf7;\n}\na.list-group-item-info,\nbutton.list-group-item-info {\n  color: #31708f;\n}\na.list-group-item-info .list-group-item-heading,\n  button.list-group-item-info .list-group-item-heading {\n    color: inherit;\n}\na.list-group-item-info:focus, a.list-group-item-info:hover,\n  button.list-group-item-info:focus,\n  button.list-group-item-info:hover {\n    color: #31708f;\n    background-color: #c4e3f3;\n}\na.list-group-item-info.active,\n  button.list-group-item-info.active {\n    color: #fff;\n    background-color: #31708f;\n    border-color: #31708f;\n}\n.list-group-item-warning {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n}\na.list-group-item-warning,\nbutton.list-group-item-warning {\n  color: #8a6d3b;\n}\na.list-group-item-warning .list-group-item-heading,\n  button.list-group-item-warning .list-group-item-heading {\n    color: inherit;\n}\na.list-group-item-warning:focus, a.list-group-item-warning:hover,\n  button.list-group-item-warning:focus,\n  button.list-group-item-warning:hover {\n    color: #8a6d3b;\n    background-color: #faf2cc;\n}\na.list-group-item-warning.active,\n  button.list-group-item-warning.active {\n    color: #fff;\n    background-color: #8a6d3b;\n    border-color: #8a6d3b;\n}\n.list-group-item-danger {\n  color: #a94442;\n  background-color: #f2dede;\n}\na.list-group-item-danger,\nbutton.list-group-item-danger {\n  color: #a94442;\n}\na.list-group-item-danger .list-group-item-heading,\n  button.list-group-item-danger .list-group-item-heading {\n    color: inherit;\n}\na.list-group-item-danger:focus, a.list-group-item-danger:hover,\n  button.list-group-item-danger:focus,\n  button.list-group-item-danger:hover {\n    color: #a94442;\n    background-color: #ebcccc;\n}\na.list-group-item-danger.active,\n  button.list-group-item-danger.active {\n    color: #fff;\n    background-color: #a94442;\n    border-color: #a94442;\n}\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n.embed-responsive::before {\n    display: block;\n    content: \"\";\n}\n.embed-responsive .embed-responsive-item,\n  .embed-responsive iframe,\n  .embed-responsive embed,\n  .embed-responsive object,\n  .embed-responsive video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n}\n.embed-responsive-21by9::before {\n  padding-top: 42.85714%;\n}\n.embed-responsive-16by9::before {\n  padding-top: 56.25%;\n}\n.embed-responsive-4by3::before {\n  padding-top: 75%;\n}\n.embed-responsive-1by1::before {\n  padding-top: 100%;\n}\n.close {\n  float: right;\n  font-size: 1.5rem;\n  font-weight: bold;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: .5;\n}\n.close:focus, .close:hover {\n    color: #000;\n    text-decoration: none;\n    cursor: pointer;\n    opacity: .75;\n}\nbutton.close {\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  -webkit-appearance: none;\n}\n.modal-open {\n  overflow: hidden;\n}\n.modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  outline: 0;\n}\n.modal.fade .modal-dialog {\n    transition: transform 0.3s ease-out;\n    transform: translate(0, -25%);\n}\n.modal.show .modal-dialog {\n    transform: translate(0, 0);\n}\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 10px;\n}\n.modal-content {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n  outline: 0;\n}\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000;\n}\n.modal-backdrop.fade {\n    opacity: 0;\n}\n.modal-backdrop.show {\n    opacity: 0.5;\n}\n.modal-header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 15px;\n  border-bottom: 1px solid #eceeef;\n}\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n.modal-body {\n  position: relative;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  padding: 15px;\n}\n.modal-footer {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  padding: 15px;\n  border-top: 1px solid #eceeef;\n}\n.modal-footer > :not(:first-child) {\n    margin-left: .25rem;\n}\n.modal-footer > :not(:last-child) {\n    margin-right: .25rem;\n}\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n@media (min-width: 576px) {\n.modal-dialog {\n    max-width: 500px;\n    margin: 30px auto;\n}\n.modal-sm {\n    max-width: 300px;\n}\n}\n@media (min-width: 992px) {\n.modal-lg {\n    max-width: 800px;\n}\n}\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: normal;\n  line-break: auto;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  white-space: normal;\n  word-break: normal;\n  word-spacing: normal;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n    opacity: 0.9;\n}\n.tooltip.tooltip-top, .tooltip.bs-tether-element-attached-bottom {\n    padding: 5px 0;\n    margin-top: -3px;\n}\n.tooltip.tooltip-top .tooltip-inner::before, .tooltip.bs-tether-element-attached-bottom .tooltip-inner::before {\n      bottom: 0;\n      left: 50%;\n      margin-left: -5px;\n      content: \"\";\n      border-width: 5px 5px 0;\n      border-top-color: #000;\n}\n.tooltip.tooltip-right, .tooltip.bs-tether-element-attached-left {\n    padding: 0 5px;\n    margin-left: 3px;\n}\n.tooltip.tooltip-right .tooltip-inner::before, .tooltip.bs-tether-element-attached-left .tooltip-inner::before {\n      top: 50%;\n      left: 0;\n      margin-top: -5px;\n      content: \"\";\n      border-width: 5px 5px 5px 0;\n      border-right-color: #000;\n}\n.tooltip.tooltip-bottom, .tooltip.bs-tether-element-attached-top {\n    padding: 5px 0;\n    margin-top: 3px;\n}\n.tooltip.tooltip-bottom .tooltip-inner::before, .tooltip.bs-tether-element-attached-top .tooltip-inner::before {\n      top: 0;\n      left: 50%;\n      margin-left: -5px;\n      content: \"\";\n      border-width: 0 5px 5px;\n      border-bottom-color: #000;\n}\n.tooltip.tooltip-left, .tooltip.bs-tether-element-attached-right {\n    padding: 0 5px;\n    margin-left: -3px;\n}\n.tooltip.tooltip-left .tooltip-inner::before, .tooltip.bs-tether-element-attached-right .tooltip-inner::before {\n      top: 50%;\n      right: 0;\n      margin-top: -5px;\n      content: \"\";\n      border-width: 5px 0 5px 5px;\n      border-left-color: #000;\n}\n.tooltip-inner {\n  max-width: 200px;\n  padding: 3px 8px;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 0.25rem;\n}\n.tooltip-inner::before {\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-color: transparent;\n    border-style: solid;\n}\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 276px;\n  padding: 1px;\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: normal;\n  line-break: auto;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  white-space: normal;\n  word-break: normal;\n  word-spacing: normal;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n}\n.popover.popover-top, .popover.bs-tether-element-attached-bottom {\n    margin-top: -10px;\n}\n.popover.popover-top::before, .popover.popover-top::after, .popover.bs-tether-element-attached-bottom::before, .popover.bs-tether-element-attached-bottom::after {\n      left: 50%;\n      border-bottom-width: 0;\n}\n.popover.popover-top::before, .popover.bs-tether-element-attached-bottom::before {\n      bottom: -11px;\n      margin-left: -11px;\n      border-top-color: rgba(0, 0, 0, 0.25);\n}\n.popover.popover-top::after, .popover.bs-tether-element-attached-bottom::after {\n      bottom: -10px;\n      margin-left: -10px;\n      border-top-color: #fff;\n}\n.popover.popover-right, .popover.bs-tether-element-attached-left {\n    margin-left: 10px;\n}\n.popover.popover-right::before, .popover.popover-right::after, .popover.bs-tether-element-attached-left::before, .popover.bs-tether-element-attached-left::after {\n      top: 50%;\n      border-left-width: 0;\n}\n.popover.popover-right::before, .popover.bs-tether-element-attached-left::before {\n      left: -11px;\n      margin-top: -11px;\n      border-right-color: rgba(0, 0, 0, 0.25);\n}\n.popover.popover-right::after, .popover.bs-tether-element-attached-left::after {\n      left: -10px;\n      margin-top: -10px;\n      border-right-color: #fff;\n}\n.popover.popover-bottom, .popover.bs-tether-element-attached-top {\n    margin-top: 10px;\n}\n.popover.popover-bottom::before, .popover.popover-bottom::after, .popover.bs-tether-element-attached-top::before, .popover.bs-tether-element-attached-top::after {\n      left: 50%;\n      border-top-width: 0;\n}\n.popover.popover-bottom::before, .popover.bs-tether-element-attached-top::before {\n      top: -11px;\n      margin-left: -11px;\n      border-bottom-color: rgba(0, 0, 0, 0.25);\n}\n.popover.popover-bottom::after, .popover.bs-tether-element-attached-top::after {\n      top: -10px;\n      margin-left: -10px;\n      border-bottom-color: #f7f7f7;\n}\n.popover.popover-bottom .popover-title::before, .popover.bs-tether-element-attached-top .popover-title::before {\n      position: absolute;\n      top: 0;\n      left: 50%;\n      display: block;\n      width: 20px;\n      margin-left: -10px;\n      content: \"\";\n      border-bottom: 1px solid #f7f7f7;\n}\n.popover.popover-left, .popover.bs-tether-element-attached-right {\n    margin-left: -10px;\n}\n.popover.popover-left::before, .popover.popover-left::after, .popover.bs-tether-element-attached-right::before, .popover.bs-tether-element-attached-right::after {\n      top: 50%;\n      border-right-width: 0;\n}\n.popover.popover-left::before, .popover.bs-tether-element-attached-right::before {\n      right: -11px;\n      margin-top: -11px;\n      border-left-color: rgba(0, 0, 0, 0.25);\n}\n.popover.popover-left::after, .popover.bs-tether-element-attached-right::after {\n      right: -10px;\n      margin-top: -10px;\n      border-left-color: #fff;\n}\n.popover-title {\n  padding: 8px 14px;\n  margin-bottom: 0;\n  font-size: 1rem;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-top-right-radius: calc(0.3rem - 1px);\n  border-top-left-radius: calc(0.3rem - 1px);\n}\n.popover-title:empty {\n    display: none;\n}\n.popover-content {\n  padding: 9px 14px;\n}\n.popover::before,\n.popover::after {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.popover::before {\n  content: \"\";\n  border-width: 11px;\n}\n.popover::after {\n  content: \"\";\n  border-width: 10px;\n}\n.carousel {\n  position: relative;\n}\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-item {\n  position: relative;\n  display: none;\n  width: 100%;\n}\n@media (-webkit-transform-3d) {\n.carousel-item {\n      transition: transform 0.6s ease-in-out;\n      -webkit-backface-visibility: hidden;\n              backface-visibility: hidden;\n      perspective: 1000px;\n}\n}\n@supports (transform: translate3d(0, 0, 0)) {\n.carousel-item {\n      transition: transform 0.6s ease-in-out;\n      -webkit-backface-visibility: hidden;\n              backface-visibility: hidden;\n      perspective: 1000px;\n}\n}\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: -ms-flexbox;\n  display: flex;\n}\n.carousel-item-next,\n.carousel-item-prev {\n  position: absolute;\n  top: 0;\n}\n@media (-webkit-transform-3d) {\n.carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    transform: translate3d(0, 0, 0);\n}\n.carousel-item-next,\n  .active.carousel-item-right {\n    transform: translate3d(100%, 0, 0);\n}\n.carousel-item-prev,\n  .active.carousel-item-left {\n    transform: translate3d(-100%, 0, 0);\n}\n}\n@supports (transform: translate3d(0, 0, 0)) {\n.carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    transform: translate3d(0, 0, 0);\n}\n.carousel-item-next,\n  .active.carousel-item-right {\n    transform: translate3d(100%, 0, 0);\n}\n.carousel-item-prev,\n  .active.carousel-item-left {\n    transform: translate3d(-100%, 0, 0);\n}\n}\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  width: 15%;\n  color: #fff;\n  text-align: center;\n  opacity: 0.5;\n}\n.carousel-control-prev:focus, .carousel-control-prev:hover,\n  .carousel-control-next:focus,\n  .carousel-control-next:hover {\n    color: #fff;\n    text-decoration: none;\n    outline: 0;\n    opacity: .9;\n}\n.carousel-control-prev {\n  left: 0;\n}\n.carousel-control-next {\n  right: 0;\n}\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: transparent no-repeat center center;\n  background-size: 100% 100%;\n}\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M4 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\");\n}\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M1.5 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\");\n}\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 10px;\n  left: 0;\n  z-index: 15;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  padding-left: 0;\n  margin-right: 15%;\n  margin-left: 15%;\n  list-style: none;\n}\n.carousel-indicators li {\n    position: relative;\n    -ms-flex: 1 0 auto;\n        flex: 1 0 auto;\n    max-width: 30px;\n    height: 3px;\n    margin-right: 3px;\n    margin-left: 3px;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: rgba(255, 255, 255, 0.5);\n}\n.carousel-indicators li::before {\n      position: absolute;\n      top: -10px;\n      left: 0;\n      display: inline-block;\n      width: 100%;\n      height: 10px;\n      content: \"\";\n}\n.carousel-indicators li::after {\n      position: absolute;\n      bottom: -10px;\n      left: 0;\n      display: inline-block;\n      width: 100%;\n      height: 10px;\n      content: \"\";\n}\n.carousel-indicators .active {\n    background-color: #fff;\n}\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n}\n.align-baseline {\n  vertical-align: baseline !important;\n}\n.align-top {\n  vertical-align: top !important;\n}\n.align-middle {\n  vertical-align: middle !important;\n}\n.align-bottom {\n  vertical-align: bottom !important;\n}\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n.align-text-top {\n  vertical-align: text-top !important;\n}\n.bg-faded {\n  background-color: #f7f7f7;\n}\n.bg-primary {\n  background-color: #0275d8 !important;\n}\na.bg-primary:focus, a.bg-primary:hover {\n  background-color: #025aa5 !important;\n}\n.bg-success {\n  background-color: #5cb85c !important;\n}\na.bg-success:focus, a.bg-success:hover {\n  background-color: #449d44 !important;\n}\n.bg-info {\n  background-color: #5bc0de !important;\n}\na.bg-info:focus, a.bg-info:hover {\n  background-color: #31b0d5 !important;\n}\n.bg-warning {\n  background-color: #f0ad4e !important;\n}\na.bg-warning:focus, a.bg-warning:hover {\n  background-color: #ec971f !important;\n}\n.bg-danger {\n  background-color: #d9534f !important;\n}\na.bg-danger:focus, a.bg-danger:hover {\n  background-color: #c9302c !important;\n}\n.bg-inverse {\n  background-color: #292b2c !important;\n}\na.bg-inverse:focus, a.bg-inverse:hover {\n  background-color: #101112 !important;\n}\n.border-0 {\n  border: 0 !important;\n}\n.border-top-0 {\n  border-top: 0 !important;\n}\n.border-right-0 {\n  border-right: 0 !important;\n}\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n.border-left-0 {\n  border-left: 0 !important;\n}\n.rounded {\n  border-radius: 0.25rem;\n}\n.rounded-top {\n  border-top-right-radius: 0.25rem;\n  border-top-left-radius: 0.25rem;\n}\n.rounded-right {\n  border-bottom-right-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.rounded-bottom {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.rounded-left {\n  border-bottom-left-radius: 0.25rem;\n  border-top-left-radius: 0.25rem;\n}\n.rounded-circle {\n  border-radius: 50%;\n}\n.rounded-0 {\n  border-radius: 0;\n}\n.clearfix::after {\n  display: block;\n  content: \"\";\n  clear: both;\n}\n.d-none {\n  display: none !important;\n}\n.d-inline {\n  display: inline !important;\n}\n.d-inline-block {\n  display: inline-block !important;\n}\n.d-block {\n  display: block !important;\n}\n.d-table {\n  display: table !important;\n}\n.d-table-cell {\n  display: table-cell !important;\n}\n.d-flex {\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n.d-inline-flex {\n  display: -ms-inline-flexbox !important;\n  display: inline-flex !important;\n}\n@media (min-width: 576px) {\n.d-sm-none {\n    display: none !important;\n}\n.d-sm-inline {\n    display: inline !important;\n}\n.d-sm-inline-block {\n    display: inline-block !important;\n}\n.d-sm-block {\n    display: block !important;\n}\n.d-sm-table {\n    display: table !important;\n}\n.d-sm-table-cell {\n    display: table-cell !important;\n}\n.d-sm-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n.d-sm-inline-flex {\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n@media (min-width: 768px) {\n.d-md-none {\n    display: none !important;\n}\n.d-md-inline {\n    display: inline !important;\n}\n.d-md-inline-block {\n    display: inline-block !important;\n}\n.d-md-block {\n    display: block !important;\n}\n.d-md-table {\n    display: table !important;\n}\n.d-md-table-cell {\n    display: table-cell !important;\n}\n.d-md-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n.d-md-inline-flex {\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n@media (min-width: 992px) {\n.d-lg-none {\n    display: none !important;\n}\n.d-lg-inline {\n    display: inline !important;\n}\n.d-lg-inline-block {\n    display: inline-block !important;\n}\n.d-lg-block {\n    display: block !important;\n}\n.d-lg-table {\n    display: table !important;\n}\n.d-lg-table-cell {\n    display: table-cell !important;\n}\n.d-lg-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n.d-lg-inline-flex {\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n@media (min-width: 1200px) {\n.d-xl-none {\n    display: none !important;\n}\n.d-xl-inline {\n    display: inline !important;\n}\n.d-xl-inline-block {\n    display: inline-block !important;\n}\n.d-xl-block {\n    display: block !important;\n}\n.d-xl-table {\n    display: table !important;\n}\n.d-xl-table-cell {\n    display: table-cell !important;\n}\n.d-xl-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n.d-xl-inline-flex {\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n.flex-first {\n  -ms-flex-order: -1;\n      order: -1;\n}\n.flex-last {\n  -ms-flex-order: 1;\n      order: 1;\n}\n.flex-unordered {\n  -ms-flex-order: 0;\n      order: 0;\n}\n.flex-row {\n  -ms-flex-direction: row !important;\n      flex-direction: row !important;\n}\n.flex-column {\n  -ms-flex-direction: column !important;\n      flex-direction: column !important;\n}\n.flex-row-reverse {\n  -ms-flex-direction: row-reverse !important;\n      flex-direction: row-reverse !important;\n}\n.flex-column-reverse {\n  -ms-flex-direction: column-reverse !important;\n      flex-direction: column-reverse !important;\n}\n.flex-wrap {\n  -ms-flex-wrap: wrap !important;\n      flex-wrap: wrap !important;\n}\n.flex-nowrap {\n  -ms-flex-wrap: nowrap !important;\n      flex-wrap: nowrap !important;\n}\n.flex-wrap-reverse {\n  -ms-flex-wrap: wrap-reverse !important;\n      flex-wrap: wrap-reverse !important;\n}\n.justify-content-start {\n  -ms-flex-pack: start !important;\n      justify-content: flex-start !important;\n}\n.justify-content-end {\n  -ms-flex-pack: end !important;\n      justify-content: flex-end !important;\n}\n.justify-content-center {\n  -ms-flex-pack: center !important;\n      justify-content: center !important;\n}\n.justify-content-between {\n  -ms-flex-pack: justify !important;\n      justify-content: space-between !important;\n}\n.justify-content-around {\n  -ms-flex-pack: distribute !important;\n      justify-content: space-around !important;\n}\n.align-items-start {\n  -ms-flex-align: start !important;\n      align-items: flex-start !important;\n}\n.align-items-end {\n  -ms-flex-align: end !important;\n      align-items: flex-end !important;\n}\n.align-items-center {\n  -ms-flex-align: center !important;\n      align-items: center !important;\n}\n.align-items-baseline {\n  -ms-flex-align: baseline !important;\n      align-items: baseline !important;\n}\n.align-items-stretch {\n  -ms-flex-align: stretch !important;\n      align-items: stretch !important;\n}\n.align-content-start {\n  -ms-flex-line-pack: start !important;\n      align-content: flex-start !important;\n}\n.align-content-end {\n  -ms-flex-line-pack: end !important;\n      align-content: flex-end !important;\n}\n.align-content-center {\n  -ms-flex-line-pack: center !important;\n      align-content: center !important;\n}\n.align-content-between {\n  -ms-flex-line-pack: justify !important;\n      align-content: space-between !important;\n}\n.align-content-around {\n  -ms-flex-line-pack: distribute !important;\n      align-content: space-around !important;\n}\n.align-content-stretch {\n  -ms-flex-line-pack: stretch !important;\n      align-content: stretch !important;\n}\n.align-self-auto {\n  -ms-flex-item-align: auto !important;\n      -ms-grid-row-align: auto !important;\n      align-self: auto !important;\n}\n.align-self-start {\n  -ms-flex-item-align: start !important;\n      align-self: flex-start !important;\n}\n.align-self-end {\n  -ms-flex-item-align: end !important;\n      align-self: flex-end !important;\n}\n.align-self-center {\n  -ms-flex-item-align: center !important;\n      -ms-grid-row-align: center !important;\n      align-self: center !important;\n}\n.align-self-baseline {\n  -ms-flex-item-align: baseline !important;\n      align-self: baseline !important;\n}\n.align-self-stretch {\n  -ms-flex-item-align: stretch !important;\n      -ms-grid-row-align: stretch !important;\n      align-self: stretch !important;\n}\n@media (min-width: 576px) {\n.flex-sm-first {\n    -ms-flex-order: -1;\n        order: -1;\n}\n.flex-sm-last {\n    -ms-flex-order: 1;\n        order: 1;\n}\n.flex-sm-unordered {\n    -ms-flex-order: 0;\n        order: 0;\n}\n.flex-sm-row {\n    -ms-flex-direction: row !important;\n        flex-direction: row !important;\n}\n.flex-sm-column {\n    -ms-flex-direction: column !important;\n        flex-direction: column !important;\n}\n.flex-sm-row-reverse {\n    -ms-flex-direction: row-reverse !important;\n        flex-direction: row-reverse !important;\n}\n.flex-sm-column-reverse {\n    -ms-flex-direction: column-reverse !important;\n        flex-direction: column-reverse !important;\n}\n.flex-sm-wrap {\n    -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n}\n.flex-sm-nowrap {\n    -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n}\n.flex-sm-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n}\n.justify-content-sm-start {\n    -ms-flex-pack: start !important;\n        justify-content: flex-start !important;\n}\n.justify-content-sm-end {\n    -ms-flex-pack: end !important;\n        justify-content: flex-end !important;\n}\n.justify-content-sm-center {\n    -ms-flex-pack: center !important;\n        justify-content: center !important;\n}\n.justify-content-sm-between {\n    -ms-flex-pack: justify !important;\n        justify-content: space-between !important;\n}\n.justify-content-sm-around {\n    -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n}\n.align-items-sm-start {\n    -ms-flex-align: start !important;\n        align-items: flex-start !important;\n}\n.align-items-sm-end {\n    -ms-flex-align: end !important;\n        align-items: flex-end !important;\n}\n.align-items-sm-center {\n    -ms-flex-align: center !important;\n        align-items: center !important;\n}\n.align-items-sm-baseline {\n    -ms-flex-align: baseline !important;\n        align-items: baseline !important;\n}\n.align-items-sm-stretch {\n    -ms-flex-align: stretch !important;\n        align-items: stretch !important;\n}\n.align-content-sm-start {\n    -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n}\n.align-content-sm-end {\n    -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n}\n.align-content-sm-center {\n    -ms-flex-line-pack: center !important;\n        align-content: center !important;\n}\n.align-content-sm-between {\n    -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n}\n.align-content-sm-around {\n    -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n}\n.align-content-sm-stretch {\n    -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n}\n.align-self-sm-auto {\n    -ms-flex-item-align: auto !important;\n        -ms-grid-row-align: auto !important;\n        align-self: auto !important;\n}\n.align-self-sm-start {\n    -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n}\n.align-self-sm-end {\n    -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n}\n.align-self-sm-center {\n    -ms-flex-item-align: center !important;\n        -ms-grid-row-align: center !important;\n        align-self: center !important;\n}\n.align-self-sm-baseline {\n    -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n}\n.align-self-sm-stretch {\n    -ms-flex-item-align: stretch !important;\n        -ms-grid-row-align: stretch !important;\n        align-self: stretch !important;\n}\n}\n@media (min-width: 768px) {\n.flex-md-first {\n    -ms-flex-order: -1;\n        order: -1;\n}\n.flex-md-last {\n    -ms-flex-order: 1;\n        order: 1;\n}\n.flex-md-unordered {\n    -ms-flex-order: 0;\n        order: 0;\n}\n.flex-md-row {\n    -ms-flex-direction: row !important;\n        flex-direction: row !important;\n}\n.flex-md-column {\n    -ms-flex-direction: column !important;\n        flex-direction: column !important;\n}\n.flex-md-row-reverse {\n    -ms-flex-direction: row-reverse !important;\n        flex-direction: row-reverse !important;\n}\n.flex-md-column-reverse {\n    -ms-flex-direction: column-reverse !important;\n        flex-direction: column-reverse !important;\n}\n.flex-md-wrap {\n    -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n}\n.flex-md-nowrap {\n    -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n}\n.flex-md-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n}\n.justify-content-md-start {\n    -ms-flex-pack: start !important;\n        justify-content: flex-start !important;\n}\n.justify-content-md-end {\n    -ms-flex-pack: end !important;\n        justify-content: flex-end !important;\n}\n.justify-content-md-center {\n    -ms-flex-pack: center !important;\n        justify-content: center !important;\n}\n.justify-content-md-between {\n    -ms-flex-pack: justify !important;\n        justify-content: space-between !important;\n}\n.justify-content-md-around {\n    -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n}\n.align-items-md-start {\n    -ms-flex-align: start !important;\n        align-items: flex-start !important;\n}\n.align-items-md-end {\n    -ms-flex-align: end !important;\n        align-items: flex-end !important;\n}\n.align-items-md-center {\n    -ms-flex-align: center !important;\n        align-items: center !important;\n}\n.align-items-md-baseline {\n    -ms-flex-align: baseline !important;\n        align-items: baseline !important;\n}\n.align-items-md-stretch {\n    -ms-flex-align: stretch !important;\n        align-items: stretch !important;\n}\n.align-content-md-start {\n    -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n}\n.align-content-md-end {\n    -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n}\n.align-content-md-center {\n    -ms-flex-line-pack: center !important;\n        align-content: center !important;\n}\n.align-content-md-between {\n    -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n}\n.align-content-md-around {\n    -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n}\n.align-content-md-stretch {\n    -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n}\n.align-self-md-auto {\n    -ms-flex-item-align: auto !important;\n        -ms-grid-row-align: auto !important;\n        align-self: auto !important;\n}\n.align-self-md-start {\n    -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n}\n.align-self-md-end {\n    -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n}\n.align-self-md-center {\n    -ms-flex-item-align: center !important;\n        -ms-grid-row-align: center !important;\n        align-self: center !important;\n}\n.align-self-md-baseline {\n    -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n}\n.align-self-md-stretch {\n    -ms-flex-item-align: stretch !important;\n        -ms-grid-row-align: stretch !important;\n        align-self: stretch !important;\n}\n}\n@media (min-width: 992px) {\n.flex-lg-first {\n    -ms-flex-order: -1;\n        order: -1;\n}\n.flex-lg-last {\n    -ms-flex-order: 1;\n        order: 1;\n}\n.flex-lg-unordered {\n    -ms-flex-order: 0;\n        order: 0;\n}\n.flex-lg-row {\n    -ms-flex-direction: row !important;\n        flex-direction: row !important;\n}\n.flex-lg-column {\n    -ms-flex-direction: column !important;\n        flex-direction: column !important;\n}\n.flex-lg-row-reverse {\n    -ms-flex-direction: row-reverse !important;\n        flex-direction: row-reverse !important;\n}\n.flex-lg-column-reverse {\n    -ms-flex-direction: column-reverse !important;\n        flex-direction: column-reverse !important;\n}\n.flex-lg-wrap {\n    -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n}\n.flex-lg-nowrap {\n    -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n}\n.flex-lg-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n}\n.justify-content-lg-start {\n    -ms-flex-pack: start !important;\n        justify-content: flex-start !important;\n}\n.justify-content-lg-end {\n    -ms-flex-pack: end !important;\n        justify-content: flex-end !important;\n}\n.justify-content-lg-center {\n    -ms-flex-pack: center !important;\n        justify-content: center !important;\n}\n.justify-content-lg-between {\n    -ms-flex-pack: justify !important;\n        justify-content: space-between !important;\n}\n.justify-content-lg-around {\n    -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n}\n.align-items-lg-start {\n    -ms-flex-align: start !important;\n        align-items: flex-start !important;\n}\n.align-items-lg-end {\n    -ms-flex-align: end !important;\n        align-items: flex-end !important;\n}\n.align-items-lg-center {\n    -ms-flex-align: center !important;\n        align-items: center !important;\n}\n.align-items-lg-baseline {\n    -ms-flex-align: baseline !important;\n        align-items: baseline !important;\n}\n.align-items-lg-stretch {\n    -ms-flex-align: stretch !important;\n        align-items: stretch !important;\n}\n.align-content-lg-start {\n    -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n}\n.align-content-lg-end {\n    -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n}\n.align-content-lg-center {\n    -ms-flex-line-pack: center !important;\n        align-content: center !important;\n}\n.align-content-lg-between {\n    -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n}\n.align-content-lg-around {\n    -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n}\n.align-content-lg-stretch {\n    -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n}\n.align-self-lg-auto {\n    -ms-flex-item-align: auto !important;\n        -ms-grid-row-align: auto !important;\n        align-self: auto !important;\n}\n.align-self-lg-start {\n    -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n}\n.align-self-lg-end {\n    -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n}\n.align-self-lg-center {\n    -ms-flex-item-align: center !important;\n        -ms-grid-row-align: center !important;\n        align-self: center !important;\n}\n.align-self-lg-baseline {\n    -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n}\n.align-self-lg-stretch {\n    -ms-flex-item-align: stretch !important;\n        -ms-grid-row-align: stretch !important;\n        align-self: stretch !important;\n}\n}\n@media (min-width: 1200px) {\n.flex-xl-first {\n    -ms-flex-order: -1;\n        order: -1;\n}\n.flex-xl-last {\n    -ms-flex-order: 1;\n        order: 1;\n}\n.flex-xl-unordered {\n    -ms-flex-order: 0;\n        order: 0;\n}\n.flex-xl-row {\n    -ms-flex-direction: row !important;\n        flex-direction: row !important;\n}\n.flex-xl-column {\n    -ms-flex-direction: column !important;\n        flex-direction: column !important;\n}\n.flex-xl-row-reverse {\n    -ms-flex-direction: row-reverse !important;\n        flex-direction: row-reverse !important;\n}\n.flex-xl-column-reverse {\n    -ms-flex-direction: column-reverse !important;\n        flex-direction: column-reverse !important;\n}\n.flex-xl-wrap {\n    -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n}\n.flex-xl-nowrap {\n    -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n}\n.flex-xl-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n}\n.justify-content-xl-start {\n    -ms-flex-pack: start !important;\n        justify-content: flex-start !important;\n}\n.justify-content-xl-end {\n    -ms-flex-pack: end !important;\n        justify-content: flex-end !important;\n}\n.justify-content-xl-center {\n    -ms-flex-pack: center !important;\n        justify-content: center !important;\n}\n.justify-content-xl-between {\n    -ms-flex-pack: justify !important;\n        justify-content: space-between !important;\n}\n.justify-content-xl-around {\n    -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n}\n.align-items-xl-start {\n    -ms-flex-align: start !important;\n        align-items: flex-start !important;\n}\n.align-items-xl-end {\n    -ms-flex-align: end !important;\n        align-items: flex-end !important;\n}\n.align-items-xl-center {\n    -ms-flex-align: center !important;\n        align-items: center !important;\n}\n.align-items-xl-baseline {\n    -ms-flex-align: baseline !important;\n        align-items: baseline !important;\n}\n.align-items-xl-stretch {\n    -ms-flex-align: stretch !important;\n        align-items: stretch !important;\n}\n.align-content-xl-start {\n    -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n}\n.align-content-xl-end {\n    -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n}\n.align-content-xl-center {\n    -ms-flex-line-pack: center !important;\n        align-content: center !important;\n}\n.align-content-xl-between {\n    -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n}\n.align-content-xl-around {\n    -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n}\n.align-content-xl-stretch {\n    -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n}\n.align-self-xl-auto {\n    -ms-flex-item-align: auto !important;\n        -ms-grid-row-align: auto !important;\n        align-self: auto !important;\n}\n.align-self-xl-start {\n    -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n}\n.align-self-xl-end {\n    -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n}\n.align-self-xl-center {\n    -ms-flex-item-align: center !important;\n        -ms-grid-row-align: center !important;\n        align-self: center !important;\n}\n.align-self-xl-baseline {\n    -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n}\n.align-self-xl-stretch {\n    -ms-flex-item-align: stretch !important;\n        -ms-grid-row-align: stretch !important;\n        align-self: stretch !important;\n}\n}\n.float-left {\n  float: left !important;\n}\n.float-right {\n  float: right !important;\n}\n.float-none {\n  float: none !important;\n}\n@media (min-width: 576px) {\n.float-sm-left {\n    float: left !important;\n}\n.float-sm-right {\n    float: right !important;\n}\n.float-sm-none {\n    float: none !important;\n}\n}\n@media (min-width: 768px) {\n.float-md-left {\n    float: left !important;\n}\n.float-md-right {\n    float: right !important;\n}\n.float-md-none {\n    float: none !important;\n}\n}\n@media (min-width: 992px) {\n.float-lg-left {\n    float: left !important;\n}\n.float-lg-right {\n    float: right !important;\n}\n.float-lg-none {\n    float: none !important;\n}\n}\n@media (min-width: 1200px) {\n.float-xl-left {\n    float: left !important;\n}\n.float-xl-right {\n    float: right !important;\n}\n.float-xl-none {\n    float: none !important;\n}\n}\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n.sticky-top {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 1030;\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n}\n.w-25 {\n  width: 25% !important;\n}\n.w-50 {\n  width: 50% !important;\n}\n.w-75 {\n  width: 75% !important;\n}\n.w-100 {\n  width: 100% !important;\n}\n.h-25 {\n  height: 25% !important;\n}\n.h-50 {\n  height: 50% !important;\n}\n.h-75 {\n  height: 75% !important;\n}\n.h-100 {\n  height: 100% !important;\n}\n.mw-100 {\n  max-width: 100% !important;\n}\n.mh-100 {\n  max-height: 100% !important;\n}\n.m-0 {\n  margin: 0 0 !important;\n}\n.mt-0 {\n  margin-top: 0 !important;\n}\n.mr-0 {\n  margin-right: 0 !important;\n}\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n.ml-0 {\n  margin-left: 0 !important;\n}\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n.m-1 {\n  margin: 0.25rem 0.25rem !important;\n}\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n.mr-1 {\n  margin-right: 0.25rem !important;\n}\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n.ml-1 {\n  margin-left: 0.25rem !important;\n}\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n.m-2 {\n  margin: 0.5rem 0.5rem !important;\n}\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n.mr-2 {\n  margin-right: 0.5rem !important;\n}\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n.ml-2 {\n  margin-left: 0.5rem !important;\n}\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n.m-3 {\n  margin: 1rem 1rem !important;\n}\n.mt-3 {\n  margin-top: 1rem !important;\n}\n.mr-3 {\n  margin-right: 1rem !important;\n}\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n.ml-3 {\n  margin-left: 1rem !important;\n}\n.mx-3 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n.m-4 {\n  margin: 1.5rem 1.5rem !important;\n}\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n.mr-4 {\n  margin-right: 1.5rem !important;\n}\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n.ml-4 {\n  margin-left: 1.5rem !important;\n}\n.mx-4 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n.m-5 {\n  margin: 3rem 3rem !important;\n}\n.mt-5 {\n  margin-top: 3rem !important;\n}\n.mr-5 {\n  margin-right: 3rem !important;\n}\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n.ml-5 {\n  margin-left: 3rem !important;\n}\n.mx-5 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n.my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n.p-0 {\n  padding: 0 0 !important;\n}\n.pt-0 {\n  padding-top: 0 !important;\n}\n.pr-0 {\n  padding-right: 0 !important;\n}\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n.pl-0 {\n  padding-left: 0 !important;\n}\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.p-1 {\n  padding: 0.25rem 0.25rem !important;\n}\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n.pr-1 {\n  padding-right: 0.25rem !important;\n}\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n.pl-1 {\n  padding-left: 0.25rem !important;\n}\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n.p-2 {\n  padding: 0.5rem 0.5rem !important;\n}\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n.pr-2 {\n  padding-right: 0.5rem !important;\n}\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n.pl-2 {\n  padding-left: 0.5rem !important;\n}\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n.p-3 {\n  padding: 1rem 1rem !important;\n}\n.pt-3 {\n  padding-top: 1rem !important;\n}\n.pr-3 {\n  padding-right: 1rem !important;\n}\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n.pl-3 {\n  padding-left: 1rem !important;\n}\n.px-3 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n.py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n.p-4 {\n  padding: 1.5rem 1.5rem !important;\n}\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n.pr-4 {\n  padding-right: 1.5rem !important;\n}\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n.pl-4 {\n  padding-left: 1.5rem !important;\n}\n.px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n.py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n.p-5 {\n  padding: 3rem 3rem !important;\n}\n.pt-5 {\n  padding-top: 3rem !important;\n}\n.pr-5 {\n  padding-right: 3rem !important;\n}\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n.pl-5 {\n  padding-left: 3rem !important;\n}\n.px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n.py-5 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n.m-auto {\n  margin: auto !important;\n}\n.mt-auto {\n  margin-top: auto !important;\n}\n.mr-auto {\n  margin-right: auto !important;\n}\n.mb-auto {\n  margin-bottom: auto !important;\n}\n.ml-auto {\n  margin-left: auto !important;\n}\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n@media (min-width: 576px) {\n.m-sm-0 {\n    margin: 0 0 !important;\n}\n.mt-sm-0 {\n    margin-top: 0 !important;\n}\n.mr-sm-0 {\n    margin-right: 0 !important;\n}\n.mb-sm-0 {\n    margin-bottom: 0 !important;\n}\n.ml-sm-0 {\n    margin-left: 0 !important;\n}\n.mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n}\n.my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n}\n.m-sm-1 {\n    margin: 0.25rem 0.25rem !important;\n}\n.mt-sm-1 {\n    margin-top: 0.25rem !important;\n}\n.mr-sm-1 {\n    margin-right: 0.25rem !important;\n}\n.mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n}\n.ml-sm-1 {\n    margin-left: 0.25rem !important;\n}\n.mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n}\n.my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n}\n.m-sm-2 {\n    margin: 0.5rem 0.5rem !important;\n}\n.mt-sm-2 {\n    margin-top: 0.5rem !important;\n}\n.mr-sm-2 {\n    margin-right: 0.5rem !important;\n}\n.mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n}\n.ml-sm-2 {\n    margin-left: 0.5rem !important;\n}\n.mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n}\n.my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n}\n.m-sm-3 {\n    margin: 1rem 1rem !important;\n}\n.mt-sm-3 {\n    margin-top: 1rem !important;\n}\n.mr-sm-3 {\n    margin-right: 1rem !important;\n}\n.mb-sm-3 {\n    margin-bottom: 1rem !important;\n}\n.ml-sm-3 {\n    margin-left: 1rem !important;\n}\n.mx-sm-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n}\n.my-sm-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n}\n.m-sm-4 {\n    margin: 1.5rem 1.5rem !important;\n}\n.mt-sm-4 {\n    margin-top: 1.5rem !important;\n}\n.mr-sm-4 {\n    margin-right: 1.5rem !important;\n}\n.mb-sm-4 {\n    margin-bottom: 1.5rem !important;\n}\n.ml-sm-4 {\n    margin-left: 1.5rem !important;\n}\n.mx-sm-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n}\n.my-sm-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n}\n.m-sm-5 {\n    margin: 3rem 3rem !important;\n}\n.mt-sm-5 {\n    margin-top: 3rem !important;\n}\n.mr-sm-5 {\n    margin-right: 3rem !important;\n}\n.mb-sm-5 {\n    margin-bottom: 3rem !important;\n}\n.ml-sm-5 {\n    margin-left: 3rem !important;\n}\n.mx-sm-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n}\n.my-sm-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n}\n.p-sm-0 {\n    padding: 0 0 !important;\n}\n.pt-sm-0 {\n    padding-top: 0 !important;\n}\n.pr-sm-0 {\n    padding-right: 0 !important;\n}\n.pb-sm-0 {\n    padding-bottom: 0 !important;\n}\n.pl-sm-0 {\n    padding-left: 0 !important;\n}\n.px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n}\n.py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n}\n.p-sm-1 {\n    padding: 0.25rem 0.25rem !important;\n}\n.pt-sm-1 {\n    padding-top: 0.25rem !important;\n}\n.pr-sm-1 {\n    padding-right: 0.25rem !important;\n}\n.pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n}\n.pl-sm-1 {\n    padding-left: 0.25rem !important;\n}\n.px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n}\n.py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n}\n.p-sm-2 {\n    padding: 0.5rem 0.5rem !important;\n}\n.pt-sm-2 {\n    padding-top: 0.5rem !important;\n}\n.pr-sm-2 {\n    padding-right: 0.5rem !important;\n}\n.pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n}\n.pl-sm-2 {\n    padding-left: 0.5rem !important;\n}\n.px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n}\n.py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n}\n.p-sm-3 {\n    padding: 1rem 1rem !important;\n}\n.pt-sm-3 {\n    padding-top: 1rem !important;\n}\n.pr-sm-3 {\n    padding-right: 1rem !important;\n}\n.pb-sm-3 {\n    padding-bottom: 1rem !important;\n}\n.pl-sm-3 {\n    padding-left: 1rem !important;\n}\n.px-sm-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n}\n.py-sm-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n}\n.p-sm-4 {\n    padding: 1.5rem 1.5rem !important;\n}\n.pt-sm-4 {\n    padding-top: 1.5rem !important;\n}\n.pr-sm-4 {\n    padding-right: 1.5rem !important;\n}\n.pb-sm-4 {\n    padding-bottom: 1.5rem !important;\n}\n.pl-sm-4 {\n    padding-left: 1.5rem !important;\n}\n.px-sm-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n}\n.py-sm-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n}\n.p-sm-5 {\n    padding: 3rem 3rem !important;\n}\n.pt-sm-5 {\n    padding-top: 3rem !important;\n}\n.pr-sm-5 {\n    padding-right: 3rem !important;\n}\n.pb-sm-5 {\n    padding-bottom: 3rem !important;\n}\n.pl-sm-5 {\n    padding-left: 3rem !important;\n}\n.px-sm-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n}\n.py-sm-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n}\n.m-sm-auto {\n    margin: auto !important;\n}\n.mt-sm-auto {\n    margin-top: auto !important;\n}\n.mr-sm-auto {\n    margin-right: auto !important;\n}\n.mb-sm-auto {\n    margin-bottom: auto !important;\n}\n.ml-sm-auto {\n    margin-left: auto !important;\n}\n.mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n}\n.my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n}\n}\n@media (min-width: 768px) {\n.m-md-0 {\n    margin: 0 0 !important;\n}\n.mt-md-0 {\n    margin-top: 0 !important;\n}\n.mr-md-0 {\n    margin-right: 0 !important;\n}\n.mb-md-0 {\n    margin-bottom: 0 !important;\n}\n.ml-md-0 {\n    margin-left: 0 !important;\n}\n.mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n}\n.my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n}\n.m-md-1 {\n    margin: 0.25rem 0.25rem !important;\n}\n.mt-md-1 {\n    margin-top: 0.25rem !important;\n}\n.mr-md-1 {\n    margin-right: 0.25rem !important;\n}\n.mb-md-1 {\n    margin-bottom: 0.25rem !important;\n}\n.ml-md-1 {\n    margin-left: 0.25rem !important;\n}\n.mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n}\n.my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n}\n.m-md-2 {\n    margin: 0.5rem 0.5rem !important;\n}\n.mt-md-2 {\n    margin-top: 0.5rem !important;\n}\n.mr-md-2 {\n    margin-right: 0.5rem !important;\n}\n.mb-md-2 {\n    margin-bottom: 0.5rem !important;\n}\n.ml-md-2 {\n    margin-left: 0.5rem !important;\n}\n.mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n}\n.my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n}\n.m-md-3 {\n    margin: 1rem 1rem !important;\n}\n.mt-md-3 {\n    margin-top: 1rem !important;\n}\n.mr-md-3 {\n    margin-right: 1rem !important;\n}\n.mb-md-3 {\n    margin-bottom: 1rem !important;\n}\n.ml-md-3 {\n    margin-left: 1rem !important;\n}\n.mx-md-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n}\n.my-md-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n}\n.m-md-4 {\n    margin: 1.5rem 1.5rem !important;\n}\n.mt-md-4 {\n    margin-top: 1.5rem !important;\n}\n.mr-md-4 {\n    margin-right: 1.5rem !important;\n}\n.mb-md-4 {\n    margin-bottom: 1.5rem !important;\n}\n.ml-md-4 {\n    margin-left: 1.5rem !important;\n}\n.mx-md-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n}\n.my-md-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n}\n.m-md-5 {\n    margin: 3rem 3rem !important;\n}\n.mt-md-5 {\n    margin-top: 3rem !important;\n}\n.mr-md-5 {\n    margin-right: 3rem !important;\n}\n.mb-md-5 {\n    margin-bottom: 3rem !important;\n}\n.ml-md-5 {\n    margin-left: 3rem !important;\n}\n.mx-md-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n}\n.my-md-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n}\n.p-md-0 {\n    padding: 0 0 !important;\n}\n.pt-md-0 {\n    padding-top: 0 !important;\n}\n.pr-md-0 {\n    padding-right: 0 !important;\n}\n.pb-md-0 {\n    padding-bottom: 0 !important;\n}\n.pl-md-0 {\n    padding-left: 0 !important;\n}\n.px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n}\n.py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n}\n.p-md-1 {\n    padding: 0.25rem 0.25rem !important;\n}\n.pt-md-1 {\n    padding-top: 0.25rem !important;\n}\n.pr-md-1 {\n    padding-right: 0.25rem !important;\n}\n.pb-md-1 {\n    padding-bottom: 0.25rem !important;\n}\n.pl-md-1 {\n    padding-left: 0.25rem !important;\n}\n.px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n}\n.py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n}\n.p-md-2 {\n    padding: 0.5rem 0.5rem !important;\n}\n.pt-md-2 {\n    padding-top: 0.5rem !important;\n}\n.pr-md-2 {\n    padding-right: 0.5rem !important;\n}\n.pb-md-2 {\n    padding-bottom: 0.5rem !important;\n}\n.pl-md-2 {\n    padding-left: 0.5rem !important;\n}\n.px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n}\n.py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n}\n.p-md-3 {\n    padding: 1rem 1rem !important;\n}\n.pt-md-3 {\n    padding-top: 1rem !important;\n}\n.pr-md-3 {\n    padding-right: 1rem !important;\n}\n.pb-md-3 {\n    padding-bottom: 1rem !important;\n}\n.pl-md-3 {\n    padding-left: 1rem !important;\n}\n.px-md-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n}\n.py-md-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n}\n.p-md-4 {\n    padding: 1.5rem 1.5rem !important;\n}\n.pt-md-4 {\n    padding-top: 1.5rem !important;\n}\n.pr-md-4 {\n    padding-right: 1.5rem !important;\n}\n.pb-md-4 {\n    padding-bottom: 1.5rem !important;\n}\n.pl-md-4 {\n    padding-left: 1.5rem !important;\n}\n.px-md-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n}\n.py-md-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n}\n.p-md-5 {\n    padding: 3rem 3rem !important;\n}\n.pt-md-5 {\n    padding-top: 3rem !important;\n}\n.pr-md-5 {\n    padding-right: 3rem !important;\n}\n.pb-md-5 {\n    padding-bottom: 3rem !important;\n}\n.pl-md-5 {\n    padding-left: 3rem !important;\n}\n.px-md-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n}\n.py-md-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n}\n.m-md-auto {\n    margin: auto !important;\n}\n.mt-md-auto {\n    margin-top: auto !important;\n}\n.mr-md-auto {\n    margin-right: auto !important;\n}\n.mb-md-auto {\n    margin-bottom: auto !important;\n}\n.ml-md-auto {\n    margin-left: auto !important;\n}\n.mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n}\n.my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n}\n}\n@media (min-width: 992px) {\n.m-lg-0 {\n    margin: 0 0 !important;\n}\n.mt-lg-0 {\n    margin-top: 0 !important;\n}\n.mr-lg-0 {\n    margin-right: 0 !important;\n}\n.mb-lg-0 {\n    margin-bottom: 0 !important;\n}\n.ml-lg-0 {\n    margin-left: 0 !important;\n}\n.mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n}\n.my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n}\n.m-lg-1 {\n    margin: 0.25rem 0.25rem !important;\n}\n.mt-lg-1 {\n    margin-top: 0.25rem !important;\n}\n.mr-lg-1 {\n    margin-right: 0.25rem !important;\n}\n.mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n}\n.ml-lg-1 {\n    margin-left: 0.25rem !important;\n}\n.mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n}\n.my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n}\n.m-lg-2 {\n    margin: 0.5rem 0.5rem !important;\n}\n.mt-lg-2 {\n    margin-top: 0.5rem !important;\n}\n.mr-lg-2 {\n    margin-right: 0.5rem !important;\n}\n.mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n}\n.ml-lg-2 {\n    margin-left: 0.5rem !important;\n}\n.mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n}\n.my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n}\n.m-lg-3 {\n    margin: 1rem 1rem !important;\n}\n.mt-lg-3 {\n    margin-top: 1rem !important;\n}\n.mr-lg-3 {\n    margin-right: 1rem !important;\n}\n.mb-lg-3 {\n    margin-bottom: 1rem !important;\n}\n.ml-lg-3 {\n    margin-left: 1rem !important;\n}\n.mx-lg-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n}\n.my-lg-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n}\n.m-lg-4 {\n    margin: 1.5rem 1.5rem !important;\n}\n.mt-lg-4 {\n    margin-top: 1.5rem !important;\n}\n.mr-lg-4 {\n    margin-right: 1.5rem !important;\n}\n.mb-lg-4 {\n    margin-bottom: 1.5rem !important;\n}\n.ml-lg-4 {\n    margin-left: 1.5rem !important;\n}\n.mx-lg-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n}\n.my-lg-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n}\n.m-lg-5 {\n    margin: 3rem 3rem !important;\n}\n.mt-lg-5 {\n    margin-top: 3rem !important;\n}\n.mr-lg-5 {\n    margin-right: 3rem !important;\n}\n.mb-lg-5 {\n    margin-bottom: 3rem !important;\n}\n.ml-lg-5 {\n    margin-left: 3rem !important;\n}\n.mx-lg-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n}\n.my-lg-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n}\n.p-lg-0 {\n    padding: 0 0 !important;\n}\n.pt-lg-0 {\n    padding-top: 0 !important;\n}\n.pr-lg-0 {\n    padding-right: 0 !important;\n}\n.pb-lg-0 {\n    padding-bottom: 0 !important;\n}\n.pl-lg-0 {\n    padding-left: 0 !important;\n}\n.px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n}\n.py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n}\n.p-lg-1 {\n    padding: 0.25rem 0.25rem !important;\n}\n.pt-lg-1 {\n    padding-top: 0.25rem !important;\n}\n.pr-lg-1 {\n    padding-right: 0.25rem !important;\n}\n.pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n}\n.pl-lg-1 {\n    padding-left: 0.25rem !important;\n}\n.px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n}\n.py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n}\n.p-lg-2 {\n    padding: 0.5rem 0.5rem !important;\n}\n.pt-lg-2 {\n    padding-top: 0.5rem !important;\n}\n.pr-lg-2 {\n    padding-right: 0.5rem !important;\n}\n.pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n}\n.pl-lg-2 {\n    padding-left: 0.5rem !important;\n}\n.px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n}\n.py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n}\n.p-lg-3 {\n    padding: 1rem 1rem !important;\n}\n.pt-lg-3 {\n    padding-top: 1rem !important;\n}\n.pr-lg-3 {\n    padding-right: 1rem !important;\n}\n.pb-lg-3 {\n    padding-bottom: 1rem !important;\n}\n.pl-lg-3 {\n    padding-left: 1rem !important;\n}\n.px-lg-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n}\n.py-lg-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n}\n.p-lg-4 {\n    padding: 1.5rem 1.5rem !important;\n}\n.pt-lg-4 {\n    padding-top: 1.5rem !important;\n}\n.pr-lg-4 {\n    padding-right: 1.5rem !important;\n}\n.pb-lg-4 {\n    padding-bottom: 1.5rem !important;\n}\n.pl-lg-4 {\n    padding-left: 1.5rem !important;\n}\n.px-lg-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n}\n.py-lg-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n}\n.p-lg-5 {\n    padding: 3rem 3rem !important;\n}\n.pt-lg-5 {\n    padding-top: 3rem !important;\n}\n.pr-lg-5 {\n    padding-right: 3rem !important;\n}\n.pb-lg-5 {\n    padding-bottom: 3rem !important;\n}\n.pl-lg-5 {\n    padding-left: 3rem !important;\n}\n.px-lg-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n}\n.py-lg-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n}\n.m-lg-auto {\n    margin: auto !important;\n}\n.mt-lg-auto {\n    margin-top: auto !important;\n}\n.mr-lg-auto {\n    margin-right: auto !important;\n}\n.mb-lg-auto {\n    margin-bottom: auto !important;\n}\n.ml-lg-auto {\n    margin-left: auto !important;\n}\n.mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n}\n.my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n}\n}\n@media (min-width: 1200px) {\n.m-xl-0 {\n    margin: 0 0 !important;\n}\n.mt-xl-0 {\n    margin-top: 0 !important;\n}\n.mr-xl-0 {\n    margin-right: 0 !important;\n}\n.mb-xl-0 {\n    margin-bottom: 0 !important;\n}\n.ml-xl-0 {\n    margin-left: 0 !important;\n}\n.mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n}\n.my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n}\n.m-xl-1 {\n    margin: 0.25rem 0.25rem !important;\n}\n.mt-xl-1 {\n    margin-top: 0.25rem !important;\n}\n.mr-xl-1 {\n    margin-right: 0.25rem !important;\n}\n.mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n}\n.ml-xl-1 {\n    margin-left: 0.25rem !important;\n}\n.mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n}\n.my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n}\n.m-xl-2 {\n    margin: 0.5rem 0.5rem !important;\n}\n.mt-xl-2 {\n    margin-top: 0.5rem !important;\n}\n.mr-xl-2 {\n    margin-right: 0.5rem !important;\n}\n.mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n}\n.ml-xl-2 {\n    margin-left: 0.5rem !important;\n}\n.mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n}\n.my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n}\n.m-xl-3 {\n    margin: 1rem 1rem !important;\n}\n.mt-xl-3 {\n    margin-top: 1rem !important;\n}\n.mr-xl-3 {\n    margin-right: 1rem !important;\n}\n.mb-xl-3 {\n    margin-bottom: 1rem !important;\n}\n.ml-xl-3 {\n    margin-left: 1rem !important;\n}\n.mx-xl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n}\n.my-xl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n}\n.m-xl-4 {\n    margin: 1.5rem 1.5rem !important;\n}\n.mt-xl-4 {\n    margin-top: 1.5rem !important;\n}\n.mr-xl-4 {\n    margin-right: 1.5rem !important;\n}\n.mb-xl-4 {\n    margin-bottom: 1.5rem !important;\n}\n.ml-xl-4 {\n    margin-left: 1.5rem !important;\n}\n.mx-xl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n}\n.my-xl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n}\n.m-xl-5 {\n    margin: 3rem 3rem !important;\n}\n.mt-xl-5 {\n    margin-top: 3rem !important;\n}\n.mr-xl-5 {\n    margin-right: 3rem !important;\n}\n.mb-xl-5 {\n    margin-bottom: 3rem !important;\n}\n.ml-xl-5 {\n    margin-left: 3rem !important;\n}\n.mx-xl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n}\n.my-xl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n}\n.p-xl-0 {\n    padding: 0 0 !important;\n}\n.pt-xl-0 {\n    padding-top: 0 !important;\n}\n.pr-xl-0 {\n    padding-right: 0 !important;\n}\n.pb-xl-0 {\n    padding-bottom: 0 !important;\n}\n.pl-xl-0 {\n    padding-left: 0 !important;\n}\n.px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n}\n.py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n}\n.p-xl-1 {\n    padding: 0.25rem 0.25rem !important;\n}\n.pt-xl-1 {\n    padding-top: 0.25rem !important;\n}\n.pr-xl-1 {\n    padding-right: 0.25rem !important;\n}\n.pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n}\n.pl-xl-1 {\n    padding-left: 0.25rem !important;\n}\n.px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n}\n.py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n}\n.p-xl-2 {\n    padding: 0.5rem 0.5rem !important;\n}\n.pt-xl-2 {\n    padding-top: 0.5rem !important;\n}\n.pr-xl-2 {\n    padding-right: 0.5rem !important;\n}\n.pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n}\n.pl-xl-2 {\n    padding-left: 0.5rem !important;\n}\n.px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n}\n.py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n}\n.p-xl-3 {\n    padding: 1rem 1rem !important;\n}\n.pt-xl-3 {\n    padding-top: 1rem !important;\n}\n.pr-xl-3 {\n    padding-right: 1rem !important;\n}\n.pb-xl-3 {\n    padding-bottom: 1rem !important;\n}\n.pl-xl-3 {\n    padding-left: 1rem !important;\n}\n.px-xl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n}\n.py-xl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n}\n.p-xl-4 {\n    padding: 1.5rem 1.5rem !important;\n}\n.pt-xl-4 {\n    padding-top: 1.5rem !important;\n}\n.pr-xl-4 {\n    padding-right: 1.5rem !important;\n}\n.pb-xl-4 {\n    padding-bottom: 1.5rem !important;\n}\n.pl-xl-4 {\n    padding-left: 1.5rem !important;\n}\n.px-xl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n}\n.py-xl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n}\n.p-xl-5 {\n    padding: 3rem 3rem !important;\n}\n.pt-xl-5 {\n    padding-top: 3rem !important;\n}\n.pr-xl-5 {\n    padding-right: 3rem !important;\n}\n.pb-xl-5 {\n    padding-bottom: 3rem !important;\n}\n.pl-xl-5 {\n    padding-left: 3rem !important;\n}\n.px-xl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n}\n.py-xl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n}\n.m-xl-auto {\n    margin: auto !important;\n}\n.mt-xl-auto {\n    margin-top: auto !important;\n}\n.mr-xl-auto {\n    margin-right: auto !important;\n}\n.mb-xl-auto {\n    margin-bottom: auto !important;\n}\n.ml-xl-auto {\n    margin-left: auto !important;\n}\n.mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n}\n.my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n}\n}\n.text-justify {\n  text-align: justify !important;\n}\n.text-nowrap {\n  white-space: nowrap !important;\n}\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.text-left {\n  text-align: left !important;\n}\n.text-right {\n  text-align: right !important;\n}\n.text-center {\n  text-align: center !important;\n}\n@media (min-width: 576px) {\n.text-sm-left {\n    text-align: left !important;\n}\n.text-sm-right {\n    text-align: right !important;\n}\n.text-sm-center {\n    text-align: center !important;\n}\n}\n@media (min-width: 768px) {\n.text-md-left {\n    text-align: left !important;\n}\n.text-md-right {\n    text-align: right !important;\n}\n.text-md-center {\n    text-align: center !important;\n}\n}\n@media (min-width: 992px) {\n.text-lg-left {\n    text-align: left !important;\n}\n.text-lg-right {\n    text-align: right !important;\n}\n.text-lg-center {\n    text-align: center !important;\n}\n}\n@media (min-width: 1200px) {\n.text-xl-left {\n    text-align: left !important;\n}\n.text-xl-right {\n    text-align: right !important;\n}\n.text-xl-center {\n    text-align: center !important;\n}\n}\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n.font-weight-normal {\n  font-weight: normal;\n}\n.font-weight-bold {\n  font-weight: bold;\n}\n.font-italic {\n  font-style: italic;\n}\n.text-white {\n  color: #fff !important;\n}\n.text-muted {\n  color: #636c72 !important;\n}\na.text-muted:focus, a.text-muted:hover {\n  color: #4b5257 !important;\n}\n.text-primary {\n  color: #0275d8 !important;\n}\na.text-primary:focus, a.text-primary:hover {\n  color: #025aa5 !important;\n}\n.text-success {\n  color: #5cb85c !important;\n}\na.text-success:focus, a.text-success:hover {\n  color: #449d44 !important;\n}\n.text-info {\n  color: #5bc0de !important;\n}\na.text-info:focus, a.text-info:hover {\n  color: #31b0d5 !important;\n}\n.text-warning {\n  color: #f0ad4e !important;\n}\na.text-warning:focus, a.text-warning:hover {\n  color: #ec971f !important;\n}\n.text-danger {\n  color: #d9534f !important;\n}\na.text-danger:focus, a.text-danger:hover {\n  color: #c9302c !important;\n}\n.text-gray-dark {\n  color: #292b2c !important;\n}\na.text-gray-dark:focus, a.text-gray-dark:hover {\n  color: #101112 !important;\n}\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n.invisible {\n  visibility: hidden !important;\n}\n.hidden-xs-up {\n  display: none !important;\n}\n@media (max-width: 575px) {\n.hidden-xs-down {\n    display: none !important;\n}\n}\n@media (min-width: 576px) {\n.hidden-sm-up {\n    display: none !important;\n}\n}\n@media (max-width: 767px) {\n.hidden-sm-down {\n    display: none !important;\n}\n}\n@media (min-width: 768px) {\n.hidden-md-up {\n    display: none !important;\n}\n}\n@media (max-width: 991px) {\n.hidden-md-down {\n    display: none !important;\n}\n}\n@media (min-width: 992px) {\n.hidden-lg-up {\n    display: none !important;\n}\n}\n@media (max-width: 1199px) {\n.hidden-lg-down {\n    display: none !important;\n}\n}\n@media (min-width: 1200px) {\n.hidden-xl-up {\n    display: none !important;\n}\n}\n.hidden-xl-down {\n  display: none !important;\n}\n.visible-print-block {\n  display: none !important;\n}\n@media print {\n.visible-print-block {\n      display: block !important;\n}\n}\n.visible-print-inline {\n  display: none !important;\n}\n@media print {\n.visible-print-inline {\n      display: inline !important;\n}\n}\n.visible-print-inline-block {\n  display: none !important;\n}\n@media print {\n.visible-print-inline-block {\n      display: inline-block !important;\n}\n}\n@media print {\n.hidden-print {\n    display: none !important;\n}\n}\n\n/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */\n/* FONT PATH\n * -------------------------- */\n@font-face {\n  font-family: 'FontAwesome';\n  src: url(" + __webpack_require__(686) + ");\n  src: url(" + __webpack_require__(685) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"), url(" + __webpack_require__(688) + ") format(\"woff2\"), url(" + __webpack_require__(689) + ") format(\"woff\"), url(" + __webpack_require__(687) + ") format(\"truetype\"), url(" + __webpack_require__(649) + "#fontawesomeregular) format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n.fa {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* makes the font 33% larger relative to the icon container */\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n.fa-2x {\n  font-size: 2em;\n}\n.fa-3x {\n  font-size: 3em;\n}\n.fa-4x {\n  font-size: 4em;\n}\n.fa-5x {\n  font-size: 5em;\n}\n.fa-fw {\n  width: 1.28571em;\n  text-align: center;\n}\n.fa-ul {\n  padding-left: 0;\n  margin-left: 2.14286em;\n  list-style-type: none;\n}\n.fa-ul > li {\n    position: relative;\n}\n.fa-li {\n  position: absolute;\n  left: -2.14286em;\n  width: 2.14286em;\n  top: 0.14286em;\n  text-align: center;\n}\n.fa-li.fa-lg {\n    left: -1.85714em;\n}\n.fa-border {\n  padding: .2em .25em .15em;\n  border: solid 0.08em #eee;\n  border-radius: .1em;\n}\n.fa-pull-left {\n  float: left;\n}\n.fa-pull-right {\n  float: right;\n}\n.fa.fa-pull-left {\n  margin-right: .3em;\n}\n.fa.fa-pull-right {\n  margin-left: .3em;\n}\n\n/* Deprecated as of 4.4.0 */\n.pull-right {\n  float: right;\n}\n.pull-left {\n  float: left;\n}\n.fa.pull-left {\n  margin-right: .3em;\n}\n.fa.pull-right {\n  margin-left: .3em;\n}\n.fa-spin {\n  animation: fa-spin 2s infinite linear;\n}\n.fa-pulse {\n  animation: fa-spin 1s infinite steps(8);\n}\n@keyframes fa-spin {\n0% {\n    transform: rotate(0deg);\n}\n100% {\n    transform: rotate(359deg);\n}\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  transform: rotate(90deg);\n}\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  transform: rotate(180deg);\n}\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  transform: rotate(270deg);\n}\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  transform: scale(-1, 1);\n}\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  transform: scale(1, -1);\n}\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical {\n  filter: none;\n}\n.fa-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n.fa-stack-1x, .fa-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n.fa-stack-1x {\n  line-height: inherit;\n}\n.fa-stack-2x {\n  font-size: 2em;\n}\n.fa-inverse {\n  color: #fff;\n}\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\n   readers do not read off random characters that represent icons */\n.fa-glass:before {\n  content: \"\\F000\";\n}\n.fa-music:before {\n  content: \"\\F001\";\n}\n.fa-search:before {\n  content: \"\\F002\";\n}\n.fa-envelope-o:before {\n  content: \"\\F003\";\n}\n.fa-heart:before {\n  content: \"\\F004\";\n}\n.fa-star:before {\n  content: \"\\F005\";\n}\n.fa-star-o:before {\n  content: \"\\F006\";\n}\n.fa-user:before {\n  content: \"\\F007\";\n}\n.fa-film:before {\n  content: \"\\F008\";\n}\n.fa-th-large:before {\n  content: \"\\F009\";\n}\n.fa-th:before {\n  content: \"\\F00A\";\n}\n.fa-th-list:before {\n  content: \"\\F00B\";\n}\n.fa-check:before {\n  content: \"\\F00C\";\n}\n.fa-remove:before,\n.fa-close:before,\n.fa-times:before {\n  content: \"\\F00D\";\n}\n.fa-search-plus:before {\n  content: \"\\F00E\";\n}\n.fa-search-minus:before {\n  content: \"\\F010\";\n}\n.fa-power-off:before {\n  content: \"\\F011\";\n}\n.fa-signal:before {\n  content: \"\\F012\";\n}\n.fa-gear:before,\n.fa-cog:before {\n  content: \"\\F013\";\n}\n.fa-trash-o:before {\n  content: \"\\F014\";\n}\n.fa-home:before {\n  content: \"\\F015\";\n}\n.fa-file-o:before {\n  content: \"\\F016\";\n}\n.fa-clock-o:before {\n  content: \"\\F017\";\n}\n.fa-road:before {\n  content: \"\\F018\";\n}\n.fa-download:before {\n  content: \"\\F019\";\n}\n.fa-arrow-circle-o-down:before {\n  content: \"\\F01A\";\n}\n.fa-arrow-circle-o-up:before {\n  content: \"\\F01B\";\n}\n.fa-inbox:before {\n  content: \"\\F01C\";\n}\n.fa-play-circle-o:before {\n  content: \"\\F01D\";\n}\n.fa-rotate-right:before,\n.fa-repeat:before {\n  content: \"\\F01E\";\n}\n.fa-refresh:before {\n  content: \"\\F021\";\n}\n.fa-list-alt:before {\n  content: \"\\F022\";\n}\n.fa-lock:before {\n  content: \"\\F023\";\n}\n.fa-flag:before {\n  content: \"\\F024\";\n}\n.fa-headphones:before {\n  content: \"\\F025\";\n}\n.fa-volume-off:before {\n  content: \"\\F026\";\n}\n.fa-volume-down:before {\n  content: \"\\F027\";\n}\n.fa-volume-up:before {\n  content: \"\\F028\";\n}\n.fa-qrcode:before {\n  content: \"\\F029\";\n}\n.fa-barcode:before {\n  content: \"\\F02A\";\n}\n.fa-tag:before {\n  content: \"\\F02B\";\n}\n.fa-tags:before {\n  content: \"\\F02C\";\n}\n.fa-book:before {\n  content: \"\\F02D\";\n}\n.fa-bookmark:before {\n  content: \"\\F02E\";\n}\n.fa-print:before {\n  content: \"\\F02F\";\n}\n.fa-camera:before {\n  content: \"\\F030\";\n}\n.fa-font:before {\n  content: \"\\F031\";\n}\n.fa-bold:before {\n  content: \"\\F032\";\n}\n.fa-italic:before {\n  content: \"\\F033\";\n}\n.fa-text-height:before {\n  content: \"\\F034\";\n}\n.fa-text-width:before {\n  content: \"\\F035\";\n}\n.fa-align-left:before {\n  content: \"\\F036\";\n}\n.fa-align-center:before {\n  content: \"\\F037\";\n}\n.fa-align-right:before {\n  content: \"\\F038\";\n}\n.fa-align-justify:before {\n  content: \"\\F039\";\n}\n.fa-list:before {\n  content: \"\\F03A\";\n}\n.fa-dedent:before,\n.fa-outdent:before {\n  content: \"\\F03B\";\n}\n.fa-indent:before {\n  content: \"\\F03C\";\n}\n.fa-video-camera:before {\n  content: \"\\F03D\";\n}\n.fa-photo:before,\n.fa-image:before,\n.fa-picture-o:before {\n  content: \"\\F03E\";\n}\n.fa-pencil:before {\n  content: \"\\F040\";\n}\n.fa-map-marker:before {\n  content: \"\\F041\";\n}\n.fa-adjust:before {\n  content: \"\\F042\";\n}\n.fa-tint:before {\n  content: \"\\F043\";\n}\n.fa-edit:before,\n.fa-pencil-square-o:before {\n  content: \"\\F044\";\n}\n.fa-share-square-o:before {\n  content: \"\\F045\";\n}\n.fa-check-square-o:before {\n  content: \"\\F046\";\n}\n.fa-arrows:before {\n  content: \"\\F047\";\n}\n.fa-step-backward:before {\n  content: \"\\F048\";\n}\n.fa-fast-backward:before {\n  content: \"\\F049\";\n}\n.fa-backward:before {\n  content: \"\\F04A\";\n}\n.fa-play:before {\n  content: \"\\F04B\";\n}\n.fa-pause:before {\n  content: \"\\F04C\";\n}\n.fa-stop:before {\n  content: \"\\F04D\";\n}\n.fa-forward:before {\n  content: \"\\F04E\";\n}\n.fa-fast-forward:before {\n  content: \"\\F050\";\n}\n.fa-step-forward:before {\n  content: \"\\F051\";\n}\n.fa-eject:before {\n  content: \"\\F052\";\n}\n.fa-chevron-left:before {\n  content: \"\\F053\";\n}\n.fa-chevron-right:before {\n  content: \"\\F054\";\n}\n.fa-plus-circle:before {\n  content: \"\\F055\";\n}\n.fa-minus-circle:before {\n  content: \"\\F056\";\n}\n.fa-times-circle:before {\n  content: \"\\F057\";\n}\n.fa-check-circle:before {\n  content: \"\\F058\";\n}\n.fa-question-circle:before {\n  content: \"\\F059\";\n}\n.fa-info-circle:before {\n  content: \"\\F05A\";\n}\n.fa-crosshairs:before {\n  content: \"\\F05B\";\n}\n.fa-times-circle-o:before {\n  content: \"\\F05C\";\n}\n.fa-check-circle-o:before {\n  content: \"\\F05D\";\n}\n.fa-ban:before {\n  content: \"\\F05E\";\n}\n.fa-arrow-left:before {\n  content: \"\\F060\";\n}\n.fa-arrow-right:before {\n  content: \"\\F061\";\n}\n.fa-arrow-up:before {\n  content: \"\\F062\";\n}\n.fa-arrow-down:before {\n  content: \"\\F063\";\n}\n.fa-mail-forward:before,\n.fa-share:before {\n  content: \"\\F064\";\n}\n.fa-expand:before {\n  content: \"\\F065\";\n}\n.fa-compress:before {\n  content: \"\\F066\";\n}\n.fa-plus:before {\n  content: \"\\F067\";\n}\n.fa-minus:before {\n  content: \"\\F068\";\n}\n.fa-asterisk:before {\n  content: \"\\F069\";\n}\n.fa-exclamation-circle:before {\n  content: \"\\F06A\";\n}\n.fa-gift:before {\n  content: \"\\F06B\";\n}\n.fa-leaf:before {\n  content: \"\\F06C\";\n}\n.fa-fire:before {\n  content: \"\\F06D\";\n}\n.fa-eye:before {\n  content: \"\\F06E\";\n}\n.fa-eye-slash:before {\n  content: \"\\F070\";\n}\n.fa-warning:before,\n.fa-exclamation-triangle:before {\n  content: \"\\F071\";\n}\n.fa-plane:before {\n  content: \"\\F072\";\n}\n.fa-calendar:before {\n  content: \"\\F073\";\n}\n.fa-random:before {\n  content: \"\\F074\";\n}\n.fa-comment:before {\n  content: \"\\F075\";\n}\n.fa-magnet:before {\n  content: \"\\F076\";\n}\n.fa-chevron-up:before {\n  content: \"\\F077\";\n}\n.fa-chevron-down:before {\n  content: \"\\F078\";\n}\n.fa-retweet:before {\n  content: \"\\F079\";\n}\n.fa-shopping-cart:before {\n  content: \"\\F07A\";\n}\n.fa-folder:before {\n  content: \"\\F07B\";\n}\n.fa-folder-open:before {\n  content: \"\\F07C\";\n}\n.fa-arrows-v:before {\n  content: \"\\F07D\";\n}\n.fa-arrows-h:before {\n  content: \"\\F07E\";\n}\n.fa-bar-chart-o:before,\n.fa-bar-chart:before {\n  content: \"\\F080\";\n}\n.fa-twitter-square:before {\n  content: \"\\F081\";\n}\n.fa-facebook-square:before {\n  content: \"\\F082\";\n}\n.fa-camera-retro:before {\n  content: \"\\F083\";\n}\n.fa-key:before {\n  content: \"\\F084\";\n}\n.fa-gears:before,\n.fa-cogs:before {\n  content: \"\\F085\";\n}\n.fa-comments:before {\n  content: \"\\F086\";\n}\n.fa-thumbs-o-up:before {\n  content: \"\\F087\";\n}\n.fa-thumbs-o-down:before {\n  content: \"\\F088\";\n}\n.fa-star-half:before {\n  content: \"\\F089\";\n}\n.fa-heart-o:before {\n  content: \"\\F08A\";\n}\n.fa-sign-out:before {\n  content: \"\\F08B\";\n}\n.fa-linkedin-square:before {\n  content: \"\\F08C\";\n}\n.fa-thumb-tack:before {\n  content: \"\\F08D\";\n}\n.fa-external-link:before {\n  content: \"\\F08E\";\n}\n.fa-sign-in:before {\n  content: \"\\F090\";\n}\n.fa-trophy:before {\n  content: \"\\F091\";\n}\n.fa-github-square:before {\n  content: \"\\F092\";\n}\n.fa-upload:before {\n  content: \"\\F093\";\n}\n.fa-lemon-o:before {\n  content: \"\\F094\";\n}\n.fa-phone:before {\n  content: \"\\F095\";\n}\n.fa-square-o:before {\n  content: \"\\F096\";\n}\n.fa-bookmark-o:before {\n  content: \"\\F097\";\n}\n.fa-phone-square:before {\n  content: \"\\F098\";\n}\n.fa-twitter:before {\n  content: \"\\F099\";\n}\n.fa-facebook-f:before,\n.fa-facebook:before {\n  content: \"\\F09A\";\n}\n.fa-github:before {\n  content: \"\\F09B\";\n}\n.fa-unlock:before {\n  content: \"\\F09C\";\n}\n.fa-credit-card:before {\n  content: \"\\F09D\";\n}\n.fa-feed:before,\n.fa-rss:before {\n  content: \"\\F09E\";\n}\n.fa-hdd-o:before {\n  content: \"\\F0A0\";\n}\n.fa-bullhorn:before {\n  content: \"\\F0A1\";\n}\n.fa-bell:before {\n  content: \"\\F0F3\";\n}\n.fa-certificate:before {\n  content: \"\\F0A3\";\n}\n.fa-hand-o-right:before {\n  content: \"\\F0A4\";\n}\n.fa-hand-o-left:before {\n  content: \"\\F0A5\";\n}\n.fa-hand-o-up:before {\n  content: \"\\F0A6\";\n}\n.fa-hand-o-down:before {\n  content: \"\\F0A7\";\n}\n.fa-arrow-circle-left:before {\n  content: \"\\F0A8\";\n}\n.fa-arrow-circle-right:before {\n  content: \"\\F0A9\";\n}\n.fa-arrow-circle-up:before {\n  content: \"\\F0AA\";\n}\n.fa-arrow-circle-down:before {\n  content: \"\\F0AB\";\n}\n.fa-globe:before {\n  content: \"\\F0AC\";\n}\n.fa-wrench:before {\n  content: \"\\F0AD\";\n}\n.fa-tasks:before {\n  content: \"\\F0AE\";\n}\n.fa-filter:before {\n  content: \"\\F0B0\";\n}\n.fa-briefcase:before {\n  content: \"\\F0B1\";\n}\n.fa-arrows-alt:before {\n  content: \"\\F0B2\";\n}\n.fa-group:before,\n.fa-users:before {\n  content: \"\\F0C0\";\n}\n.fa-chain:before,\n.fa-link:before {\n  content: \"\\F0C1\";\n}\n.fa-cloud:before {\n  content: \"\\F0C2\";\n}\n.fa-flask:before {\n  content: \"\\F0C3\";\n}\n.fa-cut:before,\n.fa-scissors:before {\n  content: \"\\F0C4\";\n}\n.fa-copy:before,\n.fa-files-o:before {\n  content: \"\\F0C5\";\n}\n.fa-paperclip:before {\n  content: \"\\F0C6\";\n}\n.fa-save:before,\n.fa-floppy-o:before {\n  content: \"\\F0C7\";\n}\n.fa-square:before {\n  content: \"\\F0C8\";\n}\n.fa-navicon:before,\n.fa-reorder:before,\n.fa-bars:before {\n  content: \"\\F0C9\";\n}\n.fa-list-ul:before {\n  content: \"\\F0CA\";\n}\n.fa-list-ol:before {\n  content: \"\\F0CB\";\n}\n.fa-strikethrough:before {\n  content: \"\\F0CC\";\n}\n.fa-underline:before {\n  content: \"\\F0CD\";\n}\n.fa-table:before {\n  content: \"\\F0CE\";\n}\n.fa-magic:before {\n  content: \"\\F0D0\";\n}\n.fa-truck:before {\n  content: \"\\F0D1\";\n}\n.fa-pinterest:before {\n  content: \"\\F0D2\";\n}\n.fa-pinterest-square:before {\n  content: \"\\F0D3\";\n}\n.fa-google-plus-square:before {\n  content: \"\\F0D4\";\n}\n.fa-google-plus:before {\n  content: \"\\F0D5\";\n}\n.fa-money:before {\n  content: \"\\F0D6\";\n}\n.fa-caret-down:before {\n  content: \"\\F0D7\";\n}\n.fa-caret-up:before {\n  content: \"\\F0D8\";\n}\n.fa-caret-left:before {\n  content: \"\\F0D9\";\n}\n.fa-caret-right:before {\n  content: \"\\F0DA\";\n}\n.fa-columns:before {\n  content: \"\\F0DB\";\n}\n.fa-unsorted:before,\n.fa-sort:before {\n  content: \"\\F0DC\";\n}\n.fa-sort-down:before,\n.fa-sort-desc:before {\n  content: \"\\F0DD\";\n}\n.fa-sort-up:before,\n.fa-sort-asc:before {\n  content: \"\\F0DE\";\n}\n.fa-envelope:before {\n  content: \"\\F0E0\";\n}\n.fa-linkedin:before {\n  content: \"\\F0E1\";\n}\n.fa-rotate-left:before,\n.fa-undo:before {\n  content: \"\\F0E2\";\n}\n.fa-legal:before,\n.fa-gavel:before {\n  content: \"\\F0E3\";\n}\n.fa-dashboard:before,\n.fa-tachometer:before {\n  content: \"\\F0E4\";\n}\n.fa-comment-o:before {\n  content: \"\\F0E5\";\n}\n.fa-comments-o:before {\n  content: \"\\F0E6\";\n}\n.fa-flash:before,\n.fa-bolt:before {\n  content: \"\\F0E7\";\n}\n.fa-sitemap:before {\n  content: \"\\F0E8\";\n}\n.fa-umbrella:before {\n  content: \"\\F0E9\";\n}\n.fa-paste:before,\n.fa-clipboard:before {\n  content: \"\\F0EA\";\n}\n.fa-lightbulb-o:before {\n  content: \"\\F0EB\";\n}\n.fa-exchange:before {\n  content: \"\\F0EC\";\n}\n.fa-cloud-download:before {\n  content: \"\\F0ED\";\n}\n.fa-cloud-upload:before {\n  content: \"\\F0EE\";\n}\n.fa-user-md:before {\n  content: \"\\F0F0\";\n}\n.fa-stethoscope:before {\n  content: \"\\F0F1\";\n}\n.fa-suitcase:before {\n  content: \"\\F0F2\";\n}\n.fa-bell-o:before {\n  content: \"\\F0A2\";\n}\n.fa-coffee:before {\n  content: \"\\F0F4\";\n}\n.fa-cutlery:before {\n  content: \"\\F0F5\";\n}\n.fa-file-text-o:before {\n  content: \"\\F0F6\";\n}\n.fa-building-o:before {\n  content: \"\\F0F7\";\n}\n.fa-hospital-o:before {\n  content: \"\\F0F8\";\n}\n.fa-ambulance:before {\n  content: \"\\F0F9\";\n}\n.fa-medkit:before {\n  content: \"\\F0FA\";\n}\n.fa-fighter-jet:before {\n  content: \"\\F0FB\";\n}\n.fa-beer:before {\n  content: \"\\F0FC\";\n}\n.fa-h-square:before {\n  content: \"\\F0FD\";\n}\n.fa-plus-square:before {\n  content: \"\\F0FE\";\n}\n.fa-angle-double-left:before {\n  content: \"\\F100\";\n}\n.fa-angle-double-right:before {\n  content: \"\\F101\";\n}\n.fa-angle-double-up:before {\n  content: \"\\F102\";\n}\n.fa-angle-double-down:before {\n  content: \"\\F103\";\n}\n.fa-angle-left:before {\n  content: \"\\F104\";\n}\n.fa-angle-right:before {\n  content: \"\\F105\";\n}\n.fa-angle-up:before {\n  content: \"\\F106\";\n}\n.fa-angle-down:before {\n  content: \"\\F107\";\n}\n.fa-desktop:before {\n  content: \"\\F108\";\n}\n.fa-laptop:before {\n  content: \"\\F109\";\n}\n.fa-tablet:before {\n  content: \"\\F10A\";\n}\n.fa-mobile-phone:before,\n.fa-mobile:before {\n  content: \"\\F10B\";\n}\n.fa-circle-o:before {\n  content: \"\\F10C\";\n}\n.fa-quote-left:before {\n  content: \"\\F10D\";\n}\n.fa-quote-right:before {\n  content: \"\\F10E\";\n}\n.fa-spinner:before {\n  content: \"\\F110\";\n}\n.fa-circle:before {\n  content: \"\\F111\";\n}\n.fa-mail-reply:before,\n.fa-reply:before {\n  content: \"\\F112\";\n}\n.fa-github-alt:before {\n  content: \"\\F113\";\n}\n.fa-folder-o:before {\n  content: \"\\F114\";\n}\n.fa-folder-open-o:before {\n  content: \"\\F115\";\n}\n.fa-smile-o:before {\n  content: \"\\F118\";\n}\n.fa-frown-o:before {\n  content: \"\\F119\";\n}\n.fa-meh-o:before {\n  content: \"\\F11A\";\n}\n.fa-gamepad:before {\n  content: \"\\F11B\";\n}\n.fa-keyboard-o:before {\n  content: \"\\F11C\";\n}\n.fa-flag-o:before {\n  content: \"\\F11D\";\n}\n.fa-flag-checkered:before {\n  content: \"\\F11E\";\n}\n.fa-terminal:before {\n  content: \"\\F120\";\n}\n.fa-code:before {\n  content: \"\\F121\";\n}\n.fa-mail-reply-all:before,\n.fa-reply-all:before {\n  content: \"\\F122\";\n}\n.fa-star-half-empty:before,\n.fa-star-half-full:before,\n.fa-star-half-o:before {\n  content: \"\\F123\";\n}\n.fa-location-arrow:before {\n  content: \"\\F124\";\n}\n.fa-crop:before {\n  content: \"\\F125\";\n}\n.fa-code-fork:before {\n  content: \"\\F126\";\n}\n.fa-unlink:before,\n.fa-chain-broken:before {\n  content: \"\\F127\";\n}\n.fa-question:before {\n  content: \"\\F128\";\n}\n.fa-info:before {\n  content: \"\\F129\";\n}\n.fa-exclamation:before {\n  content: \"\\F12A\";\n}\n.fa-superscript:before {\n  content: \"\\F12B\";\n}\n.fa-subscript:before {\n  content: \"\\F12C\";\n}\n.fa-eraser:before {\n  content: \"\\F12D\";\n}\n.fa-puzzle-piece:before {\n  content: \"\\F12E\";\n}\n.fa-microphone:before {\n  content: \"\\F130\";\n}\n.fa-microphone-slash:before {\n  content: \"\\F131\";\n}\n.fa-shield:before {\n  content: \"\\F132\";\n}\n.fa-calendar-o:before {\n  content: \"\\F133\";\n}\n.fa-fire-extinguisher:before {\n  content: \"\\F134\";\n}\n.fa-rocket:before {\n  content: \"\\F135\";\n}\n.fa-maxcdn:before {\n  content: \"\\F136\";\n}\n.fa-chevron-circle-left:before {\n  content: \"\\F137\";\n}\n.fa-chevron-circle-right:before {\n  content: \"\\F138\";\n}\n.fa-chevron-circle-up:before {\n  content: \"\\F139\";\n}\n.fa-chevron-circle-down:before {\n  content: \"\\F13A\";\n}\n.fa-html5:before {\n  content: \"\\F13B\";\n}\n.fa-css3:before {\n  content: \"\\F13C\";\n}\n.fa-anchor:before {\n  content: \"\\F13D\";\n}\n.fa-unlock-alt:before {\n  content: \"\\F13E\";\n}\n.fa-bullseye:before {\n  content: \"\\F140\";\n}\n.fa-ellipsis-h:before {\n  content: \"\\F141\";\n}\n.fa-ellipsis-v:before {\n  content: \"\\F142\";\n}\n.fa-rss-square:before {\n  content: \"\\F143\";\n}\n.fa-play-circle:before {\n  content: \"\\F144\";\n}\n.fa-ticket:before {\n  content: \"\\F145\";\n}\n.fa-minus-square:before {\n  content: \"\\F146\";\n}\n.fa-minus-square-o:before {\n  content: \"\\F147\";\n}\n.fa-level-up:before {\n  content: \"\\F148\";\n}\n.fa-level-down:before {\n  content: \"\\F149\";\n}\n.fa-check-square:before {\n  content: \"\\F14A\";\n}\n.fa-pencil-square:before {\n  content: \"\\F14B\";\n}\n.fa-external-link-square:before {\n  content: \"\\F14C\";\n}\n.fa-share-square:before {\n  content: \"\\F14D\";\n}\n.fa-compass:before {\n  content: \"\\F14E\";\n}\n.fa-toggle-down:before,\n.fa-caret-square-o-down:before {\n  content: \"\\F150\";\n}\n.fa-toggle-up:before,\n.fa-caret-square-o-up:before {\n  content: \"\\F151\";\n}\n.fa-toggle-right:before,\n.fa-caret-square-o-right:before {\n  content: \"\\F152\";\n}\n.fa-euro:before,\n.fa-eur:before {\n  content: \"\\F153\";\n}\n.fa-gbp:before {\n  content: \"\\F154\";\n}\n.fa-dollar:before,\n.fa-usd:before {\n  content: \"\\F155\";\n}\n.fa-rupee:before,\n.fa-inr:before {\n  content: \"\\F156\";\n}\n.fa-cny:before,\n.fa-rmb:before,\n.fa-yen:before,\n.fa-jpy:before {\n  content: \"\\F157\";\n}\n.fa-ruble:before,\n.fa-rouble:before,\n.fa-rub:before {\n  content: \"\\F158\";\n}\n.fa-won:before,\n.fa-krw:before {\n  content: \"\\F159\";\n}\n.fa-bitcoin:before,\n.fa-btc:before {\n  content: \"\\F15A\";\n}\n.fa-file:before {\n  content: \"\\F15B\";\n}\n.fa-file-text:before {\n  content: \"\\F15C\";\n}\n.fa-sort-alpha-asc:before {\n  content: \"\\F15D\";\n}\n.fa-sort-alpha-desc:before {\n  content: \"\\F15E\";\n}\n.fa-sort-amount-asc:before {\n  content: \"\\F160\";\n}\n.fa-sort-amount-desc:before {\n  content: \"\\F161\";\n}\n.fa-sort-numeric-asc:before {\n  content: \"\\F162\";\n}\n.fa-sort-numeric-desc:before {\n  content: \"\\F163\";\n}\n.fa-thumbs-up:before {\n  content: \"\\F164\";\n}\n.fa-thumbs-down:before {\n  content: \"\\F165\";\n}\n.fa-youtube-square:before {\n  content: \"\\F166\";\n}\n.fa-youtube:before {\n  content: \"\\F167\";\n}\n.fa-xing:before {\n  content: \"\\F168\";\n}\n.fa-xing-square:before {\n  content: \"\\F169\";\n}\n.fa-youtube-play:before {\n  content: \"\\F16A\";\n}\n.fa-dropbox:before {\n  content: \"\\F16B\";\n}\n.fa-stack-overflow:before {\n  content: \"\\F16C\";\n}\n.fa-instagram:before {\n  content: \"\\F16D\";\n}\n.fa-flickr:before {\n  content: \"\\F16E\";\n}\n.fa-adn:before {\n  content: \"\\F170\";\n}\n.fa-bitbucket:before {\n  content: \"\\F171\";\n}\n.fa-bitbucket-square:before {\n  content: \"\\F172\";\n}\n.fa-tumblr:before {\n  content: \"\\F173\";\n}\n.fa-tumblr-square:before {\n  content: \"\\F174\";\n}\n.fa-long-arrow-down:before {\n  content: \"\\F175\";\n}\n.fa-long-arrow-up:before {\n  content: \"\\F176\";\n}\n.fa-long-arrow-left:before {\n  content: \"\\F177\";\n}\n.fa-long-arrow-right:before {\n  content: \"\\F178\";\n}\n.fa-apple:before {\n  content: \"\\F179\";\n}\n.fa-windows:before {\n  content: \"\\F17A\";\n}\n.fa-android:before {\n  content: \"\\F17B\";\n}\n.fa-linux:before {\n  content: \"\\F17C\";\n}\n.fa-dribbble:before {\n  content: \"\\F17D\";\n}\n.fa-skype:before {\n  content: \"\\F17E\";\n}\n.fa-foursquare:before {\n  content: \"\\F180\";\n}\n.fa-trello:before {\n  content: \"\\F181\";\n}\n.fa-female:before {\n  content: \"\\F182\";\n}\n.fa-male:before {\n  content: \"\\F183\";\n}\n.fa-gittip:before,\n.fa-gratipay:before {\n  content: \"\\F184\";\n}\n.fa-sun-o:before {\n  content: \"\\F185\";\n}\n.fa-moon-o:before {\n  content: \"\\F186\";\n}\n.fa-archive:before {\n  content: \"\\F187\";\n}\n.fa-bug:before {\n  content: \"\\F188\";\n}\n.fa-vk:before {\n  content: \"\\F189\";\n}\n.fa-weibo:before {\n  content: \"\\F18A\";\n}\n.fa-renren:before {\n  content: \"\\F18B\";\n}\n.fa-pagelines:before {\n  content: \"\\F18C\";\n}\n.fa-stack-exchange:before {\n  content: \"\\F18D\";\n}\n.fa-arrow-circle-o-right:before {\n  content: \"\\F18E\";\n}\n.fa-arrow-circle-o-left:before {\n  content: \"\\F190\";\n}\n.fa-toggle-left:before,\n.fa-caret-square-o-left:before {\n  content: \"\\F191\";\n}\n.fa-dot-circle-o:before {\n  content: \"\\F192\";\n}\n.fa-wheelchair:before {\n  content: \"\\F193\";\n}\n.fa-vimeo-square:before {\n  content: \"\\F194\";\n}\n.fa-turkish-lira:before,\n.fa-try:before {\n  content: \"\\F195\";\n}\n.fa-plus-square-o:before {\n  content: \"\\F196\";\n}\n.fa-space-shuttle:before {\n  content: \"\\F197\";\n}\n.fa-slack:before {\n  content: \"\\F198\";\n}\n.fa-envelope-square:before {\n  content: \"\\F199\";\n}\n.fa-wordpress:before {\n  content: \"\\F19A\";\n}\n.fa-openid:before {\n  content: \"\\F19B\";\n}\n.fa-institution:before,\n.fa-bank:before,\n.fa-university:before {\n  content: \"\\F19C\";\n}\n.fa-mortar-board:before,\n.fa-graduation-cap:before {\n  content: \"\\F19D\";\n}\n.fa-yahoo:before {\n  content: \"\\F19E\";\n}\n.fa-google:before {\n  content: \"\\F1A0\";\n}\n.fa-reddit:before {\n  content: \"\\F1A1\";\n}\n.fa-reddit-square:before {\n  content: \"\\F1A2\";\n}\n.fa-stumbleupon-circle:before {\n  content: \"\\F1A3\";\n}\n.fa-stumbleupon:before {\n  content: \"\\F1A4\";\n}\n.fa-delicious:before {\n  content: \"\\F1A5\";\n}\n.fa-digg:before {\n  content: \"\\F1A6\";\n}\n.fa-pied-piper-pp:before {\n  content: \"\\F1A7\";\n}\n.fa-pied-piper-alt:before {\n  content: \"\\F1A8\";\n}\n.fa-drupal:before {\n  content: \"\\F1A9\";\n}\n.fa-joomla:before {\n  content: \"\\F1AA\";\n}\n.fa-language:before {\n  content: \"\\F1AB\";\n}\n.fa-fax:before {\n  content: \"\\F1AC\";\n}\n.fa-building:before {\n  content: \"\\F1AD\";\n}\n.fa-child:before {\n  content: \"\\F1AE\";\n}\n.fa-paw:before {\n  content: \"\\F1B0\";\n}\n.fa-spoon:before {\n  content: \"\\F1B1\";\n}\n.fa-cube:before {\n  content: \"\\F1B2\";\n}\n.fa-cubes:before {\n  content: \"\\F1B3\";\n}\n.fa-behance:before {\n  content: \"\\F1B4\";\n}\n.fa-behance-square:before {\n  content: \"\\F1B5\";\n}\n.fa-steam:before {\n  content: \"\\F1B6\";\n}\n.fa-steam-square:before {\n  content: \"\\F1B7\";\n}\n.fa-recycle:before {\n  content: \"\\F1B8\";\n}\n.fa-automobile:before,\n.fa-car:before {\n  content: \"\\F1B9\";\n}\n.fa-cab:before,\n.fa-taxi:before {\n  content: \"\\F1BA\";\n}\n.fa-tree:before {\n  content: \"\\F1BB\";\n}\n.fa-spotify:before {\n  content: \"\\F1BC\";\n}\n.fa-deviantart:before {\n  content: \"\\F1BD\";\n}\n.fa-soundcloud:before {\n  content: \"\\F1BE\";\n}\n.fa-database:before {\n  content: \"\\F1C0\";\n}\n.fa-file-pdf-o:before {\n  content: \"\\F1C1\";\n}\n.fa-file-word-o:before {\n  content: \"\\F1C2\";\n}\n.fa-file-excel-o:before {\n  content: \"\\F1C3\";\n}\n.fa-file-powerpoint-o:before {\n  content: \"\\F1C4\";\n}\n.fa-file-photo-o:before,\n.fa-file-picture-o:before,\n.fa-file-image-o:before {\n  content: \"\\F1C5\";\n}\n.fa-file-zip-o:before,\n.fa-file-archive-o:before {\n  content: \"\\F1C6\";\n}\n.fa-file-sound-o:before,\n.fa-file-audio-o:before {\n  content: \"\\F1C7\";\n}\n.fa-file-movie-o:before,\n.fa-file-video-o:before {\n  content: \"\\F1C8\";\n}\n.fa-file-code-o:before {\n  content: \"\\F1C9\";\n}\n.fa-vine:before {\n  content: \"\\F1CA\";\n}\n.fa-codepen:before {\n  content: \"\\F1CB\";\n}\n.fa-jsfiddle:before {\n  content: \"\\F1CC\";\n}\n.fa-life-bouy:before,\n.fa-life-buoy:before,\n.fa-life-saver:before,\n.fa-support:before,\n.fa-life-ring:before {\n  content: \"\\F1CD\";\n}\n.fa-circle-o-notch:before {\n  content: \"\\F1CE\";\n}\n.fa-ra:before,\n.fa-resistance:before,\n.fa-rebel:before {\n  content: \"\\F1D0\";\n}\n.fa-ge:before,\n.fa-empire:before {\n  content: \"\\F1D1\";\n}\n.fa-git-square:before {\n  content: \"\\F1D2\";\n}\n.fa-git:before {\n  content: \"\\F1D3\";\n}\n.fa-y-combinator-square:before,\n.fa-yc-square:before,\n.fa-hacker-news:before {\n  content: \"\\F1D4\";\n}\n.fa-tencent-weibo:before {\n  content: \"\\F1D5\";\n}\n.fa-qq:before {\n  content: \"\\F1D6\";\n}\n.fa-wechat:before,\n.fa-weixin:before {\n  content: \"\\F1D7\";\n}\n.fa-send:before,\n.fa-paper-plane:before {\n  content: \"\\F1D8\";\n}\n.fa-send-o:before,\n.fa-paper-plane-o:before {\n  content: \"\\F1D9\";\n}\n.fa-history:before {\n  content: \"\\F1DA\";\n}\n.fa-circle-thin:before {\n  content: \"\\F1DB\";\n}\n.fa-header:before {\n  content: \"\\F1DC\";\n}\n.fa-paragraph:before {\n  content: \"\\F1DD\";\n}\n.fa-sliders:before {\n  content: \"\\F1DE\";\n}\n.fa-share-alt:before {\n  content: \"\\F1E0\";\n}\n.fa-share-alt-square:before {\n  content: \"\\F1E1\";\n}\n.fa-bomb:before {\n  content: \"\\F1E2\";\n}\n.fa-soccer-ball-o:before,\n.fa-futbol-o:before {\n  content: \"\\F1E3\";\n}\n.fa-tty:before {\n  content: \"\\F1E4\";\n}\n.fa-binoculars:before {\n  content: \"\\F1E5\";\n}\n.fa-plug:before {\n  content: \"\\F1E6\";\n}\n.fa-slideshare:before {\n  content: \"\\F1E7\";\n}\n.fa-twitch:before {\n  content: \"\\F1E8\";\n}\n.fa-yelp:before {\n  content: \"\\F1E9\";\n}\n.fa-newspaper-o:before {\n  content: \"\\F1EA\";\n}\n.fa-wifi:before {\n  content: \"\\F1EB\";\n}\n.fa-calculator:before {\n  content: \"\\F1EC\";\n}\n.fa-paypal:before {\n  content: \"\\F1ED\";\n}\n.fa-google-wallet:before {\n  content: \"\\F1EE\";\n}\n.fa-cc-visa:before {\n  content: \"\\F1F0\";\n}\n.fa-cc-mastercard:before {\n  content: \"\\F1F1\";\n}\n.fa-cc-discover:before {\n  content: \"\\F1F2\";\n}\n.fa-cc-amex:before {\n  content: \"\\F1F3\";\n}\n.fa-cc-paypal:before {\n  content: \"\\F1F4\";\n}\n.fa-cc-stripe:before {\n  content: \"\\F1F5\";\n}\n.fa-bell-slash:before {\n  content: \"\\F1F6\";\n}\n.fa-bell-slash-o:before {\n  content: \"\\F1F7\";\n}\n.fa-trash:before {\n  content: \"\\F1F8\";\n}\n.fa-copyright:before {\n  content: \"\\F1F9\";\n}\n.fa-at:before {\n  content: \"\\F1FA\";\n}\n.fa-eyedropper:before {\n  content: \"\\F1FB\";\n}\n.fa-paint-brush:before {\n  content: \"\\F1FC\";\n}\n.fa-birthday-cake:before {\n  content: \"\\F1FD\";\n}\n.fa-area-chart:before {\n  content: \"\\F1FE\";\n}\n.fa-pie-chart:before {\n  content: \"\\F200\";\n}\n.fa-line-chart:before {\n  content: \"\\F201\";\n}\n.fa-lastfm:before {\n  content: \"\\F202\";\n}\n.fa-lastfm-square:before {\n  content: \"\\F203\";\n}\n.fa-toggle-off:before {\n  content: \"\\F204\";\n}\n.fa-toggle-on:before {\n  content: \"\\F205\";\n}\n.fa-bicycle:before {\n  content: \"\\F206\";\n}\n.fa-bus:before {\n  content: \"\\F207\";\n}\n.fa-ioxhost:before {\n  content: \"\\F208\";\n}\n.fa-angellist:before {\n  content: \"\\F209\";\n}\n.fa-cc:before {\n  content: \"\\F20A\";\n}\n.fa-shekel:before,\n.fa-sheqel:before,\n.fa-ils:before {\n  content: \"\\F20B\";\n}\n.fa-meanpath:before {\n  content: \"\\F20C\";\n}\n.fa-buysellads:before {\n  content: \"\\F20D\";\n}\n.fa-connectdevelop:before {\n  content: \"\\F20E\";\n}\n.fa-dashcube:before {\n  content: \"\\F210\";\n}\n.fa-forumbee:before {\n  content: \"\\F211\";\n}\n.fa-leanpub:before {\n  content: \"\\F212\";\n}\n.fa-sellsy:before {\n  content: \"\\F213\";\n}\n.fa-shirtsinbulk:before {\n  content: \"\\F214\";\n}\n.fa-simplybuilt:before {\n  content: \"\\F215\";\n}\n.fa-skyatlas:before {\n  content: \"\\F216\";\n}\n.fa-cart-plus:before {\n  content: \"\\F217\";\n}\n.fa-cart-arrow-down:before {\n  content: \"\\F218\";\n}\n.fa-diamond:before {\n  content: \"\\F219\";\n}\n.fa-ship:before {\n  content: \"\\F21A\";\n}\n.fa-user-secret:before {\n  content: \"\\F21B\";\n}\n.fa-motorcycle:before {\n  content: \"\\F21C\";\n}\n.fa-street-view:before {\n  content: \"\\F21D\";\n}\n.fa-heartbeat:before {\n  content: \"\\F21E\";\n}\n.fa-venus:before {\n  content: \"\\F221\";\n}\n.fa-mars:before {\n  content: \"\\F222\";\n}\n.fa-mercury:before {\n  content: \"\\F223\";\n}\n.fa-intersex:before,\n.fa-transgender:before {\n  content: \"\\F224\";\n}\n.fa-transgender-alt:before {\n  content: \"\\F225\";\n}\n.fa-venus-double:before {\n  content: \"\\F226\";\n}\n.fa-mars-double:before {\n  content: \"\\F227\";\n}\n.fa-venus-mars:before {\n  content: \"\\F228\";\n}\n.fa-mars-stroke:before {\n  content: \"\\F229\";\n}\n.fa-mars-stroke-v:before {\n  content: \"\\F22A\";\n}\n.fa-mars-stroke-h:before {\n  content: \"\\F22B\";\n}\n.fa-neuter:before {\n  content: \"\\F22C\";\n}\n.fa-genderless:before {\n  content: \"\\F22D\";\n}\n.fa-facebook-official:before {\n  content: \"\\F230\";\n}\n.fa-pinterest-p:before {\n  content: \"\\F231\";\n}\n.fa-whatsapp:before {\n  content: \"\\F232\";\n}\n.fa-server:before {\n  content: \"\\F233\";\n}\n.fa-user-plus:before {\n  content: \"\\F234\";\n}\n.fa-user-times:before {\n  content: \"\\F235\";\n}\n.fa-hotel:before,\n.fa-bed:before {\n  content: \"\\F236\";\n}\n.fa-viacoin:before {\n  content: \"\\F237\";\n}\n.fa-train:before {\n  content: \"\\F238\";\n}\n.fa-subway:before {\n  content: \"\\F239\";\n}\n.fa-medium:before {\n  content: \"\\F23A\";\n}\n.fa-yc:before,\n.fa-y-combinator:before {\n  content: \"\\F23B\";\n}\n.fa-optin-monster:before {\n  content: \"\\F23C\";\n}\n.fa-opencart:before {\n  content: \"\\F23D\";\n}\n.fa-expeditedssl:before {\n  content: \"\\F23E\";\n}\n.fa-battery-4:before,\n.fa-battery:before,\n.fa-battery-full:before {\n  content: \"\\F240\";\n}\n.fa-battery-3:before,\n.fa-battery-three-quarters:before {\n  content: \"\\F241\";\n}\n.fa-battery-2:before,\n.fa-battery-half:before {\n  content: \"\\F242\";\n}\n.fa-battery-1:before,\n.fa-battery-quarter:before {\n  content: \"\\F243\";\n}\n.fa-battery-0:before,\n.fa-battery-empty:before {\n  content: \"\\F244\";\n}\n.fa-mouse-pointer:before {\n  content: \"\\F245\";\n}\n.fa-i-cursor:before {\n  content: \"\\F246\";\n}\n.fa-object-group:before {\n  content: \"\\F247\";\n}\n.fa-object-ungroup:before {\n  content: \"\\F248\";\n}\n.fa-sticky-note:before {\n  content: \"\\F249\";\n}\n.fa-sticky-note-o:before {\n  content: \"\\F24A\";\n}\n.fa-cc-jcb:before {\n  content: \"\\F24B\";\n}\n.fa-cc-diners-club:before {\n  content: \"\\F24C\";\n}\n.fa-clone:before {\n  content: \"\\F24D\";\n}\n.fa-balance-scale:before {\n  content: \"\\F24E\";\n}\n.fa-hourglass-o:before {\n  content: \"\\F250\";\n}\n.fa-hourglass-1:before,\n.fa-hourglass-start:before {\n  content: \"\\F251\";\n}\n.fa-hourglass-2:before,\n.fa-hourglass-half:before {\n  content: \"\\F252\";\n}\n.fa-hourglass-3:before,\n.fa-hourglass-end:before {\n  content: \"\\F253\";\n}\n.fa-hourglass:before {\n  content: \"\\F254\";\n}\n.fa-hand-grab-o:before,\n.fa-hand-rock-o:before {\n  content: \"\\F255\";\n}\n.fa-hand-stop-o:before,\n.fa-hand-paper-o:before {\n  content: \"\\F256\";\n}\n.fa-hand-scissors-o:before {\n  content: \"\\F257\";\n}\n.fa-hand-lizard-o:before {\n  content: \"\\F258\";\n}\n.fa-hand-spock-o:before {\n  content: \"\\F259\";\n}\n.fa-hand-pointer-o:before {\n  content: \"\\F25A\";\n}\n.fa-hand-peace-o:before {\n  content: \"\\F25B\";\n}\n.fa-trademark:before {\n  content: \"\\F25C\";\n}\n.fa-registered:before {\n  content: \"\\F25D\";\n}\n.fa-creative-commons:before {\n  content: \"\\F25E\";\n}\n.fa-gg:before {\n  content: \"\\F260\";\n}\n.fa-gg-circle:before {\n  content: \"\\F261\";\n}\n.fa-tripadvisor:before {\n  content: \"\\F262\";\n}\n.fa-odnoklassniki:before {\n  content: \"\\F263\";\n}\n.fa-odnoklassniki-square:before {\n  content: \"\\F264\";\n}\n.fa-get-pocket:before {\n  content: \"\\F265\";\n}\n.fa-wikipedia-w:before {\n  content: \"\\F266\";\n}\n.fa-safari:before {\n  content: \"\\F267\";\n}\n.fa-chrome:before {\n  content: \"\\F268\";\n}\n.fa-firefox:before {\n  content: \"\\F269\";\n}\n.fa-opera:before {\n  content: \"\\F26A\";\n}\n.fa-internet-explorer:before {\n  content: \"\\F26B\";\n}\n.fa-tv:before,\n.fa-television:before {\n  content: \"\\F26C\";\n}\n.fa-contao:before {\n  content: \"\\F26D\";\n}\n.fa-500px:before {\n  content: \"\\F26E\";\n}\n.fa-amazon:before {\n  content: \"\\F270\";\n}\n.fa-calendar-plus-o:before {\n  content: \"\\F271\";\n}\n.fa-calendar-minus-o:before {\n  content: \"\\F272\";\n}\n.fa-calendar-times-o:before {\n  content: \"\\F273\";\n}\n.fa-calendar-check-o:before {\n  content: \"\\F274\";\n}\n.fa-industry:before {\n  content: \"\\F275\";\n}\n.fa-map-pin:before {\n  content: \"\\F276\";\n}\n.fa-map-signs:before {\n  content: \"\\F277\";\n}\n.fa-map-o:before {\n  content: \"\\F278\";\n}\n.fa-map:before {\n  content: \"\\F279\";\n}\n.fa-commenting:before {\n  content: \"\\F27A\";\n}\n.fa-commenting-o:before {\n  content: \"\\F27B\";\n}\n.fa-houzz:before {\n  content: \"\\F27C\";\n}\n.fa-vimeo:before {\n  content: \"\\F27D\";\n}\n.fa-black-tie:before {\n  content: \"\\F27E\";\n}\n.fa-fonticons:before {\n  content: \"\\F280\";\n}\n.fa-reddit-alien:before {\n  content: \"\\F281\";\n}\n.fa-edge:before {\n  content: \"\\F282\";\n}\n.fa-credit-card-alt:before {\n  content: \"\\F283\";\n}\n.fa-codiepie:before {\n  content: \"\\F284\";\n}\n.fa-modx:before {\n  content: \"\\F285\";\n}\n.fa-fort-awesome:before {\n  content: \"\\F286\";\n}\n.fa-usb:before {\n  content: \"\\F287\";\n}\n.fa-product-hunt:before {\n  content: \"\\F288\";\n}\n.fa-mixcloud:before {\n  content: \"\\F289\";\n}\n.fa-scribd:before {\n  content: \"\\F28A\";\n}\n.fa-pause-circle:before {\n  content: \"\\F28B\";\n}\n.fa-pause-circle-o:before {\n  content: \"\\F28C\";\n}\n.fa-stop-circle:before {\n  content: \"\\F28D\";\n}\n.fa-stop-circle-o:before {\n  content: \"\\F28E\";\n}\n.fa-shopping-bag:before {\n  content: \"\\F290\";\n}\n.fa-shopping-basket:before {\n  content: \"\\F291\";\n}\n.fa-hashtag:before {\n  content: \"\\F292\";\n}\n.fa-bluetooth:before {\n  content: \"\\F293\";\n}\n.fa-bluetooth-b:before {\n  content: \"\\F294\";\n}\n.fa-percent:before {\n  content: \"\\F295\";\n}\n.fa-gitlab:before {\n  content: \"\\F296\";\n}\n.fa-wpbeginner:before {\n  content: \"\\F297\";\n}\n.fa-wpforms:before {\n  content: \"\\F298\";\n}\n.fa-envira:before {\n  content: \"\\F299\";\n}\n.fa-universal-access:before {\n  content: \"\\F29A\";\n}\n.fa-wheelchair-alt:before {\n  content: \"\\F29B\";\n}\n.fa-question-circle-o:before {\n  content: \"\\F29C\";\n}\n.fa-blind:before {\n  content: \"\\F29D\";\n}\n.fa-audio-description:before {\n  content: \"\\F29E\";\n}\n.fa-volume-control-phone:before {\n  content: \"\\F2A0\";\n}\n.fa-braille:before {\n  content: \"\\F2A1\";\n}\n.fa-assistive-listening-systems:before {\n  content: \"\\F2A2\";\n}\n.fa-asl-interpreting:before,\n.fa-american-sign-language-interpreting:before {\n  content: \"\\F2A3\";\n}\n.fa-deafness:before,\n.fa-hard-of-hearing:before,\n.fa-deaf:before {\n  content: \"\\F2A4\";\n}\n.fa-glide:before {\n  content: \"\\F2A5\";\n}\n.fa-glide-g:before {\n  content: \"\\F2A6\";\n}\n.fa-signing:before,\n.fa-sign-language:before {\n  content: \"\\F2A7\";\n}\n.fa-low-vision:before {\n  content: \"\\F2A8\";\n}\n.fa-viadeo:before {\n  content: \"\\F2A9\";\n}\n.fa-viadeo-square:before {\n  content: \"\\F2AA\";\n}\n.fa-snapchat:before {\n  content: \"\\F2AB\";\n}\n.fa-snapchat-ghost:before {\n  content: \"\\F2AC\";\n}\n.fa-snapchat-square:before {\n  content: \"\\F2AD\";\n}\n.fa-pied-piper:before {\n  content: \"\\F2AE\";\n}\n.fa-first-order:before {\n  content: \"\\F2B0\";\n}\n.fa-yoast:before {\n  content: \"\\F2B1\";\n}\n.fa-themeisle:before {\n  content: \"\\F2B2\";\n}\n.fa-google-plus-circle:before,\n.fa-google-plus-official:before {\n  content: \"\\F2B3\";\n}\n.fa-fa:before,\n.fa-font-awesome:before {\n  content: \"\\F2B4\";\n}\n.fa-handshake-o:before {\n  content: \"\\F2B5\";\n}\n.fa-envelope-open:before {\n  content: \"\\F2B6\";\n}\n.fa-envelope-open-o:before {\n  content: \"\\F2B7\";\n}\n.fa-linode:before {\n  content: \"\\F2B8\";\n}\n.fa-address-book:before {\n  content: \"\\F2B9\";\n}\n.fa-address-book-o:before {\n  content: \"\\F2BA\";\n}\n.fa-vcard:before,\n.fa-address-card:before {\n  content: \"\\F2BB\";\n}\n.fa-vcard-o:before,\n.fa-address-card-o:before {\n  content: \"\\F2BC\";\n}\n.fa-user-circle:before {\n  content: \"\\F2BD\";\n}\n.fa-user-circle-o:before {\n  content: \"\\F2BE\";\n}\n.fa-user-o:before {\n  content: \"\\F2C0\";\n}\n.fa-id-badge:before {\n  content: \"\\F2C1\";\n}\n.fa-drivers-license:before,\n.fa-id-card:before {\n  content: \"\\F2C2\";\n}\n.fa-drivers-license-o:before,\n.fa-id-card-o:before {\n  content: \"\\F2C3\";\n}\n.fa-quora:before {\n  content: \"\\F2C4\";\n}\n.fa-free-code-camp:before {\n  content: \"\\F2C5\";\n}\n.fa-telegram:before {\n  content: \"\\F2C6\";\n}\n.fa-thermometer-4:before,\n.fa-thermometer:before,\n.fa-thermometer-full:before {\n  content: \"\\F2C7\";\n}\n.fa-thermometer-3:before,\n.fa-thermometer-three-quarters:before {\n  content: \"\\F2C8\";\n}\n.fa-thermometer-2:before,\n.fa-thermometer-half:before {\n  content: \"\\F2C9\";\n}\n.fa-thermometer-1:before,\n.fa-thermometer-quarter:before {\n  content: \"\\F2CA\";\n}\n.fa-thermometer-0:before,\n.fa-thermometer-empty:before {\n  content: \"\\F2CB\";\n}\n.fa-shower:before {\n  content: \"\\F2CC\";\n}\n.fa-bathtub:before,\n.fa-s15:before,\n.fa-bath:before {\n  content: \"\\F2CD\";\n}\n.fa-podcast:before {\n  content: \"\\F2CE\";\n}\n.fa-window-maximize:before {\n  content: \"\\F2D0\";\n}\n.fa-window-minimize:before {\n  content: \"\\F2D1\";\n}\n.fa-window-restore:before {\n  content: \"\\F2D2\";\n}\n.fa-times-rectangle:before,\n.fa-window-close:before {\n  content: \"\\F2D3\";\n}\n.fa-times-rectangle-o:before,\n.fa-window-close-o:before {\n  content: \"\\F2D4\";\n}\n.fa-bandcamp:before {\n  content: \"\\F2D5\";\n}\n.fa-grav:before {\n  content: \"\\F2D6\";\n}\n.fa-etsy:before {\n  content: \"\\F2D7\";\n}\n.fa-imdb:before {\n  content: \"\\F2D8\";\n}\n.fa-ravelry:before {\n  content: \"\\F2D9\";\n}\n.fa-eercast:before {\n  content: \"\\F2DA\";\n}\n.fa-microchip:before {\n  content: \"\\F2DB\";\n}\n.fa-snowflake-o:before {\n  content: \"\\F2DC\";\n}\n.fa-superpowers:before {\n  content: \"\\F2DD\";\n}\n.fa-wpexplorer:before {\n  content: \"\\F2DE\";\n}\n.fa-meetup:before {\n  content: \"\\F2E0\";\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n}\n.card {\n  margin-bottom: 1rem;\n  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);\n}\n.dark-hr {\n  border-top: 2px solid #999;\n}\n.mainBody {\n  background-color: white;\n  min-height: 65vh;\n}\n", ""]);

// exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\nul[data-v-37d5b43c] {\n    list-style-type: none;\n    padding: 0;\n}\nli[data-v-37d5b43c] {\n    display: inline-block;\n    margin: 0 10px;\n    padding: 0;\n}\n.custom-select[data-v-37d5b43c] {\n\tdisplay: inline-block;\n\tmax-width: 100%;\n\theight: calc(2.50rem + 2px);\n\tpadding: 0.375rem 1.75rem 0.375rem 0.75rem;\n\tline-height: 1.25;\n\tbackground-color: #ececeb;\n\tvertical-align: middle;\n\tbackground-size: 8px 10px;\n\tborder: 1px solid #00524A;\n\tborder-radius: 0;\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n}\n.card-block[data-v-37d5b43c] {\n\tbackground: #eceff1;\n}\n.user-input[data-v-37d5b43c] {\n\twidth: 100%;\n\tbackground: #ffffff;\n\tcolor: #333333;\n\theight: 30px;\n}\n.user-select[data-v-37d5b43c] {\n\tcolor: #333333;\n\theight: 30px;\n}\n#userSearch[data-v-37d5b43c] {\n\tmargin: 10px;\n}\n.good-table th[data-v-37d5b43c] {\n\tcolor: #333333 !important\n}\n.btn-secondary[data-v-37d5b43c]:active {\n\tbackground: #007299;\n\tbox-shadow: none;\n}\n.btn-secondary[data-v-37d5b43c] {\n\tbackground: var(--theme-primary);\n\tcolor: #ffffff;\n}\ninput[data-v-37d5b43c] {\n\twidth: 130px;\n\tbox-sizing: border-box;\n\tborder: 1px solid var(--theme-primary);\n\tborder-radius: 0;\n\tfont-size: 16px;\n\tbackground-color: #f1f1f1;\n\tbackground-position: 10px 10px;\n\tbackground-repeat: no-repeat;\n\tpadding: 15px 20px;\n\theight: 50px;\n}\n.card[data-v-37d5b43c] {\n\tposition: relative;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tbackground-color: #33373D;\n\tborder: 0px solid rgba(0, 0, 0, 0.125);\n\tborder-radius: 0px;\n\tbox-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px\n\t\trgba(0, 0, 0, 0.22);\n\tbox-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.4);\n}\n.card[data-v-37d5b43c] {\n\tmargin-bottom: 1rem;\n\tbox-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);\n}\n.card-block1[data-v-37d5b43c] {\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    padding: 0rem;\n}\n#searchId[data-v-37d5b43c] {\n\tbox-sizing: border-box !important;\n\tborder: 2px solid #dde3e6 !important;\n\tborder-radius: 0 !important;\n\tbackground-color: #fff !important;\n\tbackground-position: 10px 10px !important;\n\tbackground-repeat: no-repeat !important;\n\theight: 40px !important;\n\tmargin-bottom: 18px !important;\n\tmargin-left: 30px !important;\n}\n.filter-label[data-v-37d5b43c]{ width: 150px;\n    float: left;\n    font-size: 14px;\n    margin-top: 8px;\n    font-weight: bold;\n}\n.btn-secondary[data-v-37d5b43c] {\n\tbackground-color: var(--theme-primary);;\n\tborder-color: #00433c;\n}\n.btn-secondary[data-v-37d5b43c]:hover {\n\tbackground-color: #00524A;\n\tborder-color: #00433c;\n}\n.btn[data-v-37d5b43c] {\n\tpadding: 14px 24px;\n\tborder: 0 none;\n\tfont-weight: 700;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n/* Pills styles */\n.nav-pills .nav-link.active[data-v-37d5b43c], .nav-pills .nav-item.show .nav-link[data-v-37d5b43c] {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #FFF;\n    background-color:#fff;\n    color: var(--theme-primary);\n    width: 15rem;\n}\n.nav-pills .nav-link[data-v-37d5b43c] {\n    padding: 15px 30px;\n    border-top: 1px solid var(--theme-primary);\n    border-right: 1px solid var(--theme-primary);\n    border-left: 1px solid var(--theme-primary);\n    border-bottom: 1px solid var(--theme-primary);\n    border-radius: 0rem;\n    background-color:var(--theme-primary);\n    color:#fff;\n    width: 15rem;\n}\n.nav-pills .nav-link[data-v-37d5b43c]:hover {\n    padding: 15px 30px;\n    border-top: 1px solid #00524A;\n    border-right: 1px solid #00524A;\n    border-left: 1px solid #00524A;\n    border-bottom: 1px solid var(--theme-primary);\n    background-color:#00524A;\n    color:#fff;\n    width: ;\n}\n.nav-pills .nav-link.active[data-v-37d5b43c]:hover {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #FFF;\n    background-color:#FFF;\n    color: var(--theme-primary);\n    width: ;\n}\n.nav-tabs .nav-link[data-v-37d5b43c]:focus, .nav-tabs .nav-link[data-v-37d5b43c]:hover {\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    background-color:#00524A;\n    color: #fff;\n}\n.nav-tabs .nav-link[data-v-37d5b43c] {\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n}\n.nav-link[data-v-37d5b43c]:focus, .nav-link[data-v-37d5b43c]:hover {\n    text-decoration: none;\n}\n/* Extra small devices (portrait phones, less than 576px) */\n@media (max-width: 575px) {\n.nav-pills[data-v-37d5b43c], .nav-link[data-v-37d5b43c] {\n  width: 100%;\n}\n.nav-item[data-v-37d5b43c] {\n  margin: 5px 0 0 0;\n}\n.nav-pills .nav-link.active[data-v-37d5b43c], .nav-pills .nav-item.show .nav-link[data-v-37d5b43c] {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #CECECB;\n    margin: 2px 0;\n    background-color:#fff;\n    color: var(--theme-primary);\n    width: 100%;\n}\n.nav-pills .nav-link[data-v-37d5b43c] {\n    padding: 15px 30px;\n    border-top: 1px solid var(--theme-primary);\n    border-right: 1px solid var(--theme-primary);\n    border-left: 1px solid var(--theme-primary);\n    border-bottom: 1px solid var(--theme-primary);\n    margin: 2px 0;\n    border-radius: 0rem;\n    background-color:var(--theme-primary);\n    color:#fff;\n    width: 100%;\n}\n.barchart[data-v-37d5b43c] {\n  display:none;\n}\n}\n/* Small devices (landscape phones, 576px and up) */\n@media (min-width: 576px) and (max-width: 767px) {\n.nav-pills[data-v-37d5b43c], .nav-link[data-v-37d5b43c] {\n  width: 100%;\n}\n.nav-item[data-v-37d5b43c] {\n    margin: 0 0 0 1px;\n}\n.nav-link[data-v-37d5b43c] {\n    margin: 0;\n}\n.nav-pills .nav-link.active[data-v-37d5b43c], .nav-pills .nav-item.show .nav-link[data-v-37d5b43c] {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #CECECB;\n    margin: 2px 0;\n    background-color:#fff;\n    color: var(--theme-primary);\n    width: 100%;\n}\n.nav-pills .nav-link[data-v-37d5b43c] {\n    padding: 15px 30px;\n    border-top: 1px solid var(--theme-primary);\n    border-right: 1px solid var(--theme-primary);\n    border-left: 1px solid var(--theme-primary);\n    border-bottom: 1px solid var(--theme-primary);\n    margin: 2px 0;\n    border-radius: 0rem;\n    background-color:var(--theme-primary);\n    color:#fff;\n    width: 100%;\n}\n.barchart[data-v-37d5b43c] {\n  display:none;\n}\n}\n.input-adduser[data-v-37d5b43c]{\n    height: initial;\n    padding: 5px 15px;\n    width: 100%;\n\tbackground: #fff;\n\tmargin: 0px !important\n}\n.input-checkbx-sub[data-v-37d5b43c]{\nwidth: 20px;\nheight: 20px !important;\ndisplay: inline-block;\n}\n.preflang[data-v-37d5b43c]{\n    width: 100%;\n    min-height: 34px;\n}\n.success-bg[data-v-37d5b43c]{\n    background: #90ee90;\n}\n.error-bg[data-v-37d5b43c]{\n   background: #ffc0cb;\n}\n.form-control-label[data-v-37d5b43c]{min-width: 120px;font-size:12px;\n}\n.wrap-input[data-v-37d5b43c]{display:block;overflow:hidden\n}\n.form-wrap[data-v-37d5b43c]{    margin-bottom: 3px;\n}\n.create-btn[data-v-37d5b43c]{margin-top: 10px;\n    height: 40px;\n    line-height: 0px;font-size: 12px;float:right;\n}\n.search-icon[data-v-37d5b43c]{margin-top: 10px;\n    margin-top: 0px;\n    height: 40px !important;\n    line-height: 0px;\n    padding: 12px 24px 14px 24px;\n\tmargin-bottom: 10px;\n    border-radius: 0px;\n}\n.tableContainer[data-v-37d5b43c]{padding: 0px 15px 30px;    overflow-x: auto;\n}\n.input-group[data-v-37d5b43c]{\n    width: 100%;\n    background: #fff;\n    margin: 0px -15px 0p;\n    padding: 5px;\n    outline: 15px solid #fff;\n    /* margin: 0px -15px; */\n}\n.input-group-btn[data-v-37d5b43c] {max-width:65px\n}\n.sub-group[data-v-37d5b43c]{display: inline-block\n}\n@media (max-width: 1050px) {\n.input-group[data-v-37d5b43c] {\n    width:100% !important;\n\tdisplay: block;\n}\n}\n@media (max-width: 768px) {\n.sub-group[data-v-37d5b43c] {\n    width:100% !important;\n\tdisplay: block;\n}\n.searchId[data-v-37d5b43c]{max-width: 230px;\n}\n.filter-text[data-v-37d5b43c]{margin-left: 0px !important\n}\n.adduser-btn[data-v-37d5b43c]{margin-left: 0px !important\n}\n}\n.dropdown div[data-v-37d5b43c], .dropdown dt[data-v-37d5b43c] {\n    margin:0px;\n    padding:0px;\n}\n.dropdown ul[data-v-37d5b43c] {\n    margin:0px;\n    padding:0px;\n}\n.dropdown div[data-v-37d5b43c] {\n    position:relative;\n    margin:0px;\n    padding:0px;\n}\n.dropdown a[data-v-37d5b43c], .dropdown a[data-v-37d5b43c]:visited {\n    color:#fff;\n    text-decoration:none;\n    outline:none;\n    margin:0px;\n    padding:0px;\n    min-height: 30px;\n    border-radius: 3px;\n}\n.dropdown div a[data-v-37d5b43c] {\n    background-color:#4F6877;\n    display:block;\n    overflow: hidden;\n    width:100%;\n    margin:0px;\n    padding:0px;\n}\n.dropdown div a span[data-v-37d5b43c], .multiSel span[data-v-37d5b43c] {\n    cursor:pointer;\n    display:inline-block;\n    margin:0px;\n    padding:5px 10px;\n}\n.dropdown div ul[data-v-37d5b43c] {\n    background-color: #4F6877;\n    top:1px;\n    color:#fff;\n    display:none;\n    position:absolute;\n    width:100%;\n    list-style:none;\n    height: 100px;\n    overflow: auto;\n    margin:0px;\n    padding:0px;\n}\n.dropdown span.value[data-v-37d5b43c] {\n    display:none;\n    border-radius: 3px;\n    margin:0px;\n    padding:0px;\n}\n.dropdown div ul li a[data-v-37d5b43c] {\n    display:block;\n    margin:0px;\n    padding:0px;\n}\n.dropdown div ul li a[data-v-37d5b43c]:hover {\n    background-color:#fff;\n    margin:0px;\n    padding:0px;\n}\n.selectDropDown[data-v-37d5b43c]{border: 2px solid #dde3e6;height:34px;\n    /* border-radius: 3px; */\n    cursor: pointer;\n    background: #fff;\n\twidth: 100%;\n}\n#checkboxlist[data-v-37d5b43c]{position: relative;\n    margin-top: 0px;\n\tbackground:#fff;\n\tborder: 1px solid #ccc;\n\tmin-width: 200px;\n}\n.dd-list-item[data-v-37d5b43c]:hover{background:#fff\n}\nbutton[data-v-37d5b43c] {background:var(--theme-primary) !important\n}\n.adduser-btn[data-v-37d5b43c]{margin-left: 20px;max-height: 40px;margin-top: 0px;line-height: 0px;height: 40px;background-color: var(--theme-primary);font-size: 12px;\n}\ninput[data-v-37d5b43c], select[data-v-37d5b43c]{\nbackground: #fff!important;\n    border: 2px solid #dde3e6!important;\n\tpadding-left: 10px !important;\n    font-size: 14px !important;\n}\n.bc[data-v-37d5b43c]{font-size:10px;font-weight:bold;\n}\n.bc-adduser[data-v-37d5b43c]{font-size:10px;font-weight:bold;margin:15px\n}\n.bc-nav[data-v-37d5b43c]:hover{text-decoration:underline; cursor:pointer\n}\n.user-creds[data-v-37d5b43c]{background:#fff;    padding: 5px 10px 10px;\n    margin-bottom: 12px;\n}\n.bb0[data-v-37d5b43c]{border-top:0px !important\n}\n.add-group[data-v-37d5b43c]{color:var(--theme-primary);font-size:18px;float:right;margin-top: 5px;cursor:pointer\n}\n.remove-group[data-v-37d5b43c]{color: #d80842;\n    font-size: 20px;\n    /* float: right; */\n    margin-top: 6px;\n    cursor: pointer;\n}\n.group-div[data-v-37d5b43c]{border:2px solid #eceff1;padding: 3px 10px;\n}\n.group-name[data-v-37d5b43c]{display: inline-block;width: 90%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.usercreateinfo[data-v-37d5b43c]{margin-top: 10px;background: #546e7a;color: #fff;padding: 10px;margin-bottom: 10px;\n}\n@media screen and (max-width: 767px) {\n.main-content[data-v-37d5b43c]{padding-top:25px\n}\n.main-content[data-v-37d5b43c]{padding-left:0px\n}\n}\n@media screen and (min-width: 768px) {\n.main-content[data-v-37d5b43c]{padding-top:0px\n}\n.main-content[data-v-37d5b43c]{padding-left:200px\n}\n}\n@media screen and (min-width: 991px) {\n.search-bar-wrapper[data-v-37d5b43c]{width: 100%\n}\n.search-bar-select[data-v-37d5b43c]{width: 300px;\n}\n}\n@media screen and (max-width: 991px) {\n.search-bar-wrapper[data-v-37d5b43c]{width: 75%\n}\n.search-bar-select[data-v-37d5b43c]{width: 150px;\n}\n}\n.cancel-btn[data-v-37d5b43c]{    float: right;\n    display: block;\n    padding: 18px 30px;\n}\ninput[data-v-37d5b43c], select[data-v-37d5b43c] { height: 32px !important; color: #000 !important\n}\nbutton[data-v-37d5b43c] { height: 32px !important; color: #fff !important\n}\n.disabled[data-v-37d5b43c] {pointer-events:none;opacity:0.5\n}\n.disabledLight[data-v-37d5b43c] {pointer-events:none;opacity:0.8\n}\n.error[data-v-37d5b43c]{    color: red;width: 100%;\n    margin-left: 15px;\n}\n.pwderror[data-v-37d5b43c]{max-width:initial;width:100%;font-size: 14px;\n}\n.codeVerifybtn[data-v-37d5b43c]{\nbackground:#f9f9f9;\ncolor:#595959;\nborder:1px solid #c3c3c3;\nfont-size:13px;\ndisplay: inline-block !important;\n margin-top: -2px;\n height: 30px;\n line-height: 14px;\n width: 87px;\n}\n.fa-check-circle[data-v-37d5b43c] {font-size:40px !important\n}\nlabel[data-v-37d5b43c]{margin-bottom:0px !important;font-weight:normal !important;font-size:13px;\n}\nuser-creds label[data-v-37d5b43c]{font-weight: normal !important;\n}\n.sometext-hidden[data-v-37d5b43c]{\n-webkit-user-select: none; /* Chrome/Safari */\n-moz-user-select: none; /* Firefox */\n-ms-user-select: none; /* IE10+ */\n}\n.configGroupAdmin tr[data-v-37d5b43c], td[data-v-37d5b43c], th[data-v-37d5b43c]{padding-top: 5px;padding-bottom:5px;\n}\n.configGroupAdmin tr[data-v-37d5b43c]{border-bottom: 1px solid #eceff1;\n}\n.configGroupAdmin th[data-v-37d5b43c] {padding: 10px !important;\n}\n.addgrouptxtbox[data-v-37d5b43c]{    width: 85%;\n    border: #ccc 1px solid !important;\n    border-radius: 2px;\n    margin-top: 5px;\n}\n.deleteconfig[data-v-37d5b43c]{\nmargin-right: 15px;\nline-height: 13px;\ncursor:pointer;\npadding: 6px;\nfont-size: 13px;\n border-radius: 3px;\n background: #bf6161  !important;\n box-shadow: rgba(216, 21, 33, 0.75) 0px 0px 20px inset;\n max-height: 30px;\n margin-top: 2px;\n}\ninput[type=text][data-v-37d5b43c]:focus\n{  \n  border-color: #dde3e6 !important;\n}\n", ""]);

// exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\nul[data-v-47e688b5] {\n    list-style-type: none;\n    padding: 0;\n}\nli[data-v-47e688b5] {\n    display: inline-block;\n    margin: 0 10px;\n    padding: 0;\n}\n.custom-select[data-v-47e688b5] {\n\tdisplay: inline-block;\n\tmax-width: 100%;\n\theight: calc(2.50rem + 2px);\n\tpadding: 0.375rem 1.75rem 0.375rem 0.75rem;\n\tline-height: 1.25;\n\tbackground-color: #ececeb;\n\tvertical-align: middle;\n\tbackground-size: 8px 10px;\n\tborder: 1px solid #00524A;\n\tborder-radius: 0;\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n}\n.card-block[data-v-47e688b5] {\n\tbackground: #eceff1;\n}\n.user-input[data-v-47e688b5] {\n\twidth: 100%;\n\tbackground: #ffffff;\n\tcolor: #333333;\n\theight: 30px;\n}\n.user-select[data-v-47e688b5] {\n\tcolor: #333333;\n\theight: 30px;\n}\n#userSearch[data-v-47e688b5] {\n\tmargin: 10px;\n}\n.good-table th[data-v-47e688b5] {\n\tcolor: #333333 !important\n}\n.btn-secondary[data-v-47e688b5]:active {\n\tbackground: #007299;\n\tbox-shadow: none;\n}\n.btn-secondary[data-v-47e688b5] {\n\tbackground: var(--theme-primary);\n\tcolor: #ffffff;\n}\ninput[data-v-47e688b5] {\n\twidth: 130px;\n\tbox-sizing: border-box;\n\tborder: 1px solid var(--theme-primary);\n\tborder-radius: 0;\n\tfont-size: 16px;\n\tbackground-color: #f1f1f1;\n\tbackground-position: 10px 10px;\n\tbackground-repeat: no-repeat;\n\tpadding: 15px 20px;\n\theight: 50px;\n}\n.card[data-v-47e688b5] {\n\tposition: relative;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tbackground-color: #33373D;\n\tborder: 0px solid rgba(0, 0, 0, 0.125);\n\tborder-radius: 0px;\n\tbox-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px\n\t\trgba(0, 0, 0, 0.22);\n\tbox-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.4);\n}\n.card[data-v-47e688b5] {\n\tmargin-bottom: 1rem;\n\tbox-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);\n}\n.card-block1[data-v-47e688b5] {\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    padding: 0rem;\n}\n#searchId[data-v-47e688b5] {\n\tbox-sizing: border-box !important;\n\tborder: 2px solid #dde3e6 !important;\n\tborder-radius: 0 !important;\n\tbackground-color: #fff !important;\n\tbackground-position: 10px 10px !important;\n\tbackground-repeat: no-repeat !important;\n\theight: 40px !important;\n\tmargin-bottom: 18px !important;\n\tmargin-left: 30px !important;\n}\n.filter-label[data-v-47e688b5]{ width: 150px;\n    float: left;\n    font-size: 14px;\n    margin-top: 8px;\n    font-weight: bold;\n}\n.btn-secondary[data-v-47e688b5] {\n\tbackground-color: var(--theme-primary);;\n\tborder-color: #00433c;\n}\n.btn-secondary[data-v-47e688b5]:hover {\n\tbackground-color: #00524A;\n\tborder-color: #00433c;\n}\n.btn[data-v-47e688b5] {\n\tpadding: 14px 24px;\n\tborder: 0 none;\n\tfont-weight: 700;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n/* Pills styles */\n.nav-pills .nav-link.active[data-v-47e688b5], .nav-pills .nav-item.show .nav-link[data-v-47e688b5] {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #FFF;\n    background-color:#fff;\n    color: var(--theme-primary);\n    width: 15rem;\n}\n.nav-pills .nav-link[data-v-47e688b5] {\n    padding: 15px 30px;\n    border-top: 1px solid var(--theme-primary);\n    border-right: 1px solid var(--theme-primary);\n    border-left: 1px solid var(--theme-primary);\n    border-bottom: 1px solid var(--theme-primary);\n    border-radius: 0rem;\n    background-color:var(--theme-primary);\n    color:#fff;\n    width: 15rem;\n}\n.nav-pills .nav-link[data-v-47e688b5]:hover {\n    padding: 15px 30px;\n    border-top: 1px solid #00524A;\n    border-right: 1px solid #00524A;\n    border-left: 1px solid #00524A;\n    border-bottom: 1px solid var(--theme-primary);\n    background-color:#00524A;\n    color:#fff;\n    width: ;\n}\n.nav-pills .nav-link.active[data-v-47e688b5]:hover {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #FFF;\n    background-color:#FFF;\n    color: var(--theme-primary);\n    width: ;\n}\n.nav-tabs .nav-link[data-v-47e688b5]:focus, .nav-tabs .nav-link[data-v-47e688b5]:hover {\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    background-color:#00524A;\n    color: #fff;\n}\n.nav-tabs .nav-link[data-v-47e688b5] {\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n}\n.nav-link[data-v-47e688b5]:focus, .nav-link[data-v-47e688b5]:hover {\n    text-decoration: none;\n}\n/* Extra small devices (portrait phones, less than 576px) */\n@media (max-width: 575px) {\n.nav-pills[data-v-47e688b5], .nav-link[data-v-47e688b5] {\n  width: 100%;\n}\n.nav-item[data-v-47e688b5] {\n  margin: 5px 0 0 0;\n}\n.nav-pills .nav-link.active[data-v-47e688b5], .nav-pills .nav-item.show .nav-link[data-v-47e688b5] {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #CECECB;\n    margin: 2px 0;\n    background-color:#fff;\n    color: var(--theme-primary);\n    width: 100%;\n}\n.nav-pills .nav-link[data-v-47e688b5] {\n    padding: 15px 30px;\n    border-top: 1px solid var(--theme-primary);\n    border-right: 1px solid var(--theme-primary);\n    border-left: 1px solid var(--theme-primary);\n    border-bottom: 1px solid var(--theme-primary);\n    margin: 2px 0;\n    border-radius: 0rem;\n    background-color:var(--theme-primary);\n    color:#fff;\n    width: 100%;\n}\n.barchart[data-v-47e688b5] {\n  display:none;\n}\n}\n/* Small devices (landscape phones, 576px and up) */\n@media (min-width: 576px) and (max-width: 767px) {\n.nav-pills[data-v-47e688b5], .nav-link[data-v-47e688b5] {\n  width: 100%;\n}\n.nav-item[data-v-47e688b5] {\n    margin: 0 0 0 1px;\n}\n.nav-link[data-v-47e688b5] {\n    margin: 0;\n}\n.nav-pills .nav-link.active[data-v-47e688b5], .nav-pills .nav-item.show .nav-link[data-v-47e688b5] {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #CECECB;\n    margin: 2px 0;\n    background-color:#fff;\n    color: var(--theme-primary);\n    width: 100%;\n}\n.nav-pills .nav-link[data-v-47e688b5] {\n    padding: 15px 30px;\n    border-top: 1px solid var(--theme-primary);\n    border-right: 1px solid var(--theme-primary);\n    border-left: 1px solid var(--theme-primary);\n    border-bottom: 1px solid var(--theme-primary);\n    margin: 2px 0;\n    border-radius: 0rem;\n    background-color:var(--theme-primary);\n    color:#fff;\n    width: 100%;\n}\n.barchart[data-v-47e688b5] {\n  display:none;\n}\n}\n.input-adduser[data-v-47e688b5]{\n    height: initial;\n    padding: 5px 15px;\n    width: 100%;\n\tbackground: #fff;\n\tmargin: 0px !important\n}\n.input-checkbx-sub[data-v-47e688b5]{\nwidth: 20px;\nheight: 20px !important;\ndisplay: inline-block;\n}\n.preflang[data-v-47e688b5]{\n    width: 100%;\n    min-height: 34px;\n}\n.success-bg[data-v-47e688b5]{\n    background: #90ee90;\n}\n.error-bg[data-v-47e688b5]{\n   background: #ffc0cb;\n}\n.form-control-label[data-v-47e688b5]{min-width: 120px;font-size:12px;\n}\n.wrap-input[data-v-47e688b5]{display:block;overflow:hidden\n}\n.form-wrap[data-v-47e688b5]{    margin-bottom: 3px;\n}\n.create-btn[data-v-47e688b5]{margin-top: 10px;\n    height: 40px;\n    line-height: 0px;font-size: 12px;float:right;\n}\n.search-icon[data-v-47e688b5]{margin-top: 10px;\n    margin-top: 0px;\n    height: 40px !important;\n    line-height: 0px;\n    padding: 12px 24px 14px 24px;\n\tmargin-bottom: 10px;\n    border-radius: 0px;\n}\n.tableContainer[data-v-47e688b5]{padding: 0px 15px 30px;    overflow-x: auto;\n}\n.input-group[data-v-47e688b5]{\n    width: 100%;\n    background: #fff;\n    margin: 0px -15px 0p;\n    padding: 5px;\n    outline: 15px solid #fff;\n    /* margin: 0px -15px; */\n}\n.input-group-btn[data-v-47e688b5] {max-width:65px\n}\n.sub-group[data-v-47e688b5]{display: inline-block\n}\n@media (max-width: 1050px) {\n.input-group[data-v-47e688b5] {\n    width:100% !important;\n\tdisplay: block;\n}\n}\n@media (max-width: 768px) {\n.sub-group[data-v-47e688b5] {\n    width:100% !important;\n\tdisplay: block;\n}\n.searchId[data-v-47e688b5]{max-width: 230px;\n}\n.filter-text[data-v-47e688b5]{margin-left: 0px !important\n}\n.adduser-btn[data-v-47e688b5]{margin-left: 0px !important\n}\n}\n.dropdown div[data-v-47e688b5], .dropdown dt[data-v-47e688b5] {\n    margin:0px;\n    padding:0px;\n}\n.dropdown ul[data-v-47e688b5] {\n    margin:0px;\n    padding:0px;\n}\n.dropdown div[data-v-47e688b5] {\n    position:relative;\n    margin:0px;\n    padding:0px;\n}\n.dropdown a[data-v-47e688b5], .dropdown a[data-v-47e688b5]:visited {\n    color:#fff;\n    text-decoration:none;\n    outline:none;\n    margin:0px;\n    padding:0px;\n    min-height: 30px;\n    border-radius: 3px;\n}\n.dropdown div a[data-v-47e688b5] {\n    background-color:#4F6877;\n    display:block;\n    overflow: hidden;\n    width:100%;\n    margin:0px;\n    padding:0px;\n}\n.dropdown div a span[data-v-47e688b5], .multiSel span[data-v-47e688b5] {\n    cursor:pointer;\n    display:inline-block;\n    margin:0px;\n    padding:5px 10px;\n}\n.dropdown div ul[data-v-47e688b5] {\n    background-color: #4F6877;\n    top:1px;\n    color:#fff;\n    display:none;\n    position:absolute;\n    width:100%;\n    list-style:none;\n    height: 100px;\n    overflow: auto;\n    margin:0px;\n    padding:0px;\n}\n.dropdown span.value[data-v-47e688b5] {\n    display:none;\n    border-radius: 3px;\n    margin:0px;\n    padding:0px;\n}\n.dropdown div ul li a[data-v-47e688b5] {\n    display:block;\n    margin:0px;\n    padding:0px;\n}\n.dropdown div ul li a[data-v-47e688b5]:hover {\n    background-color:#fff;\n    margin:0px;\n    padding:0px;\n}\n.selectDropDown[data-v-47e688b5]{border: 2px solid #dde3e6;height:40px;\n    /* border-radius: 3px; */\n    cursor: pointer;\n    background: #fff;\n\twidth: 100%;\n}\n.searchDropDown[data-v-47e688b5]{\n  border: 2px solid #dde3e6;\n  background: #fff;\n\twidth: 100%;\n  min-height: 40px;\n  padding: 10px;\n}\n#checkboxlist[data-v-47e688b5]{position: relative;\n    margin-top: 0px;\n\tbackground:#fff;\n\tborder: 1px solid #ccc;\n\tmin-width: 200px;\n}\n#checkboxlistself[data-v-47e688b5] {\n  position: relative;\n  margin-top: 0px;\n\tbackground:#fff;\n\tborder: 1px solid #ccc;\n\tmin-width: 200px;\n}\n.dd-list-item[data-v-47e688b5]:hover{background:#fff\n}\nbutton[data-v-47e688b5] {background:var(--theme-primary) !important\n}\n.adduser-btn[data-v-47e688b5]{margin-left: 20px;max-height: 40px;margin-top: 0px;line-height: 0px;height: 40px;background-color: var(--theme-primary);font-size: 12px;\n}\ninput[data-v-47e688b5], select[data-v-47e688b5]{\nbackground: #fff!important;\n    border: 2px solid #dde3e6!important;\n\tpadding-left: 10px !important;\n    font-size: 14px !important;\n}\n.bc[data-v-47e688b5]{font-size:10px;font-weight:bold;\n}\n.bc-adduser[data-v-47e688b5]{font-size:10px;font-weight:bold;margin:15px\n}\n.bc-nav[data-v-47e688b5]:hover{text-decoration:underline; cursor:pointer\n}\n.user-creds[data-v-47e688b5]{background:#fff;    padding: 5px 10px 10px;\n    margin-bottom: 12px;\n}\n.bb0[data-v-47e688b5]{border-top:0px !important\n}\n.add-group[data-v-47e688b5]{color:var(--theme-primary);font-size:18px;float:right;margin-top: 5px;cursor:pointer\n}\n.remove-group[data-v-47e688b5]{color: #d80842;\n    font-size: 20px;\n    /* float: right; */\n    margin-top: 6px;\n    cursor: pointer;\n}\n.group-div[data-v-47e688b5]{border:2px solid #eceff1;padding: 3px 10px;\n}\n.group-name[data-v-47e688b5]{display: inline-block;width: 90%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.usercreateinfo[data-v-47e688b5]{margin-top: 10px;background: #546e7a;color: #fff;padding: 10px;margin-bottom: 10px;\n}\n@media screen and (max-width: 767px) {\n.main-content[data-v-47e688b5]{padding-top:25px\n}\n.main-content[data-v-47e688b5]{padding-left:0px\n}\n}\n@media screen and (min-width: 768px) {\n.main-content[data-v-47e688b5]{padding-top:0px\n}\n.main-content[data-v-47e688b5]{padding-left:200px\n}\n}\n@media screen and (min-width: 991px) {\n.search-bar-wrapper[data-v-47e688b5]{width: 100%\n}\n.search-bar-select[data-v-47e688b5]{width: 300px;\n}\n}\n@media screen and (max-width: 991px) {\n.search-bar-wrapper[data-v-47e688b5]{width: 75%\n}\n.search-bar-select[data-v-47e688b5]{width: 150px;\n}\n}\n.cancel-btn[data-v-47e688b5]{    float: right;\n    display: block;\n    padding: 18px 30px;\n}\ninput[data-v-47e688b5], select[data-v-47e688b5] { height: 32px !important; color: #000 !important\n}\nbutton[data-v-47e688b5] { height: 32px !important; color: #fff !important\n}\n.disabled[data-v-47e688b5] {pointer-events:none;opacity:0.5\n}\n.disabledLight[data-v-47e688b5] {pointer-events:none;opacity:0.8\n}\n.error[data-v-47e688b5]{    color: red;width: 100%;\n    margin-left: 15px;\n}\n.pwderror[data-v-47e688b5]{max-width:initial;width:100%;font-size: 14px;\n}\n.codeVerifybtn[data-v-47e688b5]{\nbackground:#f9f9f9;\ncolor:#595959;\nborder:1px solid #c3c3c3;\nfont-size:13px;\ndisplay: inline-block !important;\n margin-top: -2px;\n height: 30px;\n line-height: 14px;\n width: 87px;\n}\n.fa-check-circle[data-v-47e688b5] {font-size:40px !important\n}\nlabel[data-v-47e688b5]{margin-bottom:0px !important;font-weight:normal !important;font-size:13px;\n}\nuser-creds label[data-v-47e688b5]{font-weight: normal !important;\n}\n.sometext-hidden[data-v-47e688b5]{\n-webkit-user-select: none; /* Chrome/Safari */\n-moz-user-select: none; /* Firefox */\n-ms-user-select: none; /* IE10+ */\n}\n.configGroupAdmin tr[data-v-47e688b5], td[data-v-47e688b5], th[data-v-47e688b5]{padding-top: 5px;padding-bottom:5px;\n}\n.configGroupAdmin tr[data-v-47e688b5]{border-bottom: 1px solid #eceff1;\n}\n.configGroupAdmin th[data-v-47e688b5] {padding: 10px !important;\n}\n.addgrouptxtbox[data-v-47e688b5]{\n  width: 75%;\n  border: #ccc 1px solid !important;\n  border-radius: 2px;\n  margin-top: 5px;\n  font-size: 15px !important;\n}\n.deleteconfig[data-v-47e688b5]{\nmargin-right: 15px;\nline-height: 13px;\ncursor:pointer;\npadding: 6px;\nfont-size: 13px;\n border-radius: 3px;\n background: #bf6161  !important;\n box-shadow: rgba(216, 21, 33, 0.75) 0px 0px 20px inset;\n max-height: 30px;\n margin-top: 2px;\n}\ninput[type=text][data-v-47e688b5]:focus\n{  \n  border-color: #dde3e6 !important;\n}\n.app-name[data-v-47e688b5] {\n  padding-top: 5px;\n}\n.app-name[data-v-47e688b5]:hover {\n  text-decoration: underline;\n  color: blue;\n}\n.dropdownWrap[data-v-47e688b5] {\n  width:75% !important; \n  height: 40px !important; \n  padding: 7px !important; \n  font-size: 1rem !important;\n}\n.search-app[data-v-47e688b5] {\n  width: 70%;\n  font-size: 1rem !important;\n  border: 0 !important;\n  border-bottom: 1px solid #ccc !important;\n  display: inline;\n}\n.appDetails[data-v-47e688b5] {\n  padding: 10px 0px;\n  color: #658d1b;\n  font-weight: 600;\n  background: #fafafa;\n  width: 100%;\n}\n.search-list-for-admin[data-v-47e688b5] {\n  vertical-align: super;\n  cursor: pointer;\n  padding: 5px;\n}\n.search-list-for-admin[data-v-47e688b5]:hover {\n  background: #e3e2e24a;\n  transform: scale(1.05);\n}\n.switch[data-v-47e688b5] {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 20px;\n}\n.switch input[data-v-47e688b5] {\n  display: none;\n}\n.slider[data-v-47e688b5] {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n}\n.slider[data-v-47e688b5]:before {\n  position: absolute;\n  content: \"\";\n  height: 15px;\n  width: 15px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.4s;\n}\ninput:checked + .slider[data-v-47e688b5] {\n  background-color: #658d1b;\n}\ninput:focus + .slider[data-v-47e688b5] {\n  box-shadow: 0 0 1px #658d1b;\n}\ninput:checked + .slider[data-v-47e688b5]:before {\n  transform: translateX(20px);\n}\n.slider.round[data-v-47e688b5] {\n  border-radius: 34px;\n}\n.slider.round[data-v-47e688b5]:before {\n  border-radius: 50%;\n}\n", ""]);

// exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\n.hiddden[data-v-4b105266] {\r\n  visibility:hidden;\n}\ninput[data-v-4b105266] {\r\n  background: #fff;\n}\ninput[data-v-4b105266], select[data-v-4b105266] {\r\n  height: 30px;\r\n  color:#333;\r\n  margin-top:2px;\n}\nlabel > input[data-v-4b105266] { /* HIDE RADIO */\r\n  visibility: hidden; /* Makes input not-clickable */\r\n  position: absolute; /* Remove input from document flow */\n}\nlabel > input + img[data-v-4b105266] { /* IMAGE STYLES */\r\n  cursor:pointer;\r\n  border:2px solid #ddd;\n}\nlabel > input:checked + img[data-v-4b105266] { /* (RADIO CHECKED) IMAGE STYLES */\r\n  border:2px solid #333;\r\n  border-radius:0px;\n}\ninput[data-v-4b105266], select[data-v-4b105266] {\r\n  background: #fff;\r\n  border: 2px solid #dde3e6!important;\r\n  display: block !important;\r\n  border-radius: 0px !important;\r\n  min-height: 30px;\r\n  padding-left: 5px;\n}\ninput[type=button][data-v-4b105266]:hover, button[data-v-4b105266]:hover {\r\n  background-color: var(--theme-primary) !important;\r\n  border: 1px solid var(--theme-primary) !important;\r\n\tcolor: var(--regpwd-secondarytextcolor) !important;\r\n\tborder-radius: 0px !important;\n}\ninput[type=button][data-v-4b105266], button[data-v-4b105266] {  \r\n  background-color: var(--theme-primary) !important;\r\n  border-color: var(--theme-primary) !important;\r\n\tcolor: var(--regpwd-secondarytextcolor) !important;\r\n\tborder-radius: 0px !important;\n}\n#selfRegistration[data-v-4b105266], #selfRegistrationSucess[data-v-4b105266] {\r\n  max-width: 394px;\r\n  margin: auto;\r\n  margin-top: 50px;\r\n  margin-bottom: 50px;\n}\n.bg[data-v-4b105266] {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\n}\n.splash[data-v-4b105266] {\r\n  position: absolute;\r\n  top: 0px;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: -1;\r\n\t-o-object-fit: cover;\r\n\t   object-fit: cover;\n}\n.disabled[data-v-4b105266] {\r\n  pointer-events: none;\r\n  opacity: 0.6\n}\n.validation-text[data-v-4b105266] {\r\n  color: #bd0000;\r\n  background: pink;\r\n  border-radius: 3px;\r\n  border: 1px solid #bd0000;\r\n  padding: 5px 10px;\r\n  margin: 10px 0px;\n}\n.okta-sign-in-header[data-v-4b105266] {\r\n  padding: 10px 90px 10px 90px;\r\n  position: relative;\r\n  z-index: 10;\r\n  transition: padding-bottom .4s;\n}\n.auth-org-logo[data-v-4b105266] {\r\n  max-width: 120px !important;\r\n  display: block;\r\n  margin: 0 auto;\r\n  max-height: 40px;\n}\r\n", ""]);

// exports


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\nbody[data-v-4b19517a] {\n  /* Margin bottom by footer height */\n  margin-bottom: 0;\n}\n.modal-content[data-v-4b19517a] {\n    -webkit-border-radius: 0;\n    -webkit-background-clip: padding-box;\n    -moz-border-radius: 0;\n    -moz-background-clip: padding;\n    border-radius: 6px;\n    background-clip: padding-box;\n    box-shadow: 0 0 40px rgba(0,0,0,.5);\n    color: #000;\n    background-color: #fff;\n    border: rgba(0,0,0,0);\n}\n.modal-message .modal-body[data-v-4b19517a], .modal-message .modal-footer[data-v-4b19517a], .modal-message .modal-header[data-v-4b19517a], .modal-message .modal-title[data-v-4b19517a] {\n    background: 0 0;\n    border: none;\n    margin: 0;\n    padding: 0 20px;\n    text-align: center!important;\n}\n.modal-message .modal-title[data-v-4b19517a] {\n    font-size: 1.5rem;\n    color: #737373;\n    margin-bottom: 3px;\n}\n.modal-message .modal-body[data-v-4b19517a] {\n    color: #737373;\n    padding-top: 20px;\n}\n.modal-message .modal-header[data-v-4b19517a] {\n    color: #fff;\n    margin-bottom: 10px;\n    padding: 15px;\n}\n.modal-message .modal-header .fa[data-v-4b19517a],\n.modal-message .modal-header\n.glyphicon[data-v-4b19517a], .modal-message\n.modal-header .typcn[data-v-4b19517a], .modal-message .modal-header .wi[data-v-4b19517a] {\n    font-size: 3rem;\n}\n.modal-message .modal-footer[data-v-4b19517a] {\n    margin: 25px 0 20px;\n    padding-bottom: 10px;\n}\n.modal-message.modal-warning .modal-header[data-v-4b19517a] {\n    color: #f4b400;\n    border-bottom: 3px solid #ffce55;\n}\n", ""]);

// exports


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\n.admintobrand[data-v-595e07ce] {\n    font-weight:bold;\n    font-size:20px;\n    text-transform:capitalize;\n    background: #eee;\n    padding-left: 10px;\n    display:block;\n}\nul[data-v-595e07ce] {\n    list-style-type: none;\n    padding: 0;\n}\nli[data-v-595e07ce] {\n    display: inline-block;\n    margin: 0 10px;\n    padding: 0;\n}\n.custom-select[data-v-595e07ce] {\n\tdisplay: inline-block;\n\tmax-width: 100%;\n\theight: calc(2.50rem + 2px);\n\tpadding: 0.375rem 1.75rem 0.375rem 0.75rem;\n\tline-height: 1.25;\n\tbackground-color: #ececeb;\n\tvertical-align: middle;\n\tbackground-size: 8px 10px;\n\tborder: 1px solid #00524A;\n\tborder-radius: 0;\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n}\n.card-block[data-v-595e07ce] {\n\tbackground: #eceff1;\n}\n.user-input[data-v-595e07ce] {\n\twidth: 100%;\n\tbackground: #ffffff;\n\tcolor: #333333;\n\theight: 30px;\n}\n.user-select[data-v-595e07ce] {\n\tcolor: #333333;\n\theight: 30px;\n}\n#userSearch[data-v-595e07ce] {\n\tmargin: 10px;\n}\n.good-table th[data-v-595e07ce] {\n\tcolor: #333333 !important\n}\n.btn-secondary[data-v-595e07ce]:active {\n\tbackground: #007299;\n\tbox-shadow: none;\n}\n.btn-secondary[data-v-595e07ce] {\n\tbackground: var(--theme-primary);\n\tcolor: #ffffff;\n}\ninput[data-v-595e07ce] {\n\twidth: 130px;\n\tbox-sizing: border-box;\n\tborder: 1px solid var(--theme-primary);\n\tborder-radius: 0;\n\tfont-size: 16px;\n\tbackground-color: #f1f1f1;\n\tbackground-position: 10px 10px;\n\tbackground-repeat: no-repeat;\n\tpadding: 15px 20px;\n\theight: 50px;\n}\n.card[data-v-595e07ce] {\n\tposition: relative;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tbackground-color: #33373D;\n\tborder: 0px solid rgba(0, 0, 0, 0.125);\n\tborder-radius: 0px;\n\tbox-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px\n\t\trgba(0, 0, 0, 0.22);\n\tbox-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.4);\n}\n.card[data-v-595e07ce] {\n\tmargin-bottom: 1rem;\n\tbox-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);\n}\n.card-block1[data-v-595e07ce] {\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    padding: 0rem;\n}\n#searchId[data-v-595e07ce] {\n\tbox-sizing: border-box !important;\n\tborder: 2px solid #dde3e6 !important;\n\tborder-radius: 0 !important;\n\tbackground-color: #fff !important;\n\tbackground-position: 10px 10px !important;\n\tbackground-repeat: no-repeat !important;\n\theight: 40px !important;\n\tmargin-bottom: 18px !important;\n\tmargin-left: 30px !important;\n}\n.filter-label[data-v-595e07ce]{ width: 150px;\n    float: left;\n    font-size: 14px;\n    margin-top: 8px;\n    font-weight: bold;\n}\n.btn-secondary[data-v-595e07ce] {\n\tbackground-color: var(--theme-primary);;\n\tborder-color: #00433c;\n}\n.btn-secondary[data-v-595e07ce]:hover {\n\tbackground-color: #00524A;\n\tborder-color: #00433c;\n}\n.btn[data-v-595e07ce] {\n\tpadding: 14px 24px;\n\tborder: 0 none;\n\tfont-weight: 700;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n/* Pills styles */\n.nav-pills .nav-link.active[data-v-595e07ce], .nav-pills .nav-item.show .nav-link[data-v-595e07ce] {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #FFF;\n    background-color:#fff;\n    color: var(--theme-primary);\n    width: 15rem;\n}\n.nav-pills .nav-link[data-v-595e07ce] {\n    padding: 15px 30px;\n    border-top: 1px solid var(--theme-primary);\n    border-right: 1px solid var(--theme-primary);\n    border-left: 1px solid var(--theme-primary);\n    border-bottom: 1px solid var(--theme-primary);\n    border-radius: 0rem;\n    background-color:var(--theme-primary);\n    color:#fff;\n    width: 15rem;\n}\n.nav-pills .nav-link[data-v-595e07ce]:hover {\n    padding: 15px 30px;\n    border-top: 1px solid #00524A;\n    border-right: 1px solid #00524A;\n    border-left: 1px solid #00524A;\n    border-bottom: 1px solid var(--theme-primary);\n    background-color:#00524A;\n    color:#fff;\n    width: ;\n}\n.nav-pills .nav-link.active[data-v-595e07ce]:hover {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #FFF;\n    background-color:#FFF;\n    color: var(--theme-primary);\n    width: ;\n}\n.nav-tabs .nav-link[data-v-595e07ce]:focus, .nav-tabs .nav-link[data-v-595e07ce]:hover {\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    background-color:#00524A;\n    color: #fff;\n}\n.nav-tabs .nav-link[data-v-595e07ce] {\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n}\n.nav-link[data-v-595e07ce]:focus, .nav-link[data-v-595e07ce]:hover {\n    text-decoration: none;\n}\n/* Extra small devices (portrait phones, less than 576px) */\n@media (max-width: 575px) {\n.nav-pills[data-v-595e07ce], .nav-link[data-v-595e07ce] {\n  width: 100%;\n}\n.nav-item[data-v-595e07ce] {\n  margin: 5px 0 0 0;\n}\n.nav-pills .nav-link.active[data-v-595e07ce], .nav-pills .nav-item.show .nav-link[data-v-595e07ce] {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #CECECB;\n    margin: 2px 0;\n    background-color:#fff;\n    color: var(--theme-primary);\n    width: 100%;\n}\n.nav-pills .nav-link[data-v-595e07ce] {\n    padding: 15px 30px;\n    border-top: 1px solid var(--theme-primary);\n    border-right: 1px solid var(--theme-primary);\n    border-left: 1px solid var(--theme-primary);\n    border-bottom: 1px solid var(--theme-primary);\n    margin: 2px 0;\n    border-radius: 0rem;\n    background-color:var(--theme-primary);\n    color:#fff;\n    width: 100%;\n}\n.barchart[data-v-595e07ce] {\n  display:none;\n}\n}\n/* Small devices (landscape phones, 576px and up) */\n@media (min-width: 576px) and (max-width: 767px) {\n.nav-pills[data-v-595e07ce], .nav-link[data-v-595e07ce] {\n  width: 100%;\n}\n.nav-item[data-v-595e07ce] {\n    margin: 0 0 0 1px;\n}\n.nav-link[data-v-595e07ce] {\n    margin: 0;\n}\n.nav-pills .nav-link.active[data-v-595e07ce], .nav-pills .nav-item.show .nav-link[data-v-595e07ce] {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #CECECB;\n    margin: 2px 0;\n    background-color:#fff;\n    color: var(--theme-primary);\n    width: 100%;\n}\n.nav-pills .nav-link[data-v-595e07ce] {\n    padding: 15px 30px;\n    border-top: 1px solid var(--theme-primary);\n    border-right: 1px solid var(--theme-primary);\n    border-left: 1px solid var(--theme-primary);\n    border-bottom: 1px solid var(--theme-primary);\n    margin: 2px 0;\n    border-radius: 0rem;\n    background-color:var(--theme-primary);\n    color:#fff;\n    width: 100%;\n}\n.barchart[data-v-595e07ce] {\n  display:none;\n}\n}\n.input-adduser[data-v-595e07ce]{\n    height: initial;\n    padding: 5px 15px;\n    width: 100%;\n\tbackground: #fff;\n\tmargin: 0px !important\n}\n.input-checkbx[data-v-595e07ce], .gsearch[data-v-595e07ce]{\nwidth: 20px;\nheight: 20px;\ndisplay: inline-block;\n}\n.preflang[data-v-595e07ce]{\n    width: 100%;\n    min-height: 34px;\n}\n.success-bg[data-v-595e07ce]{\n    background: #90ee90;\n}\n.error-bg[data-v-595e07ce]{\n   background: #ffc0cb;\n}\n.form-control-label[data-v-595e07ce]{min-width: 120px;font-size:12px\n}\n.wrap-input[data-v-595e07ce]{display:block;overflow:hidden\n}\n.form-wrap[data-v-595e07ce]{    margin-bottom: 3px;\n}\n.create-btn[data-v-595e07ce]{margin-top: 10px;\n    height: 40px;\n    line-height: 0px;font-size: 12px;float:right;\n}\n.search-icon[data-v-595e07ce]{margin-top: 10px;\n    margin-top: 0px;\n    height: 40px !important;\n    line-height: 0px;\n    padding: 12px 24px 14px 24px;\n\tmargin-bottom: 10px;\n    border-radius: 0px;\n}\n.tableContainer[data-v-595e07ce]{padding: 0px 15px 30px;    overflow-x: auto;\n}\n.input-group[data-v-595e07ce]{\n    width: 100%;\n    background: #fff;\n    margin: 0px -15px 0p;\n    padding: 5px;\n    outline: 15px solid #fff;\n    /* margin: 0px -15px; */\n}\n.input-group-btn[data-v-595e07ce] {max-width:65px\n}\n.sub-group[data-v-595e07ce]{display: inline-block\n}\n@media (max-width: 1050px) {\n.input-group[data-v-595e07ce] {\n    width:100% !important;\n\tdisplay: block;\n}\n}\n@media (max-width: 768px) {\n.sub-group[data-v-595e07ce] {\n    width:100% !important;\n\tdisplay: block;\n}\n.searchId[data-v-595e07ce]{max-width: 230px;\n}\n.filter-text[data-v-595e07ce]{margin-left: 0px !important\n}\n.adduser-btn[data-v-595e07ce]{margin-left: 0px !important\n}\n}\n.dropdown div[data-v-595e07ce], .dropdown dt[data-v-595e07ce] {\n    margin:0px;\n    padding:0px;\n}\n.dropdown ul[data-v-595e07ce] {\n    margin:0px;\n    padding:0px;\n}\n.dropdown div[data-v-595e07ce] {\n    position:relative;\n    margin:0px;\n    padding:0px;\n}\n.dropdown a[data-v-595e07ce], .dropdown a[data-v-595e07ce]:visited {\n    color:#fff;\n    text-decoration:none;\n    outline:none;\n    margin:0px;\n    padding:0px;\n    min-height: 30px;\n    border-radius: 3px;\n}\n.dropdown div a[data-v-595e07ce] {\n    background-color:#4F6877;\n    display:block;\n    overflow: hidden;\n    width:100%;\n    margin:0px;\n    padding:0px;\n}\n.dropdown div a span[data-v-595e07ce], .multiSel span[data-v-595e07ce] {\n    cursor:pointer;\n    display:inline-block;\n    margin:0px;\n    padding:5px 10px;\n}\n.dropdown div ul[data-v-595e07ce] {\n    background-color: #4F6877;\n    top:1px;\n    color:#fff;\n    display:none;\n    position:absolute;\n    width:100%;\n    list-style:none;\n    height: 100px;\n    overflow: auto;\n    margin:0px;\n    padding:0px;\n}\n.dropdown span.value[data-v-595e07ce] {\n    display:none;\n    border-radius: 3px;\n    margin:0px;\n    padding:0px;\n}\n.dropdown div ul li a[data-v-595e07ce] {\n    display:block;\n    margin:0px;\n    padding:0px;\n}\n.dropdown div ul li a[data-v-595e07ce]:hover {\n    background-color:#fff;\n    margin:0px;\n    padding:0px;\n}\n.selectDropDown[data-v-595e07ce]{border: 2px solid #dde3e6;height:34px;\n    /* border-radius: 3px; */\n    cursor: pointer;\n    background: #fff;\n\twidth: 100%;\n}\n#checkboxlist[data-v-595e07ce]{position: relative;\n    margin-top: 0px;\n\tbackground:#fff;\n\tborder: 1px solid #ccc;\n\tmin-width: 200px;\n}\n.dd-list-item[data-v-595e07ce]:hover{background:#fff\n}\nbutton[data-v-595e07ce] {background:var(--theme-primary) !important\n}\n.adduser-btn[data-v-595e07ce]{margin-left: 20px;max-height: 40px;margin-top: 0px;line-height: 0px;height: 40px;background-color: var(--theme-primary);font-size: 12px;\n}\ninput[data-v-595e07ce], select[data-v-595e07ce]{\nbackground: #fff!important;\n    border: 2px solid #dde3e6!important;  \n\tpadding: 9px !important;\n    font-size: 14px !important;\n}\n.bc[data-v-595e07ce]{font-size:10px;font-weight:bold;\n}\n.bc-adduser[data-v-595e07ce]{font-size:10px;font-weight:bold;margin:15px\n}\n.bc-nav[data-v-595e07ce]:hover{text-decoration:underline; cursor:pointer\n}\n.user-creds[data-v-595e07ce]{background:#fff;padding: 7px 15px 15px;\n    margin-bottom: 12px;\n}\n.bb0[data-v-595e07ce]{border-bottom:0px !important\n}\n.add-group[data-v-595e07ce]{color:var(--theme-primary);font-size:18px;float:right;margin-top: 5px;cursor:pointer\n}\n.remove-group[data-v-595e07ce]{color:#d80842;font-size:18px;float:right;margin-top: 5px;cursor:pointer\n}\n.group-div[data-v-595e07ce]{border:2px solid #eceff1;padding: 3px 10px;\n}\n.group-name[data-v-595e07ce]{display: inline-block;width: 90%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.usercreateinfo[data-v-595e07ce]{margin-top: 10px;background: #546e7a;color: #fff;padding: 10px;margin-bottom: 10px;font-size: 14px;\n}\n@media screen and (max-width: 767px) {\n.main-content[data-v-595e07ce]{padding-top:25px\n}\n.main-content[data-v-595e07ce]{padding-left:0px\n}\n}\n@media screen and (min-width: 768px) {\n.main-content[data-v-595e07ce]{padding-top:0px\n}\n.main-content[data-v-595e07ce]{padding-left:200px\n}\n}\n@media screen and (min-width: 991px) {\n.search-bar-wrapper[data-v-595e07ce]{width: 100%\n}\n.search-bar-select[data-v-595e07ce]{\n}\n}\n@media screen and (max-width: 991px) {\n.search-bar-wrapper[data-v-595e07ce]{\n}\n.search-bar-select[data-v-595e07ce]{\n}\n}\n.cancel-btn[data-v-595e07ce]{    float: right;cursor:pointer;\n    display: block;\n    padding: 18px 30px;\n}\n.disabled[data-v-595e07ce]{pointer-events:none;opacity:0.6;\n}\n.searchinfotext[data-v-595e07ce] {\n    position: absolute;\n    top: 68px;\n    font-size: 12px;\n    z-index: 999;\n\tcolor: #8c8c8c;\n}\n@media all and (-ms-high-contrast:none)\n{\n.input-adduser[data-v-595e07ce] {\n  height: auto !important;\n}\n}\n.report-link[data-v-595e07ce]{\n    font-weight: bold;\n    float: right;\n    text-decoration: underline;\n    font-size: 16px;\n    color: #658d1b;\n\tcursor:pointer;\n}\nbutton.close[data-v-595e07ce] {\n  background: transparent !important;\n}\n.dxpNewmodal input[type=radio][data-v-595e07ce] {\n  width: 13px !important;\n  height: 13px !important;\n}\n.row.date-field-edit[data-v-595e07ce] {\n  padding: 0px 20px;\n}\n.date-value-edit[data-v-595e07ce] {\n  font-size: 14px;\n}\n.separator[data-v-595e07ce] {\n  line-height: 18px;\n  padding-right: 5px;\n}\n.date-info[data-v-595e07ce] {\n  padding: 0px 5px 0px 2px;\n  font-size: 12px;\n}\n.mfa-list[data-v-595e07ce] {\n  padding: 0px 10px;\n}\n.validation-mfa[data-v-595e07ce] {\n  padding: 0px 10px 10px;\n  font-size: 14px;\n  color: #ff0000;\n}\n.mfa-btn[data-v-595e07ce] {\n  font-size: 12px;\n  height: 35px;\n  margin: 5px 10px;\n  line-height: 0;\n  padding: 10px 15px;\n}\n.checkboxgroup[data-v-595e07ce] {\n  display: -ms-flexbox;\n  display: flex;\n  text-align: center;\n}\n.checkboxgroup label[data-v-595e07ce] {\n  display: inline-block;\n}\n.bulk-list[data-v-595e07ce] {\n  padding: 5px 10px;\n}\n.bulk-list[data-v-595e07ce]:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.bulk-upload-header[data-v-595e07ce] {\n  background-color: #658d1be3;\n  color: #ffffff;\n}\n.bulk-upload-warning[data-v-595e07ce] {\n  color:#ffa900;\n  padding-right:10px;\n}\n", ""]);

// exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*color: #d9d1cf; font-family: HelveticaNeueW01-75Bold, Helvetica, Arial, sans-serif; font-size: 12px*/\na.bootomFooter[data-v-6c07c36f]:hover {\n    color: var(--theme-primary);\n color: #273238 !important\n}\n.bootomFooter a[data-v-6c07c36f], .bootomFooter a[data-v-6c07c36f]:active  {\n    color: var(--theme-primary);\n color: #273238 !important\n}\n.bootomFooter a[data-v-6c07c36f]:hover {\n    text-decoration: underline;\n    color:#fff;\n}\n#applicationFooter[data-v-6c07c36f]{\n    bottom: 0;\n padding: 13px 13px 13px 200px;\n height: initial;\n background: #fff;\n color: #273238 !important;\n}\n@media (max-width: 767px) {\n#applicationFooter[data-v-6c07c36f]{\n padding-left: 15px;\n}\n}\n", ""]);

// exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\nul[data-v-7a8c026c] {\n    list-style-type: none;\n    padding: 0;\n}\nli[data-v-7a8c026c] {\n    display: inline-block;\n    margin: 0 10px;\n    padding: 0;\n}\n.custom-select[data-v-7a8c026c] {\n\tdisplay: inline-block;\n\tmax-width: 100%;\n\theight: calc(2.50rem + 2px);\n\tpadding: 0.375rem 1.75rem 0.375rem 0.75rem;\n\tline-height: 1.25;\n\tbackground-color: #ececeb;\n\tvertical-align: middle;\n\tbackground-size: 8px 10px;\n\tborder: 1px solid #00524A;\n\tborder-radius: 0;\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n}\n.card-block[data-v-7a8c026c] {\n\tbackground: #eceff1;\n}\n.user-input[data-v-7a8c026c] {\n\twidth: 100%;\n\tbackground: #ffffff;\n\tcolor: #333333;\n\theight: 30px;\n}\n.user-select[data-v-7a8c026c] {\n\tcolor: #333333;\n\theight: 30px;\n}\n#userSearch[data-v-7a8c026c] {\n\tmargin: 10px;\n}\n.good-table th[data-v-7a8c026c] {\n\tcolor: #333333 !important\n}\n.btn-secondary[data-v-7a8c026c]:active {\n\tbackground: #007299;\n\tbox-shadow: none;\n}\n.btn-secondary[data-v-7a8c026c] {\n\tbackground: var(--theme-primary);\n\tcolor: #ffffff;\n}\ninput[data-v-7a8c026c] {\n\twidth: 130px;\n\tbox-sizing: border-box;\n\tborder: 1px solid var(--theme-primary);\n\tborder-radius: 0;\n\tfont-size: 16px;\n\tbackground-color: #f1f1f1;\n\tbackground-position: 10px 10px;\n\tbackground-repeat: no-repeat;\n\tpadding: 15px 20px;\n\theight: 50px;\n}\n.card[data-v-7a8c026c] {\n\tposition: relative;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tbackground-color: #33373D;\n\tborder: 0px solid rgba(0, 0, 0, 0.125);\n\tborder-radius: 0px;\n\tbox-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px\n\t\trgba(0, 0, 0, 0.22);\n\tbox-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.4);\n}\n.card[data-v-7a8c026c] {\n\tmargin-bottom: 1rem;\n\tbox-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);\n}\n.card-block1[data-v-7a8c026c] {\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    padding: 0rem;\n}\n#searchId[data-v-7a8c026c] {\n\tbox-sizing: border-box !important;\n\tborder: 2px solid #dde3e6 !important;\n\tborder-radius: 0 !important;\n\tbackground-color: #fff !important;\n\tbackground-position: 10px 10px !important;\n\tbackground-repeat: no-repeat !important;\n\theight: 40px !important;\n\tmargin-bottom: 18px !important;\n\tmargin-left: 30px !important;\n}\n.filter-label[data-v-7a8c026c]{ width: 150px;\n    float: left;\n    font-size: 14px;\n    margin-top: 8px;\n    font-weight: bold;\n}\n.btn-secondary[data-v-7a8c026c] {\n\tbackground-color: var(--theme-primary);;\n\tborder-color: #00433c;\n}\n.btn-secondary[data-v-7a8c026c]:hover {\n\tbackground-color: #00524A;\n\tborder-color: #00433c;\n}\n.btn[data-v-7a8c026c] {\n\tpadding: 14px 24px;\n\tborder: 0 none;\n\tfont-weight: 700;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n/* Pills styles */\n.nav-pills .nav-link.active[data-v-7a8c026c], .nav-pills .nav-item.show .nav-link[data-v-7a8c026c] {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #FFF;\n    background-color:#fff;\n    color: var(--theme-primary);\n    width: 15rem;\n}\n.nav-pills .nav-link[data-v-7a8c026c] {\n    padding: 15px 30px;\n    border-top: 1px solid var(--theme-primary);\n    border-right: 1px solid var(--theme-primary);\n    border-left: 1px solid var(--theme-primary);\n    border-bottom: 1px solid var(--theme-primary);\n    border-radius: 0rem;\n    background-color:var(--theme-primary);\n    color:#fff;\n    width: 15rem;\n}\n.nav-pills .nav-link[data-v-7a8c026c]:hover {\n    padding: 15px 30px;\n    border-top: 1px solid #00524A;\n    border-right: 1px solid #00524A;\n    border-left: 1px solid #00524A;\n    border-bottom: 1px solid var(--theme-primary);\n    background-color:#00524A;\n    color:#fff;\n    width: ;\n}\n.nav-pills .nav-link.active[data-v-7a8c026c]:hover {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #FFF;\n    background-color:#FFF;\n    color: var(--theme-primary);\n    width: ;\n}\n.nav-tabs .nav-link[data-v-7a8c026c]:focus, .nav-tabs .nav-link[data-v-7a8c026c]:hover {\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    background-color:#00524A;\n    color: #fff;\n}\n.nav-tabs .nav-link[data-v-7a8c026c] {\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n}\n.nav-link[data-v-7a8c026c]:focus, .nav-link[data-v-7a8c026c]:hover {\n    text-decoration: none;\n}\n/* Extra small devices (portrait phones, less than 576px) */\n@media (max-width: 575px) {\n.nav-pills[data-v-7a8c026c], .nav-link[data-v-7a8c026c] {\n  width: 100%;\n}\n.nav-item[data-v-7a8c026c] {\n  margin: 5px 0 0 0;\n}\n.nav-pills .nav-link.active[data-v-7a8c026c], .nav-pills .nav-item.show .nav-link[data-v-7a8c026c] {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #CECECB;\n    margin: 2px 0;\n    background-color:#fff;\n    color: var(--theme-primary);\n    width: 100%;\n}\n.nav-pills .nav-link[data-v-7a8c026c] {\n    padding: 15px 30px;\n    border-top: 1px solid var(--theme-primary);\n    border-right: 1px solid var(--theme-primary);\n    border-left: 1px solid var(--theme-primary);\n    border-bottom: 1px solid var(--theme-primary);\n    margin: 2px 0;\n    border-radius: 0rem;\n    background-color:var(--theme-primary);\n    color:#fff;\n    width: 100%;\n}\n.barchart[data-v-7a8c026c] {\n  display:none;\n}\n}\n/* Small devices (landscape phones, 576px and up) */\n@media (min-width: 576px) and (max-width: 767px) {\n.nav-pills[data-v-7a8c026c], .nav-link[data-v-7a8c026c] {\n  width: 100%;\n}\n.nav-item[data-v-7a8c026c] {\n    margin: 0 0 0 1px;\n}\n.nav-link[data-v-7a8c026c] {\n    margin: 0;\n}\n.nav-pills .nav-link.active[data-v-7a8c026c], .nav-pills .nav-item.show .nav-link[data-v-7a8c026c] {\n    padding: 15px 30px;\n    border-top: 1px solid #CECECB;\n    border-right: 1px solid #CECECB;\n    border-left: 1px solid #CECECB;\n    border-bottom: 1px solid #CECECB;\n    margin: 2px 0;\n    background-color:#fff;\n    color: var(--theme-primary);\n    width: 100%;\n}\n.nav-pills .nav-link[data-v-7a8c026c] {\n    padding: 15px 30px;\n    border-top: 1px solid var(--theme-primary);\n    border-right: 1px solid var(--theme-primary);\n    border-left: 1px solid var(--theme-primary);\n    border-bottom: 1px solid var(--theme-primary);\n    margin: 2px 0;\n    border-radius: 0rem;\n    background-color:var(--theme-primary);\n    color:#fff;\n    width: 100%;\n}\n.barchart[data-v-7a8c026c] {\n  display:none;\n}\n}\n.input-adduser[data-v-7a8c026c]{\n    height: initial;\n    padding: 5px 15px;\n    width: 100%;\n\tbackground: #fff;\n\tmargin: 0px !important\n}\n.input-checkbx[data-v-7a8c026c]{\nwidth: 20px;\nheight: 20px;\ndisplay: inline-block;\n}\n.preflang[data-v-7a8c026c]{\n    width: 100%;\n    min-height: 34px;\n}\n.success-bg[data-v-7a8c026c]{\n    background: #90ee90;\n}\n.error-bg[data-v-7a8c026c]{\n   background: #ffc0cb;\n}\n.form-control-label[data-v-7a8c026c]{min-width: 120px;font-size:12px;\n}\n.wrap-input[data-v-7a8c026c]{display:block;overflow:hidden\n}\n.form-wrap[data-v-7a8c026c]{    margin-bottom: 3px;\n}\n.create-btn[data-v-7a8c026c]{margin-top: 10px;\n    height: 40px;\n    line-height: 0px;font-size: 12px;float:right;\n}\n.search-icon[data-v-7a8c026c]{margin-top: 10px;\n    margin-top: 0px;\n    height: 40px !important;\n    line-height: 0px;\n    padding: 12px 24px 14px 24px;\n\tmargin-bottom: 10px;\n    border-radius: 0px;\n}\n.tableContainer[data-v-7a8c026c]{padding: 0px 15px 30px;    overflow-x: auto;\n}\n.input-group[data-v-7a8c026c]{\n    width: 100%;\n    background: #fff;\n    margin: 0px -15px 0p;\n    padding: 5px;\n    outline: 15px solid #fff;\n    /* margin: 0px -15px; */\n}\n.input-group-btn[data-v-7a8c026c] {max-width:65px\n}\n.sub-group[data-v-7a8c026c]{display: inline-block\n}\n@media (max-width: 1050px) {\n.input-group[data-v-7a8c026c] {\n    width:100% !important;\n\tdisplay: block;\n}\n}\n@media (max-width: 768px) {\n.sub-group[data-v-7a8c026c] {\n    width:100% !important;\n\tdisplay: block;\n}\n.searchId[data-v-7a8c026c]{max-width: 230px;\n}\n.filter-text[data-v-7a8c026c]{margin-left: 0px !important\n}\n.adduser-btn[data-v-7a8c026c]{margin-left: 0px !important\n}\n}\n.dropdown div[data-v-7a8c026c], .dropdown dt[data-v-7a8c026c] {\n    margin:0px;\n    padding:0px;\n}\n.dropdown ul[data-v-7a8c026c] {\n    margin:0px;\n    padding:0px;\n}\n.dropdown div[data-v-7a8c026c] {\n    position:relative;\n    margin:0px;\n    padding:0px;\n}\n.dropdown a[data-v-7a8c026c], .dropdown a[data-v-7a8c026c]:visited {\n    color:#fff;\n    text-decoration:none;\n    outline:none;\n    margin:0px;\n    padding:0px;\n    min-height: 30px;\n    border-radius: 3px;\n}\n.dropdown div a[data-v-7a8c026c] {\n    background-color:#4F6877;\n    display:block;\n    overflow: hidden;\n    width:100%;\n    margin:0px;\n    padding:0px;\n}\n.dropdown div a span[data-v-7a8c026c], .multiSel span[data-v-7a8c026c] {\n    cursor:pointer;\n    display:inline-block;\n    margin:0px;\n    padding:5px 10px;\n}\n.dropdown div ul[data-v-7a8c026c] {\n    background-color: #4F6877;\n    top:1px;\n    color:#fff;\n    display:none;\n    position:absolute;\n    width:100%;\n    list-style:none;\n    height: 100px;\n    overflow: auto;\n    margin:0px;\n    padding:0px;\n}\n.dropdown span.value[data-v-7a8c026c] {\n    display:none;\n    border-radius: 3px;\n    margin:0px;\n    padding:0px;\n}\n.dropdown div ul li a[data-v-7a8c026c] {\n    display:block;\n    margin:0px;\n    padding:0px;\n}\n.dropdown div ul li a[data-v-7a8c026c]:hover {\n    background-color:#fff;\n    margin:0px;\n    padding:0px;\n}\n.selectDropDown[data-v-7a8c026c]{border: 2px solid #dde3e6;height:34px;\n    /* border-radius: 3px; */\n    cursor: pointer;\n    background: #fff;\n\twidth: 100%;\n}\n#checkboxlist[data-v-7a8c026c]{position: relative;\n    margin-top: 0px;\n\tbackground:#fff;\n\tborder: 1px solid #ccc;\n\tmin-width: 200px;\n}\n.dd-list-item[data-v-7a8c026c]:hover{background:#fff\n}\nbutton[data-v-7a8c026c] {background:var(--theme-primary) !important\n}\n.adduser-btn[data-v-7a8c026c]{margin-left: 20px;max-height: 40px;margin-top: 0px;line-height: 0px;height: 40px;background-color: var(--theme-primary);font-size: 12px;\n}\ninput[data-v-7a8c026c], select[data-v-7a8c026c]{\nbackground: #fff!important;\n    border: 2px solid #dde3e6!important;\n\tpadding-left: 10px !important;\n    font-size: 14px !important;\n}\n.bc[data-v-7a8c026c]{font-size:10px;font-weight:bold;\n}\n.bc-adduser[data-v-7a8c026c]{font-size:10px;font-weight:bold;margin:15px\n}\n.bc-nav[data-v-7a8c026c]:hover{text-decoration:underline; cursor:pointer\n}\n.user-creds[data-v-7a8c026c]{background:#fff;    padding: 5px 10px 10px;\n    margin-bottom: 12px;\n}\n.bb0[data-v-7a8c026c]{border-top:0px !important\n}\n.add-group[data-v-7a8c026c]{color:var(--theme-primary);font-size:18px;float:right;margin-top: 5px;cursor:pointer\n}\n.remove-group[data-v-7a8c026c]{color:#d80842;font-size:18px;float:right;margin-top: 5px;cursor:pointer\n}\n.group-div[data-v-7a8c026c]{border:2px solid #eceff1;padding: 3px 10px;\n}\n.group-name[data-v-7a8c026c]{display: inline-block;width: 90%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.usercreateinfo[data-v-7a8c026c]{margin-top: 10px;background: #546e7a;color: #fff;padding: 10px;margin-bottom: 10px;\n}\n@media screen and (max-width: 767px) {\n.main-content[data-v-7a8c026c]{padding-top:25px\n}\n.main-content[data-v-7a8c026c]{padding-left:0px\n}\n}\n@media screen and (min-width: 768px) {\n.main-content[data-v-7a8c026c]{padding-top:0px\n}\n.main-content[data-v-7a8c026c]{padding-left:200px\n}\n}\n@media screen and (min-width: 991px) {\n.search-bar-wrapper[data-v-7a8c026c]{width: 100%\n}\n.search-bar-select[data-v-7a8c026c]{width: 300px;\n}\n}\n@media screen and (max-width: 991px) {\n.search-bar-wrapper[data-v-7a8c026c]{width: 75%\n}\n.search-bar-select[data-v-7a8c026c]{width: 150px;\n}\n}\n.cancel-btn[data-v-7a8c026c]{    float: right;\n    display: block;\n    padding: 18px 30px;\n}\ninput[data-v-7a8c026c], select[data-v-7a8c026c] { height: 34px !important; color: #000 !important\n}\nbutton[data-v-7a8c026c] { height: 32px !important; color: #fff !important\n}\n.disabled[data-v-7a8c026c] {pointer-events:none;opacity:0.5;\n-webkit-user-select: none;  /* Chrome all / Safari all */\n  -moz-user-select: none;     /* Firefox all */\n  -ms-user-select: none;      /* IE 10+ */\n  user-select: none;          /* Likely future */\n}\n.error[data-v-7a8c026c]{    color: red;width: 100%;\n    margin-left: 15px;\n}\n.pwderror[data-v-7a8c026c]{max-width:initial;width:100%;font-size: 14px;\n}\n.codeVerifybtn[data-v-7a8c026c]{background:#f9f9f9;\ncolor:#595959;\nborder:1px solid #c3c3c3;\nfont-size:13px;\ndisplay: inline-block !important;\n margin-top: -2px;\n height: 30px;\n line-height: 14px;\n width: 87px;\n}\n.fa-check-circle[data-v-7a8c026c] {font-size:40px !important\n}\nlabel[data-v-7a8c026c]{margin-bottom:0px !important;\n}\nuser-creds label[data-v-7a8c026c]{font-weight: normal !important;\n}\n.sometext-hidden[data-v-7a8c026c]{\n-webkit-user-select: none; /* Chrome/Safari */\n-moz-user-select: none; /* Firefox */\n-ms-user-select: none; /* IE10+ */\n}\ninput[data-v-7a8c026c]::-webkit-contacts-auto-fill-button {\n  display: none !important;\n  position: absolute;\n  right: 0;\n}\n.regapps[data-v-7a8c026c]{\nmax-width: 200px;\nwidth:150px;\npadding: 5px;\nmargin: 15px;\ncursor: pointer;\ntext-align: center;\ndisplay: inline-block;\nvertical-align: top;\n}\n.fa-edit[data-v-7a8c026c]{color:#546E7A;font-size: 18px;\n    vertical-align: middle;\n}\n.edit-pen[data-v-7a8c026c]{width: 20px;\n    margin-top: -5px;\n\timage-rendering: -moz-crisp-edges;         /* Firefox */\nimage-rendering:   -o-crisp-edges;         /* Opera */\nimage-rendering: -webkit-optimize-contrast;/* Webkit (non-standard naming) */\nimage-rendering: crisp-edges;\n-ms-interpolation-mode: nearest-neighbor;  /* IE (non-standard property) */\n}\n@media all and (-ms-high-contrast:none)\n {\n*[data-v-7a8c026c]::-ms-backdrop, input[data-v-7a8c026c] { padding: 5px 10px !important\n} /* IE11 */\n}\n", ""]);

// exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\n.hiddden[data-v-7cc2de36] {\n  visibility: hidden;\n}\n.welcome[data-v-7cc2de36] {\n  background: var(--regpwd-topnavbarbg);\n  text-align: center;\n  padding: 10px;\n  margin-bottom: 5px;\n}\n.custom-select[data-v-7cc2de36] {\n  display: inline-block;\n  max-width: 100%;\n  height: calc(2.5rem + 2px);\n  padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n  line-height: 1.25;\n  background-color: #ececeb;\n  vertical-align: middle;\n  background-size: 8px 10px;\n  border: 1px solid #00524a;\n  border-radius: 0;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\n.card-block[data-v-7cc2de36] {\n  background: var(--theme-primary);\n  border: 1px solid #00524a;\n}\ninput[data-v-7cc2de36] {\n  background: #fff;\n}\ninput[data-v-7cc2de36],\nselect[data-v-7cc2de36] {\n  height: 30px;\n  color: #333;\n  margin-top: 2px;\n}\n.password-rule[data-v-7cc2de36] {\n  color: #666;\n  font-size: 12px;\n  display: block;\n  line-height: 16px;\n}\n.setup-section[data-v-7cc2de36] {\n  background: #fff;\n  /*border-radius:8px;border: 1px solid #ccc; margin-left: auto;margin-right: auto;text-align: left;padding-bottom: 20px;margin-bottom: 20px;font-size:14px;*/\n  font-size: 13px;\n  margin-bottom: 5px;\n}\nlabel > input[data-v-7cc2de36] {\n  /* HIDE RADIO */\n  visibility: hidden; /* Makes input not-clickable */\n  position: absolute; /* Remove input from document flow */\n}\nlabel > input + img[data-v-7cc2de36] {\n  /* IMAGE STYLES */\n  cursor: pointer;\n  border: 2px solid #ddd;\n}\nlabel > input:checked + img[data-v-7cc2de36] {\n  /* (RADIO CHECKED) IMAGE STYLES */\n  border: 2px solid #333;\n  border-radius: 0px;\n}\n.exclamatory-error-icon[data-v-7cc2de36] {\n  color: #e34843;\n  background: #ffffff;\n  border-radius: 20px;\n  width: 16px;\n  height: 16px;\n  display: block;\n  margin: 5px 3px;\n  padding-left: 5px;\n  line-height: 16px;\n  font-weight: bold;\n}\n.checked-icon[data-v-7cc2de36] {\n  background: #333;\n  padding: 3px;\n  border-radius: 3px;\n}\n.checked-icon-container[data-v-7cc2de36] {\n  position: absolute;\n  margin: 10px;\n}\n.infobox-before-common[data-v-7cc2de36],\n.infobox[data-v-7cc2de36]::before,\n.infobox-md[data-v-7cc2de36]::before,\n.infobox-compact[data-v-7cc2de36]::before {\n  position: absolute;\n  top: -1px;\n  bottom: -1px;\n  left: -1px;\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n  content: \"\";\n}\n/* line 18, target/sass/courage/infobox/_all.scss */\n.infobox[data-v-7cc2de36] {\n  position: relative;\n  min-height: 18px;\n  padding: 12px 18px 12px 48px !important;\n  -webkit-hyphens: auto;\n  -ms-hyphens: auto;\n  hyphens: auto;\n  word-break: break-word;\n}\n/* line 25, target/sass/courage/infobox/_all.scss */\n.infobox[data-v-7cc2de36]::before {\n  width: 36px;\n  background-color: #007dc1;\n}\n/* line 31, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-no-icon[data-v-7cc2de36] {\n  padding-left: 24px !important;\n}\n/* line 34, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-no-icon[data-v-7cc2de36]::before {\n  display: none;\n}\n/* line 39, target/sass/courage/infobox/_all.scss */\n.infobox > .icon[data-v-7cc2de36] {\n  position: absolute;\n  top: 13px;\n  left: 9px;\n}\n/* line 45, target/sass/courage/infobox/_all.scss */\n.infobox a[data-v-7cc2de36] {\n  line-height: 18px;\n}\n/* line 49, target/sass/courage/infobox/_all.scss */\n.infobox ul[data-v-7cc2de36] {\n  margin-right: 0;\n}\n/* line 54, target/sass/courage/infobox/_all.scss */\n.infobox .link-button[data-v-7cc2de36] {\n  line-height: 28px;\n}\n/* line 58, target/sass/courage/infobox/_all.scss */\n.infobox + .infobox[data-v-7cc2de36],\n.infobox + h2[data-v-7cc2de36] {\n  margin-top: 18px;\n}\n/* line 63, target/sass/courage/infobox/_all.scss */\n.infobox .two_col_left[data-v-7cc2de36] {\n  width: 80%;\n}\n/* line 67, target/sass/courage/infobox/_all.scss */\n.infobox .two_col_right[data-v-7cc2de36] {\n  width: 19%;\n  margin-left: 1%;\n  padding-left: 0;\n}\n/* line 72, target/sass/courage/infobox/_all.scss */\n.infobox .two_col_right .button-primary[data-v-7cc2de36] {\n  width: 100% !important;\n  float: right;\n  box-sizing: border-box;\n}\n/* line 80, target/sass/courage/infobox/_all.scss */\n.infobox[style=\"display: none;\"] + .infobox[data-v-7cc2de36],\n.infobox[style=\"display:none;\"] + .infobox[data-v-7cc2de36] {\n  margin-top: 0;\n}\n/* line 85, target/sass/courage/infobox/_all.scss */\n.infobox h2[data-v-7cc2de36],\n.infobox h3[data-v-7cc2de36],\n.infobox h2 *[data-v-7cc2de36],\n.infobox h3 *[data-v-7cc2de36] {\n  margin: 0;\n  padding: 0;\n  font-size: 13px;\n  font-weight: bold;\n  line-height: 18px;\n}\n/* line 96, target/sass/courage/infobox/_all.scss */\n.infobox h2 span[data-v-7cc2de36],\n.infobox h3 span[data-v-7cc2de36] {\n  color: #5e5e5e;\n}\n/* line 101, target/sass/courage/infobox/_all.scss */\n.infobox h2 + *[data-v-7cc2de36],\n.infobox h3 + *[data-v-7cc2de36],\n.infobox p + *[data-v-7cc2de36],\n.infobox ul + *[data-v-7cc2de36],\n.infobox ol + *[data-v-7cc2de36],\n.infobox li + *[data-v-7cc2de36] {\n  margin-top: 9px;\n}\n/* line 116, target/sass/courage/infobox/_all.scss */\n.infobox[data-v-7cc2de36],\n.infobox-md[data-v-7cc2de36] {\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  background-color: #fbfbfb;\n}\n/* line 124, target/sass/courage/infobox/_all.scss */\n.infobox-md[data-v-7cc2de36] {\n  min-height: 18px;\n  padding: 24px 24px 24px 70px !important;\n}\n/* line 128, target/sass/courage/infobox/_all.scss */\n.infobox-md h2[data-v-7cc2de36],\n.infobox-md h3[data-v-7cc2de36] {\n  font-size: 15px;\n}\n/* line 132, target/sass/courage/infobox/_all.scss */\n.infobox-md h2 *[data-v-7cc2de36],\n.infobox-md h3 *[data-v-7cc2de36] {\n  margin: 0;\n  line-height: 18px;\n}\n/* line 138, target/sass/courage/infobox/_all.scss */\n.infobox-md[data-v-7cc2de36]::before {\n  width: 48px;\n}\n/* line 143, target/sass/courage/infobox/_all.scss */\n.infobox-md > .icon[data-v-7cc2de36] {\n  top: 20px;\n  left: 11px;\n}\n/* line 148, target/sass/courage/infobox/_all.scss */\n.infobox-md + .button-bar.button-bar-attached[data-v-7cc2de36] {\n  width: auto;\n  padding-left: 60px;\n  float: none;\n}\n/* line 153, target/sass/courage/infobox/_all.scss */\n.infobox-md + .button-bar.button-bar-attached.button-bar-l-height[data-v-7cc2de36] {\n  line-height: 32px;\n}\n/* line 163, target/sass/courage/infobox/_all.scss */\n.infobox-compact[data-v-7cc2de36] {\n  min-height: 16px;\n  padding: 9px 9px 9px 40px !important;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 3px;\n  border-color: #ddd;\n  background-color: #fbfbfb;\n}\n/* line 172, target/sass/courage/infobox/_all.scss */\n.infobox-compact a[data-v-7cc2de36],\n.infobox-compact p[data-v-7cc2de36],\n.infobox-compact li[data-v-7cc2de36] {\n  line-height: 16px;\n}\n/* line 178, target/sass/courage/infobox/_all.scss */\n.infobox-compact h2 + *[data-v-7cc2de36],\n.infobox-compact h3 + *[data-v-7cc2de36],\n.infobox-compact p + *[data-v-7cc2de36],\n.infobox-compact ul + *[data-v-7cc2de36],\n.infobox-compact ol + *[data-v-7cc2de36],\n.infobox-compact li + *[data-v-7cc2de36] {\n  margin-top: 5px;\n}\n/* line 187, target/sass/courage/infobox/_all.scss */\n.infobox-compact[data-v-7cc2de36]::before {\n  width: 30px;\n}\n/* line 192, target/sass/courage/infobox/_all.scss */\n.infobox-compact + p[data-v-7cc2de36] {\n  margin-top: 9px;\n}\n/* line 196, target/sass/courage/infobox/_all.scss */\n.infobox-compact > .icon[data-v-7cc2de36] {\n  top: 9px;\n  left: 6px;\n}\n/* line 205, target/sass/courage/infobox/_all.scss */\n.infobox-xl[data-v-7cc2de36] {\n  min-height: 18px;\n  padding: 26px 36px 26px 108px !important;\n}\n/* line 209, target/sass/courage/infobox/_all.scss */\n.infobox-xl[data-v-7cc2de36]::before {\n  width: 84px;\n}\n/* line 213, target/sass/courage/infobox/_all.scss */\n.infobox-xl > .icon[data-v-7cc2de36] {\n  top: 22px;\n  left: 18px;\n}\n/* line 218, target/sass/courage/infobox/_all.scss */\n.infobox-xl p[data-v-7cc2de36],\n.infobox-xl ul[data-v-7cc2de36] {\n  width: 75%;\n  margin-top: 20px;\n}\n/* line 224, target/sass/courage/infobox/_all.scss */\n.infobox-xl p[data-v-7cc2de36],\n.infobox-xl li[data-v-7cc2de36] {\n  font-size: 14px;\n  line-height: 20px;\n}\n/* line 230, target/sass/courage/infobox/_all.scss */\n.infobox-xl h2[data-v-7cc2de36],\n.infobox-xl h3[data-v-7cc2de36] {\n  font-size: 18px;\n}\n/* line 234, target/sass/courage/infobox/_all.scss */\n.infobox-xl h2 *[data-v-7cc2de36],\n.infobox-xl h3 *[data-v-7cc2de36] {\n  margin: 0;\n  line-height: 18px;\n}\n/* line 245, target/sass/courage/infobox/_all.scss */\n.infobox-teach h2[data-v-7cc2de36],\n.infobox-teach h3[data-v-7cc2de36] {\n  color: #835ab1;\n  font-weight: 200;\n}\n/* line 251, target/sass/courage/infobox/_all.scss */\n.infobox-teach.infobox-dismiss .button-teach[data-v-7cc2de36] {\n  margin-top: 20px;\n  float: right;\n}\n/* line 259, target/sass/courage/infobox/_all.scss */\n.infobox-dismiss[data-v-7cc2de36] {\n  padding-right: 30px !important;\n}\n/* line 263, target/sass/courage/infobox/_all.scss */\n.infobox-dismiss-link[data-v-7cc2de36] {\n  display: block;\n  position: absolute;\n  top: 10px;\n  right: 8px;\n  color: #5e5e5e;\n  line-height: 14px;\n  cursor: pointer;\n}\n/* line 273, target/sass/courage/infobox/_all.scss */\n.infobox-dismiss-link[data-v-7cc2de36]:hover {\n  text-decoration: none;\n}\n/* line 277, target/sass/courage/infobox/_all.scss */\n.help-wrap .infobox.infobox-dismiss .infobox-dismiss-link[data-v-7cc2de36] {\n  top: 0;\n  right: 0;\n}\n/* line 283, target/sass/courage/infobox/_all.scss */\n.infobox-dismiss-hide[data-v-7cc2de36] {\n  display: none !important;\n}\n/* line 292, target/sass/courage/infobox/_all.scss */\n.infobox-confirm[data-v-7cc2de36] {\n  position: absolute !important;\n  top: 20px;\n  left: 50%;\n  width: 240px;\n  margin-left: -154px;\n  box-shadow: 0 2px 0 rgba(160, 160, 160, 0.1);\n  z-index: 10;\n}\n/* line 302, target/sass/courage/infobox/_all.scss */\n.infobox-confirm-fixed[data-v-7cc2de36] {\n  position: fixed !important;\n  top: 106px;\n}\n/* line 306, target/sass/courage/infobox/_all.scss */\n.infobox-confirm-fixed .infobox-dismiss-link[data-v-7cc2de36] {\n  top: 14px;\n  right: 14px;\n}\n/* line 318, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-subtle.infobox-success[data-v-7cc2de36]::before,\n.help-wrap .infobox.infobox-success[data-v-7cc2de36]::before,\n.infobox-success[data-v-7cc2de36]::before {\n  background-color: #4cbf9c;\n}\n/* line 324, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-subtle.infobox-warning[data-v-7cc2de36]::before,\n.help-wrap .infobox.infobox-warning[data-v-7cc2de36]::before,\n.infobox-warning[data-v-7cc2de36]::before {\n  background-color: #f1d10d;\n}\n/* line 330, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-subtle.infobox-error[data-v-7cc2de36]::before,\n.help-wrap .infobox.infobox-error[data-v-7cc2de36]::before,\n.infobox-error[data-v-7cc2de36]::before {\n  background-color: #e34843;\n}\n/* line 336, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-subtle.infobox-tip[data-v-7cc2de36]::before,\n.infobox.infobox-subtle.infobox-teach[data-v-7cc2de36]::before,\n.help-wrap .infobox.infobox-tip[data-v-7cc2de36]::before,\n.help-wrap .infobox.infobox-teach[data-v-7cc2de36]::before,\n.infobox-tip[data-v-7cc2de36]::before,\n.infobox-teach[data-v-7cc2de36]::before {\n  background-color: #835ab1;\n}\n/* line 346, target/sass/courage/infobox/_all.scss */\n.infobox-warning .icon.processing-16[data-v-7cc2de36] {\n  width: 16px;\n  height: 16px;\n  background: url(\"/assets/img/ui/indicators/ajax-loader-processing-16.995b6ac81af8ed76a8ade6aba2f6d4d1.gif\") no-repeat 0 0 transparent;\n}\n/* line 352, target/sass/courage/infobox/_all.scss */\n.infobox-warning .icon.processing-24[data-v-7cc2de36] {\n  width: 24px;\n  height: 24px;\n  background: url(\"/assets/img/ui/indicators/ajax-loader-processing-24.2564f2a8efed77df6c170335ff3001ef.gif\") no-repeat 0 0 transparent;\n}\n/* line 358, target/sass/courage/infobox/_all.scss */\n.infobox-error .icon.processing-16[data-v-7cc2de36] {\n  width: 16px;\n  height: 16px;\n  background: url(\"/assets/img/icons/16x16/error-01.fa55d715ffe62d95fb0eded26d323a55.png\") no-repeat 0 0 transparent;\n}\n/* line 365, target/sass/courage/infobox/_all.scss */\n.infobox + .button-bar[data-v-7cc2de36],\n.infobox + .button-bar-small[data-v-7cc2de36] {\n  border-top: 0;\n}\n/* line 370, target/sass/courage/infobox/_all.scss */\n.infobox-no-border + .button-bar[data-v-7cc2de36],\n.infobox-no-border + .button-bar-small[data-v-7cc2de36] {\n  border-top: 1px solid #dadada;\n}\n/* line 376, target/sass/courage/infobox/_all.scss */\n.infobox-no-border[data-v-7cc2de36] {\n  border: none !important;\n}\n/* line 380, target/sass/courage/infobox/_all.scss */\n.infobox-text[data-v-7cc2de36] {\n  padding: 0;\n}\n/* line 384, target/sass/courage/infobox/_all.scss */\n.infobox-header[data-v-7cc2de36] {\n  font-weight: bold;\n}\n/* line 388, target/sass/courage/infobox/_all.scss */\n.infobox-divider[data-v-7cc2de36] {\n  border-bottom: 1px dotted #ddd;\n}\n/* line 396, target/sass/courage/infobox/_all.scss */\n.edit-form .infobox[data-v-7cc2de36],\n.read-only-form .infobox[data-v-7cc2de36],\n.ajax-form-editor .infobox[data-v-7cc2de36],\n.form-content-wrap .infobox[data-v-7cc2de36],\n.o-form .infobox[data-v-7cc2de36],\n.m-form .infobox[data-v-7cc2de36],\n.v-form .infobox[data-v-7cc2de36],\n.modal-content-wrap .infobox[data-v-7cc2de36] {\n  background-color: #fff;\n}\n/* line 407, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-subtle[data-v-7cc2de36],\n.help-wrap .infobox[data-v-7cc2de36] {\n  padding: 0 0 0 18px !important;\n  border: 0;\n  background: transparent;\n}\n/* line 413, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-subtle[data-v-7cc2de36]::before,\n.help-wrap .infobox[data-v-7cc2de36]::before {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 6px;\n  border-radius: 0;\n  background-color: #007dc1;\n  content: \"\";\n}\n/* line 424, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-subtle .icon[data-v-7cc2de36],\n.help-wrap .infobox .icon[data-v-7cc2de36] {\n  display: none;\n}\n/* line 4, target/sass/modules/infobox/_overrides.scss */\n.infobox-teach + .ui-tabs[data-v-7cc2de36] {\n  margin-top: 18px;\n}\n.reg-nav[data-v-7cc2de36] {\n  color: #dbaa00 !important;\n  border-top: solid 6px #dbaa00;\n  padding-top: 10px;\n}\n.title-bar[data-v-7cc2de36] {\n  margin-right: -15px;\n  margin-left: -15px;\n  margin-top: -5px;\n}\ninput[data-v-7cc2de36],\nselect[data-v-7cc2de36] {\n  background: #fff;\n  border: 2px solid #dde3e6;\n  /* max-width: 400px !important; */\n  display: block !important;\n  border-radius: 0px !important;\n  min-height: 30px;\n  padding-left: 5px;\n}\ninput[type=\"button\"][data-v-7cc2de36]:hover,\nbutton[data-v-7cc2de36]:hover {\n  background-color: var(--theme-primary) !important;\n  border: 1px solid var(--theme-primary) !important;\n  color: var(--regpwd-secondarytextcolor) !important;\n  border-radius: 0px !important;\n}\ninput[type=\"button\"][data-v-7cc2de36],\nbutton[data-v-7cc2de36] {\n  background-color: var(--theme-primary) !important;\n  border-color: var(--theme-primary) !important;\n  color: var(--regpwd-secondarytextcolor) !important;\n  border-radius: 0px !important;\n}\n.create-acc[data-v-7cc2de36] {\n  margin: auto;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  color: #fff;\n  margin-bottom: 20px;\n  height: 30px;\n  padding-left: 20px;\n  padding-right: 20px;\n  margin-top: 10px;\n  font-size: 14px;\n  padding: 4px 15px;\n  float: right;\n}\n.pwderror[data-v-7cc2de36] {\n  display: block;\n  background: #474c55;\n  padding-left: 10px;\n  color: #ffffff;\n  border-bottom: 1px solid #eaeaea;\n  max-width: 100%;\n}\n#userRegistration[data-v-7cc2de36] {\n  max-width: 394px;\n  margin: auto;\n  margin-top: 50px;\n  margin-bottom: 50px;\n}\n.bg[data-v-7cc2de36] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.splash[data-v-7cc2de36] {\n  position: absolute;\n  top: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.disabled[data-v-7cc2de36] {\n  pointer-events: none;\n  opacity: 0.6;\n}\n.regapps[data-v-7cc2de36] {\n  max-width: 160px;\n  width: 100px;\n  padding: 5px;\n  margin: 15px;\n  cursor: pointer;\n  text-align: center;\n  display: inline-block;\n  vertical-align: top;\n}\n.icon-wrap[data-v-7cc2de36] {\n  border: 1px solid #acacac;\n  width: 140px;\n  border-radius: 3px;\n  height: 60px;\n  background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#f4f4f4));\n  vertical-align: middle;\n  display: table-cell;\n}\n.errorwrapper[data-v-7cc2de36] {\n  /* position: absolute; */\n  z-index: 999999999999999;\n  width: 100%;\n  /* padding-right: 30px; */\n}\n.validation-text[data-v-7cc2de36] {\n  color: #bd0000;\n  background: pink;\n  border-radius: 3px;\n  border: 1px solid #bd0000;\n  padding: 5px 10px;\n  margin: 10px 0px;\n}\n.margintop[data-v-7cc2de36] {\n  margin-top: -20%;\n  display: -ms-flexbox;\n  display: flex;\n}\n.okta-sign-in-header[data-v-7cc2de36] {\n  padding: 10px 90px 10px 90px;\n  position: relative;\n  z-index: 10;\n  transition: padding-bottom 0.4s;\n}\n.auth-org-logo[data-v-7cc2de36] {\n  max-width: 120px !important;\n  display: block;\n  margin: 0 auto;\n  max-height: 40px;\n}\n.phoneVerification[data-v-7cc2de36] {\n  background: #f9f9f9;\n  color: #fff;\n  border: 1px solid #c3c3c3;\n  font-size: 13px;\n  display: inline-block !important;\n  margin-top: 0px;\n  line-height: 10px;\n  margin-top: 2px;\n  height: 30px;\n  width: 100%;\n  padding: 5px;\n  white-space: normal;\n  cursor: pointer;\n}\n.invalid[data-v-7cc2de36] {\n  float: right;\n  margin-right: 25px;\n  margin-top: -20px;\n  position: relative;\n  z-index: 2;\n  color: red;\n}\n.valid[data-v-7cc2de36] {\n  float: right;\n  margin-right: 25px;\n  margin-top: -20px;\n  position: relative;\n  z-index: 2;\n  color: green;\n}\n.red-border[data-v-7cc2de36] {\n  border: 1px solid red !important;\n}\n.green-border[data-v-7cc2de36] {\n  border: 1px solid green !important;\n}\ninput[type=\"password\"][data-v-7cc2de36]:focus {\n  outline: #dde3e6;\n}\n.row-spacing[data-v-7cc2de36] {\n  padding: 0px 15px;\n}\n.field-spacing[data-v-7cc2de36] {\n  padding: 5px 0px;\n}\n.phone-error[data-v-7cc2de36] {\n  padding: 5px 15px;\n  background: rgb(255, 192, 203);\n  margin-top: 5px;\n  width: 100%;\n}\n.brand-terms[data-v-7cc2de36] {\n  margin: 6px;\n  padding-left: 17px;\n  font-size: 12px;\n}\n.input-terms[data-v-7cc2de36] {\n  margin-right: 10px;\n  float: left;\n}\n.send-code[data-v-7cc2de36] {\n  padding: 5px 15px;\n  color: #fff;\n  border: 1px solid #c3c3c3;\n  font-size: 12px;\n  margin-top: -2px;\n  min-height: 30px;\n}\n.input-reinvite[data-v-7cc2de36] {\n  width: 100%;\n  height: 45px;\n  padding-left: 10px;\n}\n.field-reinvite[data-v-7cc2de36] {\n  margin: auto;\n  text-align: left;\n  margin-bottom: 10px;\n}\n.verify-input[data-v-7cc2de36] {\n  visibility: inherit;\n  position: inherit;\n  display: inline-block !important;\n  padding-top: 0px;\n  width: 100%;\n}\n.verify-sms[data-v-7cc2de36] {\n  visibility: inherit;\n  position: inherit;\n  background: rgb(249, 249, 249);\n  color: var(--regpwd-secondarytextcolor);\n  border: 1px solid rgb(195, 195, 195);\n  display: inline-block !important;\n  font-size: 13px;\n  border-radius: 3px;\n  width: 100%;\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\nbutton[data-v-84feda02] {background:var(--theme-primary) !important\n}\nbutton[data-v-84feda02] { height: 32px !important; color: #fff !important\n}\n.get-logs[data-v-84feda02]{\npadding: 8px 15px;\n    height: 36px !important;\n    margin-top: -2px;\n}\nth[data-v-84feda02], td[data-v-84feda02]{\n    padding: 5px 5px !important;\n\tfont-size:14px !important;\n}\n", ""]);

// exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\nul[data-v-cf5396ea] {\n    list-style-type: none;\n    padding: 0;\n}\nli[data-v-cf5396ea] {\n    display: inline-block;\n    margin: 0 10px;\n    padding: 0;\n}\n.custom-select[data-v-cf5396ea] {\n\tdisplay: inline-block;\n\tmax-width: 100%;\n\theight: calc(2.50rem + 2px);\n\tpadding: 0.375rem 1.75rem 0.375rem 0.75rem;\n\tline-height: 1.25;\n\tbackground-color: #ececeb;\n\tvertical-align: middle;\n\tbackground-size: 8px 10px;\n\tborder: 1px solid #00524A;\n\tborder-radius: 0;\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n}\n.card-block[data-v-cf5396ea] {\n\tbackground: #eceff1;\n}\n.user-input[data-v-cf5396ea] {\n\twidth: 100%;\n\tbackground: #ffffff;\n\tcolor: #333333;\n\theight: 30px;\n}\n.user-select[data-v-cf5396ea] {\n\tcolor: #333333;\n\theight: 30px;\n}\n#userSearch[data-v-cf5396ea] {\n\tmargin: 10px;\n}\n.good-table th[data-v-cf5396ea] {\n\tcolor: #333333 !important\n}\n.btn-secondary[data-v-cf5396ea]:active {\n\tbackground: #007299;\n\tbox-shadow: none;\n}\n.btn-secondary[data-v-cf5396ea] {\n\tbackground: var(--theme-primary);\n\tcolor: #ffffff;\n}\ninput[data-v-cf5396ea] {\n\twidth: 130px;\n\tbox-sizing: border-box;\n\tborder: 1px solid var(--theme-primary);\n\tborder-radius: 0;\n\tfont-size: 16px;\n\tbackground-color: #f1f1f1;\n\tbackground-position: 10px 10px;\n\tbackground-repeat: no-repeat;\n\tpadding: 15px 20px;\n\theight: 50px;\n}\n.card[data-v-cf5396ea] {\n\tposition: relative;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tbackground-color: #33373D;\n\tborder: 0px solid rgba(0, 0, 0, 0.125);\n\tborder-radius: 0px;\n\tbox-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px\n\t\trgba(0, 0, 0, 0.22);\n\tbox-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.4);\n}\n.card[data-v-cf5396ea] {\n\tmargin-bottom: 1rem;\n\tbox-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);\n}\n.card-block1[data-v-cf5396ea] {\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    padding: 0rem;\n}\n#searchId[data-v-cf5396ea] {\n\tbox-sizing: border-box !important;\n\tborder: 2px solid #dde3e6 !important;\n\tborder-radius: 0 !important;\n\tbackground-color: #fff !important;\n\tbackground-position: 10px 10px !important;\n\tbackground-repeat: no-repeat !important;\n\theight: 40px !important;\n\tmargin-bottom: 18px !important;\n\tmargin-left: 30px !important;\n}\n.filter-label[data-v-cf5396ea]{ width: 150px;\n    float: left;\n    font-size: 14px;\n    margin-top: 8px;\n    font-weight: bold;\n}\n.btn-secondary[data-v-cf5396ea] {\n\tbackground-color: var(--theme-primary);;\n\tborder-color: #00433c;\n}\n.btn-secondary[data-v-cf5396ea]:hover {\n\tbackground-color: #00524A;\n\tborder-color: #00433c;\n}\n.btn[data-v-cf5396ea] {\n\tpadding: 14px 24px;\n\tborder: 0 none;\n\tfont-weight: 700;\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n}\n.input-adduser[data-v-cf5396ea]{\n    height: initial;\n    padding: 5px 15px;\n    width: 100%;\n\tbackground: #fff;\n\tmargin: 0px !important\n}\n.input-checkbx-sub[data-v-cf5396ea]{\nwidth: 20px;\nheight: 20px !important;\ndisplay: inline-block;\n}\n.preflang[data-v-cf5396ea]{\n    width: 100%;\n    min-height: 34px;\n}\n.success-bg[data-v-cf5396ea]{\n    background: #90ee90;\n}\n.error-bg[data-v-cf5396ea]{\n   background: #ffc0cb;\n}\n.form-control-label[data-v-cf5396ea]{min-width: 120px;font-size:12px;\n}\n.wrap-input[data-v-cf5396ea]{display:block;overflow:hidden\n}\n.form-wrap[data-v-cf5396ea]{    margin-bottom: 3px;\n}\n.create-btn[data-v-cf5396ea]{margin-top: 10px;\n    height: 40px;\n    line-height: 0px;font-size: 12px;float:right;\n}\n.search-icon[data-v-cf5396ea]{margin-top: 10px;\n    margin-top: 0px;\n    height: 40px !important;\n    line-height: 0px;\n    padding: 12px 24px 14px 24px;\n\tmargin-bottom: 10px;\n    border-radius: 0px;\n}\n.tableContainer[data-v-cf5396ea]{padding: 0px 15px 30px;    overflow-x: auto;\n}\n.input-group[data-v-cf5396ea]{\n    width: 100%;\n    background: #fff;\n    margin: 0px -15px 0p;\n    padding: 5px;\n    outline: 15px solid #fff;\n    /* margin: 0px -15px; */\n}\n.input-group-btn[data-v-cf5396ea] {max-width:65px\n}\n.sub-group[data-v-cf5396ea]{display: inline-block\n}\n@media (max-width: 1050px) {\n.input-group[data-v-cf5396ea] {\n    width:100% !important;\n\tdisplay: block;\n}\n}\n@media (max-width: 768px) {\n.sub-group[data-v-cf5396ea] {\n    width:100% !important;\n\tdisplay: block;\n}\n.searchId[data-v-cf5396ea]{max-width: 230px;\n}\n.filter-text[data-v-cf5396ea]{margin-left: 0px !important\n}\n.adduser-btn[data-v-cf5396ea]{margin-left: 0px !important\n}\n}\n.dropdown div[data-v-cf5396ea], .dropdown dt[data-v-cf5396ea] {\n    margin:0px;\n    padding:0px;\n}\n.dropdown ul[data-v-cf5396ea] {\n    margin:0px;\n    padding:0px;\n}\n.dropdown div[data-v-cf5396ea] {\n    position:relative;\n    margin:0px;\n    padding:0px;\n}\n.dropdown a[data-v-cf5396ea], .dropdown a[data-v-cf5396ea]:visited {\n    color:#fff;\n    text-decoration:none;\n    outline:none;\n    margin:0px;\n    padding:0px;\n    min-height: 30px;\n    border-radius: 3px;\n}\n.dropdown div a[data-v-cf5396ea] {\n    background-color:#4F6877;\n    display:block;\n    overflow: hidden;\n    width:100%;\n    margin:0px;\n    padding:0px;\n}\n.dropdown div a span[data-v-cf5396ea], .multiSel span[data-v-cf5396ea] {\n    cursor:pointer;\n    display:inline-block;\n    margin:0px;\n    padding:5px 10px;\n}\n.dropdown div ul[data-v-cf5396ea] {\n    background-color: #4F6877;\n    top:1px;\n    color:#fff;\n    display:none;\n    position:absolute;\n    width:100%;\n    list-style:none;\n    height: 100px;\n    overflow: auto;\n    margin:0px;\n    padding:0px;\n}\n.dropdown span.value[data-v-cf5396ea] {\n    display:none;\n    border-radius: 3px;\n    margin:0px;\n    padding:0px;\n}\n.dropdown div ul li a[data-v-cf5396ea] {\n    display:block;\n    margin:0px;\n    padding:0px;\n}\n.dropdown div ul li a[data-v-cf5396ea]:hover {\n    background-color:#fff;\n    margin:0px;\n    padding:0px;\n}\n.selectDropDown[data-v-cf5396ea]{border: 2px solid #dde3e6;height:34px;\n    /* border-radius: 3px; */\n    cursor: pointer;\n    background: #fff;\n\twidth: 100%;\n}\n#checkboxlist[data-v-cf5396ea]{position: relative;\n    margin-top: 0px;\n\tbackground:#fff;\n\tborder: 1px solid #ccc;\n\tmin-width: 200px;\n}\n.dd-list-item[data-v-cf5396ea]:hover{background:#fff\n}\nbutton[data-v-cf5396ea] {background:var(--theme-primary) !important\n}\n.adduser-btn[data-v-cf5396ea]{margin-left: 20px;max-height: 40px;margin-top: 0px;line-height: 0px;height: 40px;background-color: var(--theme-primary);font-size: 12px;\n}\ninput[data-v-cf5396ea], select[data-v-cf5396ea]{\nbackground: #fff!important;\n    border: 2px solid #dde3e6!important;\n\tpadding-left: 10px !important;\n    font-size: 14px !important;\n}\n.bc[data-v-cf5396ea]{font-size:10px;font-weight:bold;\n}\n.bc-adduser[data-v-cf5396ea]{font-size:10px;font-weight:bold;margin:15px\n}\n.bc-nav[data-v-cf5396ea]:hover{text-decoration:underline; cursor:pointer\n}\n.user-creds[data-v-cf5396ea]{background:#fff;    padding: 5px 10px 10px;\n    margin-bottom: 12px;\n}\n.bb0[data-v-cf5396ea]{border-top:0px !important\n}\n.add-group[data-v-cf5396ea]{color:var(--theme-primary);font-size:18px;float:right;margin-top: 5px;cursor:pointer\n}\n.remove-group[data-v-cf5396ea]{color: #d80842;\n    font-size: 20px;\n    /* float: right; */\n    margin-top: 6px;\n    cursor: pointer;\n}\n.group-div[data-v-cf5396ea]{border:2px solid #eceff1;padding: 3px 10px;\n}\n.group-name[data-v-cf5396ea]{display: inline-block;width: 90%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.usercreateinfo[data-v-cf5396ea]{margin-top: 10px;background: #546e7a;color: #fff;padding: 10px;margin-bottom: 10px;\n}\n@media screen and (max-width: 767px) {\n.main-content[data-v-cf5396ea]{padding-top:25px\n}\n.main-content[data-v-cf5396ea]{padding-left:0px\n}\n}\n@media screen and (min-width: 768px) {\n.main-content[data-v-cf5396ea]{padding-top:0px\n}\n.main-content[data-v-cf5396ea]{padding-left:200px\n}\n}\n@media screen and (min-width: 991px) {\n.search-bar-wrapper[data-v-cf5396ea]{width: 100%\n}\n.search-bar-select[data-v-cf5396ea]{width: 300px;\n}\n}\n@media screen and (max-width: 991px) {\n.search-bar-wrapper[data-v-cf5396ea]{width: 75%\n}\n.search-bar-select[data-v-cf5396ea]{width: 150px;\n}\n}\n.cancel-btn[data-v-cf5396ea]{    float: right;\n    display: block;\n    padding: 18px 30px;\n}\ninput[data-v-cf5396ea], select[data-v-cf5396ea] { height: 32px !important; color: #000 !important\n}\nbutton[data-v-cf5396ea] { height: 32px !important; color: #fff !important\n}\n.disabled[data-v-cf5396ea] {pointer-events:none;opacity:0.5\n}\n.disabledLight[data-v-cf5396ea] {pointer-events:none;opacity:0.8\n}\n.error[data-v-cf5396ea]{    color: red;width: 100%;\n    margin-left: 15px;\n}\n.pwderror[data-v-cf5396ea]{max-width:initial;width:100%;font-size: 14px;\n}\n.codeVerifybtn[data-v-cf5396ea]{\nbackground:#f9f9f9;\ncolor:#595959;\nborder:1px solid #c3c3c3;\nfont-size:13px;\ndisplay: inline-block !important;\n margin-top: -2px;\n height: 30px;\n line-height: 14px;\n width: 87px;\n}\n.fa-check-circle[data-v-cf5396ea] {font-size:40px !important\n}\nlabel[data-v-cf5396ea]{margin-bottom:0px !important;font-weight:normal !important;font-size:13px;\n}\nuser-creds label[data-v-cf5396ea]{font-weight: normal !important;\n}\n.sometext-hidden[data-v-cf5396ea]{\n-webkit-user-select: none; /* Chrome/Safari */\n-moz-user-select: none; /* Firefox */\n-ms-user-select: none; /* IE10+ */\n}\n.configGroupAdmin tr[data-v-cf5396ea], td[data-v-cf5396ea], th[data-v-cf5396ea]{padding-top: 5px;padding-bottom:5px;\n}\n.configGroupAdmin tr[data-v-cf5396ea]{border-bottom: 1px solid #eceff1;\n}\n.configGroupAdmin th[data-v-cf5396ea] {padding: 10px !important;\n}\n.addgrouptxtbox[data-v-cf5396ea]{    width: 85%;\n    border: #ccc 1px solid !important;\n    border-radius: 2px;\n    margin-top: 5px;\n}\n.deleteconfig[data-v-cf5396ea]{\nmargin-right: 15px;\nline-height: 13px;\ncursor:pointer;\npadding: 6px;\nfont-size: 13px;\n border-radius: 3px;\n background: #bf6161  !important;\n box-shadow: rgba(216, 21, 33, 0.75) 0px 0px 20px inset;\n max-height: 30px;\n margin-top: 2px;\n}\ntd:nth-child(2) span[data-v-cf5396ea] {\n    max-width: 500px !important;\n    display: block;\n}\n", ""]);

// exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\nhtml, body {\n  background-color: #FFF;\n  margin: 0px;\n  height: auto;\n}\n#login-background {\n  background-color: #FFF;\n  padding: 0;\n  margin:0;\n  /*background: url(https://www.cargill.com/image/1432079677619/hero-ag-market-landing.jpg) no-repeat !important;*/\n}\n.login-form, .forgotPasswordSection{max-width: 400px;    margin: auto;\n}\n.form-control{margin: 10px 0px;\n}\n.non-anchor-link{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display: inline-block;margin-top: 3px;\n}\n.fade-enter-active, .fade-leave-active {\n  transition: opacity 0.15s;\n}\n.fade-enter, .fade-leave-to {\n  opacity: 0;\n}\n.logo{margin:20px;text-align: center;\n}\n.logo img {max-width: 120px;\n\t    width: 120px;\n}\n.instruction {font-size:13px;\n}\nbutton {text-transform: none !important;\n}\nbutton:focus {color: #ffffff !important;\n}\nbody{background: #FFF; /* url(https://www.cargill.com/image/1432079677619/hero-ag-market-landing.jpg) no-repeat */\n    background-size: cover;\n}\n#app, #login-background, html{background:transparent\n}\n.custom-login{padding:20px;max-width: 440px;\n    margin: auto;\n    background: #ffffff97;border-radius: 2px;\n}\n.mailsent, .entersmssent{text-align: center;\n    font-weight: bold;\n}\n.emailsenttext{font-size: 14px;\n    margin-bottom: 30px;text-align: center;\n}\n.btn{cursor:pointer\n}\n.resend-code{cursor: pointer\n}\n.resend-code:focus{color:#464a4c !important\n}\n.disabled {pointer-events:none;opacity:0.5\n}\n.alternateReset {font-size: 14px;text-decoration:none;text-align: center; cursor:pointer;margin-bottom:15px;\n}\n#login-background{\n    width: calc(100vw);\n    box-sizing: border-box;\n    height: calc(100vh);\n    background-size: cover !important;\n    /* margin-top: -64px; */\n    padding-top: 60px;\n}\n.alternateReset:hover {text-decoration:underline;\n}\n.errorList{color:#d00000; background: #ffc6d195;\n    padding: 5px;\n}\n.opaqueSpinner {background: white !important;\n}\n.pwderror{display: block;\n    background: #c5c5c5;\n    padding-left: 10px;\n    color: #ffffff;\n    border-bottom: 1px solid #eaeaea;\n    max-width: 400px;\n}\n.splash{\nposition: absolute;\n    top: 0px;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n\t-o-object-fit: cover;\n\t   object-fit: cover;\n}\n.clogindiv{\n width: 300px;\n    background-color: #fff !important;\n    margin: auto;\n    padding: 20px 30px;\n    z-index: 999999999;\n    margin-top: -7px;\n    border-radius: 3px;\n}\n#cargillLogin{\n    white-space: normal;\n    background-color: var(--theme-primary);\n    font-weight: normal;\n    width: 100%;\n    border-radius: 1px;\n    font-size: 13px;\n    box-shadow: rgba(0, 0, 0, 0.15) 0 1px 0, rgba(255, 255, 255, 0.1) 0 1px 0 0 inset;\n\tcursor:pointer;\n}\n.hiddden{visibility:hidden;\n}\n.loginBrandBottomText{\n    max-width: 800px;\n    text-align: center;\n    padding: 10px;\n    margin: 0px auto;\n    font-size: 12px;\n    background: #f7f7a5;\n\tmargin-top:10px;\t\n    font-weight: bold;\n}\n.loginBrandTopText{\n    max-width: 600px;\n    text-align: left;\n    margin: 0px auto;\n    padding: 15px;\n\tmax-height: 160px;\n    overflow: auto;\n    margin-bottom: 10px;\n\tborder: 1px solid #ccc;\n\tbackground:#fff;\n\tborder-radius: 10px;\n\tfont-size: 14px;\n}\n.linkToOldEc{\n   cursor:pointer;\n   color:blue;\n   font-decoration:underline;\n}\n.disabled {\n    cursor: none;\n    pointer-events: none;\n    opacity:0.7;\n}\n.opacBg{\n  opacity:0.8;\n}\n@media screen and (max-width: 770px) {\n}\n#okta-sign-in{\nmargin-top: 0px !important;\n}\n.notification-pane{    \n    background: rgba(252, 248, 227, 0.95);\n    padding: 8px 20px;\n    border: 1px solid #fdd78a;\n    color: #ef2626;\n    max-width: 600px;\n    margin: 0px auto;\n    line-height: 20px;\n    font-size: 14px;\n    margin-bottom: 5px;\n    font-weight: bold;\n    font-style: italic;\n    border-radius: 10px;\n}\n.pull-up{margin-top:-30px;\n}\n::-webkit-scrollbar {\n    -webkit-appearance: none;\n}\n::-webkit-scrollbar:vertical {\n    width: 12px;\n}\n::-webkit-scrollbar:horizontal {\n    height: 12px;\n}\n::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, .5);\n    border-radius: 10px;\n    border: 2px solid #ffffff;\n}\n::-webkit-scrollbar-track {\n    border-radius: 10px;\n    background-color: #ffffff;\n}\n@media only screen and (max-width:360px) {\n.clogindiv {\n    margin-right: 22px;\n}\n}\n.okta-form-label {\n  text-align: left;\n}\n", ""]);

// exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\ni[data-v-da5d5c4e] {\n  padding: 24px;\n}\n", ""]);

// exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\n.hiddden[data-v-f5e219ce]{visibility:hidden\n}\n.custom-select[data-v-f5e219ce] {\n    display: inline-block;\n    max-width: 100%;\n    height: calc(2.50rem + 2px);\n    padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n    line-height: 1.25;\n    background-color: #ececeb;\n    vertical-align: middle;\n    background-size: 8px 10px;\n    border: 1px solid #00524A;\n    border-radius: 0;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n}\n.card-block[data-v-f5e219ce] {\n  background: var(--theme-primary);\n  border: 1px solid #00524A;\n}\n/*input{background: #fff;}*/\ninput[data-v-f5e219ce], select[data-v-f5e219ce]{height: 30px;color:#333;margin-top:7px;\n}\n.password-rule[data-v-f5e219ce]{color: #666;font-size: 12px;display: block;line-height: 16px;\n}\n.setup-section[data-v-f5e219ce]{background:#fff;\n/*border-radius:8px;border: 1px solid #ccc; margin-left: auto;margin-right: auto;text-align: left;padding-bottom: 20px;margin-bottom: 20px;font-size:14px;*/\nfont-size:13px;\n}\nlabel > input[data-v-f5e219ce]{ /* HIDE RADIO */\n  visibility: hidden; /* Makes input not-clickable */\n  position: absolute; /* Remove input from document flow */\n}\nlabel > input + img[data-v-f5e219ce]{ /* IMAGE STYLES */\n  cursor:pointer;\n  border:2px solid #ddd;\n}\nlabel > input:checked + img[data-v-f5e219ce]{ /* (RADIO CHECKED) IMAGE STYLES */\n  border:2px solid #333;\n  border-radius:0px;\n}\n.exclamatory-error-icon[data-v-f5e219ce]{color:#e34843;background:#ffffff;border-radius: 20px; width: 16px; height: 16px; display: block;\n    margin: 5px 3px;\n    padding-left: 5px;\n    line-height: 16px;\n    font-weight: bold;\n}\n.checked-icon[data-v-f5e219ce]{background: #333;padding: 3px;border-radius:3px;\n}\n.checked-icon-container[data-v-f5e219ce]{position: absolute; margin:10px;\n}\n.infobox-before-common[data-v-f5e219ce], .infobox[data-v-f5e219ce]::before, .infobox-md[data-v-f5e219ce]::before, .infobox-compact[data-v-f5e219ce]::before {\n  position: absolute;\n  top: -1px;\n  bottom: -1px;\n  left: -1px;\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n  content: '';\n}\n/* line 18, target/sass/courage/infobox/_all.scss */\n.infobox[data-v-f5e219ce] {\n  position: relative;\n  min-height: 18px;\n  padding: 12px 18px 12px 48px !important;\n  -webkit-hyphens: auto;\n      -ms-hyphens: auto;\n          hyphens: auto;\n  word-break: break-word;\n}\n/* line 25, target/sass/courage/infobox/_all.scss */\n.infobox[data-v-f5e219ce]::before {\n  width: 36px;\n  background-color: #007dc1;\n}\n/* line 31, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-no-icon[data-v-f5e219ce] {\n  padding-left: 24px !important;\n}\n/* line 34, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-no-icon[data-v-f5e219ce]::before {\n  display: none;\n}\n/* line 39, target/sass/courage/infobox/_all.scss */\n.infobox > .icon[data-v-f5e219ce] {\n  position: absolute;\n  top: 13px;\n  left: 9px;\n}\n/* line 45, target/sass/courage/infobox/_all.scss */\n.infobox a[data-v-f5e219ce] {\n  line-height: 18px;\n}\n/* line 49, target/sass/courage/infobox/_all.scss */\n.infobox ul[data-v-f5e219ce] {\n  margin-right: 0;\n}\n/* line 54, target/sass/courage/infobox/_all.scss */\n.infobox .link-button[data-v-f5e219ce] {\n  line-height: 28px;\n}\n/* line 58, target/sass/courage/infobox/_all.scss */\n.infobox + .infobox[data-v-f5e219ce],\n.infobox + h2[data-v-f5e219ce] {\n  margin-top: 18px;\n}\n/* line 63, target/sass/courage/infobox/_all.scss */\n.infobox .two_col_left[data-v-f5e219ce] {\n  width: 80%;\n}\n/* line 67, target/sass/courage/infobox/_all.scss */\n.infobox .two_col_right[data-v-f5e219ce] {\n  width: 19%;\n  margin-left: 1%;\n  padding-left: 0;\n}\n/* line 72, target/sass/courage/infobox/_all.scss */\n.infobox .two_col_right .button-primary[data-v-f5e219ce] {\n  width: 100% !important;\n  float: right;\n  box-sizing: border-box;\n}\n/* line 80, target/sass/courage/infobox/_all.scss */\n.infobox[style='display: none;'] + .infobox[data-v-f5e219ce],\n.infobox[style='display:none;'] + .infobox[data-v-f5e219ce] {\n  margin-top: 0;\n}\n/* line 85, target/sass/courage/infobox/_all.scss */\n.infobox h2[data-v-f5e219ce],\n.infobox h3[data-v-f5e219ce],\n.infobox h2 *[data-v-f5e219ce],\n.infobox h3 *[data-v-f5e219ce] {\n  margin: 0;\n  padding: 0;\n  font-size: 13px;\n  font-weight: bold;\n  line-height: 18px;\n}\n/* line 96, target/sass/courage/infobox/_all.scss */\n.infobox h2 span[data-v-f5e219ce],\n.infobox h3 span[data-v-f5e219ce] {\n  color: #5e5e5e;\n}\n/* line 101, target/sass/courage/infobox/_all.scss */\n.infobox h2 + *[data-v-f5e219ce],\n.infobox h3 + *[data-v-f5e219ce],\n.infobox p + *[data-v-f5e219ce],\n.infobox ul + *[data-v-f5e219ce],\n.infobox ol + *[data-v-f5e219ce],\n.infobox li + *[data-v-f5e219ce] {\n  margin-top: 9px;\n}\n/* line 116, target/sass/courage/infobox/_all.scss */\n.infobox[data-v-f5e219ce],\n.infobox-md[data-v-f5e219ce] {\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  background-color: #fbfbfb;\n}\n/* line 124, target/sass/courage/infobox/_all.scss */\n.infobox-md[data-v-f5e219ce] {\n  min-height: 18px;\n  padding: 24px 24px 24px 70px !important;\n}\n/* line 128, target/sass/courage/infobox/_all.scss */\n.infobox-md h2[data-v-f5e219ce],\n.infobox-md h3[data-v-f5e219ce] {\n  font-size: 15px;\n}\n/* line 132, target/sass/courage/infobox/_all.scss */\n.infobox-md h2 *[data-v-f5e219ce],\n.infobox-md h3 *[data-v-f5e219ce] {\n  margin: 0;\n  line-height: 18px;\n}\n/* line 138, target/sass/courage/infobox/_all.scss */\n.infobox-md[data-v-f5e219ce]::before {\n  width: 48px;\n}\n/* line 143, target/sass/courage/infobox/_all.scss */\n.infobox-md > .icon[data-v-f5e219ce] {\n  top: 20px;\n  left: 11px;\n}\n/* line 148, target/sass/courage/infobox/_all.scss */\n.infobox-md + .button-bar.button-bar-attached[data-v-f5e219ce] {\n  width: auto;\n  padding-left: 60px;\n  float: none;\n}\n/* line 153, target/sass/courage/infobox/_all.scss */\n.infobox-md + .button-bar.button-bar-attached.button-bar-l-height[data-v-f5e219ce] {\n  line-height: 32px;\n}\n/* line 163, target/sass/courage/infobox/_all.scss */\n.infobox-compact[data-v-f5e219ce] {\n  min-height: 16px;\n  padding: 9px 9px 9px 40px !important;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 3px;\n  border-color: #ddd;\n  background-color: #fbfbfb;\n}\n/* line 172, target/sass/courage/infobox/_all.scss */\n.infobox-compact a[data-v-f5e219ce],\n.infobox-compact p[data-v-f5e219ce],\n.infobox-compact li[data-v-f5e219ce] {\n  line-height: 16px;\n}\n/* line 178, target/sass/courage/infobox/_all.scss */\n.infobox-compact h2 + *[data-v-f5e219ce],\n.infobox-compact h3 + *[data-v-f5e219ce],\n.infobox-compact p + *[data-v-f5e219ce],\n.infobox-compact ul + *[data-v-f5e219ce],\n.infobox-compact ol + *[data-v-f5e219ce],\n.infobox-compact li + *[data-v-f5e219ce] {\n  margin-top: 5px;\n}\n/* line 187, target/sass/courage/infobox/_all.scss */\n.infobox-compact[data-v-f5e219ce]::before {\n  width: 30px;\n}\n/* line 192, target/sass/courage/infobox/_all.scss */\n.infobox-compact + p[data-v-f5e219ce] {\n  margin-top: 9px;\n}\n/* line 196, target/sass/courage/infobox/_all.scss */\n.infobox-compact > .icon[data-v-f5e219ce] {\n  top: 9px;\n  left: 6px;\n}\n/* line 205, target/sass/courage/infobox/_all.scss */\n.infobox-xl[data-v-f5e219ce] {\n  min-height: 18px;\n  padding: 26px 36px 26px 108px !important;\n}\n/* line 209, target/sass/courage/infobox/_all.scss */\n.infobox-xl[data-v-f5e219ce]::before {\n  width: 84px;\n}\n/* line 213, target/sass/courage/infobox/_all.scss */\n.infobox-xl > .icon[data-v-f5e219ce] {\n  top: 22px;\n  left: 18px;\n}\n/* line 218, target/sass/courage/infobox/_all.scss */\n.infobox-xl p[data-v-f5e219ce],\n.infobox-xl ul[data-v-f5e219ce] {\n  width: 75%;\n  margin-top: 20px;\n}\n/* line 224, target/sass/courage/infobox/_all.scss */\n.infobox-xl p[data-v-f5e219ce],\n.infobox-xl li[data-v-f5e219ce] {\n  font-size: 14px;\n  line-height: 20px;\n}\n/* line 230, target/sass/courage/infobox/_all.scss */\n.infobox-xl h2[data-v-f5e219ce],\n.infobox-xl h3[data-v-f5e219ce] {\n  font-size: 18px;\n}\n/* line 234, target/sass/courage/infobox/_all.scss */\n.infobox-xl h2 *[data-v-f5e219ce],\n.infobox-xl h3 *[data-v-f5e219ce] {\n  margin: 0;\n  line-height: 18px;\n}\n/* line 245, target/sass/courage/infobox/_all.scss */\n.infobox-teach h2[data-v-f5e219ce],\n.infobox-teach h3[data-v-f5e219ce] {\n  color: #835ab1;\n  font-weight: 200;\n}\n/* line 251, target/sass/courage/infobox/_all.scss */\n.infobox-teach.infobox-dismiss .button-teach[data-v-f5e219ce] {\n  margin-top: 20px;\n  float: right;\n}\n/* line 259, target/sass/courage/infobox/_all.scss */\n.infobox-dismiss[data-v-f5e219ce] {\n  padding-right: 30px !important;\n}\n/* line 263, target/sass/courage/infobox/_all.scss */\n.infobox-dismiss-link[data-v-f5e219ce] {\n  display: block;\n  position: absolute;\n  top: 10px;\n  right: 8px;\n  color: #5e5e5e;\n  line-height: 14px;\n  cursor: pointer;\n}\n/* line 273, target/sass/courage/infobox/_all.scss */\n.infobox-dismiss-link[data-v-f5e219ce]:hover {\n  text-decoration: none;\n}\n/* line 277, target/sass/courage/infobox/_all.scss */\n.help-wrap .infobox.infobox-dismiss .infobox-dismiss-link[data-v-f5e219ce] {\n  top: 0;\n  right: 0;\n}\n/* line 283, target/sass/courage/infobox/_all.scss */\n.infobox-dismiss-hide[data-v-f5e219ce] {\n  display: none !important;\n}\n/* line 292, target/sass/courage/infobox/_all.scss */\n.infobox-confirm[data-v-f5e219ce] {\n  position: absolute !important;\n  top: 20px;\n  left: 50%;\n  width: 240px;\n  margin-left: -154px;\n  box-shadow: 0 2px 0 rgba(160, 160, 160, 0.1);\n  z-index: 10;\n}\n/* line 302, target/sass/courage/infobox/_all.scss */\n.infobox-confirm-fixed[data-v-f5e219ce] {\n  position: fixed !important;\n  top: 106px;\n}\n/* line 306, target/sass/courage/infobox/_all.scss */\n.infobox-confirm-fixed .infobox-dismiss-link[data-v-f5e219ce] {\n  top: 14px;\n  right: 14px;\n}\n/* line 318, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-subtle.infobox-success[data-v-f5e219ce]::before,\n.help-wrap .infobox.infobox-success[data-v-f5e219ce]::before,\n.infobox-success[data-v-f5e219ce]::before {\n  background-color: #4cbf9c;\n}\n/* line 324, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-subtle.infobox-warning[data-v-f5e219ce]::before,\n.help-wrap .infobox.infobox-warning[data-v-f5e219ce]::before,\n.infobox-warning[data-v-f5e219ce]::before {\n  background-color: #f1d10d;\n}\n/* line 330, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-subtle.infobox-error[data-v-f5e219ce]::before,\n.help-wrap .infobox.infobox-error[data-v-f5e219ce]::before,\n.infobox-error[data-v-f5e219ce]::before {\n  background-color: #e34843;\n}\n/* line 336, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-subtle.infobox-tip[data-v-f5e219ce]::before,\n.infobox.infobox-subtle.infobox-teach[data-v-f5e219ce]::before,\n.help-wrap .infobox.infobox-tip[data-v-f5e219ce]::before,\n.help-wrap .infobox.infobox-teach[data-v-f5e219ce]::before,\n.infobox-tip[data-v-f5e219ce]::before,\n.infobox-teach[data-v-f5e219ce]::before {\n  background-color: #835ab1;\n}\n/* line 346, target/sass/courage/infobox/_all.scss */\n.infobox-warning .icon.processing-16[data-v-f5e219ce] {\n  width: 16px;\n  height: 16px;\n  background: url(\"/assets/img/ui/indicators/ajax-loader-processing-16.995b6ac81af8ed76a8ade6aba2f6d4d1.gif\") no-repeat 0 0 transparent;\n}\n/* line 352, target/sass/courage/infobox/_all.scss */\n.infobox-warning .icon.processing-24[data-v-f5e219ce] {\n  width: 24px;\n  height: 24px;\n  background: url(\"/assets/img/ui/indicators/ajax-loader-processing-24.2564f2a8efed77df6c170335ff3001ef.gif\") no-repeat 0 0 transparent;\n}\n/* line 358, target/sass/courage/infobox/_all.scss */\n.infobox-error .icon.processing-16[data-v-f5e219ce] {\n  width: 16px;\n  height: 16px;\n  background: url(\"/assets/img/icons/16x16/error-01.fa55d715ffe62d95fb0eded26d323a55.png\") no-repeat 0 0 transparent;\n}\n/* line 365, target/sass/courage/infobox/_all.scss */\n.infobox + .button-bar[data-v-f5e219ce],\n.infobox + .button-bar-small[data-v-f5e219ce] {\n  border-top: 0;\n}\n/* line 370, target/sass/courage/infobox/_all.scss */\n.infobox-no-border + .button-bar[data-v-f5e219ce],\n.infobox-no-border + .button-bar-small[data-v-f5e219ce] {\n  border-top: 1px solid #dadada;\n}\n/* line 376, target/sass/courage/infobox/_all.scss */\n.infobox-no-border[data-v-f5e219ce] {\n  border: none !important;\n}\n/* line 380, target/sass/courage/infobox/_all.scss */\n.infobox-text[data-v-f5e219ce] {\n  padding: 0;\n}\n/* line 384, target/sass/courage/infobox/_all.scss */\n.infobox-header[data-v-f5e219ce] {\n  font-weight: bold;\n}\n/* line 388, target/sass/courage/infobox/_all.scss */\n.infobox-divider[data-v-f5e219ce] {\n  border-bottom: 1px dotted #ddd;\n}\n/* line 396, target/sass/courage/infobox/_all.scss */\n.edit-form .infobox[data-v-f5e219ce],\n.read-only-form .infobox[data-v-f5e219ce],\n.ajax-form-editor .infobox[data-v-f5e219ce],\n.form-content-wrap .infobox[data-v-f5e219ce],\n.o-form .infobox[data-v-f5e219ce],\n.m-form .infobox[data-v-f5e219ce],\n.v-form .infobox[data-v-f5e219ce],\n.modal-content-wrap .infobox[data-v-f5e219ce] {\n  background-color: #fff;\n}\n/* line 407, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-subtle[data-v-f5e219ce],\n.help-wrap .infobox[data-v-f5e219ce] {\n  padding: 0 0 0 18px !important;\n  border: 0;\n  background: transparent;\n}\n/* line 413, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-subtle[data-v-f5e219ce]::before,\n.help-wrap .infobox[data-v-f5e219ce]::before {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 6px;\n  border-radius: 0;\n  background-color: #007dc1;\n  content: '';\n}\n/* line 424, target/sass/courage/infobox/_all.scss */\n.infobox.infobox-subtle .icon[data-v-f5e219ce],\n.help-wrap .infobox .icon[data-v-f5e219ce] {\n  display: none;\n}\n/* line 4, target/sass/modules/infobox/_overrides.scss */\n.infobox-teach + .ui-tabs[data-v-f5e219ce] {\n  margin-top: 18px;\n}\n.reg-nav[data-v-f5e219ce]{color:#DBAA00 !important;\nborder-top: solid 6px #DBAA00;padding-top:10px;\n}\n.title-bar[data-v-f5e219ce]{margin-right: -15px;\n    margin-left: -15px;\n    margin-top: -5px;\n}\ninput[data-v-f5e219ce], select[data-v-f5e219ce]{\n    border: 2px solid #dde3e6!important;\n    /* max-width: 400px !important; */\n    display: block !important;\n    border-radius: 0px !important;\n    min-height: 35px;\n    padding-left: 5px;\n}\ninput[type=button][data-v-f5e219ce]:hover, button[data-v-f5e219ce]:hover {\n    background-color: var(--theme-primary) !important;\n    border: 1px solid var(--theme-primary) !important;\n\t/* color: #fff !important; */\n\tborder-radius: 0px !important;\n}\ninput[type=button][data-v-f5e219ce], button[data-v-f5e219ce]\n {  background-color: var(--theme-primary) !important;\n    border-color: var(--theme-primary) !important;\n\t/* color: #fff !important; */\n\tborder-radius: 0px !important;\n}\n.create-acc[data-v-f5e219ce]{\nmargin: auto;\nborder: 1px solid #ccc;\nborder-radius: 3px;\ncolor:var(--regpwd-secondarytextcolor);\nmargin-bottom: 20px;\nheight: 34px;\npadding-left: 20px;\npadding-right: 20px;\nmargin-top: 20px;\nfont-size: 14px;\npadding: 4px 15px;\nfloat: right;\n}\n.pwderror[data-v-f5e219ce]{display: block;\n    background: #474c55;\n    padding-left: 10px;\n    color: #ffffff;\n    border-bottom: 1px solid #eaeaea;\n    max-width: 100%;\n}\n.forgot-link[data-v-f5e219ce]{\n    text-decoration: underline;\n    margin-top: 5px;\n    display: block;\n    cursor: pointer;\n}\n#userRegistration[data-v-f5e219ce]{\nmax-width: 500px;\n    margin: auto;\n    margin-top: 100px;\n\t margin-bottom: 100px;\n}\n.bg[data-v-f5e219ce]{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n}\n.splash[data-v-f5e219ce]{\nposition: absolute;\n    top: 0px;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n\t-o-object-fit: cover;\n\t   object-fit: cover;\n}\n.regapps[data-v-f5e219ce]{\nmax-width: 160px;\nwidth:100px;\npadding: 5px;\nmargin: 15px;\ncursor: pointer;\ntext-align: center;\ndisplay: inline-block;\nvertical-align: top;\n}\n.icon-wrap[data-v-f5e219ce]{border: 1px solid #acacac;width: 140px;\nborder-radius: 3px;\n    height: 60px;\n    background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#f4f4f4));    vertical-align: middle;\n    display: table-cell;\n}\n.errorwrapper[data-v-f5e219ce]{position: absolute;z-index: 999999999999999;width: 100%;padding-right: 30px;\n}\n", ""]);

// exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "/*!\n *  Weather Icons 1.3\n *  Updated November 30th, 2014\n *  Weather themed icons for Bootstrap\n *  ------------------------------------------------------------------------------\n* Maintained at http://erikflowers.github.io/weather-icons\n *  http://twitter.com/Erik_UX\n *\n *  License\n *  ------------------------------------------------------------------------------\n *  - Fpmt licensed under SIL OFL 1.1 -\n *    http://scripts.sil.org/OFL\n *  - CSS and LESS are licensed under MIT License -\n *    http://opensource.org/licenses/mit-license.html\n *  - Documentation licensed under CC BY 3.0 -\n *    http://creativecommons.org/licenses/by/3.0/\n *  - Inspired by and works great as a companion with Font Awesome\n *    \"Font Awesome by Dave Gandy - http://fontawesome.io\"\n *\n *  Weather Icons Bootstrap Package Author - Erik Flowers - erik@helloerik.com\n *  ------------------------------------------------------------------------------\n *  Email: erik@helloerik.com\n *  Twitter: http://twitter.com/Erik_UX\n */\n@font-face {\n  font-family: 'weathericons';\n  src: url(" + __webpack_require__(309) + ");\n  src: url(" + __webpack_require__(309) + "?#iefix) format('embedded-opentype'), url(" + __webpack_require__(691) + ") format('woff'), url(" + __webpack_require__(690) + ") format('truetype'), url(" + __webpack_require__(650) + "#weathericons-regular-webfontRg) format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n.wi {\n  display: inline-block;\n  font-family: 'weathericons';\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.wi-day-cloudy-gusts:before {\n  content: \"\\F000\";\n}\n.wi-day-cloudy-windy:before {\n  content: \"\\F001\";\n}\n.wi-day-cloudy:before {\n  content: \"\\F002\";\n}\n.wi-day-fog:before {\n  content: \"\\F003\";\n}\n.wi-day-hail:before {\n  content: \"\\F004\";\n}\n.wi-day-lightning:before {\n  content: \"\\F005\";\n}\n.wi-day-rain-mix:before {\n  content: \"\\F006\";\n}\n.wi-day-rain-wind:before {\n  content: \"\\F007\";\n}\n.wi-day-rain:before {\n  content: \"\\F008\";\n}\n.wi-day-showers:before {\n  content: \"\\F009\";\n}\n.wi-day-snow:before {\n  content: \"\\F00A\";\n}\n.wi-day-sprinkle:before {\n  content: \"\\F00B\";\n}\n.wi-day-sunny-overcast:before {\n  content: \"\\F00C\";\n}\n.wi-day-sunny:before {\n  content: \"\\F00D\";\n}\n.wi-day-storm-showers:before {\n  content: \"\\F00E\";\n}\n.wi-day-thunderstorm:before {\n  content: \"\\F010\";\n}\n.wi-cloudy-gusts:before {\n  content: \"\\F011\";\n}\n.wi-cloudy-windy:before {\n  content: \"\\F012\";\n}\n.wi-cloudy:before {\n  content: \"\\F013\";\n}\n.wi-fog:before {\n  content: \"\\F014\";\n}\n.wi-hail:before {\n  content: \"\\F015\";\n}\n.wi-lightning:before {\n  content: \"\\F016\";\n}\n.wi-rain-mix:before {\n  content: \"\\F017\";\n}\n.wi-rain-wind:before {\n  content: \"\\F018\";\n}\n.wi-rain:before {\n  content: \"\\F019\";\n}\n.wi-showers:before {\n  content: \"\\F01A\";\n}\n.wi-snow:before {\n  content: \"\\F01B\";\n}\n.wi-sprinkle:before {\n  content: \"\\F01C\";\n}\n.wi-storm-showers:before {\n  content: \"\\F01D\";\n}\n.wi-thunderstorm:before {\n  content: \"\\F01E\";\n}\n.wi-windy:before {\n  content: \"\\F021\";\n}\n.wi-night-alt-cloudy-gusts:before {\n  content: \"\\F022\";\n}\n.wi-night-alt-cloudy-windy:before {\n  content: \"\\F023\";\n}\n.wi-night-alt-hail:before {\n  content: \"\\F024\";\n}\n.wi-night-alt-lightning:before {\n  content: \"\\F025\";\n}\n.wi-night-alt-rain-mix:before {\n  content: \"\\F026\";\n}\n.wi-night-alt-rain-wind:before {\n  content: \"\\F027\";\n}\n.wi-night-alt-rain:before {\n  content: \"\\F028\";\n}\n.wi-night-alt-showers:before {\n  content: \"\\F029\";\n}\n.wi-night-alt-snow:before {\n  content: \"\\F02A\";\n}\n.wi-night-alt-sprinkle:before {\n  content: \"\\F02B\";\n}\n.wi-night-alt-storm-showers:before {\n  content: \"\\F02C\";\n}\n.wi-night-alt-thunderstorm:before {\n  content: \"\\F02D\";\n}\n.wi-night-clear:before {\n  content: \"\\F02E\";\n}\n.wi-night-cloudy-gusts:before {\n  content: \"\\F02F\";\n}\n.wi-night-cloudy-windy:before {\n  content: \"\\F030\";\n}\n.wi-night-cloudy:before {\n  content: \"\\F031\";\n}\n.wi-night-hail:before {\n  content: \"\\F032\";\n}\n.wi-night-lightning:before {\n  content: \"\\F033\";\n}\n.wi-night-rain-mix:before {\n  content: \"\\F034\";\n}\n.wi-night-rain-wind:before {\n  content: \"\\F035\";\n}\n.wi-night-rain:before {\n  content: \"\\F036\";\n}\n.wi-night-showers:before {\n  content: \"\\F037\";\n}\n.wi-night-snow:before {\n  content: \"\\F038\";\n}\n.wi-night-sprinkle:before {\n  content: \"\\F039\";\n}\n.wi-night-storm-showers:before {\n  content: \"\\F03A\";\n}\n.wi-night-thunderstorm:before {\n  content: \"\\F03B\";\n}\n.wi-celsius:before {\n  content: \"\\F03C\";\n}\n.wi-cloud-down:before {\n  content: \"\\F03D\";\n}\n.wi-cloud-refresh:before {\n  content: \"\\F03E\";\n}\n.wi-cloud-up:before {\n  content: \"\\F040\";\n}\n.wi-cloud:before {\n  content: \"\\F041\";\n}\n.wi-degrees:before {\n  content: \"\\F042\";\n}\n.wi-down-left:before {\n  content: \"\\F043\";\n}\n.wi-down:before {\n  content: \"\\F044\";\n}\n.wi-fahrenheit:before {\n  content: \"\\F045\";\n}\n.wi-horizon-alt:before {\n  content: \"\\F046\";\n}\n.wi-horizon:before {\n  content: \"\\F047\";\n}\n.wi-left:before {\n  content: \"\\F048\";\n}\n.wi-lightning:before {\n  content: \"\\F016\";\n}\n.wi-night-fog:before {\n  content: \"\\F04A\";\n}\n.wi-refresh-alt:before {\n  content: \"\\F04B\";\n}\n.wi-refresh:before {\n  content: \"\\F04C\";\n}\n.wi-right:before {\n  content: \"\\F04D\";\n}\n.wi-sprinkles:before {\n  content: \"\\F04E\";\n}\n.wi-strong-wind:before {\n  content: \"\\F050\";\n}\n.wi-sunrise:before {\n  content: \"\\F051\";\n}\n.wi-sunset:before {\n  content: \"\\F052\";\n}\n.wi-thermometer-exterior:before {\n  content: \"\\F053\";\n}\n.wi-thermometer-internal:before {\n  content: \"\\F054\";\n}\n.wi-thermometer:before {\n  content: \"\\F055\";\n}\n.wi-tornado:before {\n  content: \"\\F056\";\n}\n.wi-up-right:before {\n  content: \"\\F057\";\n}\n.wi-up:before {\n  content: \"\\F058\";\n}\n.wi-wind-west:before {\n  content: \"\\F059\";\n}\n.wi-wind-south-west:before {\n  content: \"\\F05A\";\n}\n.wi-wind-south-east:before {\n  content: \"\\F05B\";\n}\n.wi-wind-south:before {\n  content: \"\\F05C\";\n}\n.wi-wind-north-west:before {\n  content: \"\\F05D\";\n}\n.wi-wind-north-east:before {\n  content: \"\\F05E\";\n}\n.wi-wind-north:before {\n  content: \"\\F060\";\n}\n.wi-wind-east:before {\n  content: \"\\F061\";\n}\n.wi-smoke:before {\n  content: \"\\F062\";\n}\n.wi-dust:before {\n  content: \"\\F063\";\n}\n.wi-snow-wind:before {\n  content: \"\\F064\";\n}\n.wi-day-snow-wind:before {\n  content: \"\\F065\";\n}\n.wi-night-snow-wind:before {\n  content: \"\\F066\";\n}\n.wi-night-alt-snow-wind:before {\n  content: \"\\F067\";\n}\n.wi-day-sleet-storm:before {\n  content: \"\\F068\";\n}\n.wi-night-sleet-storm:before {\n  content: \"\\F069\";\n}\n.wi-night-alt-sleet-storm:before {\n  content: \"\\F06A\";\n}\n.wi-day-snow-thunderstorm:before {\n  content: \"\\F06B\";\n}\n.wi-night-snow-thunderstorm:before {\n  content: \"\\F06C\";\n}\n.wi-night-alt-snow-thunderstorm:before {\n  content: \"\\F06D\";\n}\n.wi-solar-eclipse:before {\n  content: \"\\F06E\";\n}\n.wi-lunar-eclipse:before {\n  content: \"\\F070\";\n}\n.wi-meteor:before {\n  content: \"\\F071\";\n}\n.wi-hot:before {\n  content: \"\\F072\";\n}\n.wi-hurricane:before {\n  content: \"\\F073\";\n}\n.wi-smog:before {\n  content: \"\\F074\";\n}\n.wi-alien:before {\n  content: \"\\F075\";\n}\n.wi-snowflake-cold:before {\n  content: \"\\F076\";\n}\n.wi-stars:before {\n  content: \"\\F077\";\n}\n.wi-night-partly-cloudy:before {\n  content: \"\\F083\";\n}\n.wi-umbrella:before {\n  content: \"\\F084\";\n}\n.wi-day-windy:before {\n  content: \"\\F085\";\n}\n.wi-night-alt-cloudy:before {\n  content: \"\\F086\";\n}\n.wi-up-left:before {\n  content: \"\\F087\";\n}\n.wi-down-right:before {\n  content: \"\\F088\";\n}\n.wi-time-12:before {\n  content: \"\\F089\";\n}\n.wi-time-1:before {\n  content: \"\\F08A\";\n}\n.wi-time-2:before {\n  content: \"\\F08B\";\n}\n.wi-time-3:before {\n  content: \"\\F08C\";\n}\n.wi-time-4:before {\n  content: \"\\F08D\";\n}\n.wi-time-5:before {\n  content: \"\\F08E\";\n}\n.wi-time-6:before {\n  content: \"\\F08F\";\n}\n.wi-time-7:before {\n  content: \"\\F090\";\n}\n.wi-time-8:before {\n  content: \"\\F091\";\n}\n.wi-time-9:before {\n  content: \"\\F092\";\n}\n.wi-time-10:before {\n  content: \"\\F093\";\n}\n.wi-time-11:before {\n  content: \"\\F094\";\n}\n.wi-day-sleet:before {\n  content: \"\\F0B2\";\n}\n.wi-night-sleet:before {\n  content: \"\\F0B3\";\n}\n.wi-night-alt-sleet:before {\n  content: \"\\F0B4\";\n}\n.wi-sleet:before {\n  content: \"\\F0B5\";\n}\n.wi-day-haze:before {\n  content: \"\\F0B6\";\n}\n.wi-beafort-0:before {\n  content: \"\\F0B7\";\n}\n.wi-beafort-1:before {\n  content: \"\\F0B8\";\n}\n.wi-beafort-2:before {\n  content: \"\\F0B9\";\n}\n.wi-beafort-3:before {\n  content: \"\\F0BA\";\n}\n.wi-beafort-4:before {\n  content: \"\\F0BB\";\n}\n.wi-beafort-5:before {\n  content: \"\\F0BC\";\n}\n.wi-beafort-6:before {\n  content: \"\\F0BD\";\n}\n.wi-beafort-7:before {\n  content: \"\\F0BE\";\n}\n.wi-beafort-8:before {\n  content: \"\\F0BF\";\n}\n.wi-beafort-9:before {\n  content: \"\\F0C0\";\n}\n.wi-beafort-10:before {\n  content: \"\\F0C1\";\n}\n.wi-beafort-11:before {\n  content: \"\\F0C2\";\n}\n.wi-beafort-12:before {\n  content: \"\\F0C3\";\n}\n.wi-wind-default:before {\n  content: \"\\F0B1\";\n}\nwi-wind-default._0-deg {\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n}\nwi-wind-default._15-deg {\n  -webkit-transform: rotate(15deg);\n  -moz-transform: rotate(15deg);\n  -ms-transform: rotate(15deg);\n  -o-transform: rotate(15deg);\n  transform: rotate(15deg);\n}\nwi-wind-default._30-deg {\n  -webkit-transform: rotate(30deg);\n  -moz-transform: rotate(30deg);\n  -ms-transform: rotate(30deg);\n  -o-transform: rotate(30deg);\n  transform: rotate(30deg);\n}\nwi-wind-default._45-deg {\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -o-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\nwi-wind-default._60-deg {\n  -webkit-transform: rotate(60deg);\n  -moz-transform: rotate(60deg);\n  -ms-transform: rotate(60deg);\n  -o-transform: rotate(60deg);\n  transform: rotate(60deg);\n}\nwi-wind-default._75-deg {\n  -webkit-transform: rotate(75deg);\n  -moz-transform: rotate(75deg);\n  -ms-transform: rotate(75deg);\n  -o-transform: rotate(75deg);\n  transform: rotate(75deg);\n}\nwi-wind-default._90-deg {\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\nwi-wind-default._105-deg {\n  -webkit-transform: rotate(105deg);\n  -moz-transform: rotate(105deg);\n  -ms-transform: rotate(105deg);\n  -o-transform: rotate(105deg);\n  transform: rotate(105deg);\n}\nwi-wind-default._120-deg {\n  -webkit-transform: rotate(120deg);\n  -moz-transform: rotate(120deg);\n  -ms-transform: rotate(120deg);\n  -o-transform: rotate(120deg);\n  transform: rotate(120deg);\n}\nwi-wind-default._135-deg {\n  -webkit-transform: rotate(135deg);\n  -moz-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  -o-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\nwi-wind-default._150-deg {\n  -webkit-transform: rotate(150deg);\n  -moz-transform: rotate(150deg);\n  -ms-transform: rotate(150deg);\n  -o-transform: rotate(150deg);\n  transform: rotate(150deg);\n}\nwi-wind-default._165-deg {\n  -webkit-transform: rotate(165deg);\n  -moz-transform: rotate(165deg);\n  -ms-transform: rotate(165deg);\n  -o-transform: rotate(165deg);\n  transform: rotate(165deg);\n}\nwi-wind-default._180-deg {\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\nwi-wind-default._195-deg {\n  -webkit-transform: rotate(195deg);\n  -moz-transform: rotate(195deg);\n  -ms-transform: rotate(195deg);\n  -o-transform: rotate(195deg);\n  transform: rotate(195deg);\n}\nwi-wind-default._210-deg {\n  -webkit-transform: rotate(210deg);\n  -moz-transform: rotate(210deg);\n  -ms-transform: rotate(210deg);\n  -o-transform: rotate(210deg);\n  transform: rotate(210deg);\n}\nwi-wind-default._225-deg {\n  -webkit-transform: rotate(225deg);\n  -moz-transform: rotate(225deg);\n  -ms-transform: rotate(225deg);\n  -o-transform: rotate(225deg);\n  transform: rotate(225deg);\n}\nwi-wind-default._240-deg {\n  -webkit-transform: rotate(240deg);\n  -moz-transform: rotate(240deg);\n  -ms-transform: rotate(240deg);\n  -o-transform: rotate(240deg);\n  transform: rotate(240deg);\n}\nwi-wind-default._255-deg {\n  -webkit-transform: rotate(255deg);\n  -moz-transform: rotate(255deg);\n  -ms-transform: rotate(255deg);\n  -o-transform: rotate(255deg);\n  transform: rotate(255deg);\n}\nwi-wind-default._270-deg {\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\nwi-wind-default._285-deg {\n  -webkit-transform: rotate(295deg);\n  -moz-transform: rotate(295deg);\n  -ms-transform: rotate(295deg);\n  -o-transform: rotate(295deg);\n  transform: rotate(295deg);\n}\nwi-wind-default._300-deg {\n  -webkit-transform: rotate(300deg);\n  -moz-transform: rotate(300deg);\n  -ms-transform: rotate(300deg);\n  -o-transform: rotate(300deg);\n  transform: rotate(300deg);\n}\nwi-wind-default._315-deg {\n  -webkit-transform: rotate(315deg);\n  -moz-transform: rotate(315deg);\n  -ms-transform: rotate(315deg);\n  -o-transform: rotate(315deg);\n  transform: rotate(315deg);\n}\nwi-wind-default._330-deg {\n  -webkit-transform: rotate(330deg);\n  -moz-transform: rotate(330deg);\n  -ms-transform: rotate(330deg);\n  -o-transform: rotate(330deg);\n  transform: rotate(330deg);\n}\nwi-wind-default._345-deg {\n  -webkit-transform: rotate(345deg);\n  -moz-transform: rotate(345deg);\n  -ms-transform: rotate(345deg);\n  -o-transform: rotate(345deg);\n  transform: rotate(345deg);\n}\n.wi-moon-new:before {\n  content: \"\\F095\";\n}\n.wi-moon-waxing-cresent-1:before {\n  content: \"\\F096\";\n}\n.wi-moon-waxing-cresent-2:before {\n  content: \"\\F097\";\n}\n.wi-moon-waxing-cresent-3:before {\n  content: \"\\F098\";\n}\n.wi-moon-waxing-cresent-4:before {\n  content: \"\\F099\";\n}\n.wi-moon-waxing-cresent-5:before {\n  content: \"\\F09A\";\n}\n.wi-moon-waxing-cresent-6:before {\n  content: \"\\F09B\";\n}\n.wi-moon-first-quarter:before {\n  content: \"\\F09C\";\n}\n.wi-moon-waxing-gibbous-1:before {\n  content: \"\\F09D\";\n}\n.wi-moon-waxing-gibbous-2:before {\n  content: \"\\F09E\";\n}\n.wi-moon-waxing-gibbous-3:before {\n  content: \"\\F09F\";\n}\n.wi-moon-waxing-gibbous-4:before {\n  content: \"\\F0A0\";\n}\n.wi-moon-waxing-gibbous-5:before {\n  content: \"\\F0A1\";\n}\n.wi-moon-waxing-gibbous-6:before {\n  content: \"\\F0A2\";\n}\n.wi-moon-full:before {\n  content: \"\\F0A3\";\n}\n.wi-moon-waning-gibbous-1:before {\n  content: \"\\F0A4\";\n}\n.wi-moon-waning-gibbous-2:before {\n  content: \"\\F0A5\";\n}\n.wi-moon-waning-gibbous-3:before {\n  content: \"\\F0A6\";\n}\n.wi-moon-waning-gibbous-4:before {\n  content: \"\\F0A7\";\n}\n.wi-moon-waning-gibbous-5:before {\n  content: \"\\F0A8\";\n}\n.wi-moon-waning-gibbous-6:before {\n  content: \"\\F0A9\";\n}\n.wi-moon-3rd-quarter:before {\n  content: \"\\F0AA\";\n}\n.wi-moon-waning-crescent-1:before {\n  content: \"\\F0AB\";\n}\n.wi-moon-waning-crescent-2:before {\n  content: \"\\F0AC\";\n}\n.wi-moon-waning-crescent-3:before {\n  content: \"\\F0AD\";\n}\n.wi-moon-waning-crescent-4:before {\n  content: \"\\F0AE\";\n}\n.wi-moon-waning-crescent-5:before {\n  content: \"\\F0AF\";\n}\n.wi-moon-waning-crescent-6:before {\n  content: \"\\F0B0\";\n}\n", ""]);

// exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "\nhtml {\n  position: relative;\n  min-height: 100%;\n}\n\n\nbody {\n  /* Margin bottom by footer height */\n  margin-bottom: 285px;\n}\n\nhtml, body {\n  font-family: 'HelveticaNeueW01-55Roma', Helvetica, Arial, Sans-serif;\n  font-size: 100%;\n  font-size: 100%;\n  word-wrap: break-word; \n  color: #273238;\n  font-weight: normal;\n  background-color: #FFF;\n}\n\n.hr {\n  background-image: url(" + __webpack_require__(308) + ");\n  background-repeat: repeat-x; \n  background-color: #000;\n  height:20px;\n  padding:0;\n  margin: 10px;\n  width:100%;\n}\n\np {\n  font-family: 'HelveticaNeueW01-55Roman', Helvetica, Arial, Sans-serif;\n  font-size: 14px;\n  line-height: 21px;\n  color: #273238;\n  font-weight: normal;\n}\np.welcome {\n  color: #fff; font-size: 18px; line-height: 26px; padding-top: 10px; font-weight: normal;\n}\n.titleBar {\n  height: 8px; background-color: var(--theme-primary); width: 100px; margin: 50px 0 8px;\n}\nH1.welcome {\n  color: #00524A; font-size: 42px; line-height: 42px; \n}\nH1 {\n  font-size: 42px;\n  line-height: 46px;\n  padding-left: -15px;\n  font-weight:bold;\n\n}\nH2 {\n  font-size: 30px;\n  line-height: 34px;\n  font-weight:bold;\n}\nH3 {\n  font-size: 24px;\n  line-height: 30px;\n  font-weight:bold;\n  margin: 10px 0;\n}\n\nH4.dashboard {\n  color: #fff;\n  font-size: 22px;\n  line-height: 28px;\n  font-weight:bold;\n}\nH5 {\n  font-size: 16px;\n  line-height: 23px;\n  font-weight:bold;\n}\n\n#app {\n  background-color: #FFF;;\n}\n\n/* ================================== Breadcrumb ================================== */\n#breadcrumb {\n  padding: 35px 0 0 15px;\n}\n\n#navlist\n{\nlist-style: none;\npadding: 0;\nmargin: 0;\n}\n\n#navlist li\n{\ndisplay: inline;\npadding: 0;\nmargin: 0;\n}\n\n#navlist li > a\n{\ncolor: var(--theme-primary);\ntext-decoration: none;\n}\n\n#navlist li > a:hover\n{\ncolor: #273238;\ncursor: pointer;\ntext-decoration: none;\n}\n.active {\n  color: #273238;\n}\n\n#navlist li:before { content: \"| \"; }\n#navlist li:first-child:before { content: \"\"; }\n\n\n/* ================================== Spinner ================================== */\n\n#overlay {\n  position: fixed; /* Sit on top of the page content */\n  display: none; /* Hidden by default */\n  width: 100%; /* Full width (cover the whole page) */\n  height: 100%; /* Full height (cover the whole page) */\n  top: 0; \n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0,0,0,0.0); /* Black background with opacity */\n  z-index: 3000; /* Specify a stack order in case you're using a different order for other elements */\n  cursor: pointer; /* Add a pointer on hover */\n  text-align: center;\n  color: black;\n}\n#overlay .inner {\n  height: 100%;\n}\n\n/* ================================== Data Table ================================== */\n\nth, td {\n  font-size: 12px;\n}\n\nth {\n  color: white;\n  background-color: #273238;\n}\n\nth::first-letter {\n  text-transform: uppercase;\n}\n\nth a, th a:hover, th a:visited {\n  color: white;\n}\n\n.fa-chevron-right {\n  color: var(--theme-primary);\n}\n\n.table tbody tr:hover td, .table tbody tr:hover th {\n  /* background-color: #DBAA00; */\n  cursor: pointer;\n}\n\n/* ================================== Data Table Filter ================================== */\n\nlabel {\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.custom-select, input {\n  font-size: 12px;\n  border-radius: 0;\n  color: yellow;\n}\n\ntr {\n  background-color: #FFFFFF;\n}\n\n\n/* ================================== Nav Tab Control ================================== */\n\n.cf-tab, .cf-tab:hover {\n  background-color: var(--theme-primary);\n  color: white;\n}\n\n/* ================================== Table Container ================================== */\n\n.tableContainer {\n  background-color: #FFF;\n  border: 1px solid #CECECB;\n  padding: 35px;\n  margin: 25px 0 0px;\n}\n\ndiv.container {\n    width: 100%;\n    max-width: 100%;\n}\n\n/* ================================== Cards CSS overwrite ================================== */\n.card-block {\n    -webkit-box-flex: 1;\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    padding: 0rem;\n}\n.card {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    background-color: #999;\n    border: 0px solid rgba(0, 0, 0, 0.125);\n    border-radius: 0;\n}\n\n\n/* ================================== Call To Action ================================== */\n\na.btn-primary {\n    background-color:var(--theme-primary);\n    border-color: var(--theme-primary);\n}\n\n.btn {\n    display: inline-block;\n    font-weight: normal;\n    line-height: 1.25;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: middle;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border: 1px solid transparent;\n    padding: 0.5rem 1rem;\n    font-size: 1rem;\n    border-radius: 0;\n    transition: all 0.2s ease-in-out;\n}\n\n.btn-floating.btn-large {\n    width: 40.5px;\n    height: 40.5px;\n}\n\n.btn-floating {\n    display: inline-block;\n    color: #fff;\n    position: relative;\n    overflow: hidden;\n    z-index: 1;\n    width: 37px;\n    height: 37px;\n    line-height: 37px;\n    padding: 0;\n    background-color: #a6c;\n    border-radius: 50%;\n    transition: .3s;\n    vertical-align: middle;\n    margin: 10px;\n}\n\n.btn-floating {\n    cursor: pointer;\n}\n\n.btn-floating {\n    box-shadow: 0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12);\n}\n\na:hover.btn-floating  {\n    box-shadow: 0 4px 7px 0 rgba(0,0,0,.18), 0 4px 12px 0 rgba(0,0,0,.14);\n}\n\n.green {\n    background-color: var(--theme-primary)!important;\n}\n\n.fa-arrow-up {\n    display: inline-block;\n    font: normal normal normal 14px/1.5 FontAwesome;\n    text-rendering: auto;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.fa-arrow-up:before {\n    content: \"\\F062\";\n    color: #fff;\n}\n\n*, ::after, ::before {\n    -webkit-box-sizing: inherit;\n    box-sizing: inherit;\n}\n\n/* ================================== Footer bar ================================== */\n.footer {\n  bottom: 0;\n  width: 100%;\n  /* Set the fixed height of the footer here */\n  height: 100px;\n  background-color: #454c56;\n  margin-top:15px;\n}\n\n.contactInfo {\n  color: white;\n  font-size: 12px;\n  font-family: HelveticaNeueW01, Helvetica, Arial, sans-serif;\n  padding-left: 55px;\n}\n\n.bootomFooter {\n  font-size: 12px;\n  color: #d9d1cf;\n color: #273238 !important;\n  font-family: HelveticaNeueW01, Helvetica, Arial, sans-serif;\n  padding-left: 55px;\n}\n\n/* ================================== Export bar ================================== */\ncaption.bottom.tableexport-caption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #636c72;\n  text-align: right;\n  caption-side: top;\n}\n\n.button-default, .button-default:active {\n  cursor: pointer;\n  color: #fff;\n  margin-left: 5px;\n  background-color: var(--theme-primary);\n  border-color: var(--theme-primary);\n  padding: 10px 20px;\n  margin-top: 2px;\n}\n\n.button-default:hover {\n  color: #fff;\n  background-color: #00524A;\n  border-color: #00524A;\n}\n\nbutton {\n  display: inline-block;\n  font-weight: normal;\n  line-height: 1.25;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border: 1px solid transparent;\n  padding: 0.5rem 1rem;\n  font-size: 0.8rem;\n  border-radius: 0;\n  transition: all 0.2s ease-in-out;\n  text-transform: uppercase;\n}\n\n /*.button-default:before {\n  font-family: 'FontAwesome';\n  content: \"\\f005\";\n  top: 0;\n  left: 10px;\n} */\n\n\n\n/* ================================== Media Queries ================================== */\n\n/* Extra small devices (portrait phones, less than 576px) */\n@media (max-width: 575px) { }\n\n/* Small devices (landscape phones, 576px and up) */\n@media (min-width: 576px) and (max-width: 767px) { \n  \n}\n\n/* Medium devices (tablets, 768px and up) */\n@media (min-width: 768px) and (max-width: 991px) { }\n\n/* Large devices (desktops, 992px and up) */\n@media (min-width: 992px) and (max-width: 1199px) { }\n\n/* Extra large devices (large desktops, 1200px and up) */\n@media (min-width: 1200px) { }\n\n/* Set Print Option to \"Landscape\" as default. Cannot be changed without removing this entry. */\n@page { size: landscape; }", ""]);

// exports


/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/weathericons-regular-webfont.b2233bc.svg";

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Thumbs.c62baa7.db";

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPIAAAAoCAYAAADEzaftAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABBtpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ1dWlkOjY1RTYzOTA2ODZDRjExREJBNkUyRDg4N0NFQUNCNDA3IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkU3RDlFNDZDNDczODExRTY5RDhFRjhDRjJDNTRDOTIyIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkU3RDlFNDZCNDczODExRTY5RDhFRjhDRjJDNTRDOTIyIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE1LjUgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MjMyN2RhOWEtMWM5Yy02ODQ4LWJmZjEtMzE5NjhmMWIyYmM2IiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6NjE3YmExYjEtMzg4Mi0xMWU2LTgxMWQtYmYxZDg1YjUzODNiIi8+IDxkYzp0aXRsZT4gPHJkZjpBbHQ+IDxyZGY6bGkgeG1sOmxhbmc9IngtZGVmYXVsdCI+YWdyZXNvdXJjZS1wdWJsaWMwNDIwMjAxNkNCXzQ8L3JkZjpsaT4gPC9yZGY6QWx0PiA8L2RjOnRpdGxlPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pg+91lsAABBoSURBVHja7F0JeFXFFZ6EALIFBCxLBeETZIkCsilhk2oF12qBirgUoSrWgmKkLqiICyiCClVQUVTaIuJeAQUEVCqrQgQFBGQRBWQRCEHCEl7P6Tvvc5ycM3fufTcJ0ft/3/8lmTdv7r1z58xZ701KLBZTAXAicCewlPD5ZOBVquiB5/WDz+/sAc4Bvg58A3hURYhQwpAa8Hs3WIQYUamYrqdVQOHvAZwC/AT422hZRPg1CHI54G0efYpLkNsk+f22wHeAadHSiPBLF+R+wN949KlSTNfTNiStflG0NCKUJPjVPGWAgx36VTrOBHk0MEbWBJrSGcDmlnE6kWaOECFsVAPuLm5B7g2sa7TtYDR0ejFMEPq2tZn2fbT5mFG9vwAnHGcbUYRfLn4HHAbsAMwG3gOcHnCs8sB7gaWBZYGP+TGtse+dTPuTIQkCjl8HeAawRojaeAkjxIjngV8I33GNfKMLUY9YPYmbXJ6uO5NM+1OSGKs0zWPivGope2CyuFEReBbFN1Is/XDBtgR2JGFomsQx8Tg1tTkqzI0br+0DFc+MdKC2FsBpKh5cPSfAmCjE39B9/RItTj8auTuwkdG2DjgTONxoP4EW1BGHcXHRDgH2NHzrZeSP4+6FUeV2hk//XxVPF7kIsoTVwNOZ9g2W73Qkbf57EhIdOXS8iSoeBY95XPcA4KXABswi/hE4F/gP4CwHYbge+CfaCEobnx8CLsSdGzhDGOM8YHumfRJwo9HWhawzE6/Sok3gCTo3835MIMtuJK0rXId55PqYAteL5rsTY0EeBL4LfBi4wsH6xPm5mgTKFN5vgR8DRwGXhyDApwEfAV5m2aAy6R7PISX5mePYuHYW0RpEi/OYwjyyA1OAy2IFMRDYIsajmsO4lwL3x2TsAGYAjzKf3W6M9YEwxsWW40vfacX0xet5M+aO8Za5vBd4yHGcY8C7LNdwAXC7j/O6XRhnntC/HtP3KaFvF63PSXTuJu4HdgPuMdrnG8doClzueE2HgT0tc9QM+KWPsbo7ygXHWsDnhDXrdZ9fAzZ2OMYQ4FBgO+Bo4GTXk+vGHDgHmG4R5HoeY3ZxXMzSDeigjZUK3Cf0qyEcvwrwR6b/dzSe3rcmcG3MP85jjjspwDi4KE5hxuoVYMEcpYVtjpXL9N0uzN1SYSFW1vpcLBz/JWAe0/649t3WjKB7YR9tHua5tvNQFhzw2Cf6FGC89hHAA7HkgPfnBeDJlmOVAt4NfAw4Cljd9STnMwd8mj6TBLmFZTzcAL5N4mKPACto4zUW+m20nMMI4Tv3MZM232IxvE8/OUw0xhps2Y2/AC4QtBiijzFWc0EgECuAiy1jPcWMxeEdZt7K0vybWGf0e8ByrRx6a5vm95Z7n2/5bDBjRW0V+m4Afgw8KHze11E2cD6ygLti4SIvIaQu5+ES7OqkOekJxMh38/LbJNyjClZQ5ZMTn0F+3huW72OQ6oCDf7xYaO8hpNG2MMG765nrV3T96Kt0I3/oa6ZPhvY7+tP3C8dsS756JvlxHCobvuMzFADSgWWznYHNKMhyvcXP19Hax/y1ErIdy5kgjxRo4rCQfo5hsiC43sZRLOEE8j2ltapjJBPHOAzsAzyV+mfS2jPhEkzDsdeQX10t5CAZ3tss4Ho6RzscpP09ZreYqX0uaeQLhfFqCibtCKafhGccfbYszS9FE7szaUlOK6BJdJYxbjlhR5/KXNdIYddPfH6PoJ3aMGNxmvZG7fPujvGANPL5TOw0+o334RoM8pjrBPda7h+6ZS+T738L8Fz6Tnvh3jxijF1acMvmGeuS0979mWtawvR7zlEjNwHOihUOso24g0ivDmc6LBhJkHsJYw5j+h4iwTX7xhzNniVCv1xHn2UzI8TImwSzvo6jIOum/YfCguaCatxibq/14YJAa4T55nzNbUafzxx83gSnCHPYSevTyDLXM4BVhXOdLQSfKjte1xzt89eYz1fSpm6O9bGD+yHJR4oWE1gbkgDvoI07RTPdqyVjWg9h2r62pDAkU1DPFV/HtP8HuJ0xLSQsMvpJVVoVKEcrYS+ZuxmCGflXpm0+mcMmuLLVXCMdwbkfrZlzqku5YJ0L6PPOlIc08bYPs22LMX/NhPu8j2nn6tnzjTSfVPP+FaWbuDw9uhbnMu2fCOdRgWn7RisOuoz5fKqQEqzlce8koOm+ktyrabSO7hDO1wX45B1WITYEPkvXsJpM93JBK7uaAC9n2p/6f97KG+nCIqjDtL/CtNUWxt1PfkkCKMRlAk5cLgk657edackxVzFy5umCn/6d4edx/uJc8v+eo7HzKacp4Tqh/V2hOIS7D5sdfN6lTBsWvdRn2ldQHthLkIdT7pfDDcJ9mCP0H8YIwWT6vbdwTVuMe1eBCnHqMX23Oa4hFN73iFkk3C9SbruvYzFOjJTjIKrNaEaxAvdiEYu6fpFR+fsZM0cyrR9gxhwqmKoVmb6dhXHnGv1uDsGU+YhJOQ0LYdwxHrEG05RdBBxgiVSWFkzKvRRdN/s3FI410sHnHcSMd6FjznyhcH1VLOtNymJkBsjlzg/h3l3icJzZzFoeo7kOzWm92rAK2JX6VyWTnkspnhzEtK5LFTBclY+r2cCVvbUXdvNcwSJwiaRK0dFHSasmeL7FJejERHLPDyHymK39Pt6j0iuFrmUsaeTRTOS/reKfLJsnRF6bW0xcL+251GcZrG4FtBKOuVf4fjPFPweeZ8k82LIlZ4dw7z4P8B20AgYC11LVHq5trLH+I5PV2E19z6BquIGkjW8OUlIrmdZ3Cp/hJA012mr68JFbMm1SWVpLR0GWFiJuOquYBb9e8bXMuJg+Mup6k8UCIw4wlEzCFIfUw23kM3ai0k8lpMEUlRZykBb0So/5Q9fpUx+CrAt9C6ZEVNoYlMd1LRI2KBtaqeSfJ/9W87eDoBptyDeQgL5FSuQWMvvRXXhIxd9Og/714xbFFViQa1GejcO1PsY2gxEnCbm2lcL3Ozvs/qidGjn40boftVwQZF1bNhb87g3kA+VpWlTfsHK0+MExQ/MhHlTxuunbKZDhteBQo95FVEKQKxEQ4sD5WIfVT3XJJ1I+lcvT5zHt7YS51h8+yfSh4fVAlxICi37RTGh/hwTKBd+FlAs+nYT2TeCttHZGahbnv4EXhHEgbiHd6hUhCyjI9YV+nMA1EKK8GKzYqv3dWtBun1kCcpWF9s0eEWbEBIomJgO0KHpSlBs3zH6W4yHO0wS5obA5fS5ohTOF4+dp2ivF0aw8VTDrFxl/t7ZoVwkNfG5QKsBYIw0LqaiQQpF6FFh8YcWH5LZNVyG+icb0kasqPuUShiDXEvpxJszVQt+FAUw9bkF6mZt1hT7bQrzBO2hxNSITOlvopwtPbcFKOMS0d1P8G2CmO8QXljFtrgLKmepHhDETqCFYSJx/jE+L7SSzNPHzB7IubOtshypelCe/OWHZhPo6KXOwAcpeWukH6YyGcJlgtAZudDCrbT7gEss5cUKKAbxNDufKlWFiKd9E9fO8N/pYl9Dv+AheV2OuJxlm3lxaoJsZDbnJWAwmNgrneqUgHFMdNsJPffixS41N5zTBQrL5uicJFhIXHMOy0+qMpbaHfq9u8XtN3EgWqO5GYOBpcCEJc2ph7RJpRiDrb0wf3O2HKzlajYI3QmjXUclyE/cYJlBNh+CRbSFKkc4Mof1zj3NPYCvT9jSj2bK1OX2WuYEvChtajBHk5R5zyL02JlEDbmKWIfhtBGE35wNz5T0ctKb0coAlHuuwnKOlVplcDRMzPVynHYzPj2tsFKO4xqoSiDRjd+J2s5eBD1jGqOIoyJLP+pKKV5Cl0Tl0F/odMRZ1PcEk26b4yqtEEMvLrLbhBOPvC4WA0iT6ebKwC+cJGtTLFM5h/FROuNGn5lIYw42Nm9swjzHn96jQd7NhUZ0dwNVB5DLXxT20MIi5B4jnPbQe53o8yQgxzu/rJVGQUzWhyxL6PB1wbPPGfCX0a0em5SyLECc0U56Df7c4gH9sBtwkM7CvsSmME7TPh4LgJ/B3w0xG7fmEYCl8pP29XwiG6fniy8mcN4FPk+lpqoaC9ixFm2tncg8w2jvQ0QRv48NU9/JfUalco/3dR8WfmuOsjMUe9w6rCbtoa/4+4BVMv7HCHJcYjXytECTARbQi4NimRp5PPk/QV+WaZnUQQa7v6PuuEvplUWAKUzitGK2H7f3VT6msbwRz+VxavNm0uXDaLp9xddaogiWu5UhQsul+thAExRzLVtbaW/Gv8vEKdLUT4g9rPMZBzd5SsAb7k7mcIWhy87pWK74gZQ4dp6Jgea4TLMswUWjvTkulm3+n8PmYJMYua5g5WGM73uM7uyngxplCC0MQZOmldkcZ7SW9srQF+ealGMHrY5j/GE2VorUY1W8vCDEK/00q/l4yHf+ybMitBSHOJS1tPpSyVrnVzCvLZr7EcHWqOwg7h1eFdtwAMwUhPkRadZ3RPk7Jde3SOWL0+w8q/p60wkS5whTkqxRfNL5RJf9uZzNyjQURUwVBQj+nCWmPsh4aubSwg+d7mHHSv4OpzWiRHj7MLFwIWODBPfyBJXcHfMwZbiCYZ+Ze1YuC/JaPsVBYOyo+f7pH2V/ekJjPgYovzMg3fN82jlpbEuTXfFzXJjKVZwgb/mBlL4fVsYw21NWqBCONgjVvC5PrsmMfJp9KCYETZWjlK8hH6UBmzi7ykbdpPp4JNFH19AEWU0wRBMomfK8ovhQuh2lDP/d0CrBcRCZwqrH5rKR5elbJdcSLaZHfreJ1tzWZgMwxGmsqWS17LPPZk3z1P5MGrsDMMQrYPynodtgyH/3o816GhYFt+DTVQ2SyYybhA+O7K42YRXmmT45yL6DBdTGP/PszVMEyzyNkAeATThOFgGECo2lDv4ME3oxV5JG1M5HmPF+VcKQE/G+MhQVcDN+rgtFE3CiuK+ZzK0NmWRkSlh+U2+t+JQsgncy9/bSJBV1M6RR3SCFLYp8PbZQAfr8pCc9BVfCxxOIApiVrkLJBK2VLwHHwmhrQ5h+jzX59EvdOx2zFp8Mk4EaHr7DFmvv7fR6rjrI83loU/6wsoY1M9GU0Tw/FF6RMOQ42GdRSW0Maa2uIY+UIFoUf7FXFU77o5a7sDGGcI2Q2F4bpfLCI5iLmdayiEOSmin9bw3T18/xfDWGXQu0wS0WIcPwBq8IqqWD/LcLPJnuX8vh/UUUhyJKPNo4CMdlkNlyjCkYU0Q/tH8BUjBChKLCBfPB+FEeoGrIWxuIUDDZu9+pcFIK8gII0qYzvcq2SH41EnxErvRZG6yXCcY4XVDzDg+naK5X38+Ze2KTi6cf3Xb+QWgQXiUn4B31+B6PUGCmeGK2RCCUEmH3BVG5XZf/fYTagBYpltBl+hLioBFmR74vlfviCMinpjtHbmWSmNFY/L4SPEKGkYDYJ4sOqYKGRDfjsNaYTh6gAhSlpRXiB04iYr8T0SzVtF9rl4gdEiFBCgKk7rAvHugX8jyAdLH0xjYmVlROSOWBaMVwk+r5bVPC8YIQIJQX4v4sxoIvPUJv/5gaDWVi0k0WKTJU0QY4Q4dcG1LZYWpt4RhwfyjlHyS9N9I3/CTAA5AAG5A++ZGIAAAAASUVORK5CYII="

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAK0AAAAgCAYAAABggfhFAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAANjSURBVHhe7ZILbiMxDEN7/0t3Y6ACCC1JSZ5Jusn6AUIT8ePJ1F/fh8ObcS7t4e04l/bwdpxLe3g76KX9+vq6ZQ7XOO+QY99KvoT4Etme7Q57nPenKd/MziWc+q/wqnNezaf+rjs4l/Yf5VN/1x289aV91Tmv5lN/11085dIuXvHSd57rHfjE33QnT7u0zwSf6V96ritc/U07eebb6cgzgeXXOMoTukWB8rE9640dDsL0GAXTXSY0NnfDzljThWVjFMyDO5wKlsFRMG8eRflUnZKg48M+5XdaUHlQR5/aL9gucNoU7MK+vEct4zyooR6fs4afF6jjHuloV7PS8/NXUhUgHR/2Ma/TkI4PPW4CtgtQY/oE1YN7piNOxzzzVPqiqyuUXuUW4VE+n35QFQRd3wK92c92DJXPoA+9+fuC+QLUmD5B9eCe6UhXZx7UmL5wutOCKusIj/L59AMs6E4H5r+aV9zlC73TpVAduFOeoNIX6Mk+tUecBzWmO3K2M5nyxKog6HgQ9EcGP1fkrOMuX+idLoXq6PZifjKI2iPOg5ryKFjWDaM8rSpAur4Auye5xSS305/B83a7XL7b6Tq6dDoqD+p5FB1PhzI9OWjngSb9yCS307/AM/Ls4PLdTtfRpdPR8SzQlyfjtAllenrQ9IGwf5KdZK50Y47tJmAeO/J3B8tP6XR0PAv05ck4bUKZvusgBfZPzphkJt2u12kdMI8dkz7V4ci+br7jyWB3zqr9lDJ910EM7MbpMPFPfcpb6RWYxw7XlzXMu1zAfJ2887jcArPZq/YTyuSVQ1wmd8b3vFfseB2dvo6nAjtwGEqrcgjzdfLO47RAeXCftYzSfepB9wCGy7DO2LlcsON1dPo6ngrsqLqUlvOVL1PlFs7jtEB5cM/0wGo/fyVVucL55cPAWTEK5WOZ7GGER3mzjjOFdbBxMD8bxlWP2iNOx7wbhVZ+6BYhzlv1hL7ryxnmYaBvOlNYBxsH87NhXPVkLYZpiuzL4/Dqg25Z9imv0xaYd75F9ma/0zLZm0d5dmFdOB1YDifDPGsyzBNT6TgO5sdx/KWygt3JTHUcRsezqHQE+1jGaROwB2eXOzrehY/4he/4j/pfLtgzOG/tFzgX9hrnzf0C59Je47y5X+Bc2it8f/8BHjRfo4CdeCYAAAAASUVORK5CYII="

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = "data:application/octet-stream;base64,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"

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQgAAABYCAQAAACjBqE3AAAB6klEQVR4Ae3bsWpUQRTG8YkkanwCa7GzVotsI/gEgk9h4Vu4ySLYmMYgbJrc3lrwZbJwC0FMt4j7F6Y4oIZrsXtgxvx/1c0ufEX4cnbmLCmSJEmSJEmSJEmSJP3XCBPvbJU+8doWmDFwyZpLBmYlNJebz0KwzykwsuSYJSNwykEJreV2BaBMaLIQZ2xYcFgqDlmw4ayE/FwL0dDk4Qh4W37DAjgqIT+3HRbigjH+iikVdxgZStgyN0Su2sXIeTwTT+esdpcbIlfNAuZ/TxresG4zV8kYWSZNiKUTokMMSWeIwTNEn4fK2TW3gRNgVkJLuVksROA9G+bEvoATNlBCa7nZXEwdxEZxzpKRKFh+bsv8LmPFmhX1OwfIz81jIRJQ5eeqG9B+riRJkiRJkiRJkiRJkiRJkiRJUkvA/8RQoEpKlJWINFkJ62AlrEP/mNBibnv2yz/A3t7Uq3LcpoxP8COjC1T5vxoAD5VdoEqdDrd5QuW1swtUSaueh3zkiuBiqgtA2OlkeMcP/uDqugsJdbjHF65VdPMKwS0+WQc/MgKvrIOHysB9vgPwk8+85hmPbnQdvHZyDMAFD7L3EOpgMcVdvnHFS0/vlatrXvCVx0U9gt3fxvnA0/hB4nmRJEmSJEmSJEmSJGmHfgFLaDPoMu5xWwAAAABJRU5ErkJggg=="

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhFAAUAPMIAIeHhz8/P1dXVycnJ8/Pz7e3t5+fn29vb////wAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFBwAIACwAAAAAFAAUAEAEUxDJSatFxtwaggWAdIyHJAhXoRYSQUhDPGx0TbmujahbXGWZWqdDAYEsp5NupLPkdDwE7oXwWVasimzWrAE1tKFHErQRK8eL8mMUlRBJVI307uoiACH5BAUHAAgALAEAAQASABIAAAROEMkpS6E4W5upMdUmEQT2feFIltMJYivbvhnZ3R0A4NMwIDodz+cL7nDEn5CH8DGZh8MtEMBEoxkqlXKVIgQCibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpjaE4W5spANUmFQX2feFIltMJYivbvhnZ3d1x4BNBIDodz+cL7nDEn5CH8DGZAsFtMMBEoxkqlXKVIgIBibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpAaA4W5vpOdUmGQb2feFIltMJYivbvhnZ3Z0g4FNRIDodz+cL7nDEn5CH8DGZgcCNQMBEoxkqlXKVIgYDibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpz6E4W5upENUmAQD2feFIltMJYivbvhnZ3V0Q4JNhIDodz+cL7nDEn5CH8DGZg8GtUMBEoxkqlXKVIggEibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkphaA4W5tpCNUmHQf2feFIltMJYivbvhnZ3d0w4BMAIDodz+cL7nDEn5CH8DGZBMLNYMBEoxkqlXKVIgoFibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpQ6A4W5vpGNUmCQL2feFIltMJYivbvhnZ3R1B4NNxIDodz+cL7nDEn5CH8DGZhcINAMBEoxkqlXKVIgwGibbK9YLBYvLtHH5K0J0IACH5BAUHAAcALAEAAQASABIAAANCeLo6wzA6FxkhbaoQ4L3ZxnXLh0EjWZ4RV71VUcCLIByyTNt2PsO8m452sBGJBsNxkUwuD03lAQBASqnUJ7aq5UYSADs="

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nutrena.fec81af.png";

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nutrenaklientportal.86be740.png";

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nutrenaklientportal2.573a62d.png";

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAAA3NCSVQICAjb4U/gAAAABlBMVEX///8AAABVwtN+AAAAAnRSTlMA/1uRIrUAAAAJcEhZcwAAAsQAAALEAVuRnQsAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDQvMTMvMTGrW0T6AAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M1cbXjNgAAAAxJREFUCJljaGBgAAABhACBrONIPgAAAABJRU5ErkJggg=="

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADAQMAAABs5if8AAAAA3NCSVQICAjb4U/gAAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlP/AOW3MEoAAAAJcEhZcwAACusAAArrAYKLDVoAAAAWdEVYdENyZWF0aW9uIFRpbWUAMjUvMDQvMTHvvlk6AAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M1cbXjNgAAAA5JREFUCJljSGB4wPAAAAVmAiGdUf+vAAAAAElFTkSuQmCC"

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAABAQMAAADO7O3JAAAAA3NCSVQICAjb4U/gAAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlP/AOW3MEoAAAAJcEhZcwAAAuwAAALsAe0ztPoAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDQvMTMvMTGrW0T6AAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M1cbXjNgAAAApJREFUCJljcAAAAEIAQZXpNDgAAAAASUVORK5CYII="

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACAQMAAACjTyRkAAAAA3NCSVQICAjb4U/gAAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlP/AOW3MEoAAAAJcEhZcwAAAuwAAALsAe0ztPoAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDQvMTMvMTGrW0T6AAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M1cbXjNgAAAAxJREFUCJljYGBoAAAAhACBnGjDJAAAAABJRU5ErkJggg=="

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADAQMAAABs5if8AAAAA3NCSVQICAjb4U/gAAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlP/AOW3MEoAAAAJcEhZcwAAAuwAAALsAe0ztPoAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDQvMTMvMTGrW0T6AAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M1cbXjNgAAAA5JREFUCJljSGBYwHAAAASGAcENz5GAAAAAAElFTkSuQmCC"

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAAA3NCSVQICAjb4U/gAAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlP/AOW3MEoAAAAJcEhZcwAAAuwAAALsAe0ztPoAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDQvMTMvMTGrW0T6AAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M1cbXjNgAAAAxJREFUCJljcGBoAAABRADBb2cx4AAAAABJRU5ErkJggg=="

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAEAQMAAACTPww9AAAAA3NCSVQICAjb4U/gAAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlP/AOW3MEoAAAAJcEhZcwAAAsQAAALEAVuRnQsAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDUvMDIvMTGI8AGbAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M1cbXjNgAAABBJREFUCJljuMCwgKGAYQEACsgCgf/CoqoAAAAASUVORK5CYII="

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADRJREFUeNpcjAEKADAIAtP//9nVmGATQvBSSqqWxvMI4BK7xaZ4FSzwh24yv3J2gZw9AgwAGZEj/RsjMkMAAAAASUVORK5CYII="

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACtJREFUeNpiZGBg+M9AAfgPBCACxO4ghc1Eia2MUGd3jjp71NnDzNkAAQYA9LOsNBe9wf8AAAAASUVORK5CYII="

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Thumbs.da9cb7a.db";

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Thumbs.a1c0559.db";

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bgi.6fabcb9.jpg";

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRkZGRkZGIiBoZWlnaHQ9IjM2IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIzNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xNS40MSAxNi4wOWwtNC41OC00LjU5IDQuNTgtNC41OUwxNCA1LjVsLTYgNiA2IDZ6Ii8+CiAgICA8cGF0aCBkPSJNMC0uNWgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPgo8L3N2Zz4="

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRkZGRkZGIiBoZWlnaHQ9IjM2IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIzNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik04LjU5IDE2LjM0bDQuNTgtNC41OS00LjU4LTQuNTlMMTAgNS43NWw2IDYtNiA2eiIvPgogICAgPHBhdGggZD0iTTAtLjI1aDI0djI0SDB6IiBmaWxsPSJub25lIi8+Cjwvc3ZnPg=="

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAAACCAYAAABmD1GAAAAAF0lEQVR42mNgGAWjYBSMglEwCkYB/QEAB4IAAcZ9XHIAAAAASUVORK5CYII="

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/weathericons-regular-webfont.2ca3df0.ttf";

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/weathericons-regular-webfont.f5b0d0d.woff";

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/FontAwesome.0d2717c.otf";

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),
/* 697 */,
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(707),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/node_modules/vuelation-affix/main.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] main.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2ead6946", Component.options)
  } else {
    hotAPI.reload("data-v-2ead6946", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal reactivatedxpnewmodal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.reactivate))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.reactivatedxpnewmodal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t          " + _vm._s(_vm.dxpnewcurrentName) + " ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dxpnewcurrentId),
      expression: "dxpnewcurrentId"
    }],
    staticClass: "form-control col-lg-12 col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "id": "message-text",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.dxpnewcurrentId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dxpnewcurrentId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendNewDxpReInvite($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.reactivatedxpnewmodal')
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal adminErrorModal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n            Error\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.adminErrorModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("\n\t\t        " + _vm._s(_vm.errorAdminMsg) + "\n\t\t      ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.adminErrorModalClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationOk))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal resetpwdemodal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.resetpwd))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.resetSuccess),
      expression: "!resetSuccess"
    }],
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.wanttoreset) + " ")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resetSuccess),
      expression: "resetSuccess"
    }],
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.resetSuccessMsg))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentId),
      expression: "currentId"
    }],
    staticClass: "form-control col-lg-12 col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "id": "message-text",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.currentId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.resetSuccess),
      expression: "!resetSuccess"
    }],
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetPassword($event)
      }
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.resetSuccess),
      expression: "!resetSuccess"
    }],
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.no))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resetSuccess),
      expression: "resetSuccess"
    }],
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.close))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal reactivatemodal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.reactivate))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.reactivatemodal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.wanttoreactivate) + " ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentId),
      expression: "currentId"
    }],
    staticClass: "form-control col-lg-12 col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "id": "message-text",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.currentId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendReInvite($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.reactivatemodal')
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal dxpmodal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.user_lang.activationTitle) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.dxpmodal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t        " + _vm._s(_vm.user_lang.activationDescription) + " ")])]), _vm._v(" "), _vm._l((_vm.dxpList), function(data) {
    return _c('div', {
      staticStyle: {
        "margin-right": "233px",
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "activation"
      },
      domProps: {
        "value": data.id
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data.id
      }
    }, [_vm._v(" " + _vm._s(data.label) + " " + _vm._s(_vm.user_lang.template))])])
  }), _vm._v(" "), _vm._l((_vm.nonDxpList), function(data, index) {
    return (index === 0) ? _c('div', {
      staticStyle: {
        "margin-right": "233px",
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "activation",
        "checked": "checked"
      },
      domProps: {
        "value": 0
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data.id
      }
    }, [_vm._v(_vm._s(_vm.user_lang.cargillActivation))])]) : _vm._e()
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentId),
      expression: "currentId"
    }],
    staticClass: "form-control col-lg-12 col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "id": "message-text",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.currentId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendDxpReInvite($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationOk))])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal newdxpmodal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.user_lang.activationTitle) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.newdxpmodal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t        " + _vm._s(_vm.user_lang.activationDescription) + " ")])]), _vm._v(" "), _vm._l((_vm.dxpList), function(data) {
    return _c('div', {
      staticStyle: {
        "margin-right": "233px",
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "activation"
      },
      domProps: {
        "value": data.id
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data.id
      }
    }, [_vm._v(" " + _vm._s(data.label) + " " + _vm._s(_vm.user_lang.template))])])
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendDxpReInvite($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationOk))])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal permissiondeniedreset",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('button', {
    staticClass: "close",
    staticStyle: {
      "text-align": "right",
      "margin": "10px 20px 0px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.permissiondeniedreset) + " ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal permissiondeniedmodal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('button', {
    staticClass: "close",
    staticStyle: {
      "text-align": "right",
      "margin": "10px 20px 0px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.permissiondenied) + " ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal nonanoktausermodal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('button', {
    staticClass: "close",
    staticStyle: {
      "text-align": "right",
      "margin": "10px 20px 0px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.nonanoktauser) + " ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal ativateanddeactivaeemodal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.requestType === 'deleteoktauser' ? _vm.user_lang.delete : _vm.statusCode == 0 ? _vm.user_lang.activateDeactivate.split('/')[0] : _vm.user_lang.activateDeactivate.split('/')[1]))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusCode == 0),
      expression: "statusCode==0"
    }],
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.user_lang.wanttoactivate))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusCode == 1),
      expression: "statusCode==1"
    }],
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.requestType === 'deleteoktauser' ? _vm.user_lang.wanttodelete : _vm.user_lang.wanttodeactivate))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusCode),
      expression: "statusCode"
    }],
    staticClass: "form-control col-lg-12 col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "id": "message-text",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.statusCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.statusCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentemailId),
      expression: "currentemailId"
    }],
    staticClass: "form-control col-lg-12 col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "id": "message-text",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.currentemailId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentemailId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deactivateUser($event)
      }
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalCount !== '' && !_vm.groupDeleted),
      expression: "totalCount !== '' && !groupDeleted"
    }],
    staticClass: "showingnusers",
    class: {
      'v-hidden': _vm.showfloatingcount
    },
    staticStyle: {
      "padding-top": "10px",
      "text-align": "center",
      "font-size": "14px",
      "background": "#fff",
      "margin": "0px -15px"
    }
  }, [_vm._v("\n\t" + _vm._s(_vm.user_lang.showing) + " 1 - " + _vm._s(_vm.rows.length) + " " + _vm._s(_vm.user_lang.of) + " " + _vm._s(_vm.totalCount) + " " + _vm._s(_vm.user_lang.userword))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalCount !== ''),
      expression: "totalCount !== ''"
    }],
    staticClass: "outOfView",
    class: {
      'v-hidden': !_vm.showfloatingcount
    },
    staticStyle: {
      "padding-top": "10px",
      "text-align": "center",
      "font-size": "14px",
      "background": "#fff",
      "margin": "0px -15px"
    }
  }, [_vm._v("\n\t" + _vm._s(_vm.user_lang.showing) + " 1 - " + _vm._s(_vm.rows.length) + " " + _vm._s(_vm.user_lang.of) + " " + _vm._s(_vm.totalCount) + " " + _vm._s(_vm.user_lang.userword))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMoreString !== undefined && _vm.showMoreString !== ''),
      expression: "showMoreString !== undefined && showMoreString !== ''"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), (_vm.groupDeleted) ? _c('div', {
    staticClass: "no-group"
  }, [_vm._v(_vm._s(_vm.user_lang.groupUnavailable))]) : _vm._e(), _vm._v(" "), _c('vue-good-table', {
    attrs: {
      "id": "table",
      "columns": _vm.columns,
      "rows": _vm.rows,
      "paginate": false,
      "paginateOnTop": true,
      "lineNumbers": false,
      "responsive": true,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: '_embedded.user.profile.updatelink',
          type: 'asc'
        }
      }
    }
  }, [_c('div', {
    staticClass: "no-data",
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n    " + _vm._s(_vm.user_lang.noTableData) + "\n  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMoreString !== undefined && _vm.showMoreString !== ''),
      expression: "showMoreString !== undefined && showMoreString !== ''"
    }],
    staticStyle: {
      "text-align": "center",
      "height": "65px"
    }
  }, [_c('button', {
    staticClass: "btn",
    class: {
      disabled: _vm.loading
    },
    staticStyle: {
      "color": "#fff",
      "height": "35px",
      "padding": "0px 20px",
      "background": "#ccc"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.showMore()
      }
    }
  }, [_vm._v("\n" + _vm._s(_vm.user_lang.showmore) + " ")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-01537783", module.exports)
  }
}

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ApplicationBrandBar'), _vm._v(" "), (_vm.badbrowser) ? _c('div', {
    staticClass: "modal modal-message modal-warning fade",
    attrs: {
      "id": "exampleModalLong",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLongTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content "
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.ieNotSupported))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.user_lang.attention))]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n           " + _vm._s(_vm.user_lang.tryChrome) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.close))])])])])]) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('ApplicationFooter'), _vm._v(" "), _c('SessionTimeout')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-016d20ce", module.exports)
  }
}

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal dxpNewmodal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.activationTemplateTitle) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.dxpNewmodal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.activationTemplateDescription) + "\n                ")])]), _vm._v(" "), _vm._l((_vm.dxpList), function(data, ind) {
    return _c('div', {
      key: ind,
      staticStyle: {
        "margin-right": "233px",
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "activation"
      },
      domProps: {
        "value": data.id
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data.id
      }
    }, [_vm._v(" " + _vm._s(data.label) + " " + _vm._s(_vm.user_lang.template))])])
  }), _vm._v(" "), _vm._l((_vm.nonDxpList), function(data, ind) {
    return _c('div', {
      key: ind,
      staticStyle: {
        "margin-right": "233px",
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "activation",
        "checked": "checked"
      },
      domProps: {
        "value": 0
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data.id
      }
    }, [_vm._v(_vm._s(_vm.user_lang.cargillActivation))])])
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendDxpNewInvite($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationOk))])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal newdxpmodal1",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.activationTitle) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.newdxpmodal1')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.activationDescription) + "\n                ")])]), _vm._v(" "), _vm._l((_vm.dxpList), function(data, ind) {
    return _c('div', {
      key: ind,
      staticStyle: {
        "margin-right": "233px",
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "activation"
      },
      domProps: {
        "value": data.id
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data.id
      }
    }, [_vm._v(" " + _vm._s(data.label) + " " + _vm._s(_vm.user_lang.template))])])
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendDxpNewInvite($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationOk))])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal mfaresetmodal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.mfaResetModalTitle) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.mfaresetmodal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(!_vm.isAuthorizedForMFA) ? _c('div', {
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.errorMsgForMFA))]) : _vm._e(), _vm._v(" "), (_vm.mfaResetSuccess) ? _c('div', {
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.factorResetSuccess))]) : _vm._e(), _vm._v(" "), (_vm.isAuthorizedForMFA && !_vm.mfaResetSuccess) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.user_lang.resetConfirmation) + "\n                  ")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetMFA($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.mfaresetmodal')
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "0px",
      "padding-top": "35px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal bulkReinviteMessageModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "top": "100px"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "bulk-upload-header",
    staticStyle: {
      "float": "left",
      "padding": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  Bulk Reinvite Message\n                  "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "text-align": "right",
      "color": "#fff"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n                  " + _vm._s(_vm.reInviteMessage) + "\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal bulkUploadOptionsModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "top": "100px"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "bulk-upload-header",
    staticStyle: {
      "float": "left",
      "padding": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.bulkUploadOptionsLabel) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 20px 5px"
    }
  }, [_c('div', {
    staticClass: "checkboxgroup"
  }, [_c('input', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "name": "bulkUpload",
      "id": "bulkCreate"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding-left": "7px",
      "font-weight": "normal"
    },
    attrs: {
      "for": "bulkCreate"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.bulkCreateUsers))])]), _vm._v(" "), _c('div', {
    staticClass: "checkboxgroup"
  }, [_c('input', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "name": "bulkUpload",
      "id": "bulkReinvite"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding-left": "7px",
      "font-weight": "normal"
    },
    attrs: {
      "for": "bulkReinvite"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.bulkReinviteUsers))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary adduser-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openbulkModals()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.confirm))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary adduser-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.bulkUploadOptionsModal');
        _vm.clearSelectedOptions();
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.user_lang.cancel) + "\n                    ")])]), _vm._v(" "), (_vm.optionsNotSelected) ? _c('div', {
    staticStyle: {
      "color": "#ff0000",
      "padding": "10px 20px 5px"
    }
  }, [_vm._v("Please select an option to proceed.")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal bulkReinviteModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "top": "100px"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "bulk-upload-header",
    staticStyle: {
      "float": "left",
      "padding": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.bulkReinviteUsers) + "\n                  "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "text-align": "right",
      "color": "#fff"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.clearSelectedOptions()
      }
    }
  }, [_vm._v("\n                    ×\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.user_lang.downloadExcelTemplate) + "\n                    "), _c('a', {
    attrs: {
      "href": "../../static/Reinvite_template.xlsx",
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "25px",
      "margin-left": "10px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "15px",
      "color": "#000",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.uploadInstruction))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0px 0px 10px 20px"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningOne))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningTwo))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningThree))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.user_lang.note))]), _vm._v(" " + _vm._s(_vm.user_lang.uploadNote) + "\n                    ")])]), _vm._v(" "), (_vm.adminType === 'admin' || _vm.adminType === 'superadmin') ? _c('div', {
    staticStyle: {
      "font-size": "14px",
      "padding-right": "30px",
      "background": "#eceff1",
      "padding": "12px 15px",
      "vertical-align": "-webkit-baseline-middle"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.user_lang.bulkReinviteUsers) + ":\n                    "), (_vm.uploadReady) ? _c('input', {
    ref: "reinviteFile",
    staticStyle: {
      "border": "none !important",
      "padding": "0px !important",
      "color": "#000 !important",
      "width": "220px",
      "background": "transparent !important"
    },
    attrs: {
      "type": "file",
      "id": "reinviteFile"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload(true)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    class: {
      disabled: !_vm.isExcel
    },
    staticStyle: {
      "padding": "5px 10px",
      "font-size": "14px !important",
      "font-weight": "bold"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submitFile(true)
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.user_lang.uploadLabel) + "\n                    ")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal bulkCreateModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "top": "100px"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "bulk-upload-header",
    staticStyle: {
      "float": "left",
      "padding": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.bulkCreateUsers) + "\n                  "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "text-align": "right",
      "color": "#fff"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.clearSelectedOptions()
      }
    }
  }, [_vm._v("\n                    ×\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.user_lang.downloadExcelTemplate) + "\n                    "), _c('a', {
    attrs: {
      "href": "../../static/template.xlsx",
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "25px",
      "margin-left": "10px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "15px",
      "color": "#000",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.uploadInstruction))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0px 0px 10px 20px"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningOne))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningFour))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningFive))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningSix))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.user_lang.note))]), _vm._v(" " + _vm._s(_vm.user_lang.uploadNote) + "\n                    ")])]), _vm._v(" "), (_vm.adminType === 'admin' || _vm.adminType === 'superadmin') ? _c('div', {
    staticStyle: {
      "font-size": "14px",
      "padding-right": "30px",
      "background": "#eceff1",
      "padding": "12px 15px",
      "vertical-align": "-webkit-baseline-middle"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.user_lang.bulkCreateUsers) + ":\n                    "), (_vm.uploadReady) ? _c('input', {
    ref: "file",
    staticStyle: {
      "border": "none !important",
      "padding": "0px !important",
      "color": "#000 !important",
      "width": "220px",
      "background": "transparent !important"
    },
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    class: {
      disabled: !_vm.isExcel
    },
    staticStyle: {
      "padding": "5px 10px",
      "font-size": "14px !important",
      "font-weight": "bold"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submitFile(false)
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.user_lang.uploadLabel) + "\n                    ")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow || _vm.updateToggle),
      expression: "isShow || updateToggle"
    }],
    staticStyle: {
      "margin": "-15px"
    }
  }, [_c('div', {
    staticClass: "bc-adduser"
  }, [_c('span', {
    staticClass: "bc-nav",
    on: {
      "click": function($event) {
        _vm.goToUserManagement()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.userAdministration))]), _vm._v("  /  "), _c('span', [_vm._v(" " + _vm._s(_vm.updateToggle ? _vm.user_lang.edituser : _vm.user_lang.adduser))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "44px !important",
      "font-weight": "bold",
      "overflow": "auto",
      "margin-bottom": "15px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.updateToggle ? _vm.user_lang.edituser : _vm.user_lang.adduser))])]), _vm._v(" "), _vm._l((_vm.addUserValidations), function(i, ind) {
    return _c('div', {
      key: ind,
      staticClass: "error-bg usercreateinfo",
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "id": "formValidation"
      }
    }, [_c('div', [_c('i', {
      staticClass: "fa fa-close",
      staticStyle: {
        "float": "right",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.addUserValidations = []
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "margin": "5px 5px"
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      staticStyle: {
        "font-size": "25px"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(i))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "background": "#f1f1f1 !important",
      "margin-bottom": "10px",
      "padding": "18px 18px"
    }
  }, [_c('div', {
    staticClass: "user-creds"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.first_name) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserFirstName),
      expression: "addUserFirstName"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.isNameEditable && _vm.updateToggle
    },
    attrs: {
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.addUserFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserFirstName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.last_name) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserLastName),
      expression: "addUserLastName"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.isNameEditable && _vm.updateToggle
    },
    attrs: {
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.addUserLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserLastName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.primary_mail) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserPrimaryEmail),
      expression: "addUserPrimaryEmail"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: _vm.updateToggle
    },
    attrs: {
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.addUserPrimaryEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserPrimaryEmail = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.secondary_mail) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserSecondaryEmail),
      expression: "addUserSecondaryEmail"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: _vm.noEditForWhitelabel
    },
    attrs: {
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.addUserSecondaryEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserSecondaryEmail = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    class: {
      disabled: _vm.updateToggle
    }
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectLang) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prefLang),
      expression: "prefLang"
    }],
    staticClass: "preflang",
    staticStyle: {
      "height": "39px"
    },
    attrs: {
      "id": "message-text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.prefLang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.lang_def), function(i, ind) {
    return _c('option', {
      key: ind,
      domProps: {
        "value": i.langCode
      }
    }, [_vm._v(_vm._s(i.langName))])
  }))])])]), _vm._v(" "), (_vm.showTransformedEmail) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("Transformed Email:")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailTransformed),
      expression: "emailTransformed"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: _vm.updateToggle
    },
    attrs: {
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.emailTransformed)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailTransformed = $event.target.value
      }
    }
  })])])]) : _vm._e()])]), _vm._v(" "), (_vm.isEdit) ? _c('div', {
    staticClass: "user-creds",
    staticStyle: {
      "padding-bottom": "7px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "5px 15px 0px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "15px",
      "width": "100%"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.viewMoreInfo))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.infoContent,
      "data-original-title": _vm.user_lang.infoContent
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "padding": "3px 10px",
      "font-size": "20px",
      "cursor": "pointer"
    },
    attrs: {
      "id": "toggle-arrow"
    },
    on: {
      "click": _vm.toggleDateFields
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "none"
    },
    attrs: {
      "id": "toggle-data"
    }
  }, [_c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.createdDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.createdDateDescription,
      "data-original-title": _vm.user_lang.createdDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.createdDate))])]), _vm._v(" "), _c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.activatedDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.activatedDateDescription,
      "data-original-title": _vm.user_lang.activatedDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.activatedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.lastLoginDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.lastLoginDateDescription,
      "data-original-title": _vm.user_lang.lastLoginDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.lastLogin))])]), _vm._v(" "), _c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.lastUpdatedDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.lastUpdatedDateDescription,
      "data-original-title": _vm.user_lang.lastUpdatedDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.lastUpdated))])]), _vm._v(" "), _c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.passwordChangedDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.passwordChangedDateDescription,
      "data-original-title": _vm.user_lang.passwordChangedDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.passwordChanged))])]), _vm._v(" "), _c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.statusChangedDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.statusChangedDateDescription,
      "data-original-title": _vm.user_lang.statusChangedDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.statusChanged))])])])])]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('div', {
    staticClass: "user-creds",
    staticStyle: {
      "padding-bottom": "7px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "5px 15px 0px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "15px",
      "width": "100%"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.resetMFATitle))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "padding": "3px 10px",
      "font-size": "20px",
      "cursor": "pointer"
    },
    attrs: {
      "id": "toggle-mfa-arrow"
    },
    on: {
      "click": _vm.toggleMFAField
    }
  })]), _vm._v(" "), (_vm.userFactorList.length === 0) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "none",
      "padding": "5px"
    },
    attrs: {
      "id": "toggle-mfa-data"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.user_lang.noFactorExist) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.userFactorList.length > 0) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "none",
      "padding": "5px"
    },
    attrs: {
      "id": "toggle-mfa-data"
    }
  }, [_vm._l((_vm.userFactorList), function(factor) {
    return _c('div', {
      key: factor.id,
      staticClass: "mfa-list"
    }, [_c('div', {
      staticClass: "checkboxgroup"
    }, [_c('input', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "type": "radio",
        "name": "mfaReset",
        "id": factor.id
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "padding-left": "7px",
        "font-weight": "normal"
      },
      attrs: {
        "for": factor.id
      }
    }, [_vm._v(_vm._s(factor.factorType.indexOf("token:software:totp") > -1 ? _vm.transformText(factor.provider) : _vm.transformText(factor.factorType)))])])])
  }), _vm._v(" "), (_vm.noFactorSelected) ? _c('div', {
    staticClass: "validation-mfa"
  }, [_vm._v(_vm._s(_vm.user_lang.mfaValidation))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mfa-btn",
    on: {
      "click": _vm.checkAccess
    }
  }, [_vm._v(_vm._s(_vm.user_lang.resetButton))])], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "user-creds"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang["assignApplication"]))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('div', {
    attrs: {
      "id": "dropdown"
    }
  }, [_c('div', {
    staticClass: "selectDropDown",
    on: {
      "click": function($event) {
        _vm.showDropDown = !_vm.showDropDown
      }
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang["selectgroups"])), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "float": "right",
      "margin": "4px 5px"
    }
  })])]), _vm._v(" "), _vm._l((_vm.adminToBrands), function(n, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          _vm.showDropDown &&
          (_vm.appUrl.indexOf('identity-dev') > -1 ||
            _vm.appUrl.indexOf('cargill') > -1 ||
            (n.toLowerCase() !== 'cargill' && _vm.appUrl.indexOf(n.toLowerCase().replace('portal', '')) > -1) ||
            _vm.appUrl.indexOf('localhost') > -1)
        ),
        expression: "\n                            showDropDown &&\n                            (appUrl.indexOf('identity-dev') > -1 ||\n                              appUrl.indexOf('cargill') > -1 ||\n                              (n.toLowerCase() !== 'cargill' && appUrl.indexOf(n.toLowerCase().replace('portal', '')) > -1) ||\n                              appUrl.indexOf('localhost') > -1)\n                          "
      }],
      key: index,
      class: {
        disabled: _vm.checkedAppBrand !== '' && n.toLowerCase() !== _vm.checkedAppBrand.toLowerCase()
      }
    }, [_c('span', {
      staticClass: "admintobrand"
    }, [_vm._v(_vm._s(n))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showDropDown),
        expression: "showDropDown"
      }],
      attrs: {
        "id": "checkboxlist"
      }
    }, _vm._l((_vm.uniqueAppsFiltered), function(app, index) {
      return _c('div', {
        key: index,
        staticClass: "dd-list-item",
        staticStyle: {
          "padding-right": "15px",
          "padding-left": "5px"
        }
      }, [(n === app.brand) ? _c('div', [_c('input', {
        staticClass: "form-control input-checkbx",
        attrs: {
          "type": "checkbox",
          "id": app.appGrpId
        },
        domProps: {
          "value": app.groupId + '-' + app.adminGroupName
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "vertical-align": "super",
          "display": "inline"
        },
        attrs: {
          "for": app.appGrpId
        }
      }, [_vm._v(_vm._s(app.applicationName) + "\n                                  ")])]) : _vm._e()])
    }))])
  })], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.brand !== ''),
      expression: "brand !== ''"
    }],
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectedBrand) + " ")]), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.brand))])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang["availablegroups"]) + ":")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, _vm._l((_vm.availablegroups), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "group-div",
      class: {
        disabled: i.isReadOnly, bb0: index !== _vm.availablegroups.length - 1
      }
    }, [_c('div', {
      staticStyle: {
        "pointer-events": "auto",
        "cursor": "default"
      },
      attrs: {
        "data-toggle": i.isReadOnly ? 'tooltip' : false,
        "title": _vm.disableAvailableGroups(i.isReadOnly),
        "data-original-title": _vm.disableAvailableGroups(i.isReadOnly)
      }
    }, [_c('div', {
      staticClass: "group-name"
    }, [_vm._v(_vm._s(i.subGroupName))]), _vm._v(" "), (!i.isReadOnly) ? _c('i', {
      staticClass: "fa fa-plus-circle add-group",
      on: {
        "click": function($event) {
          _vm.addToSelectedGroup(i.subGroupId)
        }
      }
    }) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.availableIndependentGroups))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, _vm._l((_vm.indieGroupsForNewUser), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "group-div",
      class: {
        disabled: i.isReadOnly
      }
    }, [_c('div', {
      staticStyle: {
        "pointer-events": "auto",
        "cursor": "default"
      },
      attrs: {
        "data-toggle": i.isReadOnly ? 'tooltip' : false,
        "title": _vm.disableAvailableGroups(i.isReadOnly),
        "data-original-title": _vm.disableAvailableGroups(i.isReadOnly)
      }
    }, [_c('div', {
      staticClass: "group-name"
    }, [_vm._v(_vm._s(i.subGroupId.split("~~~")[1]))]), _vm._v(" "), (!i.isReadOnly) ? _c('i', {
      staticClass: "fa fa-plus-circle add-group",
      on: {
        "click": function($event) {
          _vm.addToSelectedIndieGroup(i.subGroupId.split('~~~')[0])
        }
      }
    }) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang["selectedgroups"]))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._l((_vm.uniqueAppsFiltered), function(x) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isChildren(x.applicationId)),
        expression: "isChildren(x.applicationId)"
      }],
      key: x.appGrpId,
      staticClass: "dd-list-item",
      staticStyle: {
        "padding-right": "15px",
        "padding-left": "5px",
        "display": "block",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                        " + _vm._s(x.applicationName) + "\n                        "), _vm._l((_vm.selectedgroups), function(i, index) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (x.applicationId === i.applicationId),
          expression: "x.applicationId === i.applicationId"
        }],
        key: index,
        staticClass: "group-div",
        class: {
          disabled: i.isReadOnly || !_vm.checkSubGroupAllowed(i.subGroupId), bb0: index !== _vm.selectedgroups.length - 1
        },
        staticStyle: {
          "font-weight": "normal"
        }
      }, [_c('div', {
        staticStyle: {
          "pointer-events": "auto",
          "cursor": "default"
        },
        attrs: {
          "data-toggle": i.isReadOnly || !_vm.checkSubGroupAllowed(i.subGroupId) ? 'tooltip' : false,
          "title": _vm.disableSelectedGroups(i.isReadOnly, i.subGroupId),
          "data-original-title": _vm.disableSelectedGroups(i.isReadOnly, i.subGroupId)
        }
      }, [_c('div', {
        staticClass: "group-name"
      }, [_vm._v(_vm._s(i.subGroupName))]), _vm._v(" "), (!i.isReadOnly && _vm.checkSubGroupAllowed(i.subGroupId)) ? _c('i', {
        staticClass: "fa fa-minus-circle remove-group",
        on: {
          "click": function($event) {
            _vm.removeFromSelectedGroup(i.subGroupId)
          }
        }
      }) : _vm._e()])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "dd-list-item",
    staticStyle: {
      "padding-right": "15px",
      "padding-left": "5px",
      "display": "block",
      "font-weight": "bold"
    }
  }, _vm._l((_vm.selectedIndiegroups), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "group-div",
      class: {
        disabled: !_vm.checkSubGroupAllowed(i.subGroupId), bb0: index !== _vm.selectedIndiegroups.length - 1
      },
      staticStyle: {
        "font-weight": "normal"
      }
    }, [_c('div', {
      staticStyle: {
        "pointer-events": "auto",
        "cursor": "default"
      },
      attrs: {
        "data-toggle": !_vm.checkSubGroupAllowed(i.subGroupId) ? 'tooltip' : false,
        "title": _vm.disableSelectedIndieGroups(i.subGroupId),
        "data-original-title": _vm.disableSelectedIndieGroups(i.subGroupId)
      }
    }, [_c('div', {
      staticClass: "group-name"
    }, [_vm._v(_vm._s(i.subGroupId.split("~~~")[1]))]), _vm._v(" "), (_vm.checkSubGroupAllowed(i.subGroupId)) ? _c('i', {
      staticClass: "fa fa-minus-circle remove-group",
      on: {
        "click": function($event) {
          _vm.removeFromSelectedIndieGroup(i.subGroupId, 'indie')
        }
      }
    }) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "padding": "0px 15px 0px 5px"
    }
  }, _vm._l((_vm.selectedGroupsOutsideAdmin), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "group-div",
      class: {
        disabled: !_vm.checkSubGroupAllowed(i.subGroupId),
          bb0: index !== _vm.selectedGroupsOutsideAdmin.length - 1
      },
      staticStyle: {
        "font-weight": "normal"
      }
    }, [(i.subGroupId != _vm.onecargillusersgroupid && i.subGroupId != _vm.onecargilladmingroupid) ? _c('div', [_c('div', {
      staticStyle: {
        "pointer-events": "auto",
        "cursor": "default"
      },
      attrs: {
        "data-toggle": !_vm.checkSubGroupAllowed(i.subGroupId) ? 'tooltip' : false,
        "title": _vm.disableSelectedGroupsOutsideAdmin(i.subGroupId),
        "data-original-title": _vm.disableSelectedGroupsOutsideAdmin(i.subGroupId)
      }
    }, [_c('div', {
      staticClass: "group-name"
    }, [_vm._v(_vm._s(i.subGroupName))]), _vm._v(" "), (_vm.checkSubGroupAllowed(i.subGroupId)) ? _c('i', {
      staticClass: "fa fa-minus-circle remove-group",
      on: {
        "click": function($event) {
          _vm.removeFromSelectedIndieGroup(i.subGroupId)
        }
      }
    }) : _vm._e()])]) : _vm._e()])
  }))], 2)])])]), _vm._v(" "), (_vm.isGroupDeleted) ? _c('div', {
    staticClass: "no-group-error"
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.groupCannotBeAssigned) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userAlreadyExists),
      expression: "userAlreadyExists"
    }],
    staticStyle: {
      "margin-top": "10px",
      "cursor": "pointer",
      "text-decoration": "underline",
      "color": "#444444",
      "font-weight": "bold"
    },
    on: {
      "click": function($event) {
        _vm.goToExistingUser()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.viewuser) + "\n              ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary create-btn",
    class: {
      disabled: _vm.addUserPrimaryEmail === _vm.loggedInUser && _vm.updateToggle
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.updateToggle ? _vm.updateUser() : _vm.displayActivateModal()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.updateToggle ? _vm.user_lang.update : _vm.user_lang.inviteuser) + "\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "cancel-btn",
    on: {
      "click": function($event) {
        _vm.goToUserManagement()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.cancel))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShow && !_vm.updateToggle),
      expression: "!isShow && !updateToggle"
    }]
  }, [_c('div', {
    staticClass: "bc"
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.userAdministration))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "44px !important",
      "font-weight": "bold",
      "overflow": "auto",
      "margin-bottom": "20px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.userAdministration))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-5px"
    }
  }, [(
    _vm.hostName.toLowerCase() === 'localhost:8080' ||
    _vm.hostName.toLowerCase() === 'cargillcustomer.dev.dev-cglcloud.com' ||
    _vm.hostName.toLowerCase() === 'cargillcustomer.stage.cglcloud.in' ||
    _vm.hostName.toLowerCase() === 'cargillcustomer-deprecated.stage.cglcloud.in' ||
    _vm.hostName.toLowerCase() === 'identityservices.stage.mycargill.com' ||
    _vm.hostName.toLowerCase() === 'identityservices-deprecated.stage.mycargill.com' ||
    _vm.hostName.toLowerCase().indexOf('identity.mycargill') !== -1
  ) ? _c('button', {
    staticClass: "btn btn-primary adduser-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showBulkUploadWindow(), _vm.clearAddUserFields(), _vm.removeAllNotifications()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.bulkUploadLabel) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary adduser-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        (_vm.isShow = !_vm.isShow), (_vm.updateToggle = false), _vm.clearAddUserFields(), _vm.removeAllNotifications()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.adduser) + "\n                ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userCreationMessage == _vm.user_lang['usercreated']),
      expression: "userCreationMessage == user_lang['usercreated']"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "userCreationMessage"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.userCreationMessage = ''
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.emailsenttouser) + " " + _vm._s(_vm.addUserFirstName) + " " + _vm._s(_vm.addUserLastName) + "\n                "), _c('div', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.pendingactivation))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resetSuccess),
      expression: "resetSuccess"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.resetSuccess = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.resetsuccesspopupmsg))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activateSuccess),
      expression: "activateSuccess"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.activateSuccess = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.activatesuccess) + " " + _vm._s(_vm.reverseTransformEmail(_vm.activatedemail)) + "\n              ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.updatesuccess),
      expression: "updatesuccess"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.updatesuccess = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.updatesuccess))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deactivateSuccess),
      expression: "deactivateSuccess"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.deactivateSuccess = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.reverseTransformEmail(_vm.activatedemail)) + " " + _vm._s(_vm.user_lang.deactivatesuccess) + "\n              ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteSuccess),
      expression: "deleteSuccess"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.deleteSuccess = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.reverseTransformEmail(_vm.activatedemail)) + " " + _vm._s(_vm.user_lang.deletesuccess) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12",
    class: {
      disabled: _vm.globalsearch
    }
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.filteruser))]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAppId),
      expression: "selectedAppId"
    }],
    staticClass: "dropdown-style",
    attrs: {
      "id": "selectApp"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAppId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.filterApp]
    }
  }, _vm._l((_vm.uniqueAppsFiltered), function(app) {
    return _c('option', {
      key: app.appGrpId,
      attrs: {
        "id": app.appGrpId
      },
      domProps: {
        "value": app.applicationId
      }
    }, [_vm._v("\n                        " + _vm._s(app.applicationName) + "\n                      ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12",
    class: {
      disabled: _vm.globalsearch
    }
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.filterusergrp))]), _vm._v(" "), _c('span', {
    staticClass: "report-link",
    on: {
      "click": function($event) {
        _vm.resetTotalCount();
        _vm.downloadUsersOfGroupRecursively();
      }
    }
  }, [_c('progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }],
    staticStyle: {
      "width": "100px",
      "height": "7px"
    },
    attrs: {
      "id": "file",
      "max": _vm.reportTotalCount
    },
    domProps: {
      "value": _vm.downloadReportSet.length
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }],
    staticStyle: {
      "font-size": "16px",
      "color": "#000",
      "margin-right": "10px",
      "margin-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.reportTotalCount ? ((_vm.downloadReportSet.length / _vm.reportTotalCount) * 100).toFixed(0) : "0") + "%")]), _vm._v(_vm._s(_vm.user_lang.reportLabel) + "\n                    "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "16px"
    },
    attrs: {
      "data-v-04fb9444": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedGroupId),
      expression: "selectedGroupId"
    }],
    staticClass: "dropdown-style",
    attrs: {
      "id": "grpdd"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedGroupId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.filterGroup]
    }
  }, _vm._l((_vm.subGroups), function(group) {
    return _c('option', {
      key: group.subGroupId,
      domProps: {
        "value": group.subGroupId
      }
    }, [_vm._v(_vm._s(group.subGroupName))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.search))]), _vm._v(" "), _c('label', {
    staticClass: "form-control-label",
    staticStyle: {
      "float": "right",
      "min-width": "0px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.globalsearch))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalsearch),
      expression: "globalsearch"
    }],
    staticClass: "gsearch",
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.globalsearch) ? _vm._i(_vm.globalsearch, null) > -1 : (_vm.globalsearch)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.globalsearch,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.globalsearch = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.globalsearch = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.globalsearch = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary search-icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.globalsearch),
      expression: "!globalsearch"
    }],
    staticClass: "searchinfotext"
  }, [_vm._v(_vm._s(_vm.user_lang.searchinfotext))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-left": "0px !important",
      "margin-top": "0px",
      "margin-bottom": "0px !important",
      "width": "100% !important"
    },
    attrs: {
      "type": "text",
      "id": "searchId"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row tableContainer",
    staticStyle: {
      "margin-top": "0",
      "border": "0",
      "background": "#eceff1"
    }
  }, [_c('div', {
    staticClass: "card-block1"
  }, [_c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "search",
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "search-bar-wrapper"
  }, [_c('div')])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('UserTable', {
    attrs: {
      "adminAppsArray": _vm.adminAppsArray,
      "filterAppId": _vm.selectedAppId,
      "filterGroupId": _vm.selectedGroupId,
      "usercreated": _vm.userCreationMessage,
      "searchTerm": _vm.searchTerm,
      "globalsearch": _vm.globalsearch,
      "adminTo": _vm.adminTo
    }
  })], 1)])])])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-04fb9444", module.exports)
  }
}

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('NoTopNavFooter'), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#ECECEC"
    },
    attrs: {
      "id": "login-background"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), (_vm.accessDenied) ? _c('div', {
    staticClass: "clogindiv",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(217, 57, 52)",
      "font-size": "14px",
      "padding": "20px 30px",
      "margin-top": "90px",
      "opacity": "0.95"
    }
  }, [(_vm.isMMApp) ? _c('div', [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "48px"
    }
  }, [_vm._v("400")]), _vm._v(" "), _c('div', {
    staticClass: "bad-request-title"
  }, [_vm._v("Bad Request")])]) : _vm._e(), _vm._v(" "), (!_vm.isMMApp) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px",
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.customErrorMsg) + " ")]), _vm._v(" "), (_vm.customContact.length > 0) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "font-size": "18px",
      "color": "#000"
    }
  }, [_vm._v(" Please "), _c('a', {
    attrs: {
      "href": ("mailto:" + _vm.customContact)
    }
  }, [_vm._v("contact us")]), _vm._v(" for further Assistance / Support. ")]) : _vm._e()]) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border": "1px solid #ddd",
      "border-radius": "3px",
      "height": "45px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "float": "left",
      "height": "100%",
      "background": "rgb(217,57,52)",
      "color": "#fff",
      "padding": "7px 3px 10px 7px",
      "border-top-left-radius": "3px",
      "border-bottom-left-radius": "3px"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    staticStyle: {
      "margin-right": "5px",
      "padding-top": "7px",
      "font-size": "16px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "error-title"
  }, [_vm._v("Access denied")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0fd90017", module.exports)
  }
}

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "30px",
      "padding-top": "35px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "35px",
      "font-weight": "bold"
    }
  }, [_vm._v("Reports")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('label', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Enter the group id to generate report:\n\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gid),
      expression: "gid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Group ID"
    },
    domProps: {
      "value": (_vm.gid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary get-logs",
    class: {
      'disabled': _vm.gid.trim().length === 0
    },
    on: {
      "click": function($event) {
        _vm.downloadReport()
      }
    }
  }, [_vm._v("Download Report")])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-17c86ae4", module.exports)
  }
}

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('button', {
    staticClass: "navbar-toggler navbar-toggler-left",
    attrs: {
      "type": "button",
      "aria-controls": "navbarNavAltMarkup",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    },
    on: {
      "click": _vm.closeNav
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "cursor": "pointer"
    }
  }, [_vm._v("☰")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    staticClass: "closebtn",
    on: {
      "click": _vm.closeNav
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-default fixed-top navbar-inverse",
    attrs: {
      "role": "navigation",
      "id": "applicationbrandbar"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse",
    attrs: {
      "id": "navbarNavAltMarkup"
    }
  }, [_vm._l((_vm.navItems), function(navItem) {
    return _c('ul', {
      staticClass: "nav navbar-nav"
    }, [_c('li', {
      staticClass: "nav-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: navItem.name,
          query: navItem.query
        },
        "active-class": "activeHeader",
        "exact": ""
      }
    }, [_vm._v(_vm._s(_vm.user_lang.myprofile))])], 1), _vm._v(" "), (_vm.isAdmin === 'superadmin' || _vm.isAdmin === 'admin') ? _c('li', {
      staticClass: "nav-item",
      staticStyle: {
        "padding-right": "20px"
      }
    }, [_c('router-link', {
      attrs: {
        "id": "adminLink",
        "to": _vm.adminItem.to,
        "active-class": "activeHeader",
        "exact": ""
      }
    }, [_vm._v(_vm._s(_vm.user_lang.adminLabel))])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin === 'superadmin') ? _c('li', {
      staticClass: "nav-item",
      staticStyle: {
        "padding-right": "20px"
      }
    }, [_c('router-link', {
      attrs: {
        "id": "tmLink",
        "to": _vm.tmItem.to,
        "active-class": "activeHeader",
        "exact": ""
      }
    }, [_vm._v("Configuration")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin === 'superadmin') ? _c('li', {
      staticClass: "nav-item",
      staticStyle: {
        "padding-right": "20px"
      }
    }, [_c('router-link', {
      attrs: {
        "id": "apisetLink",
        "to": _vm.apisetItem.to,
        "active-class": "activeHeader",
        "exact": ""
      }
    }, [_vm._v("API Settings")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin === 'superadmin') ? _c('li', {
      staticClass: "nav-item",
      staticStyle: {
        "padding-right": "20px"
      }
    }, [_c('router-link', {
      attrs: {
        "id": "emailLogLink",
        "to": _vm.emailLogItem.to,
        "active-class": "activeHeader",
        "exact": ""
      }
    }, [_vm._v("Email Logs")])], 1) : _vm._e()])
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav-admin ml-auto"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "2px solid var(--theme-secondary)"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lang),
      expression: "lang"
    }],
    staticClass: "lang-dpd",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeUserLang]
    }
  }, _vm._l((_vm.lang_def), function(i) {
    return _c('option', {
      domProps: {
        "value": i.langCode
      }
    }, [_vm._v(_vm._s(i.langName))])
  })), _vm._v(" "), _c('i', {
    staticClass: "fa fa-ellipsis-v dots",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('a', {
    attrs: {
      "href": "",
      "data-toggle": "modal",
      "data-target": ".bs-example-modal-sm",
      "data-placement": "bottom",
      "title": "",
      "role": ""
    }
  }, [_c('div', {
    staticClass: "help-div"
  }, [_vm._v(" " + _vm._s(_vm.user_lang.logout) + " ")])])])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal bs-example-modal-sm",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "var(--theme-primary)"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.user_lang.logout) + " "), _c('i', {
    staticClass: "fa fa-lock"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('center', [_vm._v(_vm._s(_vm.user_lang.logoutConfirm))])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "clss": "row"
    }
  }, [_c('div', {
    staticClass: "modal-footer"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block btn-lg",
    staticStyle: {
      "background-color": "#ececec",
      "color": "#000"
    },
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.no))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "border-top": "0",
      "padding-top": "5px"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block btn-lg",
    attrs: {
      "id": "loggout",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.oktaSignOut($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0px 25px"
    }
  }, [_c('a', {
    staticClass: "navbar-brand",
    staticStyle: {
      "padding-right": "5rem"
    },
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "internal-logo",
    staticStyle: {
      "padding": "0rem",
      "max-width": "160px",
      "width": "auto",
      "height": "auto"
    },
    attrs: {
      "src": __webpack_require__(195),
      "height": "45px"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c862efd", module.exports)
  }
}

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "0px",
      "padding-top": "35px"
    }
  }, [_c('div', {
    staticClass: "modal deleteConfirmModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.delete))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "background": "#ffffff !important",
      "color": "#000 !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.wanttodeleteadminconfig))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeConfirm()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal cannotDeleteModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block",
      "border": "0px !important"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "float": "left",
      "width": "90%",
      "margin": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.cannotdeleteconfig))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "background": "#ffffff !important",
      "color": "#000 !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "margin": "-15px"
    }
  }, [_c('div', {
    staticClass: "bc-adduser"
  }, [_c('div', {
    staticStyle: {
      "font-size": "44px !important",
      "font-weight": "bold",
      "overflow": "auto",
      "margin-bottom": "15px"
    }
  }, [_c('span', [_vm._v("API Settings")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin": "10px 0px"
    }
  }, [_vm._v("Note: This section is to provide applications to use one cargill APIs.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAppList),
      expression: "showAppList"
    }]
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px 10px"
    }
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    staticClass: "form-control search-app",
    attrs: {
      "placeholder": "Search Application",
      "type": "text",
      "id": "search-criteria"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "border": "1px solid #000",
      "background": "#213031",
      "padding": "10px 10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    }
  }, [_vm._v("Applications")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    }
  }, [_vm._v("Brand")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _vm._l((_vm.appNameList), function(x, index) {
    return _c('div', {
      key: x.id,
      staticClass: "row searchbox",
      staticStyle: {
        "padding": "5px 10px",
        "border-bottom": "8px solid #eceff1",
        "background-color": "#FFFFFF"
      }
    }, [_c('div', {
      staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "app-name list",
      on: {
        "click": function($event) {
          _vm.getApplicationGroups(_vm.appAdminGroupModal[index].applicationId, index)
        }
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(x.label))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12"
    }, [_c('div', {
      staticClass: "app-name",
      staticStyle: {
        "pointer-events": "none",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.appAdminGroupModal[index].brand))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-12"
    }, [_c('button', {
      staticClass: "deleteconfig",
      on: {
        "click": function($event) {
          _vm.removeRow(_vm.appAdminGroupModal[index].appGrpId, index, _vm.appAdminGroupModal[index].applicationId)
        }
      }
    }, [_vm._v("Delete")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteSuccess),
      expression: "deleteSuccess"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.adminconfigdeletesuccess))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.addConfigRow();
        _vm.changeToAppView()
      }
    }
  }, [_vm._v("Add New App")])])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAppList),
      expression: "!showAppList"
    }]
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 0px",
      "color": "#658d1b",
      "font-weight": "700",
      "background": "#fafafa",
      "width": "100%"
    }
  }, [_vm._v("Application")]), _vm._v(" "), _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].applicationId),
      expression: "appAdminGroupModal[applicationIndex].applicationId"
    }],
    staticClass: "dropdownWrap",
    class: {
      disabledLight: _vm.appAdminGroupModal[_vm.applicationIndex].applicationId !== undefined && _vm.appAdminGroupModal[_vm.applicationIndex].applicationId !== 'undefined' && _vm.appAdminGroupModal[_vm.applicationIndex].groupId !== ''
    },
    attrs: {
      "id": 'select' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.appAdminGroupModal[_vm.applicationIndex].applicationId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getGroups(_vm.appAdminGroupModal[_vm.applicationIndex].applicationId)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectapp))]), _vm._v(" "), _vm._l((_vm.appList), function(j) {
    return (j.name !== 'bookmark') ? _c('option', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.appAdminGroupModal[_vm.applicationIndex].appGrpId === undefined),
        expression: "appAdminGroupModal[applicationIndex].appGrpId === undefined"
      }],
      key: j.id,
      domProps: {
        "value": j.id
      }
    }, [_vm._v(_vm._s(j.label))]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 0px",
      "color": "#658d1b",
      "font-weight": "700",
      "background": "#fafafa",
      "width": "100%"
    }
  }, [_vm._v("Brand")]), _vm._v(" "), _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].brand),
      expression: "appAdminGroupModal[applicationIndex].brand"
    }],
    staticClass: "dropdownWrap",
    class: {
      disabledLight: _vm.appAdminGroupModal[_vm.applicationIndex].applicationId !== undefined && _vm.appAdminGroupModal[_vm.applicationIndex].applicationId !== 'undefined' && _vm.appAdminGroupModal[_vm.applicationIndex].groupId !== ''
    },
    attrs: {
      "id": 'selectbrand' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.appAdminGroupModal[_vm.applicationIndex].brand = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectBrand))]), _vm._v(" "), _vm._l((_vm.brandDetails.data), function(j) {
    return _c('option', {
      key: j.brandKey,
      domProps: {
        "value": j.brandKey
      }
    }, [_vm._v(_vm._s(j.brandName))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 0px",
      "color": "#658d1b",
      "font-weight": "700",
      "background": "#fafafa",
      "width": "100%"
    }
  }, [_vm._v("Allowed Groups")]), _vm._v(" "), _c('span', [_c('div', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "id": "dropdown"
    }
  }, [_c('div', {
    staticClass: "selectDropDown",
    on: {
      "click": function($event) {
        _vm.openDropDown(_vm.applicationIndex)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [(_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId && _vm.appAdminGroupModal[_vm.applicationIndex].subGroupId.length == 0) ? _c('span', [_vm._v(_vm._s(_vm.user_lang['selectgroupslist']))]) : _vm._e(), _vm._v(" "), (_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId && _vm.appAdminGroupModal[_vm.applicationIndex].subGroupId.length > 0) ? _c('span', [_vm._v("Selected (" + _vm._s(_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId ? _vm.appAdminGroupModal[_vm.applicationIndex].subGroupId.length : '0') + ")")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "float": "right",
      "margin": "4px 5px",
      "margin-top": "7px"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDropDown[_vm.applicationIndex.toString()]),
      expression: "showDropDown[applicationIndex.toString()]"
    }],
    class: 'ddwrap' + _vm.applicationIndex,
    attrs: {
      "id": "checkboxlist"
    }
  }, [_vm._l((_vm.appsGroups[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId]), function(j) {
    return _c('div', {
      key: j.id,
      staticClass: "dd-list-item",
      staticStyle: {
        "padding-right": "15px",
        "padding-left": "5px"
      }
    }, [_c('input', {
      staticClass: "form-control input-checkbx-sub",
      attrs: {
        "id": j.id + '~' + _vm.applicationIndex,
        "type": "checkbox"
      },
      domProps: {
        "value": j._embedded.group.profile.name
      },
      on: {
        "change": function($event) {
          _vm.checkchange($event)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "vertical-align": "super"
      },
      attrs: {
        "for": j.id
      }
    }, [_vm._v(_vm._s(j._embedded.group.profile.name))])])
  }), _vm._v(" "), _vm._l((_vm.tempAppAdminGroupModal[_vm.applicationIndex].subGroupId), function(j) {
    return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[_vm.tempAppAdminGroupModal[_vm.applicationIndex].applicationId] && (_vm.appGroupsArrayMap[(_vm.tempAppAdminGroupModal[_vm.applicationIndex]).applicationId]).indexOf(j.split('~~~')[0]) === -1) ? _c('div', {
      key: j.id,
      staticClass: "dd-list-item",
      staticStyle: {
        "padding-right": "15px",
        "padding-left": "5px"
      }
    }, [_c('input', {
      staticClass: "form-control input-checkbx-sub",
      attrs: {
        "id": j.split('~~~')[0] + '~' + _vm.applicationIndex,
        "type": "checkbox"
      },
      domProps: {
        "value": j.split('~~~')[1]
      },
      on: {
        "change": function($event) {
          _vm.checkchange($event)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "vertical-align": "super"
      },
      attrs: {
        "for": j.split('~~~')[0]
      }
    }, [_vm._v(_vm._s(j.split('~~~')[1]))])]) : _vm._e()
  })], 2)])]), _vm._v(" "), _vm._l((_vm.appsGroups[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId]), function(j) {
    return (_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId && (_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId).indexOf(j.id + '~~~' + j._embedded.group.profile.name) > -1) ? _c('span', {
      key: j.id,
      staticStyle: {
        "display": "block",
        "padding": "5px"
      }
    }, [_vm._v("-" + _vm._s(j._embedded.group.profile.name))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId), function(j) {
    return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId] && _vm.appGroupsArrayMap[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId].indexOf(j.split('~~~')[0]) === -1) ? _c('span', {
      key: j.id,
      staticStyle: {
        "display": "block",
        "padding": "5px"
      }
    }, [_vm._v("-" + _vm._s(j.split('~~~')[1]))]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-weight": "600",
      "margin-top": "5px"
    }
  }, [_vm._v("Add additional group:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalGroup[_vm.applicationIndex]),
      expression: "additionalGroup[applicationIndex]"
    }],
    staticClass: "addgrouptxtbox",
    attrs: {
      "type": "text",
      "placeholder": "Enter group name and click +"
    },
    domProps: {
      "value": (_vm.additionalGroup[_vm.applicationIndex])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalGroup, _vm.applicationIndex, $event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    staticStyle: {
      "font-size": "20px",
      "cursor": "pointer",
      "color": "rgb(101, 141, 27)",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.addAdditionalGroup(_vm.applicationIndex, _vm.appAdminGroupModal[_vm.applicationIndex].applicationId)
      }
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isIncomplete),
      expression: "isIncomplete"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.adminConfigIncomplete))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.saveSuccess),
      expression: "saveSuccess"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.adminconfigupdatesuccess))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "font-size": "17px",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.changeView()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "font-size": "17px",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminGroups()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.save))])])])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-202322ac", module.exports)
  }
}

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "id": "session-logout",
      "href": "javascript:localStorage.clear(); sessionStorage.clear();window.location.href = '/Login'"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal bs-example-modal-sm",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true",
      "id": "sessionLogoutModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.user_lang.attention) + " "), _c('i', {
    staticClass: "fa fa-lock"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v(_vm._s(_vm.user_lang.expireWarning.replace('%', _vm.sessionExpiration - _vm.sessionWarning)))]), _vm._v(" "), _c('div', {
    attrs: {
      "clss": "row"
    }
  }, [_c('div', {
    staticClass: "modal-footer"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block btn-lg",
    staticStyle: {
      "background-color": "#ececec",
      "color": "#00524A"
    },
    attrs: {
      "href": "javascript:;",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.clickLogoutNo
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.cancel))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "border-top": "0",
      "padding-top": "5px"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block btn-lg",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.clickLogoutYes
    }
  }, [_vm._v("OK")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal bs-example-modal-sm",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true",
      "id": "logoutMessageModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.user_lang.attention) + "  "), _c('i', {
    staticClass: "fa fa-lock"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v(_vm._s(_vm.user_lang.sessionTimedout))]), _vm._v(" "), _c('div', {
    attrs: {
      "clss": "row"
    }
  })])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2480fbbb", module.exports)
  }
}

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vuelation-affix",
    style: (_vm.affixedStyles)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2ead6946", module.exports)
  }
}

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('nav', {
    staticClass: "navbar navbar-toggleable-md navbar-default fixed-top navbar-inverse",
    attrs: {
      "role": "navigation",
      "id": "applicationbrandbar"
    }
  }, [_c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarNavAltMarkup",
      "aria-controls": "navbarNavAltMarkup",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })]), _vm._v(" "), _c('div', {}, [_c('a', {
    staticClass: "navbar-brand",
    staticStyle: {
      "padding-right": "5rem"
    },
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticStyle: {
      "padding": "0rem"
    },
    attrs: {
      "src": __webpack_require__(195),
      "height": "45px"
    }
  })])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3000ba72", module.exports)
  }
}

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30e6c6f8", module.exports)
  }
}

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "0px",
      "padding-top": "35px"
    }
  }, [_c('div', {
    staticClass: "modal deleteConfirmModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.delete))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "background": "#ffffff !important",
      "color": "#000 !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.wanttodeleteadminconfig) + " ")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeConfirm()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal cannotDeleteModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block",
      "border": "0px !important"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "float": "left",
      "width": "90%",
      "margin": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.cannotdeleteconfig))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "background": "#ffffff !important",
      "color": "#000 !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "margin": "-15px"
    }
  }, [_c('div', {
    staticClass: "bc-adduser"
  }, [_c('div', {
    staticStyle: {
      "font-size": "44px !important",
      "font-weight": "bold",
      "overflow": "auto",
      "margin-bottom": "15px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.tmlabel))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin": "10px 0px"
    }
  }, [_vm._v("\n\t  Note: Ensure that the configured groups are as allowed by the access rules and the service account permissions set in the Okta admin console.\n"), _c('div', [_vm._v("Internal User groups should not be configured to be managed by this application.")])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "2500px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 configGroupAdmin table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.user_lang.application))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.user_lang.selectBrand))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.user_lang.admingroup))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.user_lang.isDxpApp))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.administeredgroups))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.user_lang.selfRegistration))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.user_lang.disableExistingUserOnboard))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.user_lang.selfRegistrationEmailId))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.user_lang.selfApp))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.user_lang.selfRegGrp))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.user_lang.maxNoUsers))]), _vm._v(" "), _c('th', [_vm._v(" ")])]), _vm._v(" "), _vm._l((_vm.appAdminGroupModal), function(i, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "min-width": "250px"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appAdminGroupModal[index].applicationId),
        expression: "appAdminGroupModal[index].applicationId"
      }],
      class: {
        disabledLight: _vm.appAdminGroupModal[index].applicationId !== undefined &&
          _vm.appAdminGroupModal[index].applicationId !== 'undefined' && _vm.appAdminGroupModal[index].groupId !== 'undefined'
      },
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "id": 'select' + i.applicationId
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.appAdminGroupModal[index].applicationId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getGroups(i.applicationId)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "undefined"
      }
    }, [_vm._v(_vm._s(_vm.user_lang.selectapp))]), _vm._v(" "), _vm._l((_vm.appList), function(j) {
      return (j.name !== 'bookmark') ? _c('option', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (i.appGrpId === undefined),
          expression: "i.appGrpId === undefined"
        }],
        domProps: {
          "value": j.id
        }
      }, [_vm._v(_vm._s(j.label))]) : _vm._e()
    })], 2)]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "200px"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appAdminGroupModal[index].brand),
        expression: "appAdminGroupModal[index].brand"
      }],
      class: {
        disabledLight: _vm.appAdminGroupModal[index].applicationId !== undefined &&
          _vm.appAdminGroupModal[index].applicationId !== 'undefined' && _vm.appAdminGroupModal[index].groupId !== 'undefined'
      },
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "id": 'selectbrand' + i.applicationId
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.appAdminGroupModal[index].brand = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "undefined"
      }
    }), _vm._v(" "), _vm._l((_vm.brandDetails.data), function(j) {
      return _c('option', {
        domProps: {
          "value": j.brandKey
        }
      }, [_vm._v(_vm._s(j.brandName))])
    })], 2)]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "250px"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appAdminGroupModal[index].groupId),
        expression: "appAdminGroupModal[index].groupId"
      }],
      class: {
        disabledLight: _vm.appAdminGroupModal[index].applicationId !== undefined &&
          _vm.appAdminGroupModal[index].applicationId !== 'undefined' && _vm.appAdminGroupModal[index].groupId !== 'undefined'
      },
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "id": i.applicationId
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.appAdminGroupModal[index].groupId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.populateOptionDetails(i.applicationId, index)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "undefined"
      }
    }, [_vm._v(_vm._s(_vm.user_lang.selectadmingroup))]), _vm._v(" "), _vm._l((_vm.appsGroups[i.applicationId]), function(j) {
      return _c('option', {
        domProps: {
          "value": j.id
        }
      }, [_vm._v(_vm._s(j._embedded.group.profile.name))])
    })], 2)]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "150px"
      }
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appAdminGroupModal[index].isDxp),
        expression: "appAdminGroupModal[index].isDxp"
      }],
      staticStyle: {
        "width": "15px",
        "vertical-align": "middle"
      },
      attrs: {
        "id": 'select' + i.applicationId,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.appAdminGroupModal[index].isDxp) ? _vm._i(_vm.appAdminGroupModal[index].isDxp, null) > -1 : (_vm.appAdminGroupModal[index].isDxp)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.appAdminGroupModal[index].isDxp,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.appAdminGroupModal[index].isDxp = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.appAdminGroupModal[index].isDxp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appAdminGroupModal[index].isDxp = $$c
          }
        }
      }
    }), _vm._v("\n       " + _vm._s(_vm.user_lang.dxpActivation) + "\n       ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "250px"
      }
    }, [_c('div', {
      attrs: {
        "id": "dropdown"
      }
    }, [_c('div', {
      staticClass: "selectDropDown",
      on: {
        "click": function($event) {
          _vm.openDropDown(index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "padding-left": "5px"
      }
    }, [(_vm.appAdminGroupModal[index].subGroupId && _vm.appAdminGroupModal[index].subGroupId.length == 0) ? _c('span', [_vm._v("\n\t\t\t" + _vm._s(_vm.user_lang['selectgroupslist']) + " ")]) : _vm._e(), _vm._v(" "), (_vm.appAdminGroupModal[index].subGroupId && _vm.appAdminGroupModal[index].subGroupId.length > 0) ? _c('span', [_vm._v("\n\t\t\tSelected (" + _vm._s(_vm.appAdminGroupModal[index].subGroupId ? _vm.appAdminGroupModal[index].subGroupId.length : '0') + ")")]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-caret-down",
      staticStyle: {
        "float": "right",
        "margin": "4px 5px"
      }
    })])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showDropDown[index.toString()]),
        expression: "showDropDown[index.toString()]"
      }],
      class: 'ddwrap' + index,
      attrs: {
        "id": "checkboxlist"
      }
    }, [_vm._l((_vm.appsGroups[i.applicationId]), function(j) {
      return _c('div', {
        staticClass: "dd-list-item",
        staticStyle: {
          "padding-right": "15px",
          "padding-left": "5px"
        }
      }, [_c('input', {
        staticClass: "form-control input-checkbx-sub",
        attrs: {
          "id": j.id + '~' + index,
          "type": "checkbox"
        },
        domProps: {
          "value": j.id
        },
        on: {
          "change": function($event) {
            _vm.checkchange($event)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "vertical-align": "super"
        },
        attrs: {
          "for": j.id
        }
      }, [_vm._v(_vm._s(j._embedded.group.profile.name))])])
    }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[index].subGroupId), function(j) {
      return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[i.applicationId] && _vm.appGroupsArrayMap[i.applicationId].indexOf(j.split('~~~')[0]) === -1) ? _c('div', {
        staticClass: "dd-list-item",
        staticStyle: {
          "padding-right": "15px",
          "padding-left": "5px"
        }
      }, [_c('input', {
        staticClass: "form-control input-checkbx-sub",
        attrs: {
          "id": j.split('~~~')[0] + '~' + index,
          "type": "checkbox"
        },
        domProps: {
          "value": j.split('~~~')[0]
        },
        on: {
          "change": function($event) {
            _vm.checkchange($event)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "vertical-align": "super"
        },
        attrs: {
          "for": j.split('~~~')[0]
        }
      }, [_vm._v(_vm._s(j.split('~~~')[1]))])]) : _vm._e()
    })], 2)]), _vm._v(" "), _vm._l((_vm.appsGroups[i.applicationId]), function(j) {
      return (_vm.appAdminGroupModal[index].subGroupId && _vm.appAdminGroupModal[index].subGroupId.indexOf(j.id) > -1) ? _c('span', {
        staticStyle: {
          "display": "block"
        }
      }, [_vm._v("-" + _vm._s(j._embedded.group.profile.name))]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[index].subGroupId), function(j) {
      return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[i.applicationId] && _vm.appGroupsArrayMap[i.applicationId].indexOf(j.split('~~~')[0]) === -1) ? _c('span', {
        staticStyle: {
          "display": "block"
        }
      }, [_vm._v("-" + _vm._s(j.split('~~~')[1]))]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-weight": "bold",
        "margin-top": "5px"
      }
    }, [_vm._v("Administer additional group:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.additionalGroup[index]),
        expression: "additionalGroup[index]"
      }],
      staticClass: "addgrouptxtbox",
      attrs: {
        "type": "text",
        "placeholder": "Enter group name and click +"
      },
      domProps: {
        "value": (_vm.additionalGroup[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.additionalGroup, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      staticStyle: {
        "font-size": "20px",
        "cursor": "pointer",
        "color": "rgb(101, 141, 27)",
        "margin-left": "10px"
      },
      on: {
        "click": function($event) {
          _vm.addAdditionalGroup(index, i.applicationId)
        }
      }
    })], 2), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "150px"
      }
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appAdminGroupModal[index].isSelfReg),
        expression: "appAdminGroupModal[index].isSelfReg"
      }],
      staticStyle: {
        "width": "15px",
        "vertical-align": "middle"
      },
      attrs: {
        "id": 'chkSelf' + i.applicationId,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.appAdminGroupModal[index].isSelfReg) ? _vm._i(_vm.appAdminGroupModal[index].isSelfReg, null) > -1 : (_vm.appAdminGroupModal[index].isSelfReg)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.appAdminGroupModal[index].isSelfReg,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.appAdminGroupModal[index].isSelfReg = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.appAdminGroupModal[index].isSelfReg = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appAdminGroupModal[index].isSelfReg = $$c
          }
        }
      }
    }), _vm._v("\n       " + _vm._s(_vm.user_lang.selfRegistration) + "\n       ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "150px"
      }
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appAdminGroupModal[index].disableExistingUserOnboard),
        expression: "appAdminGroupModal[index].disableExistingUserOnboard"
      }],
      class: {
        disabledLight: !_vm.appAdminGroupModal[index].isSelfReg
      },
      staticStyle: {
        "width": "15px",
        "vertical-align": "middle"
      },
      attrs: {
        "id": 'chkDisableExistingUserOnboard' + i.applicationId,
        "type": "checkbox",
        "disabled": !_vm.appAdminGroupModal[index].isSelfReg
      },
      domProps: {
        "checked": Array.isArray(_vm.appAdminGroupModal[index].disableExistingUserOnboard) ? _vm._i(_vm.appAdminGroupModal[index].disableExistingUserOnboard, null) > -1 : (_vm.appAdminGroupModal[index].disableExistingUserOnboard)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.appAdminGroupModal[index].disableExistingUserOnboard,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.appAdminGroupModal[index].disableExistingUserOnboard = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.appAdminGroupModal[index].disableExistingUserOnboard = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appAdminGroupModal[index].disableExistingUserOnboard = $$c
          }
        }
      }
    }), _vm._v("\n       " + _vm._s(_vm.user_lang.disableExistingUserOnboard) + "\n       ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "150px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appAdminGroupModal[index].emailId),
        expression: "appAdminGroupModal[index].emailId"
      }],
      staticStyle: {
        "width": "175px",
        "vertical-align": "middle"
      },
      attrs: {
        "id": 'txtEmail' + i.applicationId,
        "type": "text"
      },
      domProps: {
        "value": (_vm.appAdminGroupModal[index].emailId)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.appAdminGroupModal[index].emailId = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "250px"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appAdminGroupModal[index].selfRegGroupId),
        expression: "appAdminGroupModal[index].selfRegGroupId"
      }],
      class: {
        disabledLight: _vm.appAdminGroupModal[index].isSelfRegModal || !_vm.appAdminGroupModal[index].isSelfReg
      },
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "id": 'selRegGroup' + i.applicationId
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.appAdminGroupModal[index].selfRegGroupId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.populateOptionDetails(i.applicationId, index)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "undefined"
      }
    }, [_vm._v(_vm._s(_vm.user_lang.selectReggroup))]), _vm._v(" "), _vm._l((_vm.appsSelfGroups[i.applicationId]), function(j) {
      return _c('option', {
        domProps: {
          "value": j.id
        }
      }, [_vm._v(_vm._s(j._embedded.group.profile.name))])
    })], 2)]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "250px"
      }
    }, [_c('div', {
      attrs: {
        "id": "dropdown"
      }
    }, [_c('div', {
      staticClass: "selectDropDown",
      class: {
        disabledLight: !_vm.appAdminGroupModal[index].isSelfReg
      },
      on: {
        "click": function($event) {
          _vm.openSelfRegDropDown(index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "padding-left": "5px"
      }
    }, [(!_vm.appAdminGroupModal[index].selfRegGroupList || (_vm.appAdminGroupModal[index].selfRegGroupList && _vm.appAdminGroupModal[index].selfRegGroupList.length == 0)) ? _c('span', [_vm._v("\n\t\t\t" + _vm._s(_vm.user_lang['selectgroupslist']) + " ")]) : _vm._e(), _vm._v(" "), (_vm.appAdminGroupModal[index].selfRegGroupList && _vm.appAdminGroupModal[index].selfRegGroupList.length > 0) ? _c('span', [_vm._v("\n\t\t\tSelected (" + _vm._s(_vm.appAdminGroupModal[index].selfRegGroupList ? _vm.appAdminGroupModal[index].selfRegGroupList.length : '0') + ")")]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-caret-down",
      staticStyle: {
        "float": "right",
        "margin": "4px 5px"
      }
    })])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showSelfDropDown[index.toString()]),
        expression: "showSelfDropDown[index.toString()]"
      }],
      class: 'ddwrap' + index,
      attrs: {
        "id": "checkboxlist"
      }
    }, [_vm._l((_vm.appsSelfGroups[i.applicationId]), function(j) {
      return _c('div', {
        staticClass: "dd-list-item",
        staticStyle: {
          "padding-right": "15px",
          "padding-left": "5px"
        }
      }, [_c('input', {
        staticClass: "form-control input-checkbx-sub",
        attrs: {
          "id": j.id + '~self' + index,
          "type": "checkbox"
        },
        domProps: {
          "value": j.id
        },
        on: {
          "change": function($event) {
            _vm.checkSelfchange($event)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "vertical-align": "super"
        },
        attrs: {
          "for": j.id
        }
      }, [_vm._v(_vm._s(j._embedded.group.profile.name))])])
    }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[index].selfRegGroupList), function(j) {
      return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[i.applicationId] && _vm.appGroupsArrayMap[i.applicationId].indexOf(j.split('~~~')[0]) === -1) ? _c('div', {
        staticClass: "dd-list-item",
        staticStyle: {
          "padding-right": "15px",
          "padding-left": "5px"
        }
      }, [_c('input', {
        staticClass: "form-control input-checkbx-sub",
        attrs: {
          "id": j.split('~~~')[0] + '~self' + index,
          "type": "checkbox"
        },
        domProps: {
          "value": j.split('~~~')[0]
        },
        on: {
          "change": function($event) {
            _vm.checkSelfchange($event)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "vertical-align": "super"
        },
        attrs: {
          "for": j.split('~~~')[0]
        }
      }, [_vm._v(_vm._s(j.split('~~~')[1]))])]) : _vm._e()
    })], 2)]), _vm._v(" "), _vm._l((_vm.appsSelfGroups[i.applicationId]), function(j) {
      return (_vm.appAdminGroupModal[index].selfRegGroupList && _vm.appAdminGroupModal[index].selfRegGroupList.indexOf(j.id) > -1) ? _c('span', {
        staticStyle: {
          "display": "block"
        }
      }, [_vm._v("-" + _vm._s(j._embedded.group.profile.name))]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[index].selfRegGroupList), function(j) {
      return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[i.applicationId] && _vm.appGroupsArrayMap[i.applicationId].indexOf(j.split('~~~')[0]) === -1) ? _c('span', {
        staticStyle: {
          "display": "block"
        }
      }, [_vm._v("-" + _vm._s(j.split('~~~')[1]))]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-weight": "bold",
        "margin-top": "5px"
      }
    }, [_vm._v(_vm._s(_vm.user_lang.selfRegSubGrps))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.additionalSelfGroup[index]),
        expression: "additionalSelfGroup[index]"
      }],
      staticClass: "addgrouptxtbox",
      class: {
        disabledLight: !_vm.appAdminGroupModal[index].isSelfReg
      },
      attrs: {
        "type": "text",
        "placeholder": "Enter group name and click +"
      },
      domProps: {
        "value": (_vm.additionalSelfGroup[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.additionalSelfGroup, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      staticStyle: {
        "font-size": "20px",
        "cursor": "pointer",
        "color": "rgb(101, 141, 27)",
        "margin-left": "10px"
      },
      on: {
        "click": function($event) {
          _vm.addAdditionalSelfGroup(index, i.applicationId)
        }
      }
    })], 2), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "150px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appAdminGroupModal[index].maxSelfRegCount),
        expression: "appAdminGroupModal[index].maxSelfRegCount"
      }],
      class: {
        disabledLight: !_vm.appAdminGroupModal[index].isSelfReg
      },
      staticStyle: {
        "width": "75px",
        "vertical-align": "middle"
      },
      attrs: {
        "id": 'txtSelf' + i.applicationId,
        "type": "text"
      },
      domProps: {
        "value": (_vm.appAdminGroupModal[index].maxSelfRegCount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.appAdminGroupModal[index].maxSelfRegCount = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "80px"
      }
    }, [_c('button', {
      staticClass: "deleteconfig",
      on: {
        "click": function($event) {
          _vm.removeRow(i.appGrpId, index, i.applicationId)
        }
      }
    }, [_vm._v("Delete")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isIncomplete),
      expression: "isIncomplete"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "red"
    }
  }, [_vm._v("\n\t  " + _vm._s(_vm.user_lang.adminConfigIncomplete))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.saveSuccess),
      expression: "saveSuccess"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "green"
    }
  }, [_vm._v("\n\t  " + _vm._s(_vm.user_lang.adminconfigupdatesuccess))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteSuccess),
      expression: "deleteSuccess"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "green"
    }
  }, [_vm._v("\n\t  " + _vm._s(_vm.user_lang.adminconfigdeletesuccess))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "2500px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "font-size": "17px",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminGroups()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.save))]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.addConfigRow()
      }
    }
  }, [_vm._v("Add New Config")])])])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-37d5b43c", module.exports)
  }
}

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logging-in"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding": "20px 0px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "row text-center",
    staticStyle: {
      "margin": "20px 0 20px"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('H1', {
    staticStyle: {
      "color": "var(--theme-primary)"
    }
  }, [_vm._v("Signing in ...")])], 1)]), _vm._v(" "), _c('spinner', {
    attrs: {
      "spinnerOn": true
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-40e44573", module.exports)
  }
}

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "0px",
      "padding-top": "35px"
    }
  }, [_c('div', {
    staticClass: "modal deleteConfirmModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.delete))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "background": "#ffffff !important",
      "color": "#000 !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.wanttodeleteadminconfig) + " ")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeConfirm()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal cannotDeleteModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block",
      "border": "0px !important"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "float": "left",
      "width": "90%",
      "margin": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.cannotdeleteconfig))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "background": "#ffffff !important",
      "color": "#000 !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "margin": "-15px"
    }
  }, [_c('div', {
    staticClass: "bc-adduser"
  }, [_c('div', {
    staticStyle: {
      "font-size": "44px !important",
      "font-weight": "bold",
      "overflow": "auto",
      "margin-bottom": "15px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.tmlabel))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin": "10px 0px"
    }
  }, [_vm._v("\n\t            Note: Ensure that the configured groups are as allowed by the access rules and the service account permissions set in the Okta admin console.\n              "), _c('div', [_vm._v("Internal User groups should not be configured to be managed by this application.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAppList),
      expression: "showAppList"
    }]
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px 10px"
    }
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    staticClass: "form-control search-app",
    attrs: {
      "placeholder": "Search Application",
      "type": "text",
      "id": "search-criteria"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6",
    staticStyle: {
      "text-align": "right",
      "padding": "10px"
    }
  }, [_c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.addConfigRow();
        _vm.changeToAppView()
      }
    }
  }, [_vm._v("Add New App")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "border": "1px solid #000",
      "background": "#213031",
      "padding": "10px 10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    }
  }, [_vm._v("Applications")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    }
  }, [_vm._v("Brand")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _vm._l((_vm.appNameList), function(x, index) {
    return _c('div', {
      key: x.id + '~' + index,
      staticClass: "row searchbox",
      staticStyle: {
        "padding": "5px 10px",
        "border-bottom": "8px solid #eceff1",
        "background-color": "#FFFFFF"
      }
    }, [_c('div', {
      staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12",
      class: {
        disabled: x.label.indexOf('Deleted App') > -1
      }
    }, [_c('div', {
      staticClass: "app-name list",
      on: {
        "click": function($event) {
          _vm.getApplicationGroups(_vm.appAdminGroupModal[index].applicationId, index);
        }
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(x.label))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12"
    }, [_c('div', {
      staticClass: "app-name",
      staticStyle: {
        "pointer-events": "none",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.appAdminGroupModal[index].brand))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-12"
    }, [_c('button', {
      staticClass: "deleteconfig",
      on: {
        "click": function($event) {
          _vm.removeRow(_vm.appAdminGroupModal[index].appGrpId, index, _vm.appAdminGroupModal[index].applicationId)
        }
      }
    }, [_vm._v("Delete")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteSuccess),
      expression: "deleteSuccess"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.adminconfigdeletesuccess))])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAppList),
      expression: "!showAppList"
    }]
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "appDetails",
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bolder",
      "padding-left": "5px"
    }
  }, [_vm._v("App Configuration")])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v("Application")]), _vm._v(" "), _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].applicationId),
      expression: "appAdminGroupModal[applicationIndex].applicationId"
    }],
    staticClass: "dropdownWrap",
    class: {
      disabledLight: _vm.appAdminGroupModal[_vm.applicationIndex].applicationId !== undefined &&
        _vm.appAdminGroupModal[_vm.applicationIndex].applicationId !== 'undefined' && _vm.appAdminGroupModal[_vm.applicationIndex].groupId !== 'undefined'
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": 'select' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.appAdminGroupModal[_vm.applicationIndex].applicationId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getGroups(_vm.appAdminGroupModal[_vm.applicationIndex].applicationId)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectapp))]), _vm._v(" "), _vm._l((_vm.appList), function(j) {
    return (j.name !== 'bookmark') ? _c('option', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.appAdminGroupModal[_vm.applicationIndex].appGrpId === undefined),
        expression: "appAdminGroupModal[applicationIndex].appGrpId === undefined"
      }],
      key: j.id,
      domProps: {
        "value": j.id
      }
    }, [_vm._v(_vm._s(j.label))]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v("Brand")]), _vm._v(" "), _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].brand),
      expression: "appAdminGroupModal[applicationIndex].brand"
    }],
    staticClass: "dropdownWrap",
    class: {
      disabledLight: _vm.appAdminGroupModal[_vm.applicationIndex].appGrpId !== undefined &&
        _vm.appAdminGroupModal[_vm.applicationIndex].appGrpId !== ''
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": 'selectbrand' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.appAdminGroupModal[_vm.applicationIndex].brand = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectBrand))]), _vm._v(" "), _vm._l((_vm.brandDetails.data), function(j) {
    return _c('option', {
      key: j.brandKey,
      domProps: {
        "value": j.brandKey
      }
    }, [_vm._v(_vm._s(j.brandName))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v(_vm._s(_vm.user_lang.admingroup))]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupNameTyped),
      expression: "groupNameTyped"
    }],
    class: {
      disabledLight: _vm.appAdminGroupModal[_vm.applicationIndex].appGrpId !== undefined && _vm.appAdminGroupModal[_vm.applicationIndex].appGrpId !== ''
    },
    staticStyle: {
      "height": "40px !important",
      "width": "75%",
      "font-size": "16px !important"
    },
    attrs: {
      "type": "text",
      "tabindex": "-1",
      "placeholder": "Search group name"
    },
    domProps: {
      "value": (_vm.groupNameTyped)
    },
    on: {
      "keydown": function($event) {
        _vm.onSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.groupNameTyped = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "id": "dropdown"
    }
  }, [(_vm.isSearched && _vm.groupNameTyped.length > 0) ? _c('div', {
    staticClass: "searchDropDown"
  }, [_vm._l((_vm.searchDropdownData), function(j) {
    return _c('div', {
      key: j.id
    }, [_c('div', {
      staticClass: "search-list-for-admin",
      attrs: {
        "for": j.id
      },
      on: {
        "click": function($event) {
          _vm.selectAdminGroupFromList(j)
        }
      }
    }, [_vm._v(_vm._s(j.profile.name))])])
  }), _vm._v(" "), (_vm.searchDropdownData.length === 0) ? _c('div', [_c('i', [_vm._v("No groups found.")])]) : _vm._e()], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v(_vm._s(_vm.user_lang.administeredgroups))]), _vm._v(" "), _c('span', [_c('div', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "id": "dropdown"
    }
  }, [_c('div', {
    staticClass: "selectDropDown",
    on: {
      "click": function($event) {
        _vm.openDropDown(_vm.applicationIndex)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin-top": "5px",
      "padding-left": "10px"
    }
  }, [(_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId && _vm.appAdminGroupModal[_vm.applicationIndex].subGroupId.length == 0) ? _c('span', [_vm._v("\n\t\t\t                      " + _vm._s(_vm.user_lang['selectgroupslist']) + " \n                          ")]) : _vm._e(), _vm._v(" "), (_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId && _vm.appAdminGroupModal[_vm.applicationIndex].subGroupId.length > 0) ? _c('span', [_vm._v("\n  \t\t\t                    Selected (" + _vm._s(_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId ? _vm.appAdminGroupModal[_vm.applicationIndex].subGroupId.length : '0') + ")\n                          ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "float": "right",
      "margin": "4px 5px"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDropdownForGroups),
      expression: "showDropdownForGroups"
    }],
    class: 'ddwrap' + _vm.applicationIndex,
    attrs: {
      "id": "checkboxlist"
    }
  }, [_vm._l((_vm.currGroupDetails), function(j) {
    return _c('div', {
      key: j.id,
      staticClass: "dd-list-item",
      staticStyle: {
        "padding-right": "15px",
        "padding-left": "5px"
      }
    }, [_c('input', {
      staticClass: "form-control input-checkbx-sub",
      attrs: {
        "id": j.id + '~' + _vm.applicationIndex,
        "type": "checkbox"
      },
      domProps: {
        "value": j._embedded.group.profile.name
      },
      on: {
        "change": function($event) {
          _vm.checkchange($event)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "vertical-align": "super"
      },
      attrs: {
        "for": j.id
      }
    }, [_vm._v(_vm._s(j._embedded.group.profile.name))])])
  }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId), function(j) {
    return (j.indexOf('~~~') > -1 && !_vm.currGroupDetails.some(function (x) { return x.id.indexOf(j.id) > -1; })) ? _c('div', {
      key: j.id,
      staticClass: "dd-list-item",
      staticStyle: {
        "padding-right": "15px",
        "padding-left": "5px"
      }
    }, [_c('input', {
      staticClass: "form-control input-checkbx-sub",
      attrs: {
        "id": j.split('~~~')[0] + '~' + _vm.applicationIndex,
        "type": "checkbox"
      },
      domProps: {
        "value": j.split('~~~')[1]
      },
      on: {
        "change": function($event) {
          _vm.checkchange($event)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "vertical-align": "super"
      },
      attrs: {
        "for": j.split('~~~')[0]
      }
    }, [_vm._v(_vm._s(j.split('~~~')[1]))])]) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId.length > 0) ? _c('div', {
    staticStyle: {
      "text-align": "right",
      "color": "#658d1b",
      "font-weight": "600"
    }
  }, [_vm._v(" Read Only ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[_vm.applicationIndex].subGroupManagement), function(j) {
    return _c('span', {
      key: j.subGroupId,
      staticStyle: {
        "display": "block",
        "padding": "5px"
      }
    }, [(!j.roleChanged) ? _c('span', [_vm._v(_vm._s(j.subGroupName) + "\n                        "), _c('label', {
      staticClass: "switch",
      staticStyle: {
        "float": "right"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (j.isReadOnly),
        expression: "j.isReadOnly"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(j.isReadOnly) ? _vm._i(j.isReadOnly, null) > -1 : (j.isReadOnly)
      },
      on: {
        "__c": function($event) {
          var $$a = j.isReadOnly,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (j.isReadOnly = $$a.concat([$$v]))
            } else {
              $$i > -1 && (j.isReadOnly = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            j.isReadOnly = $$c
          }
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "slider round"
    })])]) : (j.roleChanged) ? _c('span', [_vm._v(_vm._s(j.subGroupName) + "\n                        "), _c('i', {
      staticClass: "fa fa-remove-circle"
    })]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-weight": "600",
      "margin-top": "5px"
    }
  }, [_vm._v("Administer additional group:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalGroup[_vm.applicationIndex]),
      expression: "additionalGroup[applicationIndex]"
    }],
    staticClass: "addgrouptxtbox",
    attrs: {
      "type": "text",
      "placeholder": "Enter group name and click +"
    },
    domProps: {
      "value": (_vm.additionalGroup[_vm.applicationIndex])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalGroup, _vm.applicationIndex, $event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    staticStyle: {
      "font-size": "20px",
      "cursor": "pointer",
      "color": "rgb(101, 141, 27)",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.addAdditionalGroup(_vm.applicationIndex, _vm.appAdminGroupModal[_vm.applicationIndex].applicationId)
      }
    }
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v(_vm._s(_vm.user_lang.isDxpApp))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].isDxp),
      expression: "appAdminGroupModal[applicationIndex].isDxp"
    }],
    staticStyle: {
      "width": "25px",
      "vertical-align": "middle"
    },
    attrs: {
      "id": 'select' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.appAdminGroupModal[_vm.applicationIndex].isDxp) ? _vm._i(_vm.appAdminGroupModal[_vm.applicationIndex].isDxp, null) > -1 : (_vm.appAdminGroupModal[_vm.applicationIndex].isDxp)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.appAdminGroupModal[_vm.applicationIndex].isDxp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appAdminGroupModal[_vm.applicationIndex].isDxp = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appAdminGroupModal[_vm.applicationIndex].isDxp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appAdminGroupModal[_vm.applicationIndex].isDxp = $$c
        }
      }
    }
  }), _vm._v("\n                    " + _vm._s(_vm.user_lang.dxpActivation) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "appDetails",
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bolder",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selfRegistration))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('div', [_c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg),
      expression: "appAdminGroupModal[applicationIndex].isSelfReg"
    }],
    staticStyle: {
      "width": "25px",
      "vertical-align": "middle"
    },
    attrs: {
      "id": 'chkSelf' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg) ? _vm._i(_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg, null) > -1 : (_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg = $$c
        }
      }
    }
  }), _vm._v("\n                      " + _vm._s(_vm.user_lang.selfRegistration) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard),
      expression: "appAdminGroupModal[applicationIndex].disableExistingUserOnboard"
    }],
    class: {
      disabledLight: !_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg
    },
    staticStyle: {
      "width": "25px",
      "vertical-align": "middle"
    },
    attrs: {
      "id": 'chkDisableExistingUserOnboard' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId,
      "type": "checkbox",
      "disabled": !_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg
    },
    domProps: {
      "checked": Array.isArray(_vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard) ? _vm._i(_vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard, null) > -1 : (_vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard = $$c
        }
      }
    }
  }), _vm._v("\n                      " + _vm._s(_vm.user_lang.disableExistingUserOnboard) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v(_vm._s(_vm.user_lang.selfRegistrationEmailId))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].emailId),
      expression: "appAdminGroupModal[applicationIndex].emailId"
    }],
    staticClass: "addgrouptxtbox",
    staticStyle: {
      "vertical-align": "middle",
      "height": "40px !important",
      "font-size": "16px !important"
    },
    attrs: {
      "id": 'txtEmail' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId,
      "type": "text"
    },
    domProps: {
      "value": (_vm.appAdminGroupModal[_vm.applicationIndex].emailId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.appAdminGroupModal[_vm.applicationIndex].emailId = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v(_vm._s(_vm.user_lang.selfApp))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupId),
      expression: "appAdminGroupModal[applicationIndex].selfRegGroupId"
    }],
    staticClass: "dropdownWrap",
    class: {
      disabledLight: _vm.appAdminGroupModal[_vm.applicationIndex].isSelfRegModal || !_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": 'selRegGroup' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.populateOptionDetails(_vm.appAdminGroupModal[_vm.applicationIndex].applicationId, _vm.applicationIndex)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectReggroup))]), _vm._v(" "), _vm._l((_vm.appsSelfGroups[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId]), function(j) {
    return _c('option', {
      key: j.id,
      domProps: {
        "value": j.id
      }
    }, [_vm._v(_vm._s(j._embedded.group.profile.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v(_vm._s(_vm.user_lang.selfRegGrp))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "id": "dropdown"
    }
  }, [_c('div', {
    staticClass: "selectDropDown",
    class: {
      disabledLight: !_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg
    },
    on: {
      "click": function($event) {
        _vm.openSelfRegDropDown(_vm.applicationIndex)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin-top": "5px",
      "padding-left": "10px"
    }
  }, [(!_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList || (_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList && _vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList.length == 0)) ? _c('span', [_vm._v("\n\t\t\t                    " + _vm._s(_vm.user_lang['selectgroupslist']) + " \n                        ")]) : _vm._e(), _vm._v(" "), (_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList && _vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList.length > 0) ? _c('span', [_vm._v("\n\t\t\t                    Selected (" + _vm._s(_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList ? _vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList.length : '0') + ")\n                        ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "float": "right",
      "margin": "4px 5px"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDropdownForSelfGroups),
      expression: "showDropdownForSelfGroups"
    }],
    class: 'ddwrapself' + _vm.applicationIndex,
    attrs: {
      "id": "checkboxlist"
    }
  }, [_vm._l((_vm.appsSelfGroups[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId]), function(j) {
    return _c('div', {
      key: j.id,
      staticClass: "dd-list-item",
      staticStyle: {
        "padding-right": "15px",
        "padding-left": "5px"
      }
    }, [_c('input', {
      staticClass: "form-control input-checkbx-sub",
      attrs: {
        "id": j.id + '~self' + _vm.applicationIndex,
        "type": "checkbox"
      },
      domProps: {
        "value": j.id
      },
      on: {
        "change": function($event) {
          _vm.checkSelfchange($event)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "vertical-align": "super"
      },
      attrs: {
        "for": j.id
      }
    }, [_vm._v(_vm._s(j._embedded.group.profile.name))])])
  }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList), function(j) {
    return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId] && _vm.appGroupsArrayMap[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId].indexOf(j.split('~~~')[0]) === -1) ? _c('div', {
      key: j.id,
      staticClass: "dd-list-item",
      staticStyle: {
        "padding-right": "15px",
        "padding-left": "5px"
      }
    }, [_c('input', {
      staticClass: "form-control input-checkbx-sub",
      attrs: {
        "id": j.split('~~~')[0] + '~self' + _vm.applicationIndex,
        "type": "checkbox"
      },
      domProps: {
        "value": j.split('~~~')[0]
      },
      on: {
        "change": function($event) {
          _vm.checkSelfchange($event)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "vertical-align": "super"
      },
      attrs: {
        "for": j.split('~~~')[0]
      }
    }, [_vm._v(_vm._s(j.split('~~~')[1]))])]) : _vm._e()
  })], 2)]), _vm._v(" "), _vm._l((_vm.appsSelfGroups[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId]), function(j) {
    return (_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList && _vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList.indexOf(j.id) > -1) ? _c('span', {
      key: j.id,
      staticStyle: {
        "display": "block",
        "padding": "5px"
      }
    }, [_vm._v("-" + _vm._s(j._embedded.group.profile.name))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList), function(j) {
    return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId] && _vm.appGroupsArrayMap[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId].indexOf(j.split('~~~')[0]) === -1) ? _c('span', {
      key: j.id,
      staticStyle: {
        "display": "block",
        "padding": "5px"
      }
    }, [_vm._v("-" + _vm._s(j.split('~~~')[1]))]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-weight": "600",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selfRegSubGrps))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalSelfGroup[_vm.applicationIndex]),
      expression: "additionalSelfGroup[applicationIndex]"
    }],
    staticClass: "addgrouptxtbox",
    class: {
      disabledLight: !_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter group name and click +"
    },
    domProps: {
      "value": (_vm.additionalSelfGroup[_vm.applicationIndex])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalSelfGroup, _vm.applicationIndex, $event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    staticStyle: {
      "font-size": "20px",
      "cursor": "pointer",
      "color": "rgb(101, 141, 27)",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.addAdditionalSelfGroup(_vm.applicationIndex, _vm.appAdminGroupModal[_vm.applicationIndex].applicationId)
      }
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v(_vm._s(_vm.user_lang.maxNoUsers))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].maxSelfRegCount),
      expression: "appAdminGroupModal[applicationIndex].maxSelfRegCount"
    }],
    class: {
      disabledLight: !_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg
    },
    staticStyle: {
      "width": "75px",
      "vertical-align": "middle",
      "height": "40px !important",
      "font-size": "16px !important"
    },
    attrs: {
      "id": 'txtSelf' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId,
      "type": "text"
    },
    domProps: {
      "value": (_vm.appAdminGroupModal[_vm.applicationIndex].maxSelfRegCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.appAdminGroupModal[_vm.applicationIndex].maxSelfRegCount = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isIncomplete),
      expression: "isIncomplete"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "red"
    }
  }, [_vm._v("\n\t              " + _vm._s(_vm.user_lang.adminConfigIncomplete))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.saveSuccess),
      expression: "saveSuccess"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "green"
    }
  }, [_vm._v("\n\t              " + _vm._s(_vm.user_lang.adminconfigupdatesuccess))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "font-size": "17px",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.changeView()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "font-size": "17px",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminGroups()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.save))])])])])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-47e688b5", module.exports)
  }
}

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "var(--regpwd-primarytextcolor)"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "splash",
    attrs: {
      "src": "static/bgi.jpg",
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.inviteSuccess) ? _c('div', {
    staticStyle: {
      "box-shadow": "2px 2px 10px #ccc"
    },
    attrs: {
      "id": "selfRegistration"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "auto",
      "padding-top": "35px",
      "padding": "35px",
      "background": "#fff"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px"
    }
  }, [_c('h5', [_vm._v(" " + _vm._s(_vm.user_lang.selfRegFormTitle) + " ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left",
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.firstName),
      expression: "person.firstName"
    }],
    staticStyle: {
      "width": "100%",
      "height": "45px",
      "padding-left": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.user_lang.first_name
    },
    domProps: {
      "value": (_vm.person.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left",
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.lastName),
      expression: "person.lastName"
    }],
    staticStyle: {
      "width": "100%",
      "height": "45px",
      "padding-left": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.user_lang.last_name
    },
    domProps: {
      "value": (_vm.person.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.lastName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left",
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.email),
      expression: "person.email"
    }],
    staticStyle: {
      "width": "100%",
      "height": "45px",
      "padding-left": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.user_lang.enter_email
    },
    domProps: {
      "value": (_vm.person.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left",
      "margin-bottom": "10px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.locale),
      expression: "person.locale"
    }],
    staticClass: "preflang",
    staticStyle: {
      "height": "39px",
      "width": "100%"
    },
    attrs: {
      "id": "message-text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.person.locale = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectLang))]), _vm._v(" "), _vm._l((_vm.lang_def), function(i) {
    return _c('option', {
      domProps: {
        "value": i.langCode
      }
    }, [_vm._v(_vm._s(i.langName))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "width": "100%",
      "text-align": "center",
      "margin": "0px auto"
    },
    attrs: {
      "id": "captcha_container"
    }
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": _vm.sitekey,
      "loadRecaptchaScript": true
    },
    on: {
      "verify": _vm.onVerify,
      "expired": _vm.onExpired,
      "error": _vm.onError,
      "render": _vm.onRender
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [(_vm.userValidations !== '') ? _c('div', {
    staticClass: "validation-text"
  }, [_vm._v(_vm._s(_vm.userValidations))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('button', {
    class: {
      'disabled': !_vm.captchaVerified
    },
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.validateAndResendInvite()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.user_lang.selfRegister))])])])])]) : _vm._e(), _vm._v(" "), (_vm.inviteSuccess) ? _c('div', {
    staticStyle: {
      "box-shadow": "2px 2px 10px #ccc"
    },
    attrs: {
      "id": "selfRegistrationSucess"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "30px",
      "border-top": "1px solid #ccc",
      "background": "#fff"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.successCode === 'E0001' || _vm.successCode === 'E0002' || _vm.successCode === 'E0005') ? _c('div', [_vm._v("\n                " + _vm._s(_vm.user_lang.E0001) + "\n                "), (_vm.mailCheck) ? _c('a', {
    attrs: {
      "href": ("mailto:" + _vm.contactMailId)
    }
  }, [_vm._v(_vm._s(_vm.user_lang.E0001_1))]) : _vm._e(), _vm._v(" "), (!_vm.mailCheck) ? _c('a', {
    attrs: {
      "href": ("" + _vm.contactMailId)
    }
  }, [_vm._v(_vm._s(_vm.user_lang.E0001_1))]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.user_lang.E0001_2) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.successCode === 'E0003' || _vm.successCode === 'STAGED' || _vm.successCode === 'PROVISIONED') ? _c('div', [_vm._v("\n                " + _vm._s(_vm.user_lang.E0003) + "\n                "), (_vm.mailCheck) ? _c('a', {
    attrs: {
      "href": ("mailto:" + _vm.contactMailId)
    }
  }, [_vm._v(_vm._s(_vm.contactMailId))]) : _vm._e(), _vm._v(" "), (!_vm.mailCheck) ? _c('a', {
    attrs: {
      "href": ("" + _vm.contactMailId)
    }
  }, [_vm._v(_vm._s(_vm.contactMailId))]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.user_lang.E0003_1) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.successCode === 'E0004' || _vm.successCode === 'ACTIVE') ? _c('div', [_vm._v("\n                " + _vm._s(_vm.user_lang.E0004) + "\n              ")]) : _vm._e()])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "okta-sign-in-header auth-header"
  }, [_c('img', {
    staticClass: "auth-org-logo",
    attrs: {
      "src": "static/1200px-Cargill_logo.svg.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "beacon-container",
    attrs: {
      "data-type": "beacon-container"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px",
      "color": "var(--theme-primary)"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b105266", module.exports)
  }
}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.badbrowser) ? _c('div', {
    staticClass: "modal modal-message modal-warning fade",
    attrs: {
      "id": "exampleModalLong",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLongTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content "
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.ieNotSupported))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.user_lang.attention))]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n           " + _vm._s(_vm.user_lang.tryChrome) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.close))])])])])]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b19517a", module.exports)
  }
}

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal dxpNewmodal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.user_lang.activationTemplateTitle) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.dxpNewmodal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t        " + _vm._s(_vm.user_lang.activationTemplateDescription) + " ")])]), _vm._v(" "), _vm._l((_vm.dxpList), function(data) {
    return _c('div', {
      staticStyle: {
        "margin-right": "233px",
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "activation"
      },
      domProps: {
        "value": data.id
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data.id
      }
    }, [_vm._v(" " + _vm._s(data.label) + " " + _vm._s(_vm.user_lang.template))])])
  }), _vm._v(" "), _vm._l((_vm.nonDxpList), function(data) {
    return _c('div', {
      staticStyle: {
        "margin-right": "233px",
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "activation",
        "checked": "checked"
      },
      domProps: {
        "value": 0
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data.id
      }
    }, [_vm._v(_vm._s(_vm.user_lang.cargillActivation))])])
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendDxpNewInvite($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationOk))])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal newdxpmodal1",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.user_lang.activationTitle) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.newdxpmodal1')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n\t\t        " + _vm._s(_vm.user_lang.activationDescription) + " ")])]), _vm._v(" "), _vm._l((_vm.dxpList), function(data) {
    return _c('div', {
      staticStyle: {
        "margin-right": "233px",
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "activation"
      },
      domProps: {
        "value": data.id
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data.id
      }
    }, [_vm._v(" " + _vm._s(data.label) + " " + _vm._s(_vm.user_lang.template))])])
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendDxpNewInvite($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationOk))])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal mfaresetmodal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.mfaResetModalTitle))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.mfaresetmodal')
      }
    }
  }, [_vm._v(" ×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(!_vm.isAuthorizedForMFA) ? _c('div', {
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.errorMsgForMFA))]) : _vm._e(), _vm._v(" "), (_vm.mfaResetSuccess) ? _c('div', {
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.factorResetSuccess))]) : _vm._e(), _vm._v(" "), (_vm.isAuthorizedForMFA && !_vm.mfaResetSuccess) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.resetConfirmation) + " ")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetMFA($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.mfaresetmodal')
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "0px",
      "padding-top": "35px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal bulkReinviteMessageModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "top": "100px"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "bulk-upload-header",
    staticStyle: {
      "float": "left",
      "padding": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Bulk Reinvite Message\n\t\t          "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "text-align": "right",
      "color": "#fff"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n              " + _vm._s(_vm.reInviteMessage) + "\n\t          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal bulkUploadOptionsModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "top": "100px"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "bulk-upload-header",
    staticStyle: {
      "float": "left",
      "padding": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.bulkUploadOptionsLabel) + "\n\t\t          ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 20px 5px"
    }
  }, [_c('div', {
    staticClass: "checkboxgroup"
  }, [_c('input', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "name": "bulkUpload",
      "id": "bulkCreate"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding-left": "7px",
      "font-weight": "normal"
    },
    attrs: {
      "for": "bulkCreate"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.bulkCreateUsers))])]), _vm._v(" "), _c('div', {
    staticClass: "checkboxgroup"
  }, [_c('input', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "name": "bulkUpload",
      "id": "bulkReinvite"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding-left": "7px",
      "font-weight": "normal"
    },
    attrs: {
      "for": "bulkReinvite"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.bulkReinviteUsers))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary adduser-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openbulkModals()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.user_lang.confirm) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary adduser-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.bulkUploadOptionsModal');
        _vm.clearSelectedOptions()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.user_lang.cancel) + " ")])]), _vm._v(" "), (_vm.optionsNotSelected) ? _c('div', {
    staticStyle: {
      "color": "#ff0000",
      "padding": "10px 20px 5px"
    }
  }, [_vm._v("Please select an option to proceed.")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal bulkReinviteModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "top": "100px"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "bulk-upload-header",
    staticStyle: {
      "float": "left",
      "padding": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.bulkReinviteUsers) + "\n\t\t          "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "text-align": "right",
      "color": "#fff"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.clearSelectedOptions()
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.downloadExcelTemplate) + " "), _c('a', {
    attrs: {
      "href": "../../static/Reinvite_template.xlsx",
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "25px",
      "margin-left": "10px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "15px",
      "color": "#000",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.uploadInstruction))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0px 0px 10px 20px"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningOne))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningTwo))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningThree))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.user_lang.note))]), _vm._v(" " + _vm._s(_vm.user_lang.uploadNote) + " ")])]), _vm._v(" "), (_vm.adminType === 'admin' || _vm.adminType === 'superadmin') ? _c('div', {
    staticStyle: {
      "font-size": "14px",
      "padding-right": "30px",
      "background": "#eceff1",
      "padding": "12px 15px",
      "vertical-align": "-webkit-baseline-middle"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.bulkReinviteUsers) + ":\n                "), (_vm.uploadReady) ? _c('input', {
    ref: "reinviteFile",
    staticStyle: {
      "border": "none !important",
      "padding": "0px !important",
      "color": "#000 !important",
      "width": "220px",
      "background": "transparent !important"
    },
    attrs: {
      "type": "file",
      "id": "reinviteFile"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload(true)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': !_vm.isExcel
    },
    staticStyle: {
      "padding": "5px 10px",
      "font-size": "14px !important",
      "font-weight": "bold"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submitFile(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.uploadLabel))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal bulkCreateModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "top": "100px"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "bulk-upload-header",
    staticStyle: {
      "float": "left",
      "padding": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.bulkCreateUsers) + "\n\t\t          "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "text-align": "right",
      "color": "#fff"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.clearSelectedOptions()
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.downloadExcelTemplate) + " "), _c('a', {
    attrs: {
      "href": "../../static/template.xlsx",
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "25px",
      "margin-left": "10px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "15px",
      "color": "#000",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.uploadInstruction))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0px 0px 10px 20px"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningOne))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningFour))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningFive))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningSix))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.user_lang.note))]), _vm._v(" " + _vm._s(_vm.user_lang.uploadNote))])]), _vm._v(" "), (_vm.adminType === 'admin' || _vm.adminType === 'superadmin') ? _c('div', {
    staticStyle: {
      "font-size": "14px",
      "padding-right": "30px",
      "background": "#eceff1",
      "padding": "12px 15px",
      "vertical-align": "-webkit-baseline-middle"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.bulkCreateUsers) + ":\n                "), (_vm.uploadReady) ? _c('input', {
    ref: "file",
    staticStyle: {
      "border": "none !important",
      "padding": "0px !important",
      "color": "#000 !important",
      "width": "220px",
      "background": "transparent !important"
    },
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': !_vm.isExcel
    },
    staticStyle: {
      "padding": "5px 10px",
      "font-size": "14px !important",
      "font-weight": "bold"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submitFile(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.uploadLabel))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow || _vm.updateToggle),
      expression: "isShow || updateToggle"
    }],
    staticStyle: {
      "margin": "-15px"
    }
  }, [_c('div', {
    staticClass: "bc-adduser"
  }, [_c('span', {
    staticClass: "bc-nav",
    on: {
      "click": function($event) {
        _vm.goToUserManagement()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.userAdministration))]), _vm._v("  /  "), _c('span', [_vm._v("\n\t  " + _vm._s(_vm.updateToggle ? _vm.user_lang.edituser : _vm.user_lang.adduser))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "44px !important",
      "font-weight": "bold",
      "overflow": "auto",
      "margin-bottom": "15px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.updateToggle ? _vm.user_lang.edituser : _vm.user_lang.adduser))])]), _vm._v(" "), _vm._l((_vm.addUserValidations), function(i) {
    return _c('div', {
      staticClass: "error-bg usercreateinfo",
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "id": "formValidation"
      }
    }, [_c('div', [_c('i', {
      staticClass: "fa fa-close",
      staticStyle: {
        "float": "right",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.addUserValidations = []
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "margin": "5px 5px"
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      staticStyle: {
        "font-size": "25px"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(i))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "background": "#f1f1f1 !important",
      "margin-bottom": "10px",
      "padding": "18px 18px"
    }
  }, [_c('div', {
    staticClass: "user-creds"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.first_name) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserFirstName),
      expression: "addUserFirstName"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.isNameEditable && _vm.updateToggle
    },
    attrs: {
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.addUserFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserFirstName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.last_name) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserLastName),
      expression: "addUserLastName"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.isNameEditable && _vm.updateToggle
    },
    attrs: {
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.addUserLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserLastName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.primary_mail) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserPrimaryEmail),
      expression: "addUserPrimaryEmail"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: _vm.updateToggle
    },
    attrs: {
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.addUserPrimaryEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserPrimaryEmail = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.secondary_mail) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserSecondaryEmail),
      expression: "addUserSecondaryEmail"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: _vm.noEditForWhitelabel
    },
    attrs: {
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.addUserSecondaryEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserSecondaryEmail = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    class: {
      disabled: _vm.updateToggle
    }
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectLang) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prefLang),
      expression: "prefLang"
    }],
    staticClass: "preflang",
    staticStyle: {
      "height": "39px"
    },
    attrs: {
      "id": "message-text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.prefLang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.lang_def), function(i) {
    return _c('option', {
      domProps: {
        "value": i.langCode
      }
    }, [_vm._v(_vm._s(i.langName))])
  }))])])]), _vm._v(" "), (_vm.showTransformedEmail) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("Transformed Email:")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailTransformed),
      expression: "emailTransformed"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: _vm.updateToggle
    },
    attrs: {
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.emailTransformed)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailTransformed = $event.target.value
      }
    }
  })])])]) : _vm._e()])]), _vm._v(" "), (_vm.isEdit) ? _c('div', {
    staticClass: "user-creds",
    staticStyle: {
      "padding-bottom": "7px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "5px 15px 0px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "15px",
      "width": "100%"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.viewMoreInfo))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.infoContent,
      "data-original-title": _vm.user_lang.infoContent
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "padding": "3px 10px",
      "font-size": "20px",
      "cursor": "pointer"
    },
    attrs: {
      "id": "toggle-arrow"
    },
    on: {
      "click": _vm.toggleDateFields
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "none"
    },
    attrs: {
      "id": "toggle-data"
    }
  }, [_c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.createdDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.createdDateDescription,
      "data-original-title": _vm.user_lang.createdDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.createdDate))])]), _vm._v(" "), _c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.activatedDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.activatedDateDescription,
      "data-original-title": _vm.user_lang.activatedDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.activatedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.lastLoginDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.lastLoginDateDescription,
      "data-original-title": _vm.user_lang.lastLoginDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.lastLogin))])]), _vm._v(" "), _c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.lastUpdatedDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.lastUpdatedDateDescription,
      "data-original-title": _vm.user_lang.lastUpdatedDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.lastUpdated))])]), _vm._v(" "), _c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.passwordChangedDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.passwordChangedDateDescription,
      "data-original-title": _vm.user_lang.passwordChangedDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.passwordChanged))])]), _vm._v(" "), _c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.statusChangedDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.statusChangedDateDescription,
      "data-original-title": _vm.user_lang.statusChangedDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.statusChanged))])])])])]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('div', {
    staticClass: "user-creds",
    staticStyle: {
      "padding-bottom": "7px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "5px 15px 0px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "15px",
      "width": "100%"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.resetMFATitle))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "padding": "3px 10px",
      "font-size": "20px",
      "cursor": "pointer"
    },
    attrs: {
      "id": "toggle-mfa-arrow"
    },
    on: {
      "click": _vm.toggleMFAField
    }
  })]), _vm._v(" "), (_vm.userFactorList.length === 0) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "none",
      "padding": "5px"
    },
    attrs: {
      "id": "toggle-mfa-data"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.user_lang.noFactorExist) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.userFactorList.length > 0) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "none",
      "padding": "5px"
    },
    attrs: {
      "id": "toggle-mfa-data"
    }
  }, [_vm._l((_vm.userFactorList), function(factor) {
    return _c('div', {
      key: factor.id,
      staticClass: "mfa-list"
    }, [_c('div', {
      staticClass: "checkboxgroup"
    }, [_c('input', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "type": "radio",
        "name": "mfaReset",
        "id": factor.id
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "padding-left": "7px",
        "font-weight": "normal"
      },
      attrs: {
        "for": factor.id
      }
    }, [_vm._v(_vm._s(factor.factorType.indexOf('token:software:totp') > -1 ? _vm.transformText(factor.provider) : _vm.transformText(factor.factorType)))])])])
  }), _vm._v(" "), (_vm.noFactorSelected) ? _c('div', {
    staticClass: "validation-mfa"
  }, [_vm._v(_vm._s(_vm.user_lang.mfaValidation))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mfa-btn",
    on: {
      "click": _vm.checkAccess
    }
  }, [_vm._v(" " + _vm._s(_vm.user_lang.resetButton))])], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "user-creds"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['assignApplication']))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('div', {
    attrs: {
      "id": "dropdown"
    }
  }, [_c('div', {
    staticClass: "selectDropDown",
    on: {
      "click": function($event) {
        _vm.showDropDown = !_vm.showDropDown
      }
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['selectgroups'])), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "float": "right",
      "margin": "4px 5px"
    }
  })])]), _vm._v(" "), _vm._l((_vm.adminToBrands), function(n, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showDropDown && ((_vm.appUrl.indexOf('identity-dev') > -1) || (_vm.appUrl.indexOf('cargill') > -1) || (n.toLowerCase() !== 'cargill' && _vm.appUrl.indexOf(n.toLowerCase().replace('portal', '')) > -1) || _vm.appUrl.indexOf('localhost') > -1)),
        expression: "showDropDown && ((appUrl.indexOf('identity-dev') > -1) || (appUrl.indexOf('cargill') > -1) || (n.toLowerCase() !== 'cargill' && appUrl.indexOf(n.toLowerCase().replace('portal','')) > -1) || appUrl.indexOf('localhost') > -1)"
      }],
      class: {
        disabled: _vm.checkedAppBrand !== '' && (n.toLowerCase() !== _vm.checkedAppBrand.toLowerCase())
      }
    }, [_c('span', {
      staticClass: "admintobrand"
    }, [_vm._v(_vm._s(n))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showDropDown),
        expression: "showDropDown"
      }],
      attrs: {
        "id": "checkboxlist"
      }
    }, _vm._l((_vm.userAppList), function(i, index) {
      return (_vm.adminTo.indexOf(i.id) > -1 && n === i.brand) ? _c('div', {
        staticClass: "dd-list-item",
        staticStyle: {
          "padding-right": "15px",
          "padding-left": "5px"
        }
      }, [_c('input', {
        staticClass: "form-control input-checkbx",
        attrs: {
          "id": i.id,
          "type": "checkbox"
        },
        domProps: {
          "value": i.groupId + '-' + i.adminGroupName
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "vertical-align": "super",
          "display": "inline"
        },
        attrs: {
          "for": i.id
        }
      }, [_vm._v(_vm._s(i.label) + " "), (i.adminGroupName) ? _c('label', [_vm._v(" - " + _vm._s(i.adminGroupName) + " ")]) : _vm._e()])]) : _vm._e()
    }))])
  })], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.brand !== ''),
      expression: "brand !== ''"
    }],
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectedBrand) + " ")]), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.brand))])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['availablegroups']) + ":")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, _vm._l((_vm.availablegroups), function(i, index) {
    return (_vm.checkAllowedSubGroup('all', i.id)) ? _c('div', {
      staticClass: "group-div",
      class: {
        disabled: i.isDisabled, bb0: index !== (_vm.availablegroups.length - 1)
      }
    }, [_c('div', {
      staticStyle: {
        "pointer-events": "auto",
        "cursor": "default"
      },
      attrs: {
        "data-toggle": i.isDisabled ? 'tooltip' : false,
        "title": _vm.disableAvailableGroups(i.isDisabled),
        "data-original-title": _vm.disableAvailableGroups(i.isDisabled)
      }
    }, [_c('div', {
      staticClass: "group-name"
    }, [_vm._v(_vm._s(i._embedded ? i._embedded.group.profile.name : i.profile.name))]), _vm._v(" "), (!i.isDisabled) ? _c('i', {
      staticClass: "fa fa-plus-circle add-group",
      on: {
        "click": function($event) {
          _vm.addToSelectedGroup(i.id)
        }
      }
    }) : _vm._e()])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.availableIndependentGroups))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, _vm._l((_vm.indieGroupsForNewUser), function(i, index) {
    return (_vm.checkAllowedSubGroup('all', i.groupId.split('~~~')[0]) && !_vm.isPresentInSelectedGroups(i.groupId.split('~~~')[0]) && i.groupId.split('~~~')[1]) ? _c('div', {
      staticClass: "group-div",
      class: {
        disabled: i.isDisabled, bb0: index !== (_vm.indieGroupsAdministered.length - 1)
      }
    }, [_c('div', {
      staticStyle: {
        "pointer-events": "auto",
        "cursor": "default"
      },
      attrs: {
        "data-toggle": i.isDisabled ? 'tooltip' : false,
        "title": _vm.disableAvailableGroups(i.isDisabled),
        "data-original-title": _vm.disableAvailableGroups(i.isDisabled)
      }
    }, [_c('div', {
      staticClass: "group-name"
    }, [_vm._v(_vm._s(i.groupId.split('~~~')[1]))]), _vm._v(" "), (!i.isDisabled) ? _c('i', {
      staticClass: "fa fa-plus-circle add-group",
      on: {
        "click": function($event) {
          _vm.addToSelectedIndieGroup(i.groupId.split('~~~')[0])
        }
      }
    }) : _vm._e()])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['selectedgroups']))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._l((_vm.grouplist), function(x) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isChildren(x.id)),
        expression: "isChildren(x.id)"
      }],
      staticClass: "dd-list-item",
      class: {
        disabled: _vm.adminTo.indexOf(x.id) === -1
      },
      staticStyle: {
        "padding-right": "15px",
        "padding-left": "5px",
        "display": "block",
        "font-weight": "bold"
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(x.label) + "\n\t  "), _vm._l((_vm.selectedgroups), function(i, index) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (x.id === i.appId),
          expression: "x.id === i.appId"
        }],
        staticClass: "group-div",
        class: {
          disabled: i.isDisabled || !_vm.checkAllowedSubGroup('all', i.id), bb0: index !== (_vm.selectedgroups.length - 1)
        },
        staticStyle: {
          "font-weight": "normal"
        }
      }, [_c('div', {
        staticStyle: {
          "pointer-events": "auto",
          "cursor": "default"
        },
        attrs: {
          "data-toggle": i.isDisabled || !_vm.checkAllowedSubGroup('all', i.id) ? 'tooltip' : false,
          "title": _vm.disableSelectedGroups(i.isDisabled, i.id),
          "data-original-title": _vm.disableSelectedGroups(i.isDisabled, i.id)
        }
      }, [_c('div', {
        staticClass: "group-name"
      }, [_vm._v(_vm._s(i._embedded ? i._embedded.group.profile.name : i.profile.name))]), _vm._v(" "), (!i.isDisabled && _vm.checkAllowedSubGroup('all', i.id)) ? _c('i', {
        staticClass: "fa fa-minus-circle remove-group",
        on: {
          "click": function($event) {
            _vm.removeFromSelectedGroup(i.id)
          }
        }
      }) : _vm._e()])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "dd-list-item",
    staticStyle: {
      "padding-right": "15px",
      "padding-left": "5px",
      "display": "block",
      "font-weight": "bold"
    }
  }, _vm._l((_vm.selectedIndiegroups), function(i, index) {
    return _c('div', {
      staticClass: "group-div",
      class: {
        disabled: !_vm.checkAllowedSubGroup('all', i.split('~~~')[0]), bb0: index !== (_vm.selectedIndiegroups.length - 1)
      },
      staticStyle: {
        "font-weight": "normal"
      }
    }, [_c('div', {
      staticStyle: {
        "pointer-events": "auto",
        "cursor": "default"
      },
      attrs: {
        "data-toggle": !_vm.checkAllowedSubGroup('all', i.split('~~~')[0]) ? 'tooltip' : false,
        "title": _vm.disableSelectedIndieGroups(i.split('~~~')[0]),
        "data-original-title": _vm.disableSelectedIndieGroups(i.split('~~~')[0])
      }
    }, [_c('div', {
      staticClass: "group-name"
    }, [_vm._v(_vm._s(i.split('~~~')[1]))]), _vm._v(" "), (_vm.checkAllowedSubGroup('all', i.split('~~~')[0])) ? _c('i', {
      staticClass: "fa fa-minus-circle remove-group",
      on: {
        "click": function($event) {
          _vm.removeFromSelectedIndieGroup(i.split('~~~')[0], 'indie')
        }
      }
    }) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "padding": "0px 15px 0px 5px"
    }
  }, _vm._l((_vm.selectedGroupsOutsideAdmin), function(i, index) {
    return (i.id != _vm.onecargillusersgroupid && i.id != _vm.onecargilladmingroupid) ? _c('div', {
      staticClass: "group-div",
      class: {
        disabled: _vm.adminTo.indexOf(i.id) === -1 && !_vm.checkAllowedSubGroup('all', i.id), bb0: index !== (_vm.selectedGroupsOutsideAdmin.length - 1)
      },
      staticStyle: {
        "font-weight": "normal"
      }
    }, [_c('div', {
      staticStyle: {
        "pointer-events": "auto",
        "cursor": "default"
      },
      attrs: {
        "data-toggle": _vm.adminTo.indexOf(i.id) === -1 && !_vm.checkAllowedSubGroup('all', i.id) ? 'tooltip' : false,
        "title": _vm.disableSelectedGroupsOutsideAdmin(i.id),
        "data-original-title": _vm.disableSelectedGroupsOutsideAdmin(i.id)
      }
    }, [_c('div', {
      staticClass: "group-name"
    }, [_vm._v(_vm._s(i._embedded ? i._embedded.group.profile.name : i.profile.name))]), _vm._v(" "), (!(_vm.adminTo.indexOf(i.id) === -1 && !_vm.checkAllowedSubGroup('all', i.id))) ? _c('i', {
      staticClass: "fa fa-minus-circle remove-group",
      on: {
        "click": function($event) {
          _vm.removeFromSelectedIndieGroup(i.id)
        }
      }
    }) : _vm._e()])]) : _vm._e()
  }))], 2)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userAlreadyExists),
      expression: "userAlreadyExists"
    }],
    staticStyle: {
      "margin-top": "10px",
      "cursor": "pointer",
      "text-decoration": "underline",
      "color": "#444444",
      "font-weight": "bold"
    },
    on: {
      "click": function($event) {
        _vm.goToExistingUser()
      }
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.viewuser))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary create-btn",
    class: {
      disabled: _vm.addUserPrimaryEmail === _vm.loggedInUser && _vm.updateToggle
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.updateToggle ? _vm.updateUser() : _vm.displayActivateModal()
      }
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.updateToggle ? _vm.user_lang.update : _vm.user_lang.inviteuser) + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "cancel-btn",
    on: {
      "click": function($event) {
        _vm.goToUserManagement()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.cancel))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShow && !_vm.updateToggle),
      expression: "!isShow && !updateToggle"
    }]
  }, [_c('div', {
    staticClass: "bc"
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.userAdministration))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "44px !important",
      "font-weight": "bold",
      "overflow": "auto",
      "margin-bottom": "20px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.userAdministration))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-5px"
    }
  }, [((_vm.hostName.toLowerCase() === 'localhost:8080' || _vm.hostName.toLowerCase() === 'cargillcustomer.dev.dev-cglcloud.com' || _vm.hostName.toLowerCase() === 'cargillcustomer.stage.cglcloud.in' || _vm.hostName.toLowerCase() === 'cargillcustomer-deprecated.stage.cglcloud.in' || _vm.hostName.toLowerCase() === 'identityservices.stage.mycargill.com' || _vm.hostName.toLowerCase() === 'identityservices-deprecated.stage.mycargill.com' || _vm.hostName.toLowerCase().indexOf('identity.mycargill') !== -1)) ? _c('button', {
    staticClass: "btn btn-primary adduser-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showBulkUploadWindow(), _vm.clearAddUserFields(), _vm.removeAllNotifications()
      }
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.user_lang.bulkUploadLabel))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary adduser-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isShow = !_vm.isShow, _vm.updateToggle = false, _vm.clearAddUserFields(), _vm.removeAllNotifications()
      }
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.user_lang.adduser))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userCreationMessage == _vm.user_lang['usercreated']),
      expression: "userCreationMessage == user_lang['usercreated']"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "userCreationMessage"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.userCreationMessage = ''
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.emailsenttouser) + " " + _vm._s(_vm.addUserFirstName) + " " + _vm._s(_vm.addUserLastName) + "\n\t\t  "), _c('div', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.pendingactivation))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resetSuccess),
      expression: "resetSuccess"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.resetSuccess = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.resetsuccesspopupmsg) + "\n\t\t  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activateSuccess),
      expression: "activateSuccess"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.activateSuccess = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activatesuccess) + " " + _vm._s(_vm.reverseTransformEmail(_vm.activatedemail)) + "\n\t\t  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.updatesuccess),
      expression: "updatesuccess"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.updatesuccess = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.updatesuccess) + "\n\t\t  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deactivateSuccess),
      expression: "deactivateSuccess"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.deactivateSuccess = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.reverseTransformEmail(_vm.activatedemail)) + " " + _vm._s(_vm.user_lang.deactivatesuccess) + "\n\t\t  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteSuccess),
      expression: "deleteSuccess"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.deleteSuccess = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.reverseTransformEmail(_vm.activatedemail)) + " " + _vm._s(_vm.user_lang.deletesuccess) + "\n\t\t  ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12",
    class: {
      disabled: _vm.globalsearch
    }
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.filteruser))]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAppId),
      expression: "selectedAppId"
    }],
    staticStyle: {
      "max-height": "40px",
      "padding": "9px",
      "margin-top": "0px",
      "width": "100%",
      "height": "40px"
    },
    attrs: {
      "id": "selectApp"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAppId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.filterApp]
    }
  }, _vm._l((_vm.appList), function(i, index) {
    return (_vm.adminTo.indexOf(i.id) > -1 && i.name !== 'bookmark' && !_vm.isAlreadyPresent(i.id, index)) ? _c('option', {
      domProps: {
        "value": i.id
      }
    }, [_vm._v(_vm._s(i.label))]) : _vm._e()
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12",
    class: {
      disabled: _vm.globalsearch
    }
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.filterusergrp))]), _vm._v(" "), _c('span', {
    staticClass: "report-link",
    on: {
      "click": function($event) {
        _vm.resetTotalCount();
        _vm.downloadUsersOfGroupRecursively();
      }
    }
  }, [_c('progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }],
    staticStyle: {
      "width": "100px",
      "height": "7px"
    },
    attrs: {
      "id": "file",
      "max": _vm.reportTotalCount
    },
    domProps: {
      "value": _vm.downloadReportSet.length
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }],
    staticStyle: {
      "font-size": "16px",
      "color": "#000",
      "margin-right": "10px",
      "margin-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.reportTotalCount ? ((_vm.downloadReportSet.length / _vm.reportTotalCount) * 100).toFixed(0) : '0') + "%")]), _vm._v(_vm._s(_vm.user_lang.reportLabel)), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "16px"
    },
    attrs: {
      "data-v-04fb9444": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedGroupId),
      expression: "selectedGroupId"
    }],
    staticStyle: {
      "max-height": "40px",
      "padding": "9px",
      "margin-top": "0px",
      "width": "100%",
      "height": "40px"
    },
    attrs: {
      "id": "grpdd"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedGroupId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.filterGroup]
    }
  }, [_vm._l((_vm.appGroupMap[_vm.selectedAppId]), function(j) {
    return (_vm.checkAllowedSubGroup(_vm.selectedAppId, j.id)) ? _c('option', {
      domProps: {
        "value": j.id
      }
    }, [_vm._v(_vm._s(j._embedded.group.profile.name))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.admingrpmodalfirstsubgrpidlist), function(j) {
    return (j.indexOf('~~~') > -1) ? _c('option', {
      domProps: {
        "value": j.split('~~~')[0]
      }
    }, [_vm._v(_vm._s(j.split('~~~')[1]))]) : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.search))]), _vm._v(" "), _c('label', {
    staticClass: "form-control-label",
    staticStyle: {
      "float": "right",
      "min-width": "0px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.globalsearch))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalsearch),
      expression: "globalsearch"
    }],
    staticClass: "gsearch",
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.globalsearch) ? _vm._i(_vm.globalsearch, null) > -1 : (_vm.globalsearch)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.globalsearch,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.globalsearch = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.globalsearch = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.globalsearch = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary search-icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.globalsearch),
      expression: "!globalsearch"
    }],
    staticClass: "searchinfotext"
  }, [_vm._v(_vm._s(_vm.user_lang.searchinfotext))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-left": "0px !important",
      "margin-top": "0px",
      "margin-bottom": "0px !important",
      "width": "100% !important"
    },
    attrs: {
      "type": "text",
      "id": "searchId"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row tableContainer",
    staticStyle: {
      "margin-top": "0",
      "border": "0",
      "background": "#eceff1"
    }
  }, [_c('div', {
    staticClass: "card-block1"
  }, [_c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "search",
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "search-bar-wrapper"
  }, [_c('div')])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('UserTable', {
    attrs: {
      "adminAppsArray": _vm.adminAppsArray,
      "filterAppId": _vm.selectedAppId,
      "filterGroupId": _vm.selectedGroupId,
      "usercreated": _vm.userCreationMessage,
      "searchTerm": _vm.searchTerm,
      "globalsearch": _vm.globalsearch,
      "adminTo": _vm.adminTo
    }
  })], 1)])])])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-595e07ce", module.exports)
  }
}

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer",
    attrs: {
      "id": "applicationFooter"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-12 bootomFooter"
  }, [(_vm.brand.toLowerCase() == 'cargill') ? _c('div', [_vm._v("© " + _vm._s(_vm.user_lang.copyrights) + "  "), _c('a', {
    attrs: {
      "href": _vm.user_lang.privacypolicy_link,
      "target": "_blank"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.privacypolicy))]), _vm._v("  |  "), _c('a', {
    attrs: {
      "href": _vm.user_lang.termsandconditions_link,
      "target": "_blank"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.termsandconditions))])]) : _vm._e(), _vm._v(" "), (_vm.brand.toLowerCase() !== 'cargill') ? _c('div', [_vm._v("© " + _vm._s(_vm.brand) + ", Incorporated. All Rights Reserved.  ")]) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c07c36f", module.exports)
  }
}

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "0px",
      "padding-top": "35px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "margin": "-15px"
    }
  }, [_c('div', {
    staticClass: "bc-adduser"
  }, [_c('div', {
    staticStyle: {
      "font-size": "44px !important",
      "font-weight": "bold",
      "overflow": "auto",
      "margin-bottom": "15px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.myprofile))]), _vm._v(" "), ((_vm.reverseTransformedEmail.toLowerCase().indexOf('cargill.') == -1 && _vm.reverseTransformedEmail.toLowerCase().indexOf('crgl-thirdparty.') == -1 && _vm.reverseTransformedEmail.toLowerCase().indexOf('awb.') == -1)) ? _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-5px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.enableEdit && (!_vm.isAzureUser || _vm.isServiceAccountGroupMember)),
      expression: "!enableEdit && (!isAzureUser || isServiceAccountGroupMember)"
    }],
    staticClass: "btn btn-primary adduser-btn",
    class: {
      disabled: _vm.isAzureUser && !_vm.isServiceAccountGroupMember
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editFields()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.user_lang.edit))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nameUpdated),
      expression: "nameUpdated"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.nameUpdated = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.nameUpdated) + "\n\t\t  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pwdupdated),
      expression: "pwdupdated"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.pwdupdated = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.pwdupdated) + "\n\t\t  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.QAupdated),
      expression: "QAupdated"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.QAupdated = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.QAupdated) + "\n\t\t  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneupdated),
      expression: "phoneupdated"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.phoneupdated = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.phoneupdated) + "\n\t\t  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activationpending),
      expression: "activationpending"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.activationpending = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationpending) + "\n\t\t  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "background": "#f1f1f1 !important",
      "margin-bottom": "10px",
      "padding": "14px 14px"
    }
  }, [_c('div', {
    staticClass: "user-creds"
  }, [_c('label', {
    staticClass: "form-control-label"
  }, [_vm._v(_vm._s(_vm.user_lang.basicinfo) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('span', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.first_name) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstname),
      expression: "firstname"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.enableEdit
    },
    attrs: {
      "id": "message-text",
      "tabindex": -1
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('span', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.last_name) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastname),
      expression: "lastname"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.enableEdit
    },
    attrs: {
      "id": "message-text",
      "tabindex": -1
    },
    domProps: {
      "value": (_vm.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastname = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('span', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.primary_mail) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reverseTransformedEmail),
      expression: "reverseTransformedEmail"
    }],
    staticClass: "form-control input-adduser disabled",
    attrs: {
      "id": "message-text",
      "tabindex": -1
    },
    domProps: {
      "value": (_vm.reverseTransformedEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reverseTransformedEmail = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('span', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.secondary_mail) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserSecondaryEmail),
      expression: "addUserSecondaryEmail"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.enableEdit
    },
    attrs: {
      "id": "message-text",
      "tabindex": -1
    },
    domProps: {
      "value": (_vm.addUserSecondaryEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserSecondaryEmail = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableEdit),
      expression: "enableEdit"
    }],
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('label', {
    staticClass: "form-control-label",
    staticStyle: {
      "min-width": "initial"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.changepwd) + ":")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-edit",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.passwordsec = !_vm.passwordsec
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordsec),
      expression: "passwordsec"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "form-control-label"
  }, [_vm._v(_vm._s(_vm.user_lang.oldpwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldpassword),
      expression: "oldpassword"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.enableEdit
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "password",
      "placeholder": "******"
    },
    domProps: {
      "value": (_vm.oldpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldpassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.oldpassword.trim().length > 0),
      expression: "oldpassword.trim().length > 0"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "form-control-label"
  }, [_vm._v(_vm._s(_vm.user_lang.enter_new_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.enableEdit
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "password",
      "placeholder": "******"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "form-control-label"
  }, [_vm._v(_vm._s(_vm.user_lang.repeat_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatpassword),
      expression: "repeatpassword"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.enableEdit
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "password",
      "placeholder": "******"
    },
    domProps: {
      "value": (_vm.repeatpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatpassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "sometext-hidden",
    staticStyle: {
      "color": "transparent",
      "width": "100%",
      "display": "block"
    }
  }, [_vm._v("sometext")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableEdit),
      expression: "enableEdit"
    }],
    staticClass: "btn btn-primary adduser-btn",
    class: {
      disabled: _vm.repeatpassword.length === 0 || _vm.password.length === 0 || _vm.oldpassword.length === 0
    },
    staticStyle: {
      "margin-left": "0px",
      "max-height": "34px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updatePwd()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.user_lang.update))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._l((_vm.pwdValidationObj), function(i) {
    return _c('span', {
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(i))])
  }), _vm._v(" "), _vm._l((_vm.repeatPwdValidationObj), function(j) {
    return _c('span', {
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(j))])
  })], 2)]), _vm._v(" "), _vm._l((_vm.formValidationObj), function(k) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.enableEdit),
        expression: "enableEdit"
      }],
      staticClass: "error"
    }, [_vm._v(_vm._s(k))])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableEdit),
      expression: "enableEdit"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', [_c('label', {
    staticClass: "form-control-label",
    staticStyle: {
      "min-width": "initial"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.nop) + ":")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-edit",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.phnsec = !_vm.phnsec
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phnsec),
      expression: "phnsec"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeSent && !_vm.factorDeleted),
      expression: "!codeSent && !factorDeleted"
    }],
    staticClass: "wrap-input col-lg-4 col-md-4 col-sm-6 col-xs-12 donotedit",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control input-adduser disabled donotedit",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "tabindex": -1,
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeSent && !_vm.factorDeleted),
      expression: "!codeSent && !factorDeleted"
    }],
    staticClass: "wrap-input col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableEdit),
      expression: "enableEdit"
    }],
    staticClass: "btn btn-primary adduser-btn",
    staticStyle: {
      "margin-left": "0px !important"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updatePhone()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.user_lang.update))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.factorStatus))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phnsec),
      expression: "phnsec"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.factorDeleted && !_vm.codeSent && _vm.enableEdit),
      expression: "factorDeleted && !codeSent && enableEdit"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('div', [_c('span', {
    attrs: {
      "for": "countryCode"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.country))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "title": _vm.user_lang.country_inst,
      "data-toggle": "tooltip",
      "data-placement": "right"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countryCode),
      expression: "countryCode"
    }],
    staticStyle: {
      "width": "100%",
      "padding": "0px 10px !important"
    },
    attrs: {
      "id": "countryCode",
      "name": "countryCode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.countryCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "93"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['93']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "355"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['355']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "213"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['213']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1684"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1684']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "376"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['376']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "244"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['244']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1264"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1264']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0672"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['antar']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1268"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1268']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "54"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['54']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "374"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['374']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "297"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['297']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "061"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['aus']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "43"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['43']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "994"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['994']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1242"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1242']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "973"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['973']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "880"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['880']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1246"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1246']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "375"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['375']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "32"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['32']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "501"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['501']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "229"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['229']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1441"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1441']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "975"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['975']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "591"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['591']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "387"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['387']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "267"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['267']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "55"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['55']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "246"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['246']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "673"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['673']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "359"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['359']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "226"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['226']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "257"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['257']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "855"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['855']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "237"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['237']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "01"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['can']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "238"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['238']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1345"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1345']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "236"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['236']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "235"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['235']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "56"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['56']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "86"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['86']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "61"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['61']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "57"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['57']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "269"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['269']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "242"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['242']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "243"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['243']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "682"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['682']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "506"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['506']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "385"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['385']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "53"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['53']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "357"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['357']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "420"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['420']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "45"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['45']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "253"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['253']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1767"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1767']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1809"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1809']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "593"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['593']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['20']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "503"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['503']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "240"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['240']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "291"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['291']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "372"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['372']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "251"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['251']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0500"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['falk']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "298"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['298']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "679"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['679']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "358"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['358']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "33"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['33']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "689"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['689']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "241"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['241']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "220"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['220']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "995"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['995']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "49"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['49']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "233"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['233']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "350"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['350']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['30']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "299"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['299']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1473"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1473']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "590"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['590']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1671"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1671']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "502"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['502']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "441481"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['441481']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "224"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['224']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "245"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['245']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "592"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['592']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "509"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['509']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "379"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['379']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "504"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['504']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "852"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['852']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "36"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['36']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "354"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['354']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "91"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['91']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "62"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['62']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "98"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['98']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "964"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['964']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "353"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['353']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "972"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['972']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "39"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['39']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "225"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['225']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1876"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1876']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "81"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['81']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "441534"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['441534']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "962"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['962']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['kazak']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "254"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['254']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "686"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['686']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "850"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['850']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "82"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['82']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "965"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['965']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "996"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['996']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "856"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['856']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "371"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['371']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "961"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['961']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "266"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['266']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "231"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['231']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "218"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['218']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "423"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['423']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "370"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['370']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "352"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['352']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "853"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['853']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "389"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['389']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "261"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['261']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "265"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['265']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "60"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['60']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "960"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['960']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "223"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['223']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "356"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['356']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "692"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['692']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "596"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['596']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "222"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['222']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "230"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['230']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0262"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['mayotte']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "52"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['52']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "691"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['691']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "373"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['373']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "377"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['377']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "976"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['976']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "382"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['382']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1664"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1664']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0212"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['morocco']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "258"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['258']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "95"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['95']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "264"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['264']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "674"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['674']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "977"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['977']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "31"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['31']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "599"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['599']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "687"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['687']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "64"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['64']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "505"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['505']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "227"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['227']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "234"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['234']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "683"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['683']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "672"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['672']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1670"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1670']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "047"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['norway']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "968"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['968']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['92']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "680"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['680']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "970"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['970']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "507"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['507']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "675"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['675']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "595"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['595']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "51"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['51']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "63"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['63']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "064"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['pitcairn']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "48"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['48']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "351"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['351']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1787"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1787']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "974"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['974']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "262"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['262']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "40"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['40']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['7']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "250"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['250']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "290"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['290']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1869"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1869']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1758"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1758']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "508"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['508']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1784"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1784']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "685"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['685']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "378"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['378']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "239"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['239']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "966"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['966']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "221"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['221']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "381"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['381']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "248"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['248']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "232"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['232']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "65"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['65']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "421"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['421']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "386"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['386']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "677"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['677']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "252"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['252']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "27"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['27']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "500"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['500']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "211"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['211']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "34"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['34']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "94"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['94']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "249"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['249']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "597"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['597']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "47"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['47']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "268"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['268']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "46"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['46']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "41"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['41']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "963"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['963']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "886"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['886']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "992"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['992']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "255"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['255']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "66"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['66']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "670"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['670']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "228"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['228']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "690"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['690']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "676"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['676']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1868"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1868']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "216"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['216']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "90"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['90']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "993"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['993']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1649"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1649']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "688"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['688']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "256"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['256']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "380"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['380']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "971"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['971']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "44"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['44']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "598"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['598']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "998"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['998']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "678"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['678']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "58"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['58']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "84"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['84']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1284"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1284']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1340"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['1340']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "681"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['681']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "212"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['212']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "967"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['967']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "260"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['260']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "263"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['263']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {}, [_c('span', {
    attrs: {
      "for": "phN"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.nop))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "title": _vm.user_lang.nop_inst,
      "data-toggle": "tooltip",
      "data-placement": "right"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phN),
      expression: "phN"
    }],
    staticStyle: {
      "width": "100%",
      "-webkit-user-select": "auto !important"
    },
    attrs: {
      "type": "text",
      "id": "pn",
      "autocomplete": "false"
    },
    domProps: {
      "value": (_vm.phN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phN = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('span', {
    staticClass: "sometext-hidden",
    staticStyle: {
      "color": "transparent",
      "width": "100%",
      "display": "block"
    }
  }, [_vm._v("sometext")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeSent),
      expression: "!codeSent"
    }],
    staticClass: "btn btn-primary adduser-btn",
    class: {
      disabled: !_vm.phN.trim().length
    },
    staticStyle: {
      "padding": "14px 23px",
      "background": "#f9f9f9",
      "color": "#595959",
      "border": "1px solid #c3c3c3",
      "font-size": "12px",
      "height": "30px",
      "margin-left": "0px !important"
    },
    on: {
      "click": function($event) {
        _vm.sendCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.update))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error30SecOTP == true),
      expression: "error30SecOTP == true"
    }],
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.user_lang.OTPEnableAfter30Sec))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneNumberNotValid == true),
      expression: "phoneNumberNotValid == true"
    }],
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.user_lang.phonenumberinvalid))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticStyle: {
      "color": "#a7a7a7",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.enter_code_rule))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "m-form verify-code-form clearfix leave-open-on-success",
    staticStyle: {
      "padding": "0px 15px",
      "margin": "0px -15px"
    },
    attrs: {
      "id": "smsPhoneCodeForm.edit.form"
    }
  }, [_c('input', {
    staticClass: "hide",
    attrs: {
      "type": "hidden",
      "name": "_xsrfToken",
      "value": "bd39219af46c391c0ea3df7053f999588ed2ca5a8553eaf83a32d4d3f063915f"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "smsFactor",
      "value": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hide",
    attrs: {
      "name": "activateFactor",
      "value": "false",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "margin-btm-0",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "smsPhoneCodeForm.code.label",
      "for": "verifyCode",
      "path": "token",
      "csserrorclass": "error"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.enter_code) + "\n\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifycode),
      expression: "verifycode"
    }],
    staticClass: "verify-code",
    staticStyle: {
      "visibility": "inherit",
      "position": "inherit",
      "max-width": "200px !important",
      "display": "inline-block !important",
      "padding-top": "14px"
    },
    attrs: {
      "id": "verifyCode",
      "name": "code",
      "type": "text",
      "value": "",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.verifycode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifycode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "codeVerifybtn",
    class: {
      disabled: _vm.verifycode.trim().length === 0
    },
    on: {
      "click": function($event) {
        _vm.verifySMS()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.verify))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "codeVerifybtn",
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.back))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passCodeInvalid),
      expression: "passCodeInvalid"
    }],
    attrs: {
      "id": "smsPhoneCodeForm.edit.errors"
    }
  }, [_c('div', {
    staticClass: "error",
    staticStyle: {
      "padding": "10px 0px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.passcodeNotValid))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error30SecOTP == true),
      expression: "error30SecOTP == true"
    }],
    staticClass: "error",
    staticStyle: {
      "padding": "10px 0px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.OTPEnableAfter30Sec))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emptypasscode == true),
      expression: "emptypasscode == true"
    }],
    staticClass: "error",
    staticStyle: {
      "padding": "10px 0px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.emptypasscode))])]), _vm._v(" "), _vm._l((_vm.phoneValidationObj), function(j) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.enableEdit),
        expression: "enableEdit"
      }],
      staticClass: "error"
    }, [_vm._v(_vm._s(j))])
  })], 2)]), _vm._v(" "), _vm._l((_vm.QAValidationObj), function(k) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.enableEdit && _vm.secqsec),
        expression: "enableEdit && secqsec"
      }],
      staticClass: "error"
    }, [_vm._v(_vm._s(k))])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableEdit),
      expression: "enableEdit"
    }],
    staticStyle: {
      "margin-top": "10px",
      "width": "100%",
      "margin-right": "15px",
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary adduser-btn",
    staticStyle: {
      "margin-left": "845px",
      "max-height": "34px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateName()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.user_lang.update))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "padding": "8px 20px"
    },
    on: {
      "click": function($event) {
        _vm.enableEdit = false, _vm.clearAllFieldsandValidations()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.cancel))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "user-creds"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang['assignedapps']))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "padding-top": "5px",
      "padding-right": "0px"
    }
  }, _vm._l((_vm.regApps), function(i) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-6 regapps",
      attrs: {
        "title": i.label
      },
      on: {
        "click": function($event) {
          _vm.goToApp(i.name.toLowerCase() === 'bookmark' ? i.settings.app.url : i._links.appLinks[0].href)
        }
      }
    }, [_c('div', {
      staticClass: "icon-wrap"
    }, [_c('img', {
      staticStyle: {
        "height": "34px"
      },
      attrs: {
        "src": i._links.logo[0].href
      }
    })]), _vm._v(" "), _c('div', {}, [_vm._v(_vm._s(i.label))])])
  }))])])])])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7a8c026c", module.exports)
  }
}

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "var(--regpwd-primarytextcolor)"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "splash hiddden",
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal errorModal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.errorMsg) + "\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.errorModalClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationOk))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "box-shadow": "2px 2px 10px #ccc"
    },
    attrs: {
      "id": "userRegistration"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tokenInvalid && !_vm.enableRefIdApproach),
      expression: "tokenInvalid && !enableRefIdApproach"
    }],
    staticStyle: {
      "max-width": "800px",
      "margin": "auto",
      "padding-top": "35px",
      "padding": "35px",
      "background": "#fff"
    }
  }, [(_vm.whitelabelSpecific) ? _c('div', [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.tokenNotValid))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.tokenInvalidInfo))])]) : _vm._e(), _vm._v(" "), (!_vm.whitelabelSpecific) ? _c('div', [_vm._m(0), _vm._v(" "), (_vm.isNetworkError) ? _c('div', {
    staticStyle: {
      "padding": "15px 0px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.user_lang.msgForGenericErrorUA) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.isNetworkError) ? _c('div', [(!_vm.inviteSuccess) ? _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user_lang.tokenInvalidShortMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.inviteSuccess && _vm.detectBrowser()) ? _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user_lang.browserspecificmsg) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.inviteSuccess) ? _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user_lang.enterActivationDetails) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.user_lang.resendActivation))])]), _vm._v(" "), (!_vm.inviteSuccess) ? _c('div', [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 field-reinvite"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userEmail),
      expression: "userEmail"
    }],
    staticClass: "input-reinvite",
    attrs: {
      "type": "text",
      "placeholder": _vm.user_lang.username
    },
    domProps: {
      "value": (_vm.userEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 field-reinvite"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userLastName),
      expression: "userLastName"
    }],
    staticClass: "input-reinvite",
    attrs: {
      "type": "text",
      "placeholder": _vm.user_lang.last_name
    },
    domProps: {
      "value": (_vm.userLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userLastName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "width": "100%",
      "text-align": "center",
      "margin": "0px auto"
    },
    attrs: {
      "id": "captcha_container"
    }
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": _vm.sitekey,
      "loadRecaptchaScript": true
    },
    on: {
      "verify": _vm.onVerify,
      "expired": _vm.onExpired,
      "render": _vm.onRender
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [(_vm.userValidations !== '') ? _c('div', {
    staticClass: "validation-text"
  }, [_vm._v("\n                    " + _vm._s(_vm.userValidations) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('button', {
    class: {
      disabled: !_vm.captchaVerified
    },
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.validateAndResendInvite()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.user_lang.reinvite) + "\n                  ")])])]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.inviteSuccess) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px",
      "border-top": "1px solid #ccc",
      "padding-top": "20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.user_lang.reinviteEmailMessage))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.user_lang.reinviteContactAdminMessage) + "\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableRefIdApproach && !_vm.tokenInvalid),
      expression: "enableRefIdApproach && !tokenInvalid"
    }],
    staticStyle: {
      "max-width": "800px",
      "margin": "auto",
      "padding-top": "35px",
      "padding": "50px",
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.copyrefid) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.refId),
      expression: "refId"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.refId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.refId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.getTokenAndRedirect(_vm.refId)
      }
    }
  }, [_vm._v("Register")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tokenInvalid && !_vm.enableRefIdApproach && !_vm.whitelabelSpecific),
      expression: "!tokenInvalid && !enableRefIdApproach && !whitelabelSpecific"
    }],
    staticClass: "okta-sign-in-header auth-header"
  }, [_c('img', {
    staticClass: "auth-org-logo",
    attrs: {
      "src": "static/1200px-Cargill_logo.svg.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tokenInvalid && !_vm.enableRefIdApproach),
      expression: "!tokenInvalid && !enableRefIdApproach"
    }],
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "title-bar"
  }, [_c('p', {
    staticClass: "welcome"
  }, [_c('span', {
    staticStyle: {
      "color": "var(--regpwd-secondarytextcolor)",
      "font-size": "15px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user_lang.welcome_cargill) + "\n              "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.browserLang != 'uk'),
      expression: "browserLang != 'uk'"
    }]
  }, [_vm._v(_vm._s(_vm.brand))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.accountsetup),
      expression: "!accountsetup"
    }],
    staticClass: "row",
    attrs: {
      "id": "registrationForm"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left",
      "margin-top": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.password_placeholder))]), _vm._v(" "), _c('div', {
    staticClass: "row-spacing"
  }, [_c('div', {
    staticClass: "field-spacing"
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.enter_new_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: _vm.borderForInputOne,
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.inputOneHasError
  })]), _vm._v(" "), (_vm.showPasswordError) ? _c('div', {
    staticClass: "errorwrapper"
  }, _vm._l((_vm.pwdValidationObj), function(i) {
    return _c('span', {
      key: i,
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(i))])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field-spacing"
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.repeat_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatpassword),
      expression: "repeatpassword"
    }],
    class: _vm.borderForInputTwo,
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.repeatpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatpassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.inputTwoHasError
  })]), _vm._v(" "), (_vm.showPasswordError) ? _c('div', {
    staticClass: "errorwrapper"
  }, _vm._l((_vm.repeatPwdValidationObj), function(i) {
    return _c('span', {
      key: i,
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(i))])
  })) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.availableFactorID === '' || _vm.availableFactorID === undefined) && !_vm.isGroupPhone),
      expression: "(availableFactorID === '' || availableFactorID === undefined) && !isGroupPhone"
    }],
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left",
      "margin-top": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.nop) + " " + _vm._s(_vm.user_lang.optional))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "title": _vm.user_lang.phone_inst,
      "data-original-title": _vm.user_lang.phone_inst,
      "data-toggle": "tooltip",
      "data-placement": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row-spacing",
    attrs: {
      "id": "phoneModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "field-spacing",
    staticStyle: {
      "color": "#a7a7a7"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.user_lang.enter_code_rule) + "\n                      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "m-form verify-code-form clearfix leave-open-on-success",
    attrs: {
      "id": "smsPhoneCodeForm.edit.form"
    }
  }, [_c('input', {
    staticClass: "hide",
    attrs: {
      "type": "hidden",
      "name": "_xsrfToken",
      "value": "bd39219af46c391c0ea3df7053f999588ed2ca5a8553eaf83a32d4d3f063915f"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "smsFactor",
      "value": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hide",
    attrs: {
      "name": "activateFactor",
      "value": "false",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "margin-btm-0",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "smsPhoneCodeForm.code.label",
      "for": "verifyCode",
      "path": "token",
      "csserrorclass": "error"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.enter_code) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-right": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "text-align": "left",
      "padding-right": "5px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifycode),
      expression: "verifycode"
    }],
    staticClass: "verify-input",
    attrs: {
      "id": "verifyCode",
      "name": "code",
      "type": "text",
      "value": "",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.verifycode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifycode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12",
    staticStyle: {
      "text-align": "left",
      "padding-right": "5px"
    }
  }, [_c('input', {
    staticClass: "ajax-form-submit verify-sms save button",
    class: {
      disabled: _vm.verifyClicked
    },
    attrs: {
      "value": _vm.user_lang.verify,
      "name": "m-save",
      "type": "button",
      "id": "smsPhoneCodeForm.button.submit"
    },
    on: {
      "click": function($event) {
        _vm.verifySMS()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12",
    staticStyle: {
      "text-align": "left",
      "padding-right": "5px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "phoneVerification",
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.user_lang.back) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "phoneVerification",
    on: {
      "click": function($event) {
        _vm.cancelVerification()
      }
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.user_lang.cancel) + "\n                            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iserror),
      expression: "iserror"
    }],
    staticStyle: {
      "padding-top": "5px"
    },
    attrs: {
      "id": "smsPhoneCodeForm.edit.errors"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "5px",
      "background": "rgb(255, 192, 203)",
      "padding-left": "15px",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.verifyCodeError) + "\n                          ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeSent),
      expression: "!codeSent"
    }],
    staticClass: "edit-form clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "padding-0 margin-0 autowidth float-n",
    attrs: {
      "id": "smsPhoneWidget"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "field-spacing"
  }, [_c('div', [_c('span', {
    attrs: {
      "for": "countryCode"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.country))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "title": _vm.user_lang.country_inst,
      "data-original-title": _vm.user_lang.country_inst,
      "data-toggle": "tooltip",
      "data-placement": "right"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [(_vm.paramLang !== 'es_ES') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countryCode),
      expression: "countryCode"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "countryCode",
      "name": "countryCode",
      "autocomplete": "off"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.countryCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.dropdownList.common), function(obj) {
    return _c('option', {
      key: obj.key,
      domProps: {
        "value": obj.key
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.user_lang[("" + (obj.value))]) + "\n                                ")])
  })) : _vm._e(), _vm._v(" "), (_vm.paramLang === 'es_ES') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countryCode),
      expression: "countryCode"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "countryCode",
      "name": "countryCode",
      "autocomplete": "off"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.countryCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.dropdownList.es), function(obj) {
    return _c('option', {
      key: obj.key,
      domProps: {
        "value": obj.key
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.user_lang[("" + (obj.value))]) + "\n                                ")])
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "field-spacing"
  }, [_c('div', {
    class: _vm.browserLang === 'uk' ? 'margintop' : ''
  }, [_c('span', {
    attrs: {
      "for": "phN"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.nopMobile))]), _c('span', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "title": _vm.user_lang.nop_inst,
      "data-original-title": _vm.user_lang.nop_inst,
      "data-toggle": "tooltip",
      "data-placement": "right"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phN),
      expression: "phN"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "id": "pn",
      "name": "phN"
    },
    domProps: {
      "value": (_vm.phN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phN = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field-spacing"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeSent),
      expression: "!codeSent"
    }],
    staticClass: "send-code",
    class: {
      disabled: !_vm.phN.trim().length
    },
    on: {
      "click": function($event) {
        _vm.sendCode()
      }
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.user_lang.send_code) + "\n                            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPhoneNoNotVerified),
      expression: "isPhoneNoNotVerified"
    }],
    staticStyle: {
      "padding": "5px 15px",
      "background": "#f3db79",
      "border": "1px solid #ffcc12",
      "margin-top": "5px",
      "width": "100%"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning",
    staticStyle: {
      "padding": "5px 5px 5px 0px"
    }
  }), _vm._v(_vm._s(_vm.user_lang.verifyPhoneWarning) + "\n                          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error30SecOTP == true),
      expression: "error30SecOTP == true"
    }],
    staticClass: "phone-error"
  }, [_vm._v(_vm._s(_vm.user_lang.OTPEnableAfter30Sec) + "\n                          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneNumberNotValid == true),
      expression: "phoneNumberNotValid == true"
    }],
    staticClass: "phone-error"
  }, [_vm._v(_vm._s(_vm.user_lang.phonenumberinvalid) + "\n                          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneNoAlreadySet == true),
      expression: "phoneNoAlreadySet == true"
    }],
    staticClass: "phone-error"
  }, [_vm._v(_vm._s(_vm.user_lang.phoneNoAlreadySet) + "\n                          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.genericErrorMsg),
      expression: "genericErrorMsg"
    }],
    staticClass: "phone-error"
  }, [_vm._v("\n                            " + _vm._s(_vm.user_lang.msgForUnhandledResponse) + "\n                          ")])]), _vm._v(" "), _vm._m(3)])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alreadyRegistered),
      expression: "alreadyRegistered"
    }],
    staticStyle: {
      "margin-left": "15px",
      "padding": "0px 15px"
    }
  }, [_c('div', {
    staticClass: "success-text",
    staticStyle: {
      "color": "green",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.phonealreadyactive) + "\n                ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.issuccess),
      expression: "issuccess"
    }],
    staticStyle: {
      "margin-left": "15px",
      "padding": "0px 15px"
    }
  }, [_c('span', {
    staticClass: "success-text",
    staticStyle: {
      "color": "green",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.verify_success))])])]), _vm._v(" "), _c('div', {
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.brand.toLowerCase().indexOf('cargill') == -1) ? _c('div', _vm._l((_vm.termsArray), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.brandtermagree[index]),
        expression: "brandtermagree[index]"
      }],
      staticClass: "input-terms",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.brandtermagree[index]) ? _vm._i(_vm.brandtermagree[index], null) > -1 : (_vm.brandtermagree[index])
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.brandtermagree[index],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.brandtermagree[index] = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.brandtermagree[index] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.brandtermagree, index, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "brand-terms"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(i)
      }
    })])])])
  })) : _vm._e(), _vm._v(" "), (_vm.brand.toLowerCase().indexOf('cargill') > -1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreeone),
      expression: "agreeone"
    }],
    staticClass: "input-terms",
    attrs: {
      "id": "agree1",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreeone) ? _vm._i(_vm.agreeone, null) > -1 : (_vm.agreeone)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.agreeone,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreeone = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agreeone = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreeone = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "brand-terms"
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.iread1))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.tclink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.iread2))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user_lang.iread3))])])])]) : _vm._e(), _vm._v(" "), (_vm.brand.toLowerCase().indexOf('cargill') > -1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreetwo),
      expression: "agreetwo"
    }],
    staticClass: "input-terms",
    attrs: {
      "id": "agree2",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreetwo) ? _vm._i(_vm.agreetwo, null) > -1 : (_vm.agreetwo)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.agreetwo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreetwo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agreetwo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreetwo = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "brand-terms"
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.iagree1))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.pplink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.iagree2))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user_lang.iagree3))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorCode != ''),
      expression: "errorCode != ''"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "display": "flex",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "left",
      "padding-top": "0px",
      "background": "#ffc0cb",
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#333",
      "font-size": "13px",
      "padding": "5px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang[_vm.errorCode]) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 offset-md-6 offset-lg-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        _vm.isCheckboxDisabled()
      }
    }
  }, [_c('button', {
    staticClass: "btn-primary create-acc",
    class: {
      disabled:
        (_vm.brand.toLowerCase().indexOf('cargill') > -1 && (!_vm.agreeone || !_vm.agreetwo)) ||
        (_vm.brand.toLowerCase().indexOf('cargill') == -1 && !(_vm.brandtermagree.filter(function (i) { return i == true; }).length === _vm.termsArray.length))
    },
    attrs: {
      "value": _vm.user_lang.create_acc
    },
    on: {
      "click": function($event) {
        _vm.setUserAccount()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.user_lang.create_acc) + "\n                    ")])])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountsetup),
      expression: "accountsetup"
    }],
    attrs: {
      "id": "congrats"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "font-size": "22px",
      "width": "80%",
      "display": "inline-block",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.internalUser ? _vm.user_lang.alreadyactive : _vm.user_lang.congrats) + "\n                "), _c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.internalUser ? _vm.user_lang.alreadyactivesetup : _vm.user_lang.accountsetup) + "\n                ")])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.regApps.length !== 0),
      expression: "regApps.length !== 0"
    }],
    staticStyle: {
      "font-size": "16px",
      "width": "80%",
      "display": "inline-block",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.gotoapp) + "\n              ")]), _vm._v(" "), _vm._l((_vm.regApps), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-6 regapps",
      attrs: {
        "title": i.label
      },
      on: {
        "click": function($event) {
          _vm.goToApp(i.name.toLowerCase() === 'bookmark' ? i.settings.app.url : i._links.appLinks[0].href)
        }
      }
    }, [_c('div', {
      staticClass: "icon-wrap"
    }, [_c('img', {
      staticStyle: {
        "max-width": "90px"
      },
      attrs: {
        "src": i._links.logo[0].href
      }
    })]), _vm._v(" "), _c('div', [_vm._v(_vm._s(i.label))])])
  })], 2)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "okta-sign-in-header auth-header"
  }, [_c('img', {
    staticClass: "auth-org-logo",
    attrs: {
      "src": "static/1200px-Cargill_logo.svg.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px",
      "color": "var(--theme-primary)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padding-0 margin-0 autowidth float-n normal"
  }, [_c('div', {
    staticClass: "infobox infobox-error margin-btm",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "smsPhoneSetupForm.edit.errors"
    }
  }, [_c('span', {
    staticClass: "icon error-16"
  }), _vm._v(" "), _c('p', [_vm._v("Please review the form to correct the following errors")]), _vm._v(" "), _c('ul', {
    staticClass: "bullets"
  }, [_c('li', [_c('span', {
    attrs: {
      "id": "smsPhoneSetupForm.passcode.error"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padding-0 margin-0 autowidth float-n normal"
  }, [_c('div', {
    staticClass: "infobox infobox-success infobox-md clear margin-top",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "smsPhoneSetupForm-edit-success"
    }
  }, [_c('span', {
    staticClass: "icon success-24"
  }), _vm._v(" "), _c('p', {
    staticClass: "success-text"
  }, [_vm._v("Phone number successfully verified!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "20%",
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px",
      "color": "var(--theme-primary)"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7cc2de36", module.exports)
  }
}

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "30px",
      "padding-top": "35px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "35px",
      "font-weight": "bold"
    }
  }, [_vm._v("Email Scheduler Logs")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('label', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Enter the email id to search:\n\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Minimum 5 characters"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary get-logs",
    class: {
      'disabled': _vm.searchTerm.trim().length < 5
    },
    on: {
      "click": function($event) {
        _vm.getLogs()
      }
    }
  }, [_vm._v("Get Logs")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Email Id")]), _vm._v(" "), _c('th', [_vm._v("Brand")]), _vm._v(" "), _c('th', [_vm._v("Email Type")]), _vm._v(" "), _c('th', [_vm._v("Log Description")]), _vm._v(" "), _c('th', [_vm._v("Date-Time")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.logsArr), function(i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(i.emailId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.brand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.statusCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.actionDate))])])
  }))]), _vm._v(" "), (_vm.logsArr.length === 0 && !_vm.emptyLogs) ? _c('div', [_vm._v("Kindly enter the email id and search.")]) : _vm._e(), _vm._v(" "), (_vm.emptyLogs) ? _c('div', [_vm._v("No logs found. ")]) : _vm._e()])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-84feda02", module.exports)
  }
}

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "0px",
      "padding-top": "35px"
    }
  }, [_c('div', {
    staticClass: "modal deleteConfirmModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.delete))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "background": "#ffffff !important",
      "color": "#000 !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.wanttodeleteadminconfig) + " ")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeConfirm()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal cannotDeleteModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block",
      "border": "0px !important"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "float": "left",
      "width": "90%",
      "margin": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.cannotdeleteconfig))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "background": "#ffffff !important",
      "color": "#000 !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "margin": "-15px"
    }
  }, [_c('div', {
    staticClass: "bc-adduser"
  }, [_c('div', {
    staticStyle: {
      "font-size": "44px !important",
      "font-weight": "bold",
      "overflow": "auto",
      "margin-bottom": "15px"
    }
  }, [_c('span', [_vm._v("API Settings")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin": "10px 0px"
    }
  }, [_vm._v("\n\t  Note: This section is to provide applications to use one cargill APIs.")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 configGroupAdmin table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', [_vm._v("Allowed Application")]), _vm._v(" "), _c('th', [_vm._v("Brand")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Allowed groups")]), _vm._v(" "), _c('th', [_vm._v(" ")])]), _vm._v(" "), _vm._l((_vm.appAdminGroupModal), function(i, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "min-width": "250px"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appAdminGroupModal[index].applicationId),
        expression: "appAdminGroupModal[index].applicationId"
      }],
      class: {
        disabledLight: _vm.appAdminGroupModal[index].applicationId !== undefined &&
          _vm.appAdminGroupModal[index].applicationId !== 'undefined' && _vm.appAdminGroupModal[index].groupId !== ''
      },
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "id": 'select' + i.applicationId
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.appAdminGroupModal[index].applicationId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getGroups(i.applicationId)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "undefined"
      }
    }, [_vm._v(_vm._s(_vm.user_lang.selectapp))]), _vm._v(" "), _vm._l((_vm.appList), function(j) {
      return (j.name !== 'bookmark') ? _c('option', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (i.appGrpId === undefined),
          expression: "i.appGrpId === undefined"
        }],
        domProps: {
          "value": j.id
        }
      }, [_vm._v(_vm._s(j.label))]) : _vm._e()
    })], 2)]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "200px"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appAdminGroupModal[index].brand),
        expression: "appAdminGroupModal[index].brand"
      }],
      class: {
        disabledLight: _vm.appAdminGroupModal[index].applicationId !== undefined &&
          _vm.appAdminGroupModal[index].applicationId !== 'undefined' && _vm.appAdminGroupModal[index].groupId !== ''
      },
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "id": 'selectbrand' + i.applicationId
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.appAdminGroupModal[index].brand = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "undefined"
      }
    }, [_vm._v(_vm._s(_vm.user_lang.selectBrand))]), _vm._v(" "), _vm._l((_vm.brandDetails.data), function(j) {
      return _c('option', {
        domProps: {
          "value": j.brandKey
        }
      }, [_vm._v(_vm._s(j.brandName))])
    })], 2)]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "250px"
      }
    }, [_c('div', {
      attrs: {
        "id": "dropdown"
      }
    }, [_c('div', {
      staticClass: "selectDropDown",
      on: {
        "click": function($event) {
          _vm.openDropDown(index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "padding-left": "5px"
      }
    }, [(_vm.appAdminGroupModal[index].subGroupId && _vm.appAdminGroupModal[index].subGroupId.length == 0) ? _c('span', [_vm._v("\n\t\t\t" + _vm._s(_vm.user_lang['selectgroupslist']) + " ")]) : _vm._e(), _vm._v(" "), (_vm.appAdminGroupModal[index].subGroupId && _vm.appAdminGroupModal[index].subGroupId.length > 0) ? _c('span', [_vm._v("\n\t\t\tSelected (" + _vm._s(_vm.appAdminGroupModal[index].subGroupId ? _vm.appAdminGroupModal[index].subGroupId.length : '0') + ")")]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-caret-down",
      staticStyle: {
        "float": "right",
        "margin": "4px 5px",
        "margin-top": "-10px"
      }
    })])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showDropDown[index.toString()]),
        expression: "showDropDown[index.toString()]"
      }],
      class: 'ddwrap' + index,
      attrs: {
        "id": "checkboxlist"
      }
    }, [_vm._l((_vm.appsGroups[i.applicationId]), function(j) {
      return _c('div', {
        staticClass: "dd-list-item",
        staticStyle: {
          "padding-right": "15px",
          "padding-left": "5px"
        }
      }, [_c('input', {
        staticClass: "form-control input-checkbx-sub",
        attrs: {
          "id": j.id + '~' + index,
          "type": "checkbox"
        },
        domProps: {
          "value": j.id
        },
        on: {
          "change": function($event) {
            _vm.checkchange($event)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "vertical-align": "super"
        },
        attrs: {
          "for": j.id
        }
      }, [_vm._v(_vm._s(j._embedded.group.profile.name))])])
    }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[index].subGroupId), function(j) {
      return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[i.applicationId].indexOf(j.split('~~~')[0]) === -1) ? _c('div', {
        staticClass: "dd-list-item",
        staticStyle: {
          "padding-right": "15px",
          "padding-left": "5px"
        }
      }, [_c('input', {
        staticClass: "form-control input-checkbx-sub",
        attrs: {
          "id": j.split('~~~')[0] + '~' + index,
          "type": "checkbox"
        },
        domProps: {
          "value": j.split('~~~')[0]
        },
        on: {
          "change": function($event) {
            _vm.checkchange($event)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "vertical-align": "super"
        },
        attrs: {
          "for": j.split('~~~')[0]
        }
      }, [_vm._v(_vm._s(j.split('~~~')[1]))])]) : _vm._e()
    })], 2)]), _vm._v(" "), _vm._l((_vm.appsGroups[i.applicationId]), function(j) {
      return (_vm.appAdminGroupModal[index].subGroupId && _vm.appAdminGroupModal[index].subGroupId.indexOf(j.id) > -1) ? _c('span', {
        staticStyle: {
          "display": "block"
        }
      }, [_vm._v("-" + _vm._s(j._embedded.group.profile.name))]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[index].subGroupId), function(j) {
      return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[i.applicationId].indexOf(j.split('~~~')[0]) === -1) ? _c('span', {
        staticStyle: {
          "display": "block"
        }
      }, [_vm._v("-" + _vm._s(j.split('~~~')[1]))]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-weight": "bold",
        "margin-top": "5px"
      }
    }, [_vm._v("Add additional group:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.additionalGroup[index]),
        expression: "additionalGroup[index]"
      }],
      staticClass: "addgrouptxtbox",
      attrs: {
        "type": "text",
        "placeholder": "Enter group name and click +"
      },
      domProps: {
        "value": (_vm.additionalGroup[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.additionalGroup, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      staticStyle: {
        "font-size": "20px",
        "cursor": "pointer",
        "color": "rgb(101, 141, 27)",
        "margin-left": "10px"
      },
      on: {
        "click": function($event) {
          _vm.addAdditionalGroup(index, i.applicationId)
        }
      }
    })], 2), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "80px"
      }
    }, [_c('button', {
      staticClass: "deleteconfig",
      on: {
        "click": function($event) {
          _vm.removeRow(i.appGrpId, index, i.applicationId)
        }
      }
    }, [_vm._v("Delete")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isIncomplete),
      expression: "isIncomplete"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "red"
    }
  }, [_vm._v("\n\t  " + _vm._s(_vm.user_lang.adminConfigIncomplete))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.saveSuccess),
      expression: "saveSuccess"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "green"
    }
  }, [_vm._v("\n\t  " + _vm._s(_vm.user_lang.adminconfigupdatesuccess))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteSuccess),
      expression: "deleteSuccess"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "green"
    }
  }, [_vm._v("\n\t  " + _vm._s(_vm.user_lang.adminconfigdeletesuccess))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "font-size": "17px",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminGroups()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.save))]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.addConfigRow()
      }
    }
  }, [_vm._v("Add New App")])])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cf5396ea", module.exports)
  }
}

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('NoTopNavFooter'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "login-background"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "splash hiddden",
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'pull-up': _vm.samlappname !== undefined && _vm.samlappname !== null && (_vm.samlappname.toLowerCase().indexOf('secure.cargillag.com') > -1 || _vm.samlappname.toLowerCase().indexOf('secure.cargillag.ca') > -1)
    }
  }, [(_vm.stateToken.trim() != '' && _vm.stateToken.trim() !== undefined && _vm.stateToken.trim() !== null && _vm.brandCode !== '003') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "5px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.connectingToText ? _vm.connectingToText : 'Connecting to') + "\n          "), _c('img', {
    staticStyle: {
      "max-width": "100px"
    },
    attrs: {
      "id": "saml-logo"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.loginBrandTopText.trim() !== '') ? _c('div', {
    staticClass: "loginBrandTopText"
  }, [_vm._v(_vm._s(_vm.loginBrandTopText))]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "widget-div"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accessDenied),
      expression: "accessDenied"
    }],
    staticClass: "clogindiv",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(217, 57, 52)",
      "padding": "10px 30px",
      "font-size": "14px"
    }
  }, [_vm._m(0)]), _vm._v(" "), (_vm.isEmployeeLoginRequired) ? _c('div', {
    staticClass: "clogindiv"
  }, [_c('button', {
    staticClass: "btn btn-primary adduser-btn",
    attrs: {
      "id": "cargillLogin"
    },
    on: {
      "click": function($event) {
        _vm.openCargillUserLogin()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.ssoLoginTxt ? _vm.ssoLoginTxt : 'Sign In as an Employee'))])]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border": "1px solid #ddd",
      "border-radius": "3px",
      "height": "45px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "float": "left",
      "height": "100%",
      "background": "rgb(217,57,52)",
      "color": "#fff",
      "padding": "7px 3px 10px 7px",
      "border-top-left-radius": "3px",
      "border-bottom-left-radius": "3px"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    staticStyle: {
      "margin-right": "5px",
      "font-size": "16px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "color": "#000000",
      "float": "left",
      "padding": "7px 3px 10px 10px"
    }
  }, [_vm._v("Access denied")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d48af610", module.exports)
  }
}

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      'display': _vm.spinnerOn ? 'block' : 'none'
    }),
    attrs: {
      "id": "overlay"
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row inner align-items-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('i', {
    staticClass: "fa fa-4x fa-spinner fa-spin"
  })])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-da5d5c4e", module.exports)
  }
}

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg",
    staticStyle: {
      "color": "var(--regpwd-primarytextcolor)"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "splash hiddden",
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "box-shadow": "2px 2px 10px #ccc"
    },
    attrs: {
      "id": "userRegistration"
    }
  }, [(_vm.tokenInvalid && !_vm.enableRefIdApproach) ? _c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "auto",
      "padding-top": "35px",
      "padding": "50px",
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._m(0), _vm._v(_vm._s(_vm.user_lang.tokenNotValid) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.tokenInvalidInfo))])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableRefIdApproach && !_vm.tokenInvalid),
      expression: "enableRefIdApproach && !tokenInvalid"
    }],
    staticStyle: {
      "max-width": "800px",
      "margin": "auto",
      "padding-top": "35px",
      "padding": "50px",
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.copyrefid))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.refId),
      expression: "refId"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.refId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.refId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('button', {
    staticStyle: {
      "color": "#fff"
    },
    on: {
      "click": function($event) {
        _vm.getTokenAndRedirect(_vm.refId)
      }
    }
  }, [_vm._v("Recover")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tokenInvalid && !_vm.enableRefIdApproach),
      expression: "!tokenInvalid && !enableRefIdApproach"
    }],
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "title-bar"
  }, [_c('p', {
    staticClass: "welcome",
    staticStyle: {
      "background": "var(--regpwd-topnavbarbg)",
      "text-align": "center",
      "padding": "15px",
      "margin": "0px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "var(--regpwd-secondarytextcolor)",
      "font-size": "15px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.hello) + " " + _vm._s(_vm.firstName))]), _vm._v(" \n            "), _c('span', {
    staticStyle: {
      "color": "var(--regpwd-secondarytextcolor)",
      "font-size": "15px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.welcome_cargill) + " " + _vm._s(_vm.brand))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.passwordreset && !_vm.accountunlocked),
      expression: "!passwordreset && !accountunlocked"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticStyle: {
      "color": "#a7a7a7",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.enter_code_rule))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "m-form verify-code-form clearfix leave-open-on-success",
    staticStyle: {
      "padding": "0px 15px",
      "margin": "0px -15px"
    },
    attrs: {
      "id": "smsPhoneCodeForm.edit.form"
    }
  }, [_c('input', {
    staticClass: "hide",
    attrs: {
      "type": "hidden",
      "name": "_xsrfToken",
      "value": "bd39219af46c391c0ea3df7053f999588ed2ca5a8553eaf83a32d4d3f063915f"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "smsFactor",
      "value": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hide",
    attrs: {
      "name": "activateFactor",
      "value": "false",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "margin-btm-0",
    staticStyle: {
      "display": "block",
      "margin-top": "20px"
    },
    attrs: {
      "id": "smsPhoneCodeForm.code.label",
      "for": "verifyCode",
      "path": "token",
      "csserrorclass": "error"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.enter_code))]), _vm._v(" "), _c('div', {}, [_c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifycode),
      expression: "verifycode"
    }],
    staticClass: "verify-code",
    staticStyle: {
      "visibility": "inherit",
      "position": "inherit",
      "width": "100%",
      "display": "inline-block !important",
      "padding-top": "0px"
    },
    attrs: {
      "id": "verifyCode",
      "name": "code",
      "type": "text",
      "value": "",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.verifycode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifycode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "float": "right"
    }
  }, [_c('input', {
    staticClass: "ajax-form-submit verify-code save button",
    staticStyle: {
      "visibility": "inherit",
      "position": "inherit",
      "color": "var(--regpwd-secondarytextcolor)",
      "border": "1px solid rgb(195, 195, 195)",
      "display": "inline-block !important",
      "font-size": "13px",
      "border-radius": "3px",
      "margin-bottom": "20px",
      "max-width": "120px",
      "padding": "8px 16px"
    },
    attrs: {
      "value": _vm.user_lang.verify,
      "name": "m-save",
      "type": "button",
      "id": "smsPhoneCodeForm.button.submit"
    },
    on: {
      "click": function($event) {
        _vm.verifyResendCode()
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticStyle: {
      "background": "#f9f9f9",
      "color": "var(--regpwd-secondarytextcolor)",
      "border": "1px solid #c3c3c3",
      "font-size": "13px",
      "display": "inline-block !important",
      "margin-top": "6px",
      "height": "35px",
      "line-height": "14px",
      "max-width": "120px",
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        _vm.forgotSQA()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.back))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticStyle: {
      "background": "#f9f9f9",
      "color": "var(--regpwd-secondarytextcolor)",
      "border": "1px solid #c3c3c3",
      "font-size": "13px",
      "display": "inline-block !important",
      "margin-top": "6px",
      "height": "35px",
      "line-height": "14px",
      "max-width": "120px",
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.retry))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iserror),
      expression: "iserror"
    }],
    attrs: {
      "id": "smsPhoneCodeForm.edit.errors"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._m(1), _vm._v(_vm._s(_vm.user_lang.passcodeNotValid) + "\n                    ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error30SecOTP == true),
      expression: "error30SecOTP == true"
    }],
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._m(2), _vm._v(_vm._s(_vm.user_lang.OTPEnableAfter30Sec) + "\n                  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emptypasscode == true),
      expression: "emptypasscode == true"
    }],
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._m(3), _vm._v(_vm._s(_vm.user_lang.emptypasscode) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResetQA && !_vm.codeSent),
      expression: "showResetQA && !codeSent"
    }],
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.choose_forgot_pwd_qtn))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSecQN),
      expression: "selectedSecQN"
    }],
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSecQN = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('optgroup', {
    attrs: {
      "label": _vm.user_lang.stock_qtn
    }
  }, _vm._l((_vm.listofsecquestions), function(sq) {
    return _c('option', {
      domProps: {
        "value": sq.question
      }
    }, [_vm._v(_vm._s(sq.questionText))])
  })), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": _vm.user_lang.custom_qtn
    }
  }, [_c('option', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.own_sec_qtn))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedSecQN == 'custom'),
      expression: "selectedSecQN == 'custom'"
    }],
    staticClass: "row",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.custom_qtn))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custom_question),
      expression: "custom_question"
    }],
    staticStyle: {
      "width": "100%"
    },
    domProps: {
      "value": (_vm.custom_question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custom_question = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.answer))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer),
      expression: "answer"
    }],
    staticStyle: {
      "width": "100%"
    },
    domProps: {
      "value": (_vm.answer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.answer = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.enter_new_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.user_lang.newpwd,
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "errorwrapper"
  }, _vm._l((_vm.pwdValidationObj), function(i) {
    return _c('span', {
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.repeat_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatpassword),
      expression: "repeatpassword"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.user_lang.rptpwd,
      "type": "password"
    },
    domProps: {
      "value": (_vm.repeatpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatpassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "errorwrapper"
  }, _vm._l((_vm.repeatPwdValidationObj), function(j) {
    return _c('span', {
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(j))])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorCode != ''),
      expression: "errorCode != ''"
    }],
    staticStyle: {
      "display": "flex",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "left",
      "padding-top": "0px",
      "background": "#d2d2d2",
      "margin-top": "15px !important"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#333",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang[_vm.errorCode]))])]), _vm._v(" "), _c('div', {
    staticClass: "setup-section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn-primary create-acc",
    attrs: {
      "value": _vm.user_lang.create_acc
    },
    on: {
      "click": function($event) {
        _vm.resetPassword()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.resetSecQA) + "\n                        "), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "var(--regpwd-secondarytextcolor)",
      "padding-left": "10px"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.secQAVerified),
      expression: "secQAVerified"
    }],
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.resetOktaPwd))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user_lang.enter_new_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.user_lang.newpwd,
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "errorwrapper"
  }, _vm._l((_vm.pwdValidationObj), function(i) {
    return _c('span', {
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.repeat_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatpassword),
      expression: "repeatpassword"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.user_lang.rptpwd,
      "type": "password"
    },
    domProps: {
      "value": (_vm.repeatpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatpassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "errorwrapper"
  }, _vm._l((_vm.repeatPwdValidationObj), function(j) {
    return _c('span', {
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(j))])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorCode != ''),
      expression: "errorCode != ''"
    }],
    staticStyle: {
      "display": "flex",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "left",
      "padding-top": "0px",
      "background": "#d2d2d2",
      "margin-top": "15px !important"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#333",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang[_vm.errorCode]))])]), _vm._v(" "), _c('div', {
    staticClass: "setup-section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn-primary create-acc",
    attrs: {
      "value": _vm.user_lang.create_acc
    },
    on: {
      "click": function($event) {
        _vm.resetPasswordWithoutQAReset()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.user_lang.resetpwd)), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "var(--regpwd-secondarytextcolor)",
      "padding-left": "10px"
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordreset),
      expression: "passwordreset"
    }],
    attrs: {
      "id": "congrats"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "font-size": "22px",
      "width": "80%",
      "display": "inline-block",
      "margin-bottom": "10px",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.passwordreset) + "\n                  "), _c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.passwordresetsuccess))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.regApps.length !== 0),
      expression: "regApps.length !== 0"
    }],
    staticStyle: {
      "font-size": "16px",
      "width": "80%",
      "display": "inline-block",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.gotoapp) + "\n                ")]), _vm._v(" "), _vm._l((_vm.regApps), function(i) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-6 regapps",
      attrs: {
        "title": i.label
      },
      on: {
        "click": function($event) {
          _vm.goToApp(i.name.toLowerCase() === 'bookmark' ? i.settings.app.url : i._links.appLinks[0].href)
        }
      }
    }, [_c('div', {
      staticClass: "icon-wrap"
    }, [_c('img', {
      staticStyle: {
        "max-width": "90px"
      },
      attrs: {
        "src": i._links.logo[0].href
      }
    })]), _vm._v(" "), _c('div', {}, [_vm._v(_vm._s(i.label))])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountunlocked),
      expression: "accountunlocked"
    }],
    attrs: {
      "id": "unlocked"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "font-size": "22px",
      "width": "80%",
      "display": "inline-block",
      "margin-bottom": "10px",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.accountunlocked) + "\n                  "), _c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.unlockaccountsuccess))])]), _vm._v(" "), _vm._m(7)])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#e34843",
      "width": "22px",
      "height": "auto",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "exclamatory-error-icon"
  }, [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#e34843",
      "width": "22px",
      "height": "auto",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "exclamatory-error-icon"
  }, [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#e34843",
      "width": "22px",
      "height": "auto",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "exclamatory-error-icon"
  }, [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#e34843",
      "width": "22px",
      "height": "auto",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "exclamatory-error-icon"
  }, [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#e34843",
      "width": "22px",
      "height": "auto"
    }
  }, [_c('span', {
    staticClass: "exclamatory-error-icon"
  }, [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#e34843",
      "width": "22px",
      "height": "auto"
    }
  }, [_c('span', {
    staticClass: "exclamatory-error-icon"
  }, [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "20%",
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px",
      "color": "var(--theme-primary)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "20%",
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px",
      "color": "var(--theme-primary)"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f5e219ce", module.exports)
  }
}

/***/ }),
/* 724 */,
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(604);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("5335dee0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-01537783\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserTable.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-01537783\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserTable.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(605);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("a66e231c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-016d20ce\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TopNavFooter.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-016d20ce\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TopNavFooter.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(606);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("62ff25fe", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-04fb9444\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Admin.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-04fb9444\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Admin.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(607);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("05a534fb", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0fd90017\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Error.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0fd90017\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Error.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(608);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("122c4aa8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-17c86ae4\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Reports.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-17c86ae4\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Reports.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(609);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("77c004ec", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1c862efd\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./brandBar.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1c862efd\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./brandBar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(610);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("947b7d94", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-202322ac\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./APISettings.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-202322ac\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./APISettings.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(611);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("4896d26e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2480fbbb\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SessionTimeout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2480fbbb\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SessionTimeout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(612);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("860867a2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3000ba72\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TncTopNavFooter.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3000ba72\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TncTopNavFooter.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(613);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("26fc855e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-30e6c6f8\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-30e6c6f8\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(614);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("9e3e5c94", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-37d5b43c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TokenManagerOld.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-37d5b43c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TokenManagerOld.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(615);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("d8e9c214", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-40e44573\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoggingIn.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-40e44573\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoggingIn.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(616);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("5b1f22b2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-47e688b5\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TokenManager.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-47e688b5\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TokenManager.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(617);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("09ae3313", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4b105266\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SelfRegistration.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4b105266\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SelfRegistration.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(618);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("82d13186", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4b19517a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NoTopNavFooter.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4b19517a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NoTopNavFooter.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(619);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("3c28222d", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-595e07ce\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AdminOld.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-595e07ce\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AdminOld.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(620);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("1d0b6338", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6c07c36f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./footer.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6c07c36f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./footer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(621);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("5947018e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7a8c026c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MyProfile.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7a8c026c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MyProfile.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(622);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("a3cc8b42", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7cc2de36\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserRegistration.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7cc2de36\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UserRegistration.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(623);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("7cdd396c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-84feda02\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SystemLogs.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-84feda02\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SystemLogs.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(624);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("047c67fe", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-cf5396ea\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./APISettingsOld.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-cf5396ea\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./APISettingsOld.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(625);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("42eb7e4c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-d48af610\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Login.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-d48af610\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Login.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(626);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("67a51424", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-da5d5c4e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Spinner.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-da5d5c4e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Spinner.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(627);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("bf35c064", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f5e219ce\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ResetPassword.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f5e219ce\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ResetPassword.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./App": 128,
	"./App.vue": 128,
	"./assets/css/bootstrap.css": 630,
	"./assets/css/bootstrap.min.css": 631,
	"./assets/css/cfApp.css": 632,
	"./assets/css/style.css": 633,
	"./assets/font/fa/FontAwesome.otf": 692,
	"./assets/font/fa/fontawesome-webfont.eot": 693,
	"./assets/font/fa/fontawesome-webfont.svg": 651,
	"./assets/font/fa/fontawesome-webfont.ttf": 694,
	"./assets/font/fa/fontawesome-webfont.woff": 695,
	"./assets/font/fa/fontawesome-webfont.woff2": 696,
	"./assets/font/roboto/Roboto-Bold.eot": 196,
	"./assets/font/roboto/Roboto-Bold.ttf": 310,
	"./assets/font/roboto/Roboto-Bold.woff": 311,
	"./assets/font/roboto/Roboto-Bold.woff2": 312,
	"./assets/font/roboto/Roboto-Light.eot": 197,
	"./assets/font/roboto/Roboto-Light.ttf": 313,
	"./assets/font/roboto/Roboto-Light.woff": 314,
	"./assets/font/roboto/Roboto-Light.woff2": 315,
	"./assets/font/roboto/Roboto-Medium.eot": 198,
	"./assets/font/roboto/Roboto-Medium.ttf": 316,
	"./assets/font/roboto/Roboto-Medium.woff": 317,
	"./assets/font/roboto/Roboto-Medium.woff2": 318,
	"./assets/font/roboto/Roboto-Regular.eot": 199,
	"./assets/font/roboto/Roboto-Regular.ttf": 319,
	"./assets/font/roboto/Roboto-Regular.woff": 320,
	"./assets/font/roboto/Roboto-Regular.woff2": 321,
	"./assets/font/roboto/Roboto-Thin.eot": 200,
	"./assets/font/roboto/Roboto-Thin.ttf": 322,
	"./assets/font/roboto/Roboto-Thin.woff": 323,
	"./assets/font/roboto/Roboto-Thin.woff2": 324,
	"./assets/img/HR-shadow.png": 308,
	"./assets/img/Thumbs.db": 652,
	"./assets/img/agRlogo.png": 653,
	"./assets/img/aghomelogo.png": 654,
	"./assets/img/extracense-logo.png": 655,
	"./assets/img/lightbox/Thumbs.db": 656,
	"./assets/img/lightbox/default-skin.png": 657,
	"./assets/img/lightbox/default-skin.svg": 658,
	"./assets/img/lightbox/preloader.gif": 659,
	"./assets/img/logo-cargill-white.svg": 660,
	"./assets/img/logo-cargill.gif": 661,
	"./assets/img/logo-cargillwhite-help.svg": 195,
	"./assets/img/logo-nutrena.jpg": 662,
	"./assets/img/logo-thrive.jpg": 663,
	"./assets/img/logo-thrive.png": 664,
	"./assets/img/nutrena.png": 665,
	"./assets/img/nutrenaklientportal.png": 666,
	"./assets/img/nutrenaklientportal2.png": 667,
	"./assets/img/overlays/01.png": 668,
	"./assets/img/overlays/02.png": 669,
	"./assets/img/overlays/03.png": 670,
	"./assets/img/overlays/04.png": 671,
	"./assets/img/overlays/05.png": 672,
	"./assets/img/overlays/06.png": 673,
	"./assets/img/overlays/07.png": 674,
	"./assets/img/overlays/08.png": 675,
	"./assets/img/overlays/09.png": 676,
	"./assets/img/overlays/Thumbs.db": 677,
	"./assets/img/png/Thumbs.db": 678,
	"./assets/img/png/bgi.jpg": 679,
	"./assets/img/png/edit.PNG": 754,
	"./assets/img/png/logo-thrive.png": 680,
	"./assets/img/svg/arrow_left.svg": 681,
	"./assets/img/svg/arrow_right.svg": 682,
	"./assets/img/transparent.png": 683,
	"./assets/logo-thrive.jpg": 684,
	"./brand-details": 16,
	"./brand-details-dev": 17,
	"./brand-details-dev.json": 17,
	"./brand-details-stage": 18,
	"./brand-details-stage.json": 18,
	"./brand-details.json": 16,
	"./components/Spinner": 21,
	"./components/Spinner.vue": 21,
	"./components/UserTable": 98,
	"./components/UserTable.vue": 98,
	"./components/footer/footer": 122,
	"./components/footer/footer.vue": 122,
	"./components/header/brandBar/brandBar": 123,
	"./components/header/brandBar/brandBar.vue": 123,
	"./components/widgets/NoTopNavFooter": 99,
	"./components/widgets/NoTopNavFooter.vue": 99,
	"./components/widgets/SessionTimeout": 201,
	"./components/widgets/SessionTimeout.vue": 201,
	"./components/widgets/TncTopNavFooter": 325,
	"./components/widgets/TncTopNavFooter.vue": 325,
	"./components/widgets/TopNavFooter": 37,
	"./components/widgets/TopNavFooter.vue": 37,
	"./event-bus": 12,
	"./event-bus.js": 12,
	"./helpers/app": 100,
	"./helpers/app.js": 100,
	"./helpers/auth-api": 163,
	"./helpers/auth-api.js": 163,
	"./helpers/common": 115,
	"./helpers/common.js": 115,
	"./helpers/country-code": 164,
	"./helpers/country-code.js": 164,
	"./helpers/country-dropdown-list": 165,
	"./helpers/country-dropdown-list.js": 165,
	"./helpers/custom-error": 166,
	"./helpers/custom-error.js": 166,
	"./helpers/group-phone": 167,
	"./helpers/group-phone.js": 167,
	"./helpers/i18nConfig": 168,
	"./helpers/i18nConfig.js": 168,
	"./helpers/okta": 50,
	"./helpers/okta-config": 87,
	"./helpers/okta-config.js": 87,
	"./helpers/okta.js": 50,
	"./helpers/storage": 5,
	"./helpers/storage.js": 5,
	"./helpers/translationConfig": 169,
	"./helpers/translationConfig.js": 169,
	"./i18n/bg": 217,
	"./i18n/bg.json": 217,
	"./i18n/cn": 218,
	"./i18n/cn.json": 218,
	"./i18n/de": 219,
	"./i18n/de.json": 219,
	"./i18n/en": 220,
	"./i18n/en.json": 220,
	"./i18n/es": 124,
	"./i18n/es.json": 124,
	"./i18n/fr": 221,
	"./i18n/fr.json": 221,
	"./i18n/hu": 222,
	"./i18n/hu.json": 222,
	"./i18n/it": 223,
	"./i18n/it.json": 223,
	"./i18n/ko": 224,
	"./i18n/ko.json": 224,
	"./i18n/locale": 8,
	"./i18n/locale.js": 8,
	"./i18n/nl": 225,
	"./i18n/nl.json": 225,
	"./i18n/pl": 226,
	"./i18n/pl.json": 226,
	"./i18n/pt": 227,
	"./i18n/pt.json": 227,
	"./i18n/ro": 228,
	"./i18n/ro.json": 228,
	"./i18n/ru": 229,
	"./i18n/ru.json": 229,
	"./i18n/tr": 230,
	"./i18n/tr.json": 230,
	"./i18n/uk": 231,
	"./i18n/uk.json": 231,
	"./i18n/vi": 328,
	"./i18n/vi.json": 328,
	"./idm-api": 20,
	"./idm-api.js": 20,
	"./internalUserEmailDomains": 78,
	"./internalUserEmailDomains.json": 78,
	"./main": 170,
	"./main.js": 170,
	"./modules/APISettings": 202,
	"./modules/APISettings.vue": 202,
	"./modules/APISettingsOld": 203,
	"./modules/APISettingsOld.vue": 203,
	"./modules/Admin": 204,
	"./modules/Admin.vue": 204,
	"./modules/AdminOld": 205,
	"./modules/AdminOld.vue": 205,
	"./modules/Error": 206,
	"./modules/Error.vue": 206,
	"./modules/LoggingIn": 207,
	"./modules/LoggingIn.vue": 207,
	"./modules/Login": 208,
	"./modules/Login.vue": 208,
	"./modules/MyProfile": 209,
	"./modules/MyProfile.vue": 209,
	"./modules/Reports": 210,
	"./modules/Reports.vue": 210,
	"./modules/ResetPassword": 211,
	"./modules/ResetPassword.vue": 211,
	"./modules/SelfRegistration": 212,
	"./modules/SelfRegistration.vue": 212,
	"./modules/SystemLogs": 213,
	"./modules/SystemLogs.vue": 213,
	"./modules/TokenManager": 214,
	"./modules/TokenManager.vue": 214,
	"./modules/TokenManagerOld": 215,
	"./modules/TokenManagerOld.vue": 215,
	"./modules/UserRegistration": 216,
	"./modules/UserRegistration.vue": 216,
	"./router/index": 125,
	"./router/index.js": 125,
	"./scss/main.scss": 634,
	"./store/index": 66,
	"./store/index.js": 66
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 753;

/***/ }),
/* 754 */
/***/ (function(module, exports) {

throw new Error("Module parse failed: /vela/src/git.cglcloud.com/CustomerFacing/OneCargill-Frontend/src/assets/img/png/edit.PNG Unexpected character '�' (1:0)\nYou may need an appropriate loader to handle this file type.\n(Source code omitted for this binary file)");

/***/ })
],[170]);


// WEBPACK FOOTER //
// static/js/app.b12f74812216a39cee25.js